var wS, Ct = "colors", ei = "sizes", he = "space", fA = { gap: he, gridGap: he, columnGap: he, gridColumnGap: he, rowGap: he, gridRowGap: he, inset: he, insetBlock: he, insetBlockEnd: he, insetBlockStart: he, insetInline: he, insetInlineEnd: he, insetInlineStart: he, margin: he, marginTop: he, marginRight: he, marginBottom: he, marginLeft: he, marginBlock: he, marginBlockEnd: he, marginBlockStart: he, marginInline: he, marginInlineEnd: he, marginInlineStart: he, padding: he, paddingTop: he, paddingRight: he, paddingBottom: he, paddingLeft: he, paddingBlock: he, paddingBlockEnd: he, paddingBlockStart: he, paddingInline: he, paddingInlineEnd: he, paddingInlineStart: he, top: he, right: he, bottom: he, left: he, scrollMargin: he, scrollMarginTop: he, scrollMarginRight: he, scrollMarginBottom: he, scrollMarginLeft: he, scrollMarginX: he, scrollMarginY: he, scrollMarginBlock: he, scrollMarginBlockEnd: he, scrollMarginBlockStart: he, scrollMarginInline: he, scrollMarginInlineEnd: he, scrollMarginInlineStart: he, scrollPadding: he, scrollPaddingTop: he, scrollPaddingRight: he, scrollPaddingBottom: he, scrollPaddingLeft: he, scrollPaddingX: he, scrollPaddingY: he, scrollPaddingBlock: he, scrollPaddingBlockEnd: he, scrollPaddingBlockStart: he, scrollPaddingInline: he, scrollPaddingInlineEnd: he, scrollPaddingInlineStart: he, fontSize: "fontSizes", background: Ct, backgroundColor: Ct, backgroundImage: Ct, borderImage: Ct, border: Ct, borderBlock: Ct, borderBlockEnd: Ct, borderBlockStart: Ct, borderBottom: Ct, borderBottomColor: Ct, borderColor: Ct, borderInline: Ct, borderInlineEnd: Ct, borderInlineStart: Ct, borderLeft: Ct, borderLeftColor: Ct, borderRight: Ct, borderRightColor: Ct, borderTop: Ct, borderTopColor: Ct, caretColor: Ct, color: Ct, columnRuleColor: Ct, fill: Ct, outline: Ct, outlineColor: Ct, stroke: Ct, textDecorationColor: Ct, fontFamily: "fonts", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", blockSize: ei, minBlockSize: ei, maxBlockSize: ei, inlineSize: ei, minInlineSize: ei, maxInlineSize: ei, width: ei, minWidth: ei, maxWidth: ei, height: ei, minHeight: ei, maxHeight: ei, flexBasis: ei, gridTemplateColumns: ei, gridTemplateRows: ei, borderWidth: "borderWidths", borderTopWidth: "borderWidths", borderRightWidth: "borderWidths", borderBottomWidth: "borderWidths", borderLeftWidth: "borderWidths", borderStyle: "borderStyles", borderTopStyle: "borderStyles", borderRightStyle: "borderStyles", borderBottomStyle: "borderStyles", borderLeftStyle: "borderStyles", borderRadius: "radii", borderTopLeftRadius: "radii", borderTopRightRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", boxShadow: "shadows", textShadow: "shadows", transition: "transitions", zIndex: "zIndices" }, hA = (e, t) => typeof t == "function" ? { "()": Function.prototype.toString.call(t) } : t, lu = () => {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, r, ...i) => {
    const n = ((a) => JSON.stringify(a, hA))(t);
    return n in e ? e[n] : e[n] = r(t, ...i);
  };
}, Nl = Symbol.for("sxs.internal"), Jf = (e, t) => Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), TS = (e) => {
  for (const t in e) return !0;
  return !1;
}, { hasOwnProperty: gA } = Object.prototype, Jm = (e) => e.includes("-") ? e : e.replace(/[A-Z]/g, ((t) => "-" + t.toLowerCase())), IA = /\s+(?![^()]*\))/, ns = (e) => (t) => e(...typeof t == "string" ? String(t).split(IA) : [t]), bS = { appearance: (e) => ({ WebkitAppearance: e, appearance: e }), backfaceVisibility: (e) => ({ WebkitBackfaceVisibility: e, backfaceVisibility: e }), backdropFilter: (e) => ({ WebkitBackdropFilter: e, backdropFilter: e }), backgroundClip: (e) => ({ WebkitBackgroundClip: e, backgroundClip: e }), boxDecorationBreak: (e) => ({ WebkitBoxDecorationBreak: e, boxDecorationBreak: e }), clipPath: (e) => ({ WebkitClipPath: e, clipPath: e }), content: (e) => ({ content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"` }), hyphens: (e) => ({ WebkitHyphens: e, hyphens: e }), maskImage: (e) => ({ WebkitMaskImage: e, maskImage: e }), maskSize: (e) => ({ WebkitMaskSize: e, maskSize: e }), tabSize: (e) => ({ MozTabSize: e, tabSize: e }), textSizeAdjust: (e) => ({ WebkitTextSizeAdjust: e, textSizeAdjust: e }), userSelect: (e) => ({ WebkitUserSelect: e, userSelect: e }), marginBlock: ns(((e, t) => ({ marginBlockStart: e, marginBlockEnd: t || e }))), marginInline: ns(((e, t) => ({ marginInlineStart: e, marginInlineEnd: t || e }))), maxSize: ns(((e, t) => ({ maxBlockSize: e, maxInlineSize: t || e }))), minSize: ns(((e, t) => ({ minBlockSize: e, minInlineSize: t || e }))), paddingBlock: ns(((e, t) => ({ paddingBlockStart: e, paddingBlockEnd: t || e }))), paddingInline: ns(((e, t) => ({ paddingInlineStart: e, paddingInlineEnd: t || e }))) }, Am = /([\d.]+)([^]*)/, UA = (e, t) => e.length ? e.reduce(((r, i) => (r.push(...t.map(((n) => n.includes("&") ? n.replace(/&/g, /[ +>|~]/.test(i) && /&.*&/.test(n) ? `:is(${i})` : i) : i + " " + n))), r)), []) : t, SA = (e, t) => e in yA && typeof t == "string" ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, ((r, i, n, a) => i + (n === "stretch" ? `-moz-available${a};${Jm(e)}:${i}-webkit-fill-available` : `-moz-fit-content${a};${Jm(e)}:${i}fit-content`) + a)) : String(t), yA = { blockSize: 1, height: 1, inlineSize: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, width: 1 }, ra = (e) => e ? e + "-" : "", tv = (e, t, r) => e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, ((i, n, a, o, s) => o == "$" == !!a ? i : (n || o == "--" ? "calc(" : "") + "var(--" + (o === "$" ? ra(t) + (s.includes("$") ? "" : ra(r)) + s.replace(/\$/g, "-") : s) + ")" + (n || o == "--" ? "*" + (n || "") + (a || "1") + ")" : ""))), vA = /\s*,\s*(?![^()]*\))/, PA = Object.prototype.toString, ls = (e, t, r, i, n) => {
  let a, o, s;
  const c = (u, l, d) => {
    let p, m;
    const f = (h) => {
      for (p in h) {
        const U = p.charCodeAt(0) === 64, S = U && Array.isArray(h[p]) ? h[p] : [h[p]];
        for (m of S) {
          const P = /[A-Z]/.test(I = p) ? I : I.replace(/-[^]/g, ((D) => D[1].toUpperCase())), v = typeof m == "object" && m && m.toString === PA && (!i.utils[P] || !l.length);
          if (P in i.utils && !v) {
            const D = i.utils[P];
            if (D !== o) {
              o = D, f(D(m)), o = null;
              continue;
            }
          } else if (P in bS) {
            const D = bS[P];
            if (D !== s) {
              s = D, f(D(m)), s = null;
              continue;
            }
          }
          if (U && (g = p.slice(1) in i.media ? "@media " + i.media[p.slice(1)] : p, p = g.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, ((D, y, w, b, T, R) => {
            const M = Am.test(y), E = 0.0625 * (M ? -1 : 1), [A, N] = M ? [b, y] : [y, b];
            return "(" + (w[0] === "=" ? "" : w[0] === ">" === M ? "max-" : "min-") + A + ":" + (w[0] !== "=" && w.length === 1 ? N.replace(Am, ((C, k, O) => Number(k) + E * (w === ">" ? 1 : -1) + O)) : N) + (T ? ") and (" + (T[0] === ">" ? "min-" : "max-") + A + ":" + (T.length === 1 ? R.replace(Am, ((C, k, O) => Number(k) + E * (T === ">" ? -1 : 1) + O)) : R) : "") + ")";
          }))), v) {
            const D = U ? d.concat(p) : [...d], y = U ? [...l] : UA(l, p.split(vA));
            a !== void 0 && n(MS(...a)), a = void 0, c(m, y, D);
          } else a === void 0 && (a = [[], l, d]), p = U || p.charCodeAt(0) !== 36 ? p : `--${ra(i.prefix)}${p.slice(1).replace(/\$/g, "-")}`, m = v ? m : typeof m == "number" ? m && P in DA ? String(m) + "px" : String(m) : tv(SA(P, m ?? ""), i.prefix, i.themeMap[P]), a[0].push(`${U ? `${p} ` : `${Jm(p)}:`}${m}`);
        }
      }
      var g, I;
    };
    f(u), a !== void 0 && n(MS(...a)), a = void 0;
  };
  c(e, t, r);
}, MS = (e, t, r) => `${r.map(((i) => `${i}{`)).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, DA = { animationDelay: 1, animationDuration: 1, backgroundSize: 1, blockSize: 1, border: 1, borderBlock: 1, borderBlockEnd: 1, borderBlockEndWidth: 1, borderBlockStart: 1, borderBlockStartWidth: 1, borderBlockWidth: 1, borderBottom: 1, borderBottomLeftRadius: 1, borderBottomRightRadius: 1, borderBottomWidth: 1, borderEndEndRadius: 1, borderEndStartRadius: 1, borderInlineEnd: 1, borderInlineEndWidth: 1, borderInlineStart: 1, borderInlineStartWidth: 1, borderInlineWidth: 1, borderLeft: 1, borderLeftWidth: 1, borderRadius: 1, borderRight: 1, borderRightWidth: 1, borderSpacing: 1, borderStartEndRadius: 1, borderStartStartRadius: 1, borderTop: 1, borderTopLeftRadius: 1, borderTopRightRadius: 1, borderTopWidth: 1, borderWidth: 1, bottom: 1, columnGap: 1, columnRule: 1, columnRuleWidth: 1, columnWidth: 1, containIntrinsicSize: 1, flexBasis: 1, fontSize: 1, gap: 1, gridAutoColumns: 1, gridAutoRows: 1, gridTemplateColumns: 1, gridTemplateRows: 1, height: 1, inlineSize: 1, inset: 1, insetBlock: 1, insetBlockEnd: 1, insetBlockStart: 1, insetInline: 1, insetInlineEnd: 1, insetInlineStart: 1, left: 1, letterSpacing: 1, margin: 1, marginBlock: 1, marginBlockEnd: 1, marginBlockStart: 1, marginBottom: 1, marginInline: 1, marginInlineEnd: 1, marginInlineStart: 1, marginLeft: 1, marginRight: 1, marginTop: 1, maxBlockSize: 1, maxHeight: 1, maxInlineSize: 1, maxWidth: 1, minBlockSize: 1, minHeight: 1, minInlineSize: 1, minWidth: 1, offsetDistance: 1, offsetRotate: 1, outline: 1, outlineOffset: 1, outlineWidth: 1, overflowClipMargin: 1, padding: 1, paddingBlock: 1, paddingBlockEnd: 1, paddingBlockStart: 1, paddingBottom: 1, paddingInline: 1, paddingInlineEnd: 1, paddingInlineStart: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1, perspective: 1, right: 1, rowGap: 1, scrollMargin: 1, scrollMarginBlock: 1, scrollMarginBlockEnd: 1, scrollMarginBlockStart: 1, scrollMarginBottom: 1, scrollMarginInline: 1, scrollMarginInlineEnd: 1, scrollMarginInlineStart: 1, scrollMarginLeft: 1, scrollMarginRight: 1, scrollMarginTop: 1, scrollPadding: 1, scrollPaddingBlock: 1, scrollPaddingBlockEnd: 1, scrollPaddingBlockStart: 1, scrollPaddingBottom: 1, scrollPaddingInline: 1, scrollPaddingInlineEnd: 1, scrollPaddingInlineStart: 1, scrollPaddingLeft: 1, scrollPaddingRight: 1, scrollPaddingTop: 1, shapeMargin: 1, textDecoration: 1, textDecorationThickness: 1, textIndent: 1, textUnderlineOffset: 1, top: 1, transitionDelay: 1, transitionDuration: 1, verticalAlign: 1, width: 1, wordSpacing: 1 }, RS = (e) => String.fromCharCode(e + (e > 25 ? 39 : 97)), oo = (e) => ((t) => {
  let r, i = "";
  for (r = Math.abs(t); r > 52; r = r / 52 | 0) i = RS(r % 52) + i;
  return RS(r % 52) + i;
})(((t, r) => {
  let i = r.length;
  for (; i; ) t = 33 * t ^ r.charCodeAt(--i);
  return t;
})(5381, JSON.stringify(e)) >>> 0), vc = ["themed", "global", "styled", "onevar", "resonevar", "allvar", "inline"], wA = (e) => {
  if (e.href && !e.href.startsWith(location.origin)) return !1;
  try {
    return !!e.cssRules;
  } catch {
    return !1;
  }
}, TA = (e) => {
  let t;
  const r = () => {
    const { cssRules: n } = t.sheet;
    return [].map.call(n, ((a, o) => {
      const { cssText: s } = a;
      let c = "";
      if (s.startsWith("--sxs")) return "";
      if (n[o - 1] && (c = n[o - 1].cssText).startsWith("--sxs")) {
        if (!a.cssRules.length) return "";
        for (const u in t.rules) if (t.rules[u].group === a) return `--sxs{--sxs:${[...t.rules[u].cache].join(" ")}}${s}`;
        return a.cssRules.length ? `${c}${s}` : "";
      }
      return s;
    })).join("");
  }, i = () => {
    if (t) {
      const { rules: s, sheet: c } = t;
      if (!c.deleteRule) {
        for (; Object(Object(c.cssRules)[0]).type === 3; ) c.cssRules.splice(0, 1);
        c.cssRules = [];
      }
      for (const u in s) delete s[u];
    }
    const n = Object(e).styleSheets || [];
    for (const s of n) if (wA(s)) {
      for (let c = 0, u = s.cssRules; u[c]; ++c) {
        const l = Object(u[c]);
        if (l.type !== 1) continue;
        const d = Object(u[c + 1]);
        if (d.type !== 4) continue;
        ++c;
        const { cssText: p } = l;
        if (!p.startsWith("--sxs")) continue;
        const m = p.slice(14, -3).trim().split(/\s+/), f = vc[m[0]];
        f && (t || (t = { sheet: s, reset: i, rules: {}, toString: r }), t.rules[f] = { group: d, index: c, cache: new Set(m) });
      }
      if (t) break;
    }
    if (!t) {
      const s = (c, u) => ({ type: u, cssRules: [], insertRule(l, d) {
        this.cssRules.splice(d, 0, s(l, { import: 3, undefined: 1 }[(l.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
      }, get cssText() {
        return c === "@media{}" ? `@media{${[].map.call(this.cssRules, ((l) => l.cssText)).join("")}}` : c;
      } });
      t = { sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : s("", "text/css"), rules: {}, reset: i, toString: r };
    }
    const { sheet: a, rules: o } = t;
    for (let s = vc.length - 1; s >= 0; --s) {
      const c = vc[s];
      if (!o[c]) {
        const u = vc[s + 1], l = o[u] ? o[u].index : a.cssRules.length;
        a.insertRule("@media{}", l), a.insertRule(`--sxs{--sxs:${s}}`, l), o[c] = { group: a.cssRules[l + 1], index: l, cache: /* @__PURE__ */ new Set([s]) };
      }
      bA(o[c]);
    }
  };
  return i(), t;
}, bA = (e) => {
  const t = e.group;
  let r = t.cssRules.length;
  e.apply = (i) => {
    try {
      t.insertRule(i, r), ++r;
    } catch {
    }
  };
}, yc = Symbol(), MA = lu(), RA = (e, t) => MA(e, (() => (...r) => {
  let i = { type: null, composers: /* @__PURE__ */ new Set() };
  for (const n of r) if (n != null) if (n[Nl]) {
    i.type == null && (i.type = n[Nl].type);
    for (const a of n[Nl].composers) i.composers.add(a);
  } else n.constructor !== Object || n.$$typeof ? i.type == null && (i.type = n) : i.composers.add(NA(n, e));
  return i.type == null && (i.type = "span"), i.composers.size || i.composers.add(["PJLV", {}, [], [], {}, []]), EA(e, i, t);
})), NA = ({ variants: e, compoundVariants: t, defaultVariants: r, ...i }, n) => {
  const a = `${ra(n.prefix)}c-${oo(i)}`, o = [], s = [], c = /* @__PURE__ */ Object.create(null), u = [];
  for (const p in r) c[p] = String(r[p]);
  if (typeof e == "object" && e) for (const p in e) {
    l = c, d = p, gA.call(l, d) || (c[p] = "undefined");
    const m = e[p];
    for (const f in m) {
      const h = { [p]: String(f) };
      String(f) === "undefined" && u.push(p);
      const g = m[f], I = [h, g, !TS(g)];
      o.push(I);
    }
  }
  var l, d;
  if (typeof t == "object" && t) for (const p of t) {
    let { css: m, ...f } = p;
    m = typeof m == "object" && m || {};
    for (const g in f) f[g] = String(f[g]);
    const h = [f, m, !TS(m)];
    s.push(h);
  }
  return [a, i, o, s, c, u];
}, EA = (e, t, r) => {
  const [i, n, a, o] = AA(t.composers), s = typeof t.type == "function" || t.type.$$typeof ? ((d) => {
    function p() {
      for (let m = 0; m < p[yc].length; m++) {
        const [f, h] = p[yc][m];
        d.rules[f].apply(h);
      }
      return p[yc] = [], null;
    }
    return p[yc] = [], p.rules = {}, vc.forEach(((m) => p.rules[m] = { apply: (f) => p[yc].push([m, f]) })), p;
  })(r) : null, c = (s || r).rules, u = `.${i}${n.length > 1 ? `:where(.${n.slice(1).join(".")})` : ""}`, l = (d) => {
    d = typeof d == "object" && d || CA;
    const { css: p, ...m } = d, f = {};
    for (const I in a) if (delete m[I], I in d) {
      let U = d[I];
      typeof U == "object" && U ? f[I] = { "@initial": a[I], ...U } : (U = String(U), f[I] = U !== "undefined" || o.has(I) ? U : a[I]);
    } else f[I] = a[I];
    const h = /* @__PURE__ */ new Set([...n]);
    for (const [I, U, S, P] of t.composers) {
      r.rules.styled.cache.has(I) || (r.rules.styled.cache.add(I), ls(U, [`.${I}`], [], e, ((y) => {
        c.styled.apply(y);
      })));
      const v = NS(S, f, e.media), D = NS(P, f, e.media, !0);
      for (const y of v) if (y !== void 0) for (const [w, b, T] of y) {
        const R = `${I}-${oo(b)}-${w}`;
        h.add(R);
        const M = (T ? r.rules.resonevar : r.rules.onevar).cache, E = T ? c.resonevar : c.onevar;
        M.has(R) || (M.add(R), ls(b, [`.${R}`], [], e, ((A) => {
          E.apply(A);
        })));
      }
      for (const y of D) if (y !== void 0) for (const [w, b] of y) {
        const T = `${I}-${oo(b)}-${w}`;
        h.add(T), r.rules.allvar.cache.has(T) || (r.rules.allvar.cache.add(T), ls(b, [`.${T}`], [], e, ((R) => {
          c.allvar.apply(R);
        })));
      }
    }
    if (typeof p == "object" && p) {
      const I = `${i}-i${oo(p)}-css`;
      h.add(I), r.rules.inline.cache.has(I) || (r.rules.inline.cache.add(I), ls(p, [`.${I}`], [], e, ((U) => {
        c.inline.apply(U);
      })));
    }
    for (const I of String(d.className || "").trim().split(/\s+/)) I && h.add(I);
    const g = m.className = [...h].join(" ");
    return { type: t.type, className: g, selector: u, props: m, toString: () => g, deferredInjector: s };
  };
  return Jf(l, { className: i, selector: u, [Nl]: t, toString: () => (r.rules.styled.cache.has(i) || l(), i) });
}, AA = (e) => {
  let t = "";
  const r = [], i = {}, n = [];
  for (const [a, , , , o, s] of e) {
    t === "" && (t = a), r.push(a), n.push(...s);
    for (const c in o) {
      const u = o[c];
      (i[c] === void 0 || u !== "undefined" || s.includes(u)) && (i[c] = u);
    }
  }
  return [t, r, i, new Set(n)];
}, NS = (e, t, r, i) => {
  const n = [];
  e: for (let [a, o, s] of e) {
    if (s) continue;
    let c, u = 0, l = !1;
    for (c in a) {
      const d = a[c];
      let p = t[c];
      if (p !== d) {
        if (typeof p != "object" || !p) continue e;
        {
          let m, f, h = 0;
          for (const g in p) {
            if (d === String(p[g])) {
              if (g !== "@initial") {
                const I = g.slice(1);
                (f = f || []).push(I in r ? r[I] : g.replace(/^@media ?/, "")), l = !0;
              }
              u += h, m = !0;
            }
            ++h;
          }
          if (f && f.length && (o = { ["@media " + f.join(", ")]: o }), !m) continue e;
        }
      }
    }
    (n[u] = n[u] || []).push([i ? "cv" : `${c}-${a[c]}`, o, l]);
  }
  return n;
}, CA = {}, OA = lu(), kA = (e, t) => OA(e, (() => (...r) => {
  const i = () => {
    for (let n of r) {
      n = typeof n == "object" && n || {};
      let a = oo(n);
      if (!t.rules.global.cache.has(a)) {
        if (t.rules.global.cache.add(a), "@import" in n) {
          let o = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
          for (let s of [].concat(n["@import"])) s = s.includes('"') || s.includes("'") ? s : `"${s}"`, t.sheet.insertRule(`@import ${s};`, o++);
          delete n["@import"];
        }
        ls(n, [], [], e, ((o) => {
          t.rules.global.apply(o);
        }));
      }
    }
    return "";
  };
  return Jf(i, { toString: i });
})), xA = lu(), FA = (e, t) => xA(e, (() => (r) => {
  const i = `${ra(e.prefix)}k-${oo(r)}`, n = () => {
    if (!t.rules.global.cache.has(i)) {
      t.rules.global.cache.add(i);
      const a = [];
      ls(r, [], [], e, ((s) => a.push(s)));
      const o = `@keyframes ${i}{${a.join("")}}`;
      t.rules.global.apply(o);
    }
    return i;
  };
  return Jf(n, { get name() {
    return n();
  }, toString: n });
})), LA = class {
  constructor(e, t, r, i) {
    this.token = e == null ? "" : String(e), this.value = t == null ? "" : String(t), this.scale = r == null ? "" : String(r), this.prefix = i == null ? "" : String(i);
  }
  get computedValue() {
    return "var(" + this.variable + ")";
  }
  get variable() {
    return "--" + ra(this.prefix) + ra(this.scale) + this.token;
  }
  toString() {
    return this.computedValue;
  }
}, _A = lu(), BA = (e, t) => _A(e, (() => (r, i) => {
  i = typeof r == "object" && r || Object(i);
  const n = `.${r = (r = typeof r == "string" ? r : "") || `${ra(e.prefix)}t-${oo(i)}`}`, a = {}, o = [];
  for (const c in i) {
    a[c] = {};
    for (const u in i[c]) {
      const l = `--${ra(e.prefix)}${c}-${u}`, d = tv(String(i[c][u]), e.prefix, c);
      a[c][u] = new LA(u, d, c, e.prefix), o.push(`${l}:${d}`);
    }
  }
  const s = () => {
    if (o.length && !t.rules.themed.cache.has(r)) {
      t.rules.themed.cache.add(r);
      const c = `${i === e.theme ? ":root," : ""}.${r}{${o.join(";")}}`;
      t.rules.themed.apply(c);
    }
    return r;
  };
  return { ...a, get className() {
    return s();
  }, selector: n, toString: s };
})), VA = lu(), rv = (e) => {
  let t = !1;
  const r = VA(e, ((i) => {
    t = !0;
    const n = "prefix" in (i = typeof i == "object" && i || {}) ? String(i.prefix) : "", a = typeof i.media == "object" && i.media || {}, o = typeof i.root == "object" ? i.root || null : globalThis.document || null, s = typeof i.theme == "object" && i.theme || {}, c = { prefix: n, media: a, theme: s, themeMap: typeof i.themeMap == "object" && i.themeMap || { ...fA }, utils: typeof i.utils == "object" && i.utils || {} }, u = TA(o), l = { css: RA(c, u), globalCss: kA(c, u), keyframes: FA(c, u), createTheme: BA(c, u), reset() {
      u.reset(), l.theme.toString();
    }, theme: {}, sheet: u, config: c, prefix: n, getCssText: u.toString, toString: u.toString };
    return String(l.theme = l.createTheme(s)), l;
  }));
  return t || r.reset(), r;
}, jA = () => wS || (wS = rv()), Ge = (...e) => jA().css(...e);
function GA({ variant: e }) {
  return Ge({
    margin: "2.5px 0",
    variants: {
      variant: {
        showAddress: {
          lineHeight: "2.3em"
        }
      }
    }
  })({ variant: e });
}
const $A = Ge({
  justifyContent: "flex-start",
  alignItems: "center",
  whiteSpace: "nowrap",
  fontWeight: 500,
  display: "flex"
}), qA = Ge({
  textTransform: "$participant$textTransform",
  // marginInlineStart: "$space$2",
  // marginInlineEnd: "$space$2",
  fontSize: "0.875rem",
  fontWeight: 500,
  variants: {
    variant: {
      winner: {
        fontWeight: 700,
        color: "$winnerName"
      },
      loser: {
        fontWeight: 500
      }
    }
  }
}), WA = Ge({
  "&::WebkitScrollbar": { display: "none" },
  justifyContent: "space-between",
  flexDirection: "column",
  marginInlineEnd: "0rem",
  scrollbarWidth: "none",
  overflowX: "scroll",
  fontWeight: 500,
  display: "flex",
  width: "100%",
  variants: {
    variant: {
      doubles: {
        marginTop: "0.25rem",
        fontSize: "0.75rem",
        lineHeight: "1rem"
      }
    }
  }
});
function HA({ drawPosition: e, sideNumber: t }) {
  return Ge({
    minHeight: "$participant$minHeight",
    justifyContent: "space-between",
    paddingInlineStart: "0.75rem",
    backgroundColor: "$matchUp",
    paddingInlineEnd: "0rem",
    boxSizing: "border-box",
    paddingBottom: ".2rem",
    position: "relative",
    alignItems: "center",
    paddingTop: ".2rem",
    minWidth: "15rem",
    cursor: "pointer",
    display: "flex",
    flexGrow: 1,
    "& p": {
      fontFamily: "Sharp Sans, Arial, sans-serif",
      color: "$color"
    },
    variants: {
      sideNumber: {
        1: { borderBottom: "1px solid $internalDividers" }
      }
    }
  })({
    sideNumber: t,
    css: e && {
      "&:before": {
        backgroundColor: "$backgroundColor",
        content: `${e}`,
        justifyContent: "center",
        alignContent: "center",
        insetInlineStart: -10,
        position: "absolute",
        color: "#55AFFE",
        display: "flex",
        width: 20
      }
    }
  });
}
function zA({
  winnerChevron: e,
  isDoubles: t
}) {
  const r = (t ? 0.4 : 0.3) * 2;
  return Ge({
    variants: {
      variant: {
        winner: {
          "&::before": {
            borderTop: `${r}rem solid transparent`,
            borderBottom: `${r}rem solid transparent`,
            borderInlineStart: "8px solid #008f70",
            position: "absolute",
            insetInlineStart: 0,
            display: "block",
            content: ""
          }
        }
      }
    }
  })({ variant: e ? "winner" : void 0 });
}
const Zf = Ge({
  fontSize: "smaller",
  color: "gray"
});
function iv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Cm = { exports: {} };
var ES;
function YA() {
  return ES || (ES = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function r() {
        for (var a = "", o = 0; o < arguments.length; o++) {
          var s = arguments[o];
          s && (a = n(a, i(s)));
        }
        return a;
      }
      function i(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return r.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var o = "";
        for (var s in a)
          t.call(a, s) && a[s] && (o = n(o, s));
        return o;
      }
      function n(a, o) {
        return o ? a ? a + " " + o : a + o : a;
      }
      e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
    })();
  })(Cm)), Cm.exports;
}
var KA = YA();
const Ga = /* @__PURE__ */ iv(KA);
function QA({
  individualParticipant: e,
  className: t
}) {
  const { city: r, state: i, countryCode: n } = e?.person?.addresses?.[0] || {}, a = [r, i, n].filter(Boolean).join(", ") || " ", o = document.createElement("div");
  return o.className = Ga(Zf(), t), o.innerHTML = a, o;
}
const XA = Ge({
  willChange: "opacity",
  position: "fixed",
  zIndex: 9998,
  bottom: 0,
  right: 0,
  left: 0,
  top: 0
}), JA = Ge({
  display: "block"
}), ZA = Ge({
  position: "fixed",
  right: 0,
  left: 0
}), eC = Ge({
  paddingRight: "15px",
  alignItems: "center",
  margin: "30px auto",
  paddingLeft: "15px",
  position: "fixed",
  height: "100vh",
  display: "flex",
  width: "100%",
  zIndex: 9999,
  bottom: 0,
  right: 0,
  left: 0,
  top: 0
}), tC = Ge({
  boxShadow: "0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)",
  backgroundColor: "white",
  position: "relative",
  borderRadius: "3px",
  minHeight: "auto",
  width: "100%"
}), rC = Ge({
  borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  alignItems: "center",
  position: "relative",
  display: "flex"
}), iC = Ge({
  fontWeight: "600",
  fontSize: "20px"
}), AS = Ge({
  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  justifyContent: "right",
  alignItems: "center",
  position: "relative",
  display: "flex"
}), CS = "Nothing to see here";
function Oi(e) {
  return typeof e == "function";
}
function El(e) {
  return typeof e == "string";
}
function OS(e) {
  return Array.isArray(e);
}
function nC(e) {
  if (e)
    for (; e.firstChild; )
      e.removeChild(e.firstChild);
}
const kS = (() => {
  const e = ZA(), t = {}, r = ".5", i = [];
  let n;
  const a = [];
  let o = [], s;
  const c = (g) => {
    {
      const I = o.pop();
      I && document.body.removeChild(I);
    }
  }, u = () => {
    s && (s.style.opacity = "0", s.style.display = "none");
  }, l = (g) => {
    const I = o.length;
    if (g && t[I] === !1)
      return;
    const U = a.pop(), S = i.pop();
    Oi(U) && U({ content: S }), document.body.classList.remove(e), document.body.style.top = null, window.scrollTo({
      top: n,
      behavior: "instant"
    }), u(), c();
  }, d = () => {
    s = document.createElement("div"), s.className = XA(), s.id = "cmdl-backdrop", s.onclick = () => l(!0), document.body.appendChild(s);
  }, p = ({ config: g }) => {
    n = window.scrollY, document.body.classList.add(e), document.body.style.top = `-${n}px`, s || d(), s.style.display = "", g?.backdrop !== !1 && (s.style.backgroundColor = "rgba(0, 0, 0, 0.2)", s.style.transition = "opacity 0.15s linear", s.style.opacity = "1");
  }, m = ({
    config: g,
    attr: I,
    attrs: U,
    unit: S = "em",
    value: P
  }) => {
    let v;
    return El(I) ? v = Zm({ element: g, attr: I }) : OS(U) && (v = U.map((D) => Zm({ element: g, attr: D })).filter(Boolean)?.[0]), v !== void 0 && (P = v), isNaN(P) ? P : `${P}${S}`;
  }, f = ({ buttons: g, config: I, modalNumber: U }) => {
    const S = document.createElement("div");
    S.className = AS(), S.style.padding = m({ config: I, attrs: ["footer.padding", "padding"], value: r });
    const P = {
      label: I?.dictionary?.close || "Close",
      onClick: () => kS.close(),
      intent: "is-info"
    };
    for (const v of g) {
      if (v.hide) continue;
      const D = { ...P, ...v }, y = document.createElement("button");
      D.disabled !== void 0 && (y.disabled = D.disabled), D.id && (y.id = D.id), y.className = D?.footer?.className || "button font-medium", y.classList.add(D.intent || "is-info"), y.style = "margin-right: .5em;", y.innerHTML = D.label || D.text || "", y.onclick = (w) => {
        w.stopPropagation(), Oi(D.onClick) && D.onClick({ e: w, content: i[U] }), D.close !== !1 && (Oi(D.close) && D.close(), kS.close());
      }, S.appendChild(y);
    }
    return S;
  };
  return { close: l, open: ({ title: g = "", content: I, buttons: U, footer: S, config: P, onClose: v } = {}) => {
    p({ config: P }), a.push(v);
    const D = o.length + 1;
    t[D] = P?.clickAway;
    const y = document.createElement("section"), w = `cmdl-${D}`;
    y.className = JA(), y.role = "dialog", y.tabIndex = -1, y.id = w;
    const b = document.createElement("div");
    b.className = eC(), b.style.maxWidth = `${P?.maxWidth || 450}px`, b.onclick = () => l(!0);
    const T = document.createElement("div");
    T.className = tC(), T.onclick = (L) => L.stopPropagation();
    const R = document.createElement("div"), M = document.createElement("div");
    R.appendChild(M), T.appendChild(R);
    const E = ({ title: L, config: j }) => {
      R.className = L ? rC() : "", R.style.padding = m({ config: j, attrs: ["title.padding", "padding"], value: r }), M.className = L ? iC() : "", M.innerHTML = L;
    };
    g && E({ title: g });
    const A = document.createElement("div");
    T.appendChild(A);
    const N = ({ content: L, config: j }) => {
      A.style.fontSize = m({ config: j, attr: "fontSize", value: "15px" }), A.style.position = "relative", A.style.padding = m({ config: j, attrs: ["content.padding", "padding"], value: r }), Oi(L) ? i[D] = L(A) : L instanceof HTMLElement ? A.appendChild(L) : El(L) ? A.innerHTML = L : A.innerHTML = CS;
    };
    N({ content: I, config: P });
    let C;
    if (OS(U))
      C = f({ buttons: U, config: P, modalNumber: D }), T.appendChild(C);
    else if (S) {
      const L = document.createElement("div");
      L.className = AS(), L.style.padding = m({ config: P, attrs: ["footer.padding", "padding"] }), S instanceof HTMLElement ? L.appendChild(S) : El(S) ? L.innerHTML = S : L.innerHTML = CS, C = L, T.appendChild(L);
    }
    b.appendChild(T), y.appendChild(b), document.body.appendChild(y), o.push(y);
    const k = ({ content: L, config: j }) => {
      i[D] = void 0, nC(A), N({ content: L, config: j });
    }, O = ({ buttons: L, config: j }) => {
      C && T.removeChild(C), C = f({ buttons: L, config: j, modalNumber: D }), T.appendChild(C);
    }, _ = ({ onClose: L }) => {
      a.length = 0, a.push(L);
    };
    return { setContent: k, setButtons: O, update: ({ content: L, buttons: j, title: H, config: G, onClose: V }) => {
      P = G || P, L && k({ content: L, config: P }), j && O({ buttons: j, config: P }), V && _({ onClose: V }), H && E({ title: H, config: P });
    } };
  } };
})();
function Zm({ element: e, attr: t }) {
  if (!El(t)) return;
  const r = t.split(".");
  for (const i of r)
    if (e = e?.[i], !e) return;
  return e;
}
function aC({
  individualParticipant: e,
  attribute: t,
  className: r
}) {
  const i = e?.person, n = Zm({ element: i, attr: t });
  if (!n) return "";
  const a = document.createElement("div");
  return a.className = Ga(Zf(), r), a.innerHTML = n, a;
}
function oC({
  individualParticipant: e,
  className: t
}) {
  const r = e?.teams?.[0], i = r?.participantName || " ", n = document.createElement("div");
  return n.className = Ga(Zf(), t), n.classList.add("tmx-tm"), n.setAttribute("id", r?.participantId || ""), n.innerHTML = i, n;
}
function sC(e) {
  const t = e?.composition?.configuration?.participantDetail;
  if (t === "TEAM") return oC(e);
  if (e?.composition?.configuration?.showAddress ?? t === "ADDRESS") return QA(e);
  if (t) {
    const n = aC({ ...e, attribute: t });
    if (n && typeof n != "string")
      return n;
  }
  return document.createElement("div");
}
const cC = Ge({
  color: "$participant$seed",
  marginInlineStart: ".5rem",
  textTransform: "uppercase",
  fontSize: "0.75rem",
  lineHeight: "1rem"
});
function uC({ className: e, composition: t, side: r }) {
  const i = r?.seedValue === "~" ? "" : r?.seedValue !== void 0 && r.seedValue || r?.seedNumber;
  if (!i) return "";
  const n = t?.configuration || {}, { bracketedSeeds: a } = n, o = typeof a == "boolean" && ["(", ")"] || a === "square" && ["[", "]"] || ["", ""], s = `${o[0]}${i}${o[1]}`, c = n.seedingElement === "sup" ? "sup" : "span", u = document.createElement(c);
  return u.className = e || "", u.innerHTML = s, u;
}
const lC = Ge({
  WebkitBoxSizing: "border-box",
  marginInlineEnd: ".5em",
  boxSizing: "border-box",
  display: "inline-block",
  position: "relative",
  fontSize: "smaller",
  fontWeight: "bold",
  borderRadius: 2,
  // width: '1.8rem',
  color: "blue",
  variants: {
    color: {
      green: {
        color: "green"
      },
      red: {
        color: "red"
      }
    }
  }
});
function dC({ individualParticipant: e, composition: t, className: r, matchUp: i, spacer: n }) {
  const a = t?.configuration, o = a?.scaleAttributes?.eventType || i?.matchUpType || "SINGLES", s = e?.rankings, c = e?.ratings, u = a?.scaleAttributes, l = u?.scaleType, d = u?.scaleName, p = u?.accessor, m = l === "RATING" ? c : s, f = m?.SINGLES?.find((w) => w?.scaleName === d)?.scaleValue, h = m?.DOUBLES?.find((w) => w?.scaleName === d)?.scaleValue, g = f && p ? f[p] : f || "", I = h && p ? h[p] : h || "", U = o === "SINGLES" ? g : I, S = a?.scaleAttributes?.fallback, P = !n && (U || S && (g || I)), v = document.createElement("span"), D = a?.scaleAttributes?.scaleColor, y = D === "green" || D === "red" ? D : void 0;
  return P && (v.className = Ga(r, lC(y ? { color: y } : {}))), v.innerHTML = P || "", v;
}
var pC = Object.defineProperty, Me = (e, t) => {
  for (var r in t) pC(e, r, { get: t[r], enumerable: !0 });
};
function bd() {
  return "2.2.31";
}
var nv = {};
Me(nv, { competitionGovernor: () => av, drawsGovernor: () => ew, entriesGovernor: () => sR, eventGovernor: () => fR, generationGovernor: () => AR, matchUpFormatGovernor: () => jR, matchUpGovernor: () => GR, mocksGovernor: () => QU, participantGovernor: () => xN, policyGovernor: () => OM, publishingGovernor: () => nE, queryGovernor: () => _M, reportGovernor: () => mE, scheduleGovernor: () => fE, scoreGovernor: () => FI, tieFormatGovernor: () => bE, tournamentGovernor: () => xE, venueGovernor: () => YE });
var av = {};
Me(av, { getLinkedTournamentIds: () => Nu, getTournamentIds: () => Mu, linkTournaments: () => QD, mutate: () => ov, query: () => ZD, unlinkTournament: () => JD, unlinkTournaments: () => XD });
var ov = {};
Me(ov, { linkTournaments: () => QD, unlinkTournament: () => JD, unlinkTournaments: () => XD });
var so = "SINGLES", Xe = "SINGLES", Ma = "DOUBLES", Ke = "DOUBLES", Hr = "TEAM", ot = "TEAM", mC = { SINGLES_MATCHUP: so, SINGLES: Xe, DOUBLES_MATCHUP: Ma, DOUBLES: Ke, TEAM_MATCHUP: Hr, TEAM: ot }, sv = { [Xe]: [Xe, "S"], [Ke]: [Ke, "D"], [ot]: [ot, "T"], S: [Xe, "S"], D: [Ke, "D"], T: [ot, "T"] };
function Ot(e, t) {
  return (e ?? 0) - (t ?? 0);
}
function pe(e) {
  return typeof e == "number" ? parseInt(e.toString()) : typeof e == "string" ? parseInt(e) : 0;
}
function Fi(e) {
  return isNaN(e) ? !1 : e && (e & e - 1) === 0;
}
function xS(e) {
  if (!e.length) return;
  let t = [...e].sort(Ot), r = Math.floor(t.length / 2);
  return t.length % 2 ? t[r] : (t[r - 1] + t[r]) / 2;
}
function fC(e) {
  if (!Fi(e)) return !1;
  let t = e, r = 1;
  for (; t !== 2; ) r += 1, t = t / 2;
  return r;
}
function eh(e) {
  return isNaN(e) ? 0 : e % 2 && e + 1 || e;
}
function th(e) {
  return Math.pow(2, Math.round(Math.log(e) / Math.log(2)));
}
function gt(e) {
  return !isNaN(parseFloat(e));
}
function cv(e) {
  let t = pe(e);
  if (!isNaN(t)) return t === 0 ? !1 : (t & -t) === 1;
}
function Bs(e) {
  if (isNaN(e)) return !1;
  for (; !Fi(e); ) e++;
  return e;
}
function ti(e, t) {
  return e = Math.ceil(e), t = Math.floor(t), Math.floor(Math.random() * (t - e + 1)) + e;
}
function Ie(e) {
  return Number.isSafeInteger(typeof e == "string" ? +e : e);
}
function hC(e = 1, t = 3, r = !0) {
  let i = 0;
  for (let n = 0; n < t; n++) i += Math.random() * (e / t);
  return r && e > 1 ? Math.round(i) : i;
}
function gC(e, t) {
  t || (t = 1);
  let r = 1 / t;
  return Math.round(e * r) / r;
}
function uv(e, t, r, i, n = 2) {
  let a = 1 - Math.random(), o = 1 - Math.random(), s = Math.sqrt(-2 * Math.log(a)) * Math.cos(2 * Math.PI * o);
  return s = s / 10 + 0.5, s > 1 || s < 0 ? s = uv(e, t, r) : (s = Math.pow(s, r), s *= t - e, s += e), i && (s = gC(s, i)), parseFloat(s.toFixed(n));
}
function Hl(e, t = 2) {
  return parseFloat(Number(Math.round(e * 1e3) / 1e3).toFixed(t));
}
function Ue(e) {
  return Array.isArray(e) ? e?.filter((t, r, i) => i.lastIndexOf(t) === r) : [];
}
function IC(e) {
  return Array.isArray(e) ? e?.map((t) => t === null ? void 0 : t) : e;
}
function mr(e) {
  return Array.isArray(e) ? e.map((t) => [Math.random(), t]).sort((t, r) => t[0] - r[0]).map((t) => t[1]) : [];
}
function gs(e) {
  return Ie(e) ? e : 1 / 0;
}
function Br(e) {
  return Array.isArray(e) ? e.reduce((t, r) => (t[r] || (t[r] = 0), t[r]++, t), {}) : {};
}
function UC(e) {
  return lv(Br(e));
}
function lv(e) {
  return Object.keys(e).reduce((t, r) => {
    let i = e[r];
    return t[i] ? t[i].push(r) : t[i] = [r], t;
  }, {});
}
function SC(e, t, r) {
  return r.indexOf(e) === t;
}
function dv(e) {
  return e.filter(SC);
}
function Lr(e) {
  return Array.isArray(e) && e.length ? e.splice(Math.floor(Math.random() * e.length), 1)[0] : void 0;
}
function xr(e) {
  let t = Math.floor(Math.random() * e.length);
  return e[t];
}
function te(e, t) {
  return Array.from({ length: t - e }, (r, i) => i + e);
}
function qi(e, t) {
  return t.reduce((r, i, n) => (i === e && r.push(n), r), []);
}
function Pt(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? [] : e.filter((r) => t.indexOf(r) !== -1).filter((r, i, n) => n.indexOf(r) === i);
}
function FS(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? [] : e.filter((r) => !t.includes(r));
}
function gr(e, t) {
  return !Array.isArray(e) || !Array.isArray(t) ? !1 : e.some((r) => t.includes(r));
}
function yC(e, t) {
  return Array.isArray(t) && t.reduce((r, i) => (r[i] = 1 + r[i] || 1, r), {})[e] || 0;
}
function vC(e, t, r, i) {
  return Array.isArray(e) ? [].concat(...e.slice(0, t), ...e.slice(t, t + r).sort(i), ...e.slice(t + r, e.length)) : [];
}
function qt(e, t) {
  return Array.isArray(e) ? e.reduce((r, i, n) => {
    let a = Math.floor(n / t);
    return r[a] = [].concat(r[a] || [], i), r;
  }, []) : [];
}
function pv(e, [t, ...r]) {
  return e.length ? [e.slice(0, t), ...pv(e.slice(t), [...r, t])] : [];
}
function PC(e) {
  return e.reduce((t, r) => {
    let i = t[t.length - 1];
    return (!i || i[i.length - 1] !== r - 1) && t.push([]), t[t.length - 1].push(r), t;
  }, []);
}
function mv(e) {
  return Array.isArray(e) ? e.reduce((t, r) => !isNaN(parseInt(r)) && t, !0) : !1;
}
function fv(e) {
  return Array.isArray(e) ? e.reduce((t, r) => isNaN(parseInt(r)) && t, !0) : !1;
}
function ef(e, t, r) {
  return Array.isArray(e) ? e.reduce((i, n, a) => {
    let o = r ? !!(Math.floor(a / t) % 2) : !1, s = a % t, c = o ? t - 1 - s : s;
    return i[c] || (i[c] = []), i[c].push(n), i;
  }, []) : [];
}
function DC(e, t = 1) {
  if (!Array.isArray(e) || !e.every(Ie)) return [];
  let r = Math.min(...e, t), i = Math.max(...e);
  return te(r, i + 1).filter((n) => !e.includes(n));
}
function Fr(e) {
  return typeof e == "function";
}
function dt(e) {
  return typeof e == "string";
}
function xe(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function wC(e, t) {
  if (!xe(e) || !xe(t)) return !1;
  let r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length) return !1;
  for (let n of r) if (e[n] !== t[n]) return !1;
  return !0;
}
function hv(e, t) {
  return Array.isArray(e) ? Object.assign({}, ...(e ?? []).filter(xe).map((r) => r[t] && { [r[t]]: r }).filter(Boolean)) : {};
}
var TC = (e) => (t) => Object.keys(e).every((r) => t[r] === e[r]);
function tf(e, t) {
  if (e === void 0) return null;
  if (!xe(e) || e === null) return e;
  let r = Object.keys(e), i = (n) => n === void 0 ? null : n;
  return Object.assign({}, ...r.map((n) => Array.isArray(e[n]) ? { [n]: t ? e[n] : e[n].map((a) => tf(a)) } : { [n]: t ? i(e[n]) : tf(e[n]) }));
}
function rf(e) {
  return Array.isArray(e) ? e.length + e.map(rf).reduce((t, r) => t + r, 0) : xe(e) && e !== null ? Object.keys(e).length + Object.keys(e).map((t) => rf(e[t])).reduce((t, r) => t + r, 0) : 0;
}
function bC(e) {
  if (e === null || typeof e != "object") return;
  let t = JSON.stringify(e), r = rf(e), i = t.split("").reduce((n, a) => n + a.charCodeAt(0), 0);
  return [t.length, r, i].map((n) => n.toString(36)).join("");
}
function Md(e, t) {
  return !Array.isArray(e) || !dt(t) ? !1 : Pt(e, sv[t]).length;
}
var x = { success: !0 }, gv = "error", MC = { SUCCESS: x, ERROR: gv };
function Iv({ collectionValueProfiles: e, matchUpCount: t }) {
  let r = [];
  if (!Array.isArray(e)) return r.push(`collectionValueProfiles is not an array: ${e}`), { errors: r };
  if (e.length && e.length !== t) return r.push("collectionValueProfiles do not align with matchUpsCount"), { errors: r };
  for (let n of e) {
    if (typeof n != "object") return r.push(`valueProfile is not type object: ${n}`), { errors: r };
    let { matchUpValue: a, collectionPosition: o } = n;
    if (typeof a != "number" || typeof o != "number" || o > t || o < 1) return r.push("Invalid value profile: value and collectionPosition must be numeric. collectionPosition cannot be greater than matchUpCount"), { errors: r };
  }
  let i = e.map((n) => n.collectionPosition);
  return i.length !== Ue(i).length ? (r.push("collectionPositions are not unique"), { errors: r }) : { ...x };
}
var RC = {};
Me(RC, { addNotice: () => Se, callListener: () => mf, createInstanceState: () => u0, cycleMutationStatus: () => Ah, deepCopyEnabled: () => Eh, deleteNotice: () => Ch, deleteNotices: () => Uu, disableNotifications: () => NP, enableNotifications: () => Ol, getDevContext: () => Yr, getMethods: () => CP, getNotices: () => OP, getProvider: () => ff, getTopics: () => ci, getTournamentId: () => Oo, getTournamentRecord: () => Oh, getTournamentRecords: () => ko, globalLog: () => FP, handleCaughtError: () => $d, hasTopic: () => jd, removeTournamentRecord: () => xP, setDeepCopy: () => Lc, setDevContext: () => Fc, setGlobalLog: () => RP, setGlobalMethods: () => EP, setGlobalSubscriptions: () => d0, setMethods: () => AP, setStateMethods: () => LP, setStateProvider: () => c0, setSubscriptions: () => p0, setTournamentId: () => _c, setTournamentRecord: () => kP, setTournamentRecords: () => Gd, timeKeeper: () => l0 });
var nf = { message: "Chronological error; time violation.", code: "ANACHRONISM" }, kc = { message: "Duplicate entry", code: "DUPLICATE_ENTRY" }, Uv = { message: "Cannot remove main structure", code: "ERR_CANNOT_REMOVE_MAIN_STRUCTURE" }, af = { message: "records must be an object with tournamentId keys", code: "ERR_INVALID_TOURNAMENTS" }, ht = { message: "Missing tournamentRecords", code: "ERR_MISSING_TOURNAMENTS" }, J = { message: "Missing tournamentRecord", code: "ERR_MISSING_TOURNAMENT" }, du = { message: "Invalid tournamentRecord", code: "ERR_INVALID_TOURNAMENT" }, Is = { message: "Missing tournamentId", code: "ERR_MISSING_TOURNAMENT_ID" }, co = { message: "Invalid drawDefinition", code: "ERR_INVALID_DRAWDEF" }, ne = { message: "Missing drawDefinition", code: "ERR_MISSING_DRAWDEF" }, Sv = { message: "Existing drawDefinition(s)", code: "ERR_EXISTING_DRAWDEFS" }, zr = { message: "drawDefinition not found", code: "ERR_NOT_FOUND_DRAWDEF" }, $a = { message: "Invalid structure", code: "ERR_INVALID_STRUCTURE" }, rh = { message: "Incomplete source structure", code: "ERR_INCOMPLETE_STRUCTURE" }, ih = { message: "Invalid drawPosition for seedAssignment", code: "ERR_INVALID_SEEDING_POSITION" }, Us = { message: "drawPosition already assigned", code: "ERR_EXISTING_POSITION_ASSIGNMENT" }, yv = { message: "Schedule not cleared", code: "ERR_UNCHANGED_SCHEDULE_NOT_CLEARED" }, vv = { message: "drawPosition not cleared", code: "ERR_FAILURE_POSITION_NOT_CLEARED" }, NC = { message: "drawPosition not found", code: "ERR_NOT_FOUND_DRAW_POSITION" }, nh = { message: "Unrecognized drawType", code: "ERR_UNRECOGNIZED_DRAW_TYPE" }, pu = { message: "Missing drawPositions", code: "ERR_MISSING_DRAW_POSITIONS" }, Rd = { message: "drawPosition is active", code: "ERR_ACTIVE_DRAW_POSITION" }, EC = { message: "drawPosition is occupied", code: "ERR_OCCUPIED_DRAW_POSITION" }, Vs = { message: "Invlid drawPosition", code: "ERR_INVALID_DRAW_POSITION" }, js = { message: "Missing drawPosition", code: "ERR_MISSING_DRAW_POSITION" }, ah = { message: "Invalid drawType", code: "ERR_INVALID_DRAW_TYPE" }, Nd = { message: "Invalid drawSize", code: "ERR_INVALID_DRAW_SIZE" }, Pv = { message: "Cannot set drawSize to be less than existing entries", code: "ERR_INVALID_DRAW_SIZE_MISMATCH" }, mu = { message: "Missing drawSize", code: "ERR_MISSING_DRAW_SIZE" }, Vi = { message: "Missing drawId", code: "ERR_MISSING_DRAW_ID" }, Dv = { message: "drawId exists", code: "ERR_EXISTING_DRAW_ID" }, wv = { message: "participantId cannot be assigned to multiple seedNumbers", code: "INVALID_PARTICIPANT_SEEDING" }, Tv = { message: "seedsCount greater than drawSize", code: "ERR_INVALID_SEED_COUNT" }, bv = { message: "Missing seedCountThresholds", code: "ERR_MISSING_SEED_COUNT_THRESHOLD" }, Mv = { message: "Invalid action", code: "ERR_INVALID_ACTION" }, of = { message: "Invalid assignment", code: "ERR_INVALID_ASSIGNMENT" }, Rv = { message: "Missing seedAssignments", code: "ERR_MISSING_SEED_ASSIGNMENTS" }, Nv = { message: "Invalid seedNumber", code: "ERR_INVALID_SEED_NUMBER" }, Ev = { message: "Invalid seedPosition", code: "ERR_INVALID_SEED_POSITION" }, oh = { message: "Missing targetLink", code: "ERR_MISSING_LINK_TARGET" }, Av = { message: "Existing round", code: "ERR_EXISTING_ROUND" }, AC = { message: "Missing roundNumber", code: "ERR_MISSING_ROUND_NUMBER" }, Qr = { message: "Missing structureId", code: "ERR_MISSING_STRUCTURE_ID" }, mt = { message: "structure not found", code: "ERR_NOT_FOUND_STRUCTURE" }, sh = { message: "Missing structures", code: "ERR_MISSING_STRUCTURES" }, qa = { message: "Missing structure", code: "ERR_MISSING_STRUCTURE" }, ch = { message: "Missing MAIN structure", code: "ERR_MISSING_MAIN_STRUCTURE" }, Cv = { message: "drawDefinition contains unlinked structures", code: "ERR_MISSING_STRUCTURE_LINKS" }, fn = { message: "Invalid eventType", code: "ERR_INVALID_EVENT_TYPE" }, st = { message: "Missing event / eventId", code: "ERR_MISSING_EVENT_ID" }, ni = { message: "Event not found", code: "ERR_NOT_FOUND_EVENT" }, Ov = { message: "Event exists", code: "ERR_EXISTING_EVENT" }, kv = { message: "Missing entries", code: "ERR_MISSING_ENTRIES" }, xv = { message: "Invalid entries", code: "ERR_INVALID_ENTRIES" }, uh = { message: "Missing assignments", code: "ERR_MISSING_ASSIGNMENTS" }, Fv = { message: "Missing stage", code: "ERR_MISSING_STAGE" }, Wa = { message: "Invalid stage", code: "ERR_INVALID_STAGE" }, Lv = { message: "stageSequence limit", code: "ERR_LIMIT_STAGE_SEQUENCE" }, _v = { message: "Missing positionAssignments", code: "ERR_MISSING_POSITION_ASSIGNMENTS" }, Bv = { message: "Cannot Assign BYE status if no assignment: { bye: true }", code: "ERR_UNCHANGED_CANNOT_ASSIGN_BYE" }, sf = { message: "Unrecognized matchUpStatus", code: "ERR_UNRECOGNIZED_MATCHUP_STATUS" }, fu = { message: "Unrecognized matchUpFormat", code: "ERR_UNRECOGNIZED_MATCHUP_FORMAT" }, Al = { message: "Incompatible matchUpStatus", code: "ERR_INCOMPATIBLE_MATCHUP_STATUS" }, Gs = { message: "Invalid matchUpStatus", code: "ERR_INVALID_MATCHUP_STATUS" }, cn = { message: "Invalid tieFormat", code: "ERR_INVALID_TIE_FORMAT" }, lh = { message: "Invalid matchUpFormat", code: "ERR_INVALID_MATCHUP_FORMAT" }, dh = { message: "Missing matchUpFormat", code: "ERR_MISSING_MATCHUP_FORMAT" }, Vv = { message: "Missing collectionDefinition", code: "ERR_MISSING_COLLECTION_DEFINITION" }, $s = { message: "Missing tieFormat", code: "ERR_MISSING_TIE_FORMAT" }, pr = { message: "Missing matchUpId", code: "ERR_MISSING_MATCHUP_ID" }, Ro = { message: "Missing matchUpIds", code: "ERR_MISSING_MATCHUP_IDS" }, cr = { message: "matchUp not found", code: "ERR_NOT_FOUND_MATCHUP" }, Gn = { message: "Missing matchUps", code: "ERR_MISSING_MATCHUPS" }, Dr = { message: "Missing matchUp", code: "ERR_MISSING_MATCHUP" }, Cr = { message: "Invalid matchUp", code: "ERR_INVALID_MATCHUP" }, ph = { message: "Missing policyType", code: "ERR_MISSING_POLICY_TYPE" }, Ed = { message: "Missing policyDefinitions", code: "ERR_MISSING_POLICY_DEFINITIONS" }, CC = { message: "Missing seeding policy", code: "ERR_MISSING_POLICY_SEEDING" }, jv = { message: "Missing avoidance policy", code: "ERR_MISSING_POLICY_AVOIDANCE" }, mh = { message: "Missing policy attributes", code: "ERR_MISSING_POLICY_ATTRIBUTES" }, Gv = { message: "Invalid policyDefinitions", code: "ERR_INVALID_POLICY_DEFINITIONS" }, fh = { message: "existing policyType", code: "ERR_EXISTING_POLICY_TYPE" }, OC = { message: "Policy not attached", code: "ERR_FAILURE_POLICY_NOT_ATTACHED" }, hu = { message: "Policy not found", code: "ERR_NOT_FOUND_POLICY" }, kC = { message: "Missing scoring policy / matchUpFormats", code: "ERR_MISSING_POLICY_SCORING_MATCHUP_FORMATS" }, hh = { message: "Invalid sideNumber", code: "ERR_INVALID_SIDE_NUMBER" }, xC = { message: "Invalid setNumber", code: "ERR_INVALID_SET_NUMBER" }, Ad = { message: "Missing setObject", code: "ERR_MISSING_SET_ATTRIBUTE" }, FC = { message: "Missing setNumber", code: "ERR_MISSING_SET_NUMBER" }, LC = { message: "Missing sideNumber", code: "ERR_MISSING_SIDE_NUMBER" }, No = { message: "Missing courtId", code: "ERR_MISSING_COURT_ID" }, ue = { message: "Missing value", code: "ERR_MISSING_VALUE" }, $v = { message: "Missing birthdate", code: "ERR_MISSING_BIRTH_DATE" }, qv = { message: "Missing date", code: "ERR_MISSING_DATE" }, Wv = { message: "No valid dates", code: "ERR_NO_VALID_DATES" }, zl = { message: "Invalid bookings", code: "ERR_INVALID_BOOKINGS" }, Cl = { message: "Invalid dateAvailability", code: "ERR_INVALID_DATE_AVAILABILITY" }, Hv = { message: "Missing dateAvailability", code: "ERR_MISSING_DATE_AVAILABILITY" }, Ht = { message: "Invalid Date", code: "ERR_INVALID_DATE" }, fi = { message: "Invalid time", code: "ERR_INVALID_TIME" }, zv = { message: "Invalid tournament dates", code: "ERR_INVALID_DATES_TOURNAMENT" }, cf = { message: "Invalid game scores", code: "ERR_INVALID_SCORES_GAME" }, Yv = { message: "Invalid score", code: "ERR_INVALID_SCORE" }, Cd = { message: "Invalid winningSide", code: "ERR_INVALID_WINNING_SIDE" }, _C = { message: "No participants generated", code: "ERR_NO_PARTICIPANTS_GENERATED" }, gh = { message: "Cannot modify tieFormat", code: "ERR_UNCHANGED_CANNOT_MODIFY_TIEFORMAT" }, Kv = { message: "Cannot modify participantType", code: "ERR_UNCHANGED_CANNOT_MODIFY_PARTICIPANT_TYPE" }, Od = { message: "Cannot remove participants", code: "ERR_UNCHANGED_CANNOT_REMOVE_PARTICIPANTS" }, uf = { message: "Participant category mismatch", code: "ERR_CATEGORY_MISMATCH" }, kd = { message: "Cannot change winningSide", code: "ERR_UNCHANGED_CANNOT_CHANGE_WINNING_SIDE" }, Eo = { message: "Invalid participant", code: "ERR_INVALID_PARTICIPANT" }, Li = { message: "Invalid participantId", code: "ERR_INVALID_PARTICIPANT_ID" }, _r = { message: "Invalid participantIds", code: "ERR_INVALID_PARTICIPANT_IDS" }, Qv = { message: "Invalid participantRole", code: "ERR_INVALID_PARTICIPANT_ROLE" }, _i = { message: "Invalid participantType", code: "ERR_INVALID_PARTICIPANT_TYPE" }, Xv = { message: "Missing participantRole", code: "ERR_MISSING_PARTICIPANT_ROLE" }, Ao = { message: "Missing participant", code: "ERR_MISSING_PARTICIPANT" }, gu = { message: "Missing participants", code: "ERR_MISSING_PARTICIPANTS" }, Ft = { message: "Missing participantId", code: "ERR_MISSING_PARTICIPANT_ID" }, Jv = { message: "Missing qualified participants", code: "ERR_MISSING_QUALIFIED_PARTICIPANTS" }, Tt = { message: "Participant Not Found", code: "ERR_NOT_FOUND_PARTICIPANT" }, Zv = { message: "participantId exists", code: "ERR_EXISTING_PARTICIPANT_ID" }, BC = { message: "participant pair exists", code: "ERR_EXISTING_PARTICIPANT_PAIR" }, eP = { message: "No participant removed", code: "ERR_UNCHANGED_NO_PARTICIPANT_REMOVED" }, la = { message: "Missing participantIds", code: "ERR_MISSING_PARTICIPANT_IDS" }, tP = { message: "Missing participantsCount", code: "ERR_MISSING_PARTICIPANT_COUNT" }, rP = { message: "Participant not checked in", code: "ERR_UNCHANGED_PARTICIPANT_NOT_CHECKED_IN" }, iP = { message: "Missing person details", code: "ERR_MISSING_PERSON_DETAILS" }, qs = { message: "Existing participant drawPosition assignment", code: "ERR_EXISTING_PARTICIPANT_DRAW_POSITION_ASSIGNMENT" }, xd = { message: "Existing participant", code: "ERR_EXISTING_PARTICIPANT" }, Ih = { message: "participantsCount exceeds drawSize", code: "ERR_INVALID_PARTICIPANT_COUNT" }, lf = { message: "Invalid entry status", code: "ERR_INVALID_ENTRY_STATUS" }, nP = { message: "Participant Entry Not Found", code: "ERR_NOT_FOUND_PARTICIPANT_ENTRY" }, VC = { message: "Participant not entered in stage", code: "ERR_UNCHANGED_PARTICIPANT_NOT_ENTERED" }, jC = { message: "Participant not found in stageSequence", code: "ERR_NOT_FOUND_PARTICIPANT_IN_STAGE" }, aP = { message: "entryStatus not allowed in stage", code: "ERR_INVALID_ENTRY_STATUS_IN_STAGE" }, oP = { message: "entryStatus not allowed for event", code: "ERR_INVALID_ENTRY_STATUS_IN_EVENT" }, df = { message: "No stage space available for entryStatus", code: "ERR_UNCHANGED_NO_AVAILABLE_STAGE_SPACE" }, Uh = { message: "Insufficient drawPositions to accommodate qualifiers", code: "ERR_UNCHANGED_NO_DRAW_POSITIONS_FOR_QUALIFIERS" }, Sh = { message: "Insufficient drawPositions to accommodate entries", code: "ERR_INSUFFICIENT_DRAW_POSITIONS" }, sP = { message: "Missing penaltyType", code: "ERR_MISSING_PENALTY_TYPE" }, yh = { message: "Missing penaltyId", code: "ERR_MISSING_PENALTY_ID" }, Ss = { message: "Penalty not found", code: "ERR_NOT_FOUND_PENALTY" }, cP = { message: "Missing courtsCount/courtNames", code: "ERR_MISSING_COURTS_INFO" }, Ws = { message: "Court not found", code: "ERR_NOT_FOUND_COURT" }, uP = { message: "Court exists", code: "ERR_EXISTING_COURT" }, lP = { message: "Venue exists", code: "ERR_EXISTING_VENUE" }, Co = { message: "Venue not found", code: "ERR_NOT_FOUND_VENUE" }, da = { message: "Missing venueId", code: "ERR_MISSING_VENUE_ID" }, dP = { message: "Invalid endTime", code: "ERR_INVALID_END_TIME" }, vh = { message: "Existing endTime", code: "ERR_EXISTING_END_TIME" }, pP = { message: "Invalid stopTime", code: "ERR_INVALID_STOP_TIME" }, mP = { message: "Invalid startTime", code: "ERR_INVALID_START_TIME" }, GC = { message: "Invalid resumeTime", code: "ERR_INVALID_RESUME_TIME" }, Ph = { message: "Invalid timeItem", code: "ERR_INVALID_TIME_ITEMS" }, fP = { message: "Missing async state provider", code: "ERR_MISSING_ASYNC_STATE_PROVIDER" }, Dh = { message: "Missing timeItem", code: "ERR_MISSING_TIME_ITEM" }, wh = { message: "Missing timeItems", code: "ERR_MISSING_TIME_ITEMS" }, Fd = { message: "Missing context", code: "ERR_MISSING_CONTEXT" }, hP = { message: "Missing schedule", code: "ERR_MISSING_SCHEDULE" }, Io = { message: "Invalid scaleItem", code: "ERR_INVALID_SCALE_ITEM" }, gP = { message: "Modifications failed", code: "ERR_FAILURE_MODIFICATIONS" }, Hs = { message: "No modifications applied", code: "ERR_UNCHANGED_NO_MODIFICATIONS_APPLIED" }, IP = { message: "Unable to assign court", code: "ERR_UNCHANGED_COURT_NOT_ASSIGNED" }, Ld = { message: "No Candidates", code: "ERR_UNCHANGED_NO_CANDIDATES" }, UP = { message: "Invalid configuration", code: "ERR_INVALID_CONFIG" }, SP = { message: "Invalid collectionDefinition", code: "ERR_INVALID_COLLECTION_DEFINITION" }, $n = { message: "Invalid object", code: "ERR_INVALID_OBJECT" }, wc = { message: "Invalid gender", code: "ERR_INVALID_GENDER" }, xc = { message: "Invalid category", code: "ERR_INVALID_CATEGORY" }, z = { message: "Invalid values", code: "ERR_INVALID_VALUES" }, yP = { message: "Duplicate value", code: "ERR_DUPLICATE_VALUE" }, Th = { message: "Team not found", code: "ERR_NOT_FOUND_TEAM" }, vP = { message: "No valid actions", code: "ERR_NO_VALID_ACTIONS" }, _d = { message: "No valid attributes", code: "ERR_NO_VALID_ATTRIBUTES" }, bh = { message: "Value unchanged", code: "ABORT_UNCHANGED" }, Kt = { message: "Not found", code: "ERR_NOT_FOUND" }, Bd = { message: "Not implemented", code: "ERR_NOT_IMPLEMENTED" }, PP = { message: "Existing flight", code: "ERR_EXISTING_FLIGHT" }, Mh = { message: "Existing flight profile", code: "ERR_EXISTING_FLIGHT_PROFILE" }, DP = { message: "Existing outcome", code: "ERR_EXISTING_OUTCOME" }, wP = { message: "Existing matchUpId", code: "ERR_EXISTING_MATCHUP_ID" }, pf = { message: "Existing stage", code: "ERR_EXISTING_STAGE" }, Rh = { message: "Existing structure", code: "ERR_EXISTING_STRUCTURE" }, Vd = { message: "Method not found", code: "ERR_NOT_FOUND_METHOD" }, TP = { message: "Scheduled matchUps", code: "ERR_SCHEDULED_MATCHUPS" }, Iu = { message: "Scores present", code: "ERR_SCORES_PRESENT" }, $C = { ANACHRONISM: nf, CANNOT_CHANGE_WINNING_SIDE: kd, CANNOT_MODIFY_TIEFORMAT: gh, CANNOT_MODIFY_PARTICIPANT_TYPE: Kv, CANNOT_REMOVE_MAIN_STRUCTURE: Uv, CANNOT_REMOVE_PARTICIPANTS: Od, CATEGORY_MISMATCH: uf, COURT_EXISTS: uP, COURT_NOT_FOUND: Ws, DRAW_DEFINITION_NOT_FOUND: zr, DRAW_ID_EXISTS: Dv, DRAW_POSITION_ACTIVE: Rd, DRAW_POSITION_ASSIGNED: Us, DRAW_POSITION_NOT_CLEARED: vv, DRAW_POSITION_NOT_FOUND: NC, DRAW_SIZE_MISMATCH: Pv, DUPLICATE_ENTRY: kc, DUPLICATE_VALUE: yP, ENTRY_STATUS_NOT_ALLOWED_FOR_EVENT: oP, ENTRY_STATUS_NOT_ALLOWED_IN_STAGE: aP, EVENT_EXISTS: Ov, EVENT_NOT_FOUND: ni, EXISTING_DRAW_DEFINITIONS: Sv, EXISTING_END_TIME: vh, EXISTING_FLIGHT: PP, EXISTING_MATCHUP_ID: wP, EXISTING_OUTCOME: DP, EXISTING_PARTICIPANT_DRAW_POSITION_ASSIGNMENT: qs, EXISTING_PARTICIPANT: xd, EXISTING_POLICY_TYPE: fh, EXISTING_PROFILE: Mh, EXISTING_ROUND: Av, EXISTING_STAGE: pf, EXISTING_STRUCTURE: Rh, INCOMPATIBLE_MATCHUP_STATUS: Al, INCOMPLETE_SOURCE_STRUCTURE: rh, INSUFFICIENT_DRAW_POSITIONS: Sh, INVALID_ACTION: Mv, INVALID_ASSIGNMENT: of, INVALID_BOOKINGS: zl, INVALID_CATEGORY: xc, INVALID_COLLECTION_DEFINITION: SP, INVALID_CONFIGURATION: UP, INVALID_DATE_AVAILABILITY: Cl, INVALID_DATE: Ht, INVALID_DRAW_DEFINITION: co, INVALID_DRAW_POSITION_FOR_SEEDING: ih, INVALID_DRAW_POSITION: Vs, INVALID_DRAW_SIZE: Nd, INVALID_END_TIME: dP, INVALID_ENTRIES: xv, INVALID_EVENT_TYPE: fn, INVALID_GAME_SCORES: cf, INVALID_GENDER: wc, INVALID_MATCHUP_FORMAT: lh, INVALID_MATCHUP_STATUS: Gs, INVALID_MATCHUP_STATUS_BYE: Bv, INVALID_MATCHUP: Cr, INVALID_OBJECT: $n, INVALID_PARTICIPANT_ID: Li, INVALID_PARTICIPANT_IDS: _r, INVALID_PARTICIPANT_ROLE: Qv, INVALID_PARTICIPANT_SEEDING: wv, INVALID_PARTICIPANT_TYPE: _i, INVALID_PARTICIPANT: Eo, INVALID_POLICY_DEFINITION: Gv, INVALID_RECORDS: af, INVALID_SCALE_ITEM: Io, INVALID_SEED_NUMBER: Nv, INVALID_SEED_POSITION: Ev, INVALID_SET_NUMBER: xC, INVALID_SIDE_NUMBER: hh, INVALID_SCORE: Yv, INVALID_STAGE: Wa, INVALID_START_TIME: mP, INVALID_STRUCTURE: $a, INVALID_STOP_TIME: pP, INVALID_TIE_FORMAT: cn, INVALID_TIME: fi, INVALID_TIME_ITEM: Ph, INVALID_TOURNAMENT_DATES: zv, INVALID_TOURNAMENT_RECORD: du, INVALID_VALUES: z, INVALID_WINNING_SIDE: Cd, MATCHUP_NOT_FOUND: cr, METHOD_NOT_FOUND: Vd, MISSING_ASSIGNMENTS: uh, MISSING_ASYNC_STATE_PROVIDER: fP, MISSING_AVOIDANCE_POLICY: jv, MISSING_BIRTH_DATE: $v, MISSING_COLLECTION_DEFINITION: Vv, MISSING_COURT_ID: No, MISSING_COURTS_INFO: cP, MISSING_DATE_AVAILABILITY: Hv, MISSING_DATE: qv, MISSING_DRAW_DEFINITION: ne, MISSING_DRAW_ID: Vi, MISSING_DRAW_POSITION: js, MISSING_DRAW_POSITIONS: pu, MISSING_DRAW_SIZE: mu, MISSING_ENTRIES: kv, MISSING_EVENT: st, MISSING_QUALIFIED_PARTICIPANTS: Jv, MISSING_MATCHUP_FORMAT: dh, MISSING_MATCHUP_ID: pr, MISSING_MATCHUP_IDS: Ro, MISSING_MATCHUP: Dr, MISSING_MATCHUPS: Gn, MISSING_PARTICIPANT_COUNT: tP, MISSING_PARTICIPANT_ID: Ft, MISSING_PARTICIPANT_IDS: la, MISSING_PARTICIPANT_ROLE: Xv, MISSING_PARTICIPANT: Ao, MISSING_PARTICIPANTS: gu, MISSING_PENALTY_ID: yh, MISSING_PENALTY_TYPE: sP, MISSING_PERSON_DETAILS: iP, MISSING_POLICY_ATTRIBUTES: mh, MISSING_POLICY_DEFINITION: Ed, MISSING_POLICY_TYPE: ph, MISSING_POSITION_ASSIGNMENTS: _v, MISSING_ROUND_NUMBER: AC, MISSING_SCHEDULE: hP, MISSING_SCORING_POLICY: kC, MISSING_SEED_ASSIGNMENTS: Rv, MISSING_SEEDCOUNT_THRESHOLDS: bv, MISSING_SEEDING_POLICY: CC, MISSING_SET_NUMBER: FC, MISSING_SET_OBJECT: Ad, MISSING_SIDE_NUMBER: LC, MISSING_STAGE: Fv, MISSING_STRUCTURE_ID: Qr, MISSING_STRUCTURE: qa, MISSING_MAIN_STRUCTURE: ch, MISSING_STRUCTURES: sh, MISSING_TARGET_LINK: oh, MISSING_TIE_FORMAT: $s, MISSING_TIME_ITEM: Dh, MISSING_TIME_ITEMS: wh, MISSING_TOURNAMENT_ID: Is, MISSING_TOURNAMENT_RECORD: J, MISSING_TOURNAMENT_RECORDS: ht, MISSING_VALUE: ue, MISSING_VENUE_ID: da, MODIFICATIONS_FAILED: gP, NO_CANDIDATES: Ld, NO_DRAW_POSITIONS_AVAILABLE_FOR_QUALIFIERS: Uh, NO_MODIFICATIONS_APPLIED: Hs, NO_STAGE_SPACE_AVAILABLE_FOR_ENTRY_STATUS: df, NO_PARTICIPANT_REMOVED: eP, NO_VALID_ACTIONS: vP, NO_VALID_ATTRIBUTES: _d, NO_VALID_DATES: Wv, NOT_FOUND: Kt, NOT_IMPLEMENTED: Bd, PARTICIPANT_COUNT_EXCEEDS_DRAW_SIZE: Ih, PARTICIPANT_ID_EXISTS: Zv, PARTICIPANT_NOT_CHECKED_IN: rP, PARTICIPANT_NOT_FOUND: Tt, PARTICIPANT_PAIR_EXISTS: BC, PENALTY_NOT_FOUND: Ss, POLICY_NOT_ATTACHED: OC, POLICY_NOT_FOUND: hu, SCHEDULE_NOT_CLEARED: yv, SCHEDULED_MATCHUPS: TP, SCORES_PRESENT: Iu, SEEDSCOUNT_GREATER_THAN_DRAW_SIZE: Tv, STAGE_SEQUENCE_LIMIT: Lv, STRUCTURE_NOT_FOUND: mt, TEAM_NOT_FOUND: Th, UNABLE_TO_ASSIGN_COURT: IP, UNLINKED_STRUCTURES: Cv, UNRECOGNIZED_DRAW_TYPE: nh, UNRECOGNIZED_MATCHUP_FORMAT: fu, UNRECOGNIZED_MATCHUP_STATUS: sf, VALUE_UNCHANGED: bh, VENUE_EXISTS: lP }, pt = { disableNotifications: !1, tournamentId: void 0, tournamentRecords: {}, subscriptions: {}, modified: !1, methods: {}, notices: [] }, bP = { addNotice: t0, callListener: o0, cycleMutationStatus: e0, deleteNotice: n0, deleteNotices: i0, disableNotifications: qC, enableNotifications: WC, getMethods: Nh, getNotices: r0, getTopics: a0, getTournamentId: MP, getTournamentRecord: HC, getTournamentRecords: zC, removeTournamentRecord: XC, setMethods: ZC, setSubscriptions: JC, setTournamentId: KC, setTournamentRecord: YC, setTournamentRecords: QC, handleCaughtError: s0 };
function qC() {
  pt.disableNotifications = !0;
}
function WC() {
  pt.disableNotifications = !1;
}
function MP() {
  return pt.tournamentId;
}
function HC(e) {
  return pt.tournamentRecords[e];
}
function zC() {
  return pt.tournamentRecords;
}
function YC(e) {
  let t = e?.tournamentId;
  return t ? (pt.tournamentRecords[t] = e, { success: !0 }) : { error: du };
}
function KC(e) {
  return e ? pt.tournamentRecords[e] ? (pt.tournamentId = e, { success: !0 }) : { error: J } : (pt.tournamentId = void 0, { success: !0 });
}
function QC(e) {
  pt.tournamentRecords = e;
  let t = Object.keys(e);
  t.length === 1 ? pt.tournamentId = t[0] : t.length || (pt.tournamentId = void 0);
}
function XC(e) {
  if (typeof e != "string") return { error: z };
  if (!pt.tournamentRecords[e]) return { error: Kt };
  delete pt.tournamentRecords[e];
  let t = Object.keys(pt.tournamentRecords);
  return t.length === 1 ? pt.tournamentId = t[0] : t.length || (pt.tournamentId = void 0), { success: !0 };
}
function JC(e) {
  return typeof e.subscriptions != "object" ? { error: z } : (Object.keys(e.subscriptions).forEach((t) => {
    typeof e.subscriptions[t] == "function" ? pt.subscriptions[t] = e.subscriptions[t] : delete pt.subscriptions[t];
  }), { ...x });
}
function ZC(e) {
  return typeof e != "object" ? { error: z } : (Object.keys(e).forEach((t) => {
    typeof e[t] == "function" && (pt.methods[t] = e[t]);
  }), { ...x });
}
function e0() {
  let e = pt.modified;
  return pt.modified = !1, e;
}
function t0({ topic: e, payload: t, key: r }, i) {
  if (!(typeof e != "string" || typeof t != "object") && (pt.disableNotifications || (pt.modified = !0), !(pt.disableNotifications || !pt.subscriptions[e] && !i))) return r && (pt.notices = pt.notices.filter((n) => !(n.topic === e && n.key === r))), pt.notices.push({ topic: e, payload: t, key: r }), { ...x };
}
function Nh() {
  return pt.methods ?? {};
}
function r0({ topic: e }) {
  return pt.notices.filter((t) => t.topic === e).map((t) => t.payload);
}
function i0() {
  pt.notices = [];
}
function n0({ topic: e, key: t }) {
  pt.notices = pt.notices.filter((r) => (!e || r.topic === e) && r.key !== t);
}
function a0() {
  return { topics: Object.keys(pt.subscriptions) };
}
function o0({ topic: e, notices: t }, r) {
  let i = pt.subscriptions[e];
  i && typeof i == "function" && i(t);
  let n = r?.[e];
  n && typeof n == "function" && n(t);
}
function s0({ engineName: e, methodName: t, params: r, err: i }) {
  let n;
  return typeof i == "string" ? n = i.toUpperCase() : i instanceof Error && (n = i.message), console.log("ERROR", { tournamentId: MP(), params: JSON.stringify(r), engine: e, methodName: t, error: n }), { error: n };
}
var et = { timers: { default: { elapsedTime: 0 } }, globalSubscriptions: {}, deepCopyAttributes: { stringify: [], ignore: [], toJSON: [] }, globalMethods: [], deepCopy: !0 }, Qt = bP, LS = ["addNotice", "callListener", "cycleMutationStatus", "deleteNotice", "deleteNotices", "disableNotifications", "enableNotifications", "getMethods", "getNotices", "getTopics", "getTournamentId", "getTournamentRecord", "getTournamentRecords", "removeTournamentRecord", "setSubscriptions", "setTournamentId", "setTournamentRecord", "setTournamentRecords"];
function c0(e) {
  if (typeof e != "object") throw new Error("Global state provider can not be undefined or null");
  if (Pt(Object.keys(e), LS).length !== LS.length) throw new Error("Global state provider is missing required methods");
  return Qt = e, { success: !0 };
}
function u0() {
  if (Qt.createInstanceState) {
    try {
      Qt.createInstanceState();
    } catch (e) {
      return { error: e };
    }
    return { success: !0 };
  } else return { error: fP };
}
function Yr(e) {
  return !e || typeof e != "object" ? et.devContext ?? !1 : typeof et.devContext != "object" ? !1 : Object.keys(e).every((t) => et.devContext?.[t] === e[t]) && et.devContext;
}
function l0(e = "reset", t = "default") {
  let r = Date.now();
  if (e === "report") {
    if (t === "allTimers") return Object.keys(et.timers).filter((i) => i !== "default" || et.timers[i].startTime).map((i) => {
      let n = et.timers[i], a = n.state === "stopped" ? 0 : (r - (n?.startTime ?? 0)) / 1e3, o = n.elapsedTime + a;
      return { state: et.timers[i].state, elapsedTime: o.toFixed(2), timer: i };
    });
    {
      let i = et.timers[t].state === "stopped" ? 0 : (r - (et.timers[t]?.startTime ?? 0)) / 1e3, n = et.timers[t].elapsedTime + i;
      return { state: et.timers[t].state, elapsedTime: n.toFixed(2), timer: t };
    }
  }
  if (!et.timers[t] || e === "reset") {
    if (t === "allTimers") return et.timers = { default: { elapsedTime: 0 } }, !0;
    et.timers[t] = { startTime: r, state: "active", elapsedTime: 0 };
  }
  return et.timers[t].elapsedTime || (et.timers[t].elapsedTime = 0), e === "stop" && et.timers[t].state !== "stopped" && (et.timers[t].state = "stopped") && (et.timers[t].elapsedTime += (r - (et.timers[t]?.startTime ?? 0)) / 1e3), e === "start" && (et.timers[t].startTime = r) && (et.timers[t].state = "active"), et.timers[t];
}
function RP(e) {
  Fr(e) ? et.globalLog = e : delete et.globalLog;
}
function Fc(e) {
  et.devContext = e;
}
function NP() {
  Qt.disableNotifications();
}
function Ol() {
  Qt.enableNotifications();
}
function Lc(e, t) {
  typeof e == "boolean" && (et.deepCopy = e), typeof t == "object" && (Array.isArray(t.ignore) && (et.deepCopyAttributes.ignore = t.ignore), Array.isArray(t.toJSON) && (et.deepCopyAttributes.toJSON = t.toJSON), Array.isArray(t.stringify) && (et.deepCopyAttributes.stringify = t.stringify), t.threshold && (et.deepCopyAttributes.threshold = t.threshold));
}
function Eh() {
  return { enabled: et.deepCopy, ...et.deepCopyAttributes };
}
function d0(e) {
  return e?.subscriptions ? (Object.keys(e.subscriptions).forEach((t) => {
    et.globalSubscriptions[t] = e.subscriptions[t];
  }), { ...x }) : { error: ue, info: "missing subscriptions" };
}
function p0(e) {
  return e?.subscriptions ? Qt.setSubscriptions({ subscriptions: e.subscriptions }) : { error: ue, info: "missing subscriptions" };
}
function EP(e) {
  return e ? typeof e != "object" ? { error: z } : (Object.keys(e).forEach((t) => {
    Fr(e[t]) && (et.globalMethods[t] = e[t]);
  }), { ...x }) : { error: ue, info: "missing method declarations" };
}
function AP(e) {
  return e ? typeof e != "object" ? { error: z } : Qt.setMethods(e) : { error: ue, info: "missing method declarations" };
}
function Ah() {
  return Qt.cycleMutationStatus();
}
function Se(e) {
  if (typeof e?.topic != "string") return;
  let t = et.globalSubscriptions[e.topic];
  return Qt.addNotice(e, t);
}
function CP() {
  return { ...et.globalMethods, ...Qt.getMethods() };
}
function OP(e) {
  return Qt.getNotices(e);
}
function Ch({ key: e, topic: t }) {
  return Qt.deleteNotice({ key: e, topic: t });
}
function Uu() {
  return Qt.deleteNotices();
}
function ci() {
  return Qt.getTopics();
}
function jd(e) {
  return ci()?.topics?.includes(e);
}
async function mf(e) {
  return Qt.callListener(e, et.globalSubscriptions);
}
function Oo() {
  return Qt.getTournamentId();
}
function Oh(e) {
  return Qt.getTournamentRecord(e);
}
function ko() {
  return Qt.getTournamentRecords();
}
function kP(e) {
  return Qt.setTournamentRecord(e);
}
function Gd(e) {
  return Qt.setTournamentRecords(e);
}
function _c(e) {
  return Qt.setTournamentId(e);
}
function xP(e) {
  return Qt.removeTournamentRecord(e);
}
function ff() {
  return Qt;
}
function $d({ engineName: e, methodName: t, params: r, err: i }) {
  let n = Fr(Qt.handleCaughtError) && Qt.handleCaughtError || bP.handleCaughtError, { tournamentRecord: a, ...o } = r;
  return n({ params: o, engineName: e, methodName: t, err: i });
}
function FP(e, t) {
  if (et.globalLog) try {
    et.globalLog({ log: e, engine: t });
  } catch (r) {
    console.log("globalLog error", r), console.log(t, e), RP();
  }
  else console.log(t, e);
}
function LP(e, t, r, i) {
  if (!xe(e)) return { error: z };
  gt || (r = 1);
  let n = Array.isArray(t) ? t : [], a = {}, o = (s, c = 0) => {
    Object.keys(s).forEach((u) => {
      Fr(s[u]) ? a[u] = s[u] : xe(s[u]) && (t === !0 || n?.includes(u)) && (r === void 0 || c < r) && o(s[u], c + 1);
    });
  };
  return o(e), i ? EP(a) : AP(a), { methods: a };
}
function m0(e, t, r) {
  return Object.keys(e).filter((i) => !t.includes(e[i]) && (!r || (Array.isArray(e[i]) ? e[i].length : !0)));
}
function ae(e, t, r, i) {
  if (typeof e != "object" || e === null) return e;
  Eh()?.enabled || (i = !0);
  let n = ["", void 0, null];
  t && n.push(!1);
  let a = m0(e, n, r);
  return Object.assign({}, ...a.map((o) => Array.isArray(e[o]) ? { [o]: i ? e[o] : e[o].map((s) => ae(s)) } : { [o]: i ? e[o] : ae(e[o]) }));
}
function F({ context: e, result: t, stack: r, info: i }) {
  return t && !Array.isArray(t?.stack) && (t.stack = []), t && Array.isArray(t?.stack) && typeof r == "string" && t.stack.push(r), t && i && (t.info = i), t && typeof e == "object" && Object.keys(e).length && (t.context || (t.context = {}), Object.assign(t.context, ae(e))), t && !t?.error && !t?.success && Object.assign(t, { ...x }), t ?? { success: !0 };
}
var Ye = "MALE", vr = "MIXED", Da = "OTHER", at = "FEMALE", kh = { ANY: "ANY", MALE: Ye, FEMALE: at, MIXED: vr, OTHER: Da }, f0 = "MIXED events can not contain mixed singles or { gender: ANY } collections", h0 = "events with { gender: ANY } can not contain MIXED singles collections";
function qd(e) {
  let t = "tieFormatGenderValidityCheck", { referenceGender: r, matchUpType: i, gender: n } = e;
  return r && n && [Ye, at].includes(r) && r !== n ? F({ result: { valid: !1, error: wc }, context: { gender: n }, stack: t }) : r === vr && (n === "ANY" || n === vr && i !== Ke) ? F({ result: { error: wc, valid: !1 }, info: f0, stack: t }) : r === "ANY" && n === vr && i !== Ke ? F({ result: { error: wc, valid: !1 }, info: h0, stack: t }) : { valid: !0 };
}
var g0 = "normal", _S = "timed", I0 = "final", xh = "NOAD", U0 = { S: g0, F: I0 };
function Wd(e, t) {
  if ((e?.bestOf || e?.exactly) && e?.setFormat) return S0(e, t);
}
function Bc(e) {
  return !isNaN(Number(e)) && Number(e);
}
function _P(e) {
  let t = `T${e.minutes}`;
  return e.based && (t += e.based), e.modifier && (t += `@${e.modifier}`), t;
}
function S0(e, t) {
  let r = Bc(e.bestOf) || void 0, i = Bc(e.exactly) || void 0, n = r || i;
  if (e.setFormat?.timed && e.simplified && n === 1) return _P(e.setFormat);
  let a = n && `SET${n}` || "", o = BS(e.setFormat, t), s = o && `S:${o}` || "", c = BS(e.finalSetFormat, t), u = n && n > 1 && c && o !== c && `F:${c}` || "";
  if (a && o) return [a, s, u].filter((l) => l).join("-");
}
function BS(e, t) {
  if (typeof e == "object" && Object.keys(e).length) {
    if (e.timed) return _P(e);
    if (e.tiebreakSet) return VS(e.tiebreakSet);
    let r = Bc(e.setTo);
    if (r) {
      let i = e.NoAD && xh || "", n = VS(e.tiebreakFormat), a = n && `/${n}` || "", o = Bc(e.tiebreakAt), s = o && (o !== r || t) && `@${o}` || "";
      if (n !== !1) return `${r}${i}${a}${s}`;
    }
  }
}
function VS(e) {
  if (e) {
    if (typeof e == "object" && !e.tiebreakTo) return "";
    if (typeof e == "object" && Bc(e.tiebreakTo)) {
      let t = `TB${e.tiebreakTo}${e.NoAD ? xh : ""}`;
      return e.modifier && (t += `@${e.modifier}`), t;
    } else return !1;
  }
}
function Sr(e) {
  if (dt(e)) {
    let t = e.startsWith("T") && _S || e.startsWith("SET") && "SET" || "";
    if (t === _S) {
      let r = VP(e), i = { simplified: !0, setFormat: r, bestOf: 1 };
      if (r) return i;
    }
    if (t === "SET") return y0(e);
  }
}
function y0(e) {
  let t = e.split("-"), r = Su(t[0].slice(3)), i = r === 1 || r % 2 !== 0 ? r : void 0, n = r !== 1 && r % 2 === 0 ? r : void 0, a = t && jS(t[1]), o = t && jS(t[2]), s = a && a.timed || o && o.timed, c = i && i < 6 || s && n, u = !t[2] || o, l = a, d = ae({ setFormat: a, exactly: n, bestOf: i });
  if (o && (d.finalSetFormat = o), c && l && u) return d;
}
function jS(e) {
  if (e?.[1] === ":") {
    let t = e.split(":"), r = U0[t[0]], i = t[1];
    if (r && i) {
      if (i.startsWith("TB")) {
        let f = GS(i);
        return f === !1 ? !1 : typeof f == "object" ? { tiebreakSet: f } : void 0;
      }
      if (i.startsWith("T")) return VP(i);
      let n = e.match(/^[FS]:(\d+)([A-Za-z]*)/), a = n && jP(n[2]) || !1, o = !n?.[2] || a, s = n ? Su(n[1]) : void 0, c = BP(i), u = c !== !1, l = u && c || s, d = GS(i.split("/")[1]), p = d !== !1, m = { setTo: s };
      return a && (m.NoAD = !0), d ? (m.tiebreakFormat = d, m.tiebreakAt = l) : m.noTiebreak = !0, s && o && p && u && m || !1;
    }
  }
}
function BP(e, t = !0) {
  let r = e?.indexOf("@") > 0 && e.split("@");
  if (r) return (t ? Su(r[1]) : r[1]) || !1;
}
function GS(e) {
  if (e) if (e.startsWith("TB")) {
    let t = BP(e, !1), r = e.match(/^TB(\d+)([A-Za-z]*)/), i = r?.[1], n = r && jP(r[2]), a = !r?.[2] || n, o = Su(i);
    if (o && a) {
      let s = { tiebreakTo: o };
      return t && typeof t == "string" && !Ie(t) && (s.modifier = t), n && (s.NoAD = !0), s;
    } else return !1;
  } else return !1;
}
function VP(e) {
  let t = e.slice(1), r = t.match(/^(\d+)(@?[A-Za-z]*)/), i = Su(r?.[1]);
  if (!i) return;
  let n = { timed: !0, minutes: i }, a = r?.[2], o = [void 0, "P", "G"].includes(a);
  if (a && !o) {
    let s = t.match(/^(\d+)(@)([A-Za-z]+)$/)?.[3];
    return s ? (n.modifier = s, n) : void 0;
  }
  return a && (n.based = r[2]), n;
}
function jP(e) {
  return e && e.indexOf(xh) >= 0;
}
function Su(e) {
  return isNaN(Number(e)) ? 0 : Number(e);
}
function Vr({ matchUpFormat: e }) {
  if (!dt(e) || e === "") return !1;
  let t = Sr(e), r = e.match(/-S:([1-9])+\/TB(\d{1,2})@?([1-9]?)*/), i = r?.[1], n = r?.[2], a = r?.[3], o = e.match(/-F:([1-9])+\/TB(\d{1,2})@?([1-9]?)*/), s = o?.[1], c = o?.[2], u = o?.[3];
  return Wd(t, !!(r && n && i === a || o && c && s === u)) === e;
}
var Yl = /^[\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1])$/, GP = /^((0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)([.,][0-9]{3})?$/, Yi = /^([\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1]))([ T](0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)?([.,][\d]{3})?Z?$/, wa = /^([\d]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][\d]|3[0-1]))?([ T]?(0[\d]|1[\d]|2[0-3]):[0-5][\d](:[0-5][\d])?)?([.,][\d]{3})?Z?$/;
function Kl(e) {
  let { scheduledDate: t } = e;
  if (!t && e.scheduledTime && (t = ve(e.scheduledTime)), !t) return;
  let r = ct(e.scheduledTime), i = ve(t);
  return i && r && (i += `T${r}`), i;
}
function v0(e) {
  return typeof e != "object" || Array.isArray(e) ? !1 : Object.prototype.toString.call(e) === "[object Date]";
}
function zs(e) {
  let t = typeof e == "string" ? e?.split(" ") : [];
  return e && t?.length > 1 && !["AM", "PM"].includes(t[1].toUpperCase()) ? !1 : !!(!e || wa.test(xo(e, !0, !0)));
}
function Ar(e) {
  return Ra(e) || Yl.test(e);
}
function P0(e) {
  let t = new Date(e), r = t.getSeconds() + 60 * t.getMinutes() + 3600 * t.getHours();
  return D0(r, { displaySeconds: !1 });
}
function D0(e, t) {
  let r = parseInt(e, 10), i = Math.floor(r / 3600), n = Math.floor((r - i * 3600) / 60), a = r - i * 3600 - n * 60;
  return (!t || t?.displaySeconds ? i + ":" + n + ":" + a : i + ":" + n).split(":").map(ri).join(":");
}
var Fh = (e) => {
  let t = Vc(e) || Ra(e) ? new Date(e) : /* @__PURE__ */ new Date(), r = t.getUTCMonth() + 1, i = r < 10 ? `0${r}` : `${r}`;
  return `${t.getUTCFullYear()}-${ri(i)}-${ri(t.getUTCDate())}`;
};
function w0(e) {
  let t = Vc(e) || Ra(e) ? new Date(e) : /* @__PURE__ */ new Date();
  return Date.UTC(t.getFullYear(), t.getMonth(), t.getDate());
}
function Ui(e, t = "-", r = "YMD") {
  if (!e) return "";
  typeof e == "string" && e.indexOf("T") < 0 && (e = e + "T00:00");
  let i = new Date(e), n = "" + (i.getMonth() + 1), a = "" + i.getDate(), o = i.getFullYear();
  return n.length < 2 && (n = "0" + n), a.length < 2 && (a = "0" + a), r === "DMY" ? [a, n, o].join(t) : r === "MDY" ? [n, a, o].join(t) : r === "YDM" ? [o, a, n].join(t) : r === "DYM" ? [a, o, n].join(t) : r === "MYD" ? [n, o, a].join(t) : [o, n, a].join(t);
}
function Ql(e) {
  let t = e ? new Date(e) : /* @__PURE__ */ new Date(), r = t.getTimezoneOffset();
  return new Date(t.getTime() - r * 60 * 1e3);
}
function T0(e) {
  return Ql(e).getTime();
}
function Vc(e) {
  if (typeof e == "boolean") return !1;
  let t = e instanceof Date && e || !isNaN(e) && new Date(e) || !1;
  return t && !isNaN(t.valueOf());
}
function ys(e, t) {
  if (!Ar(e) || !Ar(t)) return [];
  let r = ve(e) + "T00:00", i = ve(t) + "T00:00", n = new Date(r), a = new Date(i), o = Vc(a) && Vc(n) && u(n, a), s = [], c = 0;
  if (o) {
    let l = n, d = l.getTime();
    for (; d <= a.getTime() && c < 300; ) c += 1, s.push(new Date(l)), d = l.setDate(l.getDate() + 1);
  }
  return s.map((l) => Ui(l));
  function u(l, d) {
    return l <= d;
  }
}
var b0 = /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
function Ra(e) {
  return typeof e != "string" ? !1 : b0.test(e);
}
function Lh(e) {
  if (typeof e != "string") return !1;
  let t = e.split("Z")[0].split(":"), r = t.every((i) => !isNaN(parseInt(i)));
  return !(t.length < 2 || !r || parseInt(t[0]) > 23 || parseInt(t[1]) > 60);
}
function Le(e) {
  let t = ct(e);
  if (!t) return 0;
  let [r, i] = t.split(":").map((n) => parseInt(n));
  return r * 60 + i;
}
function M0(e) {
  let t = Math.floor(e / 60), r = e - t * 60;
  return t > 23 && (t = t % 24), [ri(t), ri(r)].join(":");
}
function Xl(e) {
  return Lh(e) ? e.split(":").slice(0, 2).map(ri).join(":") : void 0;
}
function ct(e) {
  return Ra(e) && e.indexOf("T") > 0 ? Xl(e.split("T").reverse()[0]) : Xl(e);
}
function ve(e) {
  return Ra(e) || Yi.test(e) ? e.split("T")[0] : void 0;
}
function Pc(e, t) {
  let r = new Date(e);
  return r.setDate(r.getDate() + t), ve(r.toISOString());
}
function Jl(e) {
  e = typeof e != "string" ? "00:00" : e;
  let t = {}, r = {};
  return { 0: t.time, 1: t.ampm } = e.split(" ") || [], { 0: r.hours, 1: r.minutes } = t.time.split(":") || [], r.ampm = t.ampm, isNaN(r.hours) || isNaN(r.minutes) || r.ampm && !["AM", "PM"].includes(r.ampm.toUpperCase()) ? {} : r;
}
function R0(e) {
  let t = Jl(e);
  return t.ampm && t.hours && (t.ampm.toLowerCase() === "pm" && parseInt(t.hours) < 12 && (t.hours = (t.hours && parseInt(t.hours) || 0) + 12), t.ampm.toLowerCase() === "am" && t.hours === "12" && (t.hours = "00")), `${t.hours || "12"}:${t.minutes || "00"}`.split(":").map(ri).join(":");
}
function N0(e) {
  let t = Jl(e);
  if (!(typeof t == "object" && !Object.keys(t).length)) return t.ampm ? e : (t.hours > 12 ? (t.hours -= 12, t.ampm = "PM") : t.hours === "12" ? t.ampm = "PM" : (t.hours === "00" && (t.hours = "12"), t.ampm = "AM"), t.hours?.[0] === "0" && (t.hours = t.hours.slice(1)), `${t.hours || "12"}:${t.minutes || "00"} ${t.ampm}`);
}
function xo(e, t, r) {
  let i = ve(e), n = ct(e), a = i ? n : e;
  return e ? t && (i && r && e || R0(a)) || N0(a) : void 0;
}
function $P(e, t) {
  let r = Jl(e), i = Jl(t);
  if (parseInt(r.hours) < parseInt(i.hours)) return -1;
  if (parseInt(r.hours) > parseInt(i.hours)) return 1;
  if (r.hours === i.hours) {
    if (parseInt(r.minutes) < parseInt(i.minutes)) return -1;
    if (parseInt(r.minutes) > parseInt(i.minutes)) return 1;
  }
  return 0;
}
function _h(e, t = 7) {
  let r = ve(e) + "T00:00", i = new Date(r), n = new Date(i.setDate(i.getDate() + t));
  return Ui(n);
}
function E0(e) {
  return _h(e);
}
function A0(e, t, r, i = !1) {
  let n = new Date(t, 0, 1 + (e - 1) * 7), a = i ? 0 : 1;
  return n.setDate(n.getDate() + (a - n.getDay())), Ui(n, r);
}
function C0(e, t, r) {
  let i = new Date(e, 0);
  return Ui(new Date(i.setDate(t)), r);
}
function Nt(e, t = void 0) {
  let [r, i] = (e || "00:00").split(":").map(ri), n = Ql(t).setHours(r, i, 0, 0);
  return Ql(n);
}
function yu(e, t, r = !0) {
  let i = new Date(e), n = (new Date(t).getTime() - i.getTime()) / 1e3 / 60;
  return r ? Math.abs(Math.round(n)) : Math.round(n);
}
function Er(e, t) {
  let r = ct(e);
  if (!r) return "00:00";
  let i = isNaN(t) ? 0 : t;
  return ct(Bh(Nt(r), i).toISOString());
}
function Bh(e, t) {
  let r = new Date(e);
  return new Date(r.getTime() + t * 6e4);
}
function ri(e) {
  return e.toString()[1] ? e : "0" + e;
}
function hn(e, t) {
  let r = new Date(e), i = new Date(t);
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth() && r.getDate() === i.getDate();
}
var qP = { addDays: _h, addWeek: E0, addMinutesToTimeString: Er, convertTime: xo, getIsoDateString: Kl, getUTCdateString: Fh, DateHHMM: P0, extractDate: ve, extractTime: ct, formatDate: Ui, getDateByWeek: A0, isISODateString: Ra, isDate: Vc, isTimeString: Lh, offsetDate: Ql, offsetTime: T0, sameDay: hn, timeStringMinutes: Le, timeToDate: Nt, timeUTC: w0, validTimeValue: zs, validDateString: Yl, timeValidation: wa, dateValidation: Yi }, O0 = (e, t) => e.filter(Boolean).every((r) => typeof r === t), k0 = (e) => e.filter(Boolean).every(gt);
function Uo(e) {
  let t = e.category;
  if (typeof t != "object") return { error: xc };
  let { ageCategoryCode: r, ageMaxDate: i, ageMinDate: n, ageMax: a, ageMin: o } = t, s = t.categoryName, c;
  if (!(O0([r, i, n, s], "string") && k0([a, o]) && [i, n].filter(Boolean).every(Ar))) return { error: xc };
  let u = e.consideredDate ?? ve((/* @__PURE__ */ new Date()).toLocaleDateString("sv"));
  if (!Ar(u)) return { error: Ht };
  let [l] = u.split("-").slice(0, 3).map((_) => parseInt(_)), d = Pc(u, -1), [p, m] = d.split("-").slice(1, 3).map((_) => parseInt(_)), f = `${ri(p)}-${ri(m)}`, h = Pc(u, 1), [g, I] = h.split("-").slice(1, 3).map((_) => parseInt(_)), U = `${ri(g)}-${ri(I)}`, S = o && Pc(u, -1 * 365 * o), P = a && Pc(u, -1 * 365 * a), v = [], D = (_) => !v.includes(_) && v.push(_);
  r = r ?? s;
  let y = /^([UO]?)(\d{1,2})([UO]?)$/, w = /^C(\d{1,2})-(\d{1,2})$/, b = r?.includes("-"), T = b && r?.match(w), R = r?.match(y), M = (_, B) => `${_}-${B}`, E = (_) => {
    let B = l - _, L = M(B, U);
    t.ageMinDate && t.ageMinDate !== L && D(`Invalid submitted ageMinDate: ${n}`), n = L, r && (t.ageMax && t.ageMax !== _ - 1 && (D(`Invalid submitted ageMax: ${a}`), P = void 0), a = _ - 1);
  }, A = (_) => {
    let B = l - _ - 1, L = M(B, U);
    t.ageMin && t.ageMin > _ && D(`Invalid submitted ageMin: ${o}`), t.ageMax && t.ageMax > _ && D(`Invalid submitted ageMax: ${a}`), t.ageMinDate && t.ageMinDate !== L && D(`Invalid submitted ageMinDate: ${n}`), n = L, r && (t.ageMax && t.ageMax !== _ && (D(`Invalid submitted ageMax: ${a}`), S = void 0), a = _);
  }, N = (_) => {
    let B = l - _, L = M(B, f);
    t.ageMaxDate && t.ageMaxDate !== L && D(`Invalid submitted ageMaxDate: ${i}`), i = L, r && (t.ageMin && t.ageMin !== _ + 1 && (D(`Invalid submitted ageMin: ${o}`), S = void 0), o = _ + 1);
  }, C = (_) => {
    let B = l - _ - 1, L = M(B, f);
    t.ageMaxDate && t.ageMaxDate !== L && D(`Invalid submitted ageMaxDate: ${i}`), i = L, r && (t.ageMin && t.ageMin !== _ && (D(`Invalid submitted ageMin: ${o}`), S = void 0), o = _);
  }, k = (_) => {
    let [B, L, j] = (_.match(y) || []).slice(1), H = parseInt(L);
    B === "U" ? (t.ageMaxDate && t.ageMaxDate !== i && D(`Invalid submitted ageMaxDate: ${t.ageMaxDate}`), E(H)) : B === "O" && N(H), j === "U" ? (t.ageMaxDate && t.ageMaxDate !== i && D(`Invalid submitted ageMaxDate: ${t.ageMaxDate}`), A(H)) : j === "O" && C(H), i = i ?? S, n = n ?? P;
  };
  if (T) {
    if (i = void 0, n = void 0, a = void 0, o = void 0, t.ageMin) {
      let L = l - t.ageMin;
      i = M(L, f);
    }
    if (t.ageMax) {
      let L = l - t.ageMax - 1;
      n = M(L, U);
    }
    let [_, B] = (r?.match(w) ?? []).slice(1).map((L) => parseInt(L));
    _ <= B ? (o = _, a = B, c = !0) : D(`Invalid combined age range ${r}`);
  } else b ? r?.split("-").forEach(k) : R ? k(r) : (o && N(o), a && A(a));
  a && t.ageMin && t.ageMin > a && (D(`Invalid submitted ageMin: ${t.ageMin}`), o = void 0);
  let O = ae({ consideredDate: u, combinedAge: c, ageMaxDate: i, ageMinDate: n, ageMax: a, ageMin: o });
  return v.length && (O.errors = v), O;
}
function jc({ category: e }) {
  if (!xe(e)) return { error: z };
  let t = Uo({ category: e });
  if (t.error) return { error: t };
  let { ratingMax: r, ratingMin: i } = e;
  return r && !gt(r) ? F({ result: { error: z }, context: { ratingMax: r } }) : i && !gt(i) ? F({ result: { error: z }, context: { ratingMin: i } }) : { ...t };
}
function vu({ childCategory: e, withDetails: t, category: r }) {
  let i = jc({ category: r }), n = jc({ category: e }), a = n.ageMin && (i.ageMin && n.ageMin < i.ageMin || i.ageMax && n.ageMin > i.ageMax), o = n.ageMax && (i.ageMax && n.ageMax > i.ageMax || i.ageMin && n.ageMax < i.ageMin), s = n.ageMinDate && i.ageMaxDate && new Date(n.ageMinDate) > new Date(i.ageMaxDate), c = n.ageMaxDate && i.ageMinDate && new Date(n.ageMaxDate) < new Date(i.ageMinDate), u = r?.ratingType && e?.ratingType && r.ratingType === e.ratingType && (r.ratingMin && e.ratingMin && e.ratingMin < r.ratingMin || r.ratingMax && e.ratingMax && e.ratingMax > r.ratingMax || r.ratingMin && e.ratingMax && e.ratingMax < r.ratingMin || r.ratingMax && e.ratingMin && e.ratingMin > r.ratingMax), l = r?.ballType && e?.ballType && r.ballType !== e.ballType, d = ae({ invalidRatingRange: u, invalidAgeMinDate: s, invalidAgeMaxDate: c, invalidBallType: l, invalidAgeMax: o, invalidAgeMin: a, valid: !u && !s && !c && !l && !o && !a }, !0);
  return t && Object.assign(d, { categoryDetails: i, childCategoryDetails: n }), d;
}
function Pu({ checkCategory: e = !0, collectionDefinition: t, checkCollectionIds: r, checkGender: i = !0, referenceCategory: n, referenceGender: a, event: o }) {
  a = a ?? o?.gender;
  let s = "validateCollectionDefinition", c = [];
  if (typeof t != "object") return c.push(`collectionDefinition must be an object: ${t}`), F({ result: { errors: c, error: $n }, stack: s });
  let { collectionValueProfiles: u, collectionGroupNumber: l, collectionValue: d, collectionId: p, matchUpCount: m, matchUpFormat: f, matchUpValue: h, matchUpType: g, scoreValue: I, setValue: U, category: S, gender: P } = t;
  if (r && typeof p != "string" && c.push(`collectionId is not type string: ${p}`), typeof m != "number" && c.push(`matchUpCount is not type number: ${m}`), g && !Md([Xe, Ke], g) && c.push(`matchUpType must be SINGLES or DOUBLES: ${g}`), [!!u?.length].concat([h, d, I, U].map(Ie)).filter(Boolean).length !== 1 && c.push("Missing value definition for matchUps: matchUpValue, collectionValue, or collectionValueProfiles"), h && typeof h != "number" && c.push(`matchUpValue is not type number: ${h}`), d && typeof d != "number" && c.push(`collectionValue is not type number: ${d}`), u && m) {
    let v = Iv({ collectionValueProfiles: u, matchUpCount: m });
    v.errors && c.push(...v.errors);
  }
  if (l && typeof l != "number" && c.push(`collectionGroupNumber is not type number: ${d}`), f && !Vr({ matchUpFormat: f }) && c.push(`Invalid matchUpFormat: ${f}`), i) {
    let v = qd({ referenceGender: a, matchUpType: g, gender: P });
    if (v.error) return F({ context: { referenceGender: a, gender: P }, result: v, stack: s });
  }
  if (e && n && S) {
    let v = vu({ category: n, childCategory: S });
    if (!v.valid) return F({ result: { error: xc }, context: v, stack: s });
  }
  return c.length ? F({ result: { errors: c, error: SP }, stack: s }) : { valid: !0 };
}
function wr(e) {
  let t = !!(e?.enforceCategory !== !1 && e?.category), r = !!(e?.enforceGender !== !1 && e?.gender), i = e?.checkCollectionIds, n = e?.tieFormat, a = e?.event, o = "validateTieFormat", s = [], c = x0({ ...e, stack: o });
  if (c?.error) return c;
  let u, l = n.collectionDefinitions.every((g) => {
    let { setValue: I, scoreValue: U, collectionValue: S } = g;
    (I || U) && !S && (u = !0);
    let { valid: P, errors: v } = Pu({ referenceCategory: e.category, referenceGender: e.gender, collectionDefinition: g, checkCollectionIds: i, checkCategory: t, checkGender: r, event: a });
    return P ? !0 : (Array.isArray(v) && s.push(...v), !1);
  }), d = typeof n.winCriteria?.valueGoal == "number" && n.winCriteria?.valueGoal > 0 && !u || n.winCriteria?.aggregateValue;
  if (!(d || n.winCriteria?.aggregateValue)) return u ? s.push("aggregateValue is required") : s.push("Either non-zero valueGoal, or { aggregateValue: true } must be specified in winCriteria"), F({ context: { tieFormat: n, errors: s, aggregateValueImperative: u }, result: { error: cn }, stack: o });
  let p = n.collectionDefinitions.map(({ collectionId: g }) => g), m = !i || p.length === Ue(p).length, f = l && d && m;
  return f ? { valid: f, errors: s } : F({ result: { error: cn }, context: { tieFormat: n, errors: s }, stack: o });
}
function x0(e) {
  let { tieFormat: t, stack: r } = e;
  return !e || !t || !xe(t) ? F({ result: { error: cn }, context: { tieFormat: t, message: "tieformat must be an object" }, stack: r }) : xe(t.winCriteria) ? Array.isArray(t.collectionDefinitions) ? { ...x } : F({ result: { error: cn }, context: { tieFormat: t, message: "collectionDefinitions must be an array" }, stack: r }) : F({ result: { error: cn }, context: { tieFormat: t, message: "tieformat.winCritiera must be an object" }, stack: r });
}
var vs = "resourceSubType", Ps = "resourceType", Ds = "identifier", F0 = { RESOURCE_SUB_TYPE: vs, RESOURCE_TYPE: Ps, IDENTIFIER: Ds };
function ie(e, t, r, i, n = 0) {
  if (ff().makeDeepCopy) return ff().makeDeepCopy(e, t, r, i);
  let a = Eh(), { stringify: o, toJSON: s, ignore: c, modulate: u } = a || {};
  if (!a?.enabled && !r || typeof e != "object" || Fr(e) || e === null || typeof a?.threshold == "number" && n >= a.threshold) return e;
  let l = Array.isArray(e) ? [] : {}, d = Object.keys(e).filter((m) => !r || !c || Array.isArray(c) && !c.includes(m) || Fr(c) && !c(m)), p = (m, f) => {
    l[m] = Fr(f?.toString) ? f.toString() : JSON.stringify(f);
  };
  for (let m of d) {
    let f = e[m], h = Fr(u) ? u(f) : void 0;
    if (h !== void 0) l[m] = h;
    else if (t && m === "extensions" && Array.isArray(f)) {
      let g = Vh(f);
      Object.assign(l, ...g);
    } else i && m === "extensions" ? l[m] = [] : Array.isArray(o) && o.includes(m) ? p(m, f) : Array.isArray(s) && s.includes(m) && Fr(f?.toJSON) ? l[m] = f.toJSON() : f === null ? l[m] = void 0 : v0(f) ? l[m] = new Date(f).toISOString() : l[m] = ie(f, t, r, i, n + 1);
  }
  return l;
}
function Vh(e) {
  return e?.map((t) => {
    let { name: r, value: i } = t;
    return r && i && { [`_${r}`]: i };
  }).filter(Boolean);
}
function WP(e = 1, t) {
  return te(0, e).map(() => je(t));
}
function je(e) {
  let t = [];
  for (let s = 0; s < 256; s++) t[s] = (s < 16 ? "0" : "") + s.toString(16);
  let r = Math.random() * 4294967295 | 0, i = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0, a = Math.random() * 4294967295 | 0, o = t[r & 255] + t[r >> 8 & 255] + t[r >> 16 & 255] + t[r >> 24 & 255] + "-" + t[i & 255] + t[i >> 8 & 255] + "-" + t[i >> 16 & 15 | 64] + t[i >> 24 & 255] + "-" + t[n & 63 | 128] + t[n >> 8 & 255] + "-" + t[n >> 16 & 255] + t[n >> 24 & 255] + t[a & 255] + t[a >> 8 & 255] + t[a >> 16 & 255] + t[a >> 24 & 255];
  return typeof e == "string" ? `${e}_${o.replace(/-/g, "")}` : o;
}
var HP = { collectionDefinitions: [{ collectionName: "Male Singles", matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpCount: 4, matchUpValue: 1, gender: "MALE" }, { collectionName: "Female Singles", matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 4, matchUpValue: 1 }, { collectionName: "Male Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpCount: 2, matchUpValue: 1, gender: "MALE" }, { collectionName: "Female Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 2, matchUpValue: 1 }, { collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpCount: 4, matchUpValue: 1, gender: "MIXED" }], tieFormatName: "USTA_GOLD_TEAM_CHALLENGE", winCriteria: { valueGoal: 9 } }, zP = { collectionDefinitions: [{ collectionName: "Round 1", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Round 2", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Round 3", matchUpCount: 3, matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "Doubles Shuffle", unrestrictedSelections: !0, winCriteria: { aggregateValue: !0 } }, YP = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_SOUTHERN_LEVEL_5", winCriteria: { valueGoal: 8 } }, KP = { collectionDefinitions: [{ category: { ageCategoryCode: "16U" }, collectionName: "16U Singles", matchUpCount: 4, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Singles", matchUpCount: 4, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Doubles", matchUpCount: 2, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Doubles", matchUpCount: 2, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Tiebreak Doubles", matchUpCount: 1, matchUpFormat: "SET1-S:TB10", matchUpType: "DOUBLES", matchUpValue: 1, processCodes: ["RANKING.IGNORE"] }], tieFormatName: "USTA_SECTION_BATTLE", winCriteria: { valueGoal: 9 } }, QP = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_INTERSECTIONAL", winCriteria: { valueGoal: 8 } }, XP = { collectionDefinitions: [{ scoreValue: 1, matchUpType: "SINGLES", collectionName: "Men's Singles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 1 }, { scoreValue: 1, matchUpType: "SINGLES", collectionName: "Women's Singles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:T60", gender: "MIXED", matchUpCount: 1 }], tieFormatName: "Time Tennis Pro Circuit", winCriteria: { aggregateValue: !0 } }, JP = { collectionDefinitions: [{ collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "DOMINANT_DUO_MIXED", winCriteria: { valueGoal: 2 } }, ZP = { collectionDefinitions: [{ scoreValue: 1, matchUpType: "SINGLES", collectionName: "Men's Singles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 3 }, { scoreValue: 1, matchUpType: "SINGLES", collectionName: "Women's Singles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 3 }, { scoreValue: 1, matchUpType: "DOUBLES", collectionName: "Men's Doubles", matchUpFormat: "SET1-S:T60", gender: "MALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Women's Doubles", matchUpFormat: "SET1-S:T60", gender: "FEMALE", matchUpCount: 1 }, { matchUpValue: 1, matchUpType: "DOUBLES", collectionName: "Mixed Doubles", matchUpFormat: "SET1-S:T60", gender: "MIXED", matchUpCount: 1 }], tieFormatName: "Time Tennis Dual", winCriteria: { aggregateValue: !0 } }, eD = { collectionDefinitions: [{ category: { ageCategoryCode: "14U" }, collectionName: "14U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Doubles", collectionGroupNumber: 1, matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], collectionGroups: [{ groupNumber: 1, groupName: "Doubles", groupValue: 1, winCriteria: { valueGoal: 2 } }], tieFormatName: "USTA_BREWER_CUP", winCriteria: { valueGoal: 4 } }, tD = { winCriteria: { valueGoal: 23 }, tieFormatName: "USTA_OZAKI_CUP", collectionDefinitions: [{ category: { ageCategoryCode: "18U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "18U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "18U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "18U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "18U" }, collectionName: "18U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "16U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "16U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "16U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "16U" }, collectionName: "16U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "14U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "14U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "14U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "14U" }, collectionName: "14U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "12U Boys Singles", matchUpType: "SINGLES", matchUpCount: 3, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "12U" }, matchUpFormat: "SET3-S:6/TB7-F:TB10", collectionName: "12U Girls Singles", matchUpType: "SINGLES", gender: "FEMALE", matchUpCount: 3, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Boys Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", matchUpCount: 1, matchUpValue: 1, gender: "MALE" }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Girls Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "FEMALE", matchUpCount: 1, matchUpValue: 1 }, { category: { ageCategoryCode: "12U" }, collectionName: "12U Mixed Doubles", matchUpFormat: "SET1-S:8/TB8", matchUpType: "DOUBLES", gender: "MIXED", matchUpCount: 1, matchUpValue: 1 }] }, Si = "SET3-S:6/TB7", L0 = "SET3-S:6NOAD", rD = "SET3-S:6/TB7-F:TB10", _0 = "SET3-S:4/TB7", B0 = "SET3-S:4/TB5@3", V0 = "SET1-S:T20", j0 = "SET1-S:8/TB7", G0 = "SET1-S:8/TB7@7", $0 = { FORMAT_STANDARD: Si, FORMAT_STANDARD_NOAD: L0, FORMAT_ATP_DOUBLES: rD, FORMAT_SHORT_SETS: _0, FORMAT_FAST4: B0, FORMAT_PRO_SET: j0, FORMAT_COLLEGE_PRO_SET: G0, TIMED20: V0 }, iD = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 2, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "DOMINANT_DUO", winCriteria: { valueGoal: 2 } }, nD = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", collectionValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "USTA_COLLEGE", winCriteria: { valueGoal: 4 } }, aD = { collectionDefinitions: [{ collectionName: "Male Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_LEVEL_1", winCriteria: { valueGoal: 10 } }, oD = { collectionDefinitions: [{ collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Overtime", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "USTA_WTT_ITT", winCriteria: { aggregateValue: !0 } }, sD = { collectionDefinitions: [{ collectionName: "Male Singles", gender: "MALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpType: "SINGLES", matchUpValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Mixed Doubles", gender: "MIXED", matchUpCount: 1, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }], tieFormatName: "USTA_ZONAL", winCriteria: { valueGoal: 10 } }, cD = { collectionDefinitions: [{ collectionGroupNumber: 1, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 1 }, { collectionGroupNumber: 1, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 1 }, { collectionGroupNumber: 2, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 2 }, { collectionGroupNumber: 2, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 2 }, { collectionGroupNumber: 3, matchUpType: "DOUBLES", matchUpCount: 1, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 3 }, { collectionGroupNumber: 3, matchUpType: "SINGLES", matchUpCount: 3, matchUpFormat: "SET3-S:6/TB7-F:TB10", matchUpValue: 3 }], collectionGroups: [{ groupNumber: 1, groupName: "Day 1" }, { groupNumber: 2, groupName: "Day 2" }, { groupNumber: 3, groupName: "Day 3" }], tieFormatName: "LAVER_CUP", winCriteria: { valueGoal: 13 } }, uD = { collectionDefinitions: [{ collectionName: "Female Doubles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Male Doubles", gender: "MALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Female Singles", gender: "FEMALE", matchUpCount: 1, matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Male Singles", matchUpCount: 1, gender: "MALE", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "SINGLES", scoreValue: 1 }, { collectionName: "Mixed Doubles", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:6/TB5NOAD@5", matchUpType: "DOUBLES", scoreValue: 1 }, { collectionName: "Overtime", matchUpCount: 1, gender: "MIXED", matchUpFormat: "SET1-S:T20", matchUpType: "DOUBLES", scoreValue: 1 }], tieFormatName: "USTA_TOC", winCriteria: { aggregateValue: !0 } }, Zl = "COLLEGE_DEFAULT", hf = "COLLEGE_JUCO", gf = "COLLEGE_D3", lD = "DOMINANT_DUO", dD = "DOMINANT_DUO_MIXED", pD = "LAVER_CUP", mD = "TEAM_DOUBLES_3_AGGREGATION", fD = "TIME_TENNIS_DUAL", hD = "TIME_TENNIS_PRO_CIRCUIT", gD = "USTA_BREWER_CUP", ID = "USTA_OZAKI_CUP", UD = "USTA_COLLEGE", SD = "USTA_GOLD_TEAM_CHALLENGE", yD = "USTA_LEVEL_1", vD = "USTA_INTERSECTIONAL", PD = "USTA_SECTION_BATTLE", DD = "USTA_SOUTHERN_LEVEL_5", wD = "USTA_TOC", TD = "USTA_WTT_ITT", bD = "USTA_ZONAL", q0 = { COLLEGE_D3: gf, COLLEGE_DEFAULT: Zl, COLLEGE_JUCO: hf, DOMINANT_DUO: lD, DOMINANT_DUO_MIXED: dD, LAVER_CUP: pD, TEAM_DOUBLES_3_AGGREGATION: mD, TIME_TENNIS_DUAL: fD, TIME_TENNIS_PRO_CIRCUIT: hD, USTA_BREWER_CUP: gD, USTA_OZAKI_CUP: ID, USTA_COLLEGE: UD, USTA_GOLD_TEAM_CHALLENGE: SD, USTA_INTERSECTIONAL: vD, USTA_LEVEL_1: yD, USTA_SECTION_BATTLE: PD, USTA_SOUTHERN_LEVEL_5: DD, USTA_TOC: wD, USTA_WTT_ITT: TD, USTA_ZONAL: bD }, MD = "STANDARD", $S = { [MD]: { hydrate: !0, doubles: { matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpCount: 6, matchUpValue: 1 }, valueGoal: 5 }, [gf]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:8/TB7@7", matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpFormat: Si, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: gf, valueGoal: 5 }, [Zl]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:6/TB7", collectionValue: 1, matchUpCount: 3 }, singles: { matchUpFormat: Si, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: Zl, valueGoal: 4 }, [hf]: { hydrate: !0, doubles: { matchUpFormat: "SET1-S:8/TB7", matchUpCount: 3, matchUpValue: 1 }, singles: { matchUpFormat: Si, matchUpCount: 6, matchUpValue: 1 }, tieFormatName: hf, valueGoal: 5 }, [pD]: cD, [lD]: iD, [dD]: JP, [mD]: zP, [fD]: ZP, [hD]: XP, [gD]: eD, [ID]: tD, [UD]: nD, [SD]: HP, [vD]: QP, [yD]: aD, [PD]: KP, [DD]: YP, [TD]: oD, [wD]: uD, [bD]: sD }, W0 = (e) => {
  let t = e?.namedFormat && Object.keys($S).includes(e.namedFormat) ? e.namedFormat : MD, r = Array.isArray(e?.uuids) ? e?.uuids : [], i, { category: n, gender: a } = e?.event ?? {}, o = ie($S[t], !1, !0), s = (c) => {
    if (!e?.isMock && !e?.event?.isMock || !e.event) return r?.pop() ?? je();
    let u = e?.event?.eventId;
    return r.pop() ?? `${u}-COL-${c + 1}`;
  };
  return o.hydrate ? (i = { winCriteria: { valueGoal: o.valueGoal }, collectionDefinitions: [{ collectionId: s(0), matchUpFormat: rD, collectionName: "Doubles", matchUpType: Ke, ...o.doubles }, { collectionId: s(1), matchUpFormat: Si, collectionName: "Singles", matchUpType: Xe, ...o.singles }] }, o.tieFormatName && (i.tieFormatName = o.tieFormatName)) : (o.collectionDefinitions.forEach((c, u) => c.collectionId = s(u)), i = o), e?.hydrateCollections && i.collectionDefinitions.forEach((c) => {
    n && !c.category && (c.category = n), a && !c.gender && (c.gender = a);
  }), i;
}, kn = W0, Ki = "SINGLES", So = "SINGLES", ai = "DOUBLES", xn = "DOUBLES", kt = "TEAM", jr = "TEAM", H0 = "RATING", z0 = "BOTH", Y0 = { AGE: "AGE", BOTH: z0, DOUBLES: ai, DOUBLES_EVENT: xn, RATING: H0, SINGLES: Ki, SINGLES_EVENT: So, TEAM_EVENT: jr, TEAM: kt }, re = "MAIN", se = "QUALIFYING", nr = "CONSOLATION", zt = "VOLUNTARY_CONSOLATION", yt = "PLAY_OFF", Hd = [re, se, nr, yt, zt], yo = { [se]: 1, [re]: 2, [yt]: 3, [nr]: 3, [zt]: 4 }, RD = "finishingPositions", ND = "aggregateEventStructures", ED = { [re]: 1, [yt]: 2, [nr]: 3, [se]: 4, [zt]: 5 }, K0 = { [yt]: 1, [re]: 2, [nr]: 3, [se]: 4, [zt]: 5 }, zd = "CLUSTER", Q0 = "SEPARATE", Na = "WATERFALL", Yd = "ITEM", yr = "CONTAINER", gi = "DRAW", Kd = "RANDOM", Ii = "TOP_DOWN", Ea = "BOTTOM_UP", gn = "POSITION", In = "WINNER", Un = "LOSER", Qi = "FIRST_MATCHUP", Gr = "AD_HOC", X0 = "AD_HOC", Ys = "FEED_IN", ws = "COMPASS", Ts = "OLYMPIC", J0 = "SINGLE_ELIMINATION", Wi = "SINGLE_ELIMINATION", Du = "DOUBLE_ELIMINATION", bs = "FIRST_MATCH_LOSER_CONSOLATION", wu = "FIRST_ROUND_LOSER_CONSOLATION", Ha = "LUCKY_DRAW", Qd = "CURTIS_CONSOLATION", Z0 = "CURTIS_CONSOLATION", jh = "FEED_IN_CHAMPIONSHIP_TO_SF", Gc = "FEED_IN_CHAMPIONSHIP_TO_SF", Gh = "FEED_IN_CHAMPIONSHIP_TO_QF", $c = "FEED_IN_CHAMPIONSHIP_TO_QF", $h = "FEED_IN_CHAMPIONSHIP_TO_R16", qc = "FEED_IN_CHAMPIONSHIP_TO_R16", AD = "MODIFIED_FEED_IN_CHAMPIONSHIP", Wc = "MODIFIED_FEED_IN_CHAMPIONSHIP", Tu = "FEED_IN_CHAMPIONSHIP", e1 = "DOUBLE_ROUND_ROBIN", Di = "ROUND_ROBIN", Sn = "ROUND_ROBIN_WITH_PLAYOFF", CD = "DECIDER", OD = "BACKDRAW", qh = { 0: { name: "East", abbreviation: "E" }, "0-1": { name: "West", abbreviation: "W" }, "0-2": { name: "North", abbreviation: "N" }, "0-3": { name: "Northeast", abbreviation: "NE" }, "0-1-1": { name: "South", abbreviation: "S" }, "0-1-2": { name: "Southwest", abbreviation: "SW" }, "0-2-1": { name: "Northwest", abbreviation: "NW" }, "0-1-1-1": { name: "Southeast", abbreviation: "SE" } }, Wh = { 0: { name: "East", abbreviation: "E" }, "0-1": { name: "West", abbreviation: "W" }, "0-2": { name: "North", abbreviation: "N" }, "0-1-1": { name: "South", abbreviation: "S" } }, Aa = "WIN_RATIO", Fo = "ROUND_OUTCOME", kD = [ws, Qd, $c, qc, Gc, Tu, Gh, $h, jh, bs, wu, Ha, Wc, Ts, yt, Sn], t1 = [Gr, ws, Qd, Du, $c, qc, Gc, Tu, Ys, bs, wu, Ha, Wc, Ts, yt, Di, Sn, Wi], xD = { MAIN: re, QUALIFYING: se, CONSOLATION: nr, ITEM: Yd, CONTAINER: yr, FIRST_MATCHUP: Qi, WINNER: In, LOSER: Un, AD_HOC: Gr, FEED_IN: Ys, FLEX_ROUNDS: X0, COMPASS: ws, PLAY_OFF: yt, OLYMPIC: Ts, KNOCKOUT: J0, SINGLE_ELIMINATION: Wi, DOUBLE_ELIMINATION: Du, CURTIS: Qd, FICSF: jh, FICQF: Gh, FICR16: $h, MFIC: AD, VOLUNTARY_CONSOLATION: zt, FIRST_MATCH_LOSER_CONSOLATION: bs, FIRST_ROUND_LOSER_CONSOLATION: wu, MODIFIED_FEED_IN_CHAMPIONSHIP: Wc, FEED_IN_CHAMPIONSHIP_TO_R16: qc, FEED_IN_CHAMPIONSHIP_TO_QF: $c, FEED_IN_CHAMPIONSHIP_TO_SF: Gc, FEED_IN_CHAMPIONSHIP: Tu, LUCKY_DRAW: Ha, ROUND_ROBIN_WITH_PLAYOFF: Sn, ROUND_ROBIN: Di, DECIDER: CD, BACKDRAW: OD, COMPASS_ATTRIBUTES: qh, OLYMPIC_ATTRIBUTES: Wh, DRAW: gi, RANDOM: Kd, TOP_DOWN: Ii, BOTTOM_UP: Ea, WATERFALL: Na, WIN_RATIO: Aa, ROUND_OUTCOME: Fo, MULTI_STRUCTURE_DRAWS: kD, generatedDrawTypes: t1, stageOrder: yo, finishOrder: ED, AGGREGATE_EVENT_STRUCTURES: ND, FINISHING_POSITIONS: RD }, r1 = xD, ur = "tournamentRecords", Hh = "policyDefinitions", Vt = "tournamentRecord", zh = "onlineResource", lr = "drawDefinition", FD = "tieFormatName", Yh = "matchUpFormat", yn = "participantId", LD = "scheduleDates", i1 = "tournamentId", n1 = "scheduleDate", a1 = "roundNumber", Xd = "structureId", Kh = "participant", bu = "matchUpIds", _D = "entryStage", o1 = "policyType", BD = "structures", Qh = "eventType", tn = "matchUpId", Jd = "tieFormat", Zd = "inContext", ep = "structure", tp = "courtIds", s1 = "personId", rp = "venueIds", Xh = "matchUps", VD = "courtId", jD = "eventId", Tn = "matchUp", GD = "drawId", yi = "error", qn = "event", Ks = "param", Jh = "uuids", c1 = "averageMatchUpMinutes", u1 = "recoveryMinutes", l1 = "periodLength", d1 = "number", Nr = "object", sr = "array", tr = "_validate", $D = "_message", Kr = "_invalid", Mr = "_ofType", Zh = "_anyOf", Ms = "_oneOf", qS = { [zh]: (e) => Pt(Object.keys(e), [vs, Ps, Ds]).length === 3, [FD]: (e) => e && kn({ namedFormat: e }), [Jh]: (e) => !e || Array.isArray(e) && e.every(dt), [Jd]: (e) => !wr({ tieFormat: e }).error, [Qh]: (e) => [Ki, ai, kt].includes(e), [_D]: (e) => Hd.includes(e) }, p1 = { [ur]: ht, [Vt]: J, [Hh]: Ed, [lr]: ne, [yn]: Ft, [Yh]: dh, [i1]: Is, [Xd]: Qr, [bu]: Ro, [Kh]: Ao, [zh]: $n, [Qh]: fn, [BD]: sh, [tn]: pr, [Jd]: cn, [ep]: qa, [VD]: No, [Xh]: Gn, [jD]: ni, [Tn]: Dr, [tp]: ue, [rp]: ue, [GD]: Vi, [qn]: st }, m1 = { [ur]: Nr, [Hh]: Nr, [Vt]: Nr, [lr]: Nr, [zh]: Nr, [LD]: sr, [Kh]: Nr, [bu]: sr, [BD]: sr, [Jd]: Nr, [ep]: Nr, [tp]: sr, [rp]: sr, [Xh]: sr, [Tn]: Nr, [qn]: Nr, [Jh]: sr };
function oe(e, t, r) {
  if (!e && !xe(e)) return { error: z };
  if (!t?.length || e?._bypassParamCheck) return { valid: !0 };
  if (!Array.isArray(t)) return { error: z };
  let { paramError: i, errorParam: n } = g1(e, t);
  if (!i) return { valid: !0 };
  let a = i[tr] && (i[yi] || i[Kr]) || e?.[n] === void 0 && (i[yi] || i[Kr] || p1[n] || z) || z, o = n ?? (i[Ms] && Object.keys(i[Ms]).join(", "));
  return F({ info: { param: o, message: i[$D] }, result: { error: a }, stack: r });
}
function qD(e, t) {
  let r = Object.keys(e), i = Object.keys(t);
  return Pt(r, i);
}
function f1(e, t) {
  if (!t) return;
  let r = qD(e, t);
  return r.length !== 1 ? { error: z } : r.reduce((i, n) => ({ ...i, [n]: !0 }), {});
}
function h1(e, t) {
  if (!t) return;
  let r = qD(e, t).filter((i) => e[i]);
  return r.length < 1 ? { error: z } : r.reduce((i, n) => ({ ...i, [n]: !0 }), {});
}
function g1(e, t) {
  let r, i;
  return { paramError: t.find(({ _ofType: n, _oneOf: a, _anyOf: o, _validate: s, _info: c, ...u }) => {
    let l = a && f1(e, a);
    if (l?.error) return l.error;
    l && Object.assign(u, l);
    let d = o && h1(e, o);
    if (d?.error) return d.error;
    d && Object.assign(u, d);
    let p = Object.keys(u).filter((f) => typeof u[f] == "boolean"), m = p.find((f) => {
      let h = s && !Fr(s), g = e[f] !== void 0 && !s && I1(e, f, n), I = u[f] && [void 0, null].includes(e[f]), U = h || g || I || s && e[f] !== void 0 && !U1(e[f], s) || qS[f] && !qS[f](e[f]);
      return U && (r = f, i = c), U;
    });
    return !p.length || m;
  }), errorParam: r, paramInfo: i };
}
function I1(e, t, r) {
  return r = r || m1[t] || "string", r === "array" ? !Array.isArray(e[t]) : typeof e[t] !== r;
}
function U1(e, t) {
  return Fr(t) ? t(e) : !0;
}
var eg = "DYNAMIC", ia = "RANKING", Zn = "RATING", Ca = "SCALE", un = "SEEDING", S1 = { RANKING: ia, RATING: Zn, SCALE: Ca, SEEDING: un };
function Qs(e) {
  let t = oe(e, [{ [Kh]: !0 }]);
  if (t.error) return t;
  let r = e.participant.timeItems?.filter(({ itemType: n }) => n?.startsWith(Ca) && [ia, Zn, un].includes(n.split(".")[1])), i = { ratings: {}, rankings: {}, seedings: {} };
  if (r?.length) {
    let n = (o) => r.filter((s) => s?.itemType === o).sort((s, c) => new Date(s.createdAt || void 0).getTime() - new Date(c.createdAt || void 0).getTime()).pop(), a = Ue(r.map(({ itemType: o }) => o));
    for (let o of a) {
      let s = n(o);
      if (s) {
        let [, c, u, l, d] = s.itemType.split("."), p = d ? `${l}.${d}` : l, m = c === un && "seedings" || c === ia && "rankings" || "ratings";
        i[m][u] || (i[m][u] = []), i[m][u].push({ scaleValue: s.itemValue, scaleDate: s.itemDate, scaleName: p });
      }
    }
  }
  return { ...x, ...i };
}
function vo(e) {
  if (e === null) return {};
  let { source: t, template: r } = e || {};
  if (!r) return t;
  let i = {};
  return n(t, r, i), i;
  function n(a, o, s) {
    if (!a || !o) return;
    let c = Object.keys(a), u = Object.keys(o), l = Object.assign({}, ...u.filter((m) => m.indexOf("||")).map((m) => m.split("||").map((f) => ({ [f]: m }))).flat()), d = u.concat(...Object.keys(l)), p = d.includes("*");
    for (let m of c) if (d.indexOf(m) >= 0 || p) {
      let f = l[m] || m, h = o[f] || p, g = a[m];
      if (typeof h == "object" && typeof g != "function" && !Array.isArray(h)) if (Array.isArray(g)) {
        let I = g.map((U) => {
          let S = {};
          return n(U, h, S) !== !1 ? S : void 0;
        }).filter(Boolean);
        s[m] = I;
      } else g && (s[m] = {}, n(g, h, s[m]));
      else {
        let I = a[m];
        if (Array.isArray(h) && !h.includes(I)) return !1;
        (o[m] || p && o[m] !== !1) && (s[m] = I);
      }
    }
  }
}
var If = "voluntaryConsolation", En = "competitiveBands", tg = "roundRobinTally", vn = "positionActions", Yt = "matchUpActions", kl = "rankingPoints", Rs = "roundNaming", Xs = "participant", Hc = "progression", pa = "scheduling", zc = "avoidance", y1 = "participant", v1 = "display", oi = "scoring", hi = "seeding", Ns = "feedIn", P1 = "audit", ed = "draws", D1 = { POLICY_TYPE_VOLUNTARY_CONSOLATION: If, POLICY_TYPE_COMPETITIVE_BANDS: En, POLICY_TYPE_ROUND_ROBIN_TALLY: tg, POLICY_TYPE_POSITION_ACTIONS: vn, POLICY_TYPE_MATCHUP_ACTIONS: Yt, POLICY_TYPE_RANKING_POINTS: kl, POLICY_TYPE_ROUND_NAMING: Rs, POLICY_TYPE_PARTICIPANT: Xs, POLICY_TYPE_PROGRESSION: Hc, POLICY_TYPE_SCHEDULING: pa, POLICY_TYPE_AVOIDANCE: zc, POLICY_TYPE_DISPLAY: v1, POLICY_TYPE_PRIVACY: y1, POLICY_TYPE_FEED_IN: Ns, POLICY_TYPE_SCORING: oi, POLICY_TYPE_SEEDING: hi, POLICY_TYPE_AUDIT: P1, POLICY_TYPE_DRAWS: ed };
function na({ tournamentParticipants: e = [], policyDefinitions: t = {}, contextProfile: r, participantId: i, internalUse: n, personId: a }) {
  let o = e.find((c) => i && c.participantId === i || a && c.person && c.person.personId === a), s = ie(o, !1, n);
  if (s) {
    let c = t?.[Xs];
    if (r?.withScaleValues) {
      let { ratings: u, rankings: l } = Qs({ participant: s });
      s.rankings = l, s.ratings = u;
    }
    if (c?.participant) return vo({ template: c.participant, source: s });
  }
  return s;
}
var w1 = "element required", T1 = "missing name";
function fr(e) {
  if (!e || typeof e != "object") return { error: ue };
  if (e.element && typeof e?.element != "object") return { error: z };
  if (!e?.name) return { error: ue, info: T1 };
  if (!e?.element) {
    if (e.discover && e.tournamentRecords) {
      for (let t of Object.keys(e.tournamentRecords)) {
        let r = e.tournamentRecords[t], i = fr({ element: r, name: e.name });
        if (i.error) return F({ result: i, stack: "removeExtension" });
      }
      return { ...x };
    }
    return { error: ue, info: w1 };
  }
  return e?.element.extensions ? (e.element.extensions = e.element.extensions.filter((t) => t?.name !== e.name), { ...x }) : { ...x, info: Kt };
}
function Xi({ requiredAttributes: e = ["name", "value"], extension: t }) {
  if (!t || typeof t != "object" || typeof t.name != "string") return !1;
  let r = Object.keys(t);
  return e.filter((i) => r.includes(i)).length === e.length;
}
function Be(e) {
  if (typeof e != "object") return { error: ue };
  let t = "addExtension";
  if (e?.element && typeof e.element != "object") return F({ result: { error: z }, stack: t });
  if (!Xi({ extension: e.extension })) return F({ result: { error: z, info: "invalid extension" }, stack: t });
  if (!e.element) if (e.discover && !e.tournamentId && e.tournamentRecords) {
    for (let i of Object.values(e.tournamentRecords)) {
      let n = Be({ extension: e.extension, element: i });
      if (n.error) return F({ result: n, stack: t });
    }
    return { ...x };
  } else return F({ result: { error: ue }, stack: t });
  if (e.element.extensions || (e.element.extensions = []), e?.creationTime ?? !0) {
    let i = (/* @__PURE__ */ new Date()).toISOString();
    Object.assign(e.extension, { createdAt: i });
  }
  let r = e.element.extensions.find(({ name: i }) => i === e.extension.name);
  return r ? r.value = e.extension.value : e.extension.value && e.element.extensions.push(e.extension), { ...x };
}
function rg(e) {
  return !e || typeof e != "object" ? { error: ue } : e.tournamentRecord ? Be({ creationTime: e.creationTime, element: e.tournamentRecord, extension: e.extension }) : { error: J };
}
function ip(e) {
  return !e || typeof e != "object" ? { error: ue } : e.drawDefinition ? Be({ creationTime: e.creationTime, element: e.drawDefinition, extension: e.extension }) : { error: zr };
}
function ma(e) {
  return !e || typeof e != "object" ? { error: ue } : e.event ? Be({ creationTime: e.creationTime, extension: e.extension, element: e.event }) : { error: ni };
}
function WD(e) {
  if (!e || typeof e != "object") return { error: ue };
  if (!e.participantId) return { error: Ft };
  let t = e.tournamentRecord?.participants || [], r = na({ participantId: e.participantId, tournamentParticipants: t });
  return r ? Be({ creationTime: e.creationTime, extension: e.extension, element: r }) : { error: Tt };
}
function ig(e) {
  return !e || typeof e != "object" ? { error: ue } : e.tournamentRecord ? fr({ element: e.tournamentRecord, name: e.name }) : { error: J };
}
function HD(e) {
  return !e || typeof e != "object" ? { error: ue } : e.drawDefinition ? fr({ element: e.drawDefinition, name: e.name }) : { error: zr };
}
function np(e) {
  return !e || typeof e != "object" ? { error: ue } : e?.event ? fr({ element: e.event, name: e.name }) : { error: ni };
}
function zD(e) {
  if (!e || typeof e != "object") return { error: ue };
  if (!e.participantId) return { error: Ft };
  let t = e.tournamentRecord?.participants || [], r = na({ participantId: e.participantId, tournamentParticipants: t });
  return r ? fr({ element: r, name: e.name }) : { error: Tt };
}
function Mu({ tournamentRecords: e }) {
  return { tournamentIds: xe(e) ? Object.keys(e) : [], ...x };
}
var b1 = "extensionQueries";
function we({ discover: e, element: t, name: r, ...i }) {
  if (!t || !r) {
    if (e && i) {
      let a = Object.keys(i).filter((c) => typeof e == "boolean" || Array.isArray(e) && e.includes(c)).find((c) => Array.isArray(i[c]?.extensions) ? i[c].extensions.find((u) => u?.name === r) : !1), o = a && i[a];
      !o && i.tournamentRecords && (o = Object.values(i.tournamentRecords).find((c) => c.extensions?.length));
      let s = o?.extensions?.find((c) => c?.name === r);
      return { extension: s, info: s ? void 0 : Kt };
    }
    return F({ result: { error: ue }, stack: b1 });
  }
  if (!Array.isArray(t.extensions)) return { info: "no extensions" };
  let n = t.extensions.find((a) => a?.name === r);
  return { extension: n, info: n ? void 0 : Kt };
}
var M1 = "activeSuspension", Yc = "appliedPolicies", YD = "context", ap = "delegatedOutcome", ki = "disabled", Po = "disableAutoCalc", op = "disableLinks", td = "display", Ta = "drawDeletions", R1 = "drawProfile", rd = "entryProfile", N1 = "eventProfile", E1 = "eventWithdrawalRequests", A1 = "factory", wi = "flightProfile", Uf = "groupingAttribute", Fn = "lineUps", Oa = "linkedTournamentsIds", sp = "matchUpHistory", ng = "participantRepresentatives", Js = "personRequests", ms = "positionActions", C1 = "rankingPoints", O1 = "registration", rn = "roundTarget", Ru = "scheduleLimits", Ln = "scheduleTiming", Do = "schedulingProfile", k1 = "statusDetail", Es = "subOrder", _n = "tally", Tc = "tieFormatModification", KD = { ACTIVE_SUSPENSION: M1, APPLIED_POLICIES: Yc, CONTEXT: YD, DELEGATED_OUTCOME: ap, DISABLED: ki, DISABLE_LINKS: op, DISABLE_AUTO_CALC: Po, DISPLAY: td, DRAW_DELETIONS: Ta, DRAW_PROFILE: R1, ENTRY_PROFILE: rd, EVENT_PROFILE: N1, EVENT_WITHDRAWAL_REQUESTS: E1, FLIGHT_PROFILE: wi, GROUPING_ATTRIBUTE: Uf, LINEUPS: Fn, LINKED_TOURNAMENTS: Oa, MATCHUP_HISTORY: sp, PARTICIPANT_REPRESENTATIVES: ng, PERSON_REQUESTS: Js, POSITION_ACTIONS: ms, RANKING_POINTS: C1, REGISTRATION: O1, ROUND_TARGET: rn, SCHEDULE_LIMITS: Ru, SCHEDULE_TIMING: Ln, SCHEDULING_PROFILE: Do, STATUS_DETAIL: k1, SUB_ORDER: Es, TALLY: _n, TIE_FORMAT_MODIFICATIONS: Tc, FACTORY: A1 }, WS = [ap, ki, Po, op, wi, Fn, Oa, sp, ng, Js, rn, Ru, Ln, Do, Es, _n, Tc];
function QD({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: ht };
  let t = Mu({ tournamentRecords: e }), { tournamentIds: r } = t;
  return r?.length > 1 ? Be({ tournamentRecords: e, discover: !0, extension: { name: Oa, value: { tournamentIds: r } } }) : { ...x };
}
function XD({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: ht };
  let t = fr({ name: Oa, tournamentRecords: e, discover: !0 });
  return F({ result: t, stack: "unlinkTournaments" });
}
function JD({ tournamentRecords: e, tournamentId: t }) {
  if (typeof e != "object") return { error: z };
  if (!t) return { error: Is };
  let r = Mu({ tournamentRecords: e }), { tournamentIds: i } = r;
  if (!i.includes(t)) return { error: Is };
  let n;
  return i.every((a) => {
    let o = e[a], { extension: s } = we({ element: o, name: Oa });
    if (!s) return !0;
    let c = s?.value?.tournamentIds || [];
    if (!c?.length || c.length === 1 && c.includes(t) || a === t) {
      let d = ig({ name: Oa, tournamentRecord: o });
      return d.error && (n = d.error), d.success;
    }
    let u = c.filter((d) => d !== t);
    s.value = { tournamentIds: u };
    let l = rg({ tournamentRecord: o, extension: s });
    return l.error && (n = l.error), l.success;
  }), n ? { error: n } : { ...x };
}
var ZD = {};
Me(ZD, { getLinkedTournamentIds: () => Nu, getTournamentIds: () => Mu });
function Nu({ tournamentRecords: e }) {
  return typeof e != "object" || !Object.keys(e).length ? { error: ht } : { linkedTournamentIds: Object.assign({}, ...Object.keys(e).map((t) => {
    let r = e[t], i = r?.tournamentId, { extension: n } = we({ element: r, name: Oa }), a = (n?.value?.tournamentIds || []).filter((o) => o !== i);
    return { [t]: a };
  })) };
}
var ew = {};
Me(ew, { adHocPositionSwap: () => HT, addAdHocMatchUps: () => xp, addDrawDefinitionTimeItem: () => oI, addFinishingRounds: () => qu, addGoesTo: () => Fa, addPlayoffStructures: () => kp, addQualifyingStructure: () => WT, addVoluntaryConsolationStage: () => _T, addVoluntaryConsolationStructure: () => zg, allPlayoffPositionsFilled: () => iI, alternateDrawPositionAssignment: () => bT, assignDrawPosition: () => Ib, assignDrawPositionBye: () => Zr, attachConsolationStructures: () => mb, attachPlayoffStructures: () => PI, attachQualifyingStructure: () => aI, attachStructures: () => Op, autoSeeding: () => F_, automatedPlayoffPositioning: () => oc, automatedPositioning: () => el, checkValidEntries: () => _p, deleteAdHocMatchUps: () => Sb, drawMatic: () => HI, findDrawDefinition: () => MI, generateAdHocMatchUps: () => Bp, generateAdHocRounds: () => WI, generateAndPopulatePlayoffStructures: () => yI, generateDrawDefinition: () => Il, generateDrawMaticRound: () => xI, generateDrawStructuresAndLinks: () => CI, generateDrawTypeAndModifyDrawDefinition: () => OI, generateQualifyingStructure: () => pI, generateVoluntaryConsolation: () => qb, getAssignedParticipantIds: () => eo, getAvailableMatchUpsCount: () => Fp, getAvailablePlayoffProfiles: () => il, getDrawDefinitionTimeItem: () => wg, getDrawParticipantRepresentativeIds: () => TI, getDrawStructures: () => Ti, getDrawTypeCoercion: () => ul, getEligibleVoluntaryConsolationParticipants: () => wI, getMatchUpsMap: () => or, getParticipantIdFinishingPositions: () => bI, getPositionAssignments: () => ru, getPositionsPlayedOff: () => sc, getRandomQualifierList: () => EI, getSeedingThresholds: () => Xg, getSeedsCount: () => ll, getStructureSeedAssignments: () => si, getTeamLineUp: () => xa, getValidGroupSizes: () => Ju, isAdHoc: () => Tr, isCompletedStructure: () => wn, isValidForQualifying: () => AI, luckyLoserDrawPositionAssignment: () => yT, modifyDrawDefinition: () => fb, modifyDrawName: () => DI, modifySeedAssignment: () => AT, mutate: () => tw, positionActions: () => NI, pruneDrawDefinition: () => gb, qualifierDrawPositionAssignment: () => nI, qualifierProgression: () => CT, query: () => Pb, removeDrawPositionAssignment: () => Zc, removeRoundMatchUps: () => yb, removeSeededParticipant: () => qT, removeStructure: () => FT, renameStructures: () => xT, resetDrawDefinition: () => hb, resetQualifyingStructure: () => BT, resetVoluntaryConsolationStructure: () => Uw, setDrawParticipantRepresentativeIds: () => rw, setPositionAssignments: () => wT, setStructureOrder: () => OT, setSubOrder: () => vb, shiftAdHocRounds: () => DT, swapAdHocRounds: () => TT, swapDrawPositionAssignments: () => GT, updateTeamLineUp: () => Qo, withdrawParticipantAtDrawPosition: () => pT });
var tw = {};
Me(tw, { adHocPositionSwap: () => HT, addAdHocMatchUps: () => xp, addDrawDefinitionTimeItem: () => oI, addPlayoffStructures: () => kp, addQualifyingStructure: () => WT, addVoluntaryConsolationStage: () => _T, addVoluntaryConsolationStructure: () => zg, alternateDrawPositionAssignment: () => bT, assignDrawPosition: () => Ib, assignDrawPositionBye: () => Zr, attachConsolationStructures: () => mb, attachPlayoffStructures: () => PI, attachQualifyingStructure: () => aI, attachStructures: () => Op, automatedPlayoffPositioning: () => oc, automatedPositioning: () => el, deleteAdHocMatchUps: () => Sb, luckyLoserDrawPositionAssignment: () => yT, modifyDrawDefinition: () => fb, modifyDrawName: () => DI, modifySeedAssignment: () => AT, pruneDrawDefinition: () => gb, qualifierDrawPositionAssignment: () => nI, qualifierProgression: () => CT, removeDrawPositionAssignment: () => Zc, removeRoundMatchUps: () => yb, removeSeededParticipant: () => qT, removeStructure: () => FT, renameStructures: () => xT, resetDrawDefinition: () => hb, resetQualifyingStructure: () => BT, resetVoluntaryConsolationStructure: () => Uw, setDrawParticipantRepresentativeIds: () => rw, setPositionAssignments: () => wT, setStructureOrder: () => OT, setSubOrder: () => vb, shiftAdHocRounds: () => DT, swapAdHocRounds: () => TT, swapDrawPositionAssignments: () => GT, updateTeamLineUp: () => Qo, withdrawParticipantAtDrawPosition: () => pT });
var ag = (e) => (t) => e[t], og = (e = []) => e.map($t).filter(Boolean), Sf = (e = []) => e.map(Re).filter(Boolean), Re = (e = {}) => ag(e)("participantId"), $t = (e = {}) => ag(e)("matchUpId"), Kc = (e = {}) => ag(e)("drawId");
function rw({ representativeParticipantIds: e, drawDefinition: t }) {
  if (!t) return { error: zr };
  if (!Array.isArray(e)) return { error: z };
  let r = Sf(t?.entries || []);
  return e.length && Pt(e, r).length < e.length ? { error: z } : ip({ drawDefinition: t, extension: { name: ng, value: e } });
}
var Or = "ABANDONED", Lo = "AWAITING_RESULT", nn = "CANCELLED", vt = "COMPLETED", Zs = "DEAD_RUBBER", Pe = "DEFAULTED", xt = "DOUBLE_DEFAULT", Mt = "DOUBLE_WALKOVER", Ri = "IN_PROGRESS", $r = "INCOMPLETE", sg = "NOT_PLAYED", Xt = "RETIRED", fa = "SUSPENDED", Dt = "TO_BE_PLAYED", be = "WALKOVER", x1 = [Lo, vt, Pe, Ri, $r, Xt, fa], iw = [Lo, vt, Pe, Mt, xt, Ri, $r, Xt, fa, be], nw = [Or, Lo, "BYE", nn, vt, Zs, Pe, Mt, xt, Ri, $r, sg, Xt, fa, Dt, be], aw = ["BYE", Mt, xt, vt, Pe, Xt, be], ow = [Or, Lo, nn, Zs, Ri, $r, sg, fa, Dt, void 0], Lt = [nn, Or, vt, Zs, Pe, Mt, xt, Xt, be], cg = [Or, vt, Pe, Mt, xt, Ri, Xt, be], sw = [Ri, $r, fa, Dt], cw = { ABANDONED: Or, AWAITING_RESULT: Lo, BYE: "BYE", CANCELLED: nn, COMPLETED: vt, DEAD_RUBBER: Zs, DEFAULTED: Pe, DOUBLE_WALKOVER: Mt, DOUBLE_DEFAULT: xt, IN_PROGRESS: Ri, INCOMPLETE: $r, NOT_PLAYED: sg, RETIRED: Xt, SUSPENDED: fa, TO_BE_PLAYED: Dt, WALKOVER: be };
function _o(e, t, r) {
  let i = (d) => we({ element: d, name: rn })?.extension?.value, n = r?.deprioritizeCompleted, a = r?.mode === ND && K0, o = r?.mode === RD && ED, s = o || a || yo, c = (d) => d?.stage === re && d?.stageSequence === 1, u = (d) => c(d) ? -1 : s[d?.stage], l = (d) => d?.matchUps.every(({ matchUpStatus: p }) => Lt.includes(p) ? 1 : -1);
  return n && l(e) - l(t) || a && u(e) - u(t) || (e?.stage && s[e.stage] || 0) - (t?.stage && s[t.stage] || 0) || (i(e) || 0) - (i(t) || 0) || !o && !a && (t?.positionAssignments?.length ?? 1 / 0) - (e?.positionAssignments?.length ?? 1 / 0) || (e?.stageSequence ?? 0) - (t?.stageSequence ?? 0) || (id(e) || 0) - (id(t) || 0);
}
function id(e) {
  return (e?.matchUps || []).reduce((t, r) => {
    let i = (r.finishingPositionRange?.winner || []).reduce((n, a) => n + a, 0);
    return !t || i < t ? i : t;
  }, void 0);
}
function me(e) {
  let t = oe(e, [{ [lr]: !0, [Xd]: !0 }]);
  if (t.error) return t;
  let { drawDefinition: r, structureId: i } = e, { structures: n } = Ti({ drawDefinition: r }), a = n?.map((c) => c.structures ? [...c.structures].concat(c) : c).flat(), o = a?.find((c) => c.structureId === i);
  if (!o) return { error: mt };
  let s = o.structureType === Yd ? a?.find((c) => c.structures?.some((u) => u.structureId === i)) : void 0;
  return { structure: o, containingStructure: s };
}
function Ti({ withStageGrouping: e, drawDefinition: t, stageSequences: r, stageSequence: i, roundTarget: n, sortConfig: a, stages: o, stage: s }) {
  let c = !t && ne || !t?.structures && sh || void 0;
  if (c) return { error: c, structures: [], stageStructures: {} };
  let u = (f) => {
    let h = we({ element: f, name: rn })?.extension?.value;
    return !n || n === h;
  }, l = t?.structures?.filter(p).filter(m).filter(u).sort((f, h) => _o(f, h, a)) ?? [], d = e ? Object.assign({}, ...Hd.map((f) => {
    let h = l?.filter((g) => g.stage === f);
    return h?.length && { [f]: h };
  }).filter(Boolean)) : {};
  return { structures: l, stageStructures: d };
  function p(f) {
    return !s && !Array.isArray(o) || s && f.stage === s || Array.isArray(o) && o.includes(f.stage);
  }
  function m(f) {
    return !i && !Array.isArray(r) || i && f.stageSequence === i || Array.isArray(r) && r.includes(f.stageSequence);
  }
}
function uw({ drawDefinition: e }) {
  if (!e) return { error: ne };
  let t = {};
  return { allPositionedParticipantIds: (e.structures || []).map((r) => {
    let i = r.stage;
    t[i] || (t[i] = []);
    let { positionAssignments: n } = Je({ structure: r }), a = n?.map(Re).filter(Boolean) ?? [];
    return t[i].push(...a), a;
  }).flat(), stagePositionedParticipantIds: t };
}
function Je({ drawDefinition: e, structureId: t, structure: r }) {
  let i, n = [];
  if (!r) {
    if (!e) return { positionAssignments: n, error: ne };
    if ({ structure: r, error: i } = me({ drawDefinition: e, structureId: t }), i) return { positionAssignments: n, error: i };
  }
  return r.structures ? n = [].concat(...r.structures.map((a) => Je({ structure: a }).positionAssignments)) : r.positionAssignments ? n = r.positionAssignments : i = _v, { positionAssignments: n, error: i };
}
function _t({ drawDefinition: e, structureId: t, structure: r }) {
  let i = Je({ drawDefinition: e, structureId: t, structure: r })?.positionAssignments || [], n = i?.filter((u) => u.participantId ?? u.bye ?? u.qualifier), a = i && i?.length === n?.length, o = i?.filter((u) => !u.participantId && !u.bye && !u.qualifier), s = i?.filter((u) => !u.participantId && u.bye), c = i?.filter((u) => !u.participantId && u.qualifier);
  return { allPositionsAssigned: a, positionAssignments: i, unassignedPositions: o, assignedPositions: n, qualifierPositions: c, byePositions: s };
}
var ug = "addDrawDefinition", cp = "addMatchUps", aa = "addParticipants", lg = "addScaleItems", lw = "addEvent", dw = "addVenue", Cn = "audit", dg = "dataIssue", pg = "deleteParticipants", mg = "deleteVenue", fg = "deletedDrawIds", hg = "deletedMatchUpIds", gg = "modifyDrawDefinition", pw = "modifyDrawEntries", mw = "modifyEventEntries", Ig = "modifyMatchUp", ar = "modifyParticipants", Ug = "modifyPositionAssignments", Sg = "modifySeedAssignments", za = "modifyTournamentDetail", Ya = "modifyVenue", yf = "mutations", vf = "publishEvent", fw = "publishEventSeeding", hw = "publishOrderOfPlay", gw = "publishParticipants", yg = "unPublishEvent", vg = "unPublishEventSeeding", Pg = "unPublishOrderOfPlay", F1 = "unPublishParticipants", up = "updateInContextMatchUp", L1 = { ADD_DRAW_DEFINITION: ug, ADD_MATCHUPS: cp, ADD_PARTICIPANTS: aa, ADD_SCALE_ITEMS: lg, ADD_EVENT: lw, ADD_VENUE: dw, AUDIT: Cn, DATA_ISSUE: dg, DELETE_PARTICIPANTS: pg, DELETE_VENUE: mg, DELETED_DRAW_IDS: fg, DELETED_MATCHUP_IDS: hg, MODIFY_DRAW_DEFINITION: gg, MODIFY_DRAW_ENTRIES: pw, MODIFY_EVENT_ENTRIES: mw, MODIFY_MATCHUP: Ig, MODIFY_PARTICIPANTS: ar, MODIFY_POSITION_ASSIGNMENTS: Ug, MODIFY_SEED_ASSIGNMENTS: Sg, MODIFY_TOURNAMENT_DETAIL: za, MODIFY_VENUE: Ya, MUTATIONS: yf, PUBLISH_EVENT_SEEDING: fw, PUBLISH_EVENT: vf, PUBLISH_ORDER_OF_PLAY: hw, PUBLISH_PARTICIPANTS: gw, UNPUBLISH_EVENT_SEEDING: vg, UNPUBLISH_EVENT: yg, UNPUBLISH_ORDER_OF_PLAY: Pg, UPDATE_INCONTEXT_MATCHUP: up };
function lp(e, t) {
  if (!e) return { error: ne };
  let r = Date.now();
  e.updatedAt && r === new Date(e.updatedAt).getTime() && (r += 1);
  let i = new Date(r).toISOString(), n = t?.filter(Boolean);
  return e.updatedAt = i, e.structures?.filter(Boolean).forEach((a) => {
    (!n?.length || n?.includes(a.structureId)) && (a.updatedAt = i);
  }), { ...x };
}
function oa({ drawDefinition: e, tournamentId: t, matchUps: r, eventId: i }) {
  return e && lp(e), Se({ payload: { matchUps: r, tournamentId: t, eventId: i }, topic: cp }), { ...x };
}
function bn({ drawDefinition: e, tournamentId: t, matchUpIds: r, eventId: i, action: n }) {
  e && lp(e), Se({ topic: hg, payload: { tournamentId: t, matchUpIds: r, eventId: i, action: n } });
  for (let a of r) Ch({ key: a });
  return { ...x };
}
function Oe({ drawDefinition: e, tournamentId: t, structureId: r, context: i, eventId: n, matchUp: a }) {
  return a ? (e && tt({ drawDefinition: e, structureIds: r ? [r] : void 0, tournamentId: t, eventId: n }), Se({ topic: Ig, payload: { matchUp: a, tournamentId: t, context: i }, key: a.matchUpId }), { ...x }) : (console.log(Dr), { error: Dr });
}
function _1({ tournamentId: e, inContextMatchUp: t }) {
  return t ? (Se({ payload: { inContextMatchUp: t, tournamentId: e }, topic: up, key: t.matchUpId }), { ...x }) : { error: Dr };
}
function Eu({ tournamentId: e, eventId: t, drawDefinition: r }) {
  return r ? (lp(r), Se({ payload: { drawDefinition: r, tournamentId: e, eventId: t }, topic: ug, key: r.drawId }), { ...x }) : (console.log(ne), { error: ne });
}
function B1({ tournamentId: e, eventId: t, drawId: r }) {
  return Se({ payload: { drawId: r, tournamentId: e, eventId: t }, topic: fg, key: r }), Ch({ key: r }), { ...x };
}
function tt({ drawDefinition: e, tournamentId: t, structureIds: r, eventId: i }) {
  return e ? (lp(e, r), Se({ payload: { tournamentId: t, eventId: i, drawDefinition: e }, topic: gg, key: e.drawId }), { ...x }) : { error: ne };
}
function Iw({ drawDefinition: e, tournamentId: t, structure: r, eventId: i }) {
  if (!e) return { error: ne };
  if (!r) return { error: qa };
  let n = r.seedAssignments, a = r.structureId, o = e.drawId;
  return Se({ payload: { tournamentId: t, eventId: i, drawId: o, structureId: a, seedAssignments: n }, topic: Sg, key: e.drawId }), tt({ structureIds: [a], drawDefinition: e, tournamentId: t, eventId: i }), { ...x };
}
function sa({ drawDefinition: e, tournamentId: t, structure: r, event: i }) {
  if (!e) return { error: ne };
  if (!r) return { error: qa };
  let n = Je({ structure: r }), a = r.structureId, o = e.drawId, s = i?.eventId;
  return Se({ topic: Ug, payload: { positionAssignments: n, tournamentId: t, structureId: a, eventId: s, drawId: o }, key: a }), tt({ structureIds: [a], drawDefinition: e, tournamentId: t, eventId: s }), { ...x };
}
function Uw({ tournamentRecord: e, drawDefinition: t, resetEntries: r, event: i }) {
  if (!t) return { error: ne };
  let n = t.structures?.find((o) => o.stage === zt);
  if (!n) return { error: mt };
  let a = n.matchUps?.map(({ matchUpId: o }) => o) || [];
  return n.positionAssignments = [], n.seedAssignments = [], n.matchUps = [], bn({ tournamentId: e?.tournamentId, action: "resetVoluntaryConsolationStructure", matchUpIds: a, drawDefinition: t }), r && (t.entries = t.entries.filter((o) => o.entryStage !== zt)), tt({ tournamentId: e?.tournamentId, eventId: i?.eventId, drawDefinition: t, structureIds: [n.structureId] }), { ...x };
}
function Dg({ drawPositions: e, structure: t }) {
  if ([se, re].includes(t.stage) && t.stageSequence === 1) return;
  let { positionAssignments: r } = Je({ structure: t });
  r?.filter(({ drawPosition: i }) => e?.includes(i))?.forEach((i) => {
    Be({ element: i, extension: { name: op, value: !0 } });
  });
}
function dp(e) {
  let { appliedPolicies: t, positionAction: r, drawDefinition: i } = e;
  if (t?.audit?.[ms] === !1) return;
  let { extension: n } = we({ name: ms, element: i }), a = Array.isArray(n?.value) ? n?.value ?? [] : [];
  if (!a?.length) {
    let s = i.structures.find((c) => c.stage === re);
    if (s) {
      let c = Je({ structure: s }).positionAssignments?.map(({ drawPosition: u, participantId: l, bye: d, qualifier: p }) => ({ drawPosition: u, participantId: l, qualifier: p, bye: d }));
      a.push({ name: "initialMainAssignments", initialAssignments: c });
    }
  }
  let o = { value: a.concat(r), name: ms };
  Be({ element: i, extension: o });
}
function ec({ tournamentRecord: e, drawDefinition: t, event: r }) {
  let i = (e?.events || r && [r])?.map((s) => s?.drawDefinitions).flat().filter(Boolean) || t && [t] || [], n = {}, a = {}, o = i.map((s) => s?.structures?.filter((c) => c?.structures)).flat().filter(Boolean);
  for (let s of o) {
    let { structures: c, structureId: u } = s ?? {};
    c && u && (n[u] = c?.map((l) => l.structureId)) && c.forEach((l) => a[l.structureId] = s?.structureId);
  }
  return { containedStructures: n, containerStructures: a };
}
function pp(e) {
  let { sides: t, matchUpType: r } = e || {}, i = e.potentialParticipants?.length ? e.potentialParticipants.flat().map((a) => r === Ke ? a?.individualParticipantIds || [] : a.participantId).flat() : [], n = (t || []).map((a) => r === Ke && (a?.participant?.individualParticipantIds || []) || a?.participantId && [a.participantId] || []).flat();
  return { individualParticipantIds: n.concat(i).flat(), enteredIndividualParticipantIds: n, potentialIndividualParticipantIds: i };
}
function ui(e) {
  return e?.tournamentRecords ?? (e?.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord }) ?? {};
}
var Au = "SIGN_IN_STATUS", Sw = "SIGNED_OUT", Qc = "SIGNED_IN", Pr = "TEAM", Ne = "INDIVIDUAL", Xr = "GROUP", De = "PAIR", We = "TEAM", bc = { TEAM_PARTICIPANT: Pr, INDIVIDUAL: Ne, GROUP: Xr, TEAM: We, PAIR: De }, V1 = { INDIVIDUAL: Ne, GROUP: Xr, PAIR: De, TEAM: We, SIGN_IN_STATUS: Au, SIGNED_OUT: Sw, SIGNED_IN: Qc };
function mp({ participantsProfile: e, participants: t = [], deepCopy: r }) {
  let i = /* @__PURE__ */ new Map(), n = r !== !1 ? ie(t, e?.convertExtensions, !0) : t, a = n.filter((c) => c.participantType === We), o = n.filter((c) => c.participantType === Xr), s = n.filter((c) => c.participantType === De);
  return n.forEach((c) => {
    if (c.participantType === Ne) {
      let { participantId: u } = c;
      c.groupParticipantIds = [], c.teamParticipantIds = [], c.pairParticipantIds = [], c.groups = [], c.teams = [], a.forEach((l) => {
        (l?.individualParticipantIds || []).forEach((d) => {
          d === u && !c.teamParticipantIds?.includes(l.participantId) && (c.teamParticipantIds.push(l.participantId), i.get(l.participantId) || i.set(l.participantId, { participantName: l.participantName, participantId: l.participantId }), c.teams.push({ participantRoleResponsibilities: l.participantRoleResponsibilities, participantOtherName: l.participantOtherName, participantName: l.participantName, participantId: l.participantId, teamId: l.teamId }));
        });
      }), s.forEach((l) => {
        (l?.individualParticipantIds || []).forEach((d) => {
          d === u && !c.pairParticipantIds.includes(l.participantId) && c.pairParticipantIds.push(l.participantId);
        });
      }), o.forEach((l) => {
        (l?.individualParticipantIds || []).forEach((d) => {
          d === u && !c.groupParticipantIds.includes(l.participantId) && (c.groupParticipantIds.push(l.participantId), c.groups.push({ participantRoleResponsibilities: l.participantRoleResponsibilities, participantOtherName: l.participantOtherName, participantName: l.participantName, participantId: l.participantId }));
        });
      });
    }
  }), { participantsWithGroupings: n, groupInfo: Object.fromEntries(i) };
}
function yw(e) {
  return e && typeof String.fromCodePoint < "u" ? e.toUpperCase().replace(/./g, (t) => String.fromCodePoint(t.charCodeAt(0) + 127397)) : e;
}
function j1(e) {
  let t = Object.assign({}, ...ea.filter((r) => r.ioc).map((r) => ({ [r.ioc]: r.iso })));
  return yw(t[e]);
}
var ea = [{ ioc: "", iso2: "", iso: "", label: "NONE", phone: "" }, { ioc: "AND", iso2: "AD", iso: "AND", label: "Andorra", phone: "376" }, { ioc: "UAE", iso2: "AE", iso: "ARE", label: "United Arab Emirates", phone: "971" }, { ioc: "AFG", iso2: "AF", iso: "AFG", label: "Afghanistan", phone: "93" }, { ioc: "ANT", iso2: "AG", iso: "ATG", label: "Antigua and Barbuda", phone: "1-268" }, { ioc: "AIA", iso2: "AI", iso: "AIA", label: "Anguilla", phone: "1-264" }, { ioc: "ALB", iso2: "AL", iso: "ALB", label: "Albania", phone: "355" }, { ioc: "ARM", iso2: "AM", iso: "ARM", label: "Armenia", phone: "374" }, { ioc: "ANG", iso2: "AO", iso: "AGO", label: "Angola", phone: "244" }, { ioc: "", iso2: "AQ", iso: "ATA", label: "Antarctica", phone: "672" }, { ioc: "ARG", iso2: "AR", iso: "ARG", label: "Argentina", phone: "54" }, { ioc: "ASA", iso2: "AS", iso: "ASM", label: "American Samoa", phone: "1-684" }, { ioc: "AUT", iso2: "AT", iso: "AUT", label: "Austria", phone: "43" }, { ioc: "AUS", iso2: "AU", iso: "AUS", label: "Australia", phone: "61", suggested: !0 }, { ioc: "ARU", iso2: "AW", iso: "ABW", label: "Aruba", phone: "297" }, { ioc: "AZE", iso2: "AZ", iso: "AZE", label: "Azerbaijan", phone: "994" }, { ioc: "BIH", iso2: "BA", iso: "BIH", label: "Bosnia and Herzegovina", phone: "387" }, { ioc: "BAR", iso2: "BB", iso: "BRB", label: "Barbados", phone: "1-246" }, { ioc: "BAN", iso2: "BD", iso: "BGD", label: "Bangladesh", phone: "880" }, { ioc: "BEL", iso2: "BE", iso: "BEL", label: "Belgium", phone: "32" }, { ioc: "BUR", iso2: "BF", iso: "BFA", label: "Burkina Faso", phone: "226" }, { ioc: "BUL", iso2: "BG", iso: "BGR", label: "Bulgaria", phone: "359" }, { ioc: "BRN", iso2: "BH", iso: "BHR", label: "Bahrain", phone: "973" }, { ioc: "BDI", iso2: "BI", iso: "BDI", label: "Burundi", phone: "257" }, { ioc: "BEN", iso2: "BJ", iso: "BEN", label: "Benin", phone: "229" }, { ioc: "", iso2: "BL", iso: "BLM", label: "Saint Barthelemy", phone: "590" }, { ioc: "BER", iso2: "BM", iso: "BMU", label: "Bermuda", phone: "1-441" }, { ioc: "BRU", iso2: "BN", iso: "BRN", label: "Brunei Darussalam", phone: "673" }, { ioc: "BOL", iso2: "BO", iso: "BOL", label: "Bolivia", phone: "591" }, { ioc: "BRA", iso2: "BR", iso: "BRA", label: "Brazil", phone: "55" }, { ioc: "BAH", iso2: "BS", iso: "BHS", label: "Bahamas", phone: "1-242" }, { ioc: "BHU", iso2: "BT", iso: "BTN", label: "Bhutan", phone: "975" }, { ioc: "", iso2: "BV", iso: "BVT", label: "Bouvet Island", phone: "47" }, { ioc: "BOT", iso2: "BW", iso: "BWA", label: "Botswana", phone: "267" }, { ioc: "BLR", iso2: "BY", iso: "BLR", label: "Belarus", phone: "375" }, { ioc: "BIZ", iso2: "BZ", iso: "BLZ", label: "Belize", phone: "501" }, { ioc: "CAN", iso2: "CA", iso: "CAN", label: "Canada", phone: "1", suggested: !0 }, { ioc: "", iso2: "CC", iso: "CCK", label: "Cocos (Keeling) Islands", phone: "61" }, { ioc: "CGO", iso2: "CD", iso: "COG", label: "Congo, Republic of the", phone: "242" }, { ioc: "CAF", iso2: "CF", iso: "CAF", label: "Central African Republic", phone: "236" }, { ioc: "COD", iso2: "CG", iso: "CGD", label: "Congo, Democratic Republic of the", phone: "243" }, { ioc: "SUI", iso2: "CH", iso: "CHE", label: "Switzerland", phone: "41" }, { ioc: "CIV", iso2: "CI", iso: "CIV", label: "Cote d'Ivoire", phone: "225" }, { ioc: "COK", iso2: "CK", iso: "COK", label: "Cook Islands", phone: "682" }, { ioc: "CHI", iso2: "CL", iso: "CHL", label: "Chile", phone: "56" }, { ioc: "CMR", iso2: "CM", iso: "CMR", label: "Cameroon", phone: "237" }, { ioc: "CHN", iso2: "CN", iso: "CHN", label: "China", phone: "86" }, { ioc: "COL", iso2: "CO", iso: "COL", label: "Colombia", phone: "57" }, { ioc: "CRC", iso2: "CR", iso: "CRI", label: "Costa Rica", phone: "506" }, { ioc: "CUB", iso2: "CU", iso: "CUB", label: "Cuba", phone: "53" }, { ioc: "CPV", iso2: "CV", iso: "CPV", label: "Cape Verde", phone: "238" }, { ioc: "CUW", iso2: "CW", iso: "CUW", label: "Curacao", phone: "599" }, { ioc: "CXR", iso2: "CX", iso: "CXR", label: "Christmas Island", phone: "61" }, { ioc: "CYP", iso2: "CY", iso: "CYP", label: "Cyprus", phone: "357" }, { ioc: "CZE", iso2: "CZ", iso: "CZE", label: "Czech Republic", phone: "420" }, { ioc: "GER", iso2: "DE", iso: "DEU", label: "Germany", phone: "49", suggested: !0 }, { ioc: "DJI", iso2: "DJ", iso: "DJI", label: "Djibouti", phone: "253" }, { ioc: "DEN", iso2: "DK", iso: "DNK", label: "Denmark", phone: "45" }, { ioc: "DMA", iso2: "DM", iso: "DMA", label: "Dominica", phone: "1-767" }, { ioc: "DOM", iso2: "DO", iso: "DOM", label: "Dominican Republic", phone: "1-809" }, { ioc: "ALG", iso2: "DZ", iso: "DZA", label: "Algeria", phone: "213" }, { ioc: "ECU", iso2: "EC", iso: "ECU", label: "Ecuador", phone: "593" }, { ioc: "EST", iso2: "EE", iso: "ESE", label: "Estonia", phone: "372" }, { ioc: "EGY", iso2: "EG", iso: "EGY", label: "Egypt", phone: "20" }, { ioc: "", iso2: "EH", iso: "ESH", label: "Western Sahara", phone: "212" }, { ioc: "ERI", iso2: "ER", iso: "ERI", label: "Eritrea", phone: "291" }, { ioc: "ESP", iso2: "ES", iso: "ESP", label: "Spain", phone: "34" }, { ioc: "ETH", iso2: "ET", iso: "ETH", label: "Ethiopia", phone: "251" }, { ioc: "FIN", iso2: "FI", iso: "FIN", label: "Finland", phone: "358" }, { ioc: "FIJ", iso2: "FJ", iso: "FJI", label: "Fiji", phone: "679" }, { ioc: "FLK", iso2: "FK", iso: "FLK", label: "Falkland Islands (Malvinas)", phone: "500" }, { ioc: "FSM", iso2: "FM", iso: "FSM", label: "Micronesia, Federated States of", phone: "691" }, { ioc: "FAR", iso2: "FO", iso: "FRO", label: "Faroe Islands", phone: "298" }, { ioc: "FRA", iso2: "FR", iso: "FRA", label: "France", phone: "33", suggested: !0 }, { ioc: "GAB", iso2: "GA", iso: "GAB", label: "Gabon", phone: "241" }, { ioc: "GBR", iso2: "GB", iso: "GBR", label: "United Kingdom", phone: "44" }, { ioc: "GRN", iso2: "GD", iso: "GRD", label: "Grenada", phone: "1-473" }, { ioc: "GEO", iso2: "GE", iso: "GEO", label: "Georgia", phone: "995" }, { ioc: "FGU", iso2: "GF", iso: "GUF", label: "French Guiana", phone: "594" }, { ioc: "", iso2: "GG", iso: "GGY", label: "Guernsey", phone: "44" }, { ioc: "", iso2: "GH", iso: "GHA", label: "Ghana", phone: "233" }, { ioc: "GIB", iso2: "GI", iso: "GIB", label: "Gibraltar", phone: "350" }, { ioc: "GRL", iso2: "GL", iso: "GRL", label: "Greenland", phone: "299" }, { ioc: "GAM", iso2: "GM", iso: "GMB", label: "Gambia", phone: "220" }, { ioc: "GUI", iso2: "GN", iso: "GIN", label: "Guinea", phone: "224" }, { ioc: "GUD", iso2: "GP", iso: "GLP", label: "Guadeloupe", phone: "590" }, { ioc: "GEQ", iso2: "GQ", iso: "GNQ", label: "Equatorial Guinea", phone: "240" }, { ioc: "GRE", iso2: "GR", iso: "GRC", label: "Greece", phone: "30" }, { ioc: "", iso2: "GS", iso: "SGS", label: "South Georgia and the South Sandwich Islands", phone: "500" }, { ioc: "GUA", iso2: "GT", iso: "GTM", label: "Guatemala", phone: "502" }, { ioc: "GUM", iso2: "GU", iso: "GUM", label: "Guam", phone: "1-671" }, { ioc: "GBS", iso2: "GW", iso: "GNB", label: "Guinea-Bissau", phone: "245" }, { ioc: "GUY", iso2: "GY", iso: "GUY", label: "Guyana", phone: "592" }, { ioc: "HKG", iso2: "HK", iso: "HKG", label: "Hong Kong", phone: "852" }, { ioc: "", iso2: "HM", iso: "HMD", label: "Heard Island and McDonald Islands", phone: "672" }, { ioc: "HON", iso2: "HN", iso: "HND", label: "Honduras", phone: "504" }, { ioc: "CRO", iso2: "HR", iso: "HRV", label: "Croatia", phone: "385" }, { ioc: "HAI", iso2: "HT", iso: "HTI", label: "Haiti", phone: "509" }, { ioc: "HUN", iso2: "HU", iso: "HUN", label: "Hungary", phone: "36" }, { ioc: "INA", iso2: "ID", iso: "IDN", label: "Indonesia", phone: "62" }, { ioc: "IRL", iso2: "IE", iso: "IRL", label: "Ireland", phone: "353" }, { ioc: "ISR", iso2: "IL", iso: "ISR", label: "Israel", phone: "972" }, { ioc: "", iso2: "IM", iso: "IMN", label: "Isle of Man", phone: "44" }, { ioc: "IND", iso2: "IN", iso: "IND", label: "India", phone: "91" }, { ioc: "", iso2: "IO", iso: "IOT", label: "British Indian Ocean Territory", phone: "246" }, { ioc: "IRQ", iso2: "IQ", iso: "IRQ", label: "Iraq", phone: "964" }, { ioc: "IRI", iso2: "IR", iso: "IRN", label: "Iran, Islamic Republic of", phone: "98" }, { ioc: "ISL", iso2: "IS", iso: "ISL", label: "Iceland", phone: "354" }, { ioc: "ITA", iso2: "IT", iso: "ITA", label: "Italy", phone: "39" }, { ioc: "", iso2: "JE", iso: "JEY", label: "Jersey", phone: "44" }, { ioc: "JAM", iso2: "JM", iso: "JAM", label: "Jamaica", phone: "1-876" }, { ioc: "JOR", iso2: "JO", iso: "JOR", label: "Jordan", phone: "962" }, { ioc: "JPN", iso2: "JP", iso: "JPN", label: "Japan", phone: "81", suggested: !0 }, { ioc: "KEN", iso2: "KE", iso: "KEN", label: "Kenya", phone: "254" }, { ioc: "KGZ", iso2: "KG", iso: "KGZ", label: "Kyrgyzstan", phone: "996" }, { ioc: "CAM", iso2: "KH", iso: "KHM", label: "Cambodia", phone: "855" }, { ioc: "KIR", iso2: "KI", iso: "KIR", label: "Kiribati", phone: "686" }, { ioc: "COM", iso2: "KM", iso: "COM", label: "Comoros", phone: "269" }, { ioc: "SKN", iso2: "KN", iso: "KNA", label: "Saint Kitts and Nevis", phone: "1-869" }, { ioc: "KOR", iso2: "KP", iso: "KOR", label: "Korea, Democratic People's Republic of", phone: "850" }, { ioc: "PRK", iso2: "KR", iso: "PRK", label: "Korea, Republic of", phone: "82" }, { ioc: "KUW", iso2: "KW", iso: "KWT", label: "Kuwait", phone: "965" }, { ioc: "CAY", iso2: "KY", iso: "CYM", label: "Cayman Islands", phone: "1-345" }, { ioc: "KAZ", iso2: "KZ", iso: "KAZ", label: "Kazakhstan", phone: "7" }, { ioc: "LAO", iso2: "LA", iso: "LAO", label: "Lao People's Democratic Republic", phone: "856" }, { ioc: "LIB", iso2: "LB", iso: "LBN", label: "Lebanon", phone: "961" }, { ioc: "LCA", iso2: "LC", iso: "LCA", label: "Saint Lucia", phone: "1-758" }, { ioc: "LIE", iso2: "LI", iso: "LIE", label: "Liechtenstein", phone: "423" }, { ioc: "SRI", iso2: "LK", iso: "LKA", label: "Sri Lanka", phone: "94" }, { ioc: "LBR", iso2: "LR", iso: "LBR", label: "Liberia", phone: "231" }, { ioc: "LES", iso2: "LS", iso: "LSO", label: "Lesotho", phone: "266" }, { ioc: "LTU", iso2: "LT", iso: "LTU", label: "Lithuania", phone: "370" }, { ioc: "LUX", iso2: "LU", iso: "LUX", label: "Luxembourg", phone: "352" }, { ioc: "LAT", iso2: "LV", iso: "LVA", label: "Latvia", phone: "371" }, { ioc: "LBA", iso2: "LY", iso: "LBY", label: "Libya", phone: "218" }, { ioc: "MAR", iso2: "MA", iso: "MAR", label: "Morocco", phone: "212" }, { ioc: "MON", iso2: "MC", iso: "MCO", label: "Monaco", phone: "377" }, { ioc: "MDA", iso2: "MD", iso: "MDA", label: "Moldova, Republic of", phone: "373" }, { ioc: "MNE", iso2: "ME", iso: "MNE", label: "Montenegro", phone: "382" }, { ioc: "", iso2: "MF", iso: "MAF", label: "Saint Martin (French part)", phone: "590" }, { ioc: "MAD", iso2: "MG", iso: "MDG", label: "Madagascar", phone: "261" }, { ioc: "MSH", iso2: "MH", iso: "MHL", label: "Marshall Islands", phone: "692" }, { ioc: "MKD", iso2: "MK", iso: "MKD", label: "Macedonia, the Former Yugoslav Republic of", phone: "389" }, { ioc: "MLI", iso2: "ML", iso: "MLI", label: "Mali", phone: "223" }, { ioc: "MYA", iso2: "MM", iso: "MMR", label: "Myanmar", phone: "95" }, { ioc: "MGL", iso2: "MN", iso: "MNG", label: "Mongolia", phone: "976" }, { ioc: "MAC", iso2: "MO", iso: "MAC", label: "Macao", phone: "853" }, { ioc: "NMA", iso2: "MP", iso: "NMP", label: "Northern Mariana Islands", phone: "1-670" }, { ioc: "MRT", iso2: "MQ", iso: "MTQ", label: "Martinique", phone: "596" }, { ioc: "MTN", iso2: "MR", iso: "MRT", label: "Mauritania", phone: "222" }, { ioc: "MNT", iso2: "MS", iso: "MSR", label: "Montserrat", phone: "1-664" }, { ioc: "MLT", iso2: "MT", iso: "MLT", label: "Malta", phone: "356" }, { ioc: "MRI", iso2: "MU", iso: "MUS", label: "Mauritius", phone: "230" }, { ioc: "MDV", iso2: "MV", iso: "MDV", label: "Maldives", phone: "960" }, { ioc: "MAW", iso2: "MW", iso: "MWI", label: "Malawi", phone: "265" }, { ioc: "MEX", iso2: "MX", iso: "MEX", label: "Mexico", phone: "52" }, { ioc: "MAS", iso2: "MY", iso: "MYS", label: "Malaysia", phone: "60" }, { ioc: "MOZ", iso2: "MZ", iso: "MOZ", label: "Mozambique", phone: "258" }, { ioc: "NAM", iso2: "NA", iso: "NAM", label: "Namibia", phone: "264" }, { ioc: "NCL", iso2: "NC", iso: "NCL", label: "New Caledonia", phone: "687" }, { ioc: "NIG", iso2: "NE", iso: "NER", label: "Niger", phone: "227" }, { ioc: "NFI", iso2: "NF", iso: "NFK", label: "Norfolk Island", phone: "672" }, { ioc: "NGR", iso2: "NG", iso: "NGA", label: "Nigeria", phone: "234" }, { ioc: "NCA", iso2: "NI", iso: "NIC", label: "Nicaragua", phone: "505" }, { ioc: "NED", iso2: "NL", iso: "NLD", label: "Netherlands", phone: "31" }, { ioc: "NOR", iso2: "NO", iso: "NOR", label: "Norway", phone: "47" }, { ioc: "NEP", iso2: "NP", iso: "NPL", label: "Nepal", phone: "977" }, { ioc: "NRU", iso2: "NR", iso: "NRU", label: "Nauru", phone: "674" }, { ioc: "NIU", iso2: "NU", iso: "NIU", label: "Niue", phone: "683" }, { ioc: "NZL", iso2: "NZ", iso: "NZL", label: "New Zealand", phone: "64" }, { ioc: "OMA", iso2: "OM", iso: "OMN", label: "Oman", phone: "968" }, { ioc: "PAN", iso2: "PA", iso: "PAN", label: "Panama", phone: "507" }, { ioc: "PER", iso2: "PE", iso: "PER", label: "Peru", phone: "51" }, { ioc: "FPO", iso2: "PF", iso: "PYF", label: "French Polynesia", phone: "689" }, { ioc: "PNG", iso2: "PG", iso: "PNG", label: "Papua New Guinea", phone: "675" }, { ioc: "PHI", iso2: "PH", iso: "PHL", label: "Philippines", phone: "63" }, { ioc: "PAK", iso2: "PK", iso: "PAK", label: "Pakistan", phone: "92" }, { ioc: "POL", iso2: "PL", iso: "POL", label: "Poland", phone: "48" }, { ioc: "SPM", iso2: "PM", iso: "SPM", label: "Saint Pierre and Miquelon", phone: "508" }, { ioc: "", iso2: "PN", iso: "PCN", label: "Pitcairn", phone: "870" }, { ioc: "PUR", iso2: "PR", iso: "PRI", label: "Puerto Rico", phone: "1" }, { ioc: "PLE", iso2: "PS", iso: "PSE", label: "Palestine, State of", phone: "970" }, { ioc: "POR", iso2: "PT", iso: "PRT", label: "Portugal", phone: "351" }, { ioc: "PLW", iso2: "PW", iso: "PLW", label: "Palau", phone: "680" }, { ioc: "PAR", iso2: "PY", iso: "PRY", label: "Paraguay", phone: "595" }, { ioc: "QAT", iso2: "QA", iso: "QAT", label: "Qatar", phone: "974" }, { ioc: "REU", iso2: "RE", iso: "REU", label: "Reunion", phone: "262" }, { ioc: "ROU", iso2: "RO", iso: "ROU", label: "Romania", phone: "40" }, { ioc: "SRB", iso2: "RS", iso: "SRB", label: "Serbia", phone: "381" }, { ioc: "RUS", iso2: "RU", iso: "RUS", label: "Russia", phone: "7" }, { ioc: "RWA", iso2: "RW", iso: "RWA", label: "Rwanda", phone: "250" }, { ioc: "KSA", iso2: "SA", iso: "SAU", label: "Saudi Arabia", phone: "966" }, { ioc: "SOL", iso2: "SB", iso: "SLB", label: "Solomon Islands", phone: "677" }, { ioc: "SEY", iso2: "SC", iso: "SYC", label: "Seychelles", phone: "248" }, { ioc: "SUD", iso2: "SD", iso: "SDN", label: "Sudan", phone: "249" }, { ioc: "SWE", iso2: "SE", iso: "SWE", label: "Sweden", phone: "46" }, { ioc: "SIN", iso2: "SG", iso: "SGP", label: "Singapore", phone: "65" }, { ioc: "HEL", iso2: "SH", iso: "SHN", label: "Saint Helena", phone: "290" }, { ioc: "SLO", iso2: "SI", iso: "SVN", label: "Slovenia", phone: "386" }, { ioc: "", iso2: "SJ", iso: "SJM", label: "Svalbard and Jan Mayen", phone: "47" }, { ioc: "SVK", iso2: "SK", iso: "SVK", label: "Slovakia", phone: "421" }, { ioc: "SLE", iso2: "SL", iso: "SLE", label: "Sierra Leone", phone: "232" }, { ioc: "SMR", iso2: "SM", iso: "SMR", label: "San Marino", phone: "378" }, { ioc: "SEN", iso2: "SN", iso: "SEN", label: "Senegal", phone: "221" }, { ioc: "SOM", iso2: "SO", iso: "SOM", label: "Somalia", phone: "252" }, { ioc: "SUR", iso2: "SR", iso: "SUR", label: "Suriname", phone: "597" }, { ioc: "", iso2: "SS", iso: "SSD", label: "South Sudan", phone: "211" }, { ioc: "STP", iso2: "ST", iso: "STP", label: "Sao Tome and Principe", phone: "239" }, { ioc: "ESA", iso2: "SV", iso: "SLV", label: "El Salvador", phone: "503" }, { ioc: "", iso2: "SX", iso: "SMX", label: "Sint Maarten", phone: "1-721" }, { ioc: "SYR", iso2: "SY", iso: "SYR", label: "Syria", phone: "963" }, { ioc: "", iso2: "SZ", iso: "SWZ", label: "Swaziland", phone: "268" }, { ioc: "TKS", iso2: "TC", iso: "TCA", label: "Turks and Caicos Islands", phone: "1-649" }, { ioc: "CHA", iso2: "TD", iso: "TCD", label: "Chad", phone: "235" }, { ioc: "", iso2: "TF", iso: "ATF", label: "French Southern Territories", phone: "262" }, { ioc: "TOG", iso2: "TG", iso: "TGO", label: "Togo", phone: "228" }, { ioc: "THA", iso2: "TH", iso: "THA", label: "Thailand", phone: "66" }, { ioc: "TJK", iso2: "TJ", iso: "TJK", label: "Tajikistan", phone: "992" }, { ioc: "", iso2: "TK", iso: "TKL", label: "Tokelau", phone: "690" }, { ioc: "TLS", iso2: "TL", iso: "TLS", label: "Timor-Leste", phone: "670" }, { ioc: "TKM", iso2: "TM", iso: "TKM", label: "Turkmenistan", phone: "993" }, { ioc: "TUN", iso2: "TN", iso: "TUN", label: "Tunisia", phone: "216" }, { ioc: "TGA", iso2: "TO", iso: "TON", label: "Tonga", phone: "676" }, { ioc: "TUR", iso2: "TR", iso: "TUR", label: "Turkey", phone: "90" }, { ioc: "TTO", iso2: "TT", iso: "TTO", label: "Trinidad and Tobago", phone: "1-868" }, { ioc: "TUV", iso2: "TV", iso: "TUV", label: "Tuvalu", phone: "688" }, { ioc: "TPE", iso2: "TW", iso: "TWN", label: "Taiwan", phone: "886" }, { ioc: "TAN", iso2: "TZ", iso: "TZA", label: "United Republic of Tanzania", phone: "255" }, { ioc: "UKR", iso2: "UA", iso: "UKR", label: "Ukraine", phone: "380" }, { ioc: "UGA", iso2: "UG", iso: "UGA", label: "Uganda", phone: "256" }, { ioc: "USA", iso2: "US", label: "United States", phone: "1", suggested: !0, iso: "USA" }, { ioc: "URU", iso2: "UY", iso: "URY", label: "Uruguay", phone: "598" }, { ioc: "UZB", iso2: "UZ", iso: "UZB", label: "Uzbekistan", phone: "998" }, { ioc: "", iso2: "VA", iso: "VAT", label: "Holy See (Vatican City State)", phone: "379" }, { ioc: "VIN", iso2: "VC", iso: "VCT", label: "Saint Vincent and the Grenadines", phone: "1-784" }, { ioc: "VEN", iso2: "VE", iso: "VEN", label: "Venezuela", phone: "58" }, { ioc: "IVB", iso2: "VG", iso: "VGB", label: "British Virgin Islands", phone: "1-284" }, { ioc: "ISV", iso2: "VI", iso: "VIR", label: "US Virgin Islands", phone: "1-340" }, { ioc: "VIE", iso2: "VN", iso: "VNM", label: "Vietnam", phone: "84" }, { ioc: "VAN", iso2: "VU", iso: "VUT", label: "Vanuatu", phone: "678" }, { ioc: "WAF", iso2: "WF", iso: "WLF", label: "Wallis and Futuna", phone: "681" }, { ioc: "SAM", iso2: "WS", iso: "WSM", label: "Samoa", phone: "685" }, { ioc: "KOS", iso2: "XK", iso: "KOS", label: "Kosovo", phone: "383" }, { ioc: "YEM", iso2: "YE", iso: "YEM", label: "Yemen", phone: "967" }, { ioc: "MAY", iso2: "YT", iso: "MYT", label: "Mayotte", phone: "262" }, { ioc: "RSA", iso2: "ZA", iso: "ZAF", label: "South Africa", phone: "27" }, { ioc: "ZAM", iso2: "ZM", iso: "ZMB", label: "Zambia", phone: "260" }, { ioc: "ZIM", iso2: "ZW", iso: "ZWE", label: "Zimbabwe", phone: "263" }];
function vw({ participant: e, withISO2: t, withIOC: r }) {
  let { person: i, individualParticipants: n } = e, a = [i, n?.map(({ person: s }) => s)].flat().filter(Boolean);
  function o(s) {
    let { nationalityCode: c } = s || {};
    if (c) {
      let u = ea.find(({ iso: l }) => l === c);
      r && u?.ioc && !s.iocNationalityCode && (s.iocNationalityCode = u.ioc), t && u?.iso2 && !s.iso2NationalityCode && (s.iso2NationalityCode = u.iso2), u?.label && !s.countryName && (s.countryName = u.label);
    }
  }
  a.forEach(o);
}
function G1({ participantMap: e, template: t }) {
  let r = Object.values(e);
  for (let i of r) {
    let n = i.participant;
    if (n.individualParticipantIds?.length) {
      n.individualParticipants = [];
      for (let a of n.individualParticipantIds) {
        let o = e[a].participant;
        n.individualParticipants.push(t ? vo({ template: t, source: o }) : o);
      }
    }
  }
}
function ha(e) {
  let { tournamentRecord: t, participantId: r } = e, i = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  for (let n of Object.values(i)) {
    let a = n.participants?.find((o) => o.participantId === r);
    if (a) return { participant: a, tournamentId: n.tournamentId };
  }
  return { error: Tt };
}
function Pw(e) {
  let { tournamentRecord: t, participantId: r } = e;
  if (r) {
    let n = ha({ tournamentRecord: t, participantId: r });
    return n.participant ?? n;
  }
  return e.element || e.drawDefinition || e.event || e.tournamentRecord || { error: ue };
}
function li(e) {
  let { returnPreviousValues: t, itemSubTypes: r, itemType: i } = e, n = Pw(e);
  if (n.error) return n;
  if (r && !Array.isArray(r)) return { error: z, context: { itemSubTypes: r } };
  if (!Array.isArray(n.timeItems)) return { error: wh };
  let a = n.timeItems.filter((s) => s?.itemType === i).filter((s) => !r?.length || r.some((c) => s?.itemSubTypes?.includes(c))).sort((s, c) => {
    let u = new Date(s.createdAt || void 0).getTime(), l = new Date(c.createdAt || void 0).getTime();
    return u - l;
  }), o = ie(a.pop(), !1, !0);
  if (o) {
    let s = { timeItem: o, ...x };
    return t && Object.assign(s, { previousItems: a }), s;
  } else return { info: Kt };
}
function wg({ returnPreviousValues: e, drawDefinition: t, itemSubTypes: r, itemType: i }) {
  if (!t) return { error: Vi };
  if (!t.timeItems) return { info: Kt };
  let { timeItem: n, previousItems: a, info: o } = li({ element: t, returnPreviousValues: e, itemSubTypes: r, itemType: i });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function Cu({ returnPreviousValues: e, itemSubTypes: t, itemType: r, event: i }) {
  if (!i) return { error: st };
  if (!i.timeItems) return { info: Kt };
  let { timeItem: n, previousItems: a, info: o } = li({ returnPreviousValues: e, element: i, itemSubTypes: t, itemType: r });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function fp({ returnPreviousValues: e, tournamentRecord: t, itemSubTypes: r, itemType: i }) {
  if (!t) return { error: J };
  if (!t.timeItems) return { info: Kt };
  let { timeItem: n, previousItems: a, info: o } = li({ element: t, returnPreviousValues: e, itemSubTypes: r, itemType: i });
  return n && { timeItem: n, previousItems: a } || { info: o };
}
function Tg({ returnPreviousValues: e, tournamentRecord: t, participantId: r, itemSubTypes: i, itemType: n }) {
  if (!t) return { error: J };
  if (!r) return { error: Ft };
  let a = ha({ tournamentRecord: t, participantId: r });
  if (a.error) return a;
  let { participant: o } = a;
  if (!o?.timeItems) return { info: Kt };
  let { timeItem: s, previousItems: c, info: u } = li({ element: a.participant, returnPreviousValues: e, itemSubTypes: i, itemType: n });
  return s && { timeItem: s, previousItems: c } || { info: u };
}
var $1 = { [Xr]: "groupParticipantIds", [De]: "pairParticipantIds", [We]: "teamParticipantIds" }, q1 = { [Xr]: "groups", [We]: "teams" };
function Dw({ withIndividualParticipants: e, convertExtensions: t, tournamentRecord: r, withSignInStatus: i, withScaleValues: n, withGroupings: a, internalUse: o, withISO2: s, withIOC: c }) {
  let u = [], l = {};
  for (let p of r.participants ?? []) {
    let m = p?.participantId;
    m && z1({ participantMap: l, participantId: m });
  }
  for (let p of r.participants ?? []) {
    let m = ie(p, t, o), { participantId: f, individualParticipantIds: h, participantType: g } = m;
    if (!l[f]) {
      u.push(f);
      continue;
    }
    if (Object.assign(l[f].participant, m), h) {
      let I = H1({ individualParticipantIds: h, participantCopy: m, participantMap: l, participantType: g, participantId: f });
      I.missingParticipantIds.length && u.push(...I.missingParticipantIds);
    }
    if (i && (l[f].participant.signedIn = W1(m)), n) {
      let { ratings: I, rankings: U, seedings: S } = Qs({ participant: m });
      l[f].participant.seedings = S, l[f].participant.rankings = U, l[f].participant.ratings = I;
    }
    (c || s) && vw({ participant: l[f].participant, withISO2: s, withIOC: c });
  }
  if (e) {
    let p = xe(e) ? e : void 0;
    G1({ participantMap: l, template: p });
  }
  let d;
  return a && (d = mp({ participants: Object.values(l).map(({ participant: p }) => p), participantsProfile: { convertExtensions: t }, deepCopy: !1 }).groupInfo), { missingParticipantIds: u, participantMap: l, groupInfo: d };
}
function W1(e) {
  let { timeItem: t } = li({ itemType: Au, element: e });
  return t?.itemValue === Qc;
}
function H1({ individualParticipantIds: e, participantCopy: t, participantMap: r, participantType: i, participantId: n }) {
  let a = [];
  for (let o of e) {
    let s = r[o]?.participant;
    if (!s) {
      a.push(o);
      continue;
    }
    if (s[$1[i]].push(n), [We, Xr].includes(i)) {
      let { participantRoleResponsibilities: c, participantOtherName: u, participantName: l, participantId: d, teamId: p } = t, m = q1[i];
      s[m].push({ participantRoleResponsibilities: c, participantOtherName: u, participantName: l, participantId: d, teamId: p });
    }
    if (i === De) {
      let c = e.find((u) => u !== o);
      r[o].pairIdMap[n] = c, r[o].pairIdMap[c] = n;
    }
  }
  return { missingParticipantIds: a };
}
function z1({ participantMap: e, participantId: t }) {
  if (e[t]) return;
  let r = { walkoverWins: 0, defaultWins: 0, walkovers: 0, defaults: 0, losses: 0, wins: 0 };
  e[t] = { structureParticipation: {}, potentialMatchUps: {}, scheduleConflicts: {}, scheduleItems: [], participant: { groupParticipantIds: [], pairParticipantIds: [], teamParticipantIds: [], seedings: {}, rankings: {}, ratings: {}, groups: [], teams: [] }, statistics: {}, opponents: {}, pairIdMap: {}, matchUps: {}, events: {}, draws: {}, counters: { [Xe]: { ...r }, [Ke]: { ...r }, [We]: { ...r }, ...r } };
}
function Ka({ participantsProfile: e, useParticipantMap: t, tournamentRecord: r, contextProfile: i, inContext: n }) {
  if (t) return Dw({ ...e, ...i, tournamentRecord: r });
  let a = ie(r.participants, !1, !0) || [];
  (e?.withIOC || e?.withISO2) && a.forEach((s) => vw({ participant: s, ...e }));
  let o;
  if ((n || e?.withGroupings) && a?.length && ({ participantsWithGroupings: a, groupInfo: o } = mp({ participantsProfile: e, deepCopy: !1, participants: a })), e?.withScaleValues && a?.length) for (let s of a) {
    let { ratings: c, rankings: u } = Qs({ participant: s });
    s.rankings = u, s.ratings = c;
  }
  return { participants: a, groupInfo: o };
}
function _e({ onlySpecifiedPolicyTypes: e = !1, policyTypes: t = [], tournamentRecord: r, drawDefinition: i, structure: n, event: a }) {
  if (!Array.isArray(t)) return { error: ph };
  let o = {};
  return r && s(r), a && s(a), i && s(i), n && s(n), { appliedPolicies: o, ...x };
  function s(c) {
    let u = c?.extensions?.find((l) => l.name === Yc)?.value;
    if (u) for (let l of Object.keys(u)) (e ? t.includes(l) : !t.length || t.includes(l)) && (o[l] = ie(u[l], !1, !0));
  }
}
function Wn({ policyTypes: e = [], tournamentRecord: t, drawDefinition: r, structure: i, event: n }) {
  if (!Array.isArray(e)) return { error: ph };
  let { appliedPolicies: a } = _e({ tournamentRecord: t, drawDefinition: r, structure: i, event: n }), o = {};
  for (let s of e) {
    let c = a?.[s];
    c && (o[s] = c);
  }
  return Object.keys(o).length ? { policyDefinitions: o } : { info: hu.message };
}
var ww = "WALKOVER", HS = "RETIRED", bg = "COMPETITIVE", Xc = "ROUTINE", Jc = "DECISIVE", xl = "winRatio", Y1 = { [En]: { policyName: "Competitive Bands Default", profileBands: { [Jc]: 20, [Xc]: 50 } } }, Mg = Y1;
function Hn({ policyDefinitions: e, tournamentRecord: t, contextProfile: r, drawDefinition: i, event: n }) {
  let a = { policies: {} };
  if (!r) return a;
  let o = Wn({ tournamentRecord: t, drawDefinition: i, event: n }).policyDefinitions;
  if (r.withCompetitiveness) {
    let s = e?.[En] ?? o?.[En] ?? Mg[En];
    a.policies[En] = s;
  }
  return a;
}
function Qa({ tournamentRecord: e, drawDefinition: t, policyType: r, structure: i, event: n }) {
  if (!e) return { error: J };
  let { appliedPolicies: a } = _e({ tournamentRecord: e, drawDefinition: t, structure: i, event: n });
  return a?.[r] ? { policy: a[r] } : { info: hu?.message };
}
function Ou({ tournamentRecord: e, categoryName: t, categoryType: r, event: i }) {
  t = t ?? i?.category?.categoryName ?? i?.category?.ageCategoryCode, r = r ?? i?.category?.categoryType ?? i?.category?.subType;
  let { policy: n } = Qa({ policyType: pa, tournamentRecord: e, event: i }), a = (e ? we({ element: e, name: Ln }).extension : void 0)?.value, o = (i && we({ name: Ln, element: i }).extension)?.value;
  return { scheduleTiming: { tournamentScheduling: a, eventScheduling: o, categoryName: t, categoryType: r, policy: n } };
}
function Rg({ drawDefinition: e, attributes: t }) {
  let { extension: r } = we({ element: e, name: rd }), i = r?.value || {};
  return t.forEach((n) => {
    Object.keys(n).forEach((a) => {
      i[a] ? Object.assign(i[a], n[a]) : i[a] = n[a];
    });
  }), r = { name: rd, value: i }, ip({ drawDefinition: e, extension: r }), { entryProfile: i };
}
function ku({ drawDefinition: e }) {
  let { extension: t } = we({ element: e, name: rd });
  return { entryProfile: t?.value || {} };
}
var vi = "ALTERNATE", xu = "CONFIRMED", kr = "DIRECT_ACCEPTANCE", Fu = "FEED_IN", Lu = "JUNIOR_EXEMPT", Bn = "LUCKY_LOSER", _u = "ORGANISER_ACCEPTANCE", Bu = "QUALIFIER", K1 = "REGISTERED", Vu = "SPECIAL_EXEMPT", di = "UNGROUPED", Xa = "UNPAIRED", As = "WILDCARD", Pn = "WITHDRAWN", Fl = [xu, kr, Lu, _u, Vu], Tw = [Fu, Bn, Bu], Ja = [xu, kr, Fu, Lu, _u, Vu, As], Ni = [xu, kr, Lu, Bn, Bu, _u, Vu, As], bw = [vi, xu, kr, Fu, Lu, Bn, _u, Bu, K1, Vu, di, Xa, As, Pn], Q1 = { ALTERNATE: vi, CONFIRMED: xu, DIRECT_ACCEPTANCE: kr, DIRECT_ENTRY_STATUSES: Ja, DRAW_SPECIFIC_STATUSES: Tw, EQUIVALENT_ACCEPTANCE_STATUSES: Fl, FEED_IN: Fu, JUNIOR_EXEMPT: Lu, LUCKY_LOSER: Bn, ORGANISER_ACCEPTANCE: _u, QUALIFIER: Bu, SPECIAL_EXEMPT: Vu, STRUCTURE_SELECTED_STATUSES: Ni, UNGROUPED: di, UNPAIRED: Xa, VALID_ENTRY_STATUSES: bw, WILDCARD: As, WITHDRAWN: Pn };
function Ng({ stage: e, drawDefinition: t }) {
  let { entryProfile: r } = ku({ drawDefinition: t }), i = Object.keys(r).includes(e);
  if (!i && Hd.includes(e)) {
    let n = [{ [e]: { drawSize: void 0, alternates: !0 } }];
    return Rg({ drawDefinition: t, attributes: n }), !0;
  }
  return i;
}
function X1({ stage: e, drawDefinition: t }) {
  let { entryProfile: r } = ku({ drawDefinition: t });
  return r[e]?.alternates || 0;
}
function J1({ stage: e, drawDefinition: t }) {
  let { entryProfile: r } = ku({ drawDefinition: t });
  return r[e]?.wildcardsCount || 0;
}
function Pf({ stage: e, drawDefinition: t, entryStatus: r }) {
  return t.entries.reduce((i, n) => n.entryStage === e && n.entryStatus === r ? i + 1 : i, 0);
}
function Bo({ provisionalPositioning: e, placementGroup: t, drawDefinition: r, stageSequence: i, entryStatuses: n, structureId: a, roundTarget: o, stages: s, stage: c }) {
  let u = r.entries?.reduce((l, d) => {
    let p = we({ name: rn, element: d })?.extension?.value, m = c && d.entryStage === c || s?.length && d.entryStage && s.includes(d.entryStage), f = !n || d.entryStatus && n.includes(d.entryStatus), h = d.entryStageSequence ?? 1;
    return m && (!i || h === i) && f && (!o || !p || o === p) ? l.concat(d) : l;
  }, []) ?? [];
  if (a && c === yt) {
    let { playoffEntries: l, error: d } = Z1({ provisionalPositioning: e, drawDefinition: r, structureId: a });
    return d && console.log("playoff entries error"), (l?.length ? l : u).filter((p) => !t || p.placementGroup === t);
  }
  return u;
}
function Z1({ provisionalPositioning: e, drawDefinition: t, structureId: r }) {
  let i = [], n = (t.links ?? []).find((a) => a.linkType === gn && a.target.structureId === r);
  if (n) {
    let { finishingPositions: a, structureId: o } = n.source, { structure: s } = me({ drawDefinition: t, structureId: o });
    s?.structureType === yr && (s.structures ?? []).forEach((c) => {
      let u = c.positionAssignments ?? [], { structureId: l } = c, d = l, p = Object.assign({}, ...u.map((h) => {
        let { participantId: g } = h, I = we({ element: h, name: _n }).extension?.value;
        return I && g ? { [g]: I } : void 0;
      }).filter(Boolean)), m = Object.keys(p).reduce((h, g) => {
        let I = p[g], U = I.groupOrder || e && I.provisionalOrder;
        return h.includes(U) || h.push(U), h;
      }, []).length === Object.keys(p).length, f = Object.keys(p).filter((h) => {
        let g = p[h], I = g.groupOrder || e && g.provisionalOrder;
        return a?.includes(I);
      });
      (!e || m) && f.forEach((h) => {
        let g = p[h], { groupOrder: I, provisionalOrder: U, GEMscore: S } = g, P = I || e && U, v = [...a ?? []].sort(Ot).indexOf(P) + 1;
        i.push({ entryStage: yt, entryStatus: Fu, placementGroup: v, groupingValue: d, participantId: h, GEMscore: S });
      });
    });
  }
  return { playoffEntries: i };
}
function eO({ stage: e, drawDefinition: t }) {
  return Ja.reduce((r, i) => (Pf({ drawDefinition: t, entryStatus: i, stage: e }) || 0) + r, 0);
}
function si({ provisionalPositioning: e, returnAllProxies: t, drawDefinition: r, structureId: i, structure: n }) {
  let a, o = [];
  n || ({ structure: n, error: a } = me({ drawDefinition: r, structureId: i }));
  let s = Je({ structure: n }).positionAssignments;
  if (a || !n) return { seedAssignments: [], error: mt };
  i || (i = n.structureId);
  let { stage: c, stageSequence: u } = n, l = c === yt && r && Bo({ provisionalPositioning: e, drawDefinition: r, stageSequence: u, structureId: i, stage: c }), d = l ? l.filter((f) => f.placementGroup === 1).sort((f, h) => f.GEMscore < h.GEMscore && 1 || f.GEMscore > h.GEMscore && -1 || 0).map((f, h) => {
    let g = h + 1;
    return { participantId: f.participantId, seedValue: g, seedProxy: !0, seedNumber: g };
  }) : [], p = d?.slice(0, t ? d.length : s.length / 2);
  p.length ? o = p : n.seedAssignments ? o = n.seedAssignments : a = Rv;
  let m = n.seedLimit ?? n?.positionAssignments?.length;
  return { seedAssignments: o, stageSequence: u, seedLimit: m, stage: c, error: a };
}
function Gi(e) {
  if (!e) return;
  let { tieFormatId: t, tieFormats: r } = e;
  if (e.tieFormat) return e.tieFormat;
  if (t && Array.isArray(r)) return r.find((i) => i.tieFormatId === t);
}
function Mc({ item: e, drawDefinition: t, structure: r, event: i }) {
  if (e) {
    if (e.tieFormat) return e.tieFormat;
    if (e.tieFormatId)
      return t.tieFormat ? t.tieFormat : t.tieFormats?.find((a) => e.tieFormatId === a.tieFormatId) || (i.tieFormat ? i.tieFormat : i.tieFormats?.find((a) => e.tieFormatId === a.tieFormatId));
    if (r.tieFormat) return r.tieFormat;
    if (r.tieFormatId) {
      let n = t.tieFormats?.find((a) => r.tieFormatId === a.tieFormatId);
      if (n) return n;
    }
  }
}
function dr({ drawDefinition: e, structure: t, matchUp: r, event: i }) {
  return { tieFormat: Mc({ item: r, drawDefinition: e, structure: t, event: i }) || Mc({ item: t, drawDefinition: e, structure: t, event: i }) || Gi(e) || Gi(i) };
}
function tO({ matchUps: e }) {
  let t = e.reduce((r, i) => !i.collectionPosition || r.includes(i.collectionPosition) ? r : r.concat(i.collectionPosition), []).map((r) => ({ [r]: e.filter((i) => i.collectionPosition === r) }));
  return { collectionPositionMatchUps: Object.assign({}, ...t) };
}
function or({ drawDefinition: e, structure: t }) {
  let r = {}, i = [];
  return (e?.structures ?? [t]).filter((n) => n && typeof n == "object").forEach((n) => {
    if (!n) return;
    let { structureId: a, matchUps: o, structures: s } = n, c = Array.isArray(s);
    if (c) c && s.forEach((u) => {
      let { structureName: l } = u, d = u.matchUps;
      r[u.structureId] = { matchUps: d, itemStructureIds: [], structureName: l }, d && (i.push(...d), d.forEach((p) => {
        p.tieMatchUps && i.push(...p.tieMatchUps);
      })), r[a] || (r[a] = { itemStructureIds: [], matchUps: [] }), r[a].itemStructureIds || (r[a].itemStructureIds = []), r[a].itemStructureIds.push(u.structureId);
    });
    else {
      let u = o;
      r[a] = { matchUps: u, itemStructureIds: [] }, u?.forEach((l) => {
        i.push(l), l.tieMatchUps && i.push(...l.tieMatchUps);
      });
    }
  }), { mappedMatchUps: r, drawMatchUps: i };
}
function ka({ mappedMatchUps: e, matchUpsMap: t, structureId: r, inContext: i }) {
  e = t?.mappedMatchUps ?? e;
  let n = e[r], a = (n?.itemStructureIds || []).map((o) => {
    let { matchUps: s, structureName: c } = e[o];
    return i ? s.map((u) => Object.assign(ie(u, !0, !0), { containerStructureId: r, structureId: o, structureName: c })) : s;
  }).flat();
  return (n?.matchUps || []).concat(...a);
}
function Mw({ groupedOrder: e, roundPositionsCount: t }) {
  if (!e || e?.length <= t) return e;
  let r = qt(e, e.length / t).map((n) => n.reduce((a, o) => a + o)), i = r.slice().sort(Ot);
  return r.map((n) => i.indexOf(n) + 1);
}
function hp(e) {
  if (!xe(e)) return !1;
  let { matchUpId: t, drawPositions: r } = e, i = typeof t == "string", n = !r || Array.isArray(r) && r.length <= 2 && r.every((a) => Ie(a) || a === void 0 || a === null);
  return i && n;
}
function pi(e) {
  return Array.isArray(e) ? e.every(hp) : !1;
}
function Ir({ matchUps: e = [], interpolate: t }) {
  if (!pi(e)) return { roundMatchUps: [], error: z };
  let r = e.reduce((d, p) => {
    let m = typeof p.roundNumber == "string" ? pe(p.roundNumber) : p.roundNumber;
    return !p.roundNumber || d.includes(m) ? d : d.concat(m);
  }, []).sort(Ot).map((d) => {
    let p = e.filter((h) => h.roundNumber === d), m = p.find(({ matchUpType: h }) => h === ot) ? p.filter(({ matchUpType: h }) => h === ot) : p, f = (h) => h.sort((g, I) => Ot(g.roundPosition, I.roundPosition));
    return { [d]: f(m) };
  }), i = e.reduce((d, p) => {
    let m = typeof p.roundNumber == "string" ? pe(p.roundNumber) : p.roundNumber;
    return d[m] || (d[m] = ae({ abbreviatedRoundName: p.abbreviatedRoundName, finishingRound: p.finishingRound, roundName: p.roundName })), d;
  }, {}), n = Object.assign({}, ...r);
  if (t) {
    let d = Math.max(...Object.keys(n).map((m) => pe(m)).filter((m) => !isNaN(m))), p = n[d]?.length;
    if (p > 1 && Fi(p)) {
      let m = d + 1, f = m + p / 2;
      te(m, f).forEach((h, g) => {
        n[h] = te(0, p / (2 + g * 2)).map(() => ({}));
      });
    }
  }
  let a = 0, o = Object.assign({}, ...Object.keys(n).map((d) => {
    let p = n[d]?.length, m = n[d]?.filter((h) => !Lt.includes(h.matchUpStatus) && !h.score?.scoreStringSide1)?.length, f = p && p === m;
    return a = Math.max(a, p), { [d]: { matchUpsCount: p, inactiveCount: m, inactiveRound: f } };
  })), s = 0, c = 0, u = Object.keys(n).map((d) => pe(d)).filter((d) => !isNaN(d));
  u.forEach((d) => {
    let p = n[d].sort((f, h) => f.roundPosition - h.roundPosition), m = p.map((f) => f?.drawPositions || []).flat();
    if (o[d].roundNumber = d, o[d].roundFactor = o[d].matchUpsCount ? a / o[d].matchUpsCount : 1, o[d].finishingRound = i[d]?.finishingRound, o[d].roundName = i[d]?.roundName, o[d].abbreviatedRoundName = i[d]?.abbreviatedRoundName, o[d].finishingPositionRange = n[d]?.[0]?.finishingPositionRange, d === 1 || !o[d - 1]) {
      let f = m.sort(Ot), h = qt(f, 2);
      o[d].drawPositions = f, o[d].pairedDrawPositions = h;
    } else {
      let f = o[d - 1], h = f.drawPositions, g = f.matchUpsCount / o[d].matchUpsCount, I = qt(h, g), U = p.map((S) => {
        let { roundPosition: P } = S, v = [...S.drawPositions || [], void 0, void 0].slice(0, 2);
        if (!P) return v;
        let D = v?.filter(Boolean) || [];
        if (!D?.length) return [void 0, void 0];
        if (d < 3 && D?.length === 2) return v?.slice().sort(Ot);
        let y = Pt(h, D).length !== D?.length;
        if (D?.length && y) return D?.length === 1 ? [D[0], void 0] : v?.slice().sort(Ot);
        let w = (P - 1) * 2;
        return I.slice(w, w + 2).map((b) => D?.find((T) => b.includes(T)));
      });
      o[d].drawPositions = U?.flat(), o[d].pairedDrawPositions = U;
    }
    o[d + 1] && o[d + 1].matchUpsCount === o[d].matchUpsCount && (o[d + 1].feedRound = !0, o[d + 1].feedRoundIndex = c, o[d].preFeedRound = !0, c += 1), o[d] && !o[d].feedRound && (o[d].roundIndex = s, s += 1);
  });
  let l = !!Object.values(o).find(({ matchUpsCount: d }) => !Fi(d));
  return { hasNoRoundPositions: e.some((d) => !d.roundPosition), roundsNotPowerOf2: l, maxMatchUpsCount: a, roundMatchUps: n, roundNumbers: u, roundProfile: o, ...x };
}
function Ll(e) {
  if (!Array.isArray(e)) return "";
  let t = e.filter(gt);
  return t.length ? Ue([Math.min(...t), Math.max(...t)]).join("-") : "";
}
function rO({ drawDefinition: e, structureId: t, matchUpsMap: r }) {
  if (!e) return { error: ne };
  if (!t) return { error: Qr };
  let { structure: i } = me({ drawDefinition: e, structureId: t });
  if (i?.stage !== nr) return { error: Wa, info: "Structure is not CONSOLATION stage" };
  let { links: n } = e, a = n?.filter((d) => d.target.structureId === t) || [], o = a?.reduce((d, p) => {
    let { structureId: m } = p.source;
    return d.includes(m) ? d : d.concat(m);
  }, []) || [], s = Object.assign({}, ...o.map((d) => {
    let p = ka({ structureId: d, matchUpsMap: r }), m = Ir({ matchUps: p }).roundProfile;
    return { [d]: m };
  })), c = ka({ matchUpsMap: r, structureId: t }), { roundProfile: u } = Ir({ matchUps: c }), l = {};
  return a?.forEach((d) => {
    let { structureId: p, roundNumber: m } = d.source, { feedProfile: f, groupedOrder: h, positionInterleave: g, roundNumber: I } = d.target, U = s[p], S = U[1]?.drawPositions, P = U[m]?.matchUpsCount;
    if (!P) return;
    let v = P ? S.length / P : 0, D = S.length / v, y = S.slice(), w = Mw({ roundPositionsCount: D, groupedOrder: h }), b = w?.length || 1;
    if (b <= D) {
      let M = S.length / b, E = qt(y, M);
      f === Ea && E.forEach((A) => A.reverse()), y = w?.length && w?.map((A) => E[A - 1]).flat() || E.flat();
    }
    let T = qt(y, v);
    if (g) {
      let M = te(0, g.interleave).map(() => {
      }), E = te(0, g.offset).map(() => {
      });
      T = T.map((N) => [N, ...M]), T.unshift(E), T = T.flat(1);
      let A = T.length - g.offset;
      T = T.slice(0, A);
    }
    l[I] || (l[I] = {});
    let R = u?.[I]?.feedRound ? 2 : 1;
    T.forEach((M, E) => {
      let A = 1 + E * R;
      l[I][A] || (l[I][A] = Ll(M));
    });
  }), { sourceDrawPositionRanges: l };
}
function Rw({ drawDefinition: e }) {
  if (typeof e != "object") return { error: co };
  let t = {}, { structures: r = [], links: i = [] } = e || {}, n = r.reduce((o, s) => {
    let { stage: c } = s;
    return o[c] ? o[c].push(s) : o[c] = [s], o;
  }, {});
  for (let o of Object.keys(n)) {
    let s = n[o].find(({ stageSequence: u }) => u === 1);
    if (!s) continue;
    let { structureId: c } = s;
    a({ aggregator: {}, targetRound: 0, exitProfiles: t, exitProfile: "0", structureId: c, stage: o });
  }
  return { exitProfiles: t };
  function a({ exitProfiles: o, exitProfile: s, structureId: c, targetRound: u, aggregator: l, stage: d }) {
    o[c] || (o[c] = []), s === "0" && [nr, yt].includes(d) || o[c].push(s);
    let p = i.filter((m) => m.source.structureId === c && m.source.roundNumber >= u);
    for (let m of p) {
      let f = m.source.roundNumber, h = m.target.roundNumber, g = m.target.structureId, I = r.find((S) => S.structureId === g).stage, U = [I, g, h, f].join("|");
      if (l[U]) return;
      l[U] = !0, a({ exitProfile: `${s}-${f}`, structureId: g, exitProfiles: o, targetRound: h, aggregator: l, stage: I });
    }
  }
}
function iO({ drawDefinition: e, roundProfile: t, structureId: r, matchUpsMap: i }) {
  if (!e) return { error: ne };
  if (!r) return { error: Qr };
  if (!t) {
    let o = ka({ matchUpsMap: i, structureId: r });
    if ({ roundProfile: t } = Ir({ matchUps: o }), !t) return { error: ue };
  }
  let n = (Math.min(...t?.[1]?.drawPositions ?? []) || 1) - 1, a = Object.keys(t);
  return { drawPositionsRanges: Object.assign({}, ...(a || []).map((o) => {
    let s = t?.[o]?.matchUpsCount, c = t?.[1]?.drawPositions ?? [], u = qt(c, c.length / s), l = u.map(Ll), d = u.map((g) => g.map((I) => I - n)).map(Ll), p = a.map((g) => {
      if (g > o) return;
      let I = t?.[g]?.drawPositions ?? [];
      return qt(I, I.length / s);
    }).filter(Boolean), m = te(0, s).map((g) => p.map((I) => I[g]).flat().filter(Boolean).sort(Ot)).map((g) => Ue(g)), f = m.map((g) => PC(g).map(Ll).join(", ")), h = Object.assign({}, ...te(0, s).map((g) => ({ [g + 1]: { firstRoundDrawPositionsRange: l[g], firstRoundOffsetDrawPositionsRange: d[g], possibleDrawPositions: m[g], drawPositionsRange: f[g] } })));
    return { [o]: h };
  })) };
}
function Eg({ roundsNotPowerOf2: e, drawDefinition: t, structure: r, matchUps: i }) {
  if (!r) return !1;
  i = i ?? r.matchUps ?? [], e = e ?? Ir({ matchUps: i }).roundsNotPowerOf2;
  let n = !!r.positionAssignments?.find(({ drawPosition: a }) => a) || !!i?.find(({ drawPositions: a }) => a?.length);
  return (!t?.drawType || t.drawType !== Ha) && !r?.structures && e && n;
}
function Tr({ structure: e }) {
  if (!e) return !1;
  let t = e.matchUps || e.roundMatchUps && Object.values(e.roundMatchUps).flat(), r = !!t?.find((n) => n?.roundPosition), i = !!t?.find((n) => n?.drawPositions?.length);
  return !e?.structures && e?.stage !== zt && (!t.length || !r && !i);
}
var Ag = { [Rs]: { policyName: "Round Naming Default", namingConventions: { round: "Round", pre: "Pre" }, qualifyingFinishMap: { 1: "Final" }, abbreviatedRoundNamingMap: { 1: "F", 2: "SF", 4: "QF" }, roundNamingMap: { 1: "Final", 2: "Semifinal", 4: "Quarterfinal" }, affixes: { roundNumber: "R", preFeedRound: "Q", preQualifying: "P" }, stageConstants: { [re]: "", [yt]: "P", [se]: "Q", [nr]: "C" } } }, nO = Ag;
function aO({ roundNamingPolicy: e, drawDefinition: t, structure: r, matchUps: i }) {
  let { roundProfile: n, roundMatchUps: a } = Ir({ matchUps: i }), { structureAbbreviation: o, stage: s } = r, c = Tr({ structure: r }), u = Eg({ structure: r }), l = r.structures, d = {}, p = Ag[Rs], m = r.stage === se, f = m ? Math.max(...(t?.structures ?? []).filter((M) => M.stage === se).map(({ stageSequence: M }) => M ?? 1), 0) : 0, h = (r.stageSequence ?? 1) < f ? r.stageSequence ?? 1 : "", g = h && (e?.affixes?.preQualifying || p.affixes.preQualifying) || "", I = e?.roundNamingMap || p.roundNamingMap || {}, U = e?.abbreviatedRoundNamingMap || p.abbreviatedRoundNamingMap || {}, S = e?.affixes?.preFeedRound || p.affixes.preFeedRound, P = e?.affixes?.roundNumber || p.affixes.roundNumber, v = (e?.namingConventions || p.namingConventions).round, D = s && s !== re ? s[0] : "", y = e?.stageConstants || p.stageConstants, w = s && y?.[s] || D, b = `${g}${w}${h}`, T = n ? Object.keys(n) : [], R = m && y?.[se] ? `${y?.[se]}-` : "";
  if (l || c || u) Object.assign(d, ...T.map((M) => {
    let E = `${R}${v} ${M}`, A = `${P}${M}`;
    return { [M]: { roundName: E, abbreviatedRoundName: A } };
  }));
  else {
    let M = m && (e?.qualifyingFinishMap || p?.qualifyingFinishMap || {});
    Object.assign(d, ...T.map((E) => {
      if (!n?.[E]) return;
      let { matchUpsCount: A, preFeedRound: N } = n[E], C = A * 2, k = M?.[n?.[E].finishingRound] || M && `${P}${C}` || I[A] || `${P}${C}`, O = N ? `-${S}` : "", _ = `${k}${O}`, B = [b, o, _].filter(Boolean).join("-"), L = `${U[A] || `${P}${C}`}${O}`, j = [b, o, L].filter(Boolean).join("-");
      return { [E]: { abbreviatedRoundName: j, roundName: B } };
    }));
  }
  return { roundNamingProfile: d, roundProfile: n, roundMatchUps: a };
}
var oO = (e, t) => (e || 0) + (t || 0);
function Nw(e, t) {
  let r = Array.isArray(e) ? e[0] : e;
  return isNaN(r) && ww || r <= t[Jc] && Jc || r <= t[Xc] && Xc || bg;
}
function Ew({ score: e }) {
  let t = e?.sets || [], r = t.reduce((n, a) => (n[0] += a.side1Score || 0, n[1] += a.side2Score || 0, n), [0, 0]), i = t.reduce((n, a) => (n[0] += a.side1TiebreakScore || 0, n[1] += a.side2TiebreakScore || 0, n), [0, 0]);
  return i.reduce(oO) && (r[i[0] > i[1] ? 0 : 1] += 1), { sets: t, games: r, score: e };
}
function sO(e) {
  let t = Math.min(...e.games), r = Math.max(...e.games);
  return Math.round(t / r * 100);
}
function Aw(e) {
  return e.map(sO).sort().map((t) => parseFloat(t.toFixed(2)));
}
function ju({ tournamentRecord: e, profileBands: t, matchUp: r }) {
  if (!r) return { error: Dr };
  let { score: i, winningSide: n } = r;
  if (!n) return { error: z };
  let a = !t && e && Qa({ policyType: En, tournamentRecord: e }).policy, o = t || a?.profileBands || Mg[En].profileBands, s = Ew({ score: i }), c = Aw([s]), u = Nw(c, o), l = Array.isArray(c) ? c[0] : c;
  return { ...x, competitiveness: u, pctSpread: l };
}
function Cw({ matchUp: e }) {
  if (!e) return { error: Dr };
  if (e && !e.sides) return { error: Cr };
  if (e && !e.hasContext) return { error: Fd };
  let t = (e.sides ?? [])?.map((o) => o?.participantId).filter(Boolean), r = e.sides?.filter((o) => o.participant?.participantType === Ne).map((o) => o.participantId).filter(Boolean) ?? [], i = ((e.sides ?? [])?.map((o) => o.participant?.individualParticipants).filter(Boolean) ?? []).map((o) => (o ?? []).map((s) => s?.participantId).filter(Boolean)), n = [...r, ...i.flat()].filter(Boolean) ?? [], a = Ue(n.concat(t)).filter(Boolean) ?? [];
  return { nestedIndividualParticipantIds: i, allRelevantParticipantIds: a, individualParticipantIds: n, sideParticipantIds: t, ...x };
}
var nd = "CHECK_IN", ad = "CHECK_OUT", cO = "SCHEDULE", Vo = "SCHEDULE.ASSIGNMENT.VENUE", Dn = "SCHEDULE.ALLOCATION.COURTS", ca = "SCHEDULE.ASSIGNMENT.COURT", gp = "SCHEDULE.COURT.ORDER", jo = "SCHEDULE.DATE", uO = "COMPLETED.DATE", Cg = "HOME_PARTICIPANT_ID", Og = "SCHEDULE.ASSIGN.OFFICIAL", Go = "SCHEDULE.TIME.SCHEDULED", Ci = "SCHEDULE.TIME.START", On = "SCHEDULE.TIME.STOP", ln = "SCHEDULE.TIME.RESUME", Vn = "SCHEDULE.TIME.END", Ip = "SCHEDULE.TIME.MODIFIERS", Ow = "TO_BE_ANNOUNCED", kw = "NEXT_AVAILABLE", xw = "FOLLOWED_BY", Fw = "AFTER_REST", Lw = "RAIN_DELAY", lO = "NOT_BEFORE", Df = [Ow, kw, xw, Fw, Lw], dO = "ELIGIBILITY", pO = "REGISTRATION", mO = "SUSPENSION", fO = "MEDICAL", hO = "PENALTY", _w = "SCALE", Bw = "RATING", Vw = "RANKING", kg = "SEEDING", ga = "PUBLISH", Jr = "PUBLIC", Ia = "STATUS", gO = "MODIFICATION", IO = "RETRIEVAL", UO = "other", SO = { MUTUALLY_EXCLUSIVE_TIME_MODIFIERS: Df, AFTER_REST: Fw, ALLOCATE_COURTS: Dn, ASSIGN_COURT: ca, ASSIGN_OFFICIAL: Og, ASSIGN_VENUE: Vo, CHECK_IN: nd, CHECK_OUT: ad, COMPLETED_DATE: uO, COURT_ORDER: gp, ELIGIBILITY: dO, END_TIME: Vn, FOLLOWED_BY: xw, MEDICAL: fO, MODIFICATION: gO, NEXT_AVAILABLE: kw, NOT_BEFORE: lO, OTHER: UO, PENALTY: hO, PUBLIC: Jr, PUBLISH: ga, RANKING: Vw, RATING: Bw, RAIN_DELAY: Lw, REGISTRATION: pO, RESUME_TIME: ln, RETRIEVAL: IO, SCALE: _w, SCHEDULE: cO, SCHEDULED_DATE: jo, SCHEDULED_TIME: Go, SEEDING: kg, START_TIME: Ci, STATUS: Ia, STOP_TIME: On, SUSPENSION: mO, TIME_MODIFIERS: Ip, TO_BE_ANNOUNCED: Ow };
function $o({ matchUp: e }) {
  if (!e) return { error: Dr };
  if (!e.hasContext) return { error: Fd };
  if (!e.sides || e.sides.filter(Boolean).length !== 2) return { error: Cr };
  let { nestedIndividualParticipantIds: t, allRelevantParticipantIds: r, sideParticipantIds: i } = Cw({ matchUp: e }), n = (e.timeItems ?? []).filter((s) => s?.itemType && [nd, ad].includes(s.itemType)).sort((s, c) => (s.createdAt ? new Date(s.createdAt).getTime() : 0) - (c.createdAt ? new Date(c.createdAt).getTime() : 0)), a = n.map((s) => s.itemValue).filter((s) => n.filter((c) => c?.itemValue === s).reverse()[0].itemType === nd);
  t?.forEach((s, c) => {
    let u = i?.[c], l = s?.length && s.every((d) => a.includes(d));
    u && l && !a.includes(u) && a.push(u);
  }), i?.forEach((s, c) => {
    a.includes(s) && (t?.[c] ?? []).forEach((u) => {
      u && !a.includes(u) && a.push(u);
    });
  });
  let o = i?.reduce((s, c) => a.includes(c) && s, !0);
  return { allRelevantParticipantIds: r, allParticipantsCheckedIn: o, checkedInParticipantIds: a, ...x };
}
var bt = (e) => (t) => {
  let r = xe(t) && t?.matchUpType || dt(t) && t;
  return r && sv[e].includes(r);
};
function Rc(e) {
  let { matchUpAverageTimes: t, matchUpFormat: r } = e || {}, i = t?.map(({ matchUpFormatCodes: a }) => a?.filter((o) => o === r)).flat().filter(Boolean).sort((a, o) => (a?.length || 0) - (o?.length || 0)) || [], n = i.includes(r) ? r : i[0];
  return t?.find(({ matchUpFormatCodes: a, averageTimes: o }) => a?.find((s) => n === s) && o)?.averageTimes;
}
function Nc(e) {
  let { matchUpRecoveryTimes: t, averageMinutes: r, matchUpFormat: i } = e || {};
  return t?.find(({ matchUpFormatCodes: n, averageTimes: a, recoveryTimes: o }) => {
    if (a && r) {
      let { greaterThan: s = 0, lessThan: c = 360 } = a;
      if (r > s && r < c) return !0;
    }
    return n?.find((s) => s === i) && o;
  })?.recoveryTimes;
}
function jw({ timesBlockArray: e, categoryName: t, categoryType: r }) {
  return e.filter((i) => Array.isArray(i)).map((i) => i.sort((n, a) => (a.categoryNames?.length || 0) - (n.categoryNames?.length || 0)).find(({ categoryTypes: n, categoryNames: a }) => !a?.length && !n?.length || a?.includes(t) || n?.includes(r))).find(Boolean);
}
function yO({ tournamentScheduling: e, eventScheduling: t, averageMinutes: r, defaultTiming: i, matchUpFormat: n, categoryName: a, categoryType: o, policy: s }) {
  let c = t?.matchUpRecoveryTimes && Nc({ ...t, averageMinutes: r, matchUpFormat: n }), u = e?.matchUpRecoveryTimes && Nc({ ...e, averageMinutes: r, matchUpFormat: n }), l = s?.matchUpRecoveryTimes && Nc({ ...s, averageMinutes: r, matchUpFormat: n }), d = [c, u, l, s?.defaultTimes?.recoveryTimes, i?.recoveryTimes];
  return jw({ categoryName: a, categoryType: o, timesBlockArray: d });
}
function vO({ matchUpFormat: e, categoryName: t, categoryType: r, defaultTiming: i, tournamentScheduling: n, eventScheduling: a, policy: o }) {
  let s = a?.matchUpAverageTimes && Rc({ ...a, matchUpFormat: e }), c = n?.matchUpAverageTimes && Rc({ ...n, matchUpFormat: e }), u = o?.matchUpAverageTimes && Rc({ ...o, matchUpFormat: e }), l = [s, c, u, o?.defaultTimes?.averageTimes, i?.averageTimes];
  return jw({ categoryName: t, categoryType: r, timesBlockArray: l });
}
var Gw = "DOUBLES_SINGLES", $w = "SINGLES_DOUBLES", Pi = "total", wf = "participantConflict", Qn = "matchUpConflict", qw = "ISSUE_IDS", ya = "CONFLICT", va = "WARNING", Tf = "ERROR", bf = "ISSUE", _l = "STATE", PO = { SINGLES_DOUBLES: $w, DOUBLES_SINGLES: Gw, TOTAL: Pi, CONFLICT_MATCHUP_ORDER: Qn, CONFLICT_PARTICIPANTS: wf, SCHEDULE_ISSUE_IDS: qw, SCHEDULE_CONFLICT: ya, SCHEDULE_WARNING: va, SCHEDULE_ERROR: Tf, SCHEDULE_ISSUE: bf, SCHEDULE_STATE: _l };
function Gu({ defaultAverageMinutes: e = 90, defaultRecoveryMinutes: t = 0, tournamentRecord: r, matchUpFormat: i, categoryName: n, categoryType: a, eventType: o, event: s }) {
  if (!r) return { error: J };
  o = o ?? s?.eventType ?? So;
  let c = { averageTimes: [{ minutes: { default: e } }], recoveryTimes: [{ minutes: { default: t } }] }, { scheduleTiming: u } = Ou({ tournamentRecord: r, categoryName: n, categoryType: a, event: s }), l = { ...u, matchUpFormat: i, categoryType: a, defaultTiming: c };
  return Up({ eventType: o, timingDetails: l });
}
function Up({ timingDetails: e, eventType: t }) {
  let r = vO(e), i = Object.keys(r?.minutes || {}), n = r?.minutes && (i?.includes(t) && r.minutes[t] || r.minutes.default), a = yO({ ...e, averageMinutes: n }), o = Object.keys(a?.minutes || {}), s = a?.minutes && (o?.includes(t) && a.minutes[t] || a.minutes.default), c = bt(So)(t) ? $w : Gw, u = a?.minutes && (o?.includes(c) && a.minutes[c] || s);
  return { averageMinutes: n, recoveryMinutes: s, typeChangeRecoveryMinutes: u };
}
function Om(e) {
  return e.createdAt ? new Date(e.createdAt).getTime() : 0;
}
function Za({ timeItems: e, itemType: t }) {
  let r = e.filter((n) => n && n.itemType === t).sort((n, a) => Om(n) - Om(a)).pop(), i = r && Om(r);
  return { itemValue: r?.itemValue, timeStamp: i };
}
function Ww({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = Za({ timeItems: r?.timeItems || [], itemType: Go });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { scheduledTime: i } : t;
}
function qo({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = Za({ timeItems: r?.timeItems || [], itemType: jo });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { scheduledDate: i } : t;
}
function no(e) {
  if (GP.test(e)) {
    let t = Fh();
    return /* @__PURE__ */ new Date(`${t}T${e}`);
  } else return new Date(e);
}
function DO({ matchUp: e }) {
  if (!e) return { error: Dr };
  if (!e.timeItems) return { error: wh };
  let t = e.timeItems.filter((i) => [Ci, On, ln, Vn].includes(i?.itemType)).sort((i, n) => no(i.itemValue).getTime() - no(n.itemValue).getTime()), r = t.reduce((i, n) => {
    let a, o = n?.itemType?.split("."), s = `SCHEDULE.TIME.${n?.itemType?.startsWith("SCHEDULE.TIME") && o[2]}`;
    switch (s) {
      case Ci:
        a = 0;
        break;
      case Vn:
        if (i.lastValue && [Ci, ln].includes(i.lastType)) {
          let c = no(n.itemValue).getTime() - no(i.lastValue).getTime();
          a = i.milliseconds + c;
        } else a = i.milliseconds;
        break;
      case On:
        if ([Ci, "SCHECULE.TIME.RESUME"].includes(i.lastType)) {
          let c = no(n.itemValue).getTime() - no(i.lastValue).getTime();
          a = i.milliseconds + c;
        } else a = i.milliseconds;
        break;
      default:
        a = i.milliseconds;
        break;
    }
    return { milliseconds: a, lastType: s, lastValue: n.itemValue };
  }, { milliseconds: 0, lastType: void 0, lastValue: void 0 });
  if ([Ci, ln].includes(r.lastType)) {
    let i = (/* @__PURE__ */ new Date()).getTime() - no(r.lastValue).getTime();
    r.milliseconds += i;
  }
  return { milliseconds: r.milliseconds, time: wO(r.milliseconds), relevantTimeItems: t };
}
function wO(e) {
  let t = (r, i = 2) => ("00" + r).slice(-i);
  return t(e / 36e5 | 0) + ":" + t(e % 36e5 / 6e4 | 0) + ":" + t(e % 6e4 / 1e3 | 0);
}
function TO({ matchUp: e }) {
  let t = e?.timeItems || [], r = (i) => i.createdAt ? new Date(i.createdAt).getTime() : 0;
  return { startTime: t.reduce((i, n) => {
    let a = n.itemType === Ci && n;
    return a && (!i || r(a) < r(i)) ? a : i;
  }, void 0)?.itemValue };
}
function $u(e) {
  let { disableNotice: t, venue: r, context: i } = e;
  if (typeof r != "object") return { error: z };
  let n = ui(e);
  r.venueId || (r.venueId = je());
  let a;
  for (let o of Object.values(n)) {
    let s = bO({ disableNotice: !0, tournamentRecord: o, context: i, venue: r });
    if (s?.error) return s;
    a = s.venue;
  }
  return t || Se({ topic: dw, payload: { venue: r } }), ae({ ...x, venue: a });
}
function bO({ tournamentRecord: e, disableNotice: t, context: r, venue: i }) {
  return e ? i ? (e.venues || (e.venues = []), i.venueId || (i.venueId = je()), e.venues.reduce((n, a) => n || a.venueId === i.venueId, void 0) ? { error: lP } : (r && Be({ element: i, extension: { value: r, name: YD } }), e.venues.push(i), { ...x, venue: ie(i) })) : { error: ue, info: "missing venue" } : { error: J };
}
function Mn({ tournamentRecords: e, tournamentRecord: t, venueId: r }) {
  if (!t) return { error: J };
  if (!r) return { error: da };
  let i = (t.venues ?? []).reduce((n, a) => a.venueId === r ? a : n, void 0);
  if (!i && e) {
    let n = (Nu({ tournamentRecords: e }).linkedTournamentIds ?? [])[t.tournamentId];
    for (let a of n) {
      let o = e[a], s = Mn({ tournamentRecord: o, venueId: r });
      if (s.success && s.venue) return $u({ tournamentRecord: t, venue: s.venue }), { ...x, venue: i };
    }
  }
  return i ? { ...x, venue: i } : { error: Co };
}
function xg({ convertExtensions: e, ...t }) {
  let { tournamentRecords: r, tournamentRecord: i, venueId: n } = t, a = Mn({ tournamentRecords: r, tournamentRecord: i, venueId: n });
  return ie(a, e, !0);
}
function Wo({ tournamentRecords: e, tournamentRecord: t, courtId: r }) {
  if (!t) return { error: J };
  if (!r) return { error: No };
  let i = "findCourt", n, a;
  if ((t.venues ?? []).forEach((o) => {
    (o.courts ?? []).forEach((s) => {
      s.courtId === r && (n = s, a = o);
    });
  }), n) return { ...x, court: n, venue: a };
  if (e) {
    let o = (Nu({ tournamentRecords: e }).linkedTournamentIds ?? [])[t.tournamentId];
    for (let s of o) {
      let c = e[s], u = Wo({ tournamentRecord: c, courtId: r });
      if (u.success) return u.venue && $u({ tournamentRecord: t, venue: u.venue }), { ...x, court: n, venue: a };
    }
  }
  return F({ result: { error: Ws }, stack: i });
}
function Fg(e) {
  return ie(Wo(e), !1, !0);
}
function Sp({ tournamentRecord: e, internalUse: t, courtId: r }) {
  if (!e) return { error: J };
  if (!r) return { error: No };
  let i = Wo({ tournamentRecord: e, courtId: r });
  if (i.error) return i;
  let n = i.court && (({ altitude: a, courtId: o, courtName: s, courtDimensions: c, latitude: u, longitude: l, surfaceCategory: d, surfaceType: p, surfacedDate: m, pace: f, notes: h }) => ({ altitude: a, courtId: o, courtName: s, courtDimensions: c, latitude: u, longitude: l, surfaceCategory: d, surfaceType: p, surfacedDate: m, pace: f, notes: h }))(i.court);
  return { ...x, courtInfo: ie(n, !1, t) };
}
function Cs(e) {
  let t = oe(e, [{ [Vt]: !0 }, { venueId: !0, [yi]: da }]);
  if (t.error) return t;
  let { tournamentRecord: r, venueId: i } = e, n = Mn({ tournamentRecord: r, venueId: i });
  if (n.error) return n;
  let a = (n.venue?.courts ?? []).map((c) => (({ courtInfo: u }) => ({ ...u }))(Sp({ courtId: c.courtId, internalUse: !0, tournamentRecord: r }))), o = n.venue && (({ venueId: c, venueName: u, venueAbbreviation: l }) => ({ venueAbbreviation: l, venueName: u, venueId: c }))(n.venue), s = o && { ...o, courtsInfo: a };
  return { ...x, venueData: ie(s, !1, !0) };
}
function MO({ matchUp: e }) {
  let t = e?.timeItems || [], r = (i) => i.createdAt ? new Date(i.createdAt).getTime() : 0;
  return { endTime: t.reduce((i, n) => {
    let a = n.itemType === Vn && n;
    return a && (!i || r(a) > r(i)) ? a : i;
  }, void 0)?.itemValue };
}
function wt({ event: e, eventId: t }) {
  if (!e) return { error: st };
  let r = we({ name: wi, element: e })?.extension, i = t ? ie(r?.value, !1, !0) : r?.value;
  return t && e.drawDefinitions?.forEach((n) => {
    i?.flights?.forEach((a) => {
      a.drawId === n.drawId && Object.assign(a, { drawDefinition: n });
    });
  }), { flightProfile: i };
}
function br(e) {
  let { tournamentRecord: t, eventId: r, drawId: i } = e, n = "findEvent", a = {}, o = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, s = Object.values(o).map(({ events: u, tournamentId: l }) => (u && u.forEach((d) => {
    a[d.eventId] = { tournamentId: l };
  }), u ?? [])).flat(), c;
  if (i) {
    let u, l = s.find((d) => {
      let p = (d?.drawDefinitions ?? []).find((m) => m.drawId === i);
      if (p) u = p, c = a[d.eventId].tournamentId;
      else {
        let m = (d && wt({ event: d })?.flightProfile)?.flights?.find((f) => f.drawId === i);
        if (m) return c = a[d.eventId].tournamentId, { entries: m.drawEntries, drawName: m.drawName, tournamentId: c, drawId: i };
      }
      return p;
    });
    if (l) return { event: l, drawDefinition: u, tournamentId: c };
  }
  if (r) {
    let u = s.find((l) => l?.eventId === r);
    if (u) c = a[u.eventId].tournamentId;
    else return { event: void 0, drawDefinition: void 0, ...F({ result: { error: ni }, stack: n }) };
    return { event: u, drawDefinition: void 0, tournamentId: c };
  }
  return { event: void 0, drawDefinition: void 0, ...F({ result: { error: zr }, context: { drawId: i, eventId: r }, stack: n }) };
}
function yp(e) {
  let t = e.event, r = e.matchUpType, { scheduleVisibilityFilters: i, afterRecoveryTimes: n, tournamentRecord: a, usePublishState: o, scheduleTiming: s, matchUpFormat: c, publishStatus: u, matchUp: l } = e;
  if (!l) return { error: Dr };
  if (n && !l.matchUpType && !e.matchUpType && (t || a) && l.drawId) {
    let v = e.drawDefinition || t?.drawDefinitions?.find((y) => y.drawId === l.drawId);
    !v && a && ({ drawDefinition: v, event: t } = br({ drawId: l.drawId, tournamentRecord: a }));
    let D = l.structureId && v?.structures?.find(({ structureId: y }) => y === l.structureId);
    r = e.matchUpType || D?.matchUpType || v?.matchUpType || t?.eventType !== kt && t?.eventType;
  }
  let { milliseconds: d, time: p } = DO({ matchUp: l }), { startTime: m } = TO({ matchUp: l }), { endTime: f } = MO({ matchUp: l }), h, { eventIds: g, drawIds: I } = i ?? {};
  if ((!g || g.includes(l.eventId)) && (!I || I.includes(l.drawId))) {
    let v = (K) => K.createdAt ? new Date(K.createdAt).getTime() : 0, D = /* @__PURE__ */ new Map(), y = l.timeItems?.toSorted((K, Q) => v(K) - v(Q)) ?? [];
    for (let K of y) D.set(K.itemType, K.itemValue);
    let w = D.get(Cg), b = D.get(Dn), T = D.get(Go), R = D.get(Ip), M = D.get(jo), E = D.get(Og), A = D.get(gp), N = D.get(Vo), C = D.get(ca), k, O, _, B, L, j = l.matchUpType ?? r;
    if (s && T && n && j) {
      let K = { matchUpFormat: l.matchUpFormat ?? c, ...s };
      ({ averageMinutes: O = 0, recoveryMinutes: _ = 0, typeChangeRecoveryMinutes: B = 0 } = Up({ timingDetails: K, eventType: j })), (O || _) && (k = f ? Er(ct(f), _) : Er(T, O + _)), B && (L = f ? Er(ct(f), B) : Er(T, O + B));
    }
    !M && T && (M = ve(T));
    let H = Kl({ scheduledDate: M, scheduledTime: T }), G = {}, V = (a && N && Cs({ tournamentRecord: a, venueId: N }))?.venueData || {};
    N && (G[N] = V);
    let { venueName: $, venueAbbreviation: q, courtsInfo: Y } = V, W = (C && Y?.find((K) => K.courtId === C))?.courtName;
    for (let K of b || []) {
      if (!a) break;
      K.venueId && !G[K.venueid] && (G[K.venueId] = Cs({ venueId: K.venueId, tournamentRecord: a })?.venueData);
      let Q = G[K.venueId];
      K.venueName = Q?.venueName;
      let X = Q?.courtsInfo?.find((ee) => ee.courtId === K.courtId);
      K.courtName = X?.courtName;
    }
    h = ae({ typeChangeTimeAfterRecovery: L, timeAfterRecovery: k, scheduledDate: M, scheduledTime: T, isoDateString: H, homeParticipantId: w, venueAbbreviation: q, allocatedCourts: b, timeModifiers: R, venueName: $, venueId: N, courtOrder: A, courtName: W, courtId: C, official: E, typeChangeRecoveryMinutes: B, recoveryMinutes: _, averageMinutes: O, milliseconds: d, startTime: m, endTime: f, time: p });
  } else h = ae({ milliseconds: d, startTime: m, endTime: f, time: p });
  let { scheduledDate: U } = qo({ matchUp: l }), { scheduledTime: S } = Ww({ matchUp: l });
  if (o && u?.displaySettings?.draws) {
    let v = u.displaySettings.draws, D = (v?.[l.drawId] ?? v?.default)?.scheduleDetails;
    if (D) {
      let y = (D.find((w) => U && w.dates?.includes(U)) ?? D.find((w) => !w.dates?.length))?.attributes;
      if (y) {
        let w = Object.assign({}, ...Object.keys(h).map((b) => ({ [b]: !0 })), y);
        h = vo({ source: h, template: w });
      }
    }
  }
  let P = l.matchUpStatus && Lt.includes(l.matchUpStatus) && (ve(f) || ve(U) || ve(S)) || void 0;
  return { schedule: h, endDate: P };
}
function RO({ drawPositions: e, roundProfile: t, roundNumber: r }) {
  let i = [void 0, void 0];
  if (fv(e)) return { orderedDrawPositions: i, displayOrder: i };
  let n = t?.[r], a = n?.pairedDrawPositions?.find((s) => gr(s || [], e.filter(Boolean))) ?? i, o = n?.feedRound;
  if (mv(e)) {
    let s = [...e].sort(Ot);
    return { orderedDrawPositions: s.length === 2 ? s : a, displayOrder: o ? s : a };
  }
  if (o) {
    let s = [e.find((c) => !isNaN(pe(c))), void 0];
    return { orderedDrawPositions: s, displayOrder: s };
  }
  return { orderedDrawPositions: a, displayOrder: a };
}
function od({ collectionPosition: e, collectionId: t, lineUp: r }) {
  let i = [], n = [];
  if (r) {
    let a = (s) => s === void 0 ? -1 : s, o = r.map((s) => {
      let { collectionAssignments: c, participantId: u } = s, l = c?.find((d) => d.collectionPosition === e && d.collectionId === t);
      return l && { participantId: u, ...l };
    }).filter(Boolean).sort((s, c) => a(s.substitutionOrder) - a(c.substitutionOrder));
    for (let s of o) {
      let { participantId: c, previousParticipantId: u, substitutionOrder: l } = s;
      i.includes(c) || (u && n.push({ previousParticipantId: u, substitutionOrder: l, participantId: c }), i = i.filter((d) => d !== u), i.push(c));
    }
  }
  return { assignedParticipantIds: i, substitutions: n };
}
function bi({ tournamentParticipants: e, tournamentRecord: t, participantIds: r }) {
  let i = "getPairedParticipant";
  if (!e && !t) return { error: J };
  if (!Array.isArray(r) || r.length > 2) return { error: _r };
  if (!r.length) return F({ result: { error: la }, stack: i });
  e = e ?? t?.participants ?? [];
  let n = e.filter((s) => s.participantType === De && Pt(r, s.individualParticipantIds).length === r.length && s.individualParticipantIds.length === r.length), a = n[0];
  if (!a) return F({ result: { error: Tt }, stack: i });
  let o = ie(n.slice(1), !1, !0);
  return { participant: ie(a), duplicatedPairParticipants: o, ...x };
}
function xa({ drawDefinition: e, participantId: t }) {
  if (typeof e != "object") return { error: ne };
  if (typeof t != "string") return { error: Ft };
  let { extension: r } = we({ element: e, name: Fn });
  return { lineUp: (r?.value || {})[t] };
}
function NO({ tournamentParticipants: e, positionAssignments: t, collectionPosition: r, drawPositions: i = [], participantMap: n, drawDefinition: a, collectionId: o, sideLineUps: s, matchUpType: c }) {
  if (!o || !r) return {};
  let u = ({ attribute: d, lineUp: p, teamParticipant: m }) => {
    let { assignedParticipantIds: f, substitutions: h } = od({ collectionPosition: r, collectionId: o, lineUp: p });
    if (c === Ke) {
      if (f?.length <= 2) {
        let g = n?.[f[0]]?.pairIdMap?.[f[1]], I = (g && n[g]?.participant || bi({ participantIds: f, tournamentParticipants: e }).participant)?.participantId;
        return { [d]: { participantId: I, teamParticipant: m, substitutions: h } };
      } else if (f?.length > 2) return { [d]: { teamParticipant: m, substitutions: h } };
    } else {
      let g = f?.[0];
      return g && { [d]: { participantId: g, teamParticipant: m, substitutions: h } };
    }
  };
  if (!i?.length) {
    let d = s?.map((p) => {
      let { teamParticipant: m, sideNumber: f } = p, h = p.lineUp || xa({ participantId: m.teamParticipantId, drawDefinition: a })?.lineUp;
      return u({ attribute: f, lineUp: h, teamParticipant: m });
    }).filter(Boolean) || {};
    return { sideNumberCollectionAssignment: Object.assign({}, ...d) };
  }
  let l = i?.map((d) => {
    let p = t.find((g) => g.drawPosition === d)?.participantId, m = s?.find((g) => g?.drawPosition === d), f = m?.teamParticipant || p && n?.[p]?.participant || e?.find(({ participantId: g }) => g === p), h = m?.lineUp || xa({ participantId: p, drawDefinition: a })?.lineUp;
    return u({ attribute: d, lineUp: h, teamParticipant: f });
  }).filter(Boolean) || {};
  return { drawPositionCollectionAssignment: Object.assign({}, ...l) };
}
function vp(e) {
  let t = oe(e, [{ [Tn]: !0 }]);
  if (t.error) return t;
  let r = e?.matchUp, i = r?.matchUpType;
  if (!i && r?.sides?.length) {
    let n = r.sides.find(({ participant: a }) => a)?.participant?.participantType;
    i = n === Ne && Xe || n === De && Ke || n === We && We || void 0;
  }
  return { matchUpType: i };
}
function EO({ drawPositionCollectionAssignment: e, sideNumberCollectionAssignment: t, positionAssignments: r, displaySideNumber: i, seedAssignments: n, drawPosition: a, isFeedRound: o, sideNumber: s }) {
  let c = r.find((m) => m.drawPosition && m.drawPosition === a), u = a && e, l = s && t, d = u ? u[a]?.participantId : c?.participantId, p = c ? AO({ displaySideNumber: i, seedAssignments: n, participantId: d, assignment: c, sideNumber: s }) : { ...l?.[s] };
  if (o && (s === 1 ? Object.assign(p, { participantFed: !0 }) : Object.assign(p, { participantAdvanced: !0 })), a && u) {
    let m = u[a]?.teamParticipant, f = u[a]?.participant, h = u[a]?.substitutions;
    f && (p.participant = f), h && (p.substitutions = h), m && (p.teamParticipant = m);
  }
  return p;
}
function AO({ displaySideNumber: e, seedAssignments: t, participantId: r, assignment: i, sideNumber: n }) {
  let a = { drawPosition: i.drawPosition, displaySideNumber: e, sideNumber: n };
  if (r) {
    let o = CO({ seedAssignments: t, participantId: r });
    Object.assign(a, o, { participantId: r }), o?.seedNumber && o?.seedValue === "" && (a.seedValue = "~");
  } else i.bye && Object.assign(a, { bye: !0 });
  return i.qualifier && Object.assign(a, { qualifier: !0 }), a;
}
function CO({ seedAssignments: e, participantId: t }) {
  return e?.find((r) => !r.seedProxy && r.participantId === t);
}
function Hw({ scheduleVisibilityFilters: e, sourceDrawPositionRanges: t, tournamentParticipants: r, positionAssignments: i, drawPositionsRanges: n, hydrateParticipants: a, afterRecoveryTimes: o, initialRoundOfPlay: s, additionalContext: c, roundNamingProfile: u, tournamentRecord: l, tieDrawPositions: d, appliedPolicies: p, isCollectionBye: m, seedAssignments: f, usePublishState: h, participantMap: g, contextContent: I, scheduleTiming: U, contextProfile: S, drawDefinition: P, publishStatus: v, scoringActive: D, matchUpTieId: y, isRoundRobin: w, roundProfile: b, sideLineUps: T, structure: R, context: M, matchUp: E, event: A }) {
  c = c ?? {};
  let N = dr({ drawDefinition: P, structure: R, matchUp: E, event: A })?.tieFormat, { roundOffset: C, structureId: k, structureName: O, stage: _, stageSequence: B } = R, { drawId: L, drawName: j, drawType: H } = P ?? {}, G = N?.collectionDefinitions, V = E.collectionId && G?.find((ye) => ye.collectionId === E.collectionId), $ = E.collectionId ? V?.matchUpFormat : E.matchUpFormat ?? R?.matchUpFormat ?? P?.matchUpFormat ?? A?.matchUpFormat, q = E.matchUpType || V?.matchUpType || R?.matchUpType || P?.matchUpType || !bt(kt)(A?.eventType) && A?.eventType, Y = m ? "BYE" : E.matchUpStatus, { schedule: W, endDate: K } = yp({ scheduleVisibilityFilters: e, afterRecoveryTimes: o, tournamentRecord: l, usePublishState: h, scheduleTiming: U, drawDefinition: P, matchUpFormat: $, publishStatus: v, matchUpType: q, matchUp: E, event: A }), Q = d ?? E.drawPositions ?? [], { collectionPosition: X, collectionId: ee, roundPosition: Z } = E, ce = E.roundNumber ?? c.roundNumber, fe = ee ? NO({ tournamentParticipants: r, positionAssignments: i, collectionPosition: X, participantMap: g, drawDefinition: P, drawPositions: Q, collectionId: ee, sideLineUps: T, matchUpType: q }) : void 0, He = u?.[ce]?.roundName || c.roundName, Te = u?.[ce]?.abbreviatedRoundName || c.abbreviatedRoundName, $e = b?.[ce]?.feedRound, it = b?.[ce]?.preFeedRound, It = b?.[ce]?.roundFactor, Rt = n?.[ce], de = Z ? Rt?.[Z] : void 0, lt = t?.[ce], le = V?.category ? { ...M?.category || {}, ...V.category } : M?.category ?? A?.category, ze = E.processCodes?.length && E.processCodes || V?.processCodes?.length && V?.processCodes || R?.processCodes?.length && R?.processCodes || P?.processCodes?.length && P?.processCodes || A?.processCodes?.length && A?.processCodes || l?.processCodes, Ae = S?.withCompetitiveness && ju({ ...I, matchUp: E }), nt = E.finishingPositionRange ?? c.finishingPositionRange, Ee = _ !== se && Ie(s) && s + (ce || 0), rt = (ye) => ae(ye, void 0, !0), ge = { ...rt(M), ...rt({ matchUpFormat: q === kt ? void 0 : $, tieFormat: q !== kt ? void 0 : N, gender: V?.gender ?? A?.gender, endDate: E.endDate ?? K, discipline: A?.discipline, category: le, finishingPositionRange: nt, abbreviatedRoundName: Te, drawPositionsRange: de, competitiveProfile: Ae, structureName: O, stageSequence: B, drawPositions: Q, matchUpStatus: Y, processCodes: ze, isRoundRobin: w, matchUpTieId: y, preFeedRound: it, matchUpType: q, roundFactor: It, roundOffset: C, structureId: k, roundNumber: ce, roundOfPlay: Ee, feedRound: $e, roundName: He, drawName: j, drawType: H, schedule: W, drawId: L, stage: _ }), ...ie(rt(E), !0, !0) };
  if ($ && E.score?.scoreStringSide1) {
    let ye = Sr($), { bestOf: Qe, finalSetFormat: Ce, setFormat: Fe } = ye ?? {};
    (Ce?.tiebreakSet || Fe?.tiebreakSet || Fe?.timed) && (ge.score.sets = ge.score.sets.sort((ke, Wt) => ke.setNumber - Wt.setNumber).map((ke, Wt) => (Wt + 1 === Qe ? (Ce?.tiebreakSet || Ce?.timed) && (ke.tiebreakSet = !0) : (Fe?.tiebreakSet || Fe?.timed) && (ke.tiebreakSet = !0), ke)));
  }
  if (Array.isArray(Q)) {
    let { orderedDrawPositions: ye, displayOrder: Qe } = RO({ drawPositions: Q, roundProfile: b, roundNumber: ce }), Ce = b?.[ce]?.feedRound, Fe = Qe[0] !== ye[0], ke = ye.concat(void 0, void 0).slice(0, 2).map((Wt, Ut) => {
      let St = Ut + 1, qe = Fe ? 3 - St : St, jt = EO({ ...fe, positionAssignments: i, displaySideNumber: qe, seedAssignments: f, drawPosition: Wt, isFeedRound: Ce, sideNumber: St }), ji = E.sides?.find((on) => on.sideNumber === St), Zt = Z ? (Z - 1) * 2 + Ut + 1 : void 0, Ai = Zt ? lt?.[Zt] : void 0;
      return rt({ sourceDrawPositionRange: Ai, ...ji, ...jt });
    });
    Object.assign(ge, ie({ sides: ke }, !0, !0));
  }
  if (r && ge.sides) {
    let ye = p?.[Xs], Qe = (Ce) => {
      let Fe = g?.[Ce]?.participant;
      return Fe && vo({ template: ye?.participant, source: Fe });
    };
    if (ge.sides.filter(Boolean).forEach((Ce) => {
      if (Ce.participantId) {
        let Fe = ie(Qe(Ce.participantId) || (r ? na({ policyDefinitions: p, participantId: Ce.participantId, tournamentParticipants: r, internalUse: !0, contextProfile: S }) : void 0), void 0, !0);
        if (Fe) {
          let ke, Wt;
          if (P?.entries) {
            let Ut = P.entries.find((qe) => qe.participantId === Ce.participantId), St = A?.entries?.find((qe) => qe.participantId === Ce.participantId);
            ke = Ut?.entryStatus || St?.entryStatus, Fe.entryStatus = ke, Ut?.entryStage && (Wt = Ut.entryStage, Fe.entryStage = Wt);
          }
          a !== !1 ? Object.assign(Ce, { participant: Fe }) : Object.assign(Ce, { participant: { entryStage: Wt, entryStatus: ke } });
        }
      }
      if (Ce?.participant?.individualParticipantIds?.length && !Ce.participant.individualParticipants?.length) {
        let Fe = Ce.participant.individualParticipantIds.map((ke) => Qe(ke) || (r ? na({ policyDefinitions: p, tournamentParticipants: r, internalUse: !0, contextProfile: S, participantId: ke }) : void 0));
        a !== !1 && Object.assign(Ce.participant, { individualParticipants: Fe });
      }
    }), !ge.matchUpType) {
      let { matchUpType: Ce } = vp({ matchUp: ge });
      Ce && Object.assign(ge, { matchUpType: Ce });
    }
    if (S?.inferGender && (!ge.gender || ge.gender === vr) && ge.sides?.length === 2 && ge.matchUpType !== kt) {
      let Ce = ge.sides.map((Fe) => {
        if (bt(Xe)(ge.matchUpType)) return Fe.participant?.person?.sex;
        if (Fe.participant?.individualParticipants?.length === 2) {
          let ke = Ue(Fe.participant.individualParticipants.map((Wt) => Wt.person?.sex)).filter(Boolean);
          if (ke.length === 1) return ke[0];
        }
      });
      if (Ce.filter(Boolean).length === 2 && Ue(Ce).length === 1) {
        let Fe = Ce[0];
        ge.inferredGender = Fe;
      }
    }
  }
  if (ge.tieMatchUps) {
    let ye = ge.matchUpStatus === "BYE", Qe = ge.sides?.map(({ participant: Ce, drawPosition: Fe, sideNumber: ke, lineUp: Wt }) => {
      let Ut = Ce?.participantType === kt && Ce;
      return { teamParticipant: Ut && ae({ participantRoleResponsibilities: Ut.participantRoleResponsibilities, participantOtherName: Ut.participanOthertName, participantName: Ut.participantName, participantId: Ut.participantId, teamId: Ut.teamId }), drawPosition: Fe, sideNumber: ke, lineUp: Wt };
    });
    ge.tieMatchUps = ge.tieMatchUps.map((Ce) => {
      let Fe = ge.matchUpId, ke = { finishingPositionRange: ge.finishingPositionRange, abbreviatedRoundName: Te, roundNumber: ce, roundName: He };
      return Hw({ tieDrawPositions: Q, scheduleVisibilityFilters: e, sourceDrawPositionRanges: t, sideLineUps: Qe, drawPositionsRanges: n, initialRoundOfPlay: s, roundNamingProfile: u, additionalContext: ke, appliedPolicies: p, isCollectionBye: ye, usePublishState: h, publishStatus: v, matchUpTieId: Fe, isRoundRobin: w, roundProfile: b, matchUp: Ce, event: A, tournamentParticipants: r, positionAssignments: i, tournamentRecord: l, seedAssignments: f, participantMap: g, contextContent: I, scheduleTiming: U, contextProfile: S, drawDefinition: P, scoringActive: D, structure: R, context: M });
    });
  }
  let Ze = ge.sides && ge.sides.filter((ye) => ye?.participantId).length === 2, At = !ge.winningSide;
  if (Object.assign(ge, { readyToScore: D && Ze && At, hasContext: !0 }), Ze) {
    let { allParticipantsCheckedIn: ye, checkedInParticipantIds: Qe } = $o({ matchUp: ge });
    Object.assign(ge, { allParticipantsCheckedIn: ye, checkedInParticipantIds: Qe });
  }
  return Array.isArray(S?.exclude) && S?.exclude.forEach((ye) => delete ge[ye]), ge;
}
function OO({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = Za({ timeItems: r?.timeItems || [], itemType: Dn });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { allocatedCourts: ie(i, !1, !0) } : t;
}
function kO({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = Za({ timeItems: r?.timeItems || [], itemType: ca });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { courtId: i } : t;
}
function xO({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = Za({ timeItems: r?.timeItems || [], itemType: Vo });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { venueId: i } : t;
}
function An(e) {
  if (!Array.isArray(e.matchUps)) return [];
  let { matchUps: t, excludeMatchUpStatuses: r, hasParticipantsCount: i, isCollectionMatchUp: n, matchUpStatuses: a, hasWinningSide: o, matchUpFormats: s, roundPositions: c, matchUpFormat: u, collectionIds: l, isMatchUpTie: d, roundNumbers: p, matchUpIds: m, roundNames: f, filterMatchUpTypes: h = !0, filterMatchUpIds: g = !0, stageSequences: I, scheduledDates: U, scheduledDate: S, participantIds: P, processContext: v, tournamentIds: D, matchUpTypes: y, structureIds: w, readyToScore: b, courtIds: T, eventIds: R, venueIds: M, drawIds: E, stages: A } = e, N = Array.isArray(P) ? P.filter(Boolean) : [], C = Array.isArray(a) ? a.filter(Boolean) : [], k = Array.isArray(r) ? r.filter(Boolean) : [], O = Array.isArray(A) ? A.filter(Boolean) : [], _ = Array.isArray(I) ? I.filter(Boolean) : [], B = Array.isArray(l) ? l.filter(Boolean) : [], L = Array.isArray(f) ? f.filter(Boolean) : [], j = Array.isArray(p) ? p.filter(Boolean) : [], H = Array.isArray(c) ? c.filter(Boolean) : [], G = Array.isArray(m) && g ? m.filter(Boolean) : [], V = Array.isArray(y) && h ? y.filter(Boolean) : [], $ = Array.isArray(T) ? T.filter(Boolean) : [], q = Array.isArray(M) ? M.filter(Boolean) : [], Y = Array.isArray(s) && s.filter(Boolean) || typeof u == "string" && [u] || [], W = Array.isArray(U) && U.filter(Boolean) || typeof S == "string" && S.length && [S] || [], K = Array.isArray(D) ? D.filter(Boolean) : [], Q = Array.isArray(R) ? R.filter(Boolean) : [], X = Array.isArray(E) ? E.filter(Boolean) : [], ee = Array.isArray(w) ? w.filter(Boolean) : [];
  return t.filter((Z) => {
    if (b && !bt(Hr)(Z) && !Z.readyToScore || Z.winningSide && o && ![1, 2].includes(Z.winningSide) || d !== void 0 && (d && !Z.tieMatchUps || !d && Z.tieMatchUps) || n !== void 0 && (n && !Z.collectionId || !n && Z.collectionId) || O.length && !O.includes(Z.stage) || _.length && !_.includes(Z.stageSequence) || B.length && (!Z.collectionId || !B.includes(Z.collectionId)) || L.length && (!Z.roundName || !L.includes(Z.roundName)) || j.length && (!Z.roundNumber || !j.includes(Z.roundNumber)) || H.length && (!Z.roundPosition || !H.includes(Z.roundPosition)) || C.length && (!Z.matchUpStatus || !C.includes(Z.matchUpStatus)) || k.length && Z.matchUpStatus && k.includes(Z.matchUpStatus) || G.length && !G.includes(Z.matchUpId) || V.length && (!Z.matchUpType || !Md(V, Z.matchUpType)) || Y.length && (!Z.matchUpFormat || !Y.includes(Z.matchUpFormat))) return !1;
    if (W?.length) {
      let { scheduledTime: ce } = Ww({ matchUp: Z }), { scheduledDate: fe } = qo({ matchUp: Z }), He = ve(ce) || fe;
      if (!W.find((Te) => hn(Te, He))) return !1;
    }
    if ($.length) {
      let { courtId: ce } = kO({ matchUp: Z }), { allocatedCourts: fe } = OO({ matchUp: Z }), He = fe?.map(({ courtId: Te }) => Te);
      if (!$.filter(Boolean).includes(ce) || He?.includes(ce)) return !1;
    }
    if (q.length) {
      let { venueId: ce } = xO({ matchUp: Z });
      if (!q.filter(Boolean).includes(ce)) return !1;
    }
    if (v) {
      if (K.length && !K.includes(Z.tournamentId) || Q.length && !Q.includes(Z.eventId) || X.length && !X.includes(Z.drawId) || ee.length && !ee.includes(Z.structureId)) return !1;
      let ce = Z.sides?.map(({ participantId: fe }) => fe).filter(Boolean) ?? [];
      if (i && ce.length < i || N.length && !N.some((fe) => ce.includes(fe))) return !1;
    }
    return !0;
  });
}
function Ve(e) {
  let { provisionalPositioning: t, tournamentRecord: r, contextFilters: i, matchUpFilters: n, contextProfile: a, drawDefinition: o, context: s = {}, structure: c, inContext: u, event: l } = e, { seedAssignments: d, contextContent: p, exitProfiles: m, matchUpsMap: f } = e, h = {}, g = {};
  if (!c) return { collectionPositionMatchUps: h, error: qa, roundMatchUps: g, matchUps: [] };
  let I = Array.isArray(n?.eventIds) ? n?.eventIds.filter(Boolean) : [], U = Array.isArray(n?.structureIds) ? n?.structureIds.filter(Boolean) : [], S = Array.isArray(n?.drawIds) ? n?.drawIds.filter(Boolean) : [], P = !s?.eventId || !I?.length && !i?.eventIds?.filter(Boolean).length || I?.includes(s.eventId) || i?.eventIds?.includes(s.eventId), v = !U?.length || U.includes(c.structureId), D = !o || !S?.length || S.includes(o.drawId);
  if (!P || !v || !D) return { collectionPositionMatchUps: h, roundMatchUps: g, matchUps: [] };
  a && !p && (p = Hn({ tournamentRecord: r, contextProfile: a, drawDefinition: o }));
  let { appliedPolicies: y } = _e({ drawDefinition: o }), w = { ...e.tournamentAppliedPolicies, ...y, ...e.policyDefinitions }, b = w?.scoring?.structures, T = c.stage && b?.stage?.[c.stage], R = c.stageSequence && T?.stageSequence?.[c.stageSequence], M = w?.scoring?.requireAllPositionsAssigned || T?.requireAllPositionsAssigned || R?.requireAllPositionsAssigned;
  f || (f = or({ drawDefinition: o, structure: c }));
  let { positionAssignments: E, allPositionsAssigned: A } = _t({ structure: c }), N = !M || A, { seedAssignments: C } = si({ provisionalPositioning: t, drawDefinition: o, structure: c });
  d = d ?? C;
  let { structureId: k } = c;
  m = m || o && Rw({ drawDefinition: o }).exitProfiles;
  let O = m?.[k], _ = O?.length && (O[0].split("-").map(($) => parseInt($)).reduce(($, q) => $ + q) || 0), B = !!c.structures, L = ka({ matchUpsMap: f, structureId: k, inContext: u }), j = w?.[Rs], H = aO({ roundNamingPolicy: j, drawDefinition: o, structure: c, matchUps: L }), { roundNamingProfile: G, roundProfile: V } = H;
  if (g = H?.roundMatchUps ?? [], n && (L = An({ matchUps: L, ...n, filterMatchUpTypes: !1, filterMatchUpIds: !1 })), u) {
    let { sourceDrawPositionRanges: $ } = rO({ drawDefinition: o, matchUpsMap: f, structureId: k }), q = o ? iO({ drawDefinition: o, roundProfile: V, matchUpsMap: f, structureId: k }).drawPositionsRanges : void 0, Y = e.tournamentParticipants, W = e.participantMap;
    !Y?.length && !W && r && ({ participants: Y = [], participantMap: W } = Ka({ participantsProfile: e.participantsProfile, useParticipantMap: e.useParticipantMap, policyDefinitions: e.policyDefinitions, tournamentRecord: r, contextProfile: a, inContext: u })), L = L.map((K) => Hw({ scheduleVisibilityFilters: e.scheduleVisibilityFilters, hydrateParticipants: e.hydrateParticipants, afterRecoveryTimes: e.afterRecoveryTimes, usePublishState: e.usePublishState, scheduleTiming: e.scheduleTiming, publishStatus: e.publishStatus, sourceDrawPositionRanges: $, tournamentParticipants: Y, positionAssignments: E, drawPositionsRanges: q, initialRoundOfPlay: _, roundNamingProfile: G, tournamentRecord: r, appliedPolicies: w, seedAssignments: d, contextContent: p, participantMap: W, contextProfile: a, drawDefinition: o, scoringActive: N, isRoundRobin: B, roundProfile: V, structure: c, context: s, matchUp: K, event: l })), (L?.filter((K) => Array.isArray(K.tieMatchUps))).forEach((K) => {
      let Q = K.tieMatchUps;
      L = L.concat(...Q);
    }), i && (L = An({ processContext: !0, ...i, matchUps: L }));
  } else (L?.filter(($) => Array.isArray($.tieMatchUps))).forEach(($) => {
    let q = $.tieMatchUps;
    L = L.concat(...q);
  });
  return n && (L = An({ matchUps: L, ...n, filterMatchUpTypes: !1, filterMatchUpIds: !1 })), (n?.matchUpTypes || n?.matchUpIds) && (L = An({ matchUpTypes: n.matchUpTypes, matchUpIds: n.matchUpIds, matchUps: L })), (n?.matchUpTypes || n?.matchUpIds || u) && (g = Ir({ matchUps: L }).roundMatchUps ?? []), dr({ drawDefinition: o, structure: c, event: l })?.tieFormat && ({ collectionPositionMatchUps: h } = tO({ matchUps: L })), { collectionPositionMatchUps: h, roundMatchUps: g, isRoundRobin: B, roundProfile: V, matchUpsMap: f, matchUps: L };
}
function ba({ matchUp: e }) {
  return e ? Lt.includes(e?.matchUpStatus) || e?.winningSide : !1;
}
function Pp({ requireParticipants: e = !0, scheduleVisibilityFilters: t, tournamentAppliedPolicies: r, tournamentParticipants: i, hydrateParticipants: n, afterRecoveryTimes: a, policyDefinitions: o, tournamentRecord: s, usePublishState: c, matchUpFilters: u, contextFilters: l, contextContent: d, participantMap: p, scheduleTiming: m, publishStatus: f, contextProfile: h, drawDefinition: g, exitProfiles: I, matchUpsMap: U, structureId: S, inContext: P, structure: v, context: D, event: y }) {
  !v && S && ({ structure: v } = me({ drawDefinition: g, structureId: S }));
  let w = Ve({ tournamentAppliedPolicies: r, scheduleVisibilityFilters: t, tournamentParticipants: i, hydrateParticipants: n, afterRecoveryTimes: a, policyDefinitions: o, tournamentRecord: s, usePublishState: c, matchUpFilters: u, contextFilters: l, contextContent: d, participantMap: p, scheduleTiming: m, publishStatus: f, contextProfile: h, drawDefinition: g, exitProfiles: I, matchUpsMap: U, structure: v, inContext: P, context: D, event: y }), b = [], T = [], R = [], M = [], E = [];
  if (w.error) return w;
  let { matchUps: A } = w, { assignedPositions: N } = _t({ structure: v }), C = N?.filter((O) => O.participantId).map((O) => O.drawPosition), k;
  return A.filter((O) => {
    let _ = u?.matchUpTypes?.length === 1 && u.matchUpTypes[0] === ot;
    return !(O.matchUpType !== ot && _);
  }).forEach((O) => {
    if (O.matchUpStatus === Or) {
      b.push(O);
      return;
    }
    O.matchUpType === ot && (k = !0);
    let _ = !!O.collectionId, B = _ && O.sides?.every(($) => $.participantId), L = !_ && O.drawPositions?.filter(Boolean).length === 2, j = !_ && O.drawPositions?.every(($) => C?.includes($)), H = N?.filter(($) => $.bye).map(($) => $.drawPosition), G = !_ && O.drawPositions?.find(($) => H?.includes($)), V = sw.includes(O.matchUpStatus) && (B || L && (!e || j));
    return G ? E.push(O) : ba({ matchUp: O }) ? T.push(O) : V ? R.push(O) : M.push(O);
  }), { includesTeamMatchUps: k, abandonedMatchUps: b, completedMatchUps: T, upcomingMatchUps: R, pendingMatchUps: M, byeMatchUps: E, structure: v };
}
function FO({ drawDefinition: e, roundNumber: t, structureId: r }) {
  if (!e) return { error: ne };
  if (!r) return { error: Qr };
  let { links: i } = tc({ drawDefinition: e, structureId: r }), n = i.source.reduce((o, s) => !s.source.roundNumber || s.source.roundNumber === t ? o.concat(s) : o, []), a = i.target.reduce((o, s) => !s.target.roundNumber || s.target.roundNumber === t ? o.concat(s) : o, []);
  return { links: { source: n, target: a } };
}
function km({ finishingPositions: e, linkCondition: t, linkType: r, source: i }) {
  let n = i.find((a) => {
    let o = !a.source?.finishingPositions || !e || gr(e, a.source?.finishingPositions);
    return t === a.linkCondition && o && a.linkType === r;
  });
  return [In, Un].includes(n?.linkType) && !n?.source?.roundNumber ? F({ result: { error: z }, stack: "getTargetLink", context: n }) : n;
}
function tc({ drawDefinition: e, structureId: t, roundNumber: r }) {
  return e ? t ? { links: (e.links || []).filter(Boolean).reduce((i, n) => (n.source?.structureId === t && (!r || n.source.roundNumber === r) && (i.source = i.source.concat(n)), n.target?.structureId === t && (!r || n.target.roundNumber === r) && (i.target = i.target.concat(n)), i), { source: [], target: [] }) } : { error: Qr } : { error: ne };
}
function LO({ structureMatchUps: e, matchUp: t }) {
  let { roundNumber: r, roundPosition: i } = t, n = e.filter((o) => o.roundNumber === r && !o.matchUpTieId), a = e.filter((o) => o.roundNumber === r + 1 && !o.matchUpTieId);
  if (a.length) {
    let o;
    return a.length === n.length ? o = a.find((s) => s.roundPosition === i) : a.length === n.length / 2 && (o = a.find((s) => s.roundPosition === Math.ceil(i / 2))), { matchUp: o };
  }
  return { message: "no progression found" };
}
function xm({ sourceRoundMatchUpCount: e, inContextDrawMatchUps: t, sourceRoundPosition: r, drawDefinition: i, targetLink: n }) {
  if (!n) return { error: oh };
  let { target: { structureId: a, feedProfile: o, groupedOrder: s, roundNumber: c, positionInterleave: u } } = n, { structure: l } = me({ drawDefinition: i, structureId: a }), { positionAssignments: d } = Je({ structure: l }), p = (t?.filter((b) => b.structureId === l?.structureId)).filter((b) => b.roundNumber === c && !b.matchUpTieId), m = p.length, f = te(1, m + 1), h = m / e, g = Math.ceil(h * r), I = 1 - r % 2;
  if (u?.interleave && h !== 0.5) {
    let b = u.offset + (r - 1) * u.interleave, T = r + b;
    g = Math.ceil(T / 2), I = 1 - T % 2;
  }
  let U = f, S = f[g - 1], P = Mw({ roundPositionsCount: f.length, groupedOrder: s }), v = P?.length || 1;
  if (v <= f.length) {
    let b = m / v, T = qt(f, b);
    o === Ea && T.forEach((R) => R.reverse()), U = P?.length && P?.map((R) => T[R - 1]).flat() || U;
  }
  o === Ii ? S = U[g - 1] : o === Ea ? ((!P?.length || v > f.length) && (g = p.length + 1 - g), S = U[g - 1]) : o === Kd && Yr() && console.log(Bd, { feedProfile: o });
  let D = S && p.reduce((b, T) => T.roundPosition === S ? T : b, void 0), y;
  D?.feedRound ? (I = 0, y = Math.min(...(D.drawPositions || []).filter(Boolean))) : y = D?.drawPositions?.length === 2 && D?.drawPositions[I];
  let w = d?.find(({ drawPosition: b }) => b === y);
  if (w) {
    let { extension: b } = we({ element: w, name: op });
    if (b?.value) return { disabledDrawPosition: y };
  }
  return { matchUp: D, targetDrawPosition: y, matchUpDrawPositionIndex: I };
}
function Ur({ inContextDrawMatchUps: e = [], useTargetMatchUpIds: t, inContextMatchUp: r, drawDefinition: i, matchUpId: n }) {
  let a = r;
  e.length && !a && (a = e.find((s) => s.matchUpId === n));
  let { structure: o } = me({ structureId: a?.structureId, drawDefinition: i });
  return o?.finishingPosition === Fo ? _O({ inContextDrawMatchUps: e, useTargetMatchUpIds: t, drawDefinition: i, structure: o, matchUp: a }) : BO({ matchUp: a });
}
function _O({ inContextDrawMatchUps: e, useTargetMatchUpIds: t, drawDefinition: r, structure: i, matchUp: n }) {
  let { winnerMatchUpId: a, loserMatchUpId: o } = n, { links: s } = FO({ roundNumber: n.roundNumber, structureId: i.structureId, drawDefinition: r }), c = s?.source, u = km({ source: c, linkType: In }), l = km({ linkCondition: Qi, linkType: Un, source: c }), d = km({ source: c, linkType: Un }), p = l && d;
  d || (d = l);
  let m = u?.target?.feedProfile, f = d?.target?.feedProfile, h = l?.target?.feedProfile, g, I, U, S, P, v, D, y, w, b;
  if (t && (a || o) && (D = a && m !== gi && e.find(({ matchUpId: M }) => M === a), S = o && f !== gi && e.find(({ matchUpId: M }) => M === o), D || S)) return { matchUp: n, targetLinks: { loserTargetLink: d, winnerTargetLink: u }, targetMatchUps: { loserMatchUp: S, winnerMatchUp: D } };
  let { roundPosition: T } = n;
  b = b || e.filter((M) => M.structureId === i.structureId);
  let R = b.reduce((M, E) => E.roundNumber === n.roundNumber && !E.matchUpTieId ? M + 1 : M, 0);
  return d && !S && f !== gi && ({ matchUpDrawPositionIndex: v, targetDrawPosition: P, matchUp: S } = xm({ targetLink: d, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: T, drawDefinition: r })), p && h !== gi && ({ matchUpDrawPositionIndex: U, targetDrawPosition: I, matchUp: g } = xm({ targetLink: l, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: T, drawDefinition: r })), u && !D && m !== gi && ({ matchUpDrawPositionIndex: w, targetDrawPosition: y, matchUp: D } = xm({ targetLink: u, sourceRoundMatchUpCount: R, inContextDrawMatchUps: e, sourceRoundPosition: T, drawDefinition: r })), D || (b = b || e.filter((M) => M.structureId === i.structureId), { matchUp: D } = LO({ structureMatchUps: b, matchUp: n })), ae({ matchUp: n, targetLinks: { loserTargetLink: d, winnerTargetLink: u, byeTargetLink: l }, targetMatchUps: { winnerMatchUpDrawPositionIndex: w, loserMatchUpDrawPositionIndex: v, byeMatchUpDrawPositionIndex: U, winnerTargetDrawPosition: y, loserTargetDrawPosition: P, byeTargetDrawPosition: I, winnerMatchUp: D, loserMatchUp: S, byeMatchUp: g }, targetMatchUpIds: !!(a || o) });
}
function BO({ matchUp: e }) {
  return { targetLinks: { loserTargetLink: void 0, winnerTargetLink: void 0 }, targetMatchUps: { loserMatchUp: void 0, winnerMatchUp: void 0 }, matchUp: e };
}
function VO({ drawDefinition: e, inContextDrawMatchUps: t }) {
  let r = {};
  return t.forEach((i) => {
    let { matchUpId: n, structureId: a, drawPositions: o = [] } = i, { structure: s } = me({ drawDefinition: e, structureId: a });
    if (s?.finishingPosition === Aa) {
      let { roundNumber: c } = i, u = c && pe(c) + 1, l = s.matchUps ?? [], { roundMatchUps: d } = Ir({ matchUps: l });
      if (u && d?.[u]) {
        let p = [...o].sort(Ot).map((m, f) => {
          let h = d[u].find((g) => g.drawPositions?.includes(m));
          return { matchUpId: h?.matchUpId, roundNumber: u, schedule: h?.schedule, sideNumber: f + 1, structureName: s.structureName };
        });
        Object.assign(i, { sidesTo: p });
      }
    } else {
      let c = Ur({ useTargetMatchUpIds: !0, inContextDrawMatchUps: t, inContextMatchUp: i, drawDefinition: e, matchUpId: n }), { winnerMatchUp: u } = c.targetMatchUps, { loserMatchUp: l } = c.targetMatchUps;
      !i.winnerMatchUpId && u && (i.winnerMatchUpId = u.matchUpId), !i.loserMatchUpId && l && (i.loserMatchUpId = l.matchUpId);
      let d = Fm({ upcomingMatchUp: u }), p = Fm({ upcomingMatchUp: l });
      if (i.matchUpStatus !== "BYE" && l?.matchUpStatus === "BYE") {
        let { matchUp: f } = zw({ matchUp: l, drawDefinition: e, inContextDrawMatchUps: t }) || {};
        p = f && Fm({ upcomingMatchUp: f }) || p;
      }
      let m = i.schedule?.timeAfterRecovery;
      if (m && (d?.schedule?.scheduledTime && Le(d.schedule.scheduledTime) < Le(m) && (r[d.matchUpId] = i.matchUpId, d.schedule.scheduleConflict = i.matchUpId), p?.schedule?.scheduledTime && Le(p.schedule.scheduledTime) < Le(m) && (r[p.matchUpId] = i.matchUpId, p.schedule.scheduleConflict = i.matchUpId)), Object.assign(i, { winnerTo: d, loserTo: p }), i.drawPositions?.filter(Boolean).length) {
        let f = c.targetLinks?.loserTargetLink?.linkCondition === Qi, h = jO(i);
        if (h.length) {
          let g = Sf(u?.sides), I = Sf(l?.sides), U = h.find(({ participantId: P }) => g.includes(P)) ? [] : h, S = h.find(({ participantId: P }) => I.includes(P)) ? [] : h;
          l && f && S.length < 2 && S.push({ bye: !0, tbd: !0 }), U?.length && u && (!c.targetMatchUpIds && u && (u = t.find(({ matchUpId: P }) => P === u.matchUpId)), u.potentialParticipants || (u.potentialParticipants = []), u.potentialParticipants.push(U)), S?.length && l && (c.targetMatchUpIds || (u = t.find(({ matchUpId: P }) => P === l.matchUpId)), l.potentialParticipants || (l.potentialParticipants = []), l.potentialParticipants.push(S));
        }
      }
    }
  }), Object.keys(r).length && t.forEach((i) => {
    Object.keys(r).includes(i.matchUpId) && (i.schedule.scheduleConflict = r[i.matchUpId]);
  }), { scheduleConflictMatchUpIds: r };
}
function jO(e) {
  return e?.sides?.map(({ participant: t, participantId: r, qualifier: i }) => t || r && { participantId: r } || i && { qualifier: i }).filter(Boolean) || [];
}
function zw({ matchUp: e, drawDefinition: t, inContextDrawMatchUps: r }) {
  let { matchUpId: i, matchUpStatus: n, structureId: a } = e || {};
  if (!e || !a || e?.matchUpStatus === Dt) return { matchUp: e };
  if (n === "BYE") {
    let o;
    return e.winnerMatchUpId ? o = r.find(({ matchUpId: s }) => s === e.winnerMatchUpId) : { winnerMatchUp: o } = Ur({ inContextDrawMatchUps: r, drawDefinition: t, matchUpId: i })?.targetMatchUps || {}, zw({ matchUp: o, drawDefinition: t, inContextDrawMatchUps: r });
  }
  return { matchUp: void 0 };
}
function Fm(e) {
  if (e?.upcomingMatchUp) return (({ matchUpId: t, structureId: r, schedule: i, roundNumber: n, roundPosition: a, structureName: o }) => ({ matchUpId: t, structureId: r, schedule: i, roundNumber: n, roundPosition: a, structureName: o }))(e.upcomingMatchUp);
}
function Et(e) {
  let t = "getAllDrawMatchUps";
  Object.assign(e, { requireParticipants: !1 });
  let r = rc(e);
  if (r.error) return F({ result: r, stack: t });
  let { abandonedMatchUps: i, completedMatchUps: n, upcomingMatchUps: a, pendingMatchUps: o, byeMatchUps: s, matchUpsMap: c } = r;
  return { matchUps: (i ?? []).concat(...n ?? [], ...a ?? [], ...o ?? [], ...s ?? []), matchUpsMap: c };
}
function rc(e) {
  if (!e?.drawDefinition) return { error: ne };
  let { tournamentParticipants: t, contextContent: r, matchUpsMap: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, requireParticipants: o, participantsProfile: s, afterRecoveryTimes: c, policyDefinitions: u, tournamentRecord: l, usePublishState: d, contextFilters: p, matchUpFilters: m, scheduleTiming: f, participantMap: h, publishStatus: g, contextProfile: I, drawDefinition: U, nextMatchUps: S, inContext: P, context: v, event: D } = e, y = [], w = [], b = [], T = [], R = [];
  I && !r && (r = Hn({ policyDefinitions: u, tournamentRecord: l, contextProfile: I, event: D }));
  let M;
  !t?.length && l && (t = l?.participants, (P || s?.withGroupings) && t?.length && ({ participantsWithGroupings: t, groupInfo: M } = mp({ participants: t, participantsProfile: s })));
  let { structures: E } = Ti({ drawDefinition: U });
  if (!E) return { error: mt };
  i || (i = or({ drawDefinition: U }));
  let A = U && Rw({ drawDefinition: U }).exitProfiles;
  E.forEach((k) => {
    let { byeMatchUps: O = [], pendingMatchUps: _ = [], upcomingMatchUps: B = [], completedMatchUps: L = [], abandonedMatchUps: j = [] } = Pp({ matchUpFilters: S ? void 0 : m, contextFilters: S ? void 0 : p, inContext: P || S || p, hydrateParticipants: e.hydrateParticipants, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, tournamentParticipants: t, requireParticipants: o, afterRecoveryTimes: c, policyDefinitions: u, tournamentRecord: l, usePublishState: d, contextContent: r, participantMap: h, scheduleTiming: f, publishStatus: g, contextProfile: I, drawDefinition: U, exitProfiles: A, matchUpsMap: i, structure: k, context: v, event: D });
    y = y.concat(...j), w = w.concat(...L), b = b.concat(...B), T = T.concat(..._), R = R.concat(...O);
  });
  let N = (k) => (!m && !S && !p || (m && (k = An({ matchUps: k, ...m })), p && (k = An({ matchUps: k, ...p, processContext: !0 }))), k), C = { abandonedMatchUps: N(y), completedMatchUps: N(w), upcomingMatchUps: N(b), pendingMatchUps: N(T), byeMatchUps: N(R), matchUpsMap: i, ...x, groupInfo: M };
  if (S) {
    let k = typeof S == "object" || { abandoned: !0, completed: !0, upcoming: !0, pending: !0, bye: !0 }, { abandoned: O, completed: _, upcoming: B, pending: L, bye: j } = k, H = [].concat(...O && y || [], ..._ && w || [], ...B && b || [], ...L && T || [], ...j && R || []);
    VO({ inContextDrawMatchUps: H, drawDefinition: U });
  }
  return C;
}
function Rn(e) {
  let { participants: t = [], contextContent: r, participantMap: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: l, usePublishState: d, contextFilters: p, matchUpFilters: m, contextProfile: f, nextMatchUps: h, inContext: g, context: I, event: U } = e;
  if (!U) return { error: st };
  let { eventId: S, eventName: P, endDate: v, eventType: D, category: y, gender: w, matchUpFormat: b } = U ?? {}, T = { ...I, ...ae({ indoorOutDoor: U.indoorOutdoor ?? l?.indoorOutdoor, surfaceCategory: U.surfaceCategory ?? l?.surfaceCategory, endDate: U.endDate ?? l?.endDate, tournamentId: l?.tournamentId, matchUpFormat: b, eventName: P, eventType: D, category: y, eventId: S, gender: w }) };
  v && (T.endDate = v), f && !r && (r = Hn({ policyDefinitions: c, tournamentRecord: l, contextProfile: f, event: U }));
  let R;
  if (!t?.length && !i && l) {
    let A = Ka({ participantsProfile: o, useParticipantMap: u, tournamentRecord: l, contextProfile: f, inContext: g });
    i = A.participantMap, t = A.participants ?? [], R = A.groupInfo;
  }
  let M = U.drawDefinitions ?? [], E = Ou({ tournamentRecord: l, event: U }).scheduleTiming;
  return { matchUps: M.flatMap((A) => {
    let { matchUps: N } = Et({ tournamentParticipants: t, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, context: T, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: l, usePublishState: d, contextFilters: p, contextProfile: f, drawDefinition: A, contextContent: r, matchUpFilters: m, participantMap: i, scheduleTiming: E, nextMatchUps: h, inContext: g, event: U });
    return N ?? [];
  }), groupInfo: R };
}
function Jt(e) {
  let t = oe(e, [{ tournamentRecord: !0 }]);
  if (t.error) return t;
  if (!e?.tournamentRecord) return { error: J };
  let { participantMap: r, participants: i } = e, { scheduleVisibilityFilters: n, participantsProfile: a, afterRecoveryTimes: o, useParticipantMap: s, policyDefinitions: c, tournamentRecord: u, inContext: l = !0, usePublishState: d, contextProfile: p, matchUpFilters: m, contextFilters: f, nextMatchUps: h, context: g } = e, I = e.tournamentId ?? u.tournamentId, U = u?.events ?? [];
  i || ({ participants: i, participantMap: r } = Ka({ participantsProfile: a, useParticipantMap: s, tournamentRecord: u, contextProfile: p, inContext: l }));
  let { appliedPolicies: S } = _e({ tournamentRecord: u }), P = { ...g, tournamentId: I, indoorOutDoor: u.indoorOutdoor, surfaceCategory: u.surfaceCategory, endDate: u.endDate }, v = Hn({ policyDefinitions: c, tournamentRecord: u, contextProfile: p });
  return { matchUps: U.flatMap((D) => (P.eventDrawsCount = D.drawDefinitions?.length ?? 0, Rn({ context: P, scheduleVisibilityFilters: n, tournamentAppliedPolicies: S, participantsProfile: a, afterRecoveryTimes: o, policyDefinitions: c, tournamentRecord: u, usePublishState: d, contextContent: v, contextFilters: f, contextProfile: p, matchUpFilters: m, participantMap: r, nextMatchUps: h, participants: i, inContext: l, event: D }).matchUps ?? [])).concat(...u.matchUps ?? []) };
}
function Bi({ scheduleVisibilityFilters: e, afterRecoveryTimes: t, participantsProfile: r, tournamentRecords: i, policyDefinitions: n, usePublishState: a, matchUpFilters: o, contextFilters: s, nextMatchUps: c, inContext: u }) {
  if (typeof i != "object" || !Object.keys(i).length) return { error: ht };
  let l = Object.keys(i).map((d) => {
    let p = i[d];
    return Jt({ scheduleVisibilityFilters: e, afterRecoveryTimes: t, participantsProfile: r, policyDefinitions: n, tournamentRecord: p, usePublishState: a, matchUpFilters: o, contextFilters: s, nextMatchUps: c, inContext: u }).matchUps ?? [];
  }).flat();
  return { ...x, matchUps: l };
}
function Ho(e, t) {
  return GO(e, t) || (e?.stageSequence || 0) - (t?.stageSequence || 0) || e?.roundNumber && t.roundNumber && e?.roundNumber - t?.roundNumber || (e?.roundPosition ?? 0) - (t?.roundPosition ?? 0);
}
function GO(e, t) {
  return (yo[e?.stage] || 0) - (yo[t?.stage] || 0);
}
function hr(e) {
  let { participants: t, participantMap: r, contextContent: i } = e, { scheduleVisibilityFilters: n, tournamentAppliedPolicies: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: l, matchUpFilters: d, contextFilters: p, contextProfile: m, drawDefinition: f, nextMatchUps: h, inContext: g, context: I, event: U } = e, { eventId: S, eventName: P, endDate: v, eventType: D, category: y, gender: w, matchUpFormat: b } = U ?? {}, T = { ...I, surfaceCategory: U?.surfaceCategory ?? l?.surfaceCategory, indoorOutDoor: U?.indoorOutdoor ?? l?.indoorOutdoor, matchUpFormat: b, eventType: D, eventName: P, category: y, eventId: S, endDate: v, gender: w }, R;
  return !t?.length && !r && l && ({ participants: t = [], participantMap: r, groupInfo: R } = Ka({ participantsProfile: o, useParticipantMap: u, tournamentRecord: l, contextProfile: m, inContext: g })), m && !i && (i = Hn({ policyDefinitions: c, tournamentRecord: l, contextProfile: m, drawDefinition: f, event: U })), { ...Et({ context: T, tournamentAppliedPolicies: a, scheduleVisibilityFilters: n, tournamentParticipants: t, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: l, drawDefinition: f, contextContent: i, contextFilters: p, contextProfile: m, matchUpFilters: d, participantMap: r, nextMatchUps: h, inContext: g, event: U }), groupInfo: R };
}
function uo({ element: e, accessor: t }) {
  if (typeof t != "string") return { values: [] };
  let r = ie(e), i = t.split("."), n = [], a;
  s({ targetElement: r, attributes: i });
  let o = { value: a };
  return n.length && (o.values = n), o;
  function s({ targetElement: c, attributes: u = [], significantCharacters: l }) {
    for (let [p, m] of u.entries()) if (c?.[m]) {
      let f = u.slice(p + 1);
      f.length ? Array.isArray(c[m]) ? c[m].forEach((h) => s({ targetElement: h, attributes: f })) : (c = c[m], d({ targetElement: c, index: p })) : (a || (a = c[m]), n.includes(c[m]) || n.push(c[m]));
    }
    function d({ targetElement: p, index: m }) {
      if (p && m === u.length - 1 && ["string", "number"].includes(typeof p)) {
        let f = l ? p.slice(0, l) : p;
        a ? n.includes(f) || n.push(f) : (a = f, n.push(f));
      }
    }
  }
}
var Yw = (e) => (t) => !e || typeof t != "object" ? void 0 : Array.isArray(e) && e.map((r) => ({ [r]: uo({ element: t, accessor: r })?.value })) || typeof e == "object" && Object.keys(e).map((r) => ({ [r]: uo({ element: t, accessor: r })?.value })) || (typeof e == "string" && uo({ element: t, accessor: e }))?.value, qr = Yw;
function qu({ finishingPositionOffset: e = 0, finishingPositionLimit: t, positionsFed: r, roundsCount: i, roundLimit: n, matchUps: a, lucky: o, fmlc: s }) {
  if (!pi(a)) return [];
  let { roundProfile: c, roundNumbers: u = [] } = Ir({ interpolate: !0, matchUps: a });
  i = i ?? Math.max(...u, 0);
  let l = n ? i - n : 0, d = l && c?.[i - l]?.matchUpsCount, p = c && Object.values(c).map(qr("matchUpsCount")), m = (g, I) => {
    let U = Math.min(...g);
    d && I && U === 1 && (U = d);
    let S = Math.max(...g);
    return t && S > t && (S = t), [U, S];
  }, f = c && Object.assign({}, ...u.map((g) => {
    let I = (i ?? 0) + 1 - g - l, U = c[g].matchUpsCount, S = { finishingPositionRange: {}, finishingRound: I }, P = p?.slice(g - 1).reduce((M, E) => M + (E || 0), 0), v = s && g !== 1, D = 1 + e + (v ? r ?? 0 : 0), y = 1, w = te(D, o ? D + U * 2 : P + D + y), b = P + y - U, T = m(w.slice(b)), R = m(w.slice(0, b), !0);
    return S.finishingPositionRange = { loser: T, winner: R }, { [g]: S };
  })), h = Yr({ finishingRound: !0 });
  return a.filter(Boolean).forEach((g) => {
    let I = g.roundNumber && f[g.roundNumber];
    h && !I && console.log({ roundFinishingData: f, matchUp: g }), g.finishingRound = I?.finishingRound, g.finishingPositionRange = I?.finishingPositionRange;
  }), a;
}
function Fa({ inContextDrawMatchUps: e, drawDefinition: t, matchUpsMap: r }) {
  if (!t) return { error: ne };
  let i = { loserMatchUpIds: {}, winnerMatchUpIds: {} };
  if (e || ({ matchUps: e, matchUpsMap: r } = Et({ inContext: !0, drawDefinition: t, matchUpsMap: r })), !r?.drawMatchUps.some((n) => n.finishingPositionRange) && t?.structures?.length === 1 && !t?.structures[0].structures) {
    let n = r?.drawMatchUps ?? [];
    qu({ matchUps: n });
  }
  return (e ?? []).filter(({ collectionId: n }) => !n).forEach((n) => {
    let { matchUpId: a, structureId: o } = n, s = Ur({ inContextDrawMatchUps: e, drawDefinition: t, matchUpId: a }), { winnerMatchUp: c, loserMatchUp: u } = s.targetMatchUps, l = c?.matchUpId, d = u?.matchUpId, p = ka({ matchUpsMap: r, structureId: o }).find((m) => m.matchUpId === a);
    if (p && (l && (i.winnerMatchUpIds[p.matchUpId] = l, Object.assign(p, { winnerMatchUpId: l }), Object.assign(n, { winnerMatchUpId: l })), d && (i.loserMatchUpIds[p.matchUpId] = d, n.loserMatchUpId = d, p.loserMatchUpId = d, n.finishingPositionRange))) {
      let m = u.finishingPositionRange && [...n.finishingPositionRange.loser, ...u.finishingPositionRange.loser], f = m && [Math.min(...m), Math.max(...m)];
      n.finishingPositionRange.loser = f, p.finishingPositionRange.loser = f;
    }
  }), { inContextDrawMatchUps: e, goesToMap: i };
}
function Ei(e) {
  let t = ui(e), r = e.matchUps ?? [], i = e.drawIds ?? [], { includeParticipantDependencies: n, tournamentRecord: a, drawDefinition: o } = e;
  if (!Array.isArray(r)) return { error: Gn };
  if (!Array.isArray(i)) return { error: Vi };
  let s = e.matchUpIds?.length ? e.matchUpIds : r.map((U) => U.matchUpId);
  if (!Array.isArray(s)) return { error: Ro };
  let c = {}, u = {}, l = {}, d = {};
  a && !Object.keys(t).length && (t = { [a.tournamentId]: a });
  let p = Object.values(t), m = p.reduce((U, S) => U.concat(S.events ?? []).map((P) => (P.drawDefinitions || []).map((v) => v.links || [])).flat(1 / 0), []).filter(({ linkType: U }) => U === gn), f = r;
  if (m.length) {
    f = Bi({ nextMatchUps: !0, tournamentRecords: t }).matchUps;
    let U = m.reduce((S, P) => {
      let v = P.source?.structureId, D = P.target?.structureId;
      return v && D && (l[D] = v), v && !S.includes(v) && S.push(v), S;
    }, []);
    for (let S of U) c[S] = [];
    for (let S of f ?? []) {
      let P = S.containerStructureId || S.structureId;
      U.includes(P) && c[P].push(S.matchUpId);
    }
  }
  let h = (U) => {
    u[U] || (u[U] = { dependentMatchUpIds: [], participantIds: [], matchUpIds: [], sources: [] }, d[U] = []);
  }, g = (U, S) => {
    u[U].matchUpIds.forEach((P) => {
      u[S].matchUpIds.push(P);
    }), u[S].matchUpIds.push(U), u[U].dependentMatchUpIds.push(S), n && u[U].participantIds.forEach((P) => u[S].participantIds.push(P));
  }, I = (U) => {
    let S = Object.keys(c).length;
    for (let P of U || []) {
      let { matchUpId: v, winnerMatchUpId: D, loserMatchUpId: y } = P;
      if (!s.length || s.includes(v)) {
        if (h(v), n) {
          let { individualParticipantIds: T } = pp(P);
          u[v].participantIds = T;
        }
        D && (h(D), g(v, D), d[D].push(v)), y && (h(y), g(v, y), d[y].push(v)), u[v].sources.push(d[v]);
        let w = d[v].map((T) => u[T].sources[0]).flat(), b = d[v].map((T) => u[T].sources[1]).flat();
        if (u[v].sources.push(w, b), S) {
          let T = P.containerStructureId || P.structureId, R = l[T];
          if (c[R]) for (let M of c[R]) h(M), g(M, v), d[M].push(v);
        }
      }
    }
  };
  if (o) Fa({ drawDefinition: o }), f?.length || (f = hr({ drawDefinition: o }).matchUps), I(f);
  else {
    if (f?.length || (f = Bi({ nextMatchUps: !0, tournamentRecords: t }).matchUps), !i.length) {
      let U = p?.length ? p.map(({ events: S = [] }) => S.map(({ drawDefinitions: P = [] }) => P.map(({ drawId: v }) => v))).flat(1 / 0) : [];
      U && (i = U);
    }
    for (let U of i) {
      let S = f?.filter((P) => P.drawId === U).sort(Ho);
      if (!S?.find(({ roundPosition: P }) => !P)) {
        let P = S?.find(({ tournamentId: D }) => D), { drawDefinition: v } = br({ tournamentRecord: t[P?.tournamentId], drawId: U });
        v && Fa({ drawDefinition: v });
      }
      I(S);
    }
  }
  return { positionDependencies: c, matchUpDependencies: u, sourceMatchUpIds: d, matchUps: f, ...x };
}
function Bt(e) {
  let t = e?.matchUp, r = e?.score || t?.score, i = r?.sets?.[0], { side1Score: n, side2Score: a, side1TiebreakScore: o, side2TiebreakScore: s, side1PointScore: c, side2PointScore: u } = i || {}, l = n || a || o || s || c || u;
  return !!(r?.sets?.length > 1 || l);
}
function Wu({ matchUpStatus: e }) {
  return aw.includes(e);
}
function $O({ matchUpStatus: e }) {
  return cg.includes(e);
}
function Mf({ matchUpStatus: e }) {
  return ow.includes(e);
}
function Lg({ matchUpStatus: e, winningSide: t, tieMatchUps: r, sides: i, score: n }) {
  let a = i?.find(({ participantId: s }) => s), o = r?.filter(Lg)?.length;
  return Bt({ score: n }) || o || t && a || e && $O({ matchUpStatus: e }) && ![Pe, be, Ri].includes(e);
}
function Hu(e) {
  let { drawDefinition: t, findContainer: r, structureId: i, event: n } = e, a = e.structure, { containedStructures: o } = ec({ drawDefinition: t }), s = i ? o[i] || [] : [], c = { isCollectionMatchUp: !1 };
  if (!a) {
    let y = me({ drawDefinition: t, structureId: i });
    if (y.error) return y;
    a = r ? y.containingStructure ?? y.structure : y.structure;
  }
  if (Tr({ structure: a })) return { structure: a, isAdHoc: !0, error: Vs };
  let { matchUps: u } = Et({ inContext: !0, matchUpFilters: c, drawDefinition: t, event: n }), l = u?.filter((y) => y.structureId === i || s.includes(y.structureId)), { matchUpDependencies: d } = Ei({ drawIds: [t.drawId], matchUps: u, drawDefinition: t }), p = [], m = [], f = {}, h = [];
  for (let y of u ?? []) {
    if (y.structureId === i || s.includes(y.structureId)) {
      m.push(...y.drawPositions ?? []);
      let w = y.roundNumber;
      for (let b of (y.drawPositions ?? []).filter(Boolean)) (!f[b] || w && f[b] > w) && (f[b] = w);
    }
    Lg(y) && (h.push(y), p.push(y.matchUpId, ...d?.[y?.matchUpId]?.matchUpIds || []));
  }
  let g = Ue(m.filter(Boolean)).sort(Ot), I = Ue(p), U = Ue(l?.map(({ matchUpId: y, drawPositions: w }) => I.includes(y) ? w : []).flat().filter(Boolean)).sort(Ot), { positionAssignments: S } = Je({ drawDefinition: t, structure: a }), P = S?.filter((y) => y.bye).map((y) => y.drawPosition), v = S?.filter((y) => y.qualifier).map((y) => y.drawPosition), D = g?.filter((y) => !U.includes(y)) || [];
  return { allDrawPositions: g, inContextStructureMatchUps: l, drawPositionInitialRounds: f, activeDependentMatchUpIds: I, qualifyingDrawPositions: v, inactiveDrawPositions: D, positionAssignments: S, activeDrawPositions: U, byeDrawPositions: P, activeMatchUps: h, structure: a };
}
function wo({ drawPosition: e, matchUps: t = [] }) {
  return { initialRoundNumber: t.filter(({ drawPositions: r }) => e && r?.includes(e)).map(({ roundNumber: r }) => r).sort(Ot)[0] };
}
function Zr({ provisionalPositioning: e, isPositionAction: t, tournamentRecord: r, drawDefinition: i, drawPosition: n, matchUpsMap: a, structureId: o, structure: s, event: c }) {
  if (!i) return { error: ne };
  if (s || ({ structure: s } = me({ drawDefinition: i, structureId: o })), !s) return { error: mt };
  o || ({ structureId: o } = s);
  let u = "assignDrawPositionBye";
  a || (a = or({ drawDefinition: i }));
  let { positionAssignments: l } = Je({ structure: s }), { activeDrawPositions: d } = Hu({ drawDefinition: i, structureId: o });
  if (l?.find((b) => b.drawPosition === n)?.bye) return { ...x };
  if (d?.includes(n)) return { error: Rd };
  let p = l?.find((b) => b.drawPosition === n);
  if (!p) return { error: Vs };
  let { filled: m, containsBye: f, assignedParticipantId: h } = qO(p);
  if (f) return { ...x };
  if (m && !f) return F({ result: { error: Us }, stack: u });
  let g = _e({ tournamentRecord: r, drawDefinition: i, event: c }).appliedPolicies ?? {}, I = Et({ inContext: !0, drawDefinition: i, matchUpsMap: a }).matchUps ?? [], U = { isCollectionMatchUp: !1 }, { matchUps: S } = Ve({ provisionalPositioning: e, drawDefinition: i, matchUpFilters: U, matchUpsMap: a, structure: s });
  if (l?.forEach((b) => {
    b.drawPosition === n && (b.bye = !0);
  }), s.structureType === yr) return WO({ tournamentRecord: r, drawDefinition: i, drawPosition: n, matchUps: S }), sa({ tournamentId: r?.tournamentId, drawDefinition: i, structure: s, event: c }), zS({ assignedParticipantId: h, isPositionAction: t, appliedPolicies: g, drawDefinition: i, drawPosition: n, structureId: o, stack: u });
  let { roundProfile: P, roundMatchUps: v } = Ir({ matchUps: S }), D = (P && Object.keys(P).map((b) => parseInt(b)).reverse())?.find((b) => P?.[b].drawPositions?.includes(n)), y = D ? v?.[D].find(({ drawPositions: b }) => b?.includes(n)) : void 0;
  y && Kw({ tournamentRecord: r, drawDefinition: i, matchUp: y, event: c });
  let w = y?.drawPositions?.find((b) => b !== n);
  if (y && w) {
    let b = _g({ sourceDrawPositions: y.drawPositions, matchUpId: y.matchUpId, inContextDrawMatchUps: I, drawPositionToAdvance: w, tournamentRecord: r, drawDefinition: i, matchUpsMap: a });
    if (b.error) return b;
  }
  return sa({ tournamentId: r?.tournamentId, drawDefinition: i, structure: s, event: c }), zS({ assignedParticipantId: h, isPositionAction: t, appliedPolicies: g, drawDefinition: i, drawPosition: n, structureId: o, stack: u });
}
function zS({ assignedParticipantId: e, isPositionAction: t, appliedPolicies: r, drawDefinition: i, drawPosition: n, structureId: a, stack: o }) {
  return t && dp({ appliedPolicies: r, drawDefinition: i, positionAction: { removedParticipantId: e, drawPosition: n, structureId: a, name: o } }), F({ result: { ...x }, stack: o });
}
function qO(e) {
  let t = e.bye, r = e.qualifier, i = e.participantId;
  return { containsBye: t, containsQualifier: r, assignedParticipantId: i, filled: t || r || i };
}
function Kw({ tournamentRecord: e, drawDefinition: t, eventId: r, matchUp: i, event: n }) {
  Object.assign(i, { matchUpStatus: "BYE", score: void 0, winningSide: void 0 }), Oe({ tournamentId: e?.tournamentId, eventId: r ?? n?.eventId, context: "setMatchUpStatusBye", drawDefinition: t, matchUp: i });
}
function WO({ tournamentRecord: e, drawDefinition: t, drawPosition: r, matchUps: i, event: n }) {
  i.forEach((a) => {
    a.drawPositions?.includes(r) && Kw({ eventId: n?.eventId, tournamentRecord: e, drawDefinition: t, matchUp: a });
  });
}
function _g({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, matchUpsMap: a, matchUpId: o, event: s }) {
  let c = a.drawMatchUps.find((S) => S.matchUpId === o), u = t.find((S) => S.matchUpId === o)?.structureId, { structure: l } = me({ drawDefinition: n, structureId: u }), { positionAssignments: d } = Je({ structure: l }), p = d?.filter((S) => S.bye).map((S) => S.drawPosition), m = c?.drawPositions?.find((S) => S !== e), f = m && p?.includes(m), { targetLinks: { loserTargetLink: h }, targetMatchUps: { loserMatchUp: g, winnerMatchUp: I, loserTargetDrawPosition: U } } = Ur({ inContextDrawMatchUps: t, drawDefinition: n, matchUpId: o });
  if (I && I.structureId === l?.structureId && HO({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, winnerMatchUp: I, matchUpsMap: a, event: s }), g && f && g.structureId !== l?.structureId) {
    let { roundNumber: S } = g;
    if (S === 1) {
      let P = Zr({ structureId: h.target.structureId, drawPosition: U, tournamentRecord: i, drawDefinition: n, event: s });
      if (P.error) return P;
    } else Qw({ loserTargetDrawPosition: U, tournamentRecord: i, loserTargetLink: h, drawDefinition: n, loserMatchUp: g, matchUpsMap: a, event: s });
  }
  return { ...x };
}
function HO({ drawPositionToAdvance: e, inContextDrawMatchUps: t, sourceDrawPositions: r, tournamentRecord: i, drawDefinition: n, winnerMatchUp: a, matchUpsMap: o, event: s }) {
  let c = "advanceWinner", u = o.drawMatchUps.find((M) => M.matchUpId === a.matchUpId), l = t.find((M) => M.matchUpId === a.matchUpId)?.structureId, { structure: d } = me({ drawDefinition: n, structureId: l }), { positionAssignments: p } = Je({ structure: d }), m = p?.find(({ drawPosition: M }) => M === e)?.bye, f = u.drawPositions?.filter(Boolean), h = p?.filter((M) => f?.includes(M.drawPosition)), g = p?.find(({ drawPosition: M }) => M === e), I = r?.find((M) => M !== e), U = (I && h?.find(({ drawPosition: M }) => M === I))?.bye, S = m && U;
  if (S && console.log({ isByeAdvancedBye: S }), f?.length > 1 && m && !U) return F({ result: { error: Us }, stack: c });
  let P = f?.find((M) => M !== e), v = S, D = [...(u.drawPositions || []).filter(Boolean), void 0, void 0].slice(0, 2).map((M) => !M && !v || M === e ? (v = !0, e) : M).sort(Ot);
  if (!v) return console.log("@@@@@@@", { advancingAssignmentIsBye: g, drawPositionToAdvance: e, existingAssignments: h }), F({ result: { error: Us }, stack: c });
  let y = p?.find(({ drawPosition: M }) => M === P)?.bye, w = p?.find(({ drawPosition: M }) => M === e)?.bye;
  Object.assign(u, { matchUpStatus: w || y ? "BYE" : Dt, score: void 0, winningSide: void 0, drawPositions: D }), Oe({ tournamentId: i?.tournamentId, matchUp: u, eventId: s?.eventId, context: c, drawDefinition: n });
  let { targetLinks: { loserTargetLink: b }, targetMatchUps: { loserMatchUp: T, loserTargetDrawPosition: R } } = Ur({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: n });
  if (y || w) {
    let M = y ? e : P;
    if (M) _g({ drawPositionToAdvance: M, matchUpId: a.matchUpId, inContextDrawMatchUps: t, tournamentRecord: i, drawDefinition: n, matchUpsMap: o });
    else if (w && b && T) if (T.feedRound) Qw({ loserTargetDrawPosition: R, tournamentRecord: i, loserTargetLink: b, drawDefinition: n, loserMatchUp: T, matchUpsMap: o });
    else {
      let E = 1 - a.roundPosition % 2, A = T.drawPositions[E], N = Zr({ structureId: b.target.structureId, drawPosition: A, tournamentRecord: i, drawDefinition: n, event: s });
      if (N.error) return N;
    }
  }
}
function Qw({ loserTargetDrawPosition: e, tournamentRecord: t, loserTargetLink: r, drawDefinition: i, loserMatchUp: n, matchUpsMap: a, event: o }) {
  let { roundNumber: s } = n, c = (a?.mappedMatchUps || {})[n.structureId].matchUps, { initialRoundNumber: u } = wo({ drawPosition: e, matchUps: c });
  if (u === s) {
    let l = Zr({ structureId: r.target.structureId, drawPosition: e, tournamentRecord: t, drawDefinition: i, event: o });
    if (l.error) return l;
  }
}
function Xw({ positionAssignments: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: i, structure: n, event: a }) {
  let { matchUps: o } = Ve({ drawDefinition: r, matchUpsMap: i, structure: n, event: a });
  o.forEach((s) => {
    let c = e.filter(({ drawPosition: u }) => s.drawPositions?.includes(u)).filter((u) => u.bye).length;
    s.winningSide || (Object.assign(s, { matchUpStatus: c ? "BYE" : Dt }), Oe({ tournamentId: t?.tournamentId, context: "modifyRoundRobinMatchUpsStatus", eventId: a?.eventId, drawDefinition: r, matchUp: s }));
  });
}
var Nn = { reset: "\x1B[0m", bright: "\x1B[1m", dim: "\x1B[2m", red: "\x1B[31m", brightred: "\x1B[91m", green: "\x1B[32m", brightgreen: "\x1B[92m", yellow: "\x1B[33m", brightyellow: "\x1B[93m", blue: "\x1B[34m", brightblue: "\x1B[94m", pinkbackground: "\x1B[105m", magenta: "\x1B[35m", brightmagenta: "\x1B[95m", cyan: "\x1B[36m", brightcyan: "\x1B[96m", white: "\x1B[37m", brightwhite: "\x1B[97m" }, Bg = [];
function Ec(e, t) {
  dt(e) && (e = { method: e }), (t || Yr()) && Bg.push(e);
}
function zO(e) {
  return Bg.slice();
}
function YO(e) {
  let t = zO().map((r) => {
    let { color: i, keyColors: n, method: a, newline: o } = r, s = Object.keys(Nn).includes(i) ? Nn[i] : Nn.cyan, c = Object.keys(r).filter((l) => !["color", "keyColors", "method", "newline"].includes(l)).map((l) => {
      let d = r[l] === void 0 && Nn.red || n && Object.keys(n).includes(l) && Nn[n[l]] && Nn[n[l]] || Nn.brightwhite;
      return `${Nn.white}${l}: ${d}${r[l]}`;
    }).join(", "), u = a?.length <= 12 && "			" || a?.length <= 20 && "		" || "	";
    return [o ? `
` : "", s, a, u, Nn.white, c, Nn.reset, `
`].join("");
  });
  t?.length && console.log(...t);
}
function KO() {
  Bg.length = 0;
}
function zu(e) {
  let { inContextDrawMatchUps: t, participantId: r, drawPosition: i } = e, { tournamentRecord: n, drawDefinition: a, structureId: o, matchUpsMap: s, event: c } = e, { structure: u } = me({ drawDefinition: a, structureId: o }), l = (_t({ drawDefinition: a, structure: u }).positionAssignments || []).find((p) => r && p.participantId === r || i && p.drawPosition === i);
  if (l && r && !i && (i = l?.drawPosition), !i) return { error: js };
  r || (r = l?.participantId);
  let { activeDrawPositions: d } = Hu({ drawDefinition: a, structureId: o });
  return d.includes(i) ? { error: Rd } : (t || ({ matchUps: t } = Et({ inContext: !0, drawDefinition: a, matchUpsMap: s })), Rf({ inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, structureId: o, drawPosition: i, matchUpsMap: s, event: c }).drawPositionCleared ? (sa({ tournamentId: n?.tournamentId, drawDefinition: a, structure: u, event: c }), { ...x, participantId: r }) : { error: vv });
}
function Rf({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, structureId: a, event: o }) {
  let { structure: s } = me({ drawDefinition: r, structureId: a });
  if (!s) return { error: mt };
  let c = _t({ drawDefinition: r, structure: s }).positionAssignments || [], u = c.some((I) => {
    if (I.drawPosition === i) return delete I.participantId, delete I.qualifier, delete I.bye, !0;
  });
  if (s.structureType === yr) return Xw({ positionAssignments: c, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, structure: s }), { drawPositionCleared: u, ...x };
  let l = { isCollectionMatchUp: !1 }, { matchUps: d } = Ve({ drawDefinition: r, matchUpFilters: l, matchUpsMap: n, structure: s, event: o }), { roundProfile: p, roundMatchUps: m } = Ir({ matchUps: d }), f = (p && Object.keys(p))?.map((I) => pe(I)), h = i, g = f?.map((I) => {
    let U = p?.[I]?.pairedDrawPositions?.find((T) => T.includes(h)), S = U?.find((T) => T !== h), P = c.find((T) => T.drawPosition === S), v = p?.[I + 1], D = P?.bye, y = v?.pairedDrawPositions?.find((T) => T.includes(S)), w = D && y && v && v.drawPositions?.includes(S), b = U && { pairedDrawPositionByeAdvancedPair: !w && y, pairedDrawPosition: S, targetDrawPosition: h, relevantPair: U, roundNumber: I };
    return w && (h = S), b;
  }).filter((I) => I?.targetDrawPosition)?.reduce((I, U) => {
    let { roundNumber: S, relevantPair: P, targetDrawPosition: v, pairedDrawPosition: D, pairedDrawPositionByeAdvancedPair: y } = U, w = { roundNumber: S, targetDrawPosition: v, relevantPair: P }, b = y && { roundNumber: S + 1, targetDrawPosition: D, relevantPair: y, subsequentRoundRemoval: !0 }, T = [w, b].filter(Boolean);
    return I.concat(...T);
  }, []);
  return g?.forEach(({ roundNumber: I, targetDrawPosition: U, relevantPair: S }) => {
    let P = m?.[I].find((v) => gr(v.drawPositions?.filter(Boolean), S.filter(Boolean)));
    P && (QO({ inContextDrawMatchUps: e, targetDrawPosition: U, tournamentRecord: t, drawDefinition: r, structureId: a, roundNumber: I, matchUpsMap: n }), Jw({ inContextDrawMatchUps: e, positionAssignments: c, tournamentRecord: t, drawDefinition: r, targetMatchUp: P, drawPosition: i, matchUpsMap: n, structure: s, event: o }));
  }), { tasks: g, drawPositionCleared: u, positionAssignments: c };
}
function QO({ inContextDrawMatchUps: e, targetDrawPosition: t, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, roundNumber: a, structureId: o }) {
  let { structure: s } = me({ drawDefinition: i, structureId: o });
  if (!s) return { error: mt };
  if (s.structureType === yr) return;
  n = n || or({ drawDefinition: i });
  let c = (n?.mappedMatchUps || {})[o].matchUps, { initialRoundNumber: u } = wo({ drawPosition: t, matchUps: c }), l = c?.filter((p) => p.roundNumber >= a && p.roundNumber !== u && p.drawPositions?.includes(t)), d = Je({ drawDefinition: i, structureId: o }).positionAssignments ?? [];
  return l?.forEach((p) => Jw({ drawPosition: t, targetMatchUp: p, inContextDrawMatchUps: e, positionAssignments: d, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, structure: s })), { ...x };
}
function Jw({ inContextDrawMatchUps: e, positionAssignments: t, tournamentRecord: r, drawDefinition: i, targetMatchUp: n, drawPosition: a, matchUpsMap: o, structure: s, event: c }) {
  let u = "removeDrawPosition", l = n.drawPositions?.slice(), d = n.matchUpStatus, p = n.winningSide;
  o = o ?? or({ drawDefinition: i });
  let m = o.mappedMatchUps[s.structureId].matchUps, { initialRoundNumber: f } = wo({ drawPosition: a, matchUps: m });
  if (n.roundNumber && f && n.roundNumber > f) {
    let y = (n.drawPositions ?? []).map((w) => w === a ? void 0 : w);
    n.drawPositions = y;
  }
  if (n.matchUpType === ot) {
    let y = (e?.find((w) => w.matchUpId === n.matchUpId)?.sides ?? []).reduce((w, b, T) => b.drawPosition === a ? T : w, void 0);
    y !== void 0 && n.sides?.[y]?.lineUp && (delete n.sides?.[y].lineUp, Oe({ tournamentId: r?.tournamentId, context: `${u}-TEAM`, eventId: c?.eventId, matchUp: n, drawDefinition: i }));
  }
  let h = Ur({ matchUpId: n.matchUpId, inContextDrawMatchUps: e, drawDefinition: i }), { targetLinks: { winnerTargetLink: g }, targetMatchUps: { loserMatchUp: I, winnerMatchUp: U, loserMatchUpDrawPositionIndex: S } } = h, P = t.filter(({ drawPosition: y }) => n.drawPositions?.includes(y)).filter((y) => y.bye).length, v = P && "BYE" || n.matchUpStatus && [Pe, be].includes(n.matchUpStatus) && n.matcHUpStatus || Dt;
  n.matchUpStatus = v, n.matchUpStatus && [be, Pe].includes(n.matchUpStatus) && (n.winningSide = void 0);
  let D = l?.find((y) => !n.drawPositions?.includes(y));
  if (l?.includes(a) && d === n.matchUpStatus && p === n.winningSide || (D && Ec({ method: u, color: "brightyellow", removedDrawPosition: D }), Oe({ tournamentId: r?.tournamentId, context: `${u}-${a}`, eventId: c?.eventId, matchUp: n, drawDefinition: i })), I && I.structureId !== h.matchUp.structureId && !P) {
    let { drawPositions: y, roundNumber: w } = I;
    if (w === 1) {
      let b = y[S];
      Rf({ structureId: I.structureId, drawPosition: b, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, matchUpsMap: o });
    } else {
      let b = Math.min(...y.filter(Boolean)), T = XO({ loserMatchUpDrawPosition: b, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, loserMatchUp: I, matchUpsMap: o, event: c });
      if (T.error) return F({ result: T, stack: u });
      let R = (o?.mappedMatchUps || {})[I.structureId].matchUps, { initialRoundNumber: M } = wo({ drawPosition: b, matchUps: R });
      M === 1 && (Ec({ method: u, color: "brightyellow", loserMatchUpDrawPosition: b }), Rf({ structureId: I.structureId, drawPosition: b, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: i, matchUpsMap: o }));
    }
  }
  return U && U.structureId !== h.matchUp.structureId && g.target.feedProfile, { ...x };
}
function XO({ loserMatchUpDrawPosition: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, loserMatchUp: n, matchUpsMap: a, event: o }) {
  let { structure: s } = me({ structureId: n.structureId, drawDefinition: i }), { positionAssignments: c } = Je({ structure: s });
  if (c?.find((u) => u.drawPosition === e)?.bye) {
    let u = zu({ drawPosition: e, structureId: n.structureId, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, matchUpsMap: a, event: o });
    if (u.error) return u;
  }
  return { ...x };
}
function eo({ drawDefinition: e, stages: t }) {
  if (!e) return { error: ne };
  let r = (e?.structures ?? []).filter((n) => !t?.length || n.stage && t.includes(n.stage)), i = Ue(r.map((n) => {
    let { positionAssignments: a } = Je({ structure: n });
    return a ? a.map(Re) : [];
  }).flat().filter(Boolean));
  return { ...x, assignedParticipantIds: i };
}
function xi(e) {
  let t = (e?.entries ?? []).filter(Boolean).reduce((i, n) => {
    let { entryStage: a, entryStatus: o } = n, s = `_${a || re}${o || ""}`;
    return i[s] || (i[s] = []), i[s].push(n), i;
  }, {}), r = (i) => isNaN(i) ? 1 / 0 : i;
  return Object.keys(t).map((i) => t[i].sort((n, a) => r(n.entryPosition) - r(a.entryPosition)).map((n, a) => {
    let o = a + 1;
    return { ...n, entryPosition: o };
  })).flat();
}
function Pa(e) {
  return [Xa, di].includes(e);
}
function sd({ autoEntryPositions: e = !0, ignoreAssignment: t, tournamentRecord: r, drawDefinition: i, participantIds: n, entryStatus: a, entryStage: o, extension: s, eventSync: c, drawId: u, stage: l, event: d }) {
  if (!n || !Array.isArray(n)) return { error: Li, method: "modifyEntriesStatus", participantIds: n };
  if (!i && !d) return { error: st };
  if (a && !bw.includes(a)) return { error: lf };
  if (o && !Hd.includes(o)) return { error: Wa };
  let p = "modifyEntriesStatus", m = [];
  if (!a && !s) return F({ result: { error: ue }, info: "Missing entryStatus", stack: p });
  if (s && !Xi({ extension: s, requiredAttributes: ["name"] })) return F({ result: { error: z }, info: "Invalid extension", context: { extension: s }, stack: p });
  let f = [];
  d?.drawDefinitions?.forEach((b) => {
    let T = eo({ stages: l && [l], drawDefinition: b }).assignedParticipantIds ?? [];
    f.push(...T);
  });
  let h = r?.participants ?? [];
  if (!n.every((b) => {
    let T = na({ tournamentParticipants: h, participantId: b })?.participantType;
    return !(T && [De, Pr].includes(T) && Pa(a)) && !(a && d?.eventType && T === Ne && [ai, jr].includes(d.eventType) && [vi, ...Fl].includes(a));
  })) return { error: lf };
  let g = d && wt({ event: d }).flightProfile, I = g?.flights?.find((b) => b.drawId === u), U = (b) => {
    let T = (b || []).filter((M) => !l || !M.entryStage || l === M.entryStage).filter(({ participantId: M }) => n.includes(M)), R = (M) => a && f.includes(M.participantId) && !(Fl.includes(M.entryStatus) && Fl.includes(a));
    return T.every((M) => R(M) && !t ? !1 : (a && (M.entryStatus = a, delete M.entryPosition), o && (M.entryStage = o, delete M.entryPosition), s && (s.value ? Be({ element: M, extension: s }) : fr({ element: M, name: s.name })), !0)) ? { ...x } : { error: qs };
  }, S = ({ flight: b, drawDefinition: T }) => {
    d && (d.entries = xi({ entries: d.entries ?? [] })), b && (b.drawEntries = xi({ entries: b.drawEntries })), T && (T.entries = xi({ entries: T.entries }));
  }, P = (b) => {
    let { flight: T, drawDefinition: R } = b, M = "updateDrawEntries";
    if (T) {
      let E = U(T.drawEntries);
      if (E.error) return F({ result: E, stack: M });
    }
    if (R) {
      let E = U(R.entries);
      if (E.error) return F({ result: E, stack: M });
      m.includes(R.drawId) || m.push(R.drawId);
    }
    return { ...x };
  }, v = d?.entries?.find(({ entryPosition: b }) => b) ?? (I?.drawEntries?.find(({ entryPosition: b }) => b) || i?.entries?.find(({ entryPosition: b }) => b));
  if (e && !v && S({ flight: I, drawDefinition: i }), I || i) {
    let b = P({ flight: I, drawDefinition: i });
    if (b.error) return F({ result: b, stack: p });
  }
  let D = d?.drawDefinitions?.map(({ drawId: b }) => b) ?? [], y = g?.flights?.filter((b) => !D.includes(b.drawId)) || [];
  for (let b of y) {
    let T = b && P({ flight: b });
    if (T?.error) return F({ result: T, stack: p });
  }
  let w = g?.flights?.length === 1 && (d?.drawDefinitions?.length ?? 0) <= g?.flights?.length;
  if (!I && !i && a && Tw.includes(a)) return { error: oP };
  if (!I && !i || a === Pn || c && w) {
    let b = U(d?.entries);
    if (b?.error) return F({ result: b, stack: p });
    let T;
    if (a === Pn && (g?.flights?.every((R) => {
      let M = U(R.drawEntries);
      return M.error ? (T = M.error, !1) : (R.drawEntries = R.drawEntries.filter(({ participantId: E }) => !n.includes(E)), !0);
    }), d?.drawDefinitions?.every((R) => {
      let M = U(R.entries);
      return M.error ? (T = M.error, !1) : (R.entries = R.entries?.filter(({ participantId: E }) => !n.includes(E)), !0);
    })), T) return F({ result: { error: T }, stack: p });
  }
  e && S({ flight: I, drawDefinition: i });
  for (let b of d?.drawDefinitions ?? []) m.length && !m.includes(b.drawId) || tt({ tournamentId: r.tournamentId, eventId: d?.eventId, drawDefinition: b });
  return { ...x };
}
function dn({ requireTimeStamp: e, scaleAttributes: t, participant: r }) {
  if (!r) return { error: Ao };
  if (!xe(t)) return { error: z };
  if (r.timeItems || (r.timeItems = []), Array.isArray(r.timeItems)) {
    let { accessor: i, scaleType: n, eventType: a, scaleName: o } = t, s = [Ca, n, a, o].join("."), c = r.timeItems.filter((u) => u?.itemType === s).filter((u) => !e || u?.itemDate).sort((u, l) => (u.createdAt ? new Date(u.createdAt).getTime() : 0) - (l.createdAt ? new Date(l.createdAt).getTime() : 0)).pop();
    if (c) {
      let [u, l, d, p] = c.itemType?.split(".") ?? [];
      if (u !== Ca) return { error: Io };
      let m = (i && uo({ element: c.itemValue, accessor: i }))?.value || c.itemValue, f = { eventType: d, scaleDate: c.itemDate, scaleValue: m, scaleName: p, scaleType: l };
      return { ...x, scaleItem: f };
    }
  }
  return { ...x, scaleItem: void 0 };
}
function JO({ publishedSeeding: e, usePublishState: t, withSeeding: r, participant: i, event: n }) {
  let a = {}, o = (l) => [Ca, un, n.eventType, l].join("."), s = Object.assign({}, ...(i.timeItems || []).filter(({ itemType: l }) => l.split(".")[1] === un).map(({ itemType: l, itemValue: d }) => ({ [l]: d }))), c = (e?.stageSeedingScaleNames && Object.values(e?.stageSeedingScaleNames) || Array.isArray(e?.seedingScaleNames) && e.seedingScaleNames || []).map(o), u = Pt(Object.keys(s), c);
  if ((!t || !Object.keys(s).length && !e?.drawIds?.length || u.length) && u.length) {
    if (e?.stageSeedingScaleNames) {
      let l = Object.keys(e.stageSeedingScaleNames).map((p) => {
        let m = o(e.stageSeedingScaleNames[p]), f = s[m];
        return [p, f];
      }).filter((p) => p[1]).map((p) => ({ [p[0]]: { seedValue: p[1] } })), d = Object.assign({}, ...l);
      a.seedAssignments = d;
    } else if (u) {
      let l = u.map((d) => s[d]);
      a.seedValue = l.pop();
    }
  } else if (!t && typeof r == "object") {
    let l = Object.keys(r).map((p) => {
      let m = o(r[p]), f = s[m];
      return [p, f];
    }).filter((p) => p[1]).map((p) => ({ [p[0]]: { seedValue: p[1] } })), d = Object.assign({}, ...l);
    a.seedAssignments = d;
  } else {
    let { categoryName: l, ageCategoryCode: d } = n.category || {}, p = [d, n.eventId, l].filter(Boolean), m;
    for (let f of p) {
      let h = { eventType: n.eventType, scaleType: un, scaleName: f }, g = dn({ scaleAttributes: h, participant: i });
      if (g.scaleItem) {
        m = g.scaleItem;
        break;
      }
    }
    if (m && (!t || e?.published && !e?.published?.drawIds?.length)) {
      let f = m.scaleValue;
      a.seedValue = f;
    }
  }
  return a;
}
function ZO({ convertExtensions: e, seedAssignments: t, participant: r, withSeeding: i, seedValue: n, eventId: a, ranking: o, entry: s }) {
  let { entryStatus: c, entryStage: u, entryPosition: l, extensions: d } = s, p = d?.length && e ? Object.assign({}, ...Vh(d ?? [])) : {}, m = Object.assign(p, { entryPosition: l, entryStatus: c, entryStage: u, ranking: o, eventId: a });
  r.events[a] = ae(m, !1, !1, !0), i && (t && (r.events[a].seedAssignments = t), n && (r.events[a].seedValue = n));
}
function Yu(e) {
  let t = oe(e, [{ [Vt]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, status: i = Jr } = e, n = `${ga}.${Ia}`;
  return ie(fp({ tournamentRecord: r, itemType: n })?.timeItem?.itemValue?.[i], !1, !0);
}
function ek(e) {
  let { tournamentId: t } = e ?? {};
  return !!t;
}
function mi({ event: e, status: t = Jr }) {
  let r = `${ga}.${Ia}`;
  return Cu({ itemType: r, event: e })?.timeItem?.itemValue?.[t];
}
function Vg({ drawDetails: e, drawId: t }) {
  return e?.[t]?.publishingDetail?.published;
}
function zo(e) {
  let { tournamentRecord: t, drawDefinition: r, eventIds: i, eventId: n, drawIds: a, drawId: o, event: s } = e ?? {};
  if (t && !ek(t)) return { error: z };
  if (n && !s) return { error: ni };
  if (Array.isArray(i) && i?.length) {
    let d = {};
    for (let p of i) {
      if (!dt(p)) return { error: z };
      let m = br({ tournamentRecord: t, eventId: p })?.event;
      if (!m) return { error: ni };
      let f = Lm({ event: m });
      d[p] = f;
    }
    return { ...x, publishState: d };
  }
  if (s) {
    let d = Lm({ event: s }), p = {};
    if (o) return r ? { publishState: { status: { published: !!d.status.publishedDrawIds?.includes(o), drawDetail: d.status.drawDetails?.[o] }, ...x } } : { error: zr };
    if (Array.isArray(a) && a?.length) {
      let m = s.drawDefinitions?.map(Kc) ?? [];
      for (let f of a) {
        if (!dt(f)) return { error: z };
        if (!m.includes(f)) return { error: zr };
        p[f] = { status: { published: !!d.status.publishedDrawIds.includes(f), drawDetail: d.status.drawDetails?.[f] } };
      }
    } else p = d;
    return { ...x, publishState: p };
  }
  let c = [], u = !1, l = {};
  for (let d of t?.events ?? []) {
    let p = Lm({ event: d });
    l[d.eventId] = p, p.status.published && (c.push(d.eventId), u = !0);
    for (let { drawId: m } of d.drawDefinitions ?? []) {
      let f = p.status?.publishedDrawIds?.includes(m);
      f && (l[m] = { status: { published: f } });
    }
  }
  if (t) {
    let d = Yu({ tournamentRecord: t });
    l.tournament = d ?? {}, (d?.orderOfPlay?.published || d?.participants?.published) && (u = !0), l.tournament.status = { published: u, publishedEventIds: c };
  }
  return { ...x, publishState: l };
}
function Lm({ event: e }) {
  let t = mi({ event: e });
  if (!t) return { status: { published: !1 } };
  let r = { published: void 0, seedingScaleNames: [], drawIds: [] };
  t.seeding && Object.assign(r, t.seeding);
  let i = t.drawDetails ?? {};
  for (let s of e.drawDefinitions?.map(Kc) || []) i[s] || (i[s] = { publishingDetail: { published: !1 } });
  let n = i && Object.keys(i).length && Object.keys(i).filter((s) => Vg({ drawDetails: i, drawId: s })), a = n?.length ? n : t.drawIds ?? [];
  if (a?.length && !n?.length) for (let s of a) i[s] = { publishingDetail: { published: !0 } };
  let o = a?.length > 0;
  return { status: { publishedDrawIds: a, publishedSeeding: r, drawDetails: i, published: o } };
}
function Zw(e) {
  let { participantMap: t, participantId: r, matchUpStatus: i, roundPosition: n, structureId: a, matchUpType: o, roundNumber: s, matchUpId: c, potential: u, schedule: l, drawId: d, score: p } = e;
  !l || !Object.keys(l).length || i === "BYE" || t[r].scheduleItems.push({ ...l, scheduledDate: ve(l?.scheduledDate), scheduledTime: ct(l?.scheduledTime), checkScoreHasValue: Bt({ score: p }), matchUpStatus: i, roundPosition: n, structureId: a, matchUpType: o, roundNumber: s, matchUpId: c, potential: u, drawId: d });
}
function tk({ finishingPositionRange: e = {}, participantMap: t, finishingRound: r, participantWon: i, matchUpStatus: n, participantId: a, stageSequence: o, roundNumber: s, structureId: c, matchUpId: u, drawId: l, stage: d }) {
  let p = t[a], m = (U) => Math.abs(U[0] - U[1]);
  p.structureParticipation[c] || (p.structureParticipation[c] = { rankingStage: d, walkoverWinCount: 0, defaultWinCount: 0, stageSequence: o, winCount: 0, structureId: c, drawId: l });
  let f = p.structureParticipation[c], { winner: h, loser: g } = e, I = i ? h : g;
  i && (f.winCount += 1, n === be && (f.walkoverWinCount += 1), n === Pe && (f.defaultWinCount += 1)), I && (!f.finishingPositionRange || m(I) < m(f.finishingPositionRange)) && (f.finishingPositionRange = I), r && ((!f.finishingRound || r < f.finishingRound) && (f.finishingMatchUpId = u, f.finishingRound = r, f.roundNumber = s), r === 1 && (f.participantWon = i));
}
function YS(e) {
  let { withScheduleItems: t, scheduleAnalysis: r, withTeamMatchUps: i, participantMap: n, withOpponents: a, withMatchUps: o, withEvents: s, withDraws: c, finishingPositionRange: u, finishingRound: l, matchUpStatus: d, stageSequence: p, roundNumber: m, structureId: f, score: h, stage: g, withRankingProfile: I, tieWinningSide: U, roundPosition: S, matchUpTieId: P, matchUpSides: v, collectionId: D, matchUpType: y, winningSide: w, matchUpId: b, schedule: T, eventId: R, drawId: M, sides: E } = e, A = a && E?.length === 2 && Object.assign({}, ...E.map(({ sideNumber: N }, C) => {
    let k = E[1 - C].participantId;
    return N && { [N]: k };
  }).filter(Boolean));
  for (let N of E) {
    let { participantId: C, sideNumber: k, bye: O } = N;
    if (O) continue;
    let _ = w === k, B = (H) => {
      let G = n[H]?.participant, V = G?.participantType, $ = [{ participantId: H, participantType: V }];
      if (V !== Pr) for (let q of G?.individualParticipantIds || []) {
        let Y = n[q]?.participant;
        $.push({ participantType: Y?.participantType, participantId: q });
      }
      return $;
    }, L = (H, G) => {
      if (o) {
        if (n[H].matchUps[b] = { participantWon: _, matchUpType: y, structureId: f, sideNumber: k, matchUpId: b, eventId: R, drawId: M, stage: g }, a) {
          let V = B(G);
          n[H].matchUps[b].opponentParticipantInfo = V;
        }
        D && (n[H].matchUps[b].collectionId = D);
      }
      a && G && (n[H].opponents[G] = { participantId: G, matchUpId: b, eventId: R, drawId: M }), I && tk({ finishingPositionRange: u, participantMap: n, participantWon: _, finishingRound: l, matchUpStatus: d, participantId: H, stageSequence: p, roundNumber: m, structureId: f, matchUpId: b, drawId: M, stage: g }), (r || t) && Zw({ participantMap: n, participantId: H, matchUpStatus: d, roundPosition: S, matchUpType: y, roundNumber: m, structureId: f, matchUpId: b, schedule: T, drawId: M, score: h });
    }, j = ({ participant: H, partnerParticipantId: G }) => {
      let V = ($, q) => {
        $ && ($.partnerParticipantIds || ($.partnerParticipantIds = []), $.partnerParticipantIds.includes(q) || $.partnerParticipantIds.push(q));
      };
      c && V(H?.draws?.[M], G), s && V(H?.events?.[R], G), o && V(H?.matchUps?.[b], G);
    };
    if (C && n[C]) {
      let H = A?.[k];
      L(C, H);
      let G = n[C]?.participant.participantType === De, V = n[C]?.participant.individualParticipantIds || [];
      if (P) {
        if (i) {
          let $ = (q) => n[q].matchUps[P] = { participantWon: U === k, matchUpId: P, matchUpType: ot, sideNumber: k };
          $(C), V.forEach($);
        }
        if (c && !n[C].draws[M]) {
          let $ = v.find((W) => W.sideNumber === k)?.participant?.participantId, q = n[$]?.draws?.[M]?.entryStatus, Y = (W) => n[W].draws[M] = { entryStatus: q, eventId: R, drawId: M };
          Y(C), V.forEach(Y);
        }
      }
      if (G && (V.forEach(($) => n[$] && L($, H)), V.forEach(($, q) => {
        let Y = V[1 - q], W = n[$];
        W && j({ participant: W, partnerParticipantId: Y });
      }), s && v)) {
        let $ = v.find((q) => q.sideNumber === k)?.participant?.participantId;
        if ($) {
          let q = n[$]?.events[R];
          q ? (n[C].events[R] = { ...q }, V.forEach((Y) => n[Y].events[R] = { ...q })) : console.log("Missing teamEntry", { eventId: R, teamParticipantId: $ });
        }
      }
      if (w) {
        let $ = (q) => {
          _ ? (n[q].counters[y].wins += 1, n[q].counters.wins += 1, d === be && (n[q].counters[y].walkoverWins += 1, n[q].counters.walkoverWins += 1), d === Pe && (n[q].counters[y].defaultWins += 1, n[q].counters.defaultWins += 1)) : (n[q].counters[y].losses += 1, n[q].counters.losses += 1, d === be && (n[q].counters[y].walkovers += 1, n[q].counters.walkovers += 1), d === Pe && (n[q].counters[y].defaults += 1, n[q].counters.defaults += 1));
        };
        $(C), V.forEach($);
      }
    }
  }
}
function Dp(e, t) {
  return (e || "").localeCompare(t || "");
}
function rk(e) {
  let { participantFilters: t, convertExtensions: r, policyDefinitions: i, tournamentRecord: n, usePublishState: a, contextFilters: o, matchUpFilters: s, participantMap: c, contextProfile: u, withPotentialMatchUps: l, withRankingProfile: d, withScheduleItems: p, scheduleAnalysis: m, withTeamMatchUps: f, withStatistics: h, withOpponents: g, withMatchUps: I, withSeeding: U, withEvents: S, withDraws: P } = e, v = t?.participantIds, D = (N) => {
    let C = [N];
    return c[N]?.participant.individualParticipantIds?.forEach((k) => C.push(k)), C.some((k) => !v?.length || v.includes(k)) ? C : [];
  }, y = { withMatchUps: I || d, withEvents: S || d, withDraws: P || d, withPotentialMatchUps: l, withRankingProfile: d, withScheduleItems: p, scheduleAnalysis: m, withTeamMatchUps: f, withStatistics: h, participantMap: c, withOpponents: g, withSeeding: U }, w = [], b = {}, T = [], R = {}, M = {}, E = {}, A = ({ eventType: N, scaleNames: C, participantId: k }) => c[k]?.participant?.rankings?.[N]?.find((O) => C.includes(O.scaleName))?.scaleValue;
  for (let N of n?.events || []) {
    if (t?.eventIds && !t.eventIds.includes(N.eventId)) continue;
    let { drawDefinitions: C = [], extensions: k = [], eventType: O, eventName: _, category: B, entries: L, eventId: j, gender: H } = N, { flightProfile: G } = wt({ event: N }), V = G?.flights ?? [], $ = zo({ event: N }).publishState;
    $ && (R[j] = $);
    let q = $?.status?.publishedSeeding;
    if (S || U || d) {
      let W = r ? Object.assign({}, ...Vh(k ?? [])) : {};
      M[j] = { ...W, eventName: _, eventType: O, category: B, eventId: j, gender: H };
      let K = [B?.categoryName, B?.ageCategoryCode].filter(Boolean);
      for (let Q of L) {
        let { participantId: X } = Q;
        if (!X || !c[X]) continue;
        let ee = A({ eventType: O, scaleNames: K, participantId: X }), Z, ce;
        if (U) {
          let He = c[X].participant;
          ({ seedAssignments: Z, seedValue: ce } = JO({ publishedSeeding: q, usePublishState: a, withSeeding: U, participant: He, event: N }));
        }
        let fe = (He) => {
          if (c[He]?.events?.[j]) return;
          let Te = c[He];
          ZO({ convertExtensions: r, seedAssignments: Z, participant: Te, withSeeding: U, seedValue: ce, eventId: j, ranking: ee, entry: Q });
        };
        fe(X), (c[X].participant.individualParticipantIds || []).forEach(fe);
      }
    }
    let Y = R?.[j]?.publishedSeeding;
    if (P || d || U) {
      let W = (Q) => Q ? Object.assign({}, ...Q.map(({ participantId: X, seedValue: ee, seedNumber: Z }) => ({ [X]: { seedValue: ee, seedNumber: Z } }))) : void 0, K = Ue([...C.map(Kc), ...V.map(Kc)]);
      for (let Q of K) {
        let X = C.find((ye) => ye.drawId === Q), ee = [B?.categoryName, B?.ageCategoryCode].filter(Boolean), { structures: Z = [], drawOrder: ce, drawName: fe, drawType: He } = X ?? {}, Te = V?.find((ye) => ye.drawId === Q), $e = X?.entries || Te?.drawEntries, it = Te?.flightNumber, It = (X?.structures || []).sort((ye, Qe) => _o(ye, Qe)).map(({ structureId: ye, structures: Qe }) => [ye, ...(Qe || []).map(({ structureId: Ce }) => Ce)]).flat(1 / 0), Rt, de, lt, le, ze = 0, Ae = Z.filter(({ stage: ye, stageSequence: Qe }) => ye === re && Qe === 1 || ye === se).flatMap((ye) => {
          let { positionAssignments: Qe } = Je({ structure: ye }), { seedAssignments: Ce, stageSequence: Fe, stage: ke } = ye;
          return ke === re ? (ze = Qe?.length ?? 0, lt = Qe, le = Ce) : Fe === 1 && (Rt = Qe, de = Ce), Qe;
        }).map(({ participantId: ye }) => ye).filter(Boolean), nt = W(le), Ee = W(de), rt = X ? $e.filter(({ participantId: ye }) => Ae.includes(ye)) : $e, ge = !a || Y?.published && (Y?.drawIds?.length === 0 || Y?.drawIds?.includes(Q));
        for (let ye of rt) {
          if (!c[ye.participantId]) continue;
          let { entryStatus: Qe, entryStage: Ce, entryPosition: Fe, participantId: ke } = ye, Wt = A({ participantId: ke, scaleNames: ee, eventType: O }), Ut = (St) => {
            if (!c[St] || c[St].draws?.[Q]) return;
            let qe = U && ge, jt = qe ? {} : void 0, ji = qe ? nt?.[ke]?.seedValue || nt?.[ke]?.seedNumber : void 0, Zt = ji ? nt?.[ke] : void 0, Ai = qe ? Ee?.[ke]?.seedValue || Ee?.[ke]?.seedNumber : void 0, on = Ai ? Ee?.[ke] : void 0;
            jt && ji && (jt[re] = Zt), jt && Ai && (jt[se] = on);
            let Sc = ji || Ai;
            Sc && (c[St].participant.seedings[O] || (c[St].participant.seedings[O] = []), Zt && c[St].participant.seedings[O].push({ ...Zt, scaleName: Q }), on && c[St].participant.seedings[O].push({ ...on, scaleName: Q }), jt && (c[St].events[j].seedAssignments || (c[St].events[j].seedAssignments = {}), Object.keys(jt).forEach((DS) => c[St].events[j].seedAssignments[DS] = jt[DS]))), (P || d) && (c[St].draws[Q] = ae({ seedAssignments: jt, entryPosition: Fe, entryStatus: Qe, entryStage: Ce, seedValue: Sc, eventId: j, ranking: Wt, drawId: Q }, !1, !1, !0));
          };
          [di, Xa].includes(Qe) || (Ut(ke), (c[ke].participant.individualParticipantIds || [])?.forEach(Ut));
        }
        let Ze = (X?.structures ?? []).reduce((ye, Qe) => (ye.includes(Qe.stage) || ye.push(Qe.stage), ye), []), At = (X?.links ?? []).length;
        E[Q] = { qualifyingPositionAssignments: Rt, qualifyingSeedAssignments: de, mainPositionAssignments: lt, qualifyingSeedingMap: Ee, mainSeedAssignments: le, orderedStructureIds: It, mainSeedingMap: nt, flightNumber: it, linksCount: At, drawOrder: ce, drawName: fe, drawType: He, drawSize: ze, drawId: Q, stages: Ze };
      }
    }
    if (d || m || f || h || g || I || P) {
      let W = !!m || l, K = Rn({ afterRecoveryTimes: !!m, policyDefinitions: i, tournamentRecord: n, inContext: !0, participantMap: c, contextFilters: o, matchUpFilters: s, contextProfile: u, nextMatchUps: W, event: N })?.matchUps ?? [];
      for (let Q of K) {
        let { finishingPositionRange: X, potentialParticipants: ee, tieMatchUps: Z = [], sides: ce = [], winningSide: fe, matchUpType: He, matchUpId: Te, eventId: $e, drawId: it, collectionId: It, stageSequence: Rt, finishingRound: de, matchUpStatus: lt, roundPosition: le, roundNumber: ze, structureId: Ae, schedule: nt, score: Ee, stage: rt } = Q;
        b[Te] = Q;
        let ge = { finishingPositionRange: X, finishingRound: de, stageSequence: Rt, roundPosition: le, collectionId: It, roundNumber: ze, structureId: Ae, schedule: nt, eventId: $e, drawId: it, score: Ee, stage: rt };
        YS({ ...ge, ...y, matchUpStatus: lt, winningSide: fe, matchUpType: He, matchUpId: Te, sides: ce });
        for (let Ze of Z) {
          let { winningSide: At, sides: ye = [], matchUpId: Qe, matchUpStatus: Ce, matchUpType: Fe } = Ze;
          YS({ ...ge, ...y, winningSide: At, tieWinningSide: fe, matchUpTieId: Te, matchUpId: Qe, sides: ye, matchUpSides: ce, matchUpStatus: Ce, matchUpType: Fe });
        }
        Array.isArray(ee) && (W || m || p) && ee.flat().map(Re).filter(Boolean)?.forEach((Ze) => {
          D(Ze)?.forEach((At) => {
            c[At] && (c[At].potentialMatchUps[Te] = ae({ tournamentId: n?.tournamentId, matchUpId: Te, eventId: $e, drawId: it }));
          }), (m || p) && Zw({ potential: !0, participantMap: c, participantId: Ze, matchUpStatus: lt, roundPosition: le, structureId: Ae, matchUpType: He, roundNumber: ze, matchUpId: Te, schedule: nt, drawId: it, score: Ee });
        });
      }
      T.push(...K);
    }
  }
  if (h || d || m) {
    let N = Object.values(c);
    for (let C of N) {
      let { wins: k, losses: O, [Xe]: { wins: _, losses: B }, [Ke]: { wins: L, losses: j } } = C.counters, H = (G, V, $) => {
        let q = V + $, Y = V, W = q && Y / q;
        C.statistics[G] = { denominator: q, numerator: Y, statValue: W, statCode: G };
      };
      if (h && (H(xl, k, O), H(`${xl}.${Xe}`, _, B), H(`${xl}.${Ke}`, L, j)), d) {
        let G = (V = []) => Math.abs(V[0] - V[1]);
        for (let V of Object.keys(C.draws)) {
          let { orderedStructureIds: $ = [], flightNumber: q } = E[V] || {};
          if (C.structureParticipation && $.length) {
            let Y, W = 0, K = $.map((Q) => {
              let X = C.structureParticipation[Q];
              if (!X) return;
              Y || (Y = X?.finishingPositionRange), G(Y) > G(X?.finishingPositionRange) && (Y = X?.finishingPositionRange);
              let ee = X.stage !== se;
              return ee && (W += 1), ae({ ...X, participationOrder: ee ? W : void 0, flightNumber: q });
            }).filter(Boolean);
            C.draws[V] && (C.draws[V].finishingPositionRange = Y, C.draws[V].structureParticipation = K);
          }
        }
      }
      if (m) {
        let G = xe(m) ? m.scheduledMinutesDifference : 0, V = C.scheduleItems || [], $ = C.potentialMatchUps || {}, q = V.reduce((W, K) => {
          let { scheduledDate: Q, scheduledTime: X } = K;
          return W[Q] || (W[Q] = []), X && W[Q].push(K), W;
        }, {});
        Object.values(q).forEach((W) => W.sort($P));
        for (let W of V) {
          let { typeChangeTimeAfterRecovery: K, timeAfterRecovery: Q, scheduledDate: X, scheduledTime: ee } = W, Z = q[X], ce = Le(ee);
          for (let fe of Z) {
            if (fe.matchUpId === W.matchUpId || [be, Pe].includes(fe.matchUpStatus) && !fe.checkScoreHasValue) continue;
            let He = W.matchUpType !== fe.matchUpType && K || Q, Te = W.drawId === fe.drawId, $e = $[W.matchUpId] && $[fe.matchUpId], it = Le(fe.scheduledTime), It = Math.abs(it - ce), Rt = it >= ce;
            if ((G && !isNaN(G) ? It <= G : Rt && Le(fe.scheduledTime) < Le(He)) && !($e && Te) && Rt) {
              let de = [W.matchUpId, fe.matchUpId].sort(Dp).join("|");
              C.scheduleConflicts[de] = { priorScheduledMatchUpId: W.matchUpId, matchUpIdWithConflict: fe.matchUpId };
            }
          }
        }
        let Y = C.participant.participantId;
        Object.keys(C.scheduleConflicts).length && w.push(Y), c[Y].scheduleConflicts = C.scheduleConflicts;
      }
    }
  }
  return { participantIdsWithConflicts: w, eventsPublishStatuses: R, derivedEventInfo: M, derivedDrawInfo: E, mappedMatchUps: b, participantMap: c, matchUps: T };
}
function Ku({ participantFilters: e = {}, tournamentRecord: t, participants: r = [] }) {
  if (!Object.keys(e).length) return r;
  let { accessorValues: i, drawEntryStatuses: n, positionedParticipants: a, eventEntryStatuses: o, participantRoles: s, participantRoleResponsibilities: c, participantTypes: u, participantIds: l, signInStatus: d, enableOrFiltering: p, eventIds: m, genders: f } = e, h = sn(m) && t?.events?.filter((P) => m?.includes(P.eventId)) || t?.events || [], g = n && ik({ drawEntryStatuses: n, tournamentEvents: h }), I = o && nk({ eventEntryStatuses: o, tournamentEvents: h }), U = a !== void 0 && [!0, !1].includes(a) && h.reduce((P, v) => P.concat(...(v.drawDefinitions || []).map((D) => uw({ drawDefinition: D }).allPositionedParticipantIds).filter(Boolean)), []), S = (P) => i?.reduce((v, D) => {
    let { accessor: y, value: w } = D, { values: b } = uo({ element: P, accessor: y });
    return v && b?.includes(w);
  }, !0);
  if (r = r?.filter((P) => {
    let v = li({ element: P, itemType: Au })?.timeItem?.itemValue, { participantRoleResponsibilities: D, participantType: y, participantRole: w, participantId: b, person: T } = P, R = Array.isArray(f) && f?.length && T?.sex && f.includes(T.sex);
    return p ? f && R || a && U.includes(b) || a === !1 && !U.includes(b) || g?.includes(b) || I?.includes(b) || l?.includes(b) || d && v === d || u && y && sn(u) && u.includes(y) || s && w && sn(s) && s.includes(w) || c && sn(D) && sn(c) && c.find((M) => D?.includes(M)) || i?.length && sn(i) && S(P) : (!f || R) && (a === void 0 || a && U.includes(b) || a === !1 && !U.includes(b)) && (!g || g.includes(b)) && (!I || I.includes(b)) && (!l || l.includes(b)) && (!d || v === d) && (!u || y && sn(u) && u.includes(y)) && (!s || w && sn(s) && s.includes(w)) && (!c || sn(D) && sn(c) && c.find((M) => D?.includes(M))) && (!i?.length || sn(i) && S(P));
  }), h.length && m) {
    let P = h.filter((v) => m.includes(v.eventId)).map((v) => {
      let D = (v.entries || []).map((w) => w.participantId);
      if (bt(Ki)(v.eventType)) return D;
      let y = (t?.participants ?? []).filter((w) => D.includes(w.participantId)).map((w) => w.individualParticipantIds).flat(1);
      return D.concat(...y);
    }).flat(1);
    r = r?.filter((v) => P.includes(v.participantId));
  }
  return r;
}
function sn(e) {
  return e && Array.isArray(e) && e.length;
}
function ik({ drawEntryStatuses: e, tournamentEvents: t }) {
  let r = ({ entryStatus: i }) => Array.isArray(e) ? e.includes(i) : !0;
  return Ue(t.reduce((i, n) => {
    let { flightProfile: a } = wt({ event: n }), o = a?.flights?.map(({ drawEntries: c }) => Array.isArray(c) ? c.filter(r).map(Re) : []).flat() || [], s = n.drawDefinitions?.map(({ entries: c }) => c ? c.filter(r).map(Re) : []) || [];
    return i.concat(...o, ...s);
  }, []));
}
function nk({ eventEntryStatuses: e, tournamentEvents: t }) {
  return Ue(t.reduce((r, i) => {
    let n = (i.entries || []).filter(({ entryStatus: a }) => Array.isArray(e) ? e.includes(a) : !0).map(Re);
    return r.concat(...n);
  }, []));
}
function ft(e) {
  let { withIndividualParticipants: t, participantFilters: r = {}, withPotentialMatchUps: i, withRankingProfile: n, convertExtensions: a, policyDefinitions: o, withScheduleItems: s, tournamentRecord: c, scheduleAnalysis: u, withSignInStatus: l, withTeamMatchUps: d, withScaleValues: p, usePublishState: m, withStatistics: f, contextFilters: h, matchUpFilters: g, contextProfile: I, withOpponents: U, withMatchUps: S, internalUse: P, withSeeding: v, withEvents: D, withDraws: y, withISO2: w, withIOC: b } = e;
  if (!c) return { error: J };
  (S || n) && Ei({ tournamentRecord: c });
  let T = Dw({ convertExtensions: a, tournamentRecord: c, withSignInStatus: l, withScaleValues: p, internalUse: P, withISO2: w, withIOC: b }), { participantMap: R } = T, M = rk({ withMatchUps: S ?? n, withEvents: D ?? n, withDraws: y ?? n, withPotentialMatchUps: i, participantFilters: r, withRankingProfile: n, convertExtensions: a, withScheduleItems: s, policyDefinitions: o, tournamentRecord: c, scheduleAnalysis: u, withTeamMatchUps: d, usePublishState: m, withStatistics: f, contextFilters: h, matchUpFilters: g, participantMap: R, withOpponents: U, contextProfile: I, withSeeding: v }), { participantIdsWithConflicts: E, eventsPublishStatuses: A, derivedEventInfo: N, derivedDrawInfo: C, mappedMatchUps: k } = M, O = M.matchUps;
  R = M.participantMap;
  let _ = u ?? i, B = ({ potentialMatchUps: $, scheduleConflicts: q, scheduleItems: Y, participant: W, statistics: K, opponents: Q, matchUps: X, events: ee, draws: Z }) => {
    let ce = Object.values(Z), fe = Object.values(Q);
    return U && ce?.forEach((He) => {
      He.opponents = fe.filter((Te) => Te.drawId === He.drawId);
    }), ae({ ...W, scheduleConflicts: u ? Object.values(q) : void 0, draws: y || n ? ce : void 0, events: D || n ? Object.values(ee) : void 0, matchUps: S || n ? Object.values(X) : void 0, opponents: U ? fe : void 0, potentialMatchUps: _ ? Object.values($) : void 0, statistics: f ? Object.values(K) : void 0, scheduleItems: s ? Y : void 0 }, !1, !1, !0);
  }, L = /* @__PURE__ */ new Map();
  for (let $ of Object.keys(R)) L.set($, B(R[$]));
  let j = [...L.values()], H = o?.[Xs]?.participant, G = Ku({ participants: j, participantFilters: r, tournamentRecord: c });
  if (t) {
    let $ = xe(t) ? t : void 0;
    for (let q of G) for (let Y of q.individualParticipantIds ?? []) {
      q.individualParticipants || (q.individualParticipants = []);
      let W = L.get(Y), K = $ ? vo({ template: $, source: W }) : W;
      q.individualParticipants.push(K);
    }
  }
  let V = H ? G.map(($) => vo({ source: $, template: H })) : G;
  return { participantMap: e.returnParticipantMap !== !1 ? R : void 0, mappedMatchUps: e.returnMatchUps !== !1 ? k : void 0, matchUps: e.returnMatchUps !== !1 ? O : void 0, missingParticipantIds: T.missingParticipantIds, participantIdsWithConflicts: E, eventsPublishStatuses: A, derivedEventInfo: N, derivedDrawInfo: C, participants: V, ...x };
}
function lo({ participantId: e, drawDefinition: t, entryStatus: r, entryStage: i }) {
  if (!t) return { error: ne };
  let n = t.entries?.find((a) => a.participantId === e && (!r || r === a.entryStatus) && (!i || i === a.entryStage));
  return e && n;
}
function ic(e) {
  let { provisionalPositioning: t, drawDefinition: r, stageSequence: i, structureId: n, stage: a } = e;
  if (!r) return { error: ne };
  let { entryProfile: o } = ku({ drawDefinition: r }), s = a && i && o?.[a]?.stageSequence?.[i]?.qualifiersCount || a && o?.[a]?.qualifiersCount || 0, c = {};
  if (!n) return { qualifiersCount: s, roundQualifiersCounts: c };
  let { structure: u } = me({ drawDefinition: r, structureId: n }), l = r.links?.filter((m) => m?.target?.structureId === u?.structureId), d = 0;
  if (l?.length) for (let m of l) {
    let f = me({ structureId: m.source.structureId, drawDefinition: r })?.structure;
    if (f?.stage === se) {
      let h = m.source.roundNumber, g = m.target.roundNumber, I = 0;
      if (f.structureType === yr) {
        let U = f.structures?.length ?? 0, S = m.source.finishingPositions?.length ?? 0;
        I = U * S;
      } else I = Ve({ matchUpFilters: { roundNumbers: [h] }, structure: f, afterRecoveryTimes: !1, provisionalPositioning: t, inContext: !1 }).matchUps?.length || 0;
      c[g] || (c[g] = 0), c[g] += I, d += I;
    }
  }
  let p = Object.keys(c);
  if (p.length <= 1) {
    let m = p[0] || 1;
    c[m] = Math.max(c[m] || 0, s);
  }
  return d = Math.max(d, s), { qualifiersCount: d, roundQualifiersCounts: c };
}
function cd({ stage: e, drawDefinition: t }) {
  let { entryProfile: r } = ku({ drawDefinition: t });
  return r?.[e]?.drawSize || 0;
}
function ak(e) {
  let { provisionalPositioning: t, drawDefinition: r, stageSequence: i, stage: n } = e, a = cd({ stage: n, drawDefinition: r }), { qualifiersCount: o } = ic({ provisionalPositioning: t, drawDefinition: r, stageSequence: i, stage: n });
  return a && a - o;
}
function eT({ stage: e, drawDefinition: t }) {
  return !!(e === zt || Ng({ stage: e, drawDefinition: t }) && cd({ stage: e, drawDefinition: t }));
}
function tT({ entryStatus: e = kr, drawDefinition: t, stageSequence: r, stage: i }) {
  if (e === vi) return X1({ stage: i, drawDefinition: t }) ? { positionsAvailable: 1 / 0, ...x } : { error: aP };
  let n = ak({ drawDefinition: t, stageSequence: r, stage: i }), a = J1({ drawDefinition: t, stage: i }), o = Pf({ entryStatus: As, drawDefinition: t, stage: i }), s = Pf({ entryStatus: kr, drawDefinition: t, stage: i }), c = o + s, u = c >= n, l = n - c;
  return i !== zt && u ? { error: df } : e === As ? o < a ? { ...x } : { error: df } : { positionsAvailable: l, ...x };
}
function jg(e) {
  let t = oe(e, [{ [lr]: !0, [_D]: !0 }]);
  if (t.error) return t;
  let { suppressDuplicateEntries: r = !0, entryStatus: i = kr, entryStageSequence: n, entryStage: a = re, ignoreStageSpace: o, drawDefinition: s, entryPosition: c, participant: u, roundTarget: l, extensions: d, extension: p, drawType: m, event: f } = e, h = "addDrawEntry";
  if (m !== Gr && !eT({ stage: a, drawDefinition: s })) return F({ result: { error: Wa }, stack: h });
  let g = tT({ stageSequence: n, stage: a, drawDefinition: s, entryStatus: i });
  if (!o && !g.success && (!m || m !== Gr)) return { error: g.error };
  if (p && !Xi({ extension: p })) return F({ result: { error: z }, info: "Invalid extension", context: { extension: p }, stack: h });
  let I = e.participantId || u?.participantId;
  if (!I) return F({ result: { error: Ft }, stack: h });
  let U = i === Bn && lo({ participantId: I, drawDefinition: s, entryStatus: i }), S = a === zt && lo({ participantId: I, drawDefinition: s, entryStage: a }), P = lo({ participantId: I, drawDefinition: s }), v = i !== Bn && a !== zt && P;
  if (v) return r ? (Se({ payload: { drawId: s.drawId, eventId: f?.eventId, error: kc, participantId: I }, topic: dg }), { ...x }) : F({ result: { error: kc }, context: { participantId: I }, stack: h });
  if (U || S) return F({ context: { invalidEntry: v, invalidLuckyLoser: U, invalidVoluntaryConsolation: S }, result: { error: xd }, stack: h });
  let D = ae({ entryStageSequence: n, participantId: I, entryPosition: c, entryStatus: i, entryStage: a, extensions: d });
  return p && Be({ element: D, extension: p }), l && Be({ extension: { name: "roundEntry", value: l }, element: D }), s.entries || (s.entries = []), s.entries.push(D), tt({ drawDefinition: s }), { ...x };
}
function ok(e) {
  let t = "addDrawEntries", { suppressDuplicateEntries: r = !0, entryStatus: i = kr, autoEntryPositions: n = !0, ignoreStageSpace: a, participantIds: o, drawDefinition: s, stageSequence: c, stage: u = re, roundTarget: l, extension: d, event: p } = e, m = s.drawType === Gr;
  if (!u) return { error: Fv };
  if (!s) return { error: ne };
  if (!Array.isArray(o)) return { error: _r };
  if (!m && !eT({ stage: u, drawDefinition: s })) return { error: Wa };
  if (d && !Xi({ extension: d })) return F({ result: { error: z }, info: "Invalid extension", context: { extension: d }, stack: t });
  let f = tT({ drawDefinition: s, stageSequence: c, entryStatus: i, stage: u });
  if (!a && !f.success && !m) return { error: f.error };
  let h = f.positionsAvailable ?? 0;
  if (!a && !m && u !== zt && h < o.length) return { error: Ih };
  let g = [], I = s.drawId, U = p?.eventId, S = o.reduce((P, v) => {
    let D = i === Bn && lo({ participantId: v, drawDefinition: s, entryStatus: i }), y = u === zt && lo({ entryStage: u, drawDefinition: s, participantId: v }), w = lo({ participantId: v, drawDefinition: s });
    return i !== Bn && u !== zt && w && (g.push(v), r && Se({ payload: { error: kc, participantId: v, eventId: U, drawId: I }, topic: dg })), D || y ? P.concat(v) : P;
  }, []);
  return g.length && !r ? F({ context: { eventId: U, drawId: I, duplicateEntries: g }, result: { error: kc }, stack: t }) : (o.filter((P) => P && !S.includes(P)).forEach((P) => {
    let v = { entryStageSequence: c, entryStage: u, participantId: P, entryStatus: i };
    d && Be({ element: v, extension: d }), l && Be({ extension: { name: rn, value: l }, element: v }), s.entries || (s.entries = []), s.entries.push(v);
  }), n && (s.entries = xi({ entries: s.entries })), tt({ drawDefinition: s }), S?.length || g?.length ? { info: "some participantIds could not be added", participantIdsNotAdded: S, duplicateEntries: g, ...x } : { ...x });
}
function Gg({ suppressDuplicateEntries: e = !0, autoEntryPositions: t = !0, entryStageSequence: r, ignoreStageSpace: i, participantIds: n, drawDefinition: a, entryStatus: o, roundTarget: s, entryStage: c, extension: u, drawId: l, event: d }) {
  if (!n?.length) return { error: la };
  if (!d) return { error: ni };
  if (!l) return { error: Vi };
  let p = (d.entries || []).map(Re);
  if (n.filter((h) => !p.includes(h)).length) return { error: kv };
  if (a) {
    let h = ok({ stageSequence: r, suppressDuplicateEntries: e, autoEntryPositions: t, stage: c, ignoreStageSpace: i, participantIds: n, drawDefinition: a, entryStatus: o, roundTarget: s, extension: u });
    if (h.error) return h;
  }
  let { flightProfile: m } = wt({ event: d }), f = m?.flights.find((h) => h.drawId === l);
  return f?.drawEntries && (n.forEach((h) => {
    let g = o === Bn && _m({ participantId: h, entryStatus: o, flight: f }), I = c === zt && _m({ participantId: h, entryStage: c, flight: f });
    !(o !== Bn && c !== zt && _m({ flight: f, participantId: h })) && !g && !I && f.drawEntries.push({ participantId: h, entryStatus: o, entryStage: c });
  }), t && (f.drawEntries = xi({ entries: f.drawEntries }))), { ...x };
}
function _m({ participantId: e, entryStatus: t, entryStage: r, flight: i }) {
  let n = i.drawEntries?.find((a) => a.participantId === e && (!t || t === a.entryStatus) && (!r || r === a.entryStage));
  return e && n;
}
function Qu({ autoEntryPositions: e = !0, participantIds: t = [], entryStatuses: r, stage: i, event: n }) {
  let a = "removeEventEntries";
  if (!n?.eventId) return { error: st };
  if (!Array.isArray(t) || t.some((d) => !dt(d))) return F({ result: { error: Li }, stack: a });
  let o = (n.drawDefinitions ?? []).flatMap((d) => eo({ drawDefinition: d }).assignedParticipantIds ?? []), s = (r?.length && n.entries?.filter((d) => d.entryStatus && r.includes(d.entryStatus)) || []).map(Re).filter((d) => !o.includes(d)), c = (i && n.entries?.filter((d) => d.entryStage && d.entryStage === i) || []).map(Re).filter((d) => !o.includes(d));
  if (t.length ? t = t.filter((d) => (!r?.length || s.includes(d)) && (!i || c.includes(d))) : s.length && c.length ? t = Pt(s, c) : s.length ? t = s : c.length && (t = c), t?.length && o.some((d) => t.includes(d))) return F({ result: { error: qs }, stack: a });
  if (!t?.length) return { ...x, participantIdsRemoved: [] };
  let u = [];
  n.entries = (n.entries ?? []).filter((d) => {
    let p = !t.includes(d?.participantId);
    return p || u.push(d.participantId), p;
  }), e && (n.entries = xi({ entries: n.entries }));
  let { flightProfile: l } = wt({ event: n });
  return l?.flights?.forEach((d) => {
    d.drawEntries = (d.drawEntries || []).filter((p) => !t.includes(p.participantId));
  }), n.drawDefinitions?.forEach((d) => {
    d.entries = (d.entries ?? []).filter((p) => !t.includes(p.participantId));
  }), { ...x, participantIdsRemoved: u };
}
var rT = { [Yt]: { policyName: "matchUpActionsDefault", enabledStructures: [{ stages: [], stageSequences: [], enabledActions: [], disabledActions: [] }], participants: { enforceCategory: !0, enforceGender: !0 }, processCodes: { substitution: ["RANKING.IGNORE", "RATING.IGNORE"] }, substituteAfterCompleted: !1, substituteWithoutScore: !1 } }, nc = rT;
function Hi(e) {
  let { suppressDuplicateEntries: t = !0, entryStatus: r = kr, autoEntryPositions: i = !0, enforceGender: n = !0, entryStageSequence: a, policyDefinitions: o, entryStage: s = re, tournamentRecord: c, ignoreStageSpace: u, drawDefinition: l, roundTarget: d, extensions: p, extension: m, drawId: f, event: h } = e, g = "addEventEntries";
  if (!Array.isArray(e.participantIds)) return F({ result: { error: _r }, stack: g });
  let I = Ue(e.participantIds ?? []);
  if (!h) return { error: st };
  if (!I?.length) return F({ result: { error: la }, stack: g });
  if (!h?.eventId) return { error: ni };
  let U = _e({ tournamentRecord: c, event: h }).appliedPolicies ?? {}, S = o?.[Yt] ?? U?.[Yt] ?? nc[Yt], P = (n ?? S?.participants?.enforceGender) !== !1, v = [], D = [];
  if (p && (!Array.isArray(p) || !p.every((N) => Xi({ extension: N }))) || m && !Xi({ extension: m })) return F({ context: ae({ extension: m, extensions: p }), result: { error: z }, info: "Invalid extension(s)", stack: g });
  let y = !!c, w = [], b, T = c?.participants?.filter((N) => {
    if (!I.includes(N.participantId)) return !1;
    let C = bt(Xe)(h.eventType) && N.participantType === Ne && !Pa(r), k = h.eventType === Ke && N.participantType === De;
    return C && (!h.gender || !P || [vr, "ANY"].includes(h.gender) || h.gender === N.person?.sex) || k && !Pa(r) || h.eventType === Ke && N.participantType === Ne && Pa(r) ? !0 : C && h.gender && P && ![vr, "ANY"].includes(h.gender) && h.gender !== N.person?.sex ? (w.push({ participantId: N.participantId, sex: N.person?.sex }), !1) : h.eventType === We && (N.participantType === We || Pa(r) && N.participantType === Ne);
  }).map((N) => N.participantId) ?? [], R = I.filter((N) => !y || T.includes(N));
  h.entries || (h.entries = []);
  let M = h.entries.map((N) => N.participantId || N.participant?.participantId);
  if (R.forEach((N) => {
    if (!M.includes(N)) {
      let C = ae({ participantId: N, entryStatus: r, entryStage: s, extensions: p });
      m && Be({ element: C, extension: m }), d && Be({ extension: { name: rn, value: d }, element: C }), a && (C.entryStageSequence = a), v.push(C.participantId), h.entries?.push(C);
    }
  }), f && !Pa(s)) {
    let N = Gg({ participantIds: R, suppressDuplicateEntries: t, autoEntryPositions: i, entryStageSequence: a, ignoreStageSpace: u, drawDefinition: l, entryStatus: r, roundTarget: d, entryStage: s, extension: m, drawId: f, event: h });
    N.error && (b = N.error);
  }
  if (h.eventType && [xn, jr].includes(h.eventType)) {
    let N = (h.entries || []).map((_) => _.participantId), C = (h.entries || []).filter((_) => Pa(_.entryStatus)).map((_) => _.participantId), k = (c?.participants ?? []).filter((_) => N.includes(_.participantId) && _.participantType && [De, We].includes(_.participantType)).map((_) => _.individualParticipantIds).flat(1 / 0), O = C.filter((_) => k.includes(_));
    O.length && (D.push(...O), Qu({ participantIds: O, autoEntryPositions: !1, event: h }));
  }
  if (R.length !== I.length) return F({ context: { mismatchedGender: w, gender: h.gender }, result: { error: _r }, stack: g });
  i && (h.entries = xi({ entries: h.entries || [] }));
  let E = v.length, A = D.length;
  return F({ result: { ...x, addedEntriesCount: E, removedEntriesCount: A }, stack: g, info: b });
}
var iT = "ADMINISTRATION", sk = "CAPTAIN", ck = "COACH", rr = "COMPETITOR", nT = "MEDIA", aT = "MEDICAL", $g = "OFFICIAL", oT = "OTHER", sT = "SECURITY", qg = { ADMINISTRATION: iT, CAPTAIN: sk, COACH: ck, COMPETITOR: rr, MEDIA: nT, MEDICAL: aT, OFFICIAL: $g, OTHER: oT, SECURITY: sT };
function Wg({ addIndividualParticipantsToEvents: e, individualParticipantIds: t, groupingParticipantId: r, tournamentRecord: i, suppressErrors: n }) {
  let a = "removeIndividualParticipantIds";
  if (!i) return F({ result: { error: J }, stack: a });
  if (!r || !t) return F({ result: { error: ue }, stack: a });
  let o = (i.participants ?? []).find((l) => l.participantId === r);
  if (!o) return F({ result: { error: Tt }, stack: a });
  if (![We, Xr].includes(o.participantType)) return F({ result: { participantType: o.participantType, error: _i }, stack: a });
  let s = cT({ individualParticipantIds: t, groupingParticipant: o, tournamentRecord: i, suppressErrors: n }), { removed: c, error: u } = s;
  if (u) return F({ result: s, stack: a });
  if (e) for (let l of i.events ?? []) {
    let d = (l.entries ?? []).map(({ participantId: p }) => p).filter(Boolean);
    if (d.includes(r)) {
      let p = c?.filter((m) => !d.includes(m));
      Hi({ participantIds: p, entryStatus: di, tournamentRecord: i, event: l });
    }
  }
  return c && Se({ topic: ar, payload: { tournamentId: i.tournamentId, participants: [o] } }), { ...x, ...s };
}
function cT({ individualParticipantIds: e = [], groupingParticipant: t, tournamentRecord: r, suppressErrors: i, mappedMatchUps: n, participants: a }) {
  let o = [];
  if (!t) return { removed: o };
  let s = [], c = [];
  a || ({ participants: a, mappedMatchUps: n } = ft({ withMatchUps: !0, tournamentRecord: r, withEvents: !0 }));
  let u = a?.find(({ participantId: p }) => p === t.participantId)?.events?.map(({ eventId: p }) => p), l = (t.individualParticipantIds ?? []).filter((p) => {
    let m = e?.includes(p), f = m && a?.find((g) => g.participantId === p)?.matchUps.filter(({ eventId: g }) => u.includes(g)).map(({ matchUpId: g }) => n?.[g]).filter(({ winningSide: g, score: I }) => g || Bt({ score: I })), h = m && !f?.length;
    if (m && !h && c.push(p), h) {
      o.push(p);
      for (let g of r.events ?? []) for (let I of g.drawDefinitions ?? []) {
        let { extension: U } = we({ element: I, name: Fn }), S = U?.value[t.participantId];
        U && S && (U.value[t.participantId] = S.filter((v) => v.participantId !== p), Be({ element: I, extension: U }), Eu({ drawDefinition: I }));
        let P = hr({ drawDefinition: I, inContext: !1 }).matchUps ?? [];
        for (let v of P) {
          let D = v.sides ?? [];
          for (let y of D) {
            let w = y.lineUp ?? [];
            w.find((b) => b.participantId === p) && (y.lineUp = w.filter((b) => b.participantId !== p), Oe({ tournamentId: r?.tournamentId, drawDefinition: I, matchUp: v }));
          }
        }
      }
    } else s.push(p);
    return !h;
  });
  t.individualParticipantIds = l;
  let d = { groupingParticipantId: t.participantId, cannotRemove: c, notRemoved: s, removed: o };
  return c.length && !i && { ...d, cannotRemove: c, error: Od } || d;
}
function wp({ participantRole: e = rr, individualParticipantIds: t = [], groupingTypes: r = [Pr, Xr], tournamentRecord: i }) {
  if (!i) return { error: J };
  let n = i.participants ?? [], { participants: a, mappedMatchUps: o } = ft({ withMatchUps: !0, tournamentRecord: i, withEvents: !0 }), s = 0;
  return n.filter((c) => (c.participantRole === e || !c.participantRole) && c.participantType && r.includes(c.participantType)).forEach((c) => {
    let { removed: u } = cT({ groupingParticipant: c, individualParticipantIds: t, tournamentRecord: i, mappedMatchUps: o, participants: a });
    u && s++;
  }), s ? x : { error: eP };
}
function Yo(e) {
  let t = oe(e, [{ [Vt]: !0 }, { participantIds: !0, [Mr]: sr, [yi]: la }]);
  if (t.error) return t;
  let { addIndividualParticipantsToEvents: r, tournamentRecord: i, participantIds: n } = e, a = i.participants?.length || 0;
  if (!a) return { ...x };
  let o = (i.events || [])?.filter(({ eventType: f }) => f === kt).map((f) => f?.drawDefinitions?.map(({ drawId: h }) => h)).flat(1 / 0), s = ft({ participantFilters: { participantIds: n }, tournamentRecord: i, withDraws: !0 }).participants ?? [], c = (f) => {
    let h = (Jt({ matchUpFilters: { drawIds: f, matchUpTypes: [Ke] }, tournamentRecord: i }).matchUps ?? []).flatMap(({ sides: g }) => g?.map(({ participantId: I }) => I || [])).filter(Boolean);
    return Pt(h, n);
  }, u = o?.length ? c(o) : [], l = s.filter((f) => f.draws?.filter((h) => (!o?.length || !o?.includes(h.drawId)) && h.positionAssignments).length);
  if (u?.length || l.length) return { error: qs };
  let d = {}, p = {};
  for (let f of i.events || []) {
    let h = Qu({ participantIds: n, event: f });
    if (h.error) return h;
    d[f.eventId] = h.participantIdsRemoved;
  }
  i.participants = (i.participants ?? []).filter((f) => {
    let h = n.includes(f.participantId) || f.participantType === De && f.individualParticipantIds?.some((g) => n.includes(g));
    if (!h && f.participantType === kt && f.individualParticipantIds?.some((g) => n.includes(g)) && (f.individualParticipantIds = f.individualParticipantIds.filter((g) => !n.includes(g))), h && r && f.participantType && [De, We].includes(f.participantType)) for (let g of f.individualParticipantIds || []) n.includes(g) || (p[f.participantId] || (p[f.participantId] = []), p[f.participantId].push(g));
    return !h;
  });
  let m = a - i.participants.length;
  if (wp({ individualParticipantIds: n, tournamentRecord: i }), r) for (let f of i.events || []) {
    let h = d[f.eventId].map((g) => p[g] || []).flat();
    Hi({ participantIds: h, entryStatus: di, tournamentRecord: i, event: f });
  }
  return m && Se({ payload: { participantIds: n, tournamentId: i.tournamentId }, topic: pg }), m ? { ...x, participantsRemovedCount: m } : { error: Od };
}
function uT({ selected: e = !0, drawDefinition: t, entryStatuses: r, drawId: i, event: n, stage: a }) {
  let o = n.entries ?? [];
  if (i) {
    let { flightProfile: c } = wt({ event: n }), u = c?.flights?.find((l) => l.drawId === i);
    u ? o = u.drawEntries : t.entries && (o = t?.entries);
  }
  let s = o.filter((c) => (!r?.length || !c.entryStatus || r.includes(c.entryStatus)) && (!a || !c.entryStage || c.entryStage === a) && (!e || c.entryStatus && Ni.includes(c.entryStatus)));
  return { entries: o, stageEntries: s };
}
function lT({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, stage: a, event: o }) {
  let s = "destroyGroupEntry";
  if (!t) return { error: J };
  if (!i) return F({ result: { error: Ft }, stack: s });
  if (!o) return { error: st };
  if (!o.eventType || ![xn, jr].includes(o.eventType)) return F({ result: { error: fn }, stack: s });
  let c = t.participants ?? [], u = c.find((I) => I.participantId === i);
  if (!u) return F({ result: { error: Tt }, stack: s });
  if (!u.participantType || ![De, Pr].includes(u.participantType) || u.participantType === Pr && o.eventType !== jr || u.participantType === De && o.eventType !== xn) return { error: _i };
  let l = (o.entries ?? []).find((I) => I.participantId === i);
  if (!l) return { error: nP };
  let { stageEntries: d } = uT({ selected: !1, drawDefinition: r, drawId: n, event: o, stage: a }), p = d.map(Re), m = c.filter(({ participantId: I }) => p.includes(I)).map(({ individualParticipantIds: I }) => I).flat().filter(Boolean), f = u.individualParticipantIds?.filter((I) => qi(I, m).length === 1), h = Qu({ participantIds: [i], event: o });
  if (h.error || f?.length && (h = Hi({ participantIds: f, entryStatus: di, entryStage: l.entryStage, tournamentRecord: t, drawDefinition: r, drawId: n, event: o }), h.error)) return h;
  let g;
  return e && Yo({ participantIds: [i], tournamentRecord: t }).success && (g = !0), { ...x, participantRemoved: g };
}
function Hg({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, event: a }) {
  return lT({ removeGroupParticipant: e, tournamentRecord: t, drawDefinition: r, participantId: i, drawId: n, event: a });
}
function dT(e) {
  if (!e.tournamentRecord) return { error: J };
  let { participantIds: t, ...r } = e, i = 0, n = [];
  for (let a of t) {
    let o = lT({ participantId: a, ...r });
    o.success && (i += 1), o.error && n.push(o.error);
  }
  return i ? { destroyedCount: i, ...x } : { error: n };
}
function Zc(e) {
  let { tournamentRecord: t, replaceWithBye: r, drawDefinition: i, destroyPair: n, entryStatus: a, matchUpsMap: o, drawId: s } = e, c = "removeDrawPositionAssignment", u = zu(e);
  if (u.error) return F({ result: u, stack: c });
  let { participantId: l } = u, { drawPosition: d, event: p, structureId: m } = e, f = _e({ tournamentRecord: t, drawDefinition: i, event: p }).appliedPolicies ?? {};
  if ([vi, Pn].includes(a) && l) {
    let { tournamentRecord: g } = e, { participant: I } = ha({ tournamentRecord: g, participantId: l }), { participantType: U, individualParticipantIds: S } = I ?? {};
    if (n && U === De) {
      let P = Hg({ tournamentRecord: g, drawDefinition: i, participantId: l, event: p });
      if (P.error) return F({ result: P, stack: c });
      S && sd({ participantIds: S, tournamentRecord: g, drawDefinition: i, entryStatus: a, drawId: s, event: p });
    } else sd({ participantIds: [l], tournamentRecord: g, drawDefinition: i, entryStatus: a, drawId: s, event: p });
  }
  if (r) {
    let g = Zr({ tournamentRecord: t, drawDefinition: i, drawPosition: d, structureId: m, matchUpsMap: o, event: p });
    if (g.error) return F({ result: g, stack: c });
  }
  let { structure: h } = me({ drawDefinition: i, structureId: m });
  return Dg({ structure: h, drawPositions: [d] }), dp({ appliedPolicies: f, drawDefinition: i, positionAction: { name: "removeDrawPositionAssignment", replaceWithBye: r, drawPosition: d, entryStatus: a, structureId: m } }), u;
}
function pT(e) {
  return Object.assign(e, { entryStatus: Pn }), Zc(e);
}
var ta = ({ finishingPosition: e = Fo, hasExistingDrawDefinition: t, qualifyingRoundNumber: r, structureAbbreviation: i, seedAssignments: n = [], stageSequence: a = 1, qualifyingOnly: o, structureOrder: s, seedingProfile: c, matchUpFormat: u, structureType: l, structureName: d, matchUps: p = [], matchUpType: m, structureId: f, roundOffset: h, roundLimit: g, stageOrder: I, structures: U, tieFormat: S, stage: P }) => {
  let v = { structureId: f ?? je(), structureAbbreviation: i, finishingPosition: e, seedAssignments: n, matchUpFormat: u, stageSequence: a, structureName: d };
  (o || t && S) && (v.tieFormat = S), s && (v.structureOrder = s), l && (v.structureType = l), c && (typeof c == "string" ? v.seedingProfile = c : typeof c == "object" && typeof c.positioning == "string" && (v.seedingProfile = c.positioning)), m && (v.matchUpType = m), h && (v.roundOffset = h), I && (v.stageOrder = I), g && (v.roundLimit = g), P && (v.stage = P), r && (v.qualifyingRoundNumber = r);
  let D = p.flatMap(({ drawPositions: y }) => y).filter(Boolean);
  return U ? v.structures = U : (v.matchUps = p, v.positionAssignments = Ue(D).sort((y, w) => y - w).map((y) => ({ drawPosition: y }))), v;
}, ii = ta;
function Nf(e) {
  return dt(e) ? e.split(" ").map((t) => t.split("").map((r, i) => i ? r.toLowerCase() : r.toUpperCase()).join("")).join(" ") : e;
}
function ir(e) {
  return dt(e) ? Nf(e.replace(/_/g, " ")) : "";
}
function zg({ structureName: e = ir(zt), structureAbbreviation: t, drawDefinition: r, matchUpType: i, structureId: n }) {
  if (!r) return { error: ne };
  let a = ii({ stage: zt, structureAbbreviation: t, structureName: e, matchUps: [], structureId: n, matchUpType: i });
  return r.structures || (r.structures = []), r.structures.push(a), tt({ drawDefinition: r, structureIds: [a.structureId] }), { ...x };
}
function Yg({ drawPositions: e }) {
  if (!e?.length) return { error: pu };
  let t = (n) => e.filter((a) => a !== n).map((a) => [n, a]), r = [].concat(...(e ?? []).map(t)), i = Ue(r.map(Tp)).map((n) => n.split("|").map((a) => +a));
  return { groupMatchUps: r, uniqueMatchUpGroupings: i };
}
function Tp(e = []) {
  return !Array.isArray(e) || !e.length ? "" : [...e].sort(Ot).join("|");
}
function mT({ groupSize: e, drawPositionOffset: t }) {
  if (!e) return [];
  let r = (d) => [...Array(d)].map((p, m) => m), i = r(2 * Math.round(e / 2) + 1).slice(1), n = r(i.length - 1).map(() => []), a = i.slice(0, i.length / 2), o = i.slice(i.length / 2);
  i.slice(1).forEach((d, p) => {
    a.forEach((g, I) => {
      n[p].push([a[I], o[I]]);
    });
    let m = a.shift(), f = a.pop(), h = o.shift();
    a = [m, h, ...a].filter(Boolean), o = [...o, f].filter(Boolean);
  });
  let s = a.shift(), c = a.pop(), u = o.shift();
  a = [s, u, ...a].filter(Boolean), o = [...o, c].filter(Boolean);
  let l = (d) => d[0].reduce((p, m) => p + m);
  return [...n].reverse().sort((d, p) => l(d) - l(p)).map((d) => d.filter((p) => p.every((m) => m <= e)).map((p) => {
    let m = p.map((f) => f + t);
    return Tp(m);
  }));
}
function uk({ rounds: e, hash: t }) {
  return e?.length ? e?.reduce((r, i, n) => i.includes(t) ? n + 1 : r, void 0) : { error: ue };
}
var lk = { getRoundRobinGroupMatchUps: Yg, determineRoundNumber: uk, drawPositionsHash: Tp, groupRounds: mT };
function Xu(e) {
  let { hasExistingDrawDefinition: t, groupNameBase: r = "Group", playoffAttributes: i, stageSequence: n = 1, structureOptions: a, appliedPolicies: o, qualifyingOnly: s, seedingProfile: c, stage: u = re, matchUpType: l, roundTarget: d, structureId: p, groupNames: m, tieFormat: f, drawSize: h, idPrefix: g, isMock: I, uuids: U } = e, S = e.structureName ?? i?.["0"]?.name ?? ir(re), { groupCount: P, groupSize: v } = dk({ structureOptions: a, appliedPolicies: o, drawSize: h }), D = Aa, y, w = te(1, P + 1).map((T) => {
    let R = pk({ groupSize: v, structureOrder: T, matchUpType: l, drawSize: h, idPrefix: g, isMock: I });
    y = Array.isArray(R) ? Math.max(...R.map(({ roundNumber: E }) => E ?? 0)) : 0;
    let M = m?.[T - 1] ?? `${r} ${T}`;
    return ta({ structureId: U?.pop(), hasExistingDrawDefinition: t, structureType: Yd, finishingPosition: D, qualifyingOnly: s, structureOrder: T, structureName: M, tieFormat: f, matchUps: R });
  }), b = ta({ structureId: p ?? U?.pop(), hasExistingDrawDefinition: t, structureType: yr, finishingPosition: D, seedingProfile: c, structureName: S, stageSequence: n, structures: w, tieFormat: f, stage: u });
  return d && Be({ extension: { name: rn, value: d }, element: b }), { structures: [b], maxRoundNumber: y, groupCount: P, links: [], groupSize: v, ...x };
}
function dk({ appliedPolicies: e, structureOptions: t, drawSize: r }) {
  let i = t?.groupSize, n = t?.groupSizeLimit || 8, { validGroupSizes: a } = Ju({ groupSizeLimit: n, drawSize: r }), o = a && Math.max(...a);
  i && a?.includes(i) || (i && i > 4 || !a?.includes(4) ? i = o : i = 4);
  let s = Math.ceil(r / i);
  return { groupSize: i, groupCount: s };
}
function Ju(e) {
  let { groupSizeLimit: t = 10, drawSize: r = 0 } = e ?? {}, i = te(3, t + 1).filter((n) => {
    let a = Math.ceil(r / n), o = a * n - r, s = Math.ceil(r / a), c = Math.ceil(o / a);
    return (!o || o < n) && s === n && s >= 3 && c < 2;
  });
  return { ...x, validGroupSizes: i };
}
function pk({ structureOrder: e, matchUpType: t, groupSize: r, drawSize: i, idPrefix: n, isMock: a, uuids: o }) {
  let s = (e - 1) * r, c = te(1 + s, r + 1 + s), u = Yg({ drawPositions: c }).uniqueMatchUpGroupings ?? [], l = mT({ groupSize: r, drawPositionOffset: s });
  return u.map(p).sort((m, f) => (m.roundNumber ?? 1 / 0) - (f.roundNumber ?? 1 / 0));
  function d(m) {
    return l.reduce((f, h, g) => h.includes(m) ? g + 1 : f, void 0);
  }
  function p(m) {
    let f = Tp(m), h = d(f), g = [1, i], I = mk({ structureOrder: e, drawPositions: m, roundNumber: h, idPrefix: n, uuids: o }), U = { matchUpStatus: h ? Dt : "BYE", matchUpType: t, finishingPositionRange: { winner: g, loser: g }, drawPositions: m, roundNumber: h, matchUpId: I };
    return a && (U.isMock = !0), U;
  }
}
function mk({ structureOrder: e, drawPositions: t, roundNumber: r, idPrefix: i, uuids: n }) {
  return i ? `${i}-${e}-${r}-DP-${t.join("-")}` : n?.pop() || je();
}
function Kg(e) {
  let { roundRobinGroupsCount: t, participantsCount: r, cluster: i } = e;
  if (!Ie(r)) return { seedBlocks: void 0, ...F({ result: { error: z }, context: { participantsCount: r }, stack: "getSeedBlocks" }) };
  let n = Bs(r);
  if (t) {
    let m = Math.min(t, n), f = [], h = 1;
    for (te(0, m).forEach(() => {
      f.push([h]), h++;
    }); h < n; ) {
      let g = te(h, h + m);
      h += m, f.push(g);
    }
    return { ...x, seedBlocks: f };
  }
  let a = te(1, n + 1), o = [], s = n / 2;
  for (; s > 1; ) {
    let m = qt(a, s), f = m.length;
    m.forEach((h, g) => {
      let I, U = g < f / 2, S = g % 2 === 0, P = h[0], v = h[h.length - 1];
      i && f > 4 ? f === 8 ? I = U ? v : P : I = S ? P : v : I = U ? P : v, gr(h, o) || o.push(I);
    }), s = s / 2;
  }
  let c = a.filter((m) => !o.includes(m));
  for (; c.length; ) c.length % 2 === 0 ? o.push(c.pop()) : o.push(c.shift());
  let u = te(0, 20).map((m) => Math.pow(2, m));
  u.unshift(1);
  let l = u.indexOf(n), d = 0, p = [];
  return te(0, l).forEach((m) => {
    p.push(o.slice(d, d + u[m])), d += u[m];
  }), { ...x, seedBlocks: p };
}
function Qg({ roundRobinGroupsCount: e, drawSize: t }) {
  let r = "getSeedGroups";
  if (!Ie(t)) return { seedGroups: void 0, ...F({ result: { error: z }, context: { drawSize: t }, stack: r }) };
  if (e) {
    if (!Ie(e)) return { seedGroups: void 0, ...F({ context: { roundRobinGroupsCount: e }, result: { error: z }, stack: r }) };
    let i = 1, n = Math.floor(t / e);
    return { seedGroups: te(0, n).map(() => {
      let a = te(i, i + e);
      return i += e, a;
    }) };
  } else {
    let { seedBlocks: i } = Kg({ participantsCount: t, roundRobinGroupsCount: e }), n = 0;
    return { seedGroups: (i || []).map((a) => (a || []).map(() => (n += 1, n))) };
  }
}
function Xg({ roundRobinGroupsCount: e, participantsCount: t }) {
  if (e) {
    let { validGroupSizes: n } = Ju({ drawSize: t });
    if (!n?.map((a) => Math.ceil(t / a))?.includes(e)) return F({ context: { roundRobinGroupsCount: e }, result: { error: z } });
  }
  let { seedGroups: r } = Qg({ drawSize: t, roundRobinGroupsCount: e }), i = r?.map((n) => Math.min(...n)) || [];
  return { ...x, seedingThresholds: i };
}
function Os(e) {
  if (!e) return 1 / 0;
  if (Ie(e)) return pe(e);
  let t = e.split("-")[0];
  return Ie(t) ? pe(t) : 1 / 0;
}
function fk({ size: e }) {
  let t = [e], r = e;
  for (; r / 2 === Math.floor(r / 2); ) r = r / 2, t.push(r);
  return t.includes(1) || t.push(1), t.sort(Ot), t.reverse(), t;
}
function hk({ blockPattern: e, index: t }) {
  let r = 0;
  for (let i of e) {
    if (r === t) return i;
    let n = 0;
    for (; n < i.length; ) {
      if (r === t) return i;
      r += 1, n++;
    }
  }
}
function gk({ positioning: e, size: t }) {
  let r = fk({ size: t }), i = [], n = [], a = (p) => p[0], o = (p) => p[p.length - 1], s = (p, m) => (e && [zd, Na].includes(e) && m % 2 ? o(p) : a(p)) || a(p), c = (p, m) => {
    if (p.every((f) => !n.includes(f))) {
      let f = s(p, m);
      return n.push(f), f;
    }
  }, u = (p) => {
    let m = p.filter((f) => !n.includes(f));
    if (m.length) return n.push(...m), m;
  }, l = (p, m) => {
    let f = s(p, m);
    if (!n.includes(f)) return n.push(f), f;
  }, d = te(1, t + 1);
  for (let p of r) if (p === 1) {
    let m = qt(d, 2), f = m.map(c).filter(Boolean);
    f.length && i.push(f);
    let h = m.flatMap(u).filter(Boolean);
    h.length && i.push(h);
  } else {
    let m = qt(d, p).map(l).filter(Boolean);
    m.length && i.push(m);
  }
  return { divisions: r, divisionGroupings: i };
}
function Ko({ provisionalPositioning: e, returnAllProxies: t, appliedPolicies: r, seedingProfile: i, drawDefinition: n, allPositions: a, structure: o }) {
  let s = [];
  if (!o) return { error: qa };
  let { matchUps: c, roundMatchUps: u } = Ve({ matchUpFilters: { roundNumbers: [1] }, provisionalPositioning: e, structure: o }), { seedAssignments: l } = si({ provisionalPositioning: e, returnAllProxies: t, drawDefinition: n, structure: o }), { positionAssignments: d } = _t({ structure: o }), p = d?.length, m = l?.length ?? 0, f = [], h = Object.keys(u).map((C) => parseInt(C)).sort((C, k) => C - k).map((C) => {
    let k = u[C].map((_) => _.drawPositions).flat(1 / 0).filter(Boolean), O = k.filter((_) => !f.includes(_));
    return f = f.concat(...k), O;
  }).filter((C) => C.length).reverse(), g = h.pop() ?? [], I = g && Math.min(...g) - 1 || 0;
  i = i ?? r?.seeding?.seedingProfile;
  let U = g?.length || 0, S = h.filter((C) => C.filter((k) => k <= m).length), { stage: P, structureType: v, roundLimit: D } = o, y = v === yr, w = !y && h?.length, b = !y && P === se && D, T = S.flat(1 / 0), R = w ? T?.length : 0, M = a ? p : m, E = Eg({ drawDefinition: n, structure: o, matchUps: c }), A = E ? 0 : !w && M || M && T.length < M && M - T.length || 0;
  if (b) {
    let C = o?.matchUps ? o.matchUps.filter(({ roundNumber: O }) => O === o.roundLimit).length : 0, k = g.length / C;
    if (!w) {
      let O = Zu(i), _ = qt(g, k), B = 1, L = te(0, _[0].length).map(() => {
        let j = te(B, B + _.length);
        return B += _.length, j;
      });
      ({ validSeedBlocks: s } = fT({ drawPositionBlocks: _, nonRandom: i?.nonRandom, positioning: O, seedGroups: L }));
    }
  } else y ? { validSeedBlocks: s } = Ik({ nonRandom: i?.nonRandom, seedingProfile: i, structure: o }) : w ? s = S.map((C) => ({ seedNumbers: C, drawPositions: C })) : E && qt(g, 2).map((C, k) => ({ drawPositions: [C[0]], seedNumbers: [k + 1] })).forEach((C) => s.push(C));
  if (!y && !E && !b) {
    let { blocks: C } = Uk({ drawPositionOffset: I, seedNumberOffset: R, seedCountGoal: A, seedingProfile: i, baseDrawSize: U });
    C.forEach((k) => s.push(k));
  }
  let N = s.flatMap((C) => C.drawPositions).reduce((C, k) => g?.includes(k) && C, !0);
  return !E && !w && !y && !N ? { error: Ev, validSeedBlocks: [], isContainer: y, isFeedIn: w } : { isLuckyStructure: E, validSeedBlocks: s, isContainer: y, isFeedIn: w };
}
function Ik({ seedingProfile: e, structure: t, nonRandom: r }) {
  let i = t.structures || [], n = i.length, a = Je({ structure: t })?.positionAssignments, o = Zu(e), s = a?.length ?? 0, { seedGroups: c } = Qg({ roundRobinGroupsCount: n, drawSize: s }), u = i.map((l) => Je({ structure: l }).positionAssignments?.map((d) => d.drawPosition));
  return fT({ drawPositionBlocks: u, positioning: o, seedGroups: c, nonRandom: r });
}
function fT({ drawPositionBlocks: e, positioning: t, seedGroups: r, nonRandom: i }) {
  let n = [], { divisionGroupings: a } = gk({ size: r.length, positioning: t }), o = [];
  return r.forEach((s, c) => {
    let u = hk({ blockPattern: a, index: c });
    s.forEach((l, d) => {
      let p = c % 2 ? e.length - d - 1 : d, m = e[p].slice().filter((h, g) => u.includes(g + 1) && h);
      t !== Na ? m = i ? m : mr(m) : c % 2 && m.reverse();
      let f = m.find((h) => !o.includes(h));
      f && (o.push(f), n.push({ drawPositions: [f], seedNumbers: [l] }));
    });
  }), { validSeedBlocks: n };
}
function Uk(e) {
  let { drawPositionOffset: t = 0, roundRobinGroupsCount: r, seedNumberOffset: i = 0, seedingProfile: n, seedCountGoal: a, baseDrawSize: o } = e, s = 1, c = [], { seedBlocks: u } = Kg({ cluster: Zu(n) === zd, participantsCount: o, roundRobinGroupsCount: r });
  s = 0;
  for (let d of u) {
    if (s + 1 > a) break;
    let p = d.map((f) => f + t), m = l(s + 1, d.length).map((f) => +f + i);
    s += d.length, c.push({ drawPositions: p, seedNumbers: m });
  }
  return { blocks: c };
  function l(d, p) {
    return Array.from(new Array(p), (m, f) => f + d);
  }
}
function ud({ appliedPolicies: e, drawDefinition: t, seedBlockInfo: r, drawPosition: i, structureId: n, seedNumber: a }) {
  let { structure: o } = me({ drawDefinition: t, structureId: n });
  e || (e = _e({ drawDefinition: t }).appliedPolicies);
  let s = r?.validSeedBlocks;
  return !s && o && (s = Ko({ appliedPolicies: e, drawDefinition: t, structure: o })?.validSeedBlocks), e?.seeding?.validSeedPositions?.ignore ? !0 : e?.seeding?.validSeedPositions?.strict ? (s.find((c) => c.seedNumbers.includes(a))?.drawPositions || []).includes(i) : [].concat(...s.map((c) => c.drawPositions)).includes(i);
}
function hT(e) {
  let { provisionalPositioning: t, drawDefinition: r, seedingProfile: i, seedBlockInfo: n, structureId: a, randomize: o } = e, { structure: s } = me({ drawDefinition: r, structureId: a }), { seedAssignments: c } = si({ returnAllProxies: e.returnAllProxies, provisionalPositioning: t, drawDefinition: r, structure: s }), { positionAssignments: u } = _t({ structure: s }), l = u?.filter((M) => M.participantId ?? M.bye ?? M.qualifier)?.map((M) => M.drawPosition).filter(Boolean), { appliedPolicies: d } = _e({ drawDefinition: r }), p = (n?.validSeedBlocks || s && Ko({ returnAllProxies: e.returnAllProxies, provisionalPositioning: t, appliedPolicies: d, drawDefinition: r, seedingProfile: i, structure: s })?.validSeedBlocks || []).filter((M) => M.drawPositions.filter((E) => !l?.includes(E)).length)[0], m = c?.map((M) => M.participantId).filter(Boolean), f = u?.map((M) => M.participantId).filter(Boolean), h = m?.filter((M) => f?.includes(M)), g = m?.filter((M) => !f?.includes(M)), I = c?.filter((M) => g?.includes(M.participantId)), U = c?.filter((M) => !M.participantId), S = (I?.length && I.length > 0 ? I.length : U?.length ?? 0) && p?.drawPositions.filter((M) => !l?.includes(M)) || [], P = o ? mr(S) : S, v = [], D = P.map(() => {
    let M = R(I, v)?.participantId;
    return M && v.push(M), M;
  }).filter(Boolean), y = c?.filter((M) => h?.includes(M.participantId)).map((M) => M.seedNumber), w = (p?.seedNumbers || []).filter((M) => !y?.includes(M)), b = c?.filter((M) => w.includes(M.seedNumber)).map((M) => M.participantId), T = d?.seeding?.duplicateSeedNumbers;
  return { nextSeedBlock: p, unplacedSeedParticipantIds: T === void 0 || T ? D : b, unplacedSeedNumbers: w, unfilledPositions: P, unplacedSeedAssignments: I };
  function R(M, E) {
    let A = M.filter((k) => !E.includes(k.participantId)), N = Math.min(...A.map((k) => Os(k.seedValue))), C = A.filter((k) => Os(k.seedValue) === N);
    return mr(C).pop();
  }
}
function Zu(e) {
  if (typeof e == "string") return e;
  if (typeof e == "object") return e.positioning;
}
function ac({ provisionalPositioning: e, tournamentRecord: t, drawDefinition: r, seedingProfile: i, participantId: n, seedBlockInfo: a, structureId: o, seedNumber: s, seedValue: c, eventId: u, event: l }) {
  let d = "assignSeed", { structure: p } = me({ drawDefinition: r, structureId: o }), { positionAssignments: m } = _t({ structure: p }), f = si({ provisionalPositioning: e, drawDefinition: r, structure: p }).seedAssignments, h = f.map((v) => v.seedNumber), g = lo({ drawDefinition: r, participantId: n });
  if (n && !g) return F({ result: { error: Li }, context: { participantId: n }, stack: d });
  let I = l ? wt({ event: l }).flightProfile?.flights?.length : 0, U = I && I > 1, S = m?.find((v) => v.participantId === n)?.drawPosition;
  if (S && !ud({ drawPosition: S, drawDefinition: r, seedBlockInfo: a, structureId: o, seedNumber: s })) return F({ result: { error: ih }, context: { assignedDrawPosition: S }, info: "invalid seed position", stack: d });
  h.includes(s) || f.push({ seedNumber: s, seedValue: c });
  let P;
  return f.forEach((v) => {
    v.participantId === n && v.seedNumber !== s && (v.participantId = void 0), v.seedNumber === s && (v.participantId = n, !i?.groupSeedingThreshold && !U && (v.seedValue = c ?? s), P = !0);
  }), P ? (Iw({ tournamentId: t?.tournamentId, drawDefinition: r, structure: p, eventId: u }), { ...x }) : F({ result: { error: Nv }, stack: d });
}
function Jg({ inContextTargetMatchUp: e, drawPositionSideIndex: t, teamParticipantId: r, tournamentRecord: i, drawDefinition: n, matchUp: a, event: o }) {
  let s = e?.sides?.[t]?.sideNumber, c = s && a.sides?.find((p) => p.sideNumber === s), { extension: u } = we({ element: n, name: Fn }), l = u?.value || {}, d = ie(l[r], !1, !0);
  if (c) a?.sides?.forEach((p) => {
    p.sideNumber === s && (p.lineUp = d);
  });
  else {
    a.sides = [1, 2].map((m) => ({ ...a.sides?.find((f) => f.sideNumber === m) ?? {}, sideNumber: m }));
    let p = a.sides.find((m) => m.sideNumber === s);
    p && (p.lineUp = d);
  }
  Oe({ tournamentId: i?.tournamentId, context: "updateSidLineUp", eventId: o?.eventId, drawDefinition: n, matchUp: a });
}
function gT(e) {
  let { sourceMatchUp: t } = e, { targetMatchUp: r, structure: i, matchUpsMap: n, drawPosition: a } = e, o = r.roundNumber > 1 && r.roundNumber - 1, s = ka({ structureId: i.structureId, matchUpsMap: n });
  !t && a && (t = s.find(({ drawPositions: f, roundNumber: h }) => h === o && f?.includes(a)));
  let c = t?.roundPosition, u = c % 2 ? 1 : -1, l = c + u, d = o && s.find(({ roundNumber: f, roundPosition: h }) => f === o && h === l), p = d?.matchUpStatus, m = [Mt, xt].includes(p);
  return { pairedPreviousMatchUp: d, pairedPreviousMatchUpIsDoubleExit: m };
}
function Sk({ drawPosition: e, drawPositions: t }) {
  let r = !1, i = !!t?.includes(e);
  return { updatedDrawPositions: i ? t || [] : [...t, void 0, void 0].slice(0, 2).map((n) => !n && !i ? (i = !0, r = !0, e) : n).sort(Ot).filter(Boolean), positionAdded: r, positionAssigned: i };
}
function IT({ structureId: e, matchUpsMap: t, matchUp: r }) {
  let i = r?.roundPosition, n = i % 2 ? 1 : -1, a = i + n;
  return { pairedPreviousMatchUp: ka({ matchUpsMap: t, structureId: e }).find(({ roundNumber: o, roundPosition: s }) => o === r?.roundNumber && s === a) };
}
function UT({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, sourceMatchUpId: r, matchUpsMap: i, matchUp: n }) {
  let a = e.find((s) => s.matchUpId === r), { pairedPreviousMatchUp: o } = IT({ structureId: a?.structureId, matchUp: a, matchUpsMap: i });
  if (a && o) {
    let s = o?.matchUpId, c = e.find((l) => l.matchUpId === s), u = a?.structureId === c?.structureId ? a?.roundPosition < c?.roundPosition && 1 || 2 : a.structureId === c?.structureId && 2 || 1;
    n.matchUpStatusCodes = (n.matchUpStatusCodes ?? []).map((l) => {
      let d = dt(l) || !isNaN(l) ? { code: l } : l;
      return d.sideNumber === u ? { ...d, previousMatchUpStatus: t } : d;
    });
  }
}
function Bl({ inContextDrawMatchUps: e, drawPosition: t, matchUpId: r }) {
  let i = e.filter(({ winnerMatchUpId: n, loserMatchUpId: a }) => a === r || n === r).sort((n, a) => n.roundPosition - a.roundPosition);
  return e.find((n) => n.matchUpId === r).feedRound ? 1 : i.reduce((n, a, o) => a.drawPositions?.includes(t) ? o + 1 : n, void 0);
}
function po({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, tournamentRecord: r, sourceMatchUpId: i, drawDefinition: n, matchUpStatus: a, drawPosition: o, matchUpsMap: s, matchUpId: c, event: u }) {
  let l = "assignMatchUpDrawPosition";
  s || (s = or({ drawDefinition: n })), e || (e = Et({ inContext: !0, drawDefinition: n, matchUpsMap: s }).matchUps ?? []);
  let d = e.find((E) => E.matchUpId === c), p = d?.structureId, m = n?.structures?.find((E) => E.structureId === p);
  if (!m) return { error: mt };
  let f = s?.drawMatchUps?.find((E) => E.matchUpId === c), h = f?.drawPositions ?? [], { positionAdded: g, positionAssigned: I, updatedDrawPositions: U } = Sk({ drawPositions: h, drawPosition: o }), { positionAssignments: S } = Je({ drawDefinition: n, structure: m }), P = S?.filter((E) => U.includes(E.drawPosition))?.find(({ bye: E }) => E), v = f?.matchUpStatus && [be, Pe].includes(f.matchUpStatus) && U.filter(Boolean).length < 2;
  a = P && "BYE" || a || v && f.matchUpStatus || f?.matchUpStatus && [Mt, xt].includes(f.matchUpStatus) && f.matchUpStatus || Dt;
  let D = !!([be, Pe].includes(f?.matchUpStatus) && f?.winningSide);
  if (f && g) {
    e = Et({ inContext: !0, drawDefinition: n, matchUpsMap: s }).matchUps ?? [];
    let E = v && Bl({ inContextDrawMatchUps: e, drawPosition: o, matchUpId: c }) || D && f.winningSide || void 0;
    f?.matchUpStatusCodes && UT({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, sourceMatchUpId: i, matchUpsMap: s, matchUp: f }), Object.assign(f, { drawPositions: U, winningSide: E, matchUpStatus: D ? f?.matchUpStatus : a }), Oe({ tournamentId: r?.tournamentId, eventId: d?.eventId, context: l, drawDefinition: n, matchUp: f });
  }
  let y = Ur({ inContextDrawMatchUps: e, inContextMatchUp: d, drawDefinition: n, matchUpId: c }), { targetMatchUps: { winnerMatchUp: w, loserMatchUp: b, loserTargetDrawPosition: T }, targetLinks: { loserTargetLink: R } } = y, M = ka({ structureId: m.structureId, matchUpsMap: s });
  if (I && P) {
    if (w) if (["BYE", Mt, xt].includes(a)) {
      let E = po({ matchUpId: w.matchUpId, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: n, drawPosition: o, matchUpsMap: s });
      if (E.error) return E;
    } else {
      let { structureId: E } = w;
      E !== m.structureId && console.log("winnerMatchUp in different structure... participant is in different targetDrawPosition");
    }
  } else if (I && D) {
    if (w) {
      let E = po({ matchUpId: w.matchUpId, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: n, drawPosition: o, matchUpsMap: s });
      if (E.error) return E;
    }
  } else if (w && d && !d.feedRound) {
    let { pairedPreviousMatchUpIsDoubleExit: E } = gT({ targetMatchUp: f, drawPosition: o, matchUpsMap: s, structure: m });
    if (E) {
      let A = po({ matchUpId: w.matchUpId, inContextDrawMatchUps: e, tournamentRecord: r, drawDefinition: n, drawPosition: o, matchUpsMap: s });
      if (A.error) return A;
    }
  }
  if (f?.matchUpType === ot) {
    let E = e?.find(({ matchUpId: C }) => C === f.matchUpId), A = (E?.sides ?? []).reduce((C, k, O) => k.drawPosition === o ? O : C, void 0), N = S?.find((C) => C.drawPosition === o)?.participantId;
    N && A !== void 0 && Jg({ inContextTargetMatchUp: E, drawPositionSideIndex: A, teamParticipantId: N, tournamentRecord: r, drawDefinition: n, matchUp: f });
  }
  if (R?.linkCondition === Qi && U.filter(Boolean).length === 2 && !P && M.filter(({ drawPositions: E, roundNumber: A }) => A === 1 && gr(E, U)).every(({ matchUpStatus: E }) => [vt, Xt].includes(E)) && b) {
    let { structureId: E } = b, A = Zr({ drawPosition: T, tournamentRecord: r, drawDefinition: n, structureId: E, matchUpsMap: s, event: u });
    if (A.error) return A;
  }
  return I ? { ...x } : F({ result: { error: Us }, context: { drawPosition: o }, stack: l });
}
function ST({ inContextDrawMatchUps: e, drawDefinition: t, assignments: r, matchUpsMap: i, structure: n }) {
  let a = ec({ drawDefinition: t })?.containedStructures?.[n.structureId]?.map(({ structureId: l }) => l) || [];
  a.push(n?.structureId);
  let o = r?.map(({ drawPosition: l }) => l) || [], s = e?.filter((l) => a.includes(l.structureId) && Pt(l.drawPositions ?? [], o).length) ?? [], c = s.map(({ matchUpId: l }) => l), u = i?.drawMatchUps?.filter((l) => c.includes(l.matchUpId)) ?? [];
  return { drawPositions: o, matchUps: u, targetMatchUps: s };
}
function Zg({ lineUp: e }) {
  if (!Array.isArray(e)) return;
  let t = {};
  return Ue(e.flatMap(({ collectionAssignments: r }) => r?.map(({ collectionId: i, collectionPosition: n }) => [i, n].join("|"))).filter(Boolean)).forEach((r) => {
    let [i, n] = r.split("|"), a = parseInt(n), { assignedParticipantIds: o } = od({ collectionPosition: a, collectionId: i, lineUp: e });
    o.forEach((s) => {
      t[s] || (t[s] = []), t[s].push({ collectionId: i, collectionPosition: a });
    });
  }), Object.keys(t).map((r) => ({ participantId: r, collectionAssignments: t[r] }));
}
function La(e) {
  return `${e} must be an array`;
}
function bp({ lineUp: e, tieFormat: t }) {
  let r = [];
  if (!Array.isArray(e)) return r.push(La("lineUp")), { valid: !1, errors: r, error: z };
  let i = e.every((a) => {
    if (typeof a != "object") return r.push("lineUp entries must be objects"), !1;
    let { participantId: o, collectionAssignments: s } = a;
    return o ? typeof o != "string" ? (r.push("participantIds must be strings"), !1) : Array.isArray(s) ? s.every((c) => {
      if (typeof c != "object") return r.push("collectionAssignments must be objects"), !1;
      let { collectionPosition: u } = c;
      return typeof u != "number" ? (r.push("collectionPosition must be a number"), !1) : !0;
    }) : (r.push(La("collectionAssignments")), !1) : (r.push("Missing participantId"), !1);
  }), n = Ue(e.map(Re)).length === e.length;
  return n || r.push("Duplicated participantId(s)"), { valid: i && n, errors: r, error: r.length ? z : void 0 };
}
function Qo({ drawDefinition: e, participantId: t, tieFormat: r, lineUp: i }) {
  if (typeof e != "object") return { error: ne };
  if (typeof t != "string") return { error: Ft };
  let n = bp({ lineUp: i, tieFormat: r });
  if (!n.valid) return n;
  let { extension: a } = we({ element: e, name: Fn }), o = a?.value || {};
  return o[t] = Zg({ lineUp: i }), Be({ element: e, extension: { name: Fn, value: o } }), Eu({ drawDefinition: e }), { ...x };
}
function eI({ inContextDrawMatchUps: e, inheritance: t = !0, tournamentRecord: r, drawDefinition: i, matchUpsMap: n, assignments: a, structure: o, event: s }) {
  if (!i) return { error: ne };
  let { drawPositions: c, matchUps: u, targetMatchUps: l } = ST({ inContextDrawMatchUps: e, matchUpsMap: n, assignments: a, structure: o });
  for (let d of l) d.matchUpType === Hr && (d.sides ?? []).forEach((p, m) => {
    if (p?.drawPosition && c?.includes(p.drawPosition)) {
      let f = u.find(({ matchUpId: h }) => h === d.matchUpId);
      if (f?.sides?.[m]) {
        if (delete f.sides[m].lineUp, t === !1) {
          let h = d.tieFormat, g = p.participantId;
          h && g && Qo({ drawDefinition: i, participantId: g, lineUp: [], tieFormat: h });
        }
        Oe({ tournamentId: r?.tournamentId, context: "resetLineUps", eventId: s?.eventId, drawDefinition: i, matchUp: f });
      }
    }
  });
  return { ...x };
}
function Ji({ provisionalPositioning: e, inContextDrawMatchUps: t, isQualifierPosition: r, sourceMatchUpStatus: i, tournamentRecord: n, drawDefinition: a, seedingProfile: o, participantId: s, seedBlockInfo: c, drawPosition: u, matchUpsMap: l, structureId: d, event: p }) {
  let m = "assignDrawPosition";
  if (!s && !r) return F({ result: { error: Ft }, stack: m });
  l = l ?? or({ drawDefinition: a }), t || ({ matchUps: t } = Et({ inContext: !0, drawDefinition: a, matchUpsMap: l }));
  let f = me({ drawDefinition: a, structureId: d });
  if (f.error) return F({ result: f, stack: m });
  let { structure: h } = f;
  if (!h) return { error: mt };
  if (Tr({ structure: h })) return F({ result: { error: Cr }, stack: m });
  let { seedAssignments: g } = si({ provisionalPositioning: e, drawDefinition: a, structure: h }), I = g?.find((T) => T.participantId === s)?.seedNumber, { appliedPolicies: U } = _e({ tournamentRecord: n, drawDefinition: a, structure: h, event: p });
  if (I && !ud({ seedNumber: I, appliedPolicies: U, drawDefinition: a, seedBlockInfo: c, drawPosition: u, structureId: d })) return F({ result: { error: ih }, context: { drawPosition: u }, stack: m });
  let S = _t({ structure: h }).positionAssignments || [], P = S?.find((T) => T.drawPosition === u);
  if (!P) return F({ result: { error: Vs }, context: { drawPosition: u }, stack: m });
  if (S?.map(Re).includes(s)) return F({ result: { error: qs }, context: { drawPosition: u }, stack: m });
  let { containsParticipant: v, containsBye: D } = b(P);
  if (D) {
    let T = zu({ inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, drawPosition: u, structureId: d, matchUpsMap: l, event: p });
    if (T.error) return F({ result: T, stack: m });
  }
  if (v && P.participantId !== s) {
    let { activeDrawPositions: T } = Hu({ drawDefinition: a, structureId: d });
    if (T.includes(u)) return F({ result: { error: Rd }, stack: m });
    eI({ assignments: [P], inContextDrawMatchUps: t, tournamentRecord: n, drawDefinition: a, matchUpsMap: l, structure: h });
  }
  if (P.participantId = s, r && (P.qualifier = !0), h.stage === re && (!h.stageSequence || h.stageSequence > 1) || h.stage && [nr, yt].includes(h.stage)) {
    let T = h.stage === se ? se : re, R = (a.structures?.find((M) => M?.stage === T && M?.stageSequence === 1)?.seedAssignments ?? []).find((M) => M.participantId === s);
    if (R?.participantId) {
      let { participantId: M, seedNumber: E, seedValue: A } = R;
      ac({ eventId: p?.eventId, provisionalPositioning: e, tournamentRecord: n, drawDefinition: a, seedingProfile: o, participantId: M, seedNumber: E, seedValue: A, structureId: d, event: p });
    }
  }
  if (h.structureType !== yr) yk({ provisionalPositioning: e, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: n, drawDefinition: a, drawPosition: u, matchUpsMap: l, structure: h, event: p });
  else {
    Xw({ positionAssignments: S, tournamentRecord: n, drawDefinition: a, matchUpsMap: l, structure: h });
    let { drawPositions: T, matchUps: R, targetMatchUps: M } = ST({ assignments: [P], inContextDrawMatchUps: t, drawDefinition: a, matchUpsMap: l, structure: h });
    if (T && R?.length === 1 && R[0].matchUpType === ot) {
      let E = (M?.[0].sides ?? []).reduce((A, N, C) => T?.includes(N.drawPosition) ? C : A, void 0);
      Jg({ inContextTargetMatchUp: M[0], teamParticipantId: s, matchUp: R[0], drawPositionSideIndex: E, tournamentRecord: n, drawDefinition: a });
    }
  }
  let y = a.entries?.find((T) => T.participantId === s), w = p?.entries?.find((T) => T.participantId === s);
  return !y && w && jg({ entryStatus: w.entryStatus, entryStage: h.stage, ignoreStageSpace: !0, drawDefinition: a, participantId: s, event: p }), sa({ tournamentId: n?.tournamentId, drawDefinition: a, structure: h, event: p }), { positionAssignments: S, ...x };
  function b(T) {
    let R = T.bye, M = T.qualifier, E = T.participantId;
    return { containsBye: R, containsQualifier: M, containsParticipant: E, filled: R || M || E };
  }
}
function yk({ provisionalPositioning: e, inContextDrawMatchUps: t, sourceMatchUpStatus: r, tournamentRecord: i, drawDefinition: n, drawPosition: a, matchUpsMap: o, structure: s, event: c }) {
  let u = { isCollectionMatchUp: !1 }, { matchUps: l } = Ve({ provisionalPositioning: e, matchUpFilters: u, drawDefinition: n, matchUpsMap: o, structure: s, event: c }), { roundMatchUps: d } = Ir({ matchUps: l }), { initialRoundNumber: p } = wo({ drawPosition: a, matchUps: l }), m = p && d?.[p].find((f) => f.drawPositions?.includes(a));
  if (m) {
    let f = po({ matchUpId: m.matchUpId, inContextDrawMatchUps: t, sourceMatchUpStatus: r, tournamentRecord: i, drawDefinition: n, drawPosition: a, matchUpsMap: o });
    if (f.error) return F({ stack: "assignDrawPositionToMatchUps", context: { drawPosition: a }, result: f });
  }
  return { ...x };
}
function tI(e) {
  let { participantIdAttributeName: t = "participantId", isQualifierPosition: r, positionActionName: i, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, event: u } = e, l = "positionParticipantAction";
  if (!a) return { error: ne };
  let d = _e({ tournamentRecord: n, drawDefinition: a, event: u }).appliedPolicies ?? {}, { inContextDrawMatchUps: p, matchUpsMap: m } = e;
  m || (m = or({ drawDefinition: a }), Object.assign(e, { matchUpsMap: m })), p || ({ matchUps: p } = Et({ inContext: !0, drawDefinition: a, matchUpsMap: m }), Object.assign(e, { inContextDrawMatchUps: p }));
  let { positionAssignments: f } = Je({ drawDefinition: a, structureId: c }), h = f?.find((P) => P.drawPosition === s);
  if (h?.participantId) {
    let P = h.participantId, v = Ji({ inContextDrawMatchUps: p, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, matchUpsMap: m, event: u });
    return v.success ? S({ appliedPolicies: d, removedParticipantId: P }) : F({ result: v, stack: l });
  }
  let g = zu({ inContextDrawMatchUps: p, tournamentRecord: n, drawDefinition: a, drawPosition: s, structureId: c, matchUpsMap: m, event: u });
  if (g.error) return F({ result: g, stack: l });
  let I = g.participantId, U = Ji({ inContextDrawMatchUps: p, isQualifierPosition: r, tournamentRecord: n, drawDefinition: a, participantId: o, drawPosition: s, structureId: c, matchUpsMap: m, event: u });
  if (!U.success) return F({ result: U, stack: l });
  return S({ appliedPolicies: d, removedParticipantId: I });
  function S({ appliedPolicies: P, removedParticipantId: v }) {
    let { structure: D } = me({ drawDefinition: a, structureId: c });
    Dg({ drawPositions: [s], structure: D });
    let y = { [t]: o, name: i, drawPosition: s, structureId: c };
    return dp({ appliedPolicies: P, drawDefinition: a, positionAction: y }), F({ context: { removedParticipantId: v }, result: { ...x }, stack: l });
  }
}
function vk({ luckyLoserParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n }) {
  return tI({ positionActionName: "luckyLoserDrawPositionAssignment", participantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n });
}
function yT(e) {
  return vk(e);
}
function vT({ params: e, modMap: t, structure: r }) {
  let { tournamentRecord: i, drawDefinition: n, event: a } = e;
  for (let o of r.matchUps) t[o.matchUpId] && (o.roundNumber = t[o.matchUpId], Oe({ tournamentId: i?.tournamentId, eventId: a?.eventId, drawDefinition: n, matchUp: o }));
}
function PT(e, t) {
  let r = [{ drawDefinition: !0, structureId: !0 }];
  Array.isArray(t) && r.push(...t);
  let i = oe(e, r);
  if (i.error) return i;
  let n = me(e);
  if (n.error) return n;
  let a = n.structure;
  if (!Tr({ structure: a })) return F({ result: { error: $a, message: "structure must be adHoc" } });
  let { roundMatchUps: o = [], roundNumbers: s } = Ir({ matchUps: a?.matchUps });
  return s?.length ? { valid: !0, structure: a, roundMatchUps: o, roundNumbers: s } : { error: Gn };
}
function DT(e) {
  let t = PT(e, [{ targetRoundNumber: !0, roundNumber: !0, [Mr]: d1 }]);
  if (t.error) return t;
  let { structure: r, roundMatchUps: i, roundNumbers: n } = t, { targetRoundNumber: a, roundNumber: o } = e;
  if (!n?.includes(o) || !n?.includes(a)) return F({ result: { error: z }, info: "roundNumbers must be valid rounds" });
  let s = a > o, c = s ? te(o + 1, a + 1) : te(a, o), u = {};
  return c.forEach((l) => (i?.[l] ?? []).forEach(({ matchUpId: d }) => {
    u[d] = l - (s ? 1 : -1);
  })), i?.[o]?.forEach(({ matchUpId: l }) => u[l] = a), vT({ params: e, modMap: u, structure: r }), { ...x };
}
function wT({ structurePositionAssignments: e, provisionalPositioning: t, tournamentRecord: r, drawDefinition: i, event: n }) {
  if (!i) return { error: ne };
  if (!Array.isArray(e)) return { error: z };
  let a = "setPositionAssignments";
  for (let s of e) {
    let { structureId: c, positionAssignments: u } = s;
    if (!u) continue;
    let l = me({ drawDefinition: i, structureId: c });
    if (l.error) return l;
    let d = l.structure;
    if (!d) return { error: mt };
    let p = Je({ structure: d }).positionAssignments?.map(({ drawPosition: g }) => g), m = u?.map(({ drawPosition: g }) => g);
    if (Pt(p, m).length !== p?.length) return F({ result: { error: z }, info: "drawPositions do not match", stack: a });
    let f = or({ drawDefinition: i }), { matchUps: h } = Et({ inContext: !0, drawDefinition: i, matchUpsMap: f });
    for (let g of u || []) {
      let { drawPosition: I, participantId: U, bye: S, qualifier: P } = g;
      if (S) {
        let v = Zr({ tournamentRecord: r, drawDefinition: i, drawPosition: I, matchUpsMap: f, structureId: c, structure: d, event: n });
        if (v?.error) return v;
      } else if (P) u.forEach((v) => {
        v.drawPosition === I && (v.qualifier = !0, delete v.participantId, delete v.bye);
      });
      else if (U) {
        let v = Ji({ provisionalPositioning: t, inContextDrawMatchUps: h, tournamentRecord: r, drawDefinition: i, participantId: U, drawPosition: I, matchUpsMap: f, structureId: c, event: n });
        if (v?.error) return v;
      }
    }
    sa({ tournamentId: r?.tournamentId, drawDefinition: i, structure: d, event: n });
  }
  let o = e.map(({ structureId: s }) => s);
  return tt({ tournamentId: r?.tournamentId, eventId: n?.eventId, drawDefinition: i, structureIds: o }), { ...x };
}
function TT(e) {
  let t = PT(e, [{ roundNumbers: !0, [Mr]: sr, [tr]: (o) => o.length === 2 && o.every(gt) }]);
  if (t.error) return t;
  let { structure: r, roundMatchUps: i, roundNumbers: n } = t;
  if (!e.roundNumbers.every((o) => n?.includes(o))) return F({ result: { error: z, message: "roundNumbers must be valid rounds" } });
  let a = {};
  return e.roundNumbers.forEach((o, s) => (i?.[o] ?? []).forEach(({ matchUpId: c }) => {
    a[c] = e.roundNumbers[1 - s];
  })), vT({ params: e, modMap: a, structure: r }), { ...x };
}
function bT({ alternateParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n, event: a }) {
  return tI({ positionActionName: "alternateDrawPositionAssignment", participantIdAttributeName: "alternateParticipantid", participantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n, event: a });
}
function MT({ drawDefinition: e, structureId: t }) {
  if (!e) return { error: ne };
  let { structure: r } = me({ drawDefinition: e, structureId: t }), i = (e?.links || []).filter((n) => n.source?.structureId === t).map((n) => n.target?.structureId);
  return { playoffStructures: (e?.structures || []).filter((n) => i.includes(n.structureId)), structure: r };
}
function Mp({ withStageGrouping: e, stageSequences: t, stageSequence: r, roundTarget: i, stages: n, event: a, stage: o }) {
  if (!a) return { error: st };
  let s = {}, c = [];
  for (let u of a.drawDefinitions || []) {
    let { structures: l, stageStructures: d } = Ti({ withStageGrouping: e, stageSequences: t, drawDefinition: u, stageSequence: r, roundTarget: i, stages: n, stage: o });
    if (c.push(...l), d) for (let p of Object.keys(d)) s[p] || (s[p] = []), s[p].push(...d[p]);
  }
  return { structures: c, stageStructures: s };
}
function rI({ withStageGrouping: e, tournamentRecord: t, stageSequences: r, stageSequence: i, roundTarget: n, stages: a, stage: o }) {
  if (!t) return { error: J };
  let s = {}, c = [];
  for (let u of t.events || []) {
    let { structures: l, stageStructures: d } = Mp({ withStageGrouping: e, stageSequences: r, stageSequence: i, roundTarget: n, stages: a, event: u, stage: o });
    if (l && c.push(...l), d) for (let p of Object.keys(d)) s[p] || (s[p] = []), s[p].push(...d[p]);
  }
  return { structures: c, stageStructures: s };
}
function wn(e) {
  if (!e?.drawDefinition) return !1;
  let t = Pp(e), r = t?.includesTeamMatchUps, { completedMatchUps: i, pendingMatchUps: n, upcomingMatchUps: a } = t || {};
  return r && (i = i?.filter(({ matchUpType: o }) => o === ot), n = n?.filter(({ matchUpType: o }) => o === ot), a = a?.filter(({ matchUpType: o }) => o === ot)), !!(i?.length && !n?.length && !a?.length);
}
function iI(e) {
  let { drawDefinition: t, structureId: r } = e;
  if (!t) return { error: ne };
  let { playoffStructures: i } = MT({ drawDefinition: t, structureId: r });
  if (!i?.length) return !1;
  let n = t?.entries?.filter((o) => o?.entryStatus && Ni.includes(o.entryStatus))?.length ?? 0, a = 0;
  return (i || []).reduce((o, s) => !!((Je({ structure: s }).positionAssignments ?? [])?.filter((c) => (c.participantId && a++, c?.bye ?? c?.participantId)).length && o), !!i.length) || a === n;
}
function Ef({ significantCharacters: e, accessors: t = [], value: r }) {
  let i = [], n = t[0];
  if (r?.[n]) {
    let o = t.slice(1);
    if (Array.isArray(r[n])) r[n].forEach((s) => {
      let c = Ef({ accessors: o, significantCharacters: e, value: s });
      i.push(...c);
    });
    else if (r = r[n], o.length) {
      let s = Ef({ accessors: o, significantCharacters: e, value: r });
      i.push(...s);
    } else a({ value: r });
  }
  function a({ value: o }) {
    if (o && ["string", "number"].includes(typeof o)) {
      let s = e ? o.slice(0, e) : o;
      i.push(s);
    }
  }
  return i;
}
function Pk({ targetParticipantIds: e, policyAttributes: t, idCollections: r, participants: i }) {
  if (!Array.isArray(t)) return { error: mh };
  if (!Array.isArray(i)) return { error: gu };
  let n = {};
  return e.forEach((a) => {
    let o = i.find((c) => c.participantId === a), { values: s } = RT({ policyAttributes: t, idCollections: r, participants: i, participant: o });
    s && s.forEach((c) => {
      n[c] || (n[c] = []), n[c].includes(a) || n[c].push(a);
    });
  }), n;
}
function RT({ policyAttributes: e, idCollections: t, participants: r, participant: i }) {
  if (!Array.isArray(e)) return { error: mh };
  if (!i) return { error: Ao };
  let n = [];
  return e.forEach((a) => {
    let { directive: o, groupings: s, key: c, significantCharacters: u } = a || {};
    if (c) {
      let l = c.split(".");
      n.push(...Ef({ significantCharacters: u, value: i, accessors: l }));
    } else if (o) {
      let l = a?.includeIds, d = (t?.[o] || []).filter((p) => !l || l.includes(p));
      d?.length && r?.length && d.forEach((p) => {
        let m = r.find((f) => f.participantId === p);
        if (m?.individualParticipantIds?.includes(i.participantId)) {
          let f = m?.participantId;
          n.push(f);
        }
      });
    } else s && Object.keys(s).forEach((l) => {
      s[l].includes(i.participantId) && n.push(l);
    });
  }), { values: Ue(n) };
}
function KS({ candidatePositionAssignments: e, participantsWithGroupings: t, policyAttributes: r, idCollections: i }) {
  let n = Object.assign({}, ...t.map((a) => ({ [a.participantId]: a })));
  return e.map((a) => {
    let o = n[a.participantId], { values: s } = RT({ participants: t, policyAttributes: r, idCollections: i, participant: o });
    return { ...a, values: s };
  });
}
function NT({ participantIdGroups: e, positionAssignments: t, groupsToAvoid: r }) {
  return Object.assign({}, ...t.filter((i) => i?.participantId).map((i) => {
    let { drawPosition: n, participantId: a } = i, o = e ? e[a] || [] : [], s = !!r.some((c) => o.includes(c));
    return { [n]: { participantGroups: o, includesGroupsToAvoid: s } };
  }));
}
function Dk(e) {
  let { unfilledPositions: t, chunkedDrawPositions: r } = e, i = NT(e);
  return r.map((a) => {
    let o = t.filter((u) => a.includes(u)), s = n(o), c = o.filter((u) => !s.includes(u)).filter((u) => {
      let l = QS(u);
      return !i[l]?.includesGroupsToAvoid;
    });
    return { unassigned: o, unpaired: s, pairedNoConflict: c };
  });
  function n(a) {
    return a.filter((s) => !o(s));
    function o(s) {
      let c = QS(s);
      return !a.includes(c);
    }
  }
}
function wk(e) {
  let { unfilledPositions: t, chunkedDrawPositions: r } = e, i = NT(e);
  return r.map((n) => {
    let a = t.filter((c) => n.includes(c)), o = a.length === n.length ? a : [], s = n.filter((c) => i[c]?.includesGroupsToAvoid).length;
    return { unassigned: a, unpaired: o, pairedNoConflict: s ? [] : a, conflictsCount: s };
  });
}
function QS(e) {
  return Number(e % 2 ? e + 1 : e - 1);
}
function Tk({ allGroups: e, participantId: t }) {
  return Object.keys(e).filter((r) => e[r].includes(t));
}
function bk({ selectedParticipantGroups: e, participantIdGroups: t, positionAssignments: r, drawPositionChunks: i, unfilledPositions: n, isRoundRobin: a }) {
  let o = i.map((s) => a ? wk({ groupsToAvoid: e, chunkedDrawPositions: s, participantIdGroups: t, positionAssignments: r, unfilledPositions: n }) : Dk({ groupsToAvoid: e, chunkedDrawPositions: s, participantIdGroups: t, positionAssignments: r, unfilledPositions: n }));
  if (a) {
    let s = o.map((l) => l.map((d) => d.unassigned).filter((d) => d?.length)).filter((l) => l?.length).sort((l, d) => (d.length || 0) - (l.length || 0)), c = o.map((l) => l.map((d) => d.unpaired).filter((d) => d?.length)).filter((l) => l?.length), u = o.map((l) => l.map((d) => d.pairedNoConflict).filter((d) => d?.length)).filter((l) => l?.length).sort((l, d) => (d.length || 0) - (l.length || 0));
    return { unassigned: s, unpaired: c, pairedNoConflict: u };
  } else {
    let s = o.map((l) => l.map((d) => d.unassigned).filter((d) => d?.length)).filter((l) => l?.length), c = o.map((l) => l.map((d) => d.unpaired).filter((d) => d?.length)).filter((l) => l?.length), u = o.map((l) => l.map((d) => d.pairedNoConflict).filter((d) => d?.length)).filter((l) => l?.length);
    return { unassigned: s, unpaired: c, pairedNoConflict: u };
  }
}
function ET({ positionAssignments: e, participantIds: t }) {
  let r = e.map((i) => i.participantId);
  return t.filter((i) => !r.includes(i));
}
function Mk({ useSpecifiedGroupKey: e = !1, targetParticipantIds: t, largestFirst: r = !0, allGroups: i, groupKey: n }) {
  let a = Object.assign({}, ...Object.keys(i).map((u) => [u, i[u].filter((l) => t.includes(l))]).filter((u) => u[1].length).map(([u, l]) => ({ [u]: l }))), o = Object.keys(a).reduce((u, l) => a[l].length > u ? a[l].length : u, 0), s = Object.keys(a).filter((u) => a[u].length === o), c = xr(r ? s : Object.keys(a));
  return n = e && a[n]?.length ? n : c, { participantId: n && a[n] ? xr(a[n]) : xr(t), groupKey: n };
}
function Rk({ drawPositionGroups: e, positionAssignments: t }) {
  let r = Object.assign({}, ...t.map((i) => ({ [i.drawPosition]: i })));
  return e.map((i) => i.filter(Boolean).map((n) => r[n]).filter(Boolean).filter((n) => !n.participantId && !n.bye).map((n) => n.drawPosition)).flat().filter(Boolean);
}
function Nk({ candidatePositionAssignments: e, unseededParticipantIds: t, participantIdGroups: r, drawPositionChunks: i, drawPositionGroups: n, pairedPriority: a, allGroups: o, groupKey: s }) {
  let c = n.reduce((w, b) => b.length > w ? b.length : w, 0) <= 2, u = ET({ positionAssignments: e, participantIds: t }), l = Rk({ positionAssignments: e, drawPositionGroups: n }), { participantId: d, groupKey: p } = Mk({ targetParticipantIds: u, useSpecifiedGroupKey: c, allGroups: o, groupKey: s }), m = Tk({ participantId: d, allGroups: o }), f = bk({ positionAssignments: e, isRoundRobin: c, selectedParticipantGroups: m, participantIdGroups: r, drawPositionChunks: i, unfilledPositions: l }), { unassigned: h, unpaired: g, pairedNoConflict: I } = f, U = I?.length && I[0], S = g?.length && g[0], P = a && U ? U : S, v = a ? S : U, D = P?.length && P || v?.length && v, y;
  if (D?.length) {
    let w = Lr(D);
    y = Lr(w);
  } else {
    let w = Lr(h[0]);
    y = Lr(w);
  }
  return { newGroupKey: p, selectedParticipantId: d, targetDrawPosition: y };
}
function ld({ isRoundRobin: e, groupedParticipants: t }) {
  let r = [];
  return e ? t.forEach((i) => {
    let n = i.map((s) => s.drawPosition), a = Yg({ drawPositions: n }).uniqueMatchUpGroupings ?? [], o = Object.assign({}, ...i.map((s) => ({ [s.drawPosition]: s })));
    a.forEach((s) => {
      gr(o[s[0]].values || [], o[s[1]].values || []) && (r.push(s), i.conflict = !0);
    });
  }) : t.forEach((i) => {
    gr(i[0]?.values || [], i[1]?.values || []) && (r.push(i), i.conflict = !0);
  }), r;
}
function Ek({ positionedParticipants: e, potentialDrawPositions: t, drawPositionGroups: r, avoidanceConflicts: i, isRoundRobin: n }) {
  return i.map((a) => {
    let o = a.map((s) => s.drawPosition);
    return a.filter((s) => t.includes(s.drawPosition)).map((s) => {
      let c = t.filter((u) => !o?.includes(u)).filter((u) => {
        let l = r.find((h) => h.includes(u)).find((h) => h !== u), d = e.find((h) => h.drawPosition === l), p = ld({ isRoundRobin: n, groupedParticipants: [[s, d]] }), m = [e.find((h) => h.drawPosition === u), d], f = ld({ isRoundRobin: n, groupedParticipants: [m] });
        return !p.length && !f.length;
      });
      if (c.length) return { drawPosition: s.drawPosition, possibleDrawPositions: c };
    }).filter(Boolean);
  }).flat(1);
}
function XS(e) {
  let { initialPositionAssignments: t, participantsWithGroupings: r, opponentsToPlaceCount: i, unseededByePositions: n, drawPositionGroups: a, policyAttributes: o, idCollections: s, allGroups: c } = e, u = [], l, d = Math.min(...(a || []).map((S) => S?.length).filter(Boolean)), p = d > 2, m = ie(t, !1, !0).filter((S) => !S.qualifier), f = t.filter((S) => !S.participantId && (!S.bye || n?.includes(S.drawPosition))).map((S) => S.drawPosition);
  te(0, i).forEach(() => {
    let { newGroupKey: S, selectedParticipantId: P, targetDrawPosition: v } = Nk({ ...e, candidatePositionAssignments: m, allGroups: c, groupKey: l });
    l = S, m.forEach((D) => {
      D.drawPosition === v && (D.participantId = P);
    });
  });
  let h = KS({ candidatePositionAssignments: m, participantsWithGroupings: r, policyAttributes: o, idCollections: s }), g = qt(h, d), I = ld({ groupedParticipants: g, isRoundRobin: p }), U = 0;
  for (; U < 20 && I.length; ) {
    let S = Ek({ positionedParticipants: h, potentialDrawPositions: f, avoidanceConflicts: I, drawPositionGroups: a, isRoundRobin: p });
    if (S.length) {
      let P = Ak({ candidatePositionAssignments: m, swapOptions: S });
      P.error && console.log({ result: P }), h = KS({ candidatePositionAssignments: m, participantsWithGroupings: r, policyAttributes: o, idCollections: s }), g = qt(h, d), I = ld({ groupedParticipants: g, isRoundRobin: p }), U++;
    } else U = 20;
  }
  return m.forEach((S) => {
    if (S.bye && S.participantId) {
      let P = of;
      u.push(P);
    }
    if (S.qualifier && S.participantId) {
      let P = of;
      u.push(P);
    }
  }), { positionAssignments: m, conflicts: I.length, groupedParticipants: g, errors: u };
}
function Ak({ candidatePositionAssignments: e, swapOptions: t }) {
  let r = Lr(t);
  if (!r) return { error: { message: "No swap options" } };
  let i = r.drawPosition, n = Lr(r.possibleDrawPositions), a = e.find((u) => u.drawPosition === i), o = e.find((u) => u.drawPosition === n) ?? {}, s = { participantId: o?.participantId, qualifier: o?.qualifier, bye: o?.bye }, c = { participantId: a.participantId, qualifier: a.qualifier, bye: a.bye };
  return Object.assign(a, s), Object.assign(o, c), { ...x };
}
function Ck({ provisionalPositioning: e, unseededParticipantIds: t, inContextDrawMatchUps: r, unseededByePositions: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, avoidance: l, drawSize: d, event: p }) {
  if (!l) return { error: jv };
  let { candidatesCount: m = 1, policyAttributes: f, targetDivisions: h } = l, { roundsToSeparate: g } = l, I = "randomUnseededSeparation", { structure: U } = me({ drawDefinition: a, structureId: u }), { matchUps: S } = Ve({ provisionalPositioning: e, matchUpsMap: c, structure: U, event: p });
  if (h && Fi(h) && !g) {
    let L = fC(h) || 0, j = S.reduce((H, G) => G.roundNumber > H ? G.roundNumber : H, 0);
    g = j < L ? 1 : j - L + 1;
  }
  let { positionAssignments: P } = _t({ structure: U }), v = mp({ participantsProfile: { convertExtensions: !0 }, deepCopy: !1, participants: s }).participantsWithGroupings, D = P?.filter((L) => !L.participantId), y = P?.map((L) => L.drawPosition), w = U?.structureType === yr, b = w ? { structure: U, matchUps: S, allDrawPositions: y, roundsToSeparate: g } : { matchUps: S, allDrawPositions: y, roundsToSeparate: g }, { drawPositionGroups: T, drawPositionChunks: R } = w ? Ok(b) : kk(b), M = { groupParticipants: s.filter((L) => L.participantType === Xr).map((L) => L.participantId), teamParticipants: s.filter((L) => L.participantType === We).map((L) => L.participantId), pairParticipants: s.filter((L) => L.participantType === De).map((L) => L.participantId) }, E = Pk({ targetParticipantIds: t, policyAttributes: f, idCollections: M, participants: s });
  if (E.error) return F({ result: E, stack: I });
  let A = Object.assign({}, ...t.map((L) => {
    let j = Object.keys(E).filter((H) => (E[H] ?? []).includes(L));
    return { [L]: j };
  })), N = ET({ participantIds: t, positionAssignments: P });
  if (N.length > (D?.length || 0)) return { error: Sh };
  let C, k = N.length, O = te(0, m).map(() => XS({ initialPositionAssignments: P, participantsWithGroupings: v, unseededParticipantIds: t, opponentsToPlaceCount: k, pairedPriority: !1, unseededByePositions: i, participantIdGroups: A, drawPositionChunks: R, drawPositionGroups: T, policyAttributes: f, idCollections: M, allGroups: E, drawSize: d }));
  if (C = O.reduce((L, j) => !L || (j.conflicts || 0) < (L.conflicts || 0) ? j : L, void 0), !C || C.conflicts) {
    let L = te(0, m).map(() => XS({ initialPositionAssignments: P, participantsWithGroupings: v, unseededParticipantIds: t, opponentsToPlaceCount: k, pairedPriority: !0, unseededByePositions: i, participantIdGroups: A, drawPositionChunks: R, drawPositionGroups: T, policyAttributes: f, idCollections: M, allGroups: E, drawSize: d }));
    C = O.concat(...L).filter((j) => !j.errors?.length).reduce((j, H) => !j || (H.conflicts || 0) < (j.conflicts || 0) ? H : j, void 0);
  }
  if (!C) return { error: Ld };
  let _ = (Je({ structure: U })?.positionAssignments ?? []).filter((L) => L.participantId).map((L) => L.participantId), B = C.positionAssignments.filter((L) => !_.includes(L.participantId));
  for (let L of B) if (L.bye) {
    let j = Zr({ tournamentRecord: n, drawDefinition: a, structureId: u, matchUpsMap: c, event: p, ...L });
    if (j.error) return F({ result: j, stack: I });
  } else if (L.participantId) {
    let j = Ji({ inContextDrawMatchUps: r, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, structureId: u, matchUpsMap: c, event: p, ...L });
    if (j.error) return F({ result: j, stack: I, context: { assignment: L } });
  }
  return { ...x };
}
function Ok(e) {
  let { structure: { structures: t } } = e, r = t.map((i) => i.positionAssignments.map((n) => n.drawPosition));
  return { drawPositionGroups: r, drawPositionChunks: [r] };
}
function kk({ allDrawPositions: e, roundsToSeparate: t, matchUps: r }) {
  let i = r.filter((l) => l.roundNumber === 1).map((l) => l.drawPositions), n = i.flat().sort(Ot), a = Math.max(...n), o = e.filter((l) => l > a), s = n.length, c = te(s === 2 ? 1 : 2, s).filter((l) => l === th(l)), u = c.slice(0, t || c.length).reverse().map((l) => qt(n, l));
  return o.length && console.log({ fedDrawPositions: o }), { drawPositionGroups: i, drawPositionChunks: u };
}
function xk({ provisionalPositioning: e, inContextDrawMatchUps: t, unseededByePositions: r, multipleStructures: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, structure: l, drawSize: d, event: p }) {
  let m = "positionUnseededParticipants";
  l || ({ structure: l } = me({ drawDefinition: a, structureId: u })), u || ({ structureId: u } = l);
  let { positionAssignments: f } = _t({ structure: l }), { seedAssignments: h } = si({ provisionalPositioning: e, drawDefinition: a, structure: l }), g = h?.map((b) => b.participantId).filter(Boolean), { stage: I, stageSequence: U } = l, S = I === se ? we({ element: l, name: rn })?.extension?.value : void 0, P = Bo({ provisionalPositioning: e, drawDefinition: a, stageSequence: U, entryStatuses: Ja, structureId: u, roundTarget: S, stage: I }), v = P.filter((b) => !g?.includes(b.participantId)).map((b) => b.participantId), D = f?.filter((b) => !b.participantId && !b.bye && !b.qualifier).map((b) => b.drawPosition);
  if (!i && v.length > (D?.length || 0)) return F({ result: { error: Sh }, context: { unseededParticipantsCount: v.length, unfilledDrawPositionsCount: D?.length }, stack: m });
  let { appliedPolicies: y } = _e({ tournamentRecord: n, drawDefinition: a, event: p }), w = y?.[zc];
  if (l.stage === yt) {
    let b = P.reduce((T, R) => (T[R.groupingValue] || (T[R.groupingValue] = []), T[R.groupingValue].push(R.participantId), T), {});
    Object.keys(b).length && (w || (w = { policyName: "Playoff Avoidance" }), w.policyAttributes || (w.policyAttributes = []), w.policyAttributes.push({ groupings: b }));
  }
  return w && s ? Ck({ provisionalPositioning: e, unseededParticipantIds: v, inContextDrawMatchUps: t, unseededByePositions: r, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, participants: s, matchUpsMap: c, structureId: u, avoidance: w, drawSize: d }) : Fk({ provisionalPositioning: e, unseededParticipantIds: v, inContextDrawMatchUps: t, unfilledDrawPositions: D, multipleStructures: i, tournamentRecord: n, drawDefinition: a, seedBlockInfo: o, structureId: u, matchUpsMap: c, drawSize: d, event: p });
}
function Fk({ provisionalPositioning: e, unseededParticipantIds: t, inContextDrawMatchUps: r, unfilledDrawPositions: i, multipleStructures: n, tournamentRecord: a, drawDefinition: o, seedBlockInfo: s, matchUpsMap: c, structureId: u, drawSize: l, event: d }) {
  let p = l > 2 ? mr(i) : i.reverse();
  for (let m of t) {
    let f = p.pop();
    if (!n || f) {
      let h = Ji({ provisionalPositioning: e, inContextDrawMatchUps: r, tournamentRecord: a, drawDefinition: o, seedBlockInfo: s, participantId: m, drawPosition: f, matchUpsMap: c, structureId: u, event: d });
      if (h?.error && console.log("!!!!!", { result: h }), h?.error) return F({ result: h, stack: "randomUnseededDistribution" });
    }
  }
  return { ...x };
}
function Lk(e) {
  let t = e.structure ?? me(e).structure, r = "positionQualifiers", i = [];
  if (t.stage === nr) return F({ result: { error: Wa }, stack: r });
  let { unplacedRoundQualifierCounts: n, positionAssignments: a, roundDrawPositions: o } = _k(e);
  for (let s of Object.keys(n)) {
    let c = a?.filter((u) => o[s].includes(u.drawPosition) && !u.participantId && !u.qualifier && !u.bye).map((u) => u.drawPosition);
    if (n[s] > (c || 0)) return F({ result: { error: Uh }, context: { unfilledDrawPositions: c }, stack: r });
    te(0, n[s]).forEach(() => {
      let u = Lr(c);
      i.push(u), a?.forEach((l) => {
        l.drawPosition === u && (l.qualifier = !0, delete l.participantId, delete l.bye);
      });
    });
  }
  return { ...x, qualifierDrawPositions: i };
}
function _k({ drawDefinition: e, structure: t, structureId: r }) {
  t || ({ structure: t } = me({ drawDefinition: e, structureId: r })), r || ({ structureId: r } = t);
  let { positionAssignments: i } = _t({ structure: t }), { stage: n, stageSequence: a } = t, { qualifiersCount: o, roundQualifiersCounts: s } = ic({ drawDefinition: e, stageSequence: a, structureId: r, stage: n }), c = (s ? Object.keys(s) : []).map((h) => pe(h)), { matchUps: u } = Ve({ structure: t }), { roundProfile: l } = Ir({ matchUps: u }), d = Object.assign({}, ...c.filter((h) => l?.[h]).map((h) => ({ [h]: l?.[h]?.drawPositions?.filter(Boolean) ?? [] }))), p = i?.filter((h) => h.qualifier).map((h) => h.drawPosition), m = o - (p?.length ?? 0), f = p?.length;
  return { unplacedRoundQualifierCounts: Object.assign({}, ...c.map((h) => {
    let g = i?.filter((I) => I.qualifier && d[h]?.drawPositions?.includes(I.drawPosition)).map((I) => I.drawPosition);
    return { [h]: (s?.[h] ?? 0) - (g?.length ?? 0) };
  })), unplacedQualifiersCount: m, placedQualifiersCount: f, roundQualifiersCounts: s, positionAssignments: i, roundDrawPositions: d, qualifiersCount: o };
}
function JS({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, appliedPolicies: i, validSeedBlocks: n, drawDefinition: a, seedingProfile: o, seedBlockInfo: s, participants: c, groupsCount: u, structureId: l, matchUpsMap: d, structure: p, event: m }) {
  let f = [], h = [], g = 0;
  if (p || ({ structure: p } = me({ drawDefinition: a, structureId: l })), l || (l = p?.structureId), i || (i = _e({ drawDefinition: a }).appliedPolicies), !n) {
    let I = p && Ko({ provisionalPositioning: e, appliedPolicies: i, drawDefinition: a, seedingProfile: o, structure: p });
    I?.error && h.push(I.error), n = I?.validSeedBlocks;
  }
  return u = u ?? n?.length ?? 0, te(0, u).forEach(() => {
    if (g < (u || 0)) {
      let I = Bk({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: a, seedingProfile: o, seedBlockInfo: s, participants: c, structureId: l, matchUpsMap: d, event: m });
      I?.success && (g++, f.push(...I.seedPositions ?? [])), I.error && h.push({ seedPositionError: I.error });
    }
  }), h.length ? { error: h } : { ...x, seedPositions: f };
}
function Bk({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, participants: o, structureId: s, matchUpsMap: c, event: u }) {
  let { unplacedSeedParticipantIds: l, unfilledPositions: d } = hT({ provisionalPositioning: e, randomize: !0, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, structureId: s }), { appliedPolicies: p } = _e({ drawDefinition: i }), { avoidance: m } = p ?? {};
  m && o && l?.length > 2;
  let f = [];
  for (let h of l) {
    let g = d.pop();
    if (!g) return { error: js };
    f.push(g);
    let I = Ji({ provisionalPositioning: e, inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, seedingProfile: n, participantId: h, seedBlockInfo: a, drawPosition: g, matchUpsMap: c, structureId: s, event: u });
    if (!I.success) return I;
  }
  return { ...x, seedPositions: f };
}
function Vk({ provisionalPositioning: e, drawDefinition: t, structure: r }) {
  let { positionAssignments: i } = _t({ structure: r }), { seedAssignments: n } = si({ provisionalPositioning: e, drawDefinition: t, structure: r }), a = Object.assign({}, ...(n || []).filter((o) => o.participantId).map((o) => ({ [o.participantId]: o })));
  return i?.map((o) => a[o.participantId] ? { ...o, seedNumber: a[o.participantId].seedNumber, seedValue: a[o.participantId].seedValue } : "").filter(Boolean);
}
function jk({ orderedSortedFirstRoundSeededDrawPositions: e, validSeedBlocks: t, byesToPlace: r }) {
  let i = [];
  t.forEach((a) => Gk(a, r, i, e));
  let n = i.map((a) => Array.isArray(a) ? mr(a) : a).flat(1 / 0);
  return cv(r) && t.map((a) => a.seedNumbers[0]).includes(r) ? e : n;
}
function Gk(e, t, r, i) {
  if (t - r.length > e.drawPositions.length) r.push(...e.drawPositions);
  else {
    let n = Af(qt(e.drawPositions, 2));
    $k(n, r, i);
  }
}
function $k(e, t, r) {
  let i, n = r[t.length];
  for (; i = Vl(e, n); ) t.push(i), n = r[t.length];
}
function Vl(e, t) {
  return Array.isArray(e) && e.length !== 2 ? e.pop() : Array.isArray(e[0]) ? Wk(e, t) : qk(e, t);
}
function qk(e, t) {
  return e.includes(t) ? e.indexOf(t) ? e.pop() : e.shift() : Math.round(Math.random()) ? e.pop() : e.shift();
}
function Wk(e, t) {
  let r = e[0].flat(1 / 0).length, i = e[1].flat(1 / 0).length;
  if (r === i) {
    let n = e[0].flat(1 / 0).includes(t) ? e[0] : e[1];
    return Vl(t ? n : e[Math.round(Math.random())], t);
  }
  return r < i ? Vl(e[1], t) : Vl(e[0], t);
}
function Af(e) {
  let t = Math.floor(e.length / 2);
  return e.length > 2 ? [Af(e.slice(0, t)), Af(e.slice(t))] : e;
}
function Hk({ provisionalPositioning: e, relevantMatchUps: t, appliedPolicies: r, drawDefinition: i, seedingProfile: n, seedBlockInfo: a, byesToPlace: o, structure: s }) {
  a || (a = Ko({ provisionalPositioning: e, appliedPolicies: r, drawDefinition: i, seedingProfile: n, structure: s }));
  let { isFeedIn: c, isLuckyStructure: u, isContainer: l } = a, { validSeedBlocks: d } = a;
  r?.seeding?.containerByesIgnoreSeeding && (d = []);
  let p = Vk({ provisionalPositioning: e, drawDefinition: i, structure: s }) ?? [], m = Ue([].concat(...t.map((P) => P.drawPositions))), f = p.filter((P) => m.includes(P.drawPosition)), h = (P, v) => Os(P.seedValue) - Os(v.seedValue), g = d.reduce((P, v) => {
    let D = f.filter((y) => v.drawPositions?.includes(y.drawPosition)).sort(h);
    return P.concat(...D);
  }, []).map((P) => P.drawPosition), I = jk({ orderedSortedFirstRoundSeededDrawPositions: g, validSeedBlocks: d, byesToPlace: o }), U = ZS({ orderedSeedDrawPositions: g, relevantMatchUps: t }).slice(0, o), S = ZS({ orderedSeedDrawPositions: I, relevantMatchUps: t }).slice(0, o);
  return { strictSeedOrderByePositions: U, blockSeedOrderByePositions: S, isLuckyStructure: u, positionedSeeds: p, isContainer: l, isFeedIn: c };
}
function ZS({ orderedSeedDrawPositions: e, relevantMatchUps: t }) {
  let r = t.map((i) => i.drawPositions).map((i) => i?.sort((n, a) => n - a)).filter((i) => i?.[0] + 1 === i?.[1]);
  return e.map((i) => r.find((n) => n?.includes(i))).filter(Boolean).map((i) => i?.reduce((n, a) => e.includes(a) ? n : a, void 0)).filter(Boolean);
}
function zk({ provisionalPositioning: e, seedOrderByePositions: t, isLuckyStructure: r, appliedPolicies: i, drawDefinition: n, seedLimit: a, structure: o, isFeedIn: s }) {
  let c = i?.seeding?.seedingProfile, u = o.stage === se, { positionAssignments: l } = _t({ structure: o }), d = l?.filter((N) => N.participantId).map((N) => N.drawPosition), p = { isCollectionMatchUp: !1 }, { matchUps: m, roundMatchUps: f } = Ve({ provisionalPositioning: e, matchUpFilters: p, structure: o }), h = f?.[1] || [], g = o.structureType === yr ? m : h, I = Ue([].concat(...g.map((N) => N.drawPositions))), U = Math.min(...I) - 1, S = d?.filter((N) => I.includes(N)), P = (N) => {
    let C = Math.ceil(N.length / 2), k = [N.slice(0, C), N.slice(C)], O = k.map(($) => [].concat(...$.flat(1 / 0)).length), _ = Math.min(...O.flat(1 / 0)), B = Math.max(...O.flat(1 / 0)), L = O.indexOf(B), j = _ !== B, H = mr(k), [G, V] = !_ || j ? [k[L], k[1 - L]] : [H[0], H[1]];
    return { greaterHalf: G, lesserHalf: V };
  }, v = (N) => {
    let { greaterHalf: C, lesserHalf: k } = P(N), { greaterHalf: O, lesserHalf: _ } = P(C), B = mr(O.flat(1 / 0)).pop(), L = O.flat().filter((j) => j !== B);
    return { newlyFilteredChunks: [...k, ..._, L], drawPosition: B };
  }, D = (N) => !t.includes(N), y = (N) => !S?.includes(N), w = (N) => {
    let C = qt(N.sort(Ot), Math.ceil(N.length / 4)).map((_) => _.filter(y)), k = [].concat(...C.flat(1 / 0)).length, O = [];
    for (let _ = 0; _ < k; _++) {
      let { newlyFilteredChunks: B, drawPosition: L } = v(C);
      O.push(L), C = B;
    }
    return O;
  }, { validSeedBlocks: b } = Ko({ provisionalPositioning: e, allPositions: !0, appliedPolicies: i, drawDefinition: n, structure: o }), T = b?.map((N) => N.drawPositions?.map((C) => C + U)), R;
  if (s) {
    let N = I.length, { seedBlocks: C } = Kg({ cluster: Zu(c) === zd, participantsCount: N });
    R = C.map((k) => k.map((O) => O + U)).map(w).filter((k) => k.length);
  } else u ? R = T?.map((N) => N.filter(y)) : R = T?.map(w).filter((N) => N.length);
  let M = g.map((N) => N.drawPositions).map((N) => N?.sort((C, k) => C - k)).filter((N) => N?.[0] + 1 === N?.[1]), E = (N) => M.reduce((C, k) => k.includes(N) ? k.reduce((O, _) => _ !== N ? _ : O, void 0) : C, void 0), A = R.map((N) => N.map(E)).flat(1 / 0).filter(y).filter(D).filter(Boolean);
  if (u && !o.structures) {
    let N = a % 4, C = A.slice(0, N), k = f[o.roundLimit]?.length, O = qt(A.slice(N), k).map(mr).flat();
    A = C.concat(O);
  }
  return { unseededByePositions: A };
}
function Yk({ provisionalPositioning: e, drawDefinition: t, matchUpsMap: r, structure: i, event: n }) {
  let a = { isCollectionMatchUp: !1 }, { matchUps: o, roundMatchUps: s } = Ve({ afterRecoveryTimes: !1, provisionalPositioning: e, drawDefinition: t, matchUpFilters: a, matchUpsMap: r, structure: i, event: n }), c = s?.[1] || [], u = i?.structureType === yr, l = u ? o : c, d = u ? i?.structures?.length || 0 : o.length, { structureId: p, stage: m, stageSequence: f } = i, h = Bo({ entryStatuses: Ni, provisionalPositioning: e, drawDefinition: t, stageSequence: f, structureId: p, stage: m }), { qualifiersCount: g } = ic({ provisionalPositioning: e, drawDefinition: t, stageSequence: f, structureId: p, stage: m }), I = h.length + g, { positionAssignments: U, unassignedPositions: S } = _t({ structure: i }), P = S?.map((T) => T.drawPosition), v = U?.filter((T) => T.bye).length, D = U?.filter((T) => T.bye).map((T) => T.drawPosition), y = l.map((T) => T.drawPositions).filter((T) => T?.reduce((R, M) => !D?.includes(M) && R, !0)).flat(1 / 0).filter((T) => P?.includes(T)), w = U?.length, b = w ? w - I : 0;
  return b > d && i.stageSequence === 1 && i.stage !== nr && (b = d), { placedByes: v, byesCount: b, relevantMatchUps: l, placedByePositions: D, roundMatchUps: s, positionsToAvoidDoubleBye: y };
}
function ey({ provisionalPositioning: e, tournamentRecord: t, appliedPolicies: r, drawDefinition: i, seedBlockInfo: n, seedingProfile: a, matchUpsMap: o, structureId: s, structure: c, seedLimit: u, seedsOnly: l, event: d }) {
  c || ({ structure: c } = me({ drawDefinition: i, structureId: s })), s || (s = c?.structureId);
  let p = !(c?.structures ?? c?.stage === se), { byesCount: m, placedByes: f, relevantMatchUps: h } = Yk({ provisionalPositioning: e, drawDefinition: i, matchUpsMap: o, structure: c, event: d }), g = m - (f || 0);
  if (g <= 0) return { ...x };
  let { strictSeedOrderByePositions: I, blockSeedOrderByePositions: U, isLuckyStructure: S, isFeedIn: P } = Hk({ provisionalPositioning: e, relevantMatchUps: h, appliedPolicies: r, drawDefinition: i, seedingProfile: a, seedBlockInfo: n, byesToPlace: g, structure: c }), v = c?.structureType && [yr, Yd].includes(c.structureType) && r?.seeding?.containerByesIgnoreSeeding, D = p && U?.length ? U : I, { unseededByePositions: y } = zk({ provisionalPositioning: e, seedOrderByePositions: D, isLuckyStructure: S, appliedPolicies: r, drawDefinition: i, seedLimit: u, structure: c, isFeedIn: P }), w = (M) => M % 2, b = (M, E) => (M || []).every((A) => w(A) ? E !== A + 1 : E !== A - 1), T = [].concat(...D);
  if (!l) for (; y.length; ) {
    let M = y.find((E) => b(T, E));
    M ? (T.push(M), y = y.filter((E) => E !== M)) : (T.push(...y), y = []);
  }
  v && (T = mr(T), Yr({ ignoreSeededByes: v }) && console.log({ byePositions: T }));
  let R = T.slice(0, g);
  for (let M of R) {
    let E = Zr({ provisionalPositioning: e, tournamentRecord: t, drawDefinition: i, drawPosition: M, matchUpsMap: o, structureId: s, structure: c, event: d });
    if (E?.error) return E;
  }
  return { ...x, unseededByePositions: y, byeDrawPositions: R };
}
function el(e) {
  let { drawDefinition: t } = e, { applyPositioning: r = !0, provisionalPositioning: i, multipleStructures: n, placeByes: a = !0, tournamentRecord: o, placementGroup: s, seedingProfile: c, structureId: u, seedLimit: l, seedsOnly: d, drawType: p, drawSize: m, event: f } = e, h = [];
  r || (NP(), t = ie(t, !1, !0));
  let g = (N) => (r || Ol(), F({ result: N, stack: "automatedPositioning" })), I = (N) => (r || Ol(), N), U = me({ drawDefinition: t, structureId: u });
  if (U.error) return g(U);
  let S = U.structure;
  if (!S) return { error: mt };
  let P = e.appliedPolicies || _e({ drawDefinition: t, structure: S, event: f })?.appliedPolicies, { qualifiersCount: v } = ic({ stageSequence: S.stageSequence, provisionalPositioning: i, stage: S.stage, drawDefinition: t, structureId: u }), D = Ja;
  if (!Bo({ stageSequence: S.stageSequence, provisionalPositioning: i, stage: S.stage, placementGroup: s, drawDefinition: t, entryStatuses: D, structureId: u })?.length && !v) return I({ ...x });
  let y = e.matchUpsMap ?? or({ drawDefinition: t }), w = e.inContextDrawMatchUps ?? Et({ inContext: !0, drawDefinition: t, matchUpsMap: y })?.matchUps, b = [], T = Ko({ provisionalPositioning: i, appliedPolicies: P, drawDefinition: t, seedingProfile: c, structure: S });
  if (T.error) return T;
  let { validSeedBlocks: R } = T;
  h.push({ validSeedBlocks: R });
  let M = e.participants || (o ? ft({ withIndividualParticipants: !0, convertExtensions: !0, tournamentRecord: o })?.participants : []);
  if (Zu(S.seedingProfile || c) === Na) {
    let N = a ? ey({ provisionalPositioning: i, tournamentRecord: o, appliedPolicies: P, drawDefinition: t, seedBlockInfo: T, matchUpsMap: y, structure: S, seedLimit: l, seedsOnly: d, event: f }) : void 0;
    if (N?.error) return g(N);
    b = N.unseededByePositions, h.push({ action: "positionByes", unseededByePositions: b });
    let C = S.seedingProfile ? { positioning: S.seedingProfile } : c;
    if (N = JS({ seedingProfile: C, provisionalPositioning: i, inContextDrawMatchUps: w, tournamentRecord: o, appliedPolicies: P, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: T, participants: M, matchUpsMap: y, structure: S, event: f }), N.error) return g(N);
    h.push({ seedPositions: N.seedPositions, action: "positionSeedBlocks" });
  } else {
    if (p !== Ha) {
      let C = S.seedingProfile ? { positioning: S.seedingProfile } : c, k = JS({ seedingProfile: C, provisionalPositioning: i, inContextDrawMatchUps: w, tournamentRecord: o, appliedPolicies: P, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: T, participants: M, matchUpsMap: y, structure: S, event: f });
      if (k.error) return g(k);
      h.push({ action: "positionSeedBlocks", seedPositions: k.seedPositions });
    }
    let N = a ? ey({ provisionalPositioning: i, tournamentRecord: o, appliedPolicies: P, drawDefinition: t, seedBlockInfo: T, matchUpsMap: y, structure: S, seedLimit: l, seedsOnly: d, event: f }) : void 0;
    if (N?.error) return g(N);
    b = N?.unseededByePositions, h.push({ action: "positionByes", byeDrawPositions: N?.byeDrawPositions, unseededByePositions: b });
  }
  let E = {};
  if (!d) {
    let N = Lk({ inContextDrawMatchUps: w, tournamentRecord: o, appliedPolicies: P, validSeedBlocks: R, drawDefinition: t, seedBlockInfo: T, participants: M, matchUpsMap: y, structure: S });
    if (N.error || (N.conflicts && (E.qualifierConflicts = N.conflicts), h.push({ action: "positionQualifiers", qualifierDrawPositions: N.qualifierDrawPositions }), N = xk({ provisionalPositioning: i, inContextDrawMatchUps: w, unseededByePositions: b, multipleStructures: n, tournamentRecord: o, drawDefinition: t, seedBlockInfo: T, participants: M, matchUpsMap: y, structureId: u, structure: S, drawSize: m, event: f }), N.error)) return g(N);
    N.conflicts && (E.unseededConflicts = N.conflicts), h.push({ action: "positionUnseededParticipants" });
  }
  let { positionAssignments: A } = Je({ drawDefinition: t, structure: S });
  return tt({ drawDefinition: t, structureIds: [u] }), r || Ol(), { positionAssignments: A, conflicts: E, ...x, positioningReport: h };
}
function oc(e) {
  let { applyPositioning: t = !0, provisionalPositioning: r, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, placeByes: s, seedsOnly: c } = e;
  if (!n) return { error: zr };
  if (!wn({ drawDefinition: n, structureId: o }) && !r) return { error: rh };
  let u = MT({ drawDefinition: n, structureId: o }).playoffStructures?.sort((p, m) => id(p) - id(m)), l = [], d = [];
  if (u) for (let p of u) {
    let { structureId: m } = p, f = el({ structureId: m, provisionalPositioning: r, applyPositioning: t, tournamentRecord: i, drawDefinition: n, seedingProfile: a, placeByes: s, seedsOnly: c });
    if (f.error) return f;
    f.positionAssignments && l.push({ positionAssignments: f.positionAssignments, structureId: m }), f.positioningReport && d.push(f.positioningReport);
  }
  return { ...x, structurePositionAssignments: l, positioningReports: d };
}
function AT({ validation: e = !0, tournamentRecord: t, drawDefinition: r, participantId: i, structureId: n, seedValue: a, event: o }) {
  if (!r) return { error: ne };
  if (!n) return { error: Qr };
  let s = (t?.participants ?? []).find((p) => p.participantId === i);
  if (t && !s) return { error: Li };
  let { structure: c } = me({ drawDefinition: r, structureId: n });
  if (!c) return { error: mt };
  if (!(!e || gt(a) || a === void 0 || a === "" || typeof a == "string" && a.split("-").every((p) => gt(p) && pe(p) > 0))) return { error: z };
  let { seedAssignments: u } = si({ drawDefinition: r, structure: c }), l = u?.map((p) => p.seedNumber), d = u?.find((p) => p.participantId === i);
  if (d) {
    let p = typeof a == "string" ? a.includes("-") && a.split("-").map((m) => parseInt(m)).join("-") || parseInt(a) > 0 && parseInt(a) || "" : a && a > 0 && a || "";
    d.seedValue = p;
  } else {
    let p = { seedNumber: Math.max(0, ...l || []) + 1, participantId: i };
    a && (p.seedValue = a), c.seedAssignments || (c.seedAssignments = []), c.seedAssignments.push(p);
  }
  return Iw({ tournamentId: t?.tournamentId, eventId: o?.eventId, drawDefinition: r, structure: c }), { ...x };
}
function nI({ qualifyingParticipantId: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n }) {
  return tI({ positionActionName: "qualifierDrawPositionAssignment", participantId: e, isQualifierPosition: !0, tournamentRecord: t, drawDefinition: r, drawPosition: i, structureId: n });
}
function eu({ targetRoundNumber: e, finishingPosition: t, drawDefinition: r, structureId: i, linkType: n }) {
  let { links: a } = tc({ drawDefinition: r, structureId: i }) || {}, o = (a?.target || []).filter(({ linkType: s }) => s === n).filter(({ target: s }) => !e || e === s.roundNumber).map((s) => {
    let c = s.source.structureId, { structure: u } = me({ structureId: c, drawDefinition: r });
    if (!(t && u?.finishingPosition !== t)) return s;
  }).filter(Boolean);
  return { sourceStructureIds: o.map(({ source: s }) => s.structureId), relevantLinks: o };
}
var Kk = (e, t) => {
  let r = [...new Set(t.slice(0, e.length))], i = [...r].sort((s, c) => s - c), n = /* @__PURE__ */ new Set(), a = [];
  r.forEach((s) => {
    let c = e.indexOf(s);
    if (c !== -1 && !n.has(c)) a.push(c), n.add(c);
    else {
      let u = i.indexOf(s), l = e.findIndex((d, p) => !n.has(p));
      for (; n.has(l) && l === -1 && n.size < e.length; ) l = e.findIndex((d, p) => !n.has(p) && p > l);
      a.push(u), n.add(u);
    }
  });
  let o = e.filter((s, c) => !n.has(c));
  return [...a, ...o];
};
function CT({ targetRoundNumber: e = 1, tournamentRecord: t, drawDefinition: r, event: i, randomList: n }) {
  let a = oe({ drawDefinition: r, event: i, tournamentRecord: t }, [{ [lr]: !0, [qn]: !0, [Vt]: !0 }]);
  if (a.error) return a;
  let o = [], s = [], c = r.structures?.find((g) => g.stage === re && g.stageSequence === 1);
  if (!c) return F({ result: { error: ch } });
  let u = (_e({ tournamentRecord: t, drawDefinition: r, structure: c, event: i }).appliedPolicies ?? {})[vn]?.requireCompletedStructures, { qualifierPositions: l, positionAssignments: d } = _t({ structure: c });
  if (!l.length) return F({ result: { error: Uh } });
  let p = te(0, l.length);
  n && (p = Kk(p, n));
  let m = d.map((g) => g.participantId).filter(Boolean), { relevantLinks: f } = eu({ structureId: c.structureId, targetRoundNumber: e, linkType: In, drawDefinition: r }) || {}, { relevantLinks: h } = eu({ structureId: c.structureId, targetRoundNumber: e, linkType: gn, drawDefinition: r }) || {};
  for (let g of f) {
    let I = r.structures?.find((S) => S.structureId === g.source.structureId);
    if (I?.stage !== se) continue;
    let U = wn({ structureId: g.source.structureId, drawDefinition: r });
    if (!u || U) {
      let S = I.qualifyingRoundNumber, { matchUps: P } = Ve({ matchUpFilters: { ...S && { roundNumbers: [S] }, isCollectionMatchUp: !1, hasWinningSide: !0 }, afterRecoveryTimes: !1, inContext: !0, structure: I });
      for (let v of P) {
        let D = v.matchUpStatus === "BYE" && v.sides?.find(({ participantId: w }) => w), y = v.sides.find((w) => w?.sideNumber === v.winningSide);
        if (y || D) {
          let { participantId: w } = y || D || {};
          w && !m.includes(w) && s.push(w);
        }
      }
    }
  }
  for (let g of h) {
    let I = r?.structures?.find((U) => U.structureId === g.source.structureId);
    if (I?.stage === se && wn({ structureId: g.source.structureId, drawDefinition: r })) {
      let { positionAssignments: U } = Je({ structure: I }), S = U?.map((P) => {
        let v = P.participantId, D = we({ element: P, name: _n }).extension?.value;
        return D ? { participantId: v, groupOrder: D?.groupOrder } : {};
      }).filter(({ groupOrder: P, participantId: v }) => P === 1 && !m.includes(v)).map(({ participantId: P }) => P) ?? [];
      S && s.push(...S);
    }
  }
  return s.length ? (p.forEach((g, I) => {
    let U = s[I], S = l[g].drawPosition;
    U && nI({ qualifyingParticipantId: U, structureId: c.structureId, drawPosition: S, tournamentRecord: t, drawDefinition: r })?.success && o.push({ participantId: U, drawPosition: S });
  }), F({ result: ae({ ...x, assignedParticipants: o }) })) : F({ result: { error: Jv } });
}
function OT({ drawDefinition: e, orderMap: t }) {
  return e ? ((typeof t != "object" || !Object.values(t).every((r) => Ie(r))) && F({ result: { error: z }, context: { orderMap: t } }), e.structures || (e.structures = []), e.structures.forEach((r) => {
    let i = t[r.structureId];
    i && (r.structureOrder = i);
  }), e.structures.sort((r, i) => gs(r.structureOrder) - gs(i.structureOrder)), { ...x }) : { error: ne };
}
function Rp({ drawDefinition: e }) {
  let t = e.structures ?? [], r = e.links ?? [], i = /* @__PURE__ */ new Map(), n = (g) => {
    let I = i.get(g) || i.set(g, { drawSources: [], drawTargets: [], progeny: [], sources: [], targets: [] }) && i.get(g);
    if (I && !I?.stage) {
      let U = t.find((S) => S.structureId === g);
      I.stage = U?.stage;
    }
    return I;
  }, a = {}, o = {}, s = r.map((g) => {
    let I = g.source.structureId, U = g.target.structureId, S = n(I), P = n(U);
    return [Ea, Ii, Kd, Na].includes(g.target.feedProfile) ? (S?.targets.push(U), P?.sources.push(I)) : g.target.feedProfile === gi && (P?.drawSources.push(I), S?.drawTargets.push(U)), o[U] = o[U] || g.target.feedProfile === gi, a[U] = Ue([...a[U] || [], I]).filter(Boolean), [g.source.structureId, g.target.structureId];
  });
  for (let g of i.keys()) {
    let I = i.get(g);
    if (I) {
      let U = I.targets ?? [];
      for (; U.length; ) {
        let S = U.pop(), P = S && i[S];
        P?.targets?.length ? U.push(...P.targets) : P && (I.rootStage = P.stage);
      }
      if (I.rootStage || (I.rootStage = I.stage), !I.targets?.length) {
        let S = I.sources ?? [];
        for (; S.length; ) {
          let P = S.pop(), v = P && i[P];
          if (v?.sources?.length) {
            for (let D of v.sources) I.progeny?.includes(D) || I.progeny?.push(D);
            S.push(...v.sources);
          }
        }
      }
    }
  }
  let c = 0;
  for (let g of i.keys()) {
    let I = i.get(g);
    if (I && I.rootStage === se) {
      let U = [I.drawTargets?.[0]], S = 0;
      for (; U.length; ) {
        S += 1;
        let P = U.pop(), v = P ? i.get(P) : void 0;
        v?.drawTargets?.length && U.push(v.drawTargets[0]);
      }
      I.distanceFromMain = S, S > c && (c = S);
    }
  }
  let u = s.length;
  te(0, Math.ceil(u / 2)).forEach(() => {
    s = te(0, u).map((g) => {
      let I = s[g], U = s.reduce((S, P) => gr(I, P) ? S.concat(...P) : S, []) || [];
      return Ue(I.concat(...U));
    });
  });
  let l = s[0], d = (g, I) => Pt(g, I).length === g.length, p = s.slice(1).reduce((g, I) => g && d(I, l), !0), m = [l].filter(Boolean), f = [l].filter(Boolean);
  t.forEach((g) => {
    let { structureId: I, stage: U } = g;
    m.find((S) => S.includes(I)) || (m.push([I]), U !== zt && f.push([I]));
  });
  let h = p && f.length === 1;
  return !r?.length && t.length === 1 && n(t[0].structureId), { structureProfiles: Object.fromEntries(i), allStructuresLinked: h, maxQualifyingDepth: c, sourceStructureIds: a, hasDrawFeedProfile: o, structureGroups: m };
}
function kT({ drawDefinition: e }) {
  let { maxQualifyingDepth: t, structureProfiles: r } = Rp({ drawDefinition: e });
  for (let i of e.structures) {
    let n = r[i.structureId];
    n.distanceFromMain && (i.stageSequence = t + 1 - n.distanceFromMain);
  }
  return { ...x };
}
function aI(e) {
  let t = oe(e, [{ [Vt]: !0, [lr]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, drawDefinition: i, structure: n, link: a } = e;
  return Qk({ tournamentId: r.tournamentId, drawDefinition: i, structure: n, link: a });
}
function Qk(e) {
  let t = oe(e, [{ [lr]: !0, [ep]: !0 }, { link: !0, [Mr]: Nr, [gv]: oh }]);
  if (t.error) return t;
  let { drawDefinition: r, tournamentId: i, structure: n, eventId: a, link: o } = e, s = o.target.structureId, c = me({ drawDefinition: r, structureId: s });
  if (c.error) return F({ stack: "attachQualifyingStructure", context: { targetStructureId: s }, result: c });
  r.structures || (r.structures = []), r.links || (r.links = []), r.structures.push(n), r.links.push(o), kT({ drawDefinition: r });
  let u = Ve({ structure: n })?.matchUps || [];
  return oa({ drawDefinition: r, tournamentId: i, matchUps: u, eventId: a }), tt({ drawDefinition: r, structureIds: [n.structureId] }), { ...x };
}
function xT({ drawDefinition: e, structureDetails: t }) {
  if (!Array.isArray(t)) return { error: z };
  if (!e) return { error: ne };
  let r = Object.assign({}, ...t.map((i) => {
    if (!xe(i)) return;
    let { structureId: n, structureName: a } = i || {};
    if (!(!n || !a)) return { [n]: a };
  }).filter(Boolean));
  if (!Object.values(r).length) return { error: ue };
  for (let i of e.structures || []) {
    let n = r[i.structureId];
    if (n && (i.structureName = n), i.structures) for (let a of i.structures) {
      let o = r[a.structureId];
      o && (a.structureName = o);
    }
  }
  return { ...x };
}
function oI({ drawDefinition: e, timeItem: t }) {
  if (!e) return { error: zr };
  if (!t) return { error: Dh };
  let r = t && Object.keys(t), i = ["itemType", "itemValue"];
  if (i.filter((a) => r.includes(a)).length !== i.length) return { error: Ph };
  e.timeItems || (e.timeItems = []);
  let n = (/* @__PURE__ */ new Date()).toISOString();
  return Object.assign(t, { createdAt: n }), e.timeItems.push(t), Eu({ drawDefinition: e }), { ...x };
}
function FT(e) {
  let { tournamentRecord: t, drawDefinition: r, structureId: i, event: n } = e, a = oe(e, [{ drawDefinition: !0, structureId: !0 }]);
  if (a.error) return a;
  let o = r.structures ?? [], s = o.find((I) => I.structureId === i);
  if (!s) return { error: mt };
  let c = o.find(({ stage: I, stageSequence: U }) => I === re && U === 1), u = i === c?.structureId, l = o.filter(({ stage: I }) => I === se).map(qr("structureId"));
  if (u && !l.length) return { error: Uv };
  let d = l.includes(i), p = Xk({ isQualifyingStructure: d, structure: s, ...e });
  if (p?.error) return p;
  let { structureIdsToRemove: m, relatedStructureIdsMap: f } = Zk({ qualifyingStructureIds: l, isQualifyingStructure: d, isMainStageSequence1: u, mainStageSequence1: c, drawDefinition: r, structureId: i }), { removedMatchUpIds: h, removedStructureIds: g } = ex({ relatedStructureIdsMap: f, qualifyingStructureIds: l, isMainStageSequence1: u, mainStageSequence1: c, drawDefinition: r, structureIdsToRemove: m, structureId: i });
  if (Jk({ removedMatchUpIds: h, drawDefinition: r }), u) {
    let I = (c.matchUps ?? [])?.map(qr("matchUpId"));
    h.push(...I), c.positionAssignments = [], c.seedAssignments = [], c.matchUps = [], c.extensions && (c.extensions = []);
  }
  return d && kT({ drawDefinition: r }), bn({ tournamentId: t?.tournamentId, matchUpIds: h, action: "removeStructure", eventId: n?.eventId, drawDefinition: r }), tt({ drawDefinition: r, eventId: n?.eventId }), { ...x, removedMatchUpIds: h, removedStructureIds: g };
}
function Xk({ isQualifyingStructure: e, tournamentRecord: t, drawDefinition: r, structureId: i, structure: n, event: a, force: o }) {
  let s = [i];
  if (e) {
    let c = (l) => r.links?.find((d) => d.target.structureId === l), u = c(i)?.source.structureId;
    for (; u; ) s.push(u), u = c(u)?.source.structureId;
  }
  if (Et({ matchUpFilters: { structureIds: s }, drawDefinition: r }).matchUps?.some(({ score: c }) => Bt({ score: c }))) {
    let c = _e({ tournamentRecord: t, drawDefinition: r, structure: n, event: a })?.appliedPolicies;
    if (!(o ?? c?.[oi]?.allowDeletionWithScoresPresent?.structures)) return { error: Iu };
  }
  return { ...x };
}
function Jk({ removedMatchUpIds: e, drawDefinition: t }) {
  let { matchUps: r } = Et({ drawDefinition: t });
  r?.forEach((i) => {
    i.winnerMatchUpId && e.includes(i.winnerMatchUpId) && delete i.winnerMatchUpId, i.loserMatchUpId && e.includes(i.loserMatchUpId) && delete i.loserMatchUpId;
  });
}
function Zk({ qualifyingStructureIds: e, isQualifyingStructure: t, isMainStageSequence1: r, mainStageSequence1: i, drawDefinition: n, structureId: a }) {
  let o = (n.structures ?? []).map(qr("structureId")), s = (l) => n.links?.map((d) => d.source.structureId === l && d.target.structureId !== i?.structureId && d.target.structureId).filter(Boolean) ?? [], c = (l) => n.links?.map((d) => e.includes(d.source.structureId) && d.target.structureId === l && d.source.structureId).filter(Boolean) ?? [], u = /* @__PURE__ */ new Map();
  return o.forEach((l) => u.set(l, t ? c(l) : s(l))), { structureIdsToRemove: r ? u.get(a) : [a], relatedStructureIdsMap: u };
}
function ex({ relatedStructureIdsMap: e, qualifyingStructureIds: t, isMainStageSequence1: r, mainStageSequence1: i, drawDefinition: n, structureIdsToRemove: a, structureId: o }) {
  let s = [], c = [];
  for (; a?.length; ) {
    let u = a.pop();
    c.push(...ix({ idBeingRemoved: u, drawDefinition: n }));
    let l = rx({ qualifyingStructureIds: t, isMainStageSequence1: r, idBeingRemoved: u, drawDefinition: n, structureId: o });
    s.push(...l.removedStructureIds);
    let d = tx({ relatedStructureIdsMap: e, mainStageSequence1: i, idBeingRemoved: u, structureId: o });
    d?.length && a.push(...d);
  }
  return { removedMatchUpIds: c, removedStructureIds: s };
}
function tx({ idBeingRemoved: e, relatedStructureIdsMap: t, mainStageSequence1: r, structureId: i }) {
  return e && t.get(e)?.filter((n) => n !== r?.structureId || i === r.structureId);
}
function rx({ qualifyingStructureIds: e, isMainStageSequence1: t, idBeingRemoved: r, drawDefinition: i, structureId: n }) {
  let a = [];
  return i.links = i.links?.filter((o) => o.source.structureId !== r && o.target.structureId !== r) ?? [], (!t || t && e.length || r !== n) && (i.structures = (i.structures ?? []).filter((o) => (r && r === o.structureId && a.push(r), o.structureId !== r))), { removedStructureIds: a };
}
function ix({ idBeingRemoved: e, drawDefinition: t }) {
  let { structure: r } = me({ structureId: e, drawDefinition: t }), i = Ve({ structure: r }).matchUps;
  return og(i);
}
function dd({ stageSequence: e = 1, drawDefinition: t, drawSize: r, stage: i }) {
  if (!t) return { error: ne };
  if (!Ng({ drawDefinition: t, stage: i })) return { error: Wa };
  let n = eO({ drawDefinition: t, stage: i }), { qualifiersCount: a } = ic({ drawDefinition: t, stageSequence: e, stage: i }), o = n + a;
  if (r < o) return { error: Pv };
  let { entryProfile: s } = Rg({ attributes: [{ [i]: { drawSize: r } }], drawDefinition: t });
  return tt({ drawDefinition: t }), { ...x, entryProfile: s };
}
function LT({ qualifiersCount: e = 0, drawDefinition: t, stage: r }) {
  return t ? Ng({ drawDefinition: t, stage: r }) ? (Rg({ attributes: [{ [r]: { qualifiersCount: e } }], drawDefinition: t }), tt({ drawDefinition: t }), { ...x }) : { error: Wa } : { error: ne };
}
function nx({ drawDefinition: e, drawSize: t }) {
  if (!e) return { error: ne };
  let r = dd({ stage: zt, stageSequence: 1, drawDefinition: e, drawSize: t });
  return r.error ? r : (tt({ drawDefinition: e }), { ...x });
}
function _T(e) {
  return nx(e);
}
function BT({ tournamentRecord: e, drawDefinition: t, event: r, structureId: i }) {
  if (!t) return { error: ne };
  let n = t.structures?.find((o) => o.stage === se && o.structureId === i);
  if (!n) return { error: mt };
  if (n.matchUps?.some(({ matchUpStatus: o, score: s }) => Bt({ score: s }) ?? Lt.includes(o))) return { error: Iu };
  let a = n.matchUps?.map(({ matchUpId: o }) => o) || [];
  return n.positionAssignments = [], n.seedAssignments = [], n.matchUps = [], bn({ tournamentId: e?.tournamentId, action: "resetVoluntaryConsolationStructure", matchUpIds: a, drawDefinition: t }), tt({ tournamentId: e?.tournamentId, eventId: r?.eventId, drawDefinition: t, structureIds: [n.structureId] }), { ...x };
}
var ax = "qualifierDrawPositionAssignment", ox = "withdrawParticipantAtDrawPosition", sx = "alternateDrawPositionAssignment", cx = "luckyLoserDrawPositionAssignment", ty = "removeDrawPositionAssignment", VT = "swapDrawPositionAssignments", ux = "modifyPairAssignment", lx = "adHocPositionSwap", dx = "modifyParticipantOtherName", ry = "assignDrawPosition", px = "removeSeededParticipant", mx = "assignDrawPositionBye", fx = "modifySeedAssignment", jT = "addPenalty", sI = "MODIFY_PAIR", Np = "QUALIFIER", cI = "ALTERNATE", uI = "WITHDRAW", To = "ASSIGN", Cf = "REMOVE", lI = "LUCKY", Ac = "REMOVE_SEED", Ep = "SWAP", tu = "NICKNAME", mo = "SEED_VALUE", bo = "PENALTY", hx = { MODIFY_PAIR_ASSIGNMENT: sI, QUALIFYING_PARTICIPANT: Np, ALTERNATE_PARTICIPANT: cI, WITHDRAW_PARTICIPANT: uI, ASSIGN_PARTICIPANT: To, LUCKY_PARTICIPANT: lI, REMOVE_ASSIGNMENT: Cf, SWAP_PARTICIPANTS: Ep, ADD_NICKNAME: tu, REMOVE_SEED: Ac, ADD_PENALTY: bo, ASSIGN_BYE: "BYE", SEED_VALUE: mo };
function GT({ tournamentRecord: e, drawDefinition: t, drawPositions: r, structureId: i, event: n }) {
  if (!t) return { error: ne };
  if (!i) return { error: Qr };
  if (r?.length !== 2) return { error: z, drawPositions: r };
  let a = or({ drawDefinition: t }), { matchUps: o } = Et({ inContext: !0, drawDefinition: t, matchUpsMap: a }), { structure: s } = me({ drawDefinition: t, structureId: i });
  if (!s) return { error: mt };
  let c = _e({ tournamentRecord: e, drawDefinition: t, event: n }).appliedPolicies ?? {}, u;
  if (s.structureType === yr ? u = Ux({ inContextDrawMatchUps: o, tournamentRecord: e, drawDefinition: t, drawPositions: r, matchUpsMap: a, structure: s, event: n }) : u = gx({ inContextDrawMatchUps: o, tournamentRecord: e, drawDefinition: t, drawPositions: r, matchUpsMap: a, structure: s, event: n }), u.error) return u;
  if (Dg({ structure: s, drawPositions: r }), dp({ appliedPolicies: c, drawDefinition: t, positionAction: { name: VT, drawPositions: r, structureId: i } }), sa({ tournamentId: e?.tournamentId, drawDefinition: t, structure: s, event: n }), n.eventType === jr) {
    let l = Ve({ matchUpFilters: { matchUpTypes: [Hr] }, inContext: !0, structure: s }).matchUps.filter((p) => p.drawPositions?.some((m) => r.includes(m))), d = Ve({ matchUpFilters: { matchUpTypes: [Hr] }, structure: s }).matchUps;
    l.forEach((p) => {
      (p.sides || []).forEach((m) => {
        let f = m?.drawPosition;
        if (r.includes(f)) {
          let h = m.participantId, g = d.find(({ matchUpId: U }) => U === p.matchUpId), I = p?.sides?.reduce((U, S, P) => S.drawPosition === f ? P : U, void 0);
          Jg({ inContextTargetMatchUp: p, drawPositionSideIndex: I, teamParticipantId: h, tournamentRecord: e, drawDefinition: t, matchUp: g, event: n });
        }
      });
    });
  }
  return tt({ drawDefinition: t, structureIds: [i] }), { ...x };
}
function gx({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPositions: i, matchUpsMap: n, structure: a, event: o }) {
  let s = a?.positionAssignments.filter((u) => i?.includes(u.drawPosition));
  if (!s) return { error: z, structure: a, info: "Missing positionAssignments" };
  if (s.filter(({ bye: u }) => u).length === 2) return { ...x };
  if (s.filter(({ qualifier: u }) => u).length === 2) return { ...x };
  let c = s.some(({ qualifier: u }) => u);
  return s.some(({ bye: u }) => u) && !c ? $T({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o }) : Ix({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o });
}
function $T({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: i, matchUpsMap: n, structure: a, event: o }) {
  let s = i.find(({ bye: f }) => f), c = i.find(({ participantId: f }) => f), u = s.drawPosition, { participantId: l, drawPosition: d } = c, { structureId: p } = a, m = Zc({ drawPosition: u, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: p, matchUpsMap: n });
  return m.error || (m = Zc({ drawPosition: d, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: p, matchUpsMap: n }), m.error) || (Zr({ drawPosition: d, tournamentRecord: t, drawDefinition: r, structureId: p, matchUpsMap: n, event: o }), m = Ji({ drawPosition: u, inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: p, participantId: l, matchUpsMap: n, event: o }), m.error) ? m : { ...x };
}
function Ix({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: i, matchUpsMap: n, structure: a, event: o }) {
  let s = Object.assign({}, ...i.map((c, u) => {
    let { drawPosition: l } = c, d = { ...i[1 - u], drawPosition: l };
    return { [l]: d };
  }));
  return a.positionAssignments = a.positionAssignments.map((c) => s[c.drawPosition] || c), eI({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, assignments: i, structure: a, event: o }), { ...x };
}
function Ux({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPositions: i, matchUpsMap: n, structure: a, event: o }) {
  let s = a.structures?.reduce((u, l) => {
    let d = l?.positionAssignments.filter((p) => i?.includes(p.drawPosition));
    return d && u.push(...d), u;
  }, []);
  if (s.filter(({ bye: u }) => u).length === 2) return { ...x };
  if (s.filter(({ qualifier: u }) => u).length === 2) return { ...x };
  eI({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, matchUpsMap: n, assignments: s, structure: a, event: o });
  let c = s.some(({ qualifier: u }) => u);
  if (s.some(({ bye: u }) => u) && !c) $T({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, assignments: s, matchUpsMap: n, structure: a, event: o });
  else {
    let u = ie(s, !1, !0);
    s.forEach((l, d) => {
      let p = u[1 - d].participantId;
      l.qualifier = u[1 - d].qualifier, l.participantId = p;
    });
  }
  return { ...x };
}
function qT({ tournamentRecord: e, drawDefinition: t, participantId: r, structureId: i }) {
  let n = "removeSeededParticipant";
  if (!e) return { error: J };
  if (!t) return { error: ne };
  let a = (t.structures ?? []).find((o) => o.structureId === i);
  return a ? !a.stage || ![re, se].includes(a.stage) || a.stage === re && a.stageSequence !== 1 ? F({ result: { error: $a }, stack: n }) : a.seedAssignments?.find((o) => o.participantId === r) ? { ...x } : F({ info: "participant not seeded", result: { error: Kt }, context: { participantId: r } }) : F({ result: { error: mt }, stack: n });
}
function tl({ targetEntryRound: e = 1, finishingPositions: t, sourceRoundNumber: r, sourceStructureId: i, targetStructureId: n, linkType: a = In }) {
  return !i || !n ? { error: Qr } : { link: ae({ linkType: a, source: { roundNumber: r, structureId: i, finishingPositions: t }, target: { feedProfile: gi, roundNumber: e, structureId: n } }) };
}
function Xo({ matchUp: e, tieFormat: t, isMock: r, uuids: i }) {
  let { collectionDefinitions: n } = t ?? {};
  return { tieMatchUps: (n ?? []).map((a) => rl({ matchUp: e, collectionDefinition: a, uuids: i, isMock: r })).filter(Boolean).flat() };
}
function rl({ collectionPositionOffset: e = 0, collectionDefinition: t, matchUpsLimit: r, matchUp: i, isMock: n, uuids: a }) {
  let { matchUpCount: o, matchUpType: s, collectionId: c, processCodes: u } = t || {}, l = r ?? o ?? 0, d = (p) => {
    if (!n && !i?.isMock) return a?.pop() ?? je();
    let m = t?.collectionId;
    return a?.pop() ?? `${i?.matchUpId}-${m}-TMU-${p + 1}`;
  };
  return te(0, l).map((p) => {
    let m = e + p + 1;
    return { sides: [{ sideNumber: 1 }, { sideNumber: 2 }], matchUpId: d(p), matchUpStatus: Dt, collectionPosition: m, collectionId: c, processCodes: u, matchUpType: s, isMock: n };
  });
}
function dI({ roundPosition: e, roundNumber: t, idPrefix: r, uuids: i }) {
  return r ? `${r}-${t}-${e}` : i?.pop() || je();
}
function pd({ includeMatchUpType: e, matchUpType: t, roundNumber: r, matchUps: i, idPrefix: n, isMock: a, uuids: o, nodes: s }) {
  let c = 0, u = [], l = 1, d = r - 1, p = s?.length;
  for (; c < (p || 0); ) {
    let m = s?.[c], f = s?.[c + 1];
    d && (m.roundNumber = d), f && d && (f.roundNumber = d);
    let h = dI({ roundPosition: l, roundNumber: r, idPrefix: n, uuids: o }), g = { roundPosition: l, children: [m, f], matchUpId: h };
    u.push(g);
    let I = { drawPositions: g.children.map((U) => U?.drawPosition).filter(Boolean), matchUpStatus: Dt, matchUpId: g.matchUpId, roundPosition: l, roundNumber: r };
    e && t && (I.matchUpType = t), a && (I.isMock = !0), i.push(I), l++, c += 2;
  }
  return { roundNodes: u, matchUps: i };
}
function Zi({ finishingPositionOffset: e, finishingPositionLimit: t, qualifyingRoundNumber: r, qualifyingPositions: i, matchUpType: n, roundLimit: a, idPrefix: o, drawSize: s, isMock: c, uuids: u }) {
  if (isNaN(s) || s < 2 || i && s <= i) return { matchUps: [], roundsCount: 0 };
  if (i && (!Fi(s) || s % i)) {
    let g = i;
    for (; g < s; ) g = 2 * g;
    s = g;
  }
  let l = i && !(s % 2) && (!isNaN(i) || r && !isNaN(r)) && (s / i === Math.round(s / i) || r && s / r === Math.round(s / r));
  if (!Fi(s) && !l) return { matchUps: [], roundsCount: 0 };
  let d = te(1, s + 1).map((g) => ({ drawPosition: g })), p, m = [], f = 1;
  for ({ roundNodes: p, matchUps: m } = pd({ matchUpType: n, roundNumber: f, idPrefix: o, matchUps: m, isMock: c, nodes: d, uuids: u }), f++, a = a ?? r; p.length > 1; ) i && p.length === i && (a = f - 1), { roundNodes: p, matchUps: m } = pd({ nodes: p, matchUpType: n, roundNumber: f, idPrefix: o, matchUps: m, isMock: c, uuids: u }), f++;
  let h = f - 1;
  return m = qu({ finishingPositionOffset: e, finishingPositionLimit: t, roundsCount: h, roundLimit: a, matchUps: m }), a ? m = m.filter((g) => a && (g.roundNumber ?? 0) <= a) : a = f - 1, { drawSize: s, matchUps: m, roundsCount: h, roundLimit: a };
}
function pI(e) {
  let t = "generateQualifyingStructure";
  if (!e.drawDefinition) return F({ result: { error: ne }, stack: t });
  if (e.drawSize && !Ie(e.drawSize) || e.participantsCount && !Ie(e.participantsCount) || e.qualifyingPositions && !Ie(e.qualifyingPositions)) return F({ result: { error: z }, stack: t });
  let r = e.drawSize ?? eh(e.participantsCount), { hasExistingDrawDefinition: i, qualifyingRoundNumber: n, qualifyingPositions: a, targetStructureId: o, structureOptions: s, appliedPolicies: c, qualifyingOnly: u, drawDefinition: l, matchUpFormat: d, structureName: p, structureId: m, roundTarget: f, tieFormat: h, drawType: g, idPrefix: I, isMock: U, uuids: S } = e;
  if (!e.drawSize) return F({ result: { error: mu }, context: { drawSize: r }, stack: t });
  if (a && a >= e.drawSize) return F({ result: { error: z }, context: { drawSize: r, qualifyingPositions: a }, stack: t });
  let P, v, D, y, w = 0, b, T = 1, { structureProfiles: R } = Rp({ drawDefinition: l }), M = R[o];
  if (!M) return F({ result: { error: mt }, context: { targetStructureId: o }, stack: t });
  let E = l.matchUpType, A = f ? `${f}-` : "", N = M.stage === se, C = c?.[Rs]?.namingConventions?.pre ?? nO[Rs]?.namingConventions?.pre, k = N && C ? `${C}-` : "", O = p ?? (A ? `${k}${ir(se)} ${A}` : `${k}${ir(se)}`);
  if (g === Di) {
    let { maxRoundNumber: L, structures: j, groupCount: H } = Xu({ structureName: p ?? O, structureId: m ?? S?.pop(), hasExistingDrawDefinition: i, stage: se, structureOptions: s, appliedPolicies: c, qualifyingOnly: u, stageSequence: T, matchUpType: E, roundTarget: f, tieFormat: h, idPrefix: I, drawSize: r, isMock: U, uuids: S });
    w = H, P = L, D = j[0], b = [1];
  } else ({ drawSize: r, matchUps: y, roundLimit: P, roundsCount: v } = Zi({ qualifyingRoundNumber: n, qualifyingPositions: a, matchUpType: E, idPrefix: I, drawSize: r, isMock: U, uuids: S })), P || (P = v), D = ii({ structureName: p ?? O, structureId: m ?? S?.pop(), qualifyingRoundNumber: P, stage: se, matchUpFormat: d, stageSequence: T, matchUpType: E, roundLimit: P, matchUps: y }), f && Be({ extension: { name: rn, value: f }, element: D }), w = y?.filter((L) => L.roundNumber === P)?.length;
  let _ = g === Di ? gn : In, B = D && P && tl({ sourceStructureId: D.structureId, sourceRoundNumber: P, targetStructureId: o, finishingPositions: b, linkType: _ })?.link;
  return h && (y = Ve({ structure: D })?.matchUps || [], y?.forEach((L) => {
    let { tieMatchUps: j } = Xo({ tieFormat: h, matchUp: L, isMock: U });
    Object.assign(L, { tieMatchUps: j, matchUpType: E });
  })), { qualifyingDrawPositionsCount: r, qualifiersCount: w, ...x, structure: D, link: B };
}
function WT(e) {
  if (!e.tournamentRecord) return { error: J };
  let t = Sx(e);
  return t.error, t;
}
function Sx(e) {
  if (!e.drawDefinition) return { error: ne };
  if (!e.targetStructureId) return { error: Qr };
  let t = pI(e);
  if (t.error) return t;
  let { structure: r, link: i } = t;
  return !r || !i ? { error: z } : aI({ tournamentRecord: e.tournamentRecord, drawDefinition: e.drawDefinition, structure: r, link: i });
}
function HT(e) {
  let t = oe(e, [{ [lr]: !0, [Xd]: !0, [tn]: !0 }, { [a1]: !0, [tr]: (d) => Number.isInteger(d) && d > 0 }, { [tr]: (d) => Array.isArray(d) && d.length === 2 && d.every(dt), [Kr]: _r, participantIds: !0 }]);
  if (t.error) return t;
  let { drawDefinition: r, structureId: i, tournamentRecord: n, event: a } = e, { structure: o } = me({ drawDefinition: r, structureId: i });
  if (!o) return { error: mt };
  if (!Tr({ structure: o })) return { error: $a };
  let s = (d) => d.sides?.map((p) => p.participantId).some((p) => e.participantIds.includes(p)), c = (d) => d.roundNumber === e.roundNumber, u = (d) => !Bt(d), l = (o?.matchUps ?? []).filter(c).filter(u).filter(s);
  if (l.length !== 2) return { error: _r };
  for (let d of l) {
    let p = d?.sides?.find((m) => e.participantIds.includes(m?.participantId));
    if (p) {
      let m = e.participantIds.find((f) => f !== p?.participantId);
      p.participantId = m, Oe({ tournamentId: n?.tournamentId, eventId: a?.eventId, drawDefinition: r, matchUp: d });
    }
  }
  return tt({ drawDefinition: r, structureIds: [i] }), { ...x };
}
function yx({ includeMatchUpType: e, drawPosition: t, roundNumber: r, matchUpType: i, idPrefix: n, matchUps: a, isMock: o, uuids: s, nodes: c, fed: u }) {
  let l = c.length, d = t ? t - l : void 0, p = te(0, l).map((h) => d ? d + h : void 0), m = [];
  for (let h = 0; h < l; h++) {
    let g = p.shift(), I = { drawPosition: g, fed: u + 1, feed: !0 }, U = c[h];
    U.roundNumber = r - 1;
    let S = dI({ roundPosition: U.roundPosition, roundNumber: r, idPrefix: n, uuids: s }), P = { roundPosition: U.roundPosition, drawPositions: [g], matchUpStatus: Dt, roundNumber: r, matchUpId: S };
    e && (P.matchUpType = i), o && (P.isMock = !0), a.push(P);
    let v = { children: [U, I] };
    m.push(v);
  }
  let f = t ? t - l : void 0;
  return { roundNodes: m, matchUps: a, drawPosition: f };
}
function ua(e) {
  let t = e.drawSize, { feedRoundsProfile: r, feedRounds: i = 0, skipRounds: n = 0, baseDrawSize: a } = e, { linkFedFinishingRoundNumbers: o, finishingPositionOffset: s, linkFedRoundNumbers: c, feedsFromFinal: u, isConsolation: l, matchUpType: d, idPrefix: p, isMock: m, uuids: f, fmlc: h } = e;
  a = a ?? A(t);
  let g = vx({ drawSize: a }), I = g.length, U = 0;
  if (r?.length) U = r.reduce((N, C) => N + C, 0);
  else if (t) {
    let N = t - a;
    r = g.filter((C) => C <= N ? (N -= C, !0) : !1), U = r.reduce((C, k) => C + k, 0), i = r.length;
  } else n >= I ? i = 0 : u && (i = I - u, n = 0), r = g.filter((N, C) => u && !i || i && C >= n + i || C < n ? 0 : N), U = r.reduce((N, C) => N + C, 0), i = r.length;
  let S = [...g, ...r].sort((N, C) => C - N), P = S.length, v = [...(c ?? []).map((N) => N - 1), ...(o ?? []).map((N) => P - N)].map((N) => S[N]).reduce((N, C) => N + C, 0);
  U = U - v;
  let D = 0, y = [], w, b = 1, T = te(0, a).map((N, C) => ({ drawPosition: C + 1 + U })), R = U + 1;
  for (let N of g) {
    if ({ roundNodes: w, matchUps: y } = pd({ matchUpType: d, roundNumber: b, idPrefix: p, matchUps: y, isMock: m, nodes: T, uuids: f }), b++, r.includes(N)) {
      let C = Br(r)[N], k = te(0, C), O = P + 1 - b, _ = o?.includes(O) ?? c?.includes(b);
      k.forEach(() => {
        ({ roundNodes: w, matchUps: y, drawPosition: R } = yx({ drawPosition: !_ && R || void 0, nodes: w, matchUpType: d, roundNumber: b, idPrefix: p, matchUps: y, isMock: m, uuids: f, fed: D })), b++, D += 1;
      });
    }
    T = w;
  }
  P !== b - 1 && console.log("ERROR");
  let M = a - U;
  y = qu({ finishingPositionOffset: l ? M : s, positionsFed: U, roundsCount: P, matchUps: y, fmlc: h });
  let E = w?.length ? w[0] : w;
  return E && (E.roundNumber = b - 1, E.matchUps = y), { draw: E, matchUps: y, roundsCount: P };
  function A(N) {
    let C = th(N);
    return C > N ? C / 2 : C;
  }
}
function vx({ drawSize: e }) {
  let t = Math.ceil(Math.log(e) / Math.log(2));
  return te(0, t).reverse().map((r) => Math.pow(2, r));
}
function fs(e) {
  let { finishingPositionOffset: t = 0, addNameBaseToAttributeName: r, playoffStructureNameBase: i, finishingPositionNaming: n, finishingPositionLimit: a, playoffAttributes: o, stageSequence: s = 1, exitProfile: c = "0", exitProfileLimit: u, roundOffsetLimit: l, roundOffset: d = 0, drawDefinition: p, staggeredEntry: m, sequenceLimit: f, stage: h = re, drawSize: g, idPrefix: I, isMock: U, uuids: S } = e;
  if (!(!o || !u || o?.[c]) || g < 2 || f && s > f) return {};
  let P = [], v = [], D = [], y = e.matchUpType ?? p?.matchUpType, w = t + 1, b = t + g, T = `${w}-${b}`, R = o?.[c], M = i && `${i} ` || "", E = o?.[T] ?? n?.[T], A = e.structureName || E?.name || R?.name && (r ? `${M}${R?.name}` : R.name) || `${M}${T}`, N = E?.abbreviation ?? R?.abbreviation, C = e.structureId ?? R?.structureId ?? S?.pop(), k = { idPrefix: I && `${I}-${A}-RP`, finishingPositionOffset: t, matchUpType: y, drawSize: g, isMock: U, uuids: S }, { matchUps: O } = m ? ua(k) : Zi(k), _ = ii({ structureAbbreviation: N, stageSequence: s, structureName: A, matchUpType: y, roundOffset: d, structureId: C, matchUps: O, stage: h });
  P.push(...O), v.push(_);
  let B = Math.ceil(Math.log(g) / Math.log(2)), L = l ? Math.min(l - d, B) : (!a || w < a) && B || 0;
  return g > 2 && te(1, L + 1).forEach((H) => j(H)), { structureId: _.structureId, matchUps: P, structureName: A, structures: v, links: D, ...x };
  function j(H) {
    let G = g / Math.pow(2, H);
    if (G < 2) return;
    let V = g / Math.pow(2, H) + t;
    if (a && V + 1 > a) return;
    let { structures: $, structureId: q, matchUps: Y, links: W } = fs({ finishingPositionOffset: V, exitProfile: `${c}-${H}`, roundOffset: d + H, stageSequence: s + 1, drawSize: G, addNameBaseToAttributeName: r, playoffStructureNameBase: i, finishingPositionNaming: n, finishingPositionLimit: a, playoffAttributes: o, exitProfileLimit: u, roundOffsetLimit: l, drawDefinition: p, sequenceLimit: f, matchUpType: y, idPrefix: I, uuids: S, stage: h });
    if (_.structureId && q) {
      let K = { linkType: Un, source: { roundNumber: H, structureId: _.structureId }, target: { roundNumber: 1, feedProfile: Ii, structureId: q } };
      W && _ && W.push(K), W?.length && D.push(...W);
    }
    return $?.length && v.push(...$), Y?.length && P.push(...Y), { structureId: q, childLinks: W, structures: v };
  }
}
function mI({ drawDefinition: e, matchUpsMap: t, structureId: r }) {
  let i = me({ drawDefinition: e, structureId: r });
  if (i.error) return F({ result: i });
  let { matchUps: n } = Ve({ structure: i.structure, matchUpsMap: t });
  return { ...Ir({ matchUps: n }), matchUps: n, matchUpsMap: t };
}
function iy({ finishingPositions: e, drawDefinition: t, structureId: r }) {
  let { roundProfile: i } = mI({ drawDefinition: t, structureId: r });
  return (i && Object.keys(i))?.reduce((n, a) => (zT(i?.[a]).forEach((o) => {
    e.forEach((s) => {
      Px({ position: s, rangeDefinition: o }) && (n[s] = { roundNumber: a });
    });
  }), n), {});
}
function Px({ position: e, rangeDefinition: t }) {
  if (!Array.isArray(t) || t.reduce((n, a) => n || isNaN(a), !1)) return !1;
  let [r, i] = t;
  return te(r, (i || r) + 1).includes(e);
}
function zT(e) {
  return [Ue(e?.finishingPositionRange?.loser || []), Ue(e?.finishingPositionRange?.winner || [])];
}
function Dx(e) {
  return zT(e).map((t) => te(t[0], t[1] && t[1] + 1 || t[0] + 1));
}
function sc({ drawDefinition: e, structureIds: t, matchUpsMap: r }) {
  if (t && !Array.isArray(t)) return { error: z, context: { structureIds: t } };
  if (!e) return { error: ne };
  t = t ?? (e.structures ?? []).filter((a) => a.stage !== se).map(({ structureId: a }) => a);
  let i = t.map((a) => {
    let { roundProfile: o } = mI({ drawDefinition: e, matchUpsMap: r, structureId: a });
    return (o && Object.values(o))?.map(Dx).flat();
  }).flat(), n = i.filter((a) => a?.length === 1).sort(Ot).flat();
  return { positionsNotPlayedOff: Ue(i.flat()).filter((a) => !n.includes(a)), positionsPlayedOff: n };
}
function YT({ excludeRoundNumbers: e = [], playoffPositions: t = [], drawDefinition: r, structureId: i }) {
  if (!r) return { error: ne };
  if (!i) return { error: Qr };
  if (!t) return { error: ue, info: "missing playoffPositions" };
  let n = sc({ drawDefinition: r });
  if (n.error) return n;
  let a = n.positionsPlayedOff, o = t.filter((I) => !a.includes(I)), s = iy({ finishingPositions: o, drawDefinition: r, structureId: i }), c = Object.values(s).reduce((I, U) => I.includes(U.roundNumber) ? I : I.concat(U.roundNumber), []).map((I) => pe(I)).filter((I) => !e.includes(I)), u = iy({ finishingPositions: a, drawDefinition: r, structureId: i }), l = u ? Object.values(u) : [], d = u ? l.reduce((I, U) => I.includes(U.roundNumber) ? I : I.concat(U.roundNumber), []).map((I) => pe(I)) : [], p = c.filter((I) => !d.includes(I)).sort(Ot), { roundProfile: m } = mI({ drawDefinition: r, structureId: i }), f = p.map((I) => {
    let U = m?.[I].finishingPositionRange.loser, [S, P] = U ?? [0, 0];
    return te(S, (P || S) + 1);
  }).flat().sort(Ot), { playoffRoundsRanges: h } = wx({ playoffSourceRounds: p, roundProfile: m }), g = [...p, ...d];
  return { playoffPositionsReturned: f, playedOffSourceRounds: d, playoffRoundsRanges: h, playoffSourceRounds: p, sourceRounds: g, roundProfile: m };
}
function wx({ playoffSourceRounds: e, roundProfile: t }) {
  return { playoffRoundsRanges: e.map((r) => {
    let i = t[r].finishingPositionRange.loser, [n, a] = i, o = te(n, (a || n) + 1);
    return { finishingPositionRange: i.join("-"), finishingPositions: o, roundNumber: r };
  }) };
}
function il({ drawDefinition: e, structureId: t }) {
  if (!e) return { error: ne };
  let { matchUps: r, matchUpsMap: i } = hr({ inContext: !0, drawDefinition: e }), { positionsNotPlayedOff: n, positionsPlayedOff: a } = sc({ drawDefinition: e, matchUpsMap: i }), { structures: o } = Ti({ drawDefinition: e }), s = o.filter((u) => !t && u.stage !== zt || u.structureId === t), c = {};
  for (let u of s) {
    let l = u?.structureId, d = Tx({ playoffPositions: n, drawDefinition: e, structure: u, matchUps: r }), { error: p, ...m } = d;
    if (p) return d;
    c[l] = { structureId: l, ...m };
  }
  return t ? { positionsPlayedOff: a, ...c[t] } : { availablePlayoffProfiles: Object.values(c), availablePlayoffRounds: Object.values(c), positionsPlayedOff: a };
}
function Tx({ playoffPositions: e, drawDefinition: t, structure: r, matchUps: i }) {
  let n = r?.structureId, { links: a } = tc({ drawDefinition: t, structureId: n });
  if (r.structureType === yr || r.structures) {
    let m = Je({ structure: r })?.positionAssignments?.length, f = r.structures.length, h = (m ?? 0) / f, g = a.source?.flatMap(({ source: T }) => T?.finishingPositions || []) || [], I = te(1, h + 1).filter((T) => !g.includes(T)), U = i.find((T) => T.containerStructureId === n && T.finishingPositionRange)?.finishingPositionRange?.winner || [0, 1], S = a?.source.map(({ target: T }) => T.structureId), { positionsPlayedOff: P = [], positionsNotPlayedOff: v = [] } = sc({ structureIds: S, drawDefinition: t }), D = [...P, ...v], y = te(U[0], U[1] + 1).filter((T) => !D.includes(T)), w = qt(y, y.length / I.length), b = I.map((T, R) => {
      let M = w[R], E = [Math.min(...M || []), Math.max(...M || [])].join("-");
      return { finishingPosition: T, finishingPositions: M, finishingPositionRange: E };
    });
    return { positionsNotPlayedOff: y, playoffFinishingPositionRanges: b, finishingPositionsAvailable: I, finishingPositionsPlayedOff: g, positionsPlayedOff: P, groupCount: f, groupSize: h };
  }
  let o = a?.source?.filter((m) => m.linkCondition !== Qi).map((m) => m.source?.roundNumber) || [], s = a?.source?.filter((m) => m.linkCondition === Qi).map((m) => m.source?.roundNumber) || [], c = YT({ excludeRoundNumbers: o, playoffPositions: e, drawDefinition: t, structureId: n }), u = c?.playoffSourceRounds ? [...c?.playoffSourceRounds || []] : void 0, l = [...c?.playoffRoundsRanges || []], { roundProfile: d, error: p } = c;
  for (let m of s) {
    let f = a?.source.find((S) => S.source.roundNumber === m), h = f?.target.roundNumber, g = f?.target.structureId, I = i.filter(({ roundNumber: S, structureId: P }) => P === g && S === h), U = I.filter(({ sides: S }) => S.find((P) => P.participantFed && !P.participantId)).length;
    if (u && U === I.length) {
      u.push(m);
      let S = d?.[m]?.finishingPositionRange?.loser;
      if (S) {
        let P = Math.min(...S), v = P + U, D = te(P, v), y = { finishingPositionRange: [P, v - 1].join("-"), finishingPositions: D, roundNumber: m };
        l.push(y);
      }
    }
  }
  return u && u.sort(Ot), l.sort((m, f) => m.roundNumber - f.roundNumber), { playoffRounds: u, playoffRoundsRanges: l, error: p };
}
function bx({ playoffGroups: e, drawDefinition: t, structureId: r }) {
  if (!t) return { error: ne };
  if (!dt(r) || !Array.isArray(e)) return { error: z };
  let i = e.map(({ finishingPositions: n }) => n).flat();
  return { positionRangeMap: il({ drawDefinition: t, structureId: r }).playoffFinishingPositionRanges?.filter((n) => i.includes(n.finishingPosition))?.reduce((n, a) => (n[a.finishingPosition] = a, n), {}) };
}
function KT(e) {
  let { finishingPositionOffset: t = 0, playoffAttributes: r, stageSequence: i = 1, staggeredEntry: n, structureName: a, stage: o = re, matchUpType: s, structureId: c, idPrefix: u, drawSize: l, isMock: d, uuids: p } = e, m = { finishingPositionOffset: t, matchUpType: s, drawSize: l, idPrefix: u, isMock: d, uuids: p }, { matchUps: f } = n ? ua(m) : Zi(m), h = ii({ structureName: a || r?.["0"]?.name || ir(re), structureId: c || p?.pop(), stageSequence: i, matchUpType: s, matchUps: f, stage: o }), g = [h], I = [];
  if (l > 2) {
    let U = l / 2, { matchUps: S } = Zi({ finishingPositionOffset: t + U, idPrefix: u && `${u}-c`, drawSize: U, matchUpType: s, isMock: d }), P = ir(nr), v = r?.["0-1"]?.name ?? e.consolationStructureName ?? (a ? `${a} ${P}` : P), D = ii({ structureName: v, matchUps: S, structureId: p?.pop(), stage: nr, stageSequence: 1, matchUpType: s });
    g.push(D);
    let y = { linkType: Un, source: { roundNumber: 1, structureId: h.structureId }, target: { roundNumber: 1, feedProfile: Ii, structureId: D.structureId } };
    I.push(y);
  }
  return { ...x, structures: g, links: I };
}
function QT({ consolationStructure: e, roundOffset: t = 0, mainStructure: r, roundsCount: i, feedPolicy: n, fmlc: a }) {
  let o = e.matchUps.reduce((u, l) => (l.drawPositions || []).filter(Boolean).length && !u.includes(l.roundNumber) ? u.concat(l.roundNumber) : u, []), s = n?.roundGroupedOrder || [], c = n?.roundFeedProfiles;
  return te(1 + t, i + 1 + t).map((u) => {
    let l = c?.[u - 1] ? c[u - 1] : u % 2 && Ii || Ea, d = u - t <= 2 ? u - t : (u - t - 2) * 2 + 2, p = { linkType: Un, source: { roundNumber: u, structureId: r.structureId }, target: { feedProfile: l, roundNumber: d, structureId: e.structureId } }, m = s[u - 1];
    return m && (p.target.groupedOrder = m), Yr() && (p.source.structureName = r.structureName, p.target.structureName = e.structureName), u === 2 && a && (p.linkCondition = Qi, p.target.feedProfile = Ii), o.includes(d) ? p : void 0;
  }).filter(Boolean);
}
function XT(e) {
  let { playoffStructureNameBase: t, finishingPositionOffset: r, stageSequence: i = 1, playoffAttributes: n, structureNameMap: a, staggeredEntry: o, stage: s = re, matchUpType: c, structureId: u, drawSize: l, idPrefix: d, isMock: p, uuids: m } = e, f = { finishingPositionOffset: r, matchUpType: c, drawSize: l, idPrefix: d, isMock: p, uuids: m }, { matchUps: h, roundsCount: g } = o ? ua(f) : Zi(f), I = e.structureName ?? n?.["0"]?.name ?? ir(re), U = ta({ structureId: u || m?.pop(), structureName: I, stageSequence: i, matchUpType: c, matchUps: h, stage: s }), S = [U], P = [];
  if (l > 2) {
    let v = [0, 2].slice(0, l / 16).map((D, y) => {
      let w = y + 1, { consolationStructure: b } = Mx({ idPrefix: d && `${d}-c${y}`, structureId: m?.pop(), playoffStructureNameBase: t, playoffAttributes: n, structureNameMap: a, stageSequence: w, roundOffset: D, matchUpType: c, drawSize: l, isMock: p, index: y, uuids: m });
      S.push(b);
      let T = QT({ consolationStructure: b, roundsCount: 2, mainStructure: U, roundOffset: D });
      return { consolationStructure: b, links: T };
    }).map((D) => D.links).flat();
    if (P.push(...v), l >= 4 && l <= 16 || l > 32) {
      let { matchUps: D } = Zi({ idPrefix: d && `${d}-p3t4`, finishingPositionOffset: 2, drawSize: 2, matchUpType: c, isMock: p }), y = n?.["3-4"]?.name ?? ir(yt), w = a?.[y] || y, b = t ? `${t} ${w}` : w, T = ta({ structureId: m?.pop(), matchUps: D, stageSequence: 2, stage: yt, structureName: b, matchUpType: c }), R = { linkType: Un, source: { roundNumber: g - 1, structureId: U.structureId }, target: { structureId: T.structureId, feedProfile: Ii, roundNumber: 1 } };
      S.push(T), P.push(R);
    }
  }
  return { structures: S, links: P, ...x };
}
function Mx({ playoffStructureNameBase: e, stageSequence: t = 1, playoffAttributes: r, structureNameMap: i, roundOffset: n = 0, matchUpType: a, structureId: o, idPrefix: s, drawSize: c, isMock: u, index: l, uuids: d }) {
  let p = c / (2 * Math.pow(2, n)), { matchUps: m, roundsCount: f } = ua({ finishingPositionOffset: p, baseDrawSize: p, isConsolation: !0, feedRounds: 1, matchUpType: a, idPrefix: s, isMock: u, uuids: d }), h = l === 0 && r?.["0-1"]?.name || l === 1 && r?.["0-3"]?.name || `${ir(nr)} ${l + 1}`, g = i?.[h] || h, I = e ? `${e} ${g}` : g;
  return { consolationStructure: ta({ matchUps: m, stage: nr, structureName: I, stageSequence: t, matchUpType: a, structureId: o }), consolationRoundsCount: f };
}
function ao(e) {
  let { finishingPositionOffset: t, stageSequence: r = 1, playoffAttributes: i, feedsFromFinal: n, staggeredEntry: a, structureName: o, stage: s = re, structureId: c, matchUpType: u, skipRounds: l, feedRounds: d, idPrefix: p, drawSize: m, isMock: f, uuids: h, fmlc: g } = e, I = e.feedPolicy || e.policyDefinitions?.[Ns] || e.appliedPolicies?.[Ns], U = { finishingPositionOffset: t, matchUpType: u, skipRounds: l, drawSize: m, idPrefix: p, isMock: f, uuids: h }, { matchUps: S } = a ? ua(U) : Zi(U), P = ii({ structureName: o || i?.["0"]?.name || ir(re), structureId: c || h?.pop(), stageSequence: r, matchUpType: u, matchUps: S, stage: s }), v = [P], D = [], y = m / 2, { matchUps: w, roundsCount: b } = ua({ finishingPositionOffset: y, idPrefix: p && `${p}-c`, isConsolation: !0, feedsFromFinal: n, baseDrawSize: y, matchUpType: u, feedRounds: d, skipRounds: l, isMock: f, uuids: h, fmlc: g });
  if (m > 2) {
    let T = i?.["0-1"]?.name ?? ir(nr), R = e.playoffStructureNameBase ? `${e.playoffStructureNameBase} ${T}` : T, M = ii({ matchUps: w, structureId: h?.pop(), stage: nr, stageSequence: 1, structureName: R, matchUpType: u });
    v.push(M);
    let E = QT({ consolationStructure: M, mainStructure: P, roundsCount: b, feedPolicy: I, fmlc: g });
    D.push(...E);
  }
  return { ...x, structures: v, links: D };
}
function JT({ requireSequential: e = !0, playoffMatchUpFormat: t, playoffAttributes: r, sourceStructureId: i, policyDefinitions: n, stageSequence: a, drawDefinition: o, playoffGroups: s, matchUpType: c, feedPolicy: u, groupCount: l, idPrefix: d, isMock: p, uuids: m }) {
  u = u || n?.[Ns];
  let f = "processPlayoffGroups", h = 0, g = [], I = [], U = [], { error: S, positionRangeMap: P } = bx({ structureId: i, drawDefinition: o, playoffGroups: s });
  if (S) return F({ result: { error: S }, stack: f });
  if (!(!P || s?.every((v) => {
    let { finishingPositions: D = [] } = v;
    if (!D.length) return !1;
    let y = [...D].sort(Ot).map((w, b) => (D[b + 1] || w) - w).every((w) => w < 2);
    return (!e || y) && D.every((w) => P[w]);
  }))) return F({ context: { validFinishingPositions: Object.values(P) }, result: { error: z }, stack: f });
  for (let v of s) {
    let D = v.finishingPositions, y = P && D.map((N) => P[N]?.finishingPositions).flat(), w = l * D.length, b = Bs(w), T = b === 2 && Wi || v.drawType || Wi;
    y && (h = Math.min(...y) - 1);
    let R = y && `${Math.min(...y)}-${Math.max(...y)}`, M = v.structureName || R && v.playoffAttributes?.[R]?.name || v.playoffAttributes?.["0"]?.name, E = { addNameBaseToAttributeName: v.addNameBaseToAttributeName, playoffStructureNameBase: v.playoffStructureNameBase, finishingPositionNaming: v.finishingPositionNaming, finishingPositionLimit: v.finishingPositionLimit, structureId: v.structureId ?? m?.pop(), playoffAttributes: v.playoffAttributes, structureNameMap: v.structureNameMap, sequenceLimit: v.sequenceLimit, structureName: M, idPrefix: d && `${d}-po`, appliedPolicies: n, finishingPositionOffset: h, stage: yt, stageSequence: a, matchUpType: c, drawSize: b, isMock: p, uuids: m }, A = ({ playoffStructures: N, playoffLinks: C }) => {
      let [k] = N, O = wl({ playoffStructureId: k.structureId, finishingPositions: D, sourceStructureId: i });
      U.push(O), U.push(...C), I.push(...N), g.push({ structureId: k.structureId, finishingPositions: D }), h += w;
    };
    if (T === Wi) {
      let { matchUps: N } = Zi({ finishingPositionLimit: h + w, idPrefix: d && `${d}-po`, finishingPositionOffset: h, matchUpType: c, drawSize: b, isMock: p, uuids: m }), C = ii({ structureId: v.structureId ?? m?.pop(), matchUpFormat: t, stage: yt, structureName: M, stageSequence: a, matchUps: N });
      I.push(C);
      let k = wl({ playoffStructureId: C.structureId, finishingPositions: D, sourceStructureId: i });
      U.push(k), h += w, g.push({ structureId: C.structureId, finishingPositions: D });
    } else if ([ws, Ts, yt].includes(T)) {
      let N = { playoffAttributes: v.playoffAttributes ?? r, playoffStructureNameBase: v.playoffStructureNameBase, structureId: v.structureId ?? m?.pop(), structureName: v.structureName, idPrefix: d && `${d}-po`, addNameBaseToAttributeName: !0, finishingPositionOffset: h, stage: yt, roundOffset: 0, stageSequence: a, drawSize: b, isMock: p, uuids: m };
      T === ws ? Object.assign(N, { playoffAttributes: v?.playoffAttributes ?? r ?? qh, roundOffsetLimit: 3 }) : T === Ts && Object.assign(N, { playoffAttributes: v?.playoffAttributes ?? r ?? Wh, roundOffsetLimit: 2 });
      let C = fs(N);
      if (C.error) return C;
      if (C.links?.length && U.push(...C.links), C.structures?.length && I.push(...C.structures), I.sort(_o), C.structureId) {
        let k = wl({ playoffStructureId: C.structureId, finishingPositions: D, sourceStructureId: i });
        U.push(k), g.push({ structureId: C.structureId, finishingPositions: D });
      }
      h += w;
    } else if ([bs, Tu, qc, $c, Gc, Wc].includes(T)) {
      let N = [m?.pop(), m?.pop()], C = { playoffStructureNameBase: v.playoffStructureNameBase, structureId: v.structureId ?? m?.pop(), playoffAttributes: v.playoffAttributes, idPrefix: d && `${d}-po`, finishingPositionOffset: h, uuids: N, stage: yt, structureName: M, matchUpType: c, feedPolicy: u, drawSize: b, isMock: p }, k = { [bs]: { fmlc: !0, feedRounds: 1 }, [Wc]: { feedRounds: 1 }, [qc]: { feedsFromFinal: 3 }, [$c]: { feedsFromFinal: 2 }, [Gc]: { feedsFromFinal: 1 } };
      Object.assign(C, k[T] || {});
      let { structures: O, links: _ } = ao(C), [B] = O, L = wl({ playoffStructureId: B.structureId, finishingPositions: D, sourceStructureId: i });
      U.push(L), U.push(..._), I.push(...O), g.push({ structureId: B.structureId, finishingPositions: D }), h += w;
    } else if ([Di].includes(T)) {
      let { structures: N, links: C } = Xu({ ...E, structureOptions: v.structureOptions || { groupSize: 4 } });
      A({ playoffStructures: N, playoffLinks: C });
    } else if ([wu].includes(T)) {
      let { structures: N, links: C } = KT(E);
      A({ playoffStructures: N, playoffLinks: C });
    } else if ([Z0].includes(T)) {
      let { structures: N, links: C } = XT(E);
      A({ playoffStructures: N, playoffLinks: C });
    } else if ([Gr].includes(T)) {
      let N = ii({ structureId: v.structureId ?? m?.pop(), structureName: v.structureName, finishingPosition: xl, stage: yt, stageSequence: a, matchUps: [] });
      A({ playoffStructures: [N], playoffLinks: [] });
    }
  }
  return { finishingPositionTargets: g, positionRangeMap: P, structures: I, links: U };
}
function wl({ playoffStructureId: e, finishingPositions: t, sourceStructureId: r }) {
  return { linkType: gn, source: { structureId: r, finishingPositions: t }, target: { structureId: e, feedProfile: gi, roundNumber: 1 } };
}
function Rx(e) {
  let t = "generateAndPopulateRRplayoffStructures";
  if (!e.playoffGroups) return F({ result: { error: ue }, info: "playoffGroups required", stack: t });
  let { sourceStructureId: r, requireSequential: i, tournamentRecord: n, drawDefinition: a, playoffGroups: o, groupCount: s, groupSize: c, event: u } = e, l = JT({ requireSequential: i, sourceStructureId: r, playoffGroups: o, groupCount: s, ...e });
  if (l.error) return F({ result: l, stack: t });
  let { structures: d = [], links: p = [], finishingPositionTargets: m, positionRangeMap: f } = l, h = m?.map(({ finishingPositions: w }) => w).flat().map((w) => f[w].finishingPositions).flat();
  a.structures.push(...d), a.links.push(...p);
  let { matchUps: g, matchUpsMap: I } = Et({ inContext: !0, drawDefinition: a }), U = d.map(({ structureId: w }) => w), S = g?.filter(({ structureId: w }) => U.includes(w)).map($t), P = I?.drawMatchUps?.filter(({ matchUpId: w }) => S?.includes(w));
  if (P?.length) {
    let w = dr({ drawDefinition: a, event: u })?.tieFormat;
    w && P.forEach((b) => {
      let { tieMatchUps: T } = Xo({ isMock: e.isMock, tieFormat: w, matchUp: b });
      Object.assign(b, { tieMatchUps: T, matchUpType: Hr });
    });
  }
  let { positionAssignments: v } = Je({ structureId: r, drawDefinition: a }), D = {};
  v?.forEach((w) => {
    let b = we({ element: w, name: _n })?.extension?.value?.groupOrder;
    b && (D[b] || (D[b] = []), D[b].push(w.participantId));
  });
  let y = oc({ provisionalPositioning: e.provisionalPositioning, structureId: r, applyPositioning: !0, event: e.event, tournamentRecord: n, drawDefinition: a });
  return y.error && y.error?.code !== rh.code ? F({ result: y, stack: t }) : { structures: d, links: p, positionsPlayedOff: h, drawDefinition: a, ...x };
}
function ds({ value: e, sourceRange: t, targetRange: r }) {
  let i = Math.min(...t), n = Math.max(...t), a = Math.min(...r), o = Math.max(...r);
  return (e - i) * (o - a) / (n - i) + a;
}
var ZT = "NTRP", Nx = { ELO: "ELO", NTRP: ZT, TRN: "TRN", UTR: "UTR", WTN: "WTN" }, Ex = { ELO: { defaultInitialization: 1500, decimalsCount: 0, range: [0, 3e3], ascending: !0 }, [ZT]: { accessors: ["ntrpRating", "dntrpRatingHundredths"], attributes: { ustaRatingType: "" }, accessor: "dntrpRatingHundredths", defaultInitialization: 3, decimalsCount: 1, ascending: !0, range: [1, 7] }, UTR: { defaultInitialization: 6, accessors: ["utrRating"], accessor: "utrRating", decimalsCount: 2, ascending: !0, range: [1, 16] }, WTN: { attributes: { confidence: { generator: !0, range: [60, 100] } }, accessors: ["wtnRating", "confidence"], defaultInitialization: 23, accessor: "wtnRating", ascending: !1, decimalsCount: 2, range: [40, 1] } }, Gt = Ex;
function Ax({ sourceRatingType: e, sourceRating: t }) {
  let r = Gt[e].range, i = r[0] > r[1], n = Gt.ELO.range;
  return ds({ value: i ? r[0] - t : t, sourceRange: r, targetRange: n });
}
function Cx({ targetRatingType: e, sourceRating: t }) {
  let r = Gt[e].decimalsCount || 0, i = Gt[e].range, n = i[0] > i[1], a = Math.max(...i), o = Gt.ELO.range, s = ds({ targetRange: i, sourceRange: o, value: t }), c = parseFloat(s.toFixed(r));
  return n ? a - c : c;
}
function ny(e) {
  let t = oe(e, [{ ratings: !0, [Mr]: Nr }]);
  if (t.error) return t;
  let r = e.matchUpType && [Xe, Ke].includes(e.matchUpType) ? e.matchUpType : Xe, i = Object.keys(Gt), n = e.targetRatingType && i.includes(e.targetRatingType) ? e.targetRatingType : "ELO", a = e.ratings[r] ? e.ratings[r].reduce((d, p) => d.includes(p.scaleName) ? d : d.concat(p.scaleName), []) : [];
  if (!a) return { error: Kt };
  let o = e.ratings[r]?.find((d) => d.scaleName === n) ?? e.ratings[r][0];
  if (a[0] === n) return o;
  let s = o.scaleName, c = Gt[o.scaleName].accessor, u = c ? o.scaleValue[c] : o.scaleValue, l = Ax({ sourceRatingType: s, sourceRating: u });
  return { convertedRating: Cx({ targetRatingType: n, sourceRating: l }), sourceRating: u };
}
function Ox({ participantResults: e, sides: t, score: r }) {
  let i = t.find(({ sideNumber: s }) => s === 1), n = t.find(({ sideNumber: s }) => s === 2), a = i?.participant?.ratings, o = n?.participant?.ratings;
  if (a?.[Xe] && o?.[Xe]) {
    let s = "ELO", { convertedRating: c } = ny({ ratings: a, targetRatingType: s }), { convertedRating: u } = ny({ ratings: o, targetRatingType: s }), { side1pressure: l, side2pressure: d } = kx({ side1ConvertedRating: c, side2ConvertedRating: u, score: r });
    l && e[i?.participantId].pressureScores.push(l), d && e[n?.participantId].pressureScores.push(d);
    let p = Math.max(...Gt.ELO.range), m = Hl((u - c) / p), f = Hl((c - u) / p);
    e[i?.participantId].ratingVariation.push(m), e[n?.participantId].ratingVariation.push(f);
  }
}
function kx({ side1ConvertedRating: e, side2ConvertedRating: t, score: r }) {
  let i = e > t ? e : t, n = e > t ? t : e, a = Math.abs(e - t), o = Gt.ELO.range, s = Math.max(...o), c = (s - i) * 0, u = (i + c) / s * a, l = r?.sets?.reduce((U, S) => U + (S?.side1Score ?? 0), 0), d = r?.sets?.reduce((U, S) => U + (S.side2Score ?? 0), 0), p = e > t ? 2 : 1, m = (l || 0) * (n + (p === 1 ? u : 0)), f = (d || 0) * (n + (p === 2 ? u : 0)), h = m + f, g = h ? Hl(m / h) : 0, I = h ? Hl(f / h) : 0;
  return { side1pressure: g, side2pressure: I };
}
function fI({ winningSide: e, matchUpFormat: t = Si, matchUpStatus: r, tallyPolicy: i, score: n }) {
  let a = [0, 0], o = n?.sets, s = typeof e == "number" && e - 1, c = Sr(t), u = hI(c?.bestOf ?? 1);
  if (typeof s == "number" && (r === Pe && i?.setsCreditForDefaults || r === be && i?.setsCreditForWalkovers)) a[s] = u;
  else for (let l of o || []) {
    let { winningSide: d } = l;
    d && (a[d - 1] += 1);
  }
  return typeof s == "number" && r === Xt && (+a[1 - s] === u && (a[1 - s] -= 1), i?.setsCreditForRetirements && (a[s] = u)), a;
}
function eb({ matchUpFormat: e = Si, winningSide: t, matchUpStatus: r, tallyPolicy: i, score: n }) {
  let { sets: a } = n || {};
  if (!a) return [0, 0];
  let o = typeof t == "number" && t - 1, s = Sr(e), c = s?.bestOf ?? 1, u = hI(c), l = s?.setFormat?.tiebreakAt || 0, d = [[], []];
  if (typeof o == "number" && (r === Pe && i?.gamesCreditForDefaults || r === be && i?.gamesCreditForWalkovers)) {
    let p = s?.setFormat?.setTo || 0, m = u * p;
    d[o].push(m);
  } else a.forEach((p, m) => {
    let f = (p.setNumber || m + 1) > u && s?.finalSetFormat ? "finalSetFormat" : "setFormat", h = s?.[f]?.based, g = s?.[f].tiebreakSet, { side1Score: I, side2Score: U } = p;
    ay(h) && (d[0].push(pe(I || 0)), d[1].push(pe(U || 0))), g && p.winningSide && i?.gamesCreditForTiebreakSets !== !1 && d[p.winningSide - 1].push(1);
  });
  if (r === Xt && typeof o == "number") {
    let p = a.length > u && s?.finalSetFormat ? "finalSetFormat" : "setFormat", m = s?.[p];
    if (ay(m.based)) {
      let f = m?.setTo || 0, h = (I) => {
        if (!(!s || I === "")) return +I === l - 1 || +I === l ? pe(l || 0) + 1 : +I < l ? f : l;
      }, g = fI({ winningSide: t, score: { sets: a }, matchUpStatus: r, matchUpFormat: e, tallyPolicy: i });
      if (d.map((I) => I[o] <= I[1 - o]).reduce((I, U) => I + (U ? 1 : 0), 0) > g[1 - o]) {
        let I = d[o].length, U = h(d[1 - o][I - 1]);
        U && (d[o][I - 1] = U);
      }
      u > d[o].length && i?.gamesCreditForRetirements && d[o].push(f);
    }
  }
  return [d[0].reduce((p, m) => p + m, 0), d[1].reduce((p, m) => p + m, 0)];
}
function tb({ matchUpFormat: e, score: t }) {
  let r = e ? Sr(e) : void 0, i = r?.bestOf ?? 1, n = hI(i), a = [0, 0], o = [0, 0];
  return t?.sets?.forEach((s, c) => {
    let u = (s.setNumber || c + 1) > n && r?.finalSetFormat ? "finalSetFormat" : "setFormat", l = r?.[u]?.based;
    if (rb(l)) {
      let { side1Score: d, side2Score: p } = s;
      d && (o[0] += pe(d || 0)), p && (o[1] += pe(p || 0));
    } else s.side1TiebreakScore && (o[0] += pe(s.side1TiebreakScore || 0)), s.side2TiebreakScore && (o[1] += pe(s.side2TiebreakScore || 0)), (s.side1TiebreakScore || s.side2TiebreakScore) && s.winningSide && (a[s.winningSide - 1] += 1);
  }), { pointsTally: o, tiebreaksTally: a };
}
function hI(e) {
  return e && Math.ceil(e / 2) || 1;
}
function rb(e) {
  return e === "P";
}
function ay(e) {
  return !rb(e);
}
function xx({ participantResults: e, groupingTotal: t, matchUpFormat: r, tallyPolicy: i, totalGames: n, perPlayer: a, totalSets: o }) {
  let s = r && Sr(r) || {}, c = s.bestOf, u = c && Math.ceil(c / 2) || 1, l = s.setFormat?.setTo, d = Math.pow(10, i?.precision || 3);
  Object.keys(e).forEach((p) => {
    let m = e[p].setsWon, f = e[p].setsLost, h = i?.groupTotalSetsPlayed || t === "setsPct" ? o : a * u || m + f, g = Math.round(m / h * d) / d;
    (g === 1 / 0 || isNaN(g)) && (g = h);
    let I = e[p].tieMatchUpsWon, U = e[p].tieMatchUpsLost, S = I + U, P = Math.round(I / S * d) / d;
    (P === 1 / 0 || isNaN(P)) && (P = I);
    let v = e[p].matchUpsWon, D = e[p].matchUpsLost, y = v + D, w = Math.round(v / y * d) / d;
    (w === 1 / 0 || isNaN(w)) && (w = v);
    let b = e[p].gamesWon || 0, T = e[p].gamesLost || 0, R = (a || 0) * u * (l || 0), M = i?.groupTotalGamesPlayed || t === "gamesPct" ? n : Math.max(R, b + T), E = Math.round(b / M * d) / d;
    (E === 1 / 0 || isNaN(E)) && (E = 0);
    let A = e[p].pointsWon + e[p].pointsLost, N = Math.round(e[p].pointsWon / A * d) / d;
    (N === 1 / 0 || isNaN(N)) && (N = 0), e[p].setsWon = m, e[p].setsLost = f, e[p].setsPct = g, e[p].tieMatchUpsWon = I, e[p].tieMatchUpsPct = P, e[p].matchUpsPct = w, e[p].gamesWon = b, e[p].gamesLost = T, e[p].gamesPct = E, e[p].pointsPct = N, e[p].result = `${e[p].matchUpsWon}/${e[p].matchUpsLost}`;
  });
}
function nl({ participantIds: e, pressureRating: t, groupingTotal: r, matchUpFormat: i, tallyPolicy: n, perPlayer: a, matchUps: o }) {
  let s = {}, c = n?.excludeMatchUpStatuses || [], u = o?.filter((m) => (m.tieMatchUps || !c.includes(m.matchUpStatus)) && (!e?.length || Pt(e, [ps(m, 0), ps(m, 1)]).length === 2)), l = u?.flatMap(({ score: m, tieMatchUps: f }) => f ? f.filter(({ matchUpStatus: h }) => !c.includes(h)).flatMap(({ score: h }) => h?.sets?.length ?? 0) : m?.sets?.length ?? 0)?.reduce((m, f) => m + f, 0), d = (m) => m?.sets?.reduce((f, h) => f + (h?.side1Score ?? 0) + (h?.side2Score ?? 0), 0) ?? 0, p = u?.flatMap(({ score: m, tieMatchUps: f }) => f ? f.filter(({ matchUpStatus: h }) => !c.includes(h)).flatMap(({ score: h }) => d(h)) : d(m))?.reduce((m, f) => m + f, 0);
  for (let m of u ?? []) {
    let { matchUpStatus: f, tieMatchUps: h, tieFormat: g, score: I, winningSide: U, sides: S } = m, P = g && m._disableAutoCalc && g.collectionDefinitions.every(({ scoreValue: y }) => y), v = U && Fx(m), D = U && Lx(m);
    if (!v && !D) if (f && Lt.includes(f)) {
      let y = ps(m, 0), w = ps(m, 1);
      y && (Xn(s, y), s[y].matchUpsCancelled += 1), w && (Xn(s, w), s[w].matchUpsCancelled += 1);
    } else if (h?.length) {
      a = 0;
      for (let y of h) {
        if (y.winningSide) {
          let w = S?.find(({ sideNumber: T }) => T === y.winningSide)?.participantId, b = S?.find(({ sideNumber: T }) => T === y.winningSide)?.participantId;
          w && b && (Xn(s, w), Xn(s, b), s[w].tieMatchUpsWon += 1, s[b].tieMatchUpsLost += 1, bt(Xe)(y.matchUpType) ? (s[w].tieSinglesWon += 1, s[b].tieSinglesLost += 1) : bt(Ke)(y.matchUpType) && (s[w].tieDoublesWon += 1, s[b].tieDoublesLost += 1));
        }
        oy({ score: y.score, manualGamesOverride: P, participantResults: s, sides: S });
      }
    } else oy({ manualGamesOverride: P, participantResults: s, score: I, sides: S });
    else if (Xn(s, v), Xn(s, D), h?.length) {
      a = 0;
      for (let y of h) {
        let { matchUpType: w } = y, b = bt(Ke)(w), T = bt(Xe)(w);
        y.winningSide && (y.winningSide === U ? (v && (s[v].tieMatchUpsWon += 1, T && (s[v].tieSinglesWon += 1), b && (s[v].tieDoublesWon += 1)), D && (s[D].tieMatchUpsLost += 1, T && (s[D].tieSinglesLost += 1), b && (s[D].tieDoublesLost += 1))) : y.winningSide !== U && (D && (s[D].tieMatchUpsWon += 1, T && (s[D].tieSinglesWon += 1), b && (s[D].tieDoublesWon += 1)), v && (s[v].tieMatchUpsLost += 1, T && (s[v].tieSinglesLost += 1), b && (s[v].tieDoublesLost += 1)))), sy({ matchUpFormat: y.matchUpFormat, matchUpStatus: y.matchUpStatus, matchUpType: y.matchUpType, score: y.score, sides: y.sides, winningParticipantId: v, losingParticipantId: D, manualGamesOverride: P, participantResults: s, isTieMatchUp: !0, pressureRating: t, tallyPolicy: n, winningSide: U });
      }
      ib({ winningParticipantId: v, losingParticipantId: D, participantResults: s, matchUpStatus: f });
    } else sy({ matchUpFormat: m.matchUpFormat ?? i, matchUpType: m.matchUpType, isTieMatchUp: void 0, winningParticipantId: v, manualGamesOverride: P, losingParticipantId: D, participantResults: s, pressureRating: t, matchUpStatus: f, tallyPolicy: n, winningSide: U, score: I, sides: S });
    if (P) {
      let y = I?.sets?.reduce((R, M) => R + (M?.side1Score ?? 0), 0), w = I?.sets?.reduce((R, M) => R + (M.side2Score ?? 0), 0), b = S?.find(({ sideNumber: R }) => R === 1)?.participantId, T = S?.find(({ sideNumber: R }) => R === 2)?.participantId;
      Xn(s, b), Xn(s, T), b && (s[b].gamesWon += y, s[b].gamesLost += w), T && (s[T].gamesWon += w, s[T].gamesLost += y);
    }
  }
  return xx({ participantResults: s, groupingTotal: r, matchUpFormat: i, tallyPolicy: n, totalGames: p, perPlayer: a, totalSets: l }), { participantResults: s };
}
function Fx(e) {
  let t = e.winningSide - 1;
  return ps(e, t);
}
function Lx(e) {
  let t = 1 - (e.winningSide - 1);
  return ps(e, t);
}
function ps(e, t) {
  if (!e?.sides) return console.log("no sides:", { matchUp: e }), "foo";
  let r = e.sides[t];
  return r ? r.participantId : (console.log("No Side", { matchUp: e, index: t }), "foo");
}
function Xn(e, t) {
  t && !e[t] && (e[t] = { allDefaults: 0, defaults: 0, defeats: [], gamesLost: 0, gamesWon: 0, matchUpsCancelled: 0, matchUpsLost: 0, matchUpsWon: 0, pointsLost: 0, pointsWon: 0, pressureScores: [], ratingVariation: [], retirements: 0, setsLost: 0, setsWon: 0, tieSinglesWon: 0, tieSinglesLost: 0, tieDoublesWon: 0, tieDoublesLost: 0, tieMatchUpsLost: 0, tieMatchUpsWon: 0, victories: [], walkovers: 0 });
}
function oy({ manualGamesOverride: e, participantResults: t, score: r, sides: i }) {
  let { sets: n } = r || {}, a = [[], []], o = [0, 0];
  for (let c of n || []) {
    let { winningSide: u, side1Score: l, side2Score: d } = c;
    u && (o[u - 1] += 1), a[0].push(pe(l || 0)), a[1].push(pe(d || 0));
  }
  let s = [a[0].reduce((c, u) => c + u, 0), a[1].reduce((c, u) => c + u, 0)];
  i.forEach((c, u) => {
    let { participantId: l } = c;
    l && (Xn(t, l), t[l].setsWon += o[u], t[l].setsLost += o[1 - u], e || (t[l].gamesWon += s[u], t[l].gamesLost += s[1 - u]));
  });
}
function sy({ winningParticipantId: e, manualGamesOverride: t, losingParticipantId: r, participantResults: i, pressureRating: n, matchUpFormat: a, matchUpStatus: o, isTieMatchUp: s, matchUpType: c, tallyPolicy: u, winningSide: l, score: d, sides: p }) {
  let m = l && l - 1, f = 1 - m;
  n && c === Xe && Ox({ participantResults: i, sides: p, score: d }), s || ib({ winningParticipantId: e, losingParticipantId: r, participantResults: i, matchUpStatus: o });
  let h = fI({ matchUpStatus: o, matchUpFormat: a, tallyPolicy: u, winningSide: l, score: d }), g = eb({ matchUpStatus: o, matchUpFormat: a, tallyPolicy: u, winningSide: l, score: d }), { pointsTally: I } = tb({ score: d, matchUpFormat: a });
  e && (i[e].setsWon += h[m], i[e].setsLost += h[f], t || (i[e].gamesWon += g[m], i[e].gamesLost += g[f]), i[e].pointsWon += I[m], i[e].pointsLost += I[f]), r && (i[r].setsWon += h[f], i[r].setsLost += h[m], t || (i[r].gamesWon += g[f], i[r].gamesLost += g[m]), i[r].pointsWon += I[f], i[r].pointsLost += I[m]);
}
function ib({ winningParticipantId: e, losingParticipantId: t, participantResults: r, matchUpStatus: i }) {
  t && (i === be && (r[t].walkovers += 1), i === Pe && (r[t].defaults += 1), i === Xt && (r[t].retirements += 1), [Pe, Xt, be].includes(i) && (r[t].allDefaults += 1), r[t].matchUpsLost += 1), e && (r[e].matchUpsWon += 1), t && e && (r[t].defeats.push(e), r[e].victories.push(t));
}
function _x({ matchUps: e, order: t, report: r }) {
  let i = {};
  e.forEach(({ sides: a }) => {
    a.forEach((o) => {
      o.participantId && o.participant && (i[o.participantId] = o.participant.participantName);
    });
  });
  let n = [];
  return Array.isArray(r) && r.forEach((a, o) => {
    if (a.excludedDirectives?.length) {
      let s = a.excludedDirectives.map(({ attribute: l }) => l).join(", "), c = `${s.length} directives were excluded due to participants limit}`;
      n.push(c);
      let u = `Excluded: ${s}`;
      n.push(u);
    } else {
      let s = (m, f) => parseFloat(a.reversed ? m : f) - parseFloat(a.reversed ? f : m), c = a.groups ? Object.values(a.groups).flat(1 / 0).length : a.participantIds?.length ?? 0, u = (m) => {
        m.groups && Object.keys(m.groups).sort(s).forEach((f) => {
          let h = m.groups[f].map((I) => i[I]).join(", "), g = `${f} ${m.attribute}: ${h}`;
          n.push(g);
        });
      }, l = a.reversed ? " in reverse order" : "", d = a.groups ? "grouped" : "separated", p = `Step ${o + 1}: ${c} particiants were ${d}${l} by ${a.attribute}`;
      if (n.push(p), a.idsFilter) {
        let m = `${a.attribute} was calculated considering ONLY TIED PARTICIPANTS`;
        n.push(m);
      }
      u(a);
    }
    n.push("----------------------");
  }), n.push("Final Order:"), t.forEach((a) => {
    let { participantId: o, resolved: s } = a, c = a.groupOrder || a.provisionalOrder;
    n.push(`${c}: ${i[o]} => resolved: ${!!s}`);
  }), n.join(`\r
`);
}
function nb({ participantResults: e, participantIds: t, attribute: r }) {
  return ab({ participantResults: e, participantIds: t }).reduce((i, n) => {
    let { participantId: a, results: o } = n, s = o?.[r];
    return !isNaN(s) && a && (i[s] ? i[s].push(a) : i[s] = [a]), i;
  }, {});
}
function ab(e) {
  return (e.participantIds || Object.keys(e.participantResults)).reduce((t, r, i) => (t.push({ participantId: r, i, results: e.participantResults[r] }), t), []);
}
var Bx = [{ attribute: "matchUpsPct", idsFilter: !1 }, { attribute: "allDefaults", reversed: !0, idsFilter: !1 }, { attribute: "defaults", reversed: !0, idsFilter: !1 }, { attribute: "walkovers", reversed: !0, idsFilter: !1 }, { attribute: "retirements", reversed: !0, idsFilter: !1 }, { attribute: "setsPct", idsFilter: !1 }, { attribute: "gamesPct", idsFilter: !1 }, { attribute: "pointsPct", idsFilter: !1 }, { attribute: "matchUpsPct", idsFilter: !0 }, { attribute: "setsPct", idsFilter: !0 }, { attribute: "gamesPct", idsFilter: !0 }, { attribute: "pointsPct", idsFilter: !0 }], Bm = { matchUpsPct: 20, tieMatchUpsPct: 16, pointsPct: 4, gamesPct: 8, setsPct: 12 };
function cy(e) {
  let { requireCompletion: t = !0, participantResults: r, subOrderMap: i, tallyPolicy: n } = e, a = [];
  if (t && !Vx(e)) return {};
  let o = ["tieMatchUpsWon", "tieSinglesWon", "tieDoublesWon", "matchUpsWon", "pointsWon", "gamesWon", "setsWon", "gamesPct", "setsPct", "pointsPct", "matchUpsPct"].includes(n?.groupOrderKey) ? n.groupOrderKey : "matchUpsWon", s = nb({ participantResults: r, attribute: o });
  a.push({ attribute: o, groups: s });
  let c = Object.keys(s).map((g) => parseFloat(g)).sort((g, I) => I - g).map((g) => s[g]).map((g) => {
    let I = ob({ participantIds: g, ...e });
    return a.push(...I.report ?? []), I.order;
  }).map((g, I) => g.map((U) => U.resolved ? U : { ...U, subGroup: [I].concat(...U.subGroup ?? []) })).flat(), u, l = 0, d = 1, p;
  c.forEach((g, I) => {
    I && (g.resolved || p && !g.resolved) && (d += 1), p = g.resolved;
    let U = parseInt(g.subGroup?.join("") || 0);
    g.resolved ? (g.position = I + 1, d = g.position) : (u && U > u && (d += l, l = 0), g.position = d, l += 1), u = U;
  });
  let m = c.map(({ position: g }) => g), f = Br(m);
  return c.forEach((g) => {
    let { participantId: I, position: U } = g || {}, S = r[I];
    g.GEMscore = h(S);
    let P = f[U];
    g?.position !== void 0 && (P > 1 && (g.ties = P, i && (g.subOrder = i[I])), g.rankOrder = U, g.groupOrder = U + (g.subOrder || 1) - 1);
  }), { groupOrder: c, report: a.flat(1 / 0).filter(Boolean) };
  function h(g) {
    return (Array.isArray(n?.GEMscore) ? Object.keys(Bm).filter((I) => n.GEMscore.includes(I)) : Object.keys(Bm)).map((I) => (g[I] || 0) * Math.pow(10, Bm[I].toFixed(3))).reduce((I, U) => I + U, 0);
  }
}
function Vx({ participantResults: e, participantsCount: t }) {
  let r = ab({ participantResults: e }).filter((i) => t - 1 === i.results.matchUpsWon + i.results.matchUpsLost + i.results.matchUpsCancelled);
  return t === r.length;
}
function jx({ disableHeadToHead: e, participantIds: t, matchUpFormat: r, groupTotals: i, tallyPolicy: n, attribute: a, idsFilter: o, matchUps: s, reversed: c }) {
  let { participantResults: u } = nl({ participantIds: o && t, groupingTotal: i && a, matchUpFormat: r, tallyPolicy: n, matchUps: s }), l = nb({ participantResults: u, participantIds: t, attribute: a }), d = [{ attribute: a, reversed: c, groups: l, idsFilter: o, groupTotals: i }], p;
  return Object.keys(l).length > 1 && t.length && (p = Object.keys(l).map((m) => parseFloat(m)).sort((m, f) => c ? m - f : f - m).map((m) => l[m]).map((m) => {
    let f = ob({ participantResults: u, disableHeadToHead: e, participantIds: m, matchUpFormat: r, tallyPolicy: n, matchUps: s });
    return d.push(...f.report ?? []), f.order;
  }).map((m, f) => m.map((h) => h.resolved ? h : { ...h, subGroup: [f].concat(...h.subGroup ?? []) })).flat()), { order: p, report: d };
}
function ob({ participantResults: e, disableHeadToHead: t, participantIds: r, matchUpFormat: i, tallyPolicy: n, matchUps: a }) {
  let o = [], s = [], c;
  if (r?.length === 1) return { order: [{ resolved: !0, participantId: r[0] }] };
  if (r?.length === 2 && (!n?.headToHead || !n.headToHead.disabled && !t)) {
    let l = Gx({ participantIds: r, participantResults: e });
    if (l) {
      let d = l[0].participantId;
      return s.push({ attribute: "head2Head", participantIds: r, headToHeadWinner: d }), { order: l, headToHeadWinner: d, report: s };
    }
  }
  let u = (n?.tallyDirectives || Bx).filter((l) => {
    let d = !(gt(l.maxParticipants) && r?.length > l.maxParticipants);
    return d || o.push(l), d;
  });
  return o.length && s.push({ excludedDirectives: o, participantIds: r }), u.every(({ attribute: l, reversed: d, idsFilter: p, groupTotals: m, disableHeadToHead: f }) => (c = jx({ disableHeadToHead: f, participantIds: r, matchUpFormat: i, groupTotals: m, tallyPolicy: n, attribute: l, idsFilter: p, matchUps: a, reversed: d }), s.push(c.report), !c.order)), c.order ? { order: c.order, report: s } : { order: r?.map((l) => ({ participantId: l })), report: s };
}
function Gx({ participantIds: e, participantResults: t }) {
  if (e) {
    if (t[e[0]].victories.includes(e[1])) return e.map((r) => ({ resolved: !0, participantId: r }));
    if (t[e[1]].victories.includes(e[0])) return e.reverse().map((r) => ({ resolved: !0, participantId: r }));
  }
}
function cc({ policyDefinitions: e, generateReport: t, pressureRating: r, matchUpFormat: i, matchUps: n = [], subOrderMap: a, perPlayer: o }) {
  if (!n?.length || !pi(n)) return { error: Gn };
  let s = Ue(n.map(({ structureId: P }) => P));
  if (s.length !== 1) return F({ result: { error: z, info: "Maximum one structureId" }, stack: "tallyParticipantResults", context: { structureIds: s } });
  let c = n.filter((P) => P && P.matchUpStatus !== "BYE"), u = c.length && Ue(c.map(({ drawPositions: P }) => P).flat()).length, l = c.filter((P) => ba({ matchUp: P })).length === c.length;
  l || (o = 0);
  let d = n.every(({ matchUpType: P, tieMatchUps: v }) => P === ot && v?.every((D) => ba({ matchUp: D }))), p = e?.[tg], m = n.filter((P) => ba({ matchUp: P }) ?? P.matchUpType === ot), { participantResults: f } = nl({ matchUps: m, pressureRating: r, matchUpFormat: i, tallyPolicy: p, perPlayer: o }), h, g, { groupOrder: I, report: U } = cy({ matchUps: m, participantResults: f, participantsCount: u, matchUpFormat: i, subOrderMap: a, tallyPolicy: p });
  if (r && $x({ participantResults: f }), l && I) h = U, g = I, I.forEach((P) => {
    let { participantId: v, groupOrder: D, rankOrder: y, subOrder: w, ties: b, GEMscore: T } = P, R = f[v];
    Object.assign(R, { groupOrder: D, rankOrder: y, GEMscore: T, subOrder: w, ties: b });
  });
  else {
    let { groupOrder: P, report: v } = cy({ requireCompletion: !1, participantResults: f, participantsCount: u, matchUpFormat: i, tallyPolicy: p, subOrderMap: a, matchUps: n });
    h = v, g = P, P && P.forEach((D) => {
      let { participantId: y, groupOrder: w, GEMscore: b } = D, T = f[y];
      Object.assign(T, { provisionalOrder: w, GEMscore: b });
    });
  }
  let S = { completedTieMatchUps: d, readableReport: "", participantResults: f, bracketComplete: l, order: [], report: h };
  if ((l || d) && (S.order = g), t || Yr({ tally: !0 })) {
    let P = _x({ matchUps: n, report: h, order: g });
    Yr({ tally: !0 }) && console.log(P), S.readableReport = P;
  }
  return S;
}
function $x({ participantResults: e }) {
  let t = (n) => n.reduce((a, o) => a + parseFloat(o), 0), r = (n) => parseFloat((t(n) / n.length).toFixed(2)), i = Object.keys(e).map((n) => {
    let a = e[n], { pressureScores: o } = a, s = o?.length ? r(o) : 0;
    return { participantId: n, averagePressure: s };
  }).sort((n, a) => (a.averagePressure || 0) - (n.averagePressure || 0)).map((n, a) => ({ ...n, order: a + 1 }));
  for (let n of i) e[n.participantId].pressureOrder = n.order;
}
function sb({ positionAssignments: e }) {
  let t = (e || []).filter(qr(yn)).map((n) => {
    let { extension: a } = we({ element: n, name: Es }), o = pe(a?.value), s = !isNaN(o) && o;
    return s && { participantId: n.participantId, subOrder: s };
  }).filter(Boolean), r = t.map(({ subOrder: n }) => n), i = Br(r);
  return { subOrderMap: Object.assign({}, ...t.filter(({ subOrder: n }) => i[n] === 1).map(({ participantId: n, subOrder: a }) => ({ [n]: a }))) };
}
function gI({ positionAssignments: e, tournamentRecord: t, drawDefinition: r, matchUpFormat: i, matchUps: n, event: a }) {
  if (!pi(n)) return { error: z };
  if (!e) return { error: z };
  let { policyDefinitions: o } = Wn({ policyTypes: [tg], tournamentRecord: t, drawDefinition: r, event: a }), { subOrderMap: s } = sb({ positionAssignments: e }), c = n.length ? cc({ policyDefinitions: o, matchUpFormat: i, subOrderMap: s, matchUps: n }) : void 0;
  if (c?.error) return c;
  let { participantResults: u = {}, bracketComplete: l, report: d } = c ?? {}, p = Object.keys(u);
  return e.forEach((m) => {
    let { participantId: f } = m;
    if (p.includes(f)) {
      let h = { value: u[f], name: _n };
      Be({ element: m, extension: h }), u[f].ties || fr({ element: m, name: Es });
    } else fr({ element: m, name: _n }), fr({ element: m, name: Es });
  }), tt({ drawDefinition: r }), { ...x, participantResults: u, bracketComplete: l, report: d };
}
function cb({ matchUps: e, matchUpId: t }) {
  return { matchUp: (e || []).find((r) => r.matchUpId === t) };
}
function ut(e) {
  let t = oe(e, [{ [lr]: !0, [tn]: !0 }]);
  if (t.error) return t;
  let { tournamentParticipants: r, afterRecoveryTimes: i, contextProfile: n, drawDefinition: a, matchUpsMap: o, matchUpId: s, inContext: c, context: u, event: l } = e, { structures: d = [] } = Ti({ drawDefinition: a }), p = e.contextContent || n && Hn({ contextProfile: n, drawDefinition: a });
  for (let m of d) {
    let { matchUps: f } = Ve({ tournamentParticipants: r, afterRecoveryTimes: i, contextContent: p, drawDefinition: a, contextProfile: n, matchUpsMap: o, inContext: c, structure: m, context: u, event: l }), { matchUp: h } = cb({ matchUps: f, matchUpId: s });
    if (h) return { matchUp: h, structure: m };
  }
  return { error: cr };
}
function Ap(e) {
  return !xe(e) || !e.notes ? { error: ue } : xe(e.element) ? !dt(e.notes) && !e.notes?.testing ? { error: z } : (Object.assign(e.element, { notes: e.notes }), { ...x }) : { error: z };
}
function II(e) {
  return xe(e) ? xe(e.element) ? (e.element.notes && delete e.element.notes, { ...x }) : { error: z } : { error: ue };
}
var Cp = { matchUpStatus: Dt, matchUpStatusCodes: [], score: { scoreStringSide1: "", scoreStringSide2: "", sets: void 0 }, matchUpFormat: void 0, winningSide: void 0 };
function zi(e) {
  let t = "modifyMatchUpScore", r = e.matchUpFormat, i = e.matchUp, n, { matchUpStatusCodes: a, tournamentRecord: o, drawDefinition: s, matchUpStatus: c, removeScore: u, winningSide: l, matchUpId: d, event: p, notes: m, score: f } = e, h = e.appliedPolicies && Object.keys(e.appliedPolicies).length ? e.appliedPolicies : _e({ policyTypes: [oi], tournamentRecord: o, drawDefinition: s, structure: n, event: p })?.appliedPolicies, g = i.matchUpType === ot;
  if (g && s) {
    if (d && i.matchUpId !== d) {
      let y = ut({ drawDefinition: s, matchUpId: d, event: p });
      if (!y.matchUp) return { error: cr };
      ({ matchUp: i, structure: n } = y);
    }
  } else i.matchUpId !== d && console.log("!!!!!");
  c && [be, Mt].includes(c) || u ? Object.assign(i, { ...Cp }) : f && (i.score = f);
  let I = c && i?.matchUpStatus === Pe && c !== Pe;
  c && (i.matchUpStatus = c), r && (i.matchUpFormat = r), a && (i.matchUpStatusCodes = a), l && (i.winningSide = l), e.removeWinningSide && (i.winningSide = void 0), !n && s && ({ structure: n } = ut({ drawDefinition: s, matchUpId: d, event: p })), c && !i.winningSide && Bt(i) && !Lt.includes(c) && ![Lo, fa, $r].includes(c) && (i.matchUpStatus = Ri);
  let U;
  if ((I && i?.processCodes?.length || c === Pe) && (U = h?.[oi]?.processCodes?.incompleteAssignmentsOnDefault), !i.collectionId) {
    let y = n?.structureType === yr, w = Tr({ structure: n });
    if (Eg({ drawDefinition: s, structure: n }) || w || y) {
      let b = (M) => {
        r = g ? "SET1-S:T100" : r ?? i.matchUpFormat ?? M?.matchUpFormat ?? s?.matchUpFormat ?? p?.matchUpFormat;
        let E = g ? { matchUpTypes: [ot] } : void 0, { matchUps: A } = Ve({ afterRecoveryTimes: !1, tournamentRecord: o, inContext: !0, matchUpFilters: E, drawDefinition: s, structure: M, event: p });
        return w && (M.positionAssignments = Ue(A.flatMap((N) => (N.sides ?? []).map((C) => C.participantId)).filter(Boolean)).map((N) => ({ participantId: N }))), gI({ positionAssignments: M.positionAssignments, tournamentRecord: o, drawDefinition: s, matchUpFormat: r, matchUps: A, event: p });
      }, T = y && n.structures.find((M) => M?.matchUps.find((E) => E.matchUpId === d)), R = b(T || n);
      if (R.error) return F({ result: R, stack: t });
    }
  }
  if (m) {
    let y = Ap({ element: i, notes: m });
    if (y.error) return F({ result: y, stack: t });
  }
  let S = o?.tournamentId, P = ci().topics.includes(up), v = (P || U) && or({ drawDefinition: s }), D = v && Et({ matchUpFilters: { matchUpIds: [d] }, nextMatchUps: !0, tournamentRecord: o, inContext: !0, drawDefinition: s, matchUpsMap: v }).matchUps?.[0];
  if (P && D && _1({ tournamentId: S, inContextMatchUp: D }), Array.isArray(U) && D && !D.sides?.every(({ participantId: y }) => y)) if (c === Pe) i.processCodes = Ue([...i.processCodes ?? [], ...U]);
  else for (let y of U || []) {
    let w = y && i?.processCodes?.lastIndexOf(y);
    i?.processCodes?.splice(w, 1);
  }
  return Oe({ eventId: p?.eventId, context: t, drawDefinition: s, tournamentId: S, matchUp: i }), { ...x };
}
function UI(e) {
  let { matchUpStatusCodes: t, matchUpStatus: r, structure: i, matchUp: n, dualMatchUp: a, inContextMatchUp: o, autoCalcDisabled: s, propagateExitStatus: c } = e, u = Wu({ matchUpStatus: r }) || [nn, Or].includes(r) && a || s, l = n?.sides?.map((h) => h.participantId).filter(Boolean).length || o?.sides?.map((h) => h.participantId).filter(Boolean).length, d = "attemptToModifyScore";
  if (!(Tr({ structure: i }) && l === 1 || r === Pe && l || qx({ structure: i, matchUp: n, inContextMatchUp: o }) || e.appliedPolicies?.[oi]?.requireParticipantsForScoring === !1 || [be, Pe].includes(r) && l === 1 && c)) return F({ result: { error: uh }, stack: d });
  let p = [be].includes(r), m = u ? r : e.winningSide && vt || $r, f = zi({ ...e, winningSide: e.winningSide, matchUpStatusCodes: u && t || [], matchUpStatus: m, removeScore: p });
  return F({ result: f, stack: d });
}
function qx({ structure: e, matchUp: t, inContextMatchUp: r }) {
  let { drawPositions: i } = t, { positionAssignments: n } = _t({ structure: e }), a = n?.filter((s) => i?.includes(s.drawPosition) && s.participantId), o = r?.sides?.every((s) => s.participantId);
  return a?.length === 2 || o;
}
function ub({ collectionGroups: e = [] }) {
  let t = Object.assign({}, ...e.filter((i) => Ie(i?.groupValue) && i?.groupNumber).map((i) => ({ [i.groupNumber]: { ...i, allGroupMatchUpsCompleted: !0, matchUpsCount: 0, sideWins: [0, 0], values: [0, 0] } }))), r = Object.keys(t).map((i) => pe(i));
  return { groupValueGroups: t, groupValueNumbers: r };
}
function Wx({ collectionDefinition: e, groupValueNumbers: t, groupValueGroups: r, sideTieValues: i, tieMatchUps: n }) {
  let a = n.filter((U) => U.collectionId === e.collectionId), o = [0, 0], s = [0, 0], c = a.every((U) => Lt.includes(U.matchUpStatus)), { collectionValueProfiles: u, collectionGroupNumber: l, collectionValue: d, matchUpValue: p, winCriteria: m, scoreValue: f, setValue: h } = e, g = l && t.includes(l), I = [0, 0];
  if (a.forEach((U) => {
    U.winningSide && (I[U.winningSide - 1] += 1);
  }), Ie(p) ? a.forEach((U) => {
    U.winningSide && (o[U.winningSide - 1] += p);
  }) : Ie(h) ? a.forEach((U) => {
    U.score?.sets?.forEach((S) => {
      S.winningSide && (o[S.winningSide - 1] += h);
    });
  }) : Ie(f) ? a.forEach((U) => {
    U.score?.sets?.forEach((S) => {
      let { side1TiebreakScore: P = 0, side2TiebreakScore: v = 0, side1Score: D = 0, side2Score: y = 0 } = S;
      (U.matchUpStatus === vt || U.winningSide || S.winningSide) && (D || y ? (o[0] += D, o[1] += y) : (P || v) && S.winningSide && (o[S.winningSide - 1] += 1));
    });
  }) : Array.isArray(u) && a.forEach((U) => {
    if (U.winningSide) {
      let S = U.collectionPosition, P = Hx({ collectionDefinition: e, collectionPosition: S });
      Ie(P) && (o[U.winningSide - 1] += P);
    }
  }), Ie(d)) {
    let U;
    if (m?.aggregateValue) c && (Ie(p || h || f) && o[0] !== o[1] ? U = o[0] > o[1] ? 1 : 2 : I[0] !== I[1] && (U = I[0] > I[1] ? 1 : 2));
    else if (m?.valueGoal) U = o.reduce((S, P, v) => P >= m.valueGoal ? v + 1 : S, 0);
    else {
      let S = Math.floor(e.matchUpCount / 2) + 1;
      U = I.reduce((P, v, D) => v >= S ? D + 1 : P, 0);
    }
    U && (g ? r[l].values[U - 1] += d : s[U - 1] += d);
  } else g ? (r[l].values[0] += o[0] || 0, r[l].values[1] += o[1] || 0) : s = o;
  g ? (r[l].sideWins[0] += I[0] || 0, r[l].sideWins[1] += I[1] || 0, r[l].allGroupMatchUpsCompleted = r[l].allGroupMatchUpsCompleted && c, r[l].matchUpsCount += a.length) : s.forEach((U, S) => i[S] += U || 0);
}
function Hx({ collectionDefinition: e, collectionPosition: t }) {
  return (e.collectionValueProfiles || [])?.find((r) => r.collectionPosition === t)?.matchUpValue;
}
function al(e) {
  let { sideAdjustments: t = [0, 0], separator: r = "-", drawDefinition: i, matchUpsMap: n, structure: a, matchUp: o, event: s } = e;
  if (!Array.isArray(t) || t.length !== 2 || isNaN(t.reduce((P, v) => P + v))) return { error: z };
  if (!o) return { error: Dr };
  let c = dr({ matchUp: o, drawDefinition: i, structure: a, event: s })?.tieFormat || e?.tieFormat;
  if (!c) return { error: $s };
  let u = wr({ tieFormat: c });
  if (u.error) return u;
  let l = c?.collectionDefinitions || [], d = o?.tieMatchUps ?? [], p = [0, 0], { groupValueGroups: m, groupValueNumbers: f } = ub(c);
  for (let P of l) Wx({ collectionDefinition: P, groupValueNumbers: f, groupValueGroups: m, sideTieValues: p, tieMatchUps: d });
  for (let P of f) {
    let v = m[P], { allGroupMatchUpsCompleted: D, matchUpCount: y, winCriteria: w, groupValue: b, sideWins: T, values: R } = v, M;
    if (w?.aggregateValue) D && R[0] !== R[1] && (M = R[0] > R[1] ? 1 : 2);
    else if (w?.valueGoal) M = R.reduce((E, A, N) => A >= w.valueGoal ? N + 1 : E, void 0);
    else {
      let E = Math.floor(y / 2) + 1;
      M = T.reduce((A, N, C) => N >= E ? C + 1 : A, void 0);
    }
    M && (p[M - 1] += b || 0);
  }
  let h = p.map((P, v) => (P || 0) + t[v]), g = { side1Score: h[0], side2Score: h[1], winningSide: void 0 }, I = h.join(r), U = h.slice().reverse().join(r), S;
  if (c?.winCriteria) {
    let { valueGoal: P, aggregateValue: v, tallyDirectives: D } = c.winCriteria;
    if (P ? S = h.map((y, w) => ({ sideNumber: w + 1, points: y })).find(({ points: y }) => y >= P)?.sideNumber : v && d.every((y) => y.matchUpStatus && Lt.includes(y.matchUpStatus) || y.winningSide) && h[0] !== h[1] && (S = h[0] > h[1] ? 1 : 2), !S && D) {
      let y = o.matchUpId, w = o.hasContext ? o : n?.drawMatchUps?.[y] || i && ut({ inContext: !0, drawDefinition: i, matchUpId: y })?.matchUp;
      if (w) {
        let { completedTieMatchUps: b, order: T } = cc({ matchUps: [w] });
        if (b && T?.length) {
          let R = T[0].participantId;
          S = w.sides.find(({ participantId: M }) => M === R)?.sideNumber;
        }
      }
    }
  }
  return S && (g.winningSide = S), { scoreStringSide1: I, scoreStringSide2: U, winningSide: S, set: g };
}
function ol({ inContextDualMatchUp: e, drawDefinition: t, tournamentId: r, dualMatchUp: i, eventId: n }) {
  if (i) {
    e || (e = ut({ matchUpId: i.matchUpId, inContext: !0, drawDefinition: t })?.matchUp);
    let { extension: a } = we({ element: t, name: Fn }), o = ie(a?.value || {}, !1, !0), s = ({ displaySideNumber: c, drawPosition: u, sideNumber: l }) => ({ drawPosition: u, sideNumber: l, displaySideNumber: c });
    i.sides = e?.sides?.map((c) => {
      let u = c.participantId, l = u && o[u] || void 0, { lineUp: d, ...p } = i.sides?.find(({ sideNumber: f }) => f === c.sideNumber) ?? {}, m = d?.length ? d : l;
      return { ...s(c), ...p, lineUp: m };
    }), Oe({ context: "ensureSidLineUps", matchUp: i, drawDefinition: t, tournamentId: r, eventId: n });
  }
}
function er(e) {
  if (e) return ie(e, !1, !0);
}
function SI(e) {
  let t = oe(e, [{ [ur]: !0 }]);
  return t.error ? t : Object.keys(e.tournamentRecords).reduce((r, i) => {
    r.tournamentIdMap[i] = [];
    let n = e.tournamentRecords[i].events ?? [], a = n.map(({ eventId: s }) => s), o = n.map((s) => (s.drawDefinitions ?? []).map(({ drawId: c }) => c)).flat();
    return r.tournamentIdMap[i].push(...a, ...o), r.eventIds.push(...a), r.drawIds.push(...o), r;
  }, { eventIds: [], drawIds: [], tournamentIdMap: {} });
}
function lb({ tournamentRecords: e, eventId: t, drawId: r }) {
  let { tournamentIdMap: i } = SI({ tournamentRecords: e });
  return (i ? Object.keys(i) : []).find((n) => t && i?.[n].includes(t) || r && i?.[n].includes(r));
}
function zn(e) {
  let { exitWhenNoValues: t, drawDefinition: r, matchUpStatus: i, removeScore: n, matchUpsMap: a, matchUpId: o, event: s } = e, c = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord?.tournamentId]: e.tournamentRecord } || {}, u = e.tournamentId || e.tournamentRecord?.tournamentId;
  c && lb({ tournamentRecords: c, ...e });
  let l = u && c[u];
  if (!l) return { error: J };
  let d = ut({ drawDefinition: r, event: s, matchUpId: o });
  if (d.error) return d;
  if (!d.matchUp) return { error: cr };
  let { matchUp: p, structure: m } = d;
  if (!p.tieMatchUps) return { error: Cr };
  ol({ tournamentId: l?.tournamentId, eventId: s?.eventId, dualMatchUp: p, drawDefinition: r });
  let { extension: f } = we({ name: Po, element: p });
  if (f?.value) if (n) fr({ element: p, name: Po });
  else return { ...x, score: p.score };
  let h = dr({ drawDefinition: r, structure: m, matchUp: p, event: s })?.tieFormat;
  p.tieFormat = er(h);
  let g = al({ drawDefinition: r, matchUpsMap: a, structure: m, matchUp: p, event: s }), { winningSide: I, set: U, scoreStringSide1: S, scoreStringSide2: P } = g, v = U?.side1Score || U?.side2Score;
  if (t && !p.score && !v) return { ...x };
  let D = { scoreStringSide1: S, scoreStringSide2: P, sets: U ? [U] : [] }, y = I && [1, 2].includes(I), w = y && vt || Lg({ matchUpStatus: i ?? p.matchUpStatus, tieMatchUps: p.tieMatchUps, winningSide: p.winningSide, score: D }) && Ri || Dt, b = !!(p.winningSide && !y), T = p.tieMatchUps.find(({ score: M, winningSide: E, matchUpStatus: A }) => M?.sets?.length && (M.sets[0].side1Score || M.sets[0].side2Score) || A && Lt.includes(A) || E), R;
  if (p.tieFormat && !y && !T) {
    let M = dr({ drawDefinition: r, structure: m, event: s })?.tieFormat;
    M && JSON.stringify(h) === JSON.stringify(M) && (p.tieFormatId = void 0, p.tieFormat = void 0, R = !0);
  }
  return zi({ appliedPolicies: e.appliedPolicies, matchUpStatus: w, score: D, removeWinningSide: b, tournamentRecord: l, drawDefinition: r, removeScore: n, winningSide: I, matchUpId: o, matchUp: p, event: s }), { ...x, score: D, removeWinningSide: b, tieFormatRemoved: R, winningSide: I };
}
function zx({ winnerMatchUpDrawPositionIndex: e, inContextDrawMatchUps: t, projectedWinningSide: r, sourceMatchUpStatus: i, winningDrawPosition: n, tournamentRecord: a, winnerTargetLink: o, sourceMatchUpId: s, drawDefinition: c, winnerMatchUp: u, dualMatchUp: l, matchUpsMap: d, event: p }) {
  let m = "directWinner";
  if (o) {
    let f = u.drawPositions || [], h = f[e], g = o.source.structureId, I = me({ structureId: g, drawDefinition: c });
    if (I.error) return I;
    let { structure: U } = I, { positionAssignments: S } = _t({ structureId: g, drawDefinition: c }), P = S?.find((T) => T.drawPosition === n)?.participantId, v = o.target.structureId, { positionAssignments: D } = _t({ structureId: v, drawDefinition: c }), y = D?.find((T) => T.participantId === P)?.drawPosition, w = D?.filter((T) => {
      let R = f.includes(T.drawPosition), M = !T.participantId && !T.bye && !T.qualifier;
      return R && M;
    }).map((T) => T.drawPosition), b = w?.includes(h);
    if (P && o.target.roundNumber === 1 && b) Ji({ drawPosition: h, participantId: P, structureId: v, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, drawDefinition: c, matchUpsMap: d, event: p });
    else if (P && w?.length) {
      let T = w.pop();
      T && Ji({ participantId: P, structureId: v, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, drawDefinition: c, drawPosition: T, matchUpsMap: d, event: p });
    } else if (y) {
      let T = po({ drawPosition: y, matchUpId: u.matchUpId, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, sourceMatchUpId: s, drawDefinition: c, matchUpsMap: d });
      if (T.error) return F({ result: T, stack: m });
    } else if (U?.stage !== se) {
      let T = "winner target position unavaiallble";
      console.log(T), F({ stack: m, result: { error: T } });
    }
    if (U?.seedAssignments && U.structureId !== v) {
      let T = U.seedAssignments.find(({ participantId: M }) => M === P), R = T?.participantId;
      T && R && ac({ eventId: u?.eventId, structureId: v, ...T, tournamentRecord: a, drawDefinition: c, participantId: R });
    }
  } else {
    let f = po({ matchUpId: u.matchUpId, drawPosition: n, inContextDrawMatchUps: t, sourceMatchUpStatus: i, tournamentRecord: a, sourceMatchUpId: s, drawDefinition: c, matchUpsMap: d });
    if (f.error) return f;
  }
  if (l && r) {
    let f = l.sides?.find((h) => h.sideNumber === r);
    if (f?.lineUp) {
      let h = l.roundPosition, g = u.roundPosition, I = h === g && h !== 1 || Math.floor(h / 2) === g ? 2 : 1, U = d?.drawMatchUps?.find(({ matchUpId: v }) => v === u.matchUpId), S = [1, 2].map((v) => ({ ...U.sides?.find((D) => D.sideNumber === v) || {}, sideNumber: v }));
      U.sides = S;
      let P = U.sides.find((v) => v.sideNumber === I);
      if (P) {
        let v = f.lineUp?.filter((D) => D?.participantId);
        P.lineUp = Zg({ lineUp: v }), Oe({ tournamentId: a?.tournamentId, eventId: u?.eventId, matchUp: U, context: m, drawDefinition: c });
      }
    }
  }
  return { ...x };
}
function Yx(e) {
  let { loserMatchUpDrawPositionIndex: t, inContextDrawMatchUps: r, projectedWinningSide: i, propagateExitStatus: n, sourceMatchUpStatus: a, loserDrawPosition: o, tournamentRecord: s, loserTargetLink: c, drawDefinition: u, loserMatchUp: l, dualMatchUp: d, matchUpsMap: p, event: m } = e, f = "directLoser", h = c.linkCondition, g = l.drawPositions || [], I = h === Qi && l.roundNumber === 2 && Math.min(...g.filter(Boolean)), U = I || g[t], S = I || g[1 - t], P = c.source.structureId, { structure: v } = me({ structureId: P, drawDefinition: u }), { matchUps: D } = Ve({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: u, structure: v, event: m }), y = D.filter((G) => G.drawPositions?.includes(o)).filter((G) => {
    let V = G.sides.find((q) => q.drawPosition === o), $ = G.matchUpStatus === be || G.matchUpStatus === Pe && !Bt(G);
    return V?.sideNumber === G.winningSide && !$;
  }), w = h === Qi && y.length === 0, { positionAssignments: b } = _t({ structureId: P, drawDefinition: u }), T = b?.find((G) => G.drawPosition === o)?.participantId, R = { loserParticipantId: T }, M = c.target.structureId, { positionAssignments: E } = _t({ structureId: M, drawDefinition: u }), A = E?.filter(({ drawPosition: G }) => g.includes(G)), N = A?.some((G) => G.participantId && T && G.participantId === T), C = n && [Xt, be, Pe].includes(a || "");
  if (N) return { ...x, stack: f };
  let k = A?.filter((G) => {
    let V = g.includes(G.drawPosition), $ = !G.participantId && !G.bye && !G.qualifier;
    return V && $;
  }).map((G) => G.drawPosition), O = k?.includes(U), _ = c.target.roundNumber > 1 && k?.length, B = c.target.roundNumber === 1 && O;
  if (I) {
    let G = L();
    if (G.context && Object.assign(R, G.context), G.error) return F({ result: G, stack: f });
  } else if (B) {
    let G = H();
    if (G.context && Object.assign(R, G.context), G.error) return F({ result: G, stack: f });
  } else if (T && _) {
    k.sort(Ot);
    let G = k[0], V = Ji({ participantId: T, structureId: M, drawPosition: G, inContextDrawMatchUps: r, sourceMatchUpStatus: a, tournamentRecord: s, drawDefinition: u, matchUpsMap: p, event: m });
    if (V.error) return F({ result: V, stack: f });
    if (!V.error && C && n) return { stack: f, context: { progressExitStatus: !0, loserParticipantId: T } };
  } else return F({ context: { loserDrawPosition: o, loserTargetLink: c, targetDrawPositionIsUnfilled: O }, result: { error: O ? Vs : EC }, stack: f });
  if (v?.seedAssignments && v.structureId !== M) {
    let G = v.seedAssignments.find(({ participantId: $ }) => $ === T), V = G?.participantId;
    G && V && ac({ eventId: l?.eventId, structureId: M, ...G, tournamentRecord: s, drawDefinition: u, participantId: V });
  }
  if (d && i) {
    let G = d.sides?.find((V) => V.sideNumber === 3 - i);
    if (G?.lineUp) {
      let { roundNumber: V, eventId: $ } = l, { roundPosition: q } = d, Y = V === 1 ? 2 - q % 2 : 1, W = p?.drawMatchUps?.find(({ matchUpId: X }) => X === l.matchUpId), K = [1, 2].map((X) => ({ ...W.sides?.find((ee) => ee.sideNumber === X) || {}, sideNumber: X }));
      W.sides = K;
      let Q = W.sides.find((X) => X.sideNumber === Y);
      Q && (Q.lineUp = Zg({ lineUp: G.lineUp }), Oe({ tournamentId: s?.tournamentId, matchUp: W, context: f, drawDefinition: u, eventId: $ }));
    }
  }
  return { ...x, stack: f, context: R };
  function L() {
    let G = "loserLinkFedFMLC";
    return F(w ? { result: H(), stack: G } : { result: j(), stack: G });
  }
  function j() {
    let G = Zr({ drawPosition: S, structureId: M, tournamentRecord: s, drawDefinition: u, event: m });
    return F({ result: G, stack: "assignLoserPositionBye" });
  }
  function H() {
    let G = T ? Ji({ drawPosition: U, participantId: T, structureId: M, inContextDrawMatchUps: r, sourceMatchUpStatus: a, tournamentRecord: s, drawDefinition: u, matchUpsMap: p, event: m }) : { error: Ft };
    return !G.error && C && n ? { stack: f, context: { progressExitStatus: !0 } } : F({ result: G, stack: "assignLoserDrawPosition" });
  }
}
function db(e) {
  let t = "directParticipants", r = UI(e);
  if (r.error) return F({ result: r, stack: t });
  let i = Wu({ matchUpStatus: e.matchUpStatus }), { dualWinningSideChange: n, inContextDrawMatchUps: a, projectedWinningSide: o, propagateExitStatus: s, matchUpStatusCodes: c, tournamentRecord: u, drawDefinition: l, matchUpStatus: d, dualMatchUp: p, matchUpsMap: m, winningSide: f, targetData: h, matchUpId: g, structure: I, matchUp: U, event: S } = e, P = !!U.collectionId, v = Tr({ structure: I }), D = U.drawPositions, y;
  if (P) {
    let { matchUpTieId: w, matchUpsMap: b } = e, T = zn({ appliedPolicies: e.appliedPolicies, matchUpId: w, tournamentRecord: u, drawDefinition: l, matchUpsMap: b, event: S });
    if (y = T && { tieMatchUpResult: T }, D = a.find(({ matchUpId: R }) => R === w)?.drawPositions, !n) return F({ result: { ...x, ...y }, stack: t });
  }
  if (v) return F({ result: { ...x, ...y }, stack: t });
  if (D) {
    let w = o ? o - 1 : f - 1, b = 1 - w, T = D[w], R = D[b], M = {}, { targetLinks: { loserTargetLink: E, winnerTargetLink: A, byeTargetLink: N }, targetMatchUps: { winnerMatchUpDrawPositionIndex: C, loserMatchUpDrawPositionIndex: k, winnerMatchUp: O, loserMatchUp: _, byeMatchUp: B } } = h;
    if (O) {
      let L = zx({ sourceMatchUpStatus: i && d || vt, winnerMatchUpDrawPositionIndex: C, sourceMatchUpId: g, inContextDrawMatchUps: a, projectedWinningSide: o, winningDrawPosition: T, tournamentRecord: u, winnerTargetLink: A, drawDefinition: l, winnerMatchUp: O, dualMatchUp: p, matchUpsMap: m, event: S });
      if (L.error) return F({ result: L, stack: t });
    }
    if (_) {
      let L = Yx({ sourceMatchUpStatus: i && d || vt, loserMatchUpDrawPositionIndex: k, inContextDrawMatchUps: a, projectedWinningSide: o, propagateExitStatus: s, loserDrawPosition: R, tournamentRecord: u, loserTargetLink: E, drawDefinition: l, loserMatchUp: _, matchUpsMap: m, dualMatchUp: p, event: S });
      if (L.context?.progressExitStatus && Object.assign(M, L.context, { sourceMatchUpStatus: i && d || vt, sourceMatchUpStatusCodes: c || [], loserMatchUp: _, matchUpsMap: m }), L.error) return F({ result: L, stack: t });
    }
    if (B) {
      let L = B.drawPositions || [], j = Math.min(...L.filter(Boolean)), H = N.target.structureId, G = Zr({ drawPosition: j, structureId: H, tournamentRecord: u, drawDefinition: l, event: S });
      if (G.error) return F({ result: G, stack: t });
    }
    return F({ result: { ...x, ...y }, stack: t, context: M });
  } else return F({ result: { error: pu }, stack: t });
}
function yI(e) {
  let t = "genPlayoffStructure";
  if (!e.drawDefinition) return F({ result: { error: ne }, stack: t });
  let r = il(e);
  if (r.error) return F({ result: r, stack: t });
  let { structureId: i, addNameBaseToAttributeName: n, playoffStructureNameBase: a, finishingPositionNaming: o, finishingPositionLimit: s, playoffAttributes: c, playoffPositions: u, roundOffsetLimit: l, tournamentRecord: d, exitProfileLimit: p, roundProfiles: m, roundNumbers: f, idPrefix: h, isMock: g, event: I, uuids: U } = e, S = ie(e.drawDefinition, !1, !0), { structure: P } = me({ structureId: i, drawDefinition: S });
  if (!P) return F({ result: { error: mt }, stack: t });
  if (P.structureType === yr || P.structures) return Rx({ sourceStructureId: P.structureId, ...e, ...r, drawDefinition: S });
  let { playoffRoundsRanges: v, playoffRounds: D } = r, { playoffPositionsReturned: y, error: w, playoffSourceRounds: b, playoffRoundsRanges: T } = YT(e);
  if (w) return F({ result: { error: w }, stack: t });
  let R = m?.length && Object.assign({}, ...m), M = f || typeof m == "object" && m.map((q) => Object.keys(q)).flat(), E = Array.isArray(M) && M.map((q) => !isNaN(q) && pe(q)).filter(Boolean);
  if (E) {
    if (!Array.isArray(E)) return F({ result: { error: z }, context: { validRoundNumbers: E }, stack: t });
    E.forEach((q) => {
      if (!D?.includes(q)) return F({ result: { error: z }, context: { roundNumber: q }, stack: t });
    });
  }
  u && u.forEach((q) => {
    if (!y?.includes(q)) return F({ result: { error: z }, context: { playoffPosition: q }, stack: t });
  });
  let A = E || b, N = E ? v : T, C = [], k = [];
  for (let q of A ?? []) {
    let Y = N?.find((fe) => fe.roundNumber === q);
    if (!Y) return F({ result: { error: z }, context: { roundNumber: q }, stack: t });
    let W = Y.finishingPositions.length, K = Math.min(...Y.finishingPositions) - 1, Q = 2, X = q && R?.[q] && Q + R[q] - 1, ee = fs({ exitProfile: `0-${q}`, addNameBaseToAttributeName: n, playoffStructureNameBase: a, finishingPositionOffset: K, playoffAttributes: c, exitProfileLimit: p, stage: yt, roundOffset: 0, drawDefinition: S, sequenceLimit: X, stageSequence: Q, drawSize: W, idPrefix: h, isMock: g, uuids: U, finishingPositionNaming: o, finishingPositionLimit: s, roundOffsetLimit: l });
    if (ee.error) return F({ result: ee, stack: t });
    let { structures: Z, links: ce } = ee;
    if (Z?.length && C.push(...Z), ce?.length && k.push(...ce), ee.structureId && q) {
      let fe = { linkType: Un, source: { structureId: i, roundNumber: q }, target: { structureId: ee.structureId, feedProfile: Ii, roundNumber: 1 } };
      k.push(fe);
    }
  }
  if (!C.length) return F({ result: { error: z }, info: "No structures generated", stack: t });
  S.structures.push(...C), S.links.push(...k);
  let { matchUps: O, matchUpsMap: _ } = Et({ inContext: !0, drawDefinition: S }), B = C.map(({ structureId: q }) => q), L = O?.filter(({ structureId: q }) => B.includes(q)).map($t), j = _?.drawMatchUps?.filter(({ matchUpId: q }) => L?.includes(q));
  if (j?.length) {
    let q = dr({ drawDefinition: S, event: I })?.tieFormat;
    q && j.forEach((Y) => {
      let { tieMatchUps: W } = Xo({ matchUp: Y, tieFormat: q, isMock: g });
      Object.assign(Y, { tieMatchUps: W, matchUpType: ot });
    });
  }
  O?.filter((q) => ba({ matchUp: q }) && q.structureId === i)?.forEach((q) => {
    let { matchUpId: Y, score: W, winningSide: K } = q, Q = Ur({ inContextDrawMatchUps: O, drawDefinition: S, matchUpId: Y }), X = db({ inContextDrawMatchUps: O, tournamentRecord: d, drawDefinition: S, matchUpsMap: _, winningSide: K, targetData: Q, matchUpId: Y, structure: P, matchUp: q, score: W, event: I });
    X.error && console.log(X.error);
  }), O?.filter((q) => q.matchUpStatus === "BYE" && q.structureId === i)?.forEach((q) => {
    let { matchUpId: Y } = q, W = Ur({ inContextDrawMatchUps: O, drawDefinition: S, matchUpId: Y }), { targetLinks: { loserTargetLink: K }, targetMatchUps: { loserMatchUpDrawPositionIndex: Q, loserMatchUp: X } } = W;
    if (K && X) {
      let ee = K.target.structureId, Z = X.drawPositions[Q], ce = Zr({ drawPosition: Z, structureId: ee, tournamentRecord: d, drawDefinition: S, event: I });
      ce.error && console.log(ce.error);
    }
  });
  let H = [], G = Fa({ inContextDrawMatchUps: O, drawDefinition: S, matchUpsMap: _ }).goesToMap, { structure: V } = me({ drawDefinition: e.drawDefinition, structureId: i }), { matchUps: $ } = Ve({ structure: V });
  return $.forEach((q) => {
    let Y = G?.loserMatchUpIds[q.matchUpId];
    if (Y && q.loserMatchUpId !== Y) {
      q.loserMatchUpId = Y;
      let K = { tournamentId: d?.tournamentId, eventId: e.event?.eventId, context: t, matchUp: q };
      H.push(K);
    }
    let W = G?.winnerMatchUpIds[q.matchUpId];
    if (W && q.winnerMatchUpId !== W) {
      q.winnerMatchUpId = W;
      let K = { tournamentId: d?.tournamentId, eventId: e.event?.eventId, context: t, matchUp: q };
      H.push(K);
    }
  }), { structures: C, matchUpModifications: H, links: k, drawDefinition: S, ...x };
}
function pb({ element: e }) {
  if (!e) return { error: z };
  if (!e.timeItems) return {};
  if (!Array.isArray(e.timeItems)) return { error: z };
  let t = (r, i) => (n, a) => (a[r] && (n[a[r]] = a[i]), n);
  return e.timeItems.reduce(t("itemType", "itemValue"), {});
}
function an(e) {
  let { duplicateValues: t = !0, creationTime: r = !0, removePriorValues: i, timeItem: n } = e;
  if (!n) return { error: Dh };
  let a = Pw(e);
  if (a.error) return a;
  if (!(xe(n) && dt(n.itemType) && Object.keys(n).includes("itemValue"))) return { error: Ph };
  if (!a.timeItems) a.timeItems = [];
  else if (Kx({ element: a, duplicateValues: t, timeItem: n })) return { ...x };
  if (n.itemSubTypes && !n.itemSubTypes.length && delete n.itemSubTypes, r) {
    let o = (/* @__PURE__ */ new Date()).toISOString();
    Object.assign(n, { createdAt: o });
  }
  return i && (a.timeItems = a.timeItems.filter(({ itemType: o }) => n.itemType !== o)), i && !n.itemValue || a.timeItems.push(n), { ...x };
}
function Kx({ element: e, duplicateValues: t, timeItem: r }) {
  let { itemType: i, itemSubTypes: n, itemValue: a } = r, o = i && li({ itemSubTypes: n, itemType: i, element: e })?.timeItem;
  return o && JSON.stringify(o?.itemValue) === JSON.stringify(a) && !t;
}
function vI({ creationTime: e = !0, removePriorValues: t, tournamentRecord: r, duplicateValues: i, participantId: n, timeItem: a }) {
  if (!r) return { error: J };
  if (!n) return { error: Ft };
  let o = ha({ tournamentRecord: r, participantId: n });
  return o.error ? o : an({ element: o.participant, removePriorValues: t, duplicateValues: i, creationTime: e, timeItem: a });
}
function sl(e) {
  let { removePriorValues: t, tournamentRecord: r, duplicateValues: i, creationTime: n, timeItem: a } = e;
  if (!r) return { error: J };
  let o = an({ element: r, removePriorValues: t, duplicateValues: i, creationTime: n, timeItem: a });
  if (o.error) return o;
  let s = pb({ element: r });
  return Se({ payload: { parentOrganisation: r.parentOrganisation, tournamentId: r.tournamentId, timeItemValues: s }, topic: za }), o;
}
function Jo(e) {
  let { removePriorValues: t, duplicateValues: r, creationTime: i, timeItem: n, event: a } = e;
  return a ? an({ removePriorValues: t, duplicateValues: r, element: a, creationTime: i, timeItem: n }) : { error: ni };
}
function mb(e) {
  return Op({ ...e, itemType: "attachConsolationStructures" });
}
function PI(e) {
  return Op({ ...e, itemType: "attachPlayoffStructures" });
}
function Op({ itemType: e = "attachStructures", matchUpModifications: t, tournamentRecord: r, drawDefinition: i, structures: n, links: a = [], event: o }) {
  let s = "attachStructures";
  if (!i) return { error: ne };
  if (!Array.isArray(n) || !Array.isArray(a)) return F({ result: { error: z }, stack: s });
  let c = (g) => [g.source.structureId, g.source.roundNumber || g.source.finishingPositions?.join("|"), g.target.roundNumber].join("|"), u = i.links?.map(c);
  if (a.some((g) => {
    let I = c(g);
    return u?.includes(I);
  })) return F({ result: { error: Rh }, info: "playoff structure exists", stack: s });
  a.length && i.links?.push(...a);
  let l = n.map(({ structureId: g }) => g), d = i.structures?.map(({ structureId: g }) => g);
  i.structures = (i.structures ?? []).map((g) => l.includes(g.structureId) ? n.find(({ structureId: I }) => I === g.structureId) : g);
  let p = n?.filter(({ structureId: g }) => !d?.includes(g));
  p.length && i.structures.push(...p), Fa({ drawDefinition: i });
  let m = n.map((g) => Ve({ structure: g })?.matchUps || []).flat();
  oa({ tournamentId: r?.tournamentId, eventId: o?.eventId, drawDefinition: i, matchUps: m });
  let f = n.map(({ structureId: g }) => g);
  if (tt({ drawDefinition: i, structureIds: f }), t?.length) {
    let g = {};
    t.forEach((U) => {
      let S = U.matchUp?.matchUpId;
      S && (g[S] = U);
    });
    let I = (U) => {
      U.matchUps.forEach((S) => {
        if (g[S.matchUpId]) {
          let { tieMatchUps: P, ...v } = g[S.matchUpId].matchUp;
          if (Object.assign(S, v), P?.length) {
            let D = {};
            P.forEach((y) => g[y.matchUpId] = y), S.tieMatchUps.forEach((y) => Object.assign(y, D[y.matchUpId]));
          }
          g[S.matchUpId].matchUp = S, Oe(g[S.matchUpId]);
        }
      });
    };
    i.structures.forEach((U) => {
      if (d?.includes(U.structureId)) if (U.structures) for (let S of U.structures) I(S);
      else I(U);
    });
  }
  let h = p.map(qr("structureId"));
  if (r) {
    let g = { itemValue: { structureIds: f, drawId: i.drawId }, itemType: e };
    an({ element: r, timeItem: g });
  }
  return { ...x, addedStructureIds: h };
}
function kp(e) {
  let { structures: t, links: r, matchUpModifications: i, error: n } = yI(e);
  if (n) return { error: n };
  let a = e.drawDefinition;
  return PI({ tournamentId: e.tournamentRecord?.tournamentId, eventId: e.event?.eventId || e.eventId, matchUpModifications: i, drawDefinition: a, structures: t, links: r });
}
function _a(e) {
  let t = oe(e, [{ _anyOf: { [ur]: !1, [Vt]: !1, [lr]: !1, [qn]: !1 }, [Hh]: !0 }]);
  if (t.error) return t;
  let r = [], i = e.drawDefinition ?? e.event ?? ((e.tournamentId || !e.tournamentRecords) && e.tournamentRecord);
  if (i) {
    let n = uy(e, i);
    if (n.error) return n;
    r.push(...n?.applied ?? []), e.drawDefinition && tt({ drawDefinition: e.drawDefinition, tournamentId: e.tournamentId });
  } else if (e.tournamentRecords) {
    let n = Object.keys(e.tournamentRecords);
    if (!n.length) return { error: J };
    for (let a of n) {
      let o = e.tournamentRecords[a], s = uy(e, o);
      if (s.error) return s;
      r.push(...s?.applied ?? []);
    }
  } else return { error: J };
  return r.length ? { ...x, applied: r } : { error: fh };
}
function uy(e, t) {
  let r = _e(e).appliedPolicies ?? {};
  t.extensions || (t.extensions = []);
  let i = [], n = Object.keys(e.policyDefinitions);
  if (!n.length) return { error: Ed };
  for (let a of n) if (!r[a] || e.allowReplacement) {
    let o = e.policyDefinitions[a];
    if (!o) continue;
    if (!xe(o)) return { error: z };
    let { policyName: s, ...c } = o;
    if (!c || !Object.keys(c).length || s && !dt(s)) return { error: z };
    r[a] = e.policyDefinitions[a], i.push(a);
  }
  return i?.length ? { ...Be({ element: t, extension: { name: Yc, value: r } }), applied: i } : { applied: i, error: fh };
}
function DI({ tournamentRecord: e, drawDefinition: t, flightProfile: r, drawName: i, drawId: n, event: a }) {
  if (!i || typeof i != "string") return F({ result: { error: z }, context: { drawName: i } });
  r || (r = wt({ event: a }).flightProfile);
  let o = r?.flights?.find((s) => s.drawId === n);
  if (o) {
    o.drawName = i;
    let s = { name: wi, value: { ...r, flights: r.flights } };
    ma({ event: a, extension: s });
  }
  return t && (t.drawName = i, tt({ tournamentId: e?.tournamentId, drawDefinition: t })), !o && !t ? { error: ne } : { ...x, flight: o };
}
function fb({ tournamentRecord: e, drawDefinition: t, drawUpdates: r, drawId: i, event: n }) {
  if (!xe(r)) return { error: z };
  let a = wt({ event: n }).flightProfile, o = r.drawName && DI({ drawName: r.drawName, tournamentRecord: e, drawDefinition: t, flightProfile: a, drawId: i, event: n });
  if (o?.error) return o?.error;
  let s = o?.flight || a?.flights?.find((c) => c.drawId === i);
  if (!s && !t) return { error: ne };
  if (s) {
    let c = { name: wi, value: { ...a, flights: a.flights } };
    ma({ event: n, extension: c });
  }
  return t && (r.policyDefinitions && _a({ policyDefinitions: r.policyDefinitions, drawDefinition: t }), tt({ tournamentId: e?.tournamentId, drawDefinition: t })), { ...x };
}
function hb({ tournamentRecord: e, removeScheduling: t, drawDefinition: r }) {
  if (!r) return { error: ne };
  let i = or({ drawDefinition: r }), n = (o) => i?.drawMatchUps?.find((s) => s.matchUpId === o);
  for (let o of r.structures || []) {
    let { positionAssignments: s, stage: c, stageSequence: u } = o;
    s && (u !== 1 || ![se, re].includes(c)) && (o.positionAssignments = s.map((p) => (delete p.participantId, p)), o.seedAssignments = []);
    let { matchUps: l, isRoundRobin: d } = Ve({ afterRecoveryTimes: !1, inContext: !0, matchUpsMap: i, structure: o });
    for (let p of l) {
      let { matchUpId: m, roundNumber: f } = p, h = p.sides || [], g = n(m);
      if (g) {
        if (delete g.extensions, delete g.notes, g.matchUpStatus !== "BYE" && Object.assign(g, Cp), f && f > 1 && g.drawPositions?.length && !d) {
          let I = h?.map(({ drawPosition: S, participantFed: P }) => !P && S).filter(Boolean), U = g.drawPositions.map((S) => I.includes(S) ? void 0 : S);
          g.drawPositions = U;
        }
        t ? delete g.timeItems : g.timeItems?.length && (g.timeItems = g.timeItems.filter((I) => I.itemType && ![Dn, ca, Vo, Og, jo, Go].includes(I.itemType))), Oe({ tournamentId: e?.tournamentId, context: "resetDrawDefiniton", drawDefinition: r, matchUp: g });
      }
    }
  }
  r.extensions = r.extensions.filter((o) => o.name !== ms);
  let a = (r.structures || []).map(({ structureId: o }) => o);
  return tt({ drawDefinition: r, structureIds: a }), { ...x };
}
function cl({ tournamentRecord: e }) {
  if (!e) return { error: J };
  let t = { positionsNoOutcomes: [], canBePruned: [], matchPlay: [], inactive: [], drawAnalysis: {} }, r = {};
  return (e.events?.map((i) => {
    let n = i.eventId;
    return r[n] = i, (i?.drawDefinitions || []).map((a) => ({ drawDefinition: a, eventId: n }));
  }).flat().filter(Boolean)).forEach(({ drawDefinition: i, eventId: n }) => {
    let a = 0, o = 0, s = 0, { allStructuresLinked: c } = Rp({ drawDefinition: i }), u = r[n], l = (i?.structures || []).map((S) => {
      let { stage: P, stageSequence: v, structureId: D } = S, y = yo[P], { inContextStructureMatchUps: w } = Hu({ drawDefinition: i, structure: S, event: u }), b = w?.filter(({ winningSide: j }) => j), T = b.filter(Boolean).length || 0;
      o += T, s += w.length - o;
      let R = Math.max(b.filter(({ roundNumber: j }) => j === 1).map(({ roundPosition: j }) => j)), { positionAssignments: M } = Je({ structure: S }), E = M?.filter(({ participantId: j }) => j);
      a += E?.length ?? 0;
      let A = (M?.length ?? 0) - (E?.length ?? 0), { roundMatchUps: N, roundProfile: C, roundNumbers: k, maxMatchUpsCount: O } = Ir({ matchUps: w }), _ = C && Object.keys(C).filter((j) => !C[j].inactiveRound).map((j) => parseInt(j)), B = C && Object.keys(C).filter((j) => C[j].inactiveRound).map((j) => parseInt(j)), L = C && Object.values(C).every((j) => j.inactiveRound);
      return { positionsAssignedCount: E?.length ?? 0, maxWinningSideFirstRoundPosition: R, unassignedPositionsCount: A, inactiveStructure: L, maxMatchUpsCount: O, inactiveRounds: B, roundMatchUps: N, activeRounds: _, roundNumbers: k, roundProfile: C, structureId: D, stageSequence: v, orderNumber: y, stage: P };
    }), d = l.find((S) => S.orderNumber === 2 && S.stageSequence === 1), p = l.filter(({ inactiveStructure: S }) => !S).length, { links: m } = tc({ structureId: d.structureId, drawDefinition: i }), f = pe(d.activeRounds[0]) === 1 && d.activeRounds.length === 1 && p === 1, h = l?.every(({ inactiveStructure: S }) => S), g = !m.length && d.activeRounds.length && (d.roundProfile[1].inactiveCount || d.inactiveRounds.length), I = i.drawId;
    a && !o && t.positionsNoOutcomes.push(I), h && t.inactive.push(I), f && t.matchPlay.push(I), g && t.canBePruned.push(I);
    let U = { matchUpsWithWinningSideCount: o, matchUpsNoOutcomeCount: s, positionsAssignedCount: a, allStructuresLinked: c, structuresData: l, inactiveDraw: h, isMatchPlay: f, drawId: I };
    t.drawAnalysis[I] = U;
  }), { ...x, drawsAnalysis: t };
}
function gb({ matchPlayDrawPositions: e = !0, tournamentRecord: t, drawDefinition: r, drawId: i }) {
  if (!t) return { error: J };
  if (!r) return { error: ne };
  let n = [], { drawsAnalysis: a } = cl({ tournamentRecord: t });
  if (a.canBePruned.includes(i)) {
    let o = a.matchPlay.includes(i), s = a.drawAnalysis[i], { structures: [c] } = Ti({ stageSequence: 1, drawDefinition: r, stage: re }), u = s.structuresData.find(({ structureId: m }) => c.structureId === m), l = (c.matchUps ?? []).sort((m, f) => m.roundPosition - f.roundPosition);
    n = l.filter(({ roundNumber: m }) => !u.inactiveRounds.includes(m));
    let d = n.map($t), p = l.map($t).filter((m) => !d.includes(m));
    if (o) {
      let m = n.filter(({ roundNumber: U }) => !u.inactiveRounds.includes(U)).filter(({ winningSide: U }) => U), f = m.map($t), h = d.filter((U) => !f.includes(U));
      p.push(...h);
      let g = m.flatMap((U) => U.drawPositions ?? []).filter(Boolean).flat(), I = Object.assign({}, ...g.map((U, S) => ({ [U]: S + 1 })));
      if (m.forEach((U) => {
        e ? U.drawPositions = U.drawPositions.map((S) => I[S]) : delete U.drawPositions;
      }), e) {
        let U = c?.positionAssignments?.filter((S) => g.includes(S.drawPosition)).map((S) => (S.drawPosition = I[S.drawPosition], S));
        c.positionAssignments = U;
      } else c.positionAssignments = [];
      c.matchUps = m, n = m;
    }
    bn({ tournamentId: t?.tournamentId, matchUpIds: p, drawDefinition: r }), tt({ drawDefinition: r });
  }
  return { ...x, matchUps: n };
}
function Ib({ tournamentRecord: e, drawDefinition: t, participantId: r, drawPosition: i, structureId: n, qualifier: a, event: o, bye: s }) {
  if (!t) return { error: ne };
  if (!i) return { error: js };
  if (!n) return { error: Qr };
  if (s) {
    let c = Zr({ tournamentRecord: e, drawDefinition: t, drawPosition: i, structureId: n, event: o });
    if (c.error) return c;
  } else {
    if (a) return { error: Bd };
    {
      let c = Ji({ tournamentRecord: e, drawDefinition: t, participantId: r, drawPosition: i, structureId: n, event: o });
      if (c.error) return c;
    }
  }
  return { ...x };
}
function Ub(e) {
  let t = e.matchUpIds ?? [], { drawDefinition: r } = e, i = e.structureId ?? r?.structures?.find((c) => c.matchUps?.some(({ matchUpId: u }) => t.includes(u)))?.structureId ?? r?.structures?.[0]?.structureId;
  if (!i) return { error: mt };
  let n = r.structures?.find((c) => c.structureId === i);
  if (!n) return { error: mt };
  let a = n?.matchUps, o = a?.find((c) => !!c.roundPosition);
  if (n.structures || o || n.finishingPosition === Fo) return { error: $a };
  let s = a.filter(({ roundNumber: c }) => e.roundNumbers?.includes(c)).map($t);
  return t = t.filter((c) => !s.includes(c)), e.roundNumbers && !t.length && (t = s), { existingMatchUps: a, matchUpIds: t, structureId: i, structure: n };
}
function Sb(e) {
  let t = oe(e, [{ [lr]: !0 }, { [Ms]: { [bu]: !1, roundNumbers: !1 }, [Kr]: z, [Mr]: sr }]);
  if (t.error) return t;
  let { removeIncomplete: r = !1, removeUnAssigned: i = !0, removeCompleted: n = !1, tournamentRecord: a, drawDefinition: o, event: s } = e, c = Ub(e);
  if (c.error) return c;
  let { structure: u, structureId: l, existingMatchUps: d, matchUpIds: p } = c, m = [], f = d?.filter(({ matchUpId: I, score: U, winningSide: S }) => {
    if (S && !n) return !1;
    if (S || Bt({ score: U })) {
      if (!S && !r) return !1;
      m.push(I);
    } else if (!i) return !1;
    return p?.includes(I);
  }) ?? [], h = f.map($t), g = f.map(({ tieMatchUps: I }) => I?.map($t)).filter(Boolean).flat();
  if (h.length) {
    u.matchUps = (u.matchUps ?? []).filter(({ matchUpId: S }) => !h.includes(S)), bn({ tournamentId: a?.tournamentId, matchUpIds: [...g, ...h], action: "deleteAdHocMatchUps", eventId: s?.eventId, drawDefinition: o });
    let I = Ue(u.matchUps.map(qr("roundNumber"))), U = DC(I);
    if (U.length) {
      U.reverse();
      for (let S of U) u.matchUps.forEach((P) => {
        P.roundNumber && P.roundNumber > S && (P.roundNumber -= 1, Oe({ tournamentId: a?.tournamentId, context: ["adHoc round deletion"], eventId: s?.eventId, drawDefinition: o, matchUp: P }));
      });
    }
    if (m.length) {
      u.positionAssignments = Ue(u.matchUps.flatMap((y) => (y.sides ?? []).map((w) => w.participantId)).filter(Boolean)).map((y) => ({ participantId: y }));
      let S = u?.matchUpFormat ?? o?.matchUpFormat ?? s?.matchUpFormat, P = c.existingMatchUps.some((y) => y.matchUpType === Hr) ? { matchUpTypes: [Hr] } : void 0, { matchUps: v } = Ve({ afterRecoveryTimes: !1, inContext: !0, matchUpFilters: P, structure: u, event: s });
      Tr({ structure: u }) && (u.positionAssignments = Ue(v.flatMap((y) => (y.sides ?? []).map((w) => w.participantId)).filter(Boolean)).map((y) => ({ participantId: y })));
      let D = gI({ positionAssignments: u.positionAssignments, tournamentRecord: a, drawDefinition: o, matchUpFormat: S, matchUps: v, event: s });
      D.error && console.log(D);
    }
    tt({ structureIds: [l], eventId: s?.eventId, drawDefinition: o });
  }
  return !h.length && p.length ? { error: Iu } : { ...x, deletedMatchUpsCount: [...h, ...g].length };
}
function yb({ removeCompletedMatchUps: e, tournamentRecord: t, drawDefinition: r, structureId: i, roundNumber: n, event: a }) {
  if (!t) return { error: J };
  if (!r) return { error: ne };
  if (!n) return F({ result: { error: ue }, info: "roundNumber required" });
  let o = me({ drawDefinition: r, structureId: i });
  if (o.error) return o;
  let s = o.structure;
  return s?.structures ? { error: $a } : Tr({ structure: s }) ? Qx({ tournamentId: t.tournamentId, removeCompletedMatchUps: e, eventId: a.eventId, drawDefinition: r, roundNumber: n, structure: s }) : (console.log("not implemented"), { ...x });
}
function Qx({ removeCompletedMatchUps: e, drawDefinition: t, tournamentId: r, roundNumber: i, structure: n, eventId: a }) {
  let o = n?.matchUps ?? [], s = [], c = [], u = !1;
  if (o.reduce((l, d) => {
    let p = d?.roundNumber;
    return p ? l.includes(p) ? l : l.concat(p) : l;
  }, []).sort(Ot).includes(i)) {
    let l = o.filter((d) => {
      let p = d.roundNumber === i && (!Lt.includes(d.matchUpStatus) || e);
      return p && (c.push(d.matchUpId), d.tieMatchUps && s.push(...d.tieMatchUps.map($t))), !p;
    });
    c.length && (bn({ matchUpIds: [...s, ...c], drawDefinition: t, tournamentId: r, eventId: a }), l.some((d) => d.roundNumber === i) || (l.forEach((d) => {
      d.roundNumber > i && (d.roundNumber -= 1, Oe({ drawDefinition: t, tournamentId: r, eventId: a, matchUp: d }));
    }), u = !0), n.matchUps = l);
  }
  return { deletedMatchUpsCount: c.length, roundRemoved: u, ...x };
}
function xp(e) {
  let { suppressNotifications: t, tournamentRecord: r, drawDefinition: i, matchUps: n, event: a } = e;
  if (typeof i != "object") return { error: ne };
  let o = e?.structureId;
  if (!o && i.structures?.length === 1 && (o = i.structures?.[0]?.structureId), typeof o != "string") return { error: Qr };
  if (!pi(n)) return { error: z, info: La("matchUps") };
  let s = i.structures?.find((p) => p.structureId === o);
  if (!s) return { error: mt };
  let c = (s?.matchUps).find((p) => !!p.roundPosition);
  if (s.structures || c || s.finishingPosition === Fo) return { error: $a };
  let u = Jt({ tournamentRecord: r, inContext: !1 })?.matchUps?.map($t) ?? [], l = n.map($t);
  if (gr(u, l)) return { error: wP, info: "One or more matchUpIds already present in tournamentRecord" };
  s.matchUps.push(...n);
  let d = n.map(({ tieMatchUps: p }) => p).filter(Boolean).flat();
  return t || (oa({ tournamentId: r?.tournamentId, matchUps: [...d, ...n], eventId: a?.eventId, drawDefinition: i }), tt({ drawDefinition: i, structureIds: [o] })), { ...x };
}
function vb({ tournamentRecord: e, drawDefinition: t, drawPosition: r, structureId: i, subOrder: n, event: a }) {
  if (!t) return { error: ne };
  if (!i) return { error: Qr };
  if (!r) return { error: js };
  let { structure: o } = me({ drawDefinition: t, structureId: i });
  if (!o) return { error: mt };
  let s = o;
  o.structures && o.structureType === yr && (s = o.structures?.find((m) => m.positionAssignments?.find((f) => f.drawPosition === r)));
  let c = s?.positionAssignments, u = c?.find((m) => m.drawPosition === r);
  u && Be({ element: u, extension: { name: Es, value: n } });
  let l = (a?.eventType === ot || t.matchUpType === ot || (a?.tieFormat ?? t?.tieFormat ?? o?.tieFormat)) && { matchUpTypes: [ot] }, { matchUps: d } = Ve({ structure: s, afterRecoveryTimes: !1, inContext: !0, matchUpFilters: l, event: a }), p = o?.matchUpFormat ?? t.matchUpFormat;
  return gI({ positionAssignments: c, tournamentRecord: e, drawDefinition: t, matchUpFormat: p, matchUps: d, event: a }), tt({ drawDefinition: t, structureIds: [i] }), { ...x };
}
var Pb = {};
Me(Pb, { addGoesTo: () => Fa, allPlayoffPositionsFilled: () => iI, checkValidEntries: () => _p, findDrawDefinition: () => MI, getAssignedParticipantIds: () => eo, getAvailableMatchUpsCount: () => Fp, getAvailablePlayoffProfiles: () => il, getDrawDefinitionTimeItem: () => wg, getDrawParticipantRepresentativeIds: () => TI, getDrawStructures: () => Ti, getDrawTypeCoercion: () => ul, getEligibleVoluntaryConsolationParticipants: () => wI, getMatchUpsMap: () => or, getParticipantIdFinishingPositions: () => bI, getPositionAssignments: () => ru, getPositionsPlayedOff: () => sc, getRandomQualifierList: () => EI, getSeedingThresholds: () => Xg, getSeedsCount: () => ll, getStructureSeedAssignments: () => si, getTeamLineUp: () => xa, getValidGroupSizes: () => Ju, isAdHoc: () => Tr, isCompletedStructure: () => wn, isValidForQualifying: () => AI, positionActions: () => NI });
function wI({ excludedMatchUpStatuses: e = [], includeEventParticipants: t, includeQualifyingStage: r, finishingRoundLimit: i, policyDefinitions: n, roundNumberLimit: a, tournamentRecord: o, drawDefinition: s, matchUpsLimit: c, requirePlay: u, requireLoss: l, allEntries: d, winsLimit: p, event: m }) {
  if (!s) return { error: ne };
  let f = [re, yt];
  r && f.push(se);
  let h = m?.eventType ? { matchUpTypes: [m.eventType] } : void 0, g = s?.matchUpType ? { matchUpTypes: [s.matchUpType] } : void 0, I = t && m ? Rn({ contextFilters: { stages: f }, matchUpFilters: h, tournamentRecord: o, inContext: !0, event: m })?.matchUps ?? [] : hr({ contextFilters: { stages: f }, matchUpFilters: g, tournamentRecord: o, inContext: !0, drawDefinition: s })?.matchUps ?? [], U = Bo({ stage: zt, drawDefinition: s }).map(({ participantId: k }) => k), S = {}, P = {}, v = {}, D = {};
  n || (n = Wn({ policyTypes: [If], tournamentRecord: o, drawDefinition: s, event: m }).policyDefinitions);
  let y = n?.[If];
  e = e.length && e || y?.excludedMatchUpStatuses || [], t = t ?? y?.includeEventParticipants, d = d ?? y?.allEntries, i = i ?? y?.finishingRoundLimit, a = a ?? y?.roundNumberLimit, c = c ?? y?.matchUpsLimit, u === void 0 && (u = y?.requirePlay !== void 0 ? y.requirePlay : !0), l === void 0 && (l = y?.requireLoss !== void 0 ? y.requireLoss : !0), p = p ?? y?.winsLimit;
  for (let k of I) {
    if (u && k.winningSide && ![1, 2].includes(k.winningSide) && k.matchUpStatus !== Mt || k.finishingRound && i && k.finishingRound >= i || k.finishingRound && a && k.finishingRound <= a) continue;
    let O = k.sides?.find(({ sideNumber: B }) => k.winningSide && B === 3 - k.winningSide), _ = k.sides?.find(({ sideNumber: B }) => k.winningSide && B === k.winningSide);
    if (k.sides?.forEach((B) => {
      let L = B?.participant?.participantId;
      L && (v[L] = B.participant, k.matchUpStatus === Mt && !u && (P[L] = B.participant, S[L] || (S[L] = 0), (!k.matchUpStatus || !e.includes(k.matchUpStatus)) && (S[L] += 1)));
    }), O?.participant) {
      let B = O.participant.participantId;
      P[B] = O.participant, S[B] || (S[B] = 0), k.matchUpStatus && !e.includes(k.matchUpStatus) && (S[B] += 1);
    }
    if (_?.participant) {
      let B = _.participant.participantId;
      D[B] || (D[B] = 0), D[B] += 1, S[B] || (S[B] = 0), k.matchUpStatus && !e.includes(k.matchUpStatus) && (S[B] += 1);
    }
  }
  let w = o?.participants && !u && !l && d, b = w ? ((t && m ? m.entries : s.entries) ?? []).filter((k) => ![Pn, di].includes(k.entryStatus)).map(({ participantId: k }) => k) : [], T = Object.keys(P), R = w ? (o?.participants ?? []).filter(({ participantId: k }) => b.includes(k)) : l && Object.values(P) || Object.values(v), M = (k) => !l || T.includes(k), E = (k) => !u || (S[k] || 0) >= 0, A = (k) => !p || (D[k] || 0) <= p, N = (k) => !c || S[k] <= c, C = (k) => !U.includes(k);
  return { eligibleParticipants: R.filter((k) => M(k.participantId) && E(k.participantId) && A(k.participantId) && N(k.participantId) && C(k.participantId)).map((k) => ({ ...k, individualParticipants: k.individualParticipantIds?.map((O) => o?.participants?.find((_) => _.participantId === O)) })), losingParticipantIds: T, ...x };
}
function Fp(e) {
  let t = oe(e, [{ drawDefinition: !0 }]);
  if (t.error) return t;
  let { drawDefinition: r, roundNumber: i } = e, n = e.structureId ?? (r.structures?.length === 1 && r.structures?.[0]?.structureId);
  if (typeof n != "string") return { error: Qr };
  let a = r.structures?.find((f) => f.structureId === n);
  if (!a) return { error: mt };
  let o, s = (a.matchUps ?? [])?.reduce((f, h) => (h.roundPosition && (o = !0), (h?.roundNumber || 0) > f ? h.roundNumber : f), 0);
  if (a.structures || o || a.finishingPosition === Fo) return { error: $a };
  let c = r?.entries?.filter((f) => {
    let h = f.entryStatus;
    return Ni.includes(h);
  }) ?? [], u = Math.floor(c?.length / 2) || 1, l = i ?? s ?? 1, d = a.matchUps?.filter((f) => f.roundNumber === l)?.length ?? 0, p = u - d, m = p > 0 ? p : 0;
  return { ...x, availableMatchUpsCount: m, lastRoundNumber: s, roundMatchUpsCount: u };
}
function TI({ drawDefinition: e }) {
  let t = we({ name: "participantRepresentatives", element: e });
  return t.error ? t : { representativeParticipantIds: t.extension?.value || [] };
}
function Xx({ tournamentParticipants: e, drawDefinition: t, event: r }) {
  if (!t) return { error: ne };
  let i = Et({ tournamentParticipants: e, inContext: !0, drawDefinition: t, event: r }), n = ie(i.matchUps, !1, !0), a = Ue(n.reduce((s, c) => s.concat(...c.sides.map((u) => u.participantId).filter(Boolean)), [])), o = Object.assign({}, ...a.map((s) => {
    let c = n.filter((u) => u.sides.map((l) => l.participantId).filter(Boolean).includes(s));
    return { [s]: c };
  }));
  return { participantIds: a, participantIdMatchUps: o };
}
function bI({ byeAdvancements: e = !1, tournamentRecord: t, drawDefinition: r }) {
  if (!r) return { error: ne };
  let { participantIds: i, participantIdMatchUps: n } = Xx({ tournamentParticipants: t?.participants, drawDefinition: r }), a = i?.map((o) => {
    let s = n[o].filter((d) => [vt, "BYE"].includes(d.matchUpStatus) || d.winningSide), c = s.map((d) => {
      let p = d.sides.find((f) => f.bye), m = d.sides.find((f) => f.participantId === o).sideNumber;
      return (d.winningSide || e && p && m) === m ? d.finishingPositionRange.winner : d.finishingPositionRange.loser;
    }), u = (d) => Math.abs(d[0] - d[1]), l = c.reduce((d, p) => d && u(d) < u(p) ? d : p, void 0);
    return { [o]: { relevantMatchUps: s, finishingPositionRanges: c, finishingPositionRange: l } };
  }) || [];
  return Object.assign({}, ...a);
}
function Ua({ tournamentRecords: e, tournamentRecord: t, tournamentId: r, drawId: i }) {
  if (!t && !e) return { error: J };
  if (!i) return { error: Vi };
  if (!t && e) {
    if (typeof r != "string" && (r = lb({ tournamentRecords: e, drawId: i }), !r)) return { error: Is };
    if (t = e[r], !t) return { error: J };
  }
  let n = t && br({ tournamentRecord: t, drawId: i });
  return n?.drawDefinition ? { drawDefinition: n.drawDefinition, event: n.event, tournamentRecord: t, ...x } : F({ result: { error: zr }, stack: "findDrawDefinition" });
}
function MI(e) {
  let { drawDefinition: t, error: r } = Ua(e);
  return r ? { error: r } : { drawDefinition: ie(t) };
}
function Jx({ tournamentParticipants: e, returnParticipants: t, drawPosition: r, participant: i, drawId: n, event: a }) {
  let o = a?.entries?.filter(({ entryStatus: s }) => [di, Xa].includes(s)).map(({ participantId: s }) => s) || [];
  if (o.length) {
    let s = i.individualParticipantIds, c = t ? e.filter(({ participantId: l }) => o.includes(l)) : void 0, u = t ? e.filter(({ participantId: l }) => s.includes(l)) : void 0;
    return { validModifyAssignedPairAction: ae({ payload: { participantId: i.participantId, replacementIndividualParticipantId: void 0, existingIndividualParticipantId: void 0, drawPosition: r, drawId: n }, method: ux, availableIndividualParticipantIds: o, availableIndividualParticipants: c, existingIndividualParticipantIds: s, existingIndividualParticipants: u, type: sI }, !1, !1, !0) };
  }
  return {};
}
function Ba(e) {
  let { inContextDrawMatchUps: t, targetData: r, drawDefinition: i, relevantLink: n, matchUpStatus: a, score: o, winningSide: s } = e;
  if (n?.linkCondition === Qi && r?.matchUp?.matchUpStatus === "BYE") return !1;
  let { targetMatchUps: { loserMatchUp: c, winnerMatchUp: u }, targetLinks: l } = r, d = c && Ur({ matchUpId: c.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), p = d?.targetMatchUps?.loserMatchUp, m = d?.targetMatchUps?.loserMatchUpDrawPositionIndex, f = p?.sides[m]?.participant, h = [Pe, be].includes(c?.matchUpStatus) && !f, g = c?.sides?.reduce((D, y) => y?.participant ? ++D : D, 0) ?? 0, I = c?.winningSide && [Pe, be].includes(c?.matchUpStatus) && f && g === 1, U = a === Dt && o?.scoreStringSide1 === "" && o?.scoreStringSide2 === "" && !s, S = u?.drawPositions?.filter(Boolean).length || 0;
  if (I && U || !I && (c?.winningSide && !h || u?.winningSide && S === 2 && (!u.feedRound || ![be, Pe].includes(u?.matchUpStatus)))) return !0;
  let P = u && Ur({ matchUpId: u.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), v = d && Ba({ relevantLink: l?.loserTargetLink, targetData: d, inContextDrawMatchUps: t, drawDefinition: i });
  return !!(P && Ba({ targetData: P, inContextDrawMatchUps: t, drawDefinition: i }) || v);
}
var Db = { [vn]: { policyName: "positionActionsDefault", enabledStructures: [{ stages: [se, re], stageSequences: [1], enabledActions: [], disabledActions: [] }, { stages: [], stageSequences: [], enabledActions: [tu, bo, Np, mo], disabledActions: [] }], disbledStructures: [], otherFlightEntries: !1, activePositionOverrides: [] } }, jl = "positionAction", Of = "matchUpAction";
function wb({ actionType: e = jl, appliedPolicies: t, drawDefinition: r, structure: i }) {
  let n = e === jl && vn || e === Of && Yt, a = e === jl && Db || e === Of && rT, o = n && (t?.[n] || a?.[n]), s = r.links?.filter((d) => d?.target?.structureId === i?.structureId)?.map(({ target: d }) => d.feedProfile) ?? [], { enabledStructures: c, disabledStructures: u } = o || {}, l = u?.find((d) => {
    let { stages: p, stageSequences: m, structureTypes: f, feedProfiles: h } = d;
    return (!h?.length || Array.isArray(h) && h.some((g) => s.includes(g))) && (!p?.length || Array.isArray(p) && p?.includes(i?.stage)) && (!f?.length || Array.isArray(f) && f?.includes(i?.structureType)) && (!m?.length || Array.isArray(m) && m.includes(i?.stageSequence));
  });
  return { enabledStructures: c, actionsDisabled: l, actionsPolicy: o };
}
function ly({ activePositionOverrides: e, activeDrawPositions: t, action: r }) {
  return r && e.includes(r) ? !0 : !t.length;
}
function Tb({ enabledStructures: e, drawDefinition: t, structure: r }) {
  if (e === !1) return {};
  if (!e?.length) return { policyActions: { enabledActions: [], disabledActions: [] } };
  let { stage: i, stageSequence: n, structureType: a } = r || {}, o = t.links?.filter((s) => s?.target?.structureId === r?.structureId)?.map(({ target: s }) => s.feedProfile) || [];
  return { policyActions: e.find((s) => {
    let { stages: c, stageSequences: u, structureTypes: l, feedProfiles: d } = s || {}, p = !c?.length || Array.isArray(c) && c.includes(i), m = !u?.length || Array.isArray(u) && u.includes(n), f = !l?.length || Array.isArray(l) && l.includes(a), h = !d?.length || Array.isArray(d) && d.some((g) => o.includes(g));
    return m && f && h && s && p;
  }) };
}
function Rr({ action: e, policyActions: t }) {
  let r = !t?.enabledActions || t?.disabledActions?.length && t.disabledActions.includes(e);
  return r ? !1 : (t?.enabledActions.length === 0 || t?.enabledActions.includes(e)) && !r;
}
var bb = "replaceTieMatchUpParticipantId", Mb = "assignTieMatchUpParticipantId", kf = "removeTieMatchUpParticipantId", dy = "assignMatchUpSideParticipant", Zx = "removeMatchUpSideParticipant", Rb = "substituteParticipant", xf = "REMOVE_SUBSTITUTION", Nb = "REPLACE_PARTICIPANT", RI = "REMOVE_PARTICIPANT", Ff = "setMatchUpStatus", Lf = "SUBSTITUTION", Eb = "SCHEDULE", eF = "PENALTY", _f = "REFEREE", Ab = "STATUS", Bf = "START", Cb = "SCORE", tF = { REPLACE_TEAM_POSITION_METHOD: bb, ASSIGN_TEAM_POSITION_METHOD: Mb, REMOVE_TEAM_POSITION_METHOD: kf, REPLACE_PARTICIPANT: Nb, SUBSTITUTION_METHOD: Rb, REMOVE_SUBSTITUTION: xf, REMOVE_PARTICIPANT: RI, SCHEDULE_METHOD: Ff, SUBSTITUTION: Lf, SCHEDULE: Eb, PENALTY: eF, REFEREE: _f, STATUS: Ab, SCORE: Cb, START: Bf, END: "END" };
function rF({ specifiedPolicyDefinitions: e, inContextDrawMatchUps: t, matchUpParticipantIds: r, matchUpActionsPolicy: i, inContextMatchUp: n, policyActions: a, enforceGender: o, participantId: s, sideNumber: c, matchUpId: u, matchUp: l, drawId: d, side: p }) {
  let m = [], f = n.sides?.find((A) => A.participant), h = n.gender === vr && n.sideNumber && n.sides?.filter((A) => A.particiapntId).length === 1 && f?.participant?.person?.sex, g = n.matchUpType, I = (o ?? i?.participants?.enforceGender) !== !1 ? n.gender : void 0, U = n.sides?.flatMap((A) => A.participant?.individualParticipants || A.participant).filter(Boolean)?.map(Re), S = n.sides?.filter((A) => !c || A.sideNumber === c).flatMap((A) => A.participant?.individualParticipants || A.participant).filter(Boolean), P = S?.map(Re), v = t?.find((A) => A.matchUpId === n.matchUpTieId)?.sides?.map((A) => A?.participant?.individualParticipants?.filter(({ participantId: N, person: C }) => !P?.includes(N) && (!I || I === "ANY" || C.sex === I || I === vr && !h || h && C.sex !== h))), D = c ? v?.[c - 1] : v?.map((A, N) => ({ participants: A, sideNumber: N + 1 })), y = c ? v?.[c - 1]?.map(Re) : v?.map((A, N) => ({ participants: A?.map(Re), sideNumber: N + 1 })), w = c && (bt(so)(g) && !P?.length || bt(Ma)(g) && (P?.length ?? 0) < 2) || !c && (bt(so)(g) && (P?.length ?? 0) < 2 || bt(Ma)(g) && (P?.length ?? 0) < 4), b = y?.filter((A) => !U?.includes(A)), T = D?.filter(({ participantId: A }) => b.includes(A));
  if (w && b?.length && m.push({ availableParticipantIds: b, method: Mb, availableParticipants: T, type: To, payload: { participantId: void 0, tieMatchUpId: u, sideNumber: c, drawId: d } }), P?.length && (!Bt(l) || p?.substitutions?.length) && m.push({ method: kf, type: RI, existingParticipantIds: P, payload: { participantId: void 0, tieMatchUpId: u, drawId: d } }), T?.length && (!c && P?.length || c && p?.participant) && m.push({ availableParticipantIds: b, method: bb, availableParticipants: T, type: Nb, existingParticipantIds: P, payload: { existingParticipantId: void 0, participantId: void 0, tieMatchUpId: u, drawId: d } }), Rr({ policyActions: a, action: xf }) && p?.substitutions?.length) {
    let A = p.participant?.participantType === Ne && [p.participantId] || p.participant?.participantType === De && p.participant.individualParticipantIds || [], N = p.substitutions.map((C) => C.participantId).filter((C) => A.includes(C));
    (!s || N.includes(s)) && m.push({ method: kf, type: xf, substitutedParticipantIds: N, payload: { participantId: void 0, tieMatchUpId: u, drawId: d } });
  }
  let R = e?.[Yt], M = R?.substituteWithoutScore, E = R?.substituteAfterCompleted;
  if (Rr({ policyActions: a, action: Lf }) && r.length === 2 && (!c && P?.length || c && p?.participant) && (M || Bt(l)) && (E || l.matchUpStatus && !Lt.includes(l.matchUpStatus)) && S?.length && D.length) {
    let A = S.map(Re);
    m.push({ info: "list of team players available for substitution", method: Rb, availableParticipantIds: y, existingParticipantIds: A, availableParticipants: D, existingParticipants: S, type: Lf, payload: { substituteParticipantId: void 0, existingParticipantId: void 0, sideNumber: c, matchUpId: u, drawId: d } });
  }
  return m;
}
function iF({ tournamentParticipants: e = [], possiblyDisablingAction: t, activeDrawPositions: r, positionAssignments: i, returnParticipants: n, appliedPolicies: a, drawDefinition: o, drawPosition: s, validActions: c, structureId: u, structure: l, drawId: d, event: p }) {
  if (r.includes(s)) return {};
  let m = c.find((y) => y.type === To)?.availableParticipantIds, f = a?.[vn]?.otherFlightEntries, h = a?.[vn]?.restrictQualifyingAlternates, g = (o.entries ?? []).filter(({ entryStage: y }) => !h || (l.stage === se ? y === se : y !== se)).sort((y, w) => (y.entryPosition ?? 1 / 0) - (w.entryPosition ?? 1 / 0)).map(({ participantId: y }) => y).filter(Boolean), { allPositionedParticipantIds: I } = uw({ drawDefinition: o }), U = i.map((y) => y.participantId).filter(Boolean), S = g.filter((y) => l.stage && [se, re, yt].includes(l.stage) ? !I?.includes(y) : !U.includes(y)), P = (p?.entries ?? []).filter((y) => y.entryStatus === vi && Ob({ restrictQualifyingAlternates: h, structure: l, entry: y }) && (l.stage && [se, re, yt].includes(l.stage) ? !I?.includes(y.participantId) : !U.includes(y.participantId))).sort((y, w) => (y.entryPosition ?? 1 / 0) - (w.entryPosition ?? 1 / 0)).map((y) => y.participantId), v = Ue(S.concat(P));
  if (f) {
    let y = (p ? wt({ event: p }).flightProfile : void 0)?.flights?.filter((w) => w.drawId !== d).map((w) => w.drawEntries.filter((b) => b.participantId && ![Pn, di, Xa].includes(b.entryStatus) && !g.includes(b.participantId)).map(({ participantId: b }) => b)).flat().filter(Boolean);
    y?.length && v.push(...y);
  }
  m?.length && (v = v.filter((y) => !m.includes(y)));
  let D = n ? e?.filter((y) => v.includes(y.participantId)) : void 0;
  return D?.forEach((y) => {
    let w = (o.entries ?? []).find((b) => b.participantId === y.participantId);
    y.entryPosition = w?.entryPosition;
  }), D?.sort((y, w) => (y.entryPosition || 1 / 0) - (w.entryPosition || 1 / 0)), v.length ? { validAlternatesAction: ae({ payload: { drawId: d, structureId: u, drawPosition: s }, willDisableLinks: t, method: sx, availableAlternatesParticipantIds: v, type: cI, availableAlternates: D }) } : {};
}
function Ob({ restrictQualifyingAlternates: e, structure: t, entry: r }) {
  let { stage: i } = t;
  if (!r.entryStage || r.entryStage === i || i === se && !e || r.entryStage === re && i === nr) return !0;
}
function nF({ eventEntries: e, structure: t }) {
  let r = (n) => n.entryStatus === vi && Ob({ structure: t, entry: n }), i = (n, a) => (n.entryPosition || 1 / 0) - (a.entryPosition || 1 / 0);
  return e.filter(r).sort(i).map(Re);
}
function aF({ restrictAdHocRoundParticipants: e, tournamentParticipants: t, matchUpParticipantIds: r, otherFlightEntries: i, drawDefinition: n, structureId: a, sideNumber: o, matchUpId: s, structure: c, matchUp: u, drawId: l, event: d }) {
  let p = [], m = c?.matchUps ?? [], f = u.sides?.find((w) => w.sideNumber === o)?.participantId, h = m.filter(({ roundNumber: w }) => w === u.roundNumber), g = n?.entries?.filter(({ entryStatus: w }) => w && Ja.includes(w)).map(Re) ?? [], I = h.map((w) => (w.sides ?? []).flatMap(Re)).flat().filter(Boolean), U = g.filter((w) => !r.includes(w) && (!e || !I.includes(w))), S = t?.filter((w) => U?.includes(w.participantId)).map((w) => ie(w, void 0, !0));
  S?.forEach((w) => {
    let b = (n.entries ?? []).find((T) => T.participantId === w.participantId);
    w.entryPosition = b?.entryPosition;
  }), U.length && p.push({ payload: { drawId: l, matchUpId: s, structureId: a, sideNumber: o }, method: dy, type: To, availableParticipantIds: U, participantsAvailable: S });
  let P = d?.entries ?? [], v = nF({ eventEntries: P, structure: c }), D = Ue(g.concat(v));
  if (i) {
    let w = (d ? wt({ event: d }) : void 0)?.flights?.filter((b) => b.drawId !== l).flatMap((b) => b.drawEntries.filter((T) => T.participantId && ![Pn, di, Xa].includes(T.entryStatus)).map(({ participantId: T }) => T)).filter(Boolean);
    w?.length && D.push(...w);
  }
  D = D.filter((w) => !r.includes(w) && !U.includes(w) && (!e || !I.includes(w)));
  let y = t?.filter((w) => D.includes(w.participantId)).map((w) => ie(w, void 0, !0));
  if (y?.forEach((w) => {
    let b = (n.entries ?? []).find((T) => T.participantId === w.participantId);
    w.entryPosition = b?.entryPosition;
  }), y?.sort((w, b) => (w.entryPosition || 1 / 0) - (b.entryPosition || 1 / 0)), D.length && p.push({ payload: { drawId: l, matchUpId: s, structureId: a, sideNumber: o }, availableParticipantIds: D, participantsAvailable: y, method: dy, type: vi }), !Bt(u) && o && f) {
    p.push({ payload: { drawId: l, matchUpId: s, structureId: a, sideNumber: o }, method: Zx, type: RI });
    let w = (C) => C.sides.map(Re), b = ({ matchUpId: C }) => C !== u.matchUpId, T = (C) => !Bt(C), R = u.sides?.find((C) => C.sideNumber !== o)?.participantId, M = m.filter(({ roundNumber: C }) => C !== u.roundNumber).filter(b).map(w), E = [R, ...M.filter((C) => C.includes(f)).flat()].filter(Boolean), A = (C) => !E.flat().includes(C), N = h.filter(T).filter(b).map(w).flat().filter(A);
    if (N.length) {
      let C = t?.filter((k) => N.includes(k.participantId)).map((k) => ie(k, void 0, !0));
      p.push({ payload: { participantIds: [f], roundNumber: u.roundNumber, structureId: a, sideNumber: o, matchUpId: s, drawId: l }, swappableParticipantIds: N, method: lx, type: Ep, swappableParticipants: C });
    }
  }
  return p;
}
function Lp(e) {
  if (!e) return { error: z };
  let { drawDefinition: t, event: r } = e, { restrictAdHocRoundParticipants: i = !0, policyDefinitions: n, enforceGender: a, participantId: o, sideNumber: s, matchUpId: c } = e, u = e.tournamentRecord ?? (e.tournamentId && dt(e.tournamentId) && e.tournamentRecords?.[e.tournamentId]);
  if (!u) return { error: J };
  if (!c || !dt(c)) return { error: pr };
  if (s && ![1, 2].includes(s)) return F({ result: { error: z }, context: { sideNumber: s } });
  if (!t) {
    let W = (Jt({ tournamentRecord: u }).matchUps ?? []).find((Q) => Q.matchUpId === c);
    r = (u?.events ?? []).find((Q) => Q.eventId === W?.eventId);
    let K = (r?.drawDefinitions ?? []).find((Q) => Q.drawId === W?.drawId);
    K && (t = K);
  }
  if (!t) return { error: ne };
  let l = ft({ withIndividualParticipants: !0, tournamentRecord: u }).participants, { drawId: d } = t, { matchUp: p, structure: m } = ut({ drawDefinition: t, matchUpId: c, event: r });
  if (!p) return { error: cr };
  let f = _e({ tournamentRecord: u, drawDefinition: t, structure: m, event: r }).appliedPolicies ?? {};
  Object.assign(f, n ?? {});
  let h = f?.[vn]?.otherFlightEntries, g = f?.[Yt] ?? nc[Yt], { enabledStructures: I } = wb({ actionType: Of, appliedPolicies: f, drawDefinition: t, structure: m }), { policyActions: U } = Tb({ enabledStructures: I, drawDefinition: t, structure: m }), S = e.matchUpsMap ?? or({ drawDefinition: t }), P = e.inContextDrawMatchUps ?? Et({ tournamentParticipants: l, inContext: !0, drawDefinition: t, matchUpsMap: S, event: r }).matchUps, v = P?.find((W) => W.matchUpId === c), D = s && v?.sides?.find((W) => W.sideNumber === s), y = v?.sides?.map((W) => W.participantId || W.participant?.participantid).filter(Boolean) ?? [], { assignedPositions: w, allPositionsAssigned: b } = _t({ structure: m }), { structureId: T } = m ?? {}, R = [];
  if (!T) return { validActions: R };
  let M = Tr({ structure: m }), E = !!p.collectionId;
  if (M && !E) {
    let W = aF({ restrictAdHocRoundParticipants: i, tournamentParticipants: l, matchUpParticipantIds: y, otherFlightEntries: h, drawDefinition: t, structureId: T, sideNumber: s, matchUpId: c, structure: m, matchUp: p, drawId: d, event: r });
    R.push(...W);
  }
  let A = wn({ drawDefinition: t, structure: m }), N = w?.filter((W) => W.participantId).map((W) => W.drawPosition), C = w?.filter((W) => W.bye).map((W) => W.drawPosition), k = p.matchUpStatus === "BYE" || !E && p.drawPositions?.reduce((W, K) => C?.includes(K) || W, !1);
  if (k) return { validActions: R, isByeMatchUp: k };
  Rr({ policyActions: U, action: _f }) && R.push({ type: _f, payload: { matchUpId: c } });
  let O = !Wu({ matchUpStatus: p.matchUpStatus }), _ = f?.scoring?.structures, B = m?.stage && _?.stage && _?.stage[m.stage], L = m?.stageSequence && B?.stageSequence && B.stageSequence[m.stageSequence], j = !(f?.scoring?.requireAllPositionsAssigned || B?.requireAllPositionsAssigned || L?.requireAllPositionsAssigned) || b, H = p.sides && p.sides.filter((W) => W?.participantId).length === 2, G = p.matchUpStatus && [Mt, xt].includes(p.matchUpStatus), V = Ur({ inContextDrawMatchUps: P, drawDefinition: t, matchUpId: c }), $ = Ba({ inContextDrawMatchUps: P, drawDefinition: t, targetData: V }), q = (v?.drawPositions?.length === 2 && v.drawPositions.every((W) => N?.includes(W)) && v?.sides?.length === 2 && v.sides.every(({ participantId: W }) => W) || H) && !(G && $), Y = { method: jT, type: bo, payload: { drawId: d, matchUpId: c, penaltyCode: void 0, penaltyType: void 0, participantIds: [], notes: void 0 } };
  if (O && R.push({ payload: { drawId: d, matchUpId: c, schedule: {} }, method: Ff, type: Eb }), Rr({ policyActions: U, action: bo }) && (D?.participant || !s && y?.length) && R.push(Y), O && q && R.push({ type: Ab }), j && q) {
    let { matchUpId: W, matchUpFormat: K } = p, Q = { drawId: d, matchUpId: W, matchUpFormat: K, outcome: { scoreStringSide1: void 0, scoreStringSide2: void 0, sets: [] }, winningSide: void 0 };
    R.push({ info: "set outcome and winningSide", method: Ff, type: Cb, payload: Q }), Rr({ policyActions: U, action: Bf }) && R.push({ type: Bf }), Rr({ policyActions: U, action: "END" }) && R.push({ type: "END" });
  }
  if (E && v) {
    let W = rF({ specifiedPolicyDefinitions: n, inContextDrawMatchUps: P, matchUpParticipantIds: y, matchUpActionsPolicy: g, inContextMatchUp: v, policyActions: U, enforceGender: a, participantId: o, sideNumber: s, matchUpId: c, matchUp: p, drawId: d, side: D });
    R.push(...W);
  }
  return { structureIsComplete: A, validActions: R, isDoubleExit: G, ...x };
}
function oF({ tournamentParticipants: e = [], sourceStructuresComplete: t, possiblyDisablingAction: r, isWinRatioFedStructure: i, activeDrawPositions: n, positionAssignments: a, drawDefinition: o, drawPosition: s, structureId: c, structure: u, drawId: l, event: d }) {
  if (n.includes(s) || i && !t) return {};
  let { sourceStructureIds: p, targetStructureIds: m } = o.links?.reduce((I, U) => {
    let S = U.source?.structureId, P = U.target?.structureId;
    return I.sourceStructureIds.includes(S) || I.sourceStructureIds.push(S), I.targetStructureIds.includes(P) || I.targetStructureIds.push(P), I;
  }, { sourceStructureIds: [], targetStructureIds: [] }) || {}, f = [], h = o.links?.filter((I) => I.target?.structureId === u.structureId) ?? [];
  for (let I of h) {
    let U = I?.source?.structureId, { structure: S } = me({ structureId: U, drawDefinition: o }), P = S?.finishingPosition === Fo && (p?.length !== 1 || m?.length !== 1), v = {};
    if (P) {
      let { matchUps: w } = Ve({ drawDefinition: o, structure: u, event: d }), { initialRoundNumber: b } = wo({ drawPosition: s, matchUps: w }), T = o.links?.find((R) => R.target?.structureId === u?.structureId && R.target.roundNumber === b)?.source?.roundNumber;
      v.roundNumbers = [T];
    }
    let { completedMatchUps: D } = Pp({ structureId: U, inContext: !0, matchUpFilters: v, drawDefinition: o }), y = a.map((w) => w.participantId).filter(Boolean);
    D?.filter(({ matchUpType: w, winningSide: b }) => b && (d?.eventType !== kt || w === kt)).map(({ winningSide: w, sides: b }) => w && b?.[1 - (w - 1)]).map(Re).filter((w) => w && !y.includes(w))?.forEach((w) => {
      f.includes(w) || f.push(w);
    });
  }
  let g = e?.filter((I) => f?.includes(I.participantId));
  return g?.forEach((I) => {
    let U = (o.entries ?? []).find((S) => S.participantId === I.participantId);
    I.entryPosition = U?.entryPosition;
  }), f?.length ? { validLuckyLosersAction: { type: lI, method: cx, availableLuckyLosers: g, availableLuckyLoserParticipantIds: f, willDisableLinks: r, payload: { drawId: l, structureId: c, drawPosition: s } } } : {};
}
function sF({ positionSourceStructureIds: e, unassignedParticipantIds: t, possiblyDisablingAction: r, provisionalPositioning: i, tournamentParticipants: n, isWinRatioFedStructure: a, positionAssignments: o, returnParticipants: s, appliedPolicies: c, drawDefinition: u, seedingProfile: l, isByePosition: d, drawPosition: p, structureId: m, event: f }) {
  let { drawId: h } = u, g = [], I, U, S = [], P = c?.[hi]?.validSeedPositions?.ignore;
  if (P || ({ unplacedSeedParticipantIds: I, unplacedSeedAssignments: U, unfilledPositions: S } = hT({ provisionalPositioning: i, returnAllProxies: !0, randomize: !0, drawDefinition: u, seedingProfile: l, structureId: m })), S?.length || (S = o.filter((v) => !v.participantId && !v.bye && !v.qualifier).map((v) => v.drawPosition)), d || g.push({ payload: { drawId: h, structureId: m, drawPosition: p, isPositionAction: !0 }, willDisableLinks: r, method: mx, type: "BYE" }), a && P) {
    let v = o.map((T) => T.participantId).filter(Boolean), D = { structureIds: e }, { completedMatchUps: y } = rc({ inContext: !0, matchUpFilters: D, drawDefinition: u }), w = Ue((y ?? []).filter(({ matchUpType: T }) => f?.eventType !== kt || T === kt)?.map(({ sides: T }) => T?.map(Re)).flat().filter((T) => T && !v.includes(T))), b = s ? n?.filter((T) => w?.includes(T.participantId)).map((T) => ie(T, void 0, !0)) : void 0;
    return b?.forEach((T) => {
      let R = (u.entries ?? []).find((M) => M.participantId === T.participantId);
      T.entryPosition = R?.entryPosition;
    }), b?.length && g.push(ae({ payload: { drawId: h, structureId: m, drawPosition: p }, willDisableLinks: r, method: ry, type: To, availableParticipantIds: w, participantsAvailable: b })), { validAssignmentActions: g };
  }
  if (S.includes(p) || d) {
    let v;
    if (U?.length) {
      let y = U.filter((w) => I?.includes(w.participantId));
      y.sort(cF), v = y.map((w) => w.participantId);
    } else v = t;
    let D = s ? n?.filter((y) => v.includes(y.participantId)).map((y) => ie(y, void 0, !0)) : void 0;
    D?.length && g.push(ae({ payload: { drawId: h, structureId: m, drawPosition: p }, willDisableLinks: r, method: ry, type: To, availableParticipantIds: v, participantsAvailable: D }));
  }
  return { validAssignmentActions: g };
}
function cF(e, t) {
  return e.bye || Os(e.seedValue) < Os(t.seedValue) || e.seedValue && !t.seedValue ? -1 : (e.seedNumber || 0) - (t.seedNumber || 0);
}
function uF({ drawPositionInitialRounds: e, tournamentParticipants: t, positionAssignments: r, returnParticipants: i, appliedPolicies: n, drawDefinition: a, drawPosition: o, structureId: s, drawId: c }) {
  let u = [], l = [], d = [], p = [], m = r.map((v) => v.participantId).filter(Boolean), f = n?.[vn], h = !f?.disableRoundRestrictions && e[o], g = f?.requireCompletedStructures, { sourceStructureIds: I, relevantLinks: U } = eu({ targetRoundNumber: h, linkType: In, drawDefinition: a, structureId: s }) || {};
  I?.length && p.push(...I);
  let { sourceStructureIds: S, relevantLinks: P } = eu({ targetRoundNumber: h, linkType: gn, drawDefinition: a, structureId: s }) || {};
  S?.length && p.push(...S);
  for (let v of U) {
    let D = a.structures?.find((w) => w.structureId === v.source.structureId);
    if (D?.stage !== se) continue;
    let y = wn({ structureId: v.source.structureId, drawDefinition: a });
    if (!g || y) {
      let w = D.qualifyingRoundNumber, { matchUps: b } = Ve({ matchUpFilters: { roundNumbers: [w], isCollectionMatchUp: !1, hasWinningSide: !0 }, afterRecoveryTimes: !1, tournamentParticipants: t, inContext: !0, structure: D });
      for (let T of b) {
        let R = T.sides.find((E) => E?.sideNumber === T.winningSide), M = T.matchUpStatus === "BYE" && T.sides?.find(({ participantId: E }) => E);
        if (R || M) {
          let { participantId: E, participant: A } = R || M || {};
          E && !m.includes(E) && (A && i && u.push(A), l.push(E));
        }
      }
    }
  }
  for (let v of P) {
    let D = a.structures?.find((w) => w.structureId === v.source.structureId);
    if (D?.stage !== se) continue;
    let y = wn({ structureId: v.source.structureId, drawDefinition: a });
    if (!g || y) {
      let { positionAssignments: w } = Je({ structure: D }), b = w?.map((T) => {
        let R = T.participantId, M = we({ element: T, name: _n }).extension?.value;
        return M ? { participantId: R, groupOrder: M?.groupOrder } : {};
      }).filter(({ groupOrder: T, participantId: R }) => T === 1 && !m.includes(R)).map(({ participantId: T }) => T) ?? [];
      if (b && l.push(...b), i) {
        let T = t.filter(({ participantId: R }) => b.includes(R));
        u.push(...T);
      }
    }
  }
  return l.length && d.push(ae({ qualifyingParticipants: i ? u : void 0, method: ax, type: Np, qualifyingParticipantIds: l, payload: { qualifyingParticipantId: void 0, drawPosition: o, structureId: s, drawId: c } })), { validAssignmentActions: d, sourceStructureIds: p };
}
function lF({ onlyAssignedPositions: e = !0, possiblyDisablingAction: t, tournamentParticipants: r, inactiveDrawPositions: i, activeDrawPositions: n, positionAssignments: a, returnParticipants: o, byeDrawPositions: s, drawDefinition: c, isByePosition: u, drawPosition: l, structureId: d, structure: p, drawId: m, event: f }) {
  if (n.includes(l)) return {};
  let h = (T) => !e || T.participantId || T.qualifier || T.bye, g = i?.filter((T) => T !== l && !(u && s.includes(T))), I = a?.filter((T) => h(T) && g?.includes(T.drawPosition)) ?? [], U = I.map(({ drawPosition: T }) => T), { matchUps: S } = Ve({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: c, structure: p, event: f }), P = S.filter(({ drawPositions: T }) => gr(T, U)), v = Object.assign({}, ...P.map((T) => T.sides?.filter(({ sourceDrawPositionRange: R }) => R).map(({ drawPosition: R, sourceDrawPositionRange: M }) => ({ [R]: M }))).flat()), D = I.map((T) => T.participantId).filter(Boolean), y = (r ?? []).filter((T) => D.includes(T.participantId)), w = Object.assign({}, ...y.map((T) => ({ [T.participantId]: T }))), b = I.map((T) => {
    let R = w?.[T.participantId], M = v[T.drawPosition];
    return ae({ ...T, participant: o ? ie(R, !1, !0) : void 0, sourceDrawPositionRange: M });
  });
  return b.length ? { validSwapAction: { payload: { drawId: m, structureId: d, drawPositions: [l] }, willDisableLinks: t, method: VT, type: Ep, availableAssignments: b } } : {};
}
function NI(e) {
  let t = oe(e, [{ event: !0, drawDefinition: !0, structureId: !0 }]);
  if (t.error) return t;
  let { policyDefinitions: r, returnParticipants: i = !0, provisionalPositioning: n, tournamentRecord: a, drawDefinition: o, drawPosition: s, event: c } = e, u = e.tournamentParticipants ?? (a && ft({ withIndividualParticipants: !0, tournamentRecord: a }).participants) ?? [], l = me({ structureId: e.structureId, drawDefinition: o });
  if (l.error) return l;
  let d = l.containingStructure || l.structure;
  if (!d) return { error: mt };
  let p = d.structureId;
  if (l = Hu({ drawDefinition: o, structureId: p }), s === void 0 && !l.isAdHoc) return { error: js };
  if (l.isAdHoc) return Lp(e);
  if (l.error) return l;
  let { drawPositionInitialRounds: m, inactiveDrawPositions: f, activeDrawPositions: h, byeDrawPositions: g } = l, I = _e({ tournamentRecord: a, drawDefinition: o, structure: d, event: c }).appliedPolicies ?? {};
  Object.assign(I, r ?? {});
  let { actionsPolicy: U, enabledStructures: S, actionsDisabled: P } = wb({ actionType: jl, appliedPolicies: I, drawDefinition: o, structure: d }), v = U?.activePositionOverrides || [], { sourceStructureIds: D } = eu({ finishingPosition: Aa, targetRoundNumber: 1, linkType: gn, drawDefinition: o, structureId: p }) || {}, y;
  D?.length && (y = D.every((Y) => wn({ structureId: Y, drawDefinition: o })));
  let w = D.length, b = D.length && !y, { policyActions: T } = Tb({ enabledStructures: S, drawDefinition: o, structure: d }), R = ![se, re].includes(d.stage) || d.stageSequence !== 1, { drawId: M } = o, E = [], { assignedPositions: A, positionAssignments: N } = _t({ structure: d }), C = A?.find((Y) => Y.drawPosition === s), k = !!C;
  if (!N?.map((Y) => Y.drawPosition)?.includes(s)) return { error: Vs };
  let { stage: O, stageSequence: _ } = d, B = [O];
  O === nr && B.push(re), O === re && B.push(nr);
  let L = Bo({ entryStatuses: Ja, provisionalPositioning: n, drawDefinition: o, stageSequence: _, structureId: p, stages: B }), j = eo({ drawDefinition: o, stages: B }).assignedParticipantIds ?? [], H = L.filter((Y) => !j.includes(Y.participantId)).map((Y) => Y.participantId), G = g.includes(s), V = h.includes(s);
  if (P) return { info: "Actions Disabled for structure", isActiveDrawPosition: V, isDrawPosition: !0, hasPositionAssigned: k, validActions: [], isByePosition: G };
  if (Rr({ policyActions: T, action: To }) && !V && N && !b && (!C || G)) {
    let { validAssignmentActions: Y } = sF({ positionSourceStructureIds: D, unassignedParticipantIds: H, possiblyDisablingAction: R, isWinRatioFedStructure: w, tournamentParticipants: u, positionAssignments: N, returnParticipants: i, appliedPolicies: I, drawDefinition: o, isByePosition: G, drawPosition: s, structureId: p, event: c });
    Y?.forEach((W) => E.push(W));
  }
  if (Rr({ policyActions: T, action: Np }) && !V) {
    let { validAssignmentActions: Y } = uF({ drawPositionInitialRounds: m, tournamentParticipants: u, positionAssignments: N, returnParticipants: i, appliedPolicies: I, drawDefinition: o, drawPosition: s, structureId: p, drawId: M });
    Y?.forEach((W) => E.push(W));
  }
  let { participantId: $ } = C || {}, q = $ && u.find((Y) => Y.participantId === $);
  if (C) {
    Rr({ policyActions: T, action: Cf }) && !V && (E.push({ type: Cf, method: ty, payload: { drawId: M, structureId: p, drawPosition: s }, willDisableLinks: R }), G || E.push({ type: uI, method: ox, payload: { drawId: M, structureId: p, drawPosition: s }, willDisableLinks: R }), Rr({ policyActions: T, action: "BYE" }) && !G && E.push({ type: "BYE", method: ty, payload: { drawId: M, structureId: p, drawPosition: s, replaceWithBye: !0 }, willDisableLinks: R }));
    let Y = d.stage === se || d.stage === re && d.stageSequence === 1;
    if (!G && ly({ activePositionOverrides: v, activeDrawPositions: h, action: mo }) && Rr({ policyActions: T, action: mo }) && ud({ drawDefinition: o, structureId: p, drawPosition: s }) && Y) {
      let { seedAssignments: W } = si({ returnAllProxies: !0, drawDefinition: o, structure: d }), { seedNumber: K, seedValue: Q } = W?.find((X) => X.participantId === $) ?? {};
      E.push({ type: mo, method: fx, participant: q, seedNumber: K, payload: { drawId: M, structureId: p, participantId: $, seedValue: Q } });
    }
    if (!G && ly({ activePositionOverrides: v, activeDrawPositions: h, action: Ac }) && Rr({ policyActions: T, action: Ac }) && ud({ drawDefinition: o, structureId: p, drawPosition: s }) && Y) {
      let { seedAssignments: W } = si({ returnAllProxies: !0, drawDefinition: o, structure: d }), { seedNumber: K } = W?.find((Q) => Q.participantId === $) ?? {};
      E.push({ method: px, type: Ac, participant: q, seedNumber: K, payload: { participantId: $, structureId: p, drawId: M } });
    }
    if (!G && $) {
      if (Rr({ policyActions: T, action: bo })) {
        let W = { type: bo, method: jT, participant: q, payload: { penaltyCode: void 0, penaltyType: void 0, participantIds: [], notes: void 0, drawId: M } };
        E.push(W);
      }
      if (Rr({ policyActions: T, action: tu })) {
        let W = { type: tu, method: dx, participant: q, payload: { participantId: $, otherName: void 0 } };
        E.push(W);
      }
    }
    if (Rr({ policyActions: T, action: Ep })) {
      let { validSwapAction: W } = lF({ possiblyDisablingAction: R, tournamentParticipants: u, inactiveDrawPositions: f, activeDrawPositions: h, positionAssignments: N, returnParticipants: i, byeDrawPositions: g, drawDefinition: o, isByePosition: G, drawPosition: s, structureId: p, structure: d, drawId: M });
      W && E.push(W);
    }
  }
  if (Rr({ policyActions: T, action: cI }) && !b) {
    let { validAlternatesAction: Y } = iF({ possiblyDisablingAction: R, tournamentParticipants: u, positionAssignments: N, activeDrawPositions: h, returnParticipants: i, appliedPolicies: I, drawDefinition: o, drawPosition: s, validActions: E, structureId: p, structure: d, drawId: M, event: c });
    Y && E.push(Y);
  }
  if (Rr({ policyActions: T, action: lI }) && !b && !V && N) {
    let { validLuckyLosersAction: Y } = oF({ sourceStructuresComplete: y, possiblyDisablingAction: R, isWinRatioFedStructure: w, tournamentParticipants: u, activeDrawPositions: h, positionAssignments: N, drawDefinition: o, drawPosition: s, structureId: p, structure: d, drawId: M });
    Y && E.push(Y);
  }
  if (q?.participantType === De && Rr({ policyActions: T, action: sI })) {
    let { validModifyAssignedPairAction: Y } = Jx({ tournamentParticipants: u, returnParticipants: i, drawPosition: s, participant: q, drawId: M, event: c });
    Y && E.push(Y);
  }
  return { isActiveDrawPosition: V, isDrawPosition: !0, hasPositionAssigned: k, isByePosition: G, validActions: E, ...x };
}
function ul({ policyDefinitions: e, appliedPolicies: t, drawType: r }) {
  let i = e?.[ed]?.drawTypeCoercion, n = t?.[ed]?.drawTypeCoercion;
  return (typeof i == "boolean" ? i : void 0) ?? (r && i?.[r]) ?? (typeof n == "boolean" ? n : void 0) ?? (r && n?.[r]) ?? !0;
}
var EI = ({ drawDefinition: e }) => {
  let t = oe({ drawDefinition: e }, [{ [lr]: !0 }]);
  if (t.error) return t;
  let r = e.structures?.find((n) => n.stage === re && n.stageSequence === 1);
  if (!r) return F({ result: { error: ch } });
  let { qualifierPositions: i } = _t({ structure: r });
  return te(0, i.length).sort(() => Math.random() - 0.5);
};
function AI({ structureId: e, drawDefinition: t }) {
  if (!t) return { error: ne };
  if (!dt(e)) return { error: z };
  let r = tc({ drawDefinition: t, structureId: e });
  if (r.error) return r;
  let i = r.links.target.flatMap((a) => a.target.feedProfile).filter(Boolean), n = !Pt([Ea, Ii, Kd, Na], i).length;
  return { ...x, valid: n };
}
function ru({ tournamentRecord: e, drawDefinition: t, stage: r = re, structureId: i, structure: n }) {
  if (!e) return { error: J };
  if (!n && !t) return { error: ne };
  if (!n && !i && t?.structures?.filter((s) => s.stage === r).length === 1 && (n = t.structures.find((s) => s.stage === r)), !n && !i) return { error: Qr };
  let { error: a, positionAssignments: o } = Je({ drawDefinition: t, structureId: i, structure: n });
  return { positionAssignments: o ?? [], structureId: n?.structureId, error: a };
}
function kb({ participantsCount: e, participantCount: t }) {
  if (e = e ?? t, !e) return { error: z };
  let r = Bs(e);
  return r ? { drawSize: r } : F({ result: { error: z }, stack: "getEliminationDrawSize", context: { participantsCount: e } });
}
function ll(e) {
  let { drawSizeProgression: t = !1, policyDefinitions: r, drawSize: i } = e || {}, { requireParticipantCount: n = !0, tournamentRecord: a, drawDefinition: o, event: s } = e || {}, c = "getSeedsCount", u = e?.participantsCount ?? e?.participantCount;
  if (!r) {
    let f = Wn({ tournamentRecord: a, drawDefinition: o, event: s });
    if (f.error) return F({ result: f, stack: c });
    r = f.policyDefinitions;
  }
  let l = Ie(u);
  if (u && !l) return F({ result: { error: z }, context: { participantsCount: u }, stack: c });
  if (n && !l) return F({ result: { error: tP }, stack: c });
  if (isNaN(i)) if (u) ({ drawSize: i } = kb({ participantsCount: u }));
  else return F({ result: { error: mu }, stack: c });
  let d = n && u || i;
  if (d && d > i) return { error: Ih };
  let p = r?.[hi];
  if (!p) return { error: Gv };
  let m = p.seedsCountThresholds;
  return m ? (p.drawSizeProgression !== void 0 && (t = p.drawSizeProgression), { seedsCount: m.filter((f) => t ? f.drawSize <= i : i === f.drawSize).reduce((f, h) => u && u >= h.minimumParticipantCount ? h.seedsCount : f, 0) }) : { error: bv };
}
function _p({ consideredEntries: e, policyDefinitions: t, tournamentRecord: r, appliedPolicies: i, participantMap: n, enforceGender: a, participants: o, event: s }) {
  if ((!o || !n) && r && ({ participants: o, participantMap: n } = ft({ tournamentRecord: r })), !o) return { error: gu };
  if (!Array.isArray(o)) return { error: z };
  if (!s) return { error: st };
  let c = t?.[Yt] ?? i?.[Yt] ?? nc[Yt], u = (a ?? c?.participants?.enforceGender) !== !1, { eventType: l, gender: d } = s, p = l === xn, m = l === jr && We || p && De || Ne, f = Object.assign({}, ...(e ?? s.entries ?? []).map((I) => ({ [I.participantId]: I.entryStatus }))), h = Object.keys(f), g = o.filter((I) => h.includes(I.participantId)).filter((I) => {
    let U = dF({ participant: I, participantType: m, eventType: l, entryStatusMap: f }), S = pF({ genderEnforced: u, participantMap: n, eventGender: d, participant: I, isDoubles: p, mismatch: U });
    return U || !S;
  });
  if (g.length) {
    let I = g.map((U) => U.participantId);
    return { error: xv, invalidParticipantIds: I };
  }
  return { ...x, valid: !0 };
}
function dF({ participant: e, participantType: t, eventType: r, entryStatusMap: i }) {
  let n = i[e.participantId], a = r && [xn, jr].includes(r) && e.participantType === Ne && (Pa(n) || n === Pn);
  return e.participantType !== t && !a;
}
function pF(e) {
  let { participant: t, participantMap: r, eventGender: i, mismatch: n, isDoubles: a, genderEnforced: o } = e, s = !n && a && Ue(t?.individualParticipantIds?.map((d) => r?.[d]?.participant?.person?.sex).filter(Boolean) ?? []) || [], c = !i || !s?.length || i === "ANY" || [Ye, at].includes(i) && s[0] === i || vr === i && (s.length === 1 && t.individualParticipantIds?.length === 1 || s.length === 2), u = t?.person?.sex, l = !t?.person || !i || ["ANY", vr].includes(i) || [Ye, at].includes(i) && u === i;
  return !o || c && l;
}
function xb({ hasExistingDrawDefinition: e, qualifyingProfiles: t, appliedPolicies: r, qualifyingOnly: i, tieFormat: n, idPrefix: a, isMock: o, uuids: s }) {
  let c = "generateQualifyingSTructures", u = [], l = [], d = [], p = (U, S) => U.stageSequence - S.stageSequence, m = (U, S) => U.roundTarget - S.roundTarget, f = 0, h = 0, g, I = 1;
  for (let U of t.sort(m)) {
    let S = U.structureProfiles || [];
    I = U.roundTarget || I;
    let P = 1, v = 0, D, y, w;
    for (let b of (S || []).sort(p)) {
      let T = eh(b.drawSize || b.participantsCount), { qualifyingRoundNumber: R, structureOptions: M, matchUpFormat: E, structureName: A, structureId: N, drawType: C } = b, k = b.matchUpType, O = b.qualifyingPositions || mF({ drawSize: T, qualifyingRoundNumber: R }), _, B, L;
      if (!Ie(T)) return F({ result: { error: mu }, stack: c });
      let j = t.length > 1 ? `${I}-` : "", H = S.length > 1 || j ? P : "", G = A || (j || H ? `${ir(se)} ${j}${H}` : ir(se));
      if (C === Di) {
        let { structures: V, groupCount: $, maxRoundNumber: q } = Xu({ structureName: b.structureName || G, structureId: N || s?.pop(), hasExistingDrawDefinition: e, stage: se, structureOptions: M, appliedPolicies: r, qualifyingOnly: i, stageSequence: P, matchUpType: k, roundTarget: I, tieFormat: n, drawSize: T, idPrefix: a, isMock: o, uuids: s });
        v = $, _ = q, B = V[0], g = [1];
      } else ({ drawSize: T, matchUps: L, roundLimit: _ } = Zi({ qualifyingRoundNumber: R, qualifyingPositions: O, matchUpType: k, drawSize: T, idPrefix: a, isMock: o, uuids: s })), B = ii({ structureName: b.structureName || G, structureId: N || s?.pop(), qualifyingRoundNumber: _, hasExistingDrawDefinition: e, stage: se, qualifyingOnly: i, matchUpFormat: E, stageSequence: P, matchUpType: k, roundLimit: _, tieFormat: n, matchUps: L }), I && Be({ extension: { name: rn, value: I }, element: B }), v = L?.filter((V) => V.roundNumber === _)?.length || 0;
      if (P > 1) {
        let { link: V } = tl({ sourceStructureId: y, sourceRoundNumber: D, targetStructureId: B.structureId, finishingPositions: w === gn ? [1] : void 0, linkType: w });
        d.push(V), f += (T || 0) - v;
      } else f += T || 0;
      w = C === Di ? gn : In, y = B.structureId, D = _, n && (L = Ve({ structure: B })?.matchUps || [], L?.forEach((V) => {
        let { tieMatchUps: $ } = Xo({ tieFormat: n, matchUp: V, isMock: o });
        Object.assign(V, { tieMatchUps: $, matchUpType: k });
      })), l.push(B), P += 1;
    }
    h += v, u.push({ qualifiersCount: v, finalQualifyingRoundNumber: D, finalQualifyingStructureId: y, finishingPositions: g, roundTarget: I, linkType: w }), I += 1;
  }
  return { qualifiersCount: h, qualifyingDrawPositionsCount: f, qualifyingDetails: u, structures: l, ...x, links: d };
}
function mF({ drawSize: e, qualifyingRoundNumber: t }) {
  let r = e, i = 0;
  for (; i < t; ) r = Math.floor(r / 2), i += 1;
  return r;
}
function Fb(e) {
  let { drawTypeCoercion: t, enforceMinimumDrawSize: r } = e, i = pe(e.drawSize), n = t && e.drawType !== Gr && (typeof t == "boolean" || t <= 2) && i === 2 && Wi || e.drawType || Wi, a = kD.includes(n);
  if (i && a) {
    if (t && (typeof t == "boolean" && i < 4 || i <= t)) n = Wi;
    else if (i < 4 && r) return { ...F({ context: { enforceMinimumDrawSize: r, drawSize: i, drawType: n }, result: { error: Nd }, stack: "getCoercedDrawType" }), drawType: n };
  }
  return { drawType: n };
}
function fF(e) {
  let { drawDefinition: t, structureOptions: r, requireSequential: i } = e, n = { structureName: ir(re), ...e, stage: re }, { structures: a, groupCount: o } = Xu(n);
  if (o < 1) return { error: UP };
  let s = r?.playoffGroups || [{ finishingPositions: [1], structureName: ir(yt) }], [c] = a, { structures: u, links: l } = JT({ sourceStructureId: c.structureId, requireSequential: i, drawDefinition: t, playoffGroups: s, groupCount: o, ...e });
  return u && a.push(...u), { ...x, structures: a, links: l };
}
function hF({ mainStructure: e, consolationStructure: t, deciderStructure: r }) {
  let i = t.matchUps.reduce((u, l) => (l.drawPositions || []).filter(Boolean).length && !u.includes(l.roundNumber) ? u.concat(l.roundNumber) : u, []), n = e.matchUps.reduce((u, l) => !u || l.roundNumber > u ? l.roundNumber : u, void 0), a = t.matchUps.reduce((u, l) => !u || l.roundNumber > u ? l.roundNumber : u, void 0), o = i.map((u, l) => {
    let d = i.indexOf(u) % 2 ? Ii : Ea, p = 1 + l;
    return { linkType: Un, source: { roundNumber: p, structureId: e.structureId }, target: { feedProfile: d, roundNumber: u, structureId: t.structureId } };
  }), s = { linkType: In, source: { roundNumber: a, structureId: t.structureId }, target: { feedProfile: Ii, roundNumber: n, structureId: e.structureId } }, c = [{ linkType: In, source: { roundNumber: n, structureId: e.structureId }, target: { feedProfile: Ii, roundNumber: 1, structureId: r.structureId } }, { linkType: Un, source: { roundNumber: n, structureId: e.structureId }, target: { feedProfile: Ii, roundNumber: 1, structureId: r.structureId } }];
  return [...o, s, ...c];
}
function gF({ structureName: e, matchUpType: t, idPrefix: r, drawSize: i, isMock: n, uuids: a }) {
  let o = [], { matchUps: s } = ua({ linkFedFinishingRoundNumbers: [1], drawSize: i + 1, matchUpType: t, idPrefix: r, isMock: n }), c = ta({ structureName: e || ir(re), structureId: a?.pop(), stageSequence: 1, stage: re, matchUpType: t, matchUps: s });
  o.push(c);
  let u = i / 2, { matchUps: l } = ua({ finishingPositionOffset: u, idPrefix: r && `${r}-c`, drawSize: i - 1, isConsolation: !0, matchUpType: t, isMock: n, uuids: a }), d = ta({ structureName: ir(OD), matchUps: l, structureId: a?.pop(), stage: nr, stageSequence: 2, matchUpType: t });
  o.push(d);
  let { matchUps: p } = Zi({ idPrefix: r && `${r}-p1t2`, drawSize: 2, matchUpType: t, isMock: n }), m = ta({ structureName: ir(CD), matchUps: p, structureId: a?.pop(), stageSequence: 3, stage: yt, matchUpType: t });
  o.push(m);
  let f = hF({ mainStructure: c, consolationStructure: d, deciderStructure: m });
  return { structures: o, links: f, ...x };
}
function IF(e) {
  let { qualifyingRoundNumber: t, finishingPositionOffset: r, qualifyingPositions: i, matchUpType: n, idPrefix: a, drawSize: o, isMock: s, uuids: c } = e;
  if (!Ie(o) || o < 2) return { matchUps: [], roundsCount: 0 };
  if (Fi(o)) return Zi(e);
  let u = UF(o), l = u.shift(), d = te(1, (l?.participantsCount || 0) + 1).map((g) => ({ drawPosition: g })), p = [], m = 1;
  ({ matchUps: p } = pd({ roundNumber: m, matchUpType: n, idPrefix: a, matchUps: p, isMock: s, nodes: d, uuids: c })), m++;
  let f = e.roundLimit || t;
  for (let g of u) {
    let I = g.participantsCount / 2, U = te(1, I + 1);
    i && I === i && (f = m - 1);
    let S = U.map((P) => {
      let v = dI({ roundPosition: P, roundNumber: m, idPrefix: a, uuids: c });
      return { roundPosition: P, roundNumber: m, matchUpId: v };
    });
    p.push(...S), m++;
  }
  let h = m - 1;
  return p = qu({ finishingPositionOffset: r, lucky: !0, roundsCount: h, roundLimit: f, matchUps: p }), f && (p = p.filter((g) => g.roundNumber <= f)), { matchUps: p, roundsCount: h, roundLimit: f };
}
function UF(e) {
  let t = pe(e), r = t % 2 ? t + 1 : t, i = !!(Math.ceil(r / 2) % 2), n = [{ participantsCount: r, preFeedRound: i }];
  for (; r > 2; ) {
    let a = Math.ceil(r / 2), o = a === 1, s = !!(!o && a % 2);
    r = !o && s ? a + 1 : a;
    let c = !!(r !== 2 && Math.ceil(r / 2) % 2);
    n.push({ participantsCount: r, preFeedRound: c, feedRound: s });
  }
  return n;
}
function Lb(e) {
  let { playoffAttributes: t, stageSequence: r = 1, stage: i = re, tieFormat: n, matchUpType: a, drawSize: o, uuids: s } = e, c = () => !e.isMock && !e.idPrefix ? void 0 : `${e.drawDefinition.drawId}-s-0`, u = e.structureId || c() || s?.pop(), l = e.appliedPolicies ?? _e(e), d = e.policyDefinitions?.[Ns] || l?.[Ns];
  e.skipRounds = e.skipRounds || o <= 4 && (d?.feedFromMainFinal ? 0 : 1) || 0;
  let p = e.structureName ?? t?.["0"]?.name ?? ir(re), m = () => {
    let { matchUps: f } = Zi(e);
    return { structures: [ii({ stageSequence: r, structureName: p, matchUpType: a, structureId: u, tieFormat: n, matchUps: f, stage: i })], links: [], ...x };
  };
  return { generators: { [Gr]: () => ({ structures: [ii({ finishingPosition: Aa, stageSequence: r, structureName: p, matchUps: [], matchUpType: a, structureId: u, stage: i })], links: [], ...x }), [Ha]: () => {
    let { matchUps: f } = IF(e);
    return { structures: [ii({ stageSequence: r, structureName: p, matchUpType: a, structureId: u, matchUps: f, stage: i })], links: [], ...x };
  }, [Wi]: () => m(), [Du]: () => gF(e), [ws]: () => fs({ ...e, roundOffsetLimit: 3, playoffAttributes: t ?? qh }), [Ts]: () => fs({ ...e, roundOffsetLimit: 2, playoffAttributes: t ?? Wh }), [yt]: () => fs(e), [Ys]: () => {
    let { matchUps: f } = ua({ drawSize: o, uuids: s, matchUpType: a });
    return { structures: [ii({ stageSequence: r, structureName: p, matchUpType: a, structureId: u, stage: re, tieFormat: n, matchUps: f })], links: [], ...x };
  }, [wu]: () => KT(e), [bs]: () => ao({ ...e, feedRounds: 1, fmlc: !0 }), [AD]: () => ao({ ...e, feedRounds: 1 }), [jh]: () => ao({ ...e, feedsFromFinal: 1 }), [Gh]: () => ao({ ...e, feedsFromFinal: 2 }), [$h]: () => ao({ ...e, feedsFromFinal: 3 }), [Tu]: () => ao(e), [Qd]: () => XT(e), [Di]: () => Xu(e), [Sn]: () => fF(e) } };
}
function CI(e) {
  let { enforceMinimumDrawSize: t = !0, overwriteExisting: r, appliedPolicies: i, qualifyingOnly: n, staggeredEntry: a, drawDefinition: o, tieFormat: s, isMock: c, uuids: u } = e || {}, l = pe(e.drawSize), d = e.drawTypeCoercion ?? ul({ appliedPolicies: i, drawType: e.drawType }), p = "generateDrawStructuresAndLinks", m = Fb({ drawType: e.drawType, enforceMinimumDrawSize: t, drawTypeCoercion: d, drawSize: l });
  if (m.error) return m;
  let f = m.drawType, h = [], g = [], I = e?.matchUpType ?? Xe, U = o?.structures?.filter(({ stage: H }) => H === se);
  U && h.push(...U);
  let S = U?.map(({ structureId: H }) => H), P = o?.structures?.find(({ stage: H, stageSequence: G }) => H === re && G === 1), v = o?.links?.filter((H) => H.target.structureId === P?.structureId && S?.includes(H.source.structureId)), D = (H, G) => {
    if (H.linkType === gn && G?.structures) {
      let V = H.source.finishingPositions || [];
      return G.structures.length * V.length;
    } else if (H.linkType === In && G?.matchUps?.length) {
      let V = H.source.roundNumber;
      return G.matchUps.filter(({ roundNumber: $ }) => $ === V).length;
    }
  }, y = U?.map((H) => {
    let G = v?.find((W) => W.target.structureId === H.structureId), V = Je({ structure: H })?.positionAssignments?.length ?? 0;
    if (!G) return V;
    let $ = G?.source.structureId, q = o.structures?.find((W) => W.structureId === $), Y = D(G, q) || 0;
    return V - Y;
  }).filter(Boolean).reduce((H, G) => H + G, 0), w = v?.map((H) => {
    let G = H.source.structureId, V = U?.find(($) => $.structureId === G);
    return D(H, V);
  }).filter(Boolean).reduce((H, G) => H + G, 0), b = !!(P && !P?.matchUps?.length);
  if (U?.length && !b) return { error: pf };
  let T = !U?.length && e.qualifyingProfiles, R = T?.length && xb({ idPrefix: e.idPrefix, qualifyingProfiles: T, appliedPolicies: i, qualifyingOnly: n, tieFormat: s, isMock: c, uuids: u });
  if (R?.error) return R;
  let { qualifyingDrawPositionsCount: M, qualifyingDetails: E, qualifiersCount: A } = R || { qualifyingDrawPositionsCount: y, qualifiersCount: w };
  M && (R?.structures && h.push(...R.structures), R?.links && g.push(...R.links)), Object.assign(e, ae({ drawSize: l, matchUpType: I, tieFormat: s }));
  let N = f !== Gr && (!l || l < 2 || !a && ![Ys, Ha].includes(f) && ([Sn, Di].includes(f) && l < 3 || ![Di, Sn].includes(f) && !Fi(l)));
  if (N && !M) return F({ context: { drawSize: l, invalidDrawSize: N }, result: { error: Nd }, stack: p });
  let { generators: C, error: k } = Lb(e);
  if (k) return { error: k };
  let O = C[f];
  if (!O) return { error: nh };
  let _ = O?.();
  if (_.error) return _;
  let { structures: B, links: L } = _;
  if (B?.length) {
    let H = B.find(({ stage: G, stageSequence: V }) => G === re && V === 1);
    if (P && H) {
      if (b) {
        let G = H.structureId;
        if (H.structureId = P.structureId, L?.length) for (let V of L) V.source.structureId === G && (V.source.structureId = P.structureId), V.target.structureId === G && (V.target.structureId = P.structureId);
      } else if (!r) return { error: pf };
    }
    h.push(...B);
  }
  h.sort(_o), L?.length && g.push(...L);
  let j = _.structures.find(({ stage: H, stageSequence: G }) => H === re && G === 1);
  for (let H of E || []) {
    let { finalQualifyingRoundNumber: G, finalQualifyingStructureId: V, roundTarget: $, finishingPositions: q, linkType: Y } = H, W = j && tl({ targetStructureId: j.structureId, sourceStructureId: V, sourceRoundNumber: G, finishingPositions: q, targetEntryRound: $, linkType: Y })?.link;
    if (W?.error) return W;
    W && g.push(W);
  }
  return v && g.push(...v), { ...x, qualifyingResult: { qualifyingDrawPositionsCount: M, qualifiersCount: A }, structures: h, links: g };
}
function OI(e) {
  let { modifyOriginal: t = !0, stageSequence: r = 1, isMock: i } = e || {}, n = "generateDrawTypeAndModifyDrawDefinition";
  if (!e.drawDefinition) return F({ result: { error: ne }, stack: n });
  let a = t ? e.drawDefinition : ie(e.drawDefinition, !1, !0), { tieFormat: o, matchUpType: s } = e;
  if (o) {
    let S = wr({ tieFormat: o });
    if (S.error) return S;
  }
  o = er(o ?? dr({ drawDefinition: a })?.tieFormat), s = s ?? (a.matchUpType || Xe), e.tieFormat = o, e.matchUpType = s;
  let c = cd({ drawDefinition: a, stage: re });
  e.drawSize = e.drawSize ?? c, !c && e.drawSize && dd({ drawSize: e.drawSize, drawDefinition: a, stageSequence: r, stage: re });
  let u = or({ drawDefinition: a }).drawMatchUps.map($t), l = CI(e);
  if (l.error) return F({ result: l, stack: n });
  let { structures: d, links: p, qualifyingResult: m } = l;
  a.structures = d, a.links = p;
  let f = Math.max(e.qualifiersCount ?? 0, m?.qualifiersCount || 0);
  if (m?.qualifyingDrawPositionsCount && !cd({ stage: se, drawDefinition: a })) {
    let S = dd({ drawSize: m.qualifyingDrawPositionsCount, stage: se, drawDefinition: a });
    if (S.error) return S;
  }
  if (f) {
    let S = LT({ qualifiersCount: f, drawDefinition: a, stage: re });
    if (S.error) return S;
  }
  let h = e.drawSize ?? c;
  Object.assign(e, ae({ drawSize: h, matchUpType: s, tieFormat: o }));
  let { matchUps: g, matchUpsMap: I } = Et({ drawDefinition: a });
  o && g?.forEach((S) => {
    if (!u.includes(S.matchUpId)) {
      let { tieMatchUps: P } = Xo({ tieFormat: o, matchUp: S, isMock: i });
      Object.assign(S, { tieMatchUps: P, matchUpType: s });
    }
  });
  let { inContextDrawMatchUps: U } = Fa({ drawDefinition: a, matchUpsMap: I });
  return tt({ tournamentId: e.tournamentRecord?.tournamentId, drawDefinition: a }), { inContextDrawMatchUps: U, drawDefinition: a, matchUpsMap: I, ...x, structures: d, matchUps: g, links: p };
}
function dl(e) {
  let { removePriorValues: t, tournamentRecord: r, participantId: i, scaleItem: n } = e, a, o;
  if (!Bb({ scaleItem: n })) return { error: Io };
  if (i && Array.isArray(r.participants) && (o = r.participants.find((s) => s.participantId === i), o)) {
    if (o.participantType === Pr && n?.eventType !== jr) return { error: Io };
    let s = Vb({ removePriorValues: t, participant: o, scaleItem: n });
    if (s.error) return s;
    a = !s.valueChanged;
    let { topics: c } = ci();
    c.includes(ar) && Se({ topic: ar, payload: { tournamentId: r.tournamentId, participants: [o] } });
  }
  return a && { ...x, info: bh, existingValue: n?.scaleValue } || o && { ...x, newValue: n?.scaleValue } || { error: Tt };
}
function _b(e) {
  let { scaleItemsWithParticipantIds: t = [], removePriorValues: r, tournamentRecord: i, auditData: n, context: a } = e;
  if (!i) return { error: J };
  if (!i.participants) return { error: gu };
  let o = 0, s = {}, c = [];
  for (let d of t) {
    let p = d?.participantId;
    if (Array.isArray(d?.scaleItems)) for (let m of d.scaleItems) if (Bb({ scaleItem: m })) Array.isArray(s[p]) || (s[p] = []), s[p].push(m);
    else return { error: Io };
  }
  for (let d of i.participants) {
    let { participantId: p } = d || {};
    if (Array.isArray(s[p])) for (let m of s[p]) {
      if (d.participantType === Pr && m?.eventType !== jr) return F({ context: { participantId: p, scaleItem: m, participantType: d.participantType }, info: "Invalid participantType for eventType", result: { error: Io } });
      Vb({ participant: d, scaleItem: m, removePriorValues: r }), c.push(d), o++;
    }
  }
  let u = o ? void 0 : Hs, { topics: l } = ci();
  if (l.includes(ar) && o && Se({ topic: ar, payload: { tournamentId: i.tournamentId, participants: c } }), a) {
    let { eventId: d, drawId: p, ...m } = a, f = m.scaleAttributes?.scaleType && [m.scaleAttributes.scaleType];
    if (Object.keys(m).length) {
      let h = { itemType: lg, itemValue: m };
      if (f && (h.itemSubTypes = f), p || d) {
        let { drawDefinition: g, event: I } = br({ tournamentRecord: i, eventId: d, drawId: p });
        p && oI({ drawDefinition: g, timeItem: h }), d && Jo({ event: I, timeItem: h });
      } else sl({ tournamentRecord: i, timeItem: h });
    }
  }
  return n && l.includes(Cn) && Se({ topic: Cn, payload: n }), ae({ ...x, modificationsApplied: o, info: u });
}
function Bb({ scaleItem: e }) {
  let t = e && Object.keys(e), r = ["scaleType", "eventType", "scaleName"];
  return r.filter((i) => t?.includes(i)).length === r.length;
}
function Vb({ removePriorValues: e, participant: t, scaleItem: r }) {
  if (!t) return { error: Ao };
  let i = r && Object.keys(r), n = ["scaleType", "eventType", "scaleName"];
  if (n.filter((u) => i.includes(u) && r[u]).length !== n.length) return { error: Io };
  let a = (/* @__PURE__ */ new Date()).toISOString();
  t.timeItems || (t.timeItems = []);
  let { scaleItem: o } = dn({ scaleAttributes: r, participant: t }), s = (u) => [void 0, null, ""].includes(u), c = !(s(o?.scaleValue) && s(r.scaleValue)) && JSON.stringify(o?.scaleValue) !== JSON.stringify(r.scaleValue);
  if (c) {
    let { scaleType: u, eventType: l, scaleName: d } = r, p = [Ca, u, l, d].join("."), m = ae({ itemValue: r.scaleValue, itemDate: r.scaleDate, createdAt: a, itemType: p });
    r.scaleId && (m.itemSubTypes = [r.scaleId]), e && (t.timeItems = t.timeItems.filter((f) => f.itemType !== p)), t.timeItems.push(m);
  }
  return { ...x, valueChanged: c, newValue: r.scaleValue };
}
function kI(e) {
  let { tournamentRecord: t, modifiedScaleValues: r, removePriorValues: i } = e, n = oe(e, [{ [Vt]: !0 }, { modifiedScaleValues: !0, [Mr]: Nr }]);
  if (n.error) return n;
  for (let a in r) {
    let o = dl({ scaleItem: r[a], removePriorValues: i, tournamentRecord: t, participantId: a });
    if (o.error) return o;
  }
  return { ...x };
}
function ks(e) {
  let { tournamentRecord: t, scaleAttributes: r, participantId: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!i) return { error: Ft };
  let { participant: a, tournamentId: o } = ha({ tournamentRecords: n, tournamentRecord: t, participantId: i });
  return a ? { ...dn({ participant: a, scaleAttributes: r }), tournamentId: o } : { error: Tt };
}
var SF = (e = 0) => 250 / Math.pow(e + 5, 0.4), yF = () => 1;
function vF(e = 3, t = 2) {
  let r = e / t;
  return isNaN(r) ? us.kDefault() : r;
}
var us = { nSpread: 400, diffThreshold: 0.125, kCalc: SF, kMultiplier: vF, kDefault: yF };
function jb(e) {
  let { winnerRating: t, loserRating: r } = e, { ratings: i = Gt, winnerCountables: n = 1, loserCountables: a = 0, ratingType: o = "ELO", maxCountables: s, countables: c } = e || {}, u = i?.[o];
  if (!u) return { error: ue };
  let l = u.range || e.ratingRange;
  t = t || u.defaultInitialization, r = r || u.defaultInitialization;
  let d = l[0] > l[1], p = u.decimalsCount || 0, m = d ? l.slice().reverse() : l, f = (C, k) => parseFloat(k) >= Math.min(...C) && parseFloat(k) <= Math.max(...C);
  (!f(l, t) || !f(l, r)) && (f(l, t) || (t = u.defaultInitialization), f(l, r) || (r = u.defaultInitialization));
  let h = ds({ targetRange: Gt.ELO.range, sourceRange: m, value: d ? l[0] - t : t }), g = ds({ targetRange: Gt.ELO.range, sourceRange: m, value: d ? l[0] - r : r }), I = (C, k) => 1 / (1 + Math.pow(10, (k - C) / us.nSpread)), U = I(h, g), S = I(g, h), P = us.kCalc(n), v = us.kCalc(a), D = us.kMultiplier(s, c), y = h + D * P * (1 - U), w = g + D * v * (0 - S), b = ds({ sourceRange: Gt.ELO.range, value: y, targetRange: m }), T = ds({ sourceRange: Gt.ELO.range, value: w, targetRange: m }), R = d ? l[0] - b : b, M = parseFloat(R.toFixed(p)), E = d ? l[0] - T : T, A = parseFloat(E.toFixed(p)), N = Math.max(...l) ? Math.abs(t - r) / Math.max(...l) : 0;
  return (b > T && N > us.diffThreshold || M < 0 || A < 0) && (M = t, A = r), { newWinnerRating: M, newLoserRating: A };
}
var PF = (e) => e?.reduce((t, r) => (r.winningSide && (t[r.winningSide - 1] += 1), t), [0, 0]) || [0, 0];
function Gb(e) {
  let t = oe(e, [{ [Vt]: !0 }, { matchUpIds: !0, [Mr]: sr, [yi]: Ro }, { ratingType: !1, [tr]: (U) => Gt[U] }]);
  if (t.error) return t;
  let { updateParticipantRatings: r, removePriorValues: i = !0, tournamentRecord: n, ratingType: a = "ELO", refreshDynamic: o, considerGames: s, drawDefinition: c, matchUpIds: u, asDynamic: l } = e, d = Gt[a], { accessor: p } = d, m = {}, f = (e.matchUps || o && hr({ drawDefinition: c, tournamentRecord: n, inContext: !0, matchUpFilters: { matchUpStatuses: Lt } }).matchUps || Jt({ matchUpFilters: { matchUpIds: u, matchUpStatuses: Lt }, tournamentRecord: n, inContext: !0 }).matchUps) ?? [], h = `${a}.${eg}`, g = l ? h : a;
  f.sort(Ho);
  for (let U of f) {
    let { endDate: S, matchUpFormat: P, score: v, sides: D, winningSide: y } = U, w = U.matchUpType, b = { eventType: w, scaleName: a, scaleType: Zn }, T = { scaleName: h, eventType: w, scaleType: Zn }, R = Object.assign({}, ...(D ?? []).map((B) => {
      let { sideNumber: L, participant: j } = B;
      return L && { [L]: [j?.participantId, ...j?.individualParticipantIds ?? []].filter(Boolean).flat() };
    })), M = Object.assign({}, ...Object.values(R).flat().map((B) => {
      let L = m[B], j = !o || L ? ks({ scaleAttributes: T, tournamentRecord: n, participantId: B }).scaleItem : void 0, H = ks({ tournamentRecord: n, scaleAttributes: b, participantId: B }).scaleItem, G = p ? { [p]: void 0 } : void 0;
      return B && { [B]: j ?? H ?? { scaleName: g, eventType: w, scaleDate: S, scaleType: Zn, scaleValue: G } };
    })), E = P ? Sr(P) : {}, A = E?.bestOf || 1, N = E?.setsTo || 1, C = s ? A & N : A, k = v?.sets && PF(v.sets) || y === 1 && [1, 0] || [0, 1], O = y ? R[y] : [], _ = y ? R[3 - y] : [];
    for (let B of O) {
      let L = M[B]?.scaleValue, j = typeof L == "object" ? L[p] : L;
      for (let H of _) {
        let G = M[H]?.scaleValue, V = typeof G == "object" ? G[p] : G, $ = y ? k[y] : [0, 0], q = y ? k[3 - y] : [0, 0], { newWinnerRating: Y, newLoserRating: W } = jb({ winnerCountables: $, loserCountables: q, maxCountables: C, winnerRating: j, loserRating: V, ratingType: a }), K = p ? { ...L, [p]: Y } : Y, Q = p ? { ...G, [p]: W } : W;
        M[B].scaleValue = K, M[H].scaleValue = Q, M[B].scaleName = g, M[H].scaleName = g;
      }
    }
    Object.assign(m, M), r && kI({ tournamentRecord: n, modifiedScaleValues: m, removePriorValues: i });
  }
  let I = f.map(({ matchUpId: U }) => U);
  return { ...x, modifiedScaleValues: m, outputScaleName: g, processedMatchUpIds: I };
}
function Bp(e) {
  let { matchUpIds: t = [], drawDefinition: r, roundNumber: i, newRound: n, isMock: a, event: o } = e;
  if (typeof r != "object") return { error: ne };
  let { participantIdPairings: s, matchUpsCount: c } = e, u = Fp(e);
  if (u.error) return F({ result: u });
  let { lastRoundNumber: l, availableMatchUpsCount: d = 0, roundMatchUpsCount: p = 0 } = u;
  if (!c) n ? c = p : d > 0 && (c = d);
  else if (c > p && e.restrictMatchUpsCount !== !1) return F({ result: { error: z, info: "matchUpsCount error", context: { roundMatchUpsCount: p } } });
  if (s && !Array.isArray(s) || c && !Ie(c) || t && !Array.isArray(t) || !s && !c) return { error: z, info: "matchUpsCount or pairings error" };
  if (c && e.restrictMatchUpsCount !== !1 && c > 32) return { error: z, info: "matchUpsCount must be less than 33" };
  if (i && !e.ignoreLastRoundNumber && i - 1 > (l || 0)) return { error: z, info: "roundNumber error" };
  let m = i ?? (n && (l ?? 0) + 1 || l || 1);
  s = s ?? te(0, c).map(() => ({ participantIds: [void 0, void 0] }));
  let f = (g) => {
    if (!e.idPrefix) return;
    let I = r.drawId, U = e.idPrefix ?? "ah";
    return `${I}-${U}-${m}-${g}`;
  }, h = s?.map((g, I) => {
    let U = g?.participantIds ?? [void 0, void 0];
    U.push(void 0, void 0);
    let S = U.slice(0, 2).map((v, D) => ae({ sideNumber: D + 1, participantId: v })), P = t[I] ?? f(I) ?? je();
    return { roundNumber: m, matchUpStatus: Dt, matchUpId: P, sides: S };
  });
  if (h?.length) {
    let g = dr({ drawDefinition: r, event: o })?.tieFormat;
    g && h.forEach((I) => {
      let { tieMatchUps: U } = Xo({ tieFormat: g, matchUp: I, isMock: a });
      Object.assign(I, { tieMatchUps: U, matchUpType: ot });
    });
  }
  return { roundNumber: m, matchUpsCount: h?.length ?? 0, matchUps: h, ...x };
}
function DF({ maxIterations: e = 4e3, valueSortedPairings: t, pairingValues: r, valueObjects: i, deltaObjects: n }) {
  let a = Object.assign({}, ...t.map((U) => ({ [U.pairing]: U.value }))), o = Object.keys(r), s = [], c = py({ actorsCount: o.length, valueSortedPairings: t, pairingValueMap: a, deltaObjects: n, valueObjects: i }), u = [Vm(c)];
  s.push(c);
  let l = c.value, d = c, p = 1, m = 0, f = o.length, h;
  do
    f -= 1, h = o.length * r[o[0]].length;
  while (h > e && f > 5);
  let g = [];
  o.forEach((U) => {
    r[U].slice(0, f).forEach((S) => {
      m += 1;
      let P = fo(U, S.opponent);
      if (!g.includes(P)) {
        let v = py({ stipulated: [[U, S.opponent]], actorsCount: o.length, valueSortedPairings: t, pairingValueMap: a, deltaObjects: n, valueObjects: i });
        if (!u.includes(Vm(v))) {
          u.push(Vm(v)), s.push(v);
          let { maxDelta: D, value: y } = v;
          D < d.maxDelta && (d = v), (y < l || y === l && Math.round(Math.random())) && (l = y), g.push(P), p += 1;
        }
      }
    }), s = s.filter((S) => Math.abs(S.value - l) < 5);
  }), s.sort((U, S) => U.maxDiff - S.maxDiff);
  let I = Lr(s);
  return { candidatesCount: p, deltaCandidate: d, maxIterations: e, iterations: m, candidate: I };
}
function Vm(e) {
  return e.participantIdPairings.map(({ participantIds: t }) => t.sort().join("|")).sort().join("/");
}
function py({ valueSortedPairings: e, stipulated: t = [], pairingValueMap: r, deltaObjects: i, valueObjects: n, actorsCount: a }) {
  let o = [].concat(...t), s = [], c = 0;
  t.filter(Boolean).forEach((d) => {
    let [p, m] = d, f = fo(p, m), h = r[f];
    s.push({ participantIds: d, value: h }), c += r[f];
  }), qt(e, a).map((d) => mr(d).map((p) => ({ ...p, value: p.value + Math.random() * Math.round(Math.random()) }))).flat().forEach((d) => {
    let p = d.pairing.split("|");
    if (!p.reduce((m, f) => o.includes(f) || m, !1)) {
      o.push(...p);
      let m = d.value;
      c += m, s.push({ participantIds: p, value: m });
    }
  }), s.sort((d, p) => d.value - p.value);
  let u = s.reduce((d, p) => {
    let [m, f] = p.participantIds, h = fo(m, f), g = i[h];
    return g > d ? g : d;
  }, 0), l = s.reduce((d, p) => {
    let [m, f] = p.participantIds, h = fo(m, f), g = n[h];
    return g > d ? g : d;
  }, 0);
  return { value: c, participantIdPairings: s, maxDelta: u, maxDiff: l };
}
function fo(e, t) {
  return [e, t].sort(Dp).join("|");
}
function $b({ participantIds: e }) {
  let t = {}, r = [];
  e.forEach((n) => {
    t[n] = e.filter((a) => a !== n), t[n].forEach((a) => {
      let o = fo(a, n);
      r.includes(o) || r.push(o);
    });
  });
  let i = Object.assign({}, ...r.map((n) => ({ [n]: 0 })));
  return { uniquePairings: r, possiblePairings: t, deltaObjects: i };
}
function wF({ matchUps: e }) {
  let t = [];
  for (let r of e) {
    let i = r.sides.map(Re);
    if (i.length === 2) {
      let [n, a] = i, o = fo(n, a);
      t.includes(o) || t.push(o);
    }
  }
  return { encounters: t };
}
function TF({ possiblePairings: e, valueObjects: t }) {
  let r = {};
  for (let n of Object.keys(e)) {
    let a = e[n].map((o) => i(n, o));
    r[n] = a.sort((o, s) => o.value - s.value);
  }
  function i(n, a) {
    let o = fo(n, a);
    return { opponent: a, value: t[o] };
  }
  return { pairingValues: r };
}
var bF = 0;
function MF({ tournamentParticipants: e, adHocRatings: t, eventType: r, scaleName: i, pairing: n }) {
  let a = Gt[i]?.defaultInitialization ?? bF;
  return n.split("|").map((o) => {
    if (r === ai) {
      let s = e?.find((c) => c.participantId === o)?.individualParticipantIds;
      return s ? s?.map((c) => t[c] || a) : a * 2;
    } else return t[o] || a;
  });
}
function RF(e) {
  let { tournamentParticipants: t, adHocRatings: r = {}, possiblePairings: i, uniquePairings: n, maxIterations: a, minimizeDelta: o, deltaObjects: s, valueObjects: c, eventType: u, scaleName: l, salted: d } = e;
  n.forEach((S) => {
    let P = MF({ tournamentParticipants: t, adHocRatings: r, scaleName: l, eventType: u, pairing: S }), v = typeof d == "number" && d || 0.5, D = d && (Math.round(Math.random()) ? v : v * -1) || 0, y = Math.abs(P[0] - P[1]) + D, w = Math.abs(P[0] - P[1]);
    s[S] = w, c[S] || (c[S] = 0), c[S] += y ? Math.pow(y, 2) : 0;
  });
  let p = n.map((S) => ({ pairing: S, value: c[S] })).sort((S, P) => S.value - P.value), { pairingValues: m } = TF({ possiblePairings: i, valueObjects: c }), { candidate: f, candidatesCount: h, deltaCandidate: g, iterations: I } = DF({ valueSortedPairings: p, maxIterations: a, pairingValues: m, deltaObjects: s, valueObjects: c }), { participantIdPairings: U } = o ? g : f;
  return { participantIdPairings: U, candidatesCount: h, deltaCandidate: g, iterations: I, candidate: f };
}
var NF = 100, EF = 100, AF = 4e3;
function xI(e) {
  let { encounterValue: t = NF, sameTeamValue: r = EF, maxIterations: i = AF, updateParticipantRatings: n, generateMatchUps: a = !0, ignoreLastRoundNumber: o, iterationMatchUps: s, tournamentRecord: c, dynamicRatings: u, refreshDynamic: l, participantIds: d, drawDefinition: p, roundNumber: m, structureId: f, matchUpIds: h, eventType: g, scaleName: I, idPrefix: U, isMock: S, salted: P, event: v } = e;
  if (!p) return { error: ne };
  if (!e.structure && !f) return { error: mt };
  let D = e.structure || me({ drawDefinition: p, structureId: f }).structure;
  if (!xe(D)) return { error: qa };
  if (!d?.length) return { error: la };
  let y = [...s ?? [], ...D?.matchUps ?? []], { encounters: w } = wF({ matchUps: y }), b = c?.participants ?? [], T = {};
  if (u) {
    let $ = Ue(D?.matchUps ? D.matchUps.map(({ roundNumber: Y }) => Y) : []), q = Math.max(...$, 0);
    if (q) {
      let Y = D?.matchUps?.filter(({ roundNumber: K }) => K === q).map(({ matchUpId: K }) => K), W = Gb({ ratingType: I ?? v?.category?.ratingType, updateParticipantRatings: n, tournamentRecord: c, asDynamic: !0, refreshDynamic: l, drawDefinition: p, matchUpIds: Y });
      if (W.error) return W;
      W.modifiedScaleValues && (T = W.modifiedScaleValues);
    }
  }
  let { valueObjects: R } = CF({ tournamentParticipants: b, encounterValue: t, sameTeamValue: r, encounters: w }), { uniquePairings: M, possiblePairings: E, deltaObjects: A } = $b({ participantIds: d }), N = Object.values(T).length ? T : e.adHocRatings, C = { tournamentParticipants: b, possiblePairings: E, uniquePairings: M, maxIterations: i, adHocRatings: N, deltaObjects: A, valueObjects: R, eventType: g, scaleName: I, salted: P }, { candidatesCount: k, participantIdPairings: O, deltaCandidate: _, iterations: B, candidate: L } = RF(C);
  if (!k) return { error: Ld };
  let j, H;
  if (a) {
    let $ = Bp({ structureId: D?.structureId, ignoreLastRoundNumber: o, participantIdPairings: O, newRound: !0, drawDefinition: p, roundNumber: m, matchUpIds: h, idPrefix: U, isMock: S, event: v });
    if ($.error) return $;
    j = $.roundNumber, H = $.matchUps;
  }
  let { maxDelta: G, maxDiff: V } = L;
  return { roundNumber: j, participantIdPairings: O, modifiedScaleValues: T, candidatesCount: k, deltaCandidate: _, ...x, iterations: B, matchUps: H, maxDelta: G, maxDiff: V };
}
function CF({ encounters: e, tournamentParticipants: t, encounterValue: r, sameTeamValue: i }) {
  let n = {};
  for (let o of e) n[o] || (n[o] = 0), n[o] += r;
  let a = t?.filter(({ participantType: o }) => o === We);
  if (a) for (let o of a) {
    let s = o.individualParticipantIds ?? [], { uniquePairings: c } = $b({ participantIds: s });
    for (let u of c) n[u] || (n[u] = 0), n[u] += i;
  }
  return { valueObjects: n };
}
function qb(e) {
  let { drawType: t = Wi, attachConsolation: r = !0, applyPositioning: i = !0, tournamentRecord: n, staggeredEntry: a, automated: o, placeByes: s, isMock: c, event: u } = e, l = e?.drawDefinition;
  if (!l) return { error: ne };
  let d = zt, p = Bo({ stageSequence: 1, drawDefinition: l, stage: d }), m = [Di, Du, Sn].includes(t) ? p.length : Bs(p.length);
  if (!a && t === Ys && p.length < 2 || t === Di && p.length < 3) return { error: Nd };
  let { tieFormat: f, matchUpType: h } = e;
  if (f) {
    let R = wr({ tieFormat: f });
    if (R.error) return R;
  }
  f = er(f ?? dr({ drawDefinition: l })?.tieFormat), h = h ?? l.matchUpType;
  let { structures: g } = Ti({ stageSequence: 1, drawDefinition: l, stage: d });
  if (g.length > 1) return { error: Lv };
  if (g?.[0]?.matchUps?.length) return { error: Rh };
  let I = g?.[0]?.structureId;
  Object.assign(e, ae({ structureName: e.structureName ?? ir(zt), structureId: I, matchUpType: h, tieFormat: f, drawSize: m, stage: d }));
  let U = Lb(e);
  if (U.error) return U;
  let S = U.generators[t];
  if (!S) return { error: nh };
  let P = S?.();
  if (P.error) return P;
  let { structures: v, links: D } = P, y = v.map((R) => Ve({ structure: R }).matchUps).flat();
  f && y.forEach((R) => {
    let { tieMatchUps: M } = Xo({ matchUp: R, tieFormat: f, isMock: c });
    Object.assign(R, { tieMatchUps: M, matchUpType: h });
  }), (!i || !r) && (l = ie(l, !1, !0)), l.links || (l.links = []), D.length && l.links.push(...D);
  let w = v.map(({ structureId: R }) => R);
  l.structures || (l.structures = []);
  let b = l.structures.map(({ structureId: R }) => R);
  l.structures = l.structures.map((R) => w.includes(R.structureId) ? v.find(({ structureId: M }) => M === R.structureId) : R);
  let T = v.filter(({ structureId: R }) => !b.includes(R));
  return T.length && l.structures.push(...T), o && el({ seedingProfile: e.seedingProfile, applyPositioning: i, tournamentRecord: n, drawDefinition: l, structureId: I, placeByes: s, drawSize: m, event: u }), r && tt({ drawDefinition: l }), { links: D, structures: v, ...x };
}
var FI = {};
Me(FI, { addGame: () => Jb, addPoint: () => Xb, addSet: () => eM, addShot: () => Zb, analyzeScore: () => GI, analyzeSet: () => nu, calculateHistoryScore: () => Yb, checkScoreHasValue: () => Bt, checkSetIsComplete: () => Gp, clearHistory: () => Qb, generate: () => Wb, generateScoreString: () => pn, generateTieMatchUpScore: () => al, getSetComplement: () => qI, getTiebreakComplement: () => Hp, helpers: () => nM, isValidMatchUpFormat: () => Vr, keyValueScore: () => TM, mutate: () => zb, parseMatchUpFormat: () => Sr, parseScoreString: () => gd, query: () => EM, redo: () => tM, reverseScore: () => Hb, setServingSide: () => Kb, stringifyMatchUpFormat: () => Wd, tidyScore: () => NM, umo: () => iM, undo: () => rM, validateScore: () => $I, validateTieFormat: () => wr });
var Wb = {};
Me(Wb, { generateScoreString: () => pn, generateTieMatchUpScore: () => al, reverseScore: () => Hb });
function pn(e) {
  let { winnerFirst: t = !0, setTBlast: r = !0, addOutcomeString: i, reversed: n = !1, matchUpStatus: a, matchUpFormat: o, autoComplete: s, winningSide: c, sets: u } = e;
  if (!u) return { error: ue, info: "missing sets" };
  let l = o && Sr(o), { bestOf: d, finalSetFormat: p, setFormat: m } = l ?? {}, f = n || !(!t || !c || c === 1), h = i ? OF({ matchUpStatus: a }) : "", g = u?.sort(kF).map(I).filter(Boolean).join(" ") || "";
  if (!h) return g;
  if (c === 2) return `${h} ${g}`;
  return `${g} ${h}`;
  function I(U) {
    let S = d && U.setNumber === d && p ? p : m, P = (H) => gt(H?.side1Score) || gt(H?.side2Score), v = ((H) => gt(H?.side1TiebreakScore) || gt(H?.side2TiebreakScore))(U), D = S?.tiebreakSet || !P(U) && v, { side1Score: y, side2Score: w, side1TiebreakScore: b, side2TiebreakScore: T } = U, R = b || (gt(b) || v && s ? 0 : ""), M = T || (gt(T) || v && s ? 0 : "");
    if (D) return `[${(f ? [M, R] : [R, M]).join("-")}]`;
    let E = v ? Math.min(R, M) : "", A = E === R ? 1 : 2, N = gt(E) ? `(${E})` : "", C = y || (gt(y) || s ? 0 : ""), k = w || (gt(w) || s ? 0 : ""), O = (H) => !r && A === H ? N : "", _ = `${C}${O(1)}`, B = `${k}${O(2)}`, L = r && v ? `(${E})` : "", j = f ? `${[B, _].join("-")}${L}` : `${[_, B].join("-")}${L}`;
    return ["-", " "].includes(j) && (j = ""), j;
  }
}
function OF({ matchUpStatus: e }) {
  let t = { [Xt]: "RET", [be]: "WO", [xt]: "DF/DF", [Mt]: "WO/WO", [fa]: "SUS", [Or]: "ABN", [Pe]: "DEF", [Zs]: "DR" };
  return e && t[e] || "";
}
function kF(e, t) {
  return e.setNumber - t.setNumber;
}
function Hb(e) {
  if (!e?.score) return { error: ue };
  let { sets: t } = e.score, r = t.map((o) => {
    let { side1TiebreakScore: s, side2TiebreakScore: c, winningSide: u, side1Score: l, side2Score: d, setNumber: p } = o;
    return ae({ winningSide: u ? 3 - u : void 0, side1TiebreakScore: c, side2TiebreakScore: s, side1Score: d, side2Score: l, setNumber: p });
  }), i = e?.setTBlast, n = pn({ setTBlast: i, sets: r }), a = pn({ sets: r, reversed: !0, setTBlast: i });
  return { reversedScore: { sets: r, scoreStringSide1: n, scoreStringSide2: a }, ...x };
}
var zb = {};
Me(zb, { addGame: () => Jb, addPoint: () => Xb, addSet: () => eM, addShot: () => Zb, calculateHistoryScore: () => Yb, clearHistory: () => Qb, redo: () => tM, setServingSide: () => Kb, umo: () => iM, undo: () => rM });
function to({ matchUp: e }) {
  let { extension: t } = we({ name: sp, element: e });
  if (!t) return { error: Kt };
  let { history: r = [], undoHistory: i = [] } = t.value;
  return { history: r, undoHistory: i, ...x };
}
function Yb(e) {
  if (!e) return { error: ue };
  let { matchUp: t, updateScore: r } = e;
  if (!t) return { error: Dr };
  let i = to({ matchUp: t })?.history || [];
  if (!Array.isArray(i)) return { error: z, info: "history is not an array" };
  let { matchUpFormat: n } = t;
  if (!n) return { error: dh };
  if (!Vr({ matchUpFormat: n })) return { error: lh };
  let a = Sr(n), { bestOf: o, finalSetFormat: s, setFormat: c } = a, u = ["0", "15", "30", "40", "A", "G"], l = { sets: [] }, d = [], p, m = [0, 0], f = 1, h = 0, g, I = 0, U = (T) => [1, 2].includes(T), S = () => (h += 1, { winningSide: void 0, side1Score: 0, side2Score: 0, setNumber: h, games: [] }), P = () => ({ winningSide: void 0, points: [] }), v = () => ({ winningSide: void 0, side1Score: "", side2Score: "", shots: [] }), D = v(), y = P(), w = S(), b = 0;
  for (let T of i) {
    b += 1, g = l.sets.length + 1 === o;
    let R = g && s ? s : c, { tiebreakAt: M, setTo: E, NoAD: A, tiebbreakFormat: N } = R, C = w.side1Score === M && w.side1Score === w.side2Score, k = !!R.tiebreakSet, O = k ? R.tiebreakSet : N, { tiebreakTo: _, NoAD: B } = O || {}, L = () => {
      p = void 0, m = [0, 0], f = 3 - f, w.side1TiebreakScore = "", w.side2TiebreakScore = "", w.side1PointScore = "", w.side2PointScore = "", I = 0;
    }, j = (V) => {
      w.winningSide = V;
      let { s: $, ...q } = w;
      l.sets.push(q), D = v(), y = P(), w = S(), L();
    }, H = (V) => {
      y.winningSide = V;
      let { g: $, ...q } = y;
      w.games.push(q), D = v(), y = P(), L();
      let Y = `side${V}Score`;
      w[Y] += 1;
    }, G = (V) => {
      D.winningSide = V;
      let { p: $, ...q } = D;
      y.points.push(q), D = v(), I = 0;
      let Y = () => m.reduce((K, Q) => K + Q) % 4 / 4 > 0.5 ? f : 3 - f, W = V - 1;
      if (C || k) {
        m[W] += 1, p = Y(), w[`side${V}TiebreakScore`] = m[W], w[`side${3 - V}TiebreakScore`] = m[1 - W];
        let K = B ? 1 : 2;
        if (m[W] >= _ && m[W] >= m[1 - W] + K) return H(V), { gameCompleted: !0 };
      } else if (m[1 - W] === 4 && m[W] === 3 ? m[1 - W] -= 1 : m[W] += 1, w.side1PointScore = u[m[0]], w.side2PointScore = u[m[1]], m[W] === 5 || m[W] === 4 && m[1 - W] < 3 || A && m[W] === 4) return H(V), { gameCompleted: !0 };
    };
    if (U(T.srv) && (f = T.srv), ["p", "s", "g", "o"].includes(T.u) && d.push(T.u), T.shotOutcome && (D.shots.push(T), T.shotType === "SERVE" && ["OUT", "NET"].includes(T.shotOutcome) && (I += 1), I === 2)) {
      let V = 3 - f;
      G(V);
    }
    if (U(T.p) || Ie(T.pointNumber)) {
      let V = T.winningSide || T.p;
      if (G(V)?.gameCompleted) continue;
    }
    if (U(T.g) || Ie(T.gameNumber)) {
      let V = T.winningSide || T.g;
      y.winningSide = V;
      let $ = `side${V}Score`, q = `side${3 - V}Score`;
      if (d.length && (d.includes("p"), d = []), H(V), w[$] === E && w[$] - w[q] >= (A ? 1 : 2) && (j(V), g)) break;
    }
    if (U(T.s) || Ie(T.setNumber)) {
      let V = T.winningSide || T.s;
      if (j(V), d.length && (d.includes("p"), d.includes("g"), d = []), g) break;
    }
  }
  return b !== i.length && console.log({ error: "Match completed with excess history" }), (w.side1Score || w.side2Score || w.games.length || w.side1TiebreakScore || w.side2TiebreakScore) && l.sets.push(w), l.scoreStringSide1 = pn({ ...l, matchUpFormat: n }), l.scoreStringSide2 = pn({ ...l, matchUpFormat: n, reversed: !0 }), f = p || f, r && (t.score = l), { ...x, servingSide: f, score: l };
}
function ro({ undoHistory: e, history: t, matchUp: r }) {
  return Be({ element: r, extension: { value: { history: t, undoHistory: e }, name: sp } });
}
function Kb({ matchUp: e, sideNumber: t }) {
  if (![1, 2].includes(t)) return { error: hh };
  let { history: r = [] } = to({ matchUp: e });
  return r.push({ srv: t }), ro({ matchUp: e, history: r });
}
function Qb({ matchUp: e }) {
  return ro({ matchUp: e });
}
function Xb({ matchUp: e, point: t }) {
  if (!t || !e) return { error: ue };
  if (typeof t != "object") return { error: z, context: { point: t } };
  let { history: r = [] } = to({ matchUp: e });
  return r.push(t), ro({ matchUp: e, history: r });
}
function Jb({ matchUp: e, game: t }) {
  if (typeof t != "object") return { error: z, context: { game: t } };
  let { history: r = [] } = to({ matchUp: e });
  return r.push(t), ro({ matchUp: e, history: r });
}
function Zb({ matchUp: e, shot: t }) {
  if (typeof t != "object") return { error: ue };
  let { history: r = [] } = to({ matchUp: e });
  return r.push(t), ro({ matchUp: e, history: r });
}
function eM({ matchUp: e, set: t }) {
  if (typeof t != "object") return { error: ue };
  let { history: r = [] } = to({ matchUp: e });
  return r.push(t), ro({ matchUp: e, history: r });
}
function tM({ matchUp: e }) {
  let { history: t = [], undoHistory: r = [] } = to({ matchUp: e });
  return r.length && t.push(r.pop()), ro({ matchUp: e, history: t, undoHistory: r });
}
function rM({ matchUp: e }) {
  let { history: t = [], undoHistory: r = [] } = to({ matchUp: e });
  return r.push(t.pop()), ro({ matchUp: e, history: t, undoHistory: r });
}
var iM = {}, nM = {};
Me(nM, { keyValueScore: () => TM, parseMatchUpFormat: () => Sr, stringifyMatchUpFormat: () => Wd, tidyScore: () => NM });
var xF = "COMPLETED", FF = "WO/WO", aM = ["RET", "DEF", "WO", FF, "ABN", "SUS", "INT"], Vf = "DEFAULTED", oM = "WALKOVER", sM = "ABANDONED", cM = "SUSPENDED", uM = "RETIRED", lM = "INTERRUPTED", LF = [uM, Vf, oM], _F = "Enter Score", Mo = "()", Va = "[]", LI = ["up", "left", "shift+tab"], _I = ["enter", "down", "tab", "right"], md = "backspace", dM = "r", pM = "s", mM = "a", fM = "d", hM = "w", gM = "i", Vp = [dM, fM, hM, mM, pM, gM], jp = "space", jm = ["[", "("], fd = [...LI, ..._I, jp, "]"], IM = "-", BF = "/", ho = IM, mn = IM, UM = [BF], VF = 0, jF = ["=", "+", "num_1", "num_2", "shift+=", "shift+-"], BI = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].concat(Vp), SM = BI.map((e) => `shift+${e}`), yM = [ho, md].concat(fd, UM), vM = [BI, SM, yM].join(","), GF = [vM, LI, _I, jF].join(","), $F = { OUTCOMEKEYS: Vp, SIDE1KEYS: BI, SIDE2KEYS: SM, MODIFIERS: yM, PROMPT: _F, MOVEUP: LI, MOVEDOWN: _I, HOTKEYS: GF };
function as({ scoreString: e, lowSide: t, outcome: r }) {
  if ({ scoreString: e } = PM({ scoreString: e }), t === 2) {
    let i = (e && e[e.length - 1]) !== " " ? " " : "";
    return e + i + r;
  } else return r + " " + e;
}
function PM({ scoreString: e }) {
  if (!e) return { scoreString: "" };
  let t = !1;
  for (let r of aM) {
    let i = e?.indexOf(r);
    i === 0 ? e = e.slice(r.length + 1).trim() + " " : i > 0 && (e = e.slice(0, i)), i >= 0 && (t = !0);
  }
  return e?.trim() || (e = ""), { scoreString: e, removed: t };
}
function jf({ analysis: e, scoreString: t, sets: r, lowSide: i }) {
  let n, a;
  if (!t) return { scoreString: t, sets: r };
  let { scoreString: o, removed: s } = PM({ scoreString: t });
  if (t = o, s) return { scoreString: t, sets: r, outcomeRemoved: !0 };
  let c = r[r.length - 1] || {}, u = Object.values(c).filter((h) => h !== void 0).length;
  c.setNumber && u === 1 && (r = r.slice(0, r.length - 1), c = r[r.length - 1] || {});
  let { tiebreakSet: l } = e.setFormat, { tiebreakTo: d, NoAD: p } = l || {}, { isTiebreakEntry: m } = hs({ brackets: Va, scoreString: t }), f = WF(t);
  if (f >= 0) {
    n = t.slice(0, f);
    let { isTiebreakEntry: h } = hs({ brackets: Mo, scoreString: n }), { lastOpenBracketIndex: g, isTiebreakEntry: I } = hs({ brackets: Va, scoreString: n }), U = n && n[n.length - 1].trim(), S = n && !isNaN(U), P = e.isIncompleteSetScore;
    if (m && I) {
      let v = n.slice(g + 1).split(mn), D = v?.length > 0 && v[0] !== void 0 && !isNaN(parseInt(v[0])) && parseInt(v[0]) || void 0, y = v?.length > 1 && v[1] !== void 0 && parseInt(v[1]) || void 0, w = [D, y];
      if (y) {
        let b = i === 1 ? 1 : 0;
        w[b] = (w?.[1 - b] || 0) + (p ? 1 : 2), (w[b] || 0) < d && (w[b] = d), n = t.slice(0, g + 1), n += w.join(mn);
      } else D !== void 0 ? (n = t.slice(0, g + 1), n += D) : (n = t.slice(0, g), P = !0);
      c.side1TiebreakScore = w[0] || 0, c.side2TiebreakScore = w[1] || 0;
    }
    if (n.length || (n = void 0), P) {
      let v = c.side1Score?.toString();
      if (v) {
        let D = v?.slice(0, v.length - 1);
        c.side1Score = !isNaN(D) && parseInt(D) || void 0, c.side1Score === void 0 && (c.side2Score = void 0);
      }
      e.isTimedSet ? (a = c.side1Score ? r : r?.slice(0, r.length - 1) || [], a[r.length - 1] = c) : a = r?.slice(0, r.length - 1) || [];
    } else if (S) {
      let v = c.side2Score?.toString(), D = c.side1Score?.toString();
      if (!e.isTiebreakEntry && !e.isMatchTiebreak) if (c.side2Score) {
        let y = v?.slice(0, v.length - 1);
        c.side2Score = !isNaN(y) && parseInt(y) || void 0;
      } else {
        let y = D?.slice(0, D.length - 1);
        c.side1Score = !isNaN(y) && parseInt(y) || void 0;
      }
      e.isTimedSet ? c.side1Score ? (a = r || [], a[r.length - 1] = c) : a = r?.slice(0, r.length - 1) || [] : (a = r || [], a[r.length - 1] = c), a[a.length - 1] && Object.assign(a[a.length - 1], { winningSide: void 0 });
    } else h ? (a = r || [], Object.assign(a[a.length - 1] || {}, { winningSide: void 0, side1TiebreakScore: void 0, side2TiebreakScore: void 0 })) : (m && !I ? a = r?.slice(0, r.length - 1) || [] : (a = r, a[r.length - 1] = c), m || (a[a.length - 1].side2Score = 0, a[a.length - 1].winningSide = void 0));
    return { scoreString: n, sets: a };
  }
  return { scoreString: t, sets: r };
}
function hs({ brackets: e = Mo, scoreString: t }) {
  if (!t) return {};
  let [r, i] = e.split(""), n = t.split(""), a = Math.max(...qi(r, n)), o = Math.max(...qi(i, n));
  return { isTiebreakEntry: a > o, lastOpenBracketIndex: a };
}
function qF({ scoreString: e }) {
  if (!e) return !1;
  let t = e && e[e.length - 1].trim(), r = e && !isNaN(t), [i, n] = Va.split(""), a = e.split(""), o = Math.max(...qi(i, a)), s = Math.max(...qi(n, a)), c = Math.max(...qi(mn, a));
  return r && o > s && c > o;
}
function WF(e) {
  return e.split("").reduce((t, r, i) => (r.match(/\d+/g) && t.push(i), t), []).pop();
}
function DM(e) {
  let { lowValue: t = 0, NoAD: r = !1, tiebreakTo: i } = e || {}, n = r ? 1 : 2;
  return t + 1 >= i ? t + n : parseInt(i);
}
function my({ matchUpFormat: e, matchUpStatus: t, winningSide: r, sets: i }) {
  let n = Sr(e), { bestOf: a } = n, o = Math.ceil(a / 2), s = i?.reduce((c, u) => {
    let { winningSide: l } = u;
    return l && c[l - 1]++, c;
  }, [0, 0])?.indexOf(o) + 1 || void 0;
  return LF.includes(t) && r && (s = r), { matchUpWinningSide: s };
}
function Gp({ ignoreTiebreak: e = !1, matchUpScoringFormat: t, matchUpFormat: r, isTiebreakSet: i, isDecidingSet: n, isTimedSet: a, set: o }) {
  if (!o) return { error: ue, info: "missing set" };
  t = t || r && Sr(r);
  let s = n && t.finalSetFormat || t?.setFormat || {}, { side1Score: c, side2Score: u } = o, { setTo: l, tiebreakAt: d } = s, p = c || u, m = $p({ set: o }), f = Math.abs(c - u), h = c >= l || u >= l, g = i || c >= l && u >= l || d && d < l && (c === d || u === d), I = e || g && (m === 1 && o.side1TiebreakScore > o.side2TiebreakScore || m === 2 && o.side2TiebreakScore > o.side1TiebreakScore), U = !g && s.NoAD || g || i && s.tiebreakFormat?.NoAD ? 1 : 2, S = f >= U;
  return !!((a && p || h && (S || g) || i) && (!g || I));
}
function $p({ set: e }) {
  if (e.side1Score || e.side2Score) {
    if (e.side1Score > e.side2Score) return 1;
    if (e.side2Score > e.side1Score) return 2;
  } else if (e.side1TiebreakScore || e.side2TiebreakScore) {
    if (e.side1TiebreakScore > e.side2TiebreakScore) return 1;
    if (e.side2TiebreakScore > e.side1TiebreakScore) return 2;
  }
}
function VI({ analysis: e, set: t }) {
  let r = $p({ set: t }), { isDecidingSet: i, isTiebreakSet: n, matchUpScoringFormat: a } = e;
  return Gp({ matchUpScoringFormat: a, isDecidingSet: i, isTiebreakSet: n, set: t }) && r;
}
function HF({ analysis: e, scoreString: t, sets: r, value: i }) {
  let n;
  if (!r?.length) return { sets: [] };
  let a = r[r.length - 1];
  i = pe(i);
  let { validSide2Score: o, requiresTiebreak: s } = zF({ analysis: e, set: a, value: i });
  if (o) {
    n = !0, t = (t || "") + i, a.side2Score = i;
    let c = VI({ analysis: e, set: r[r.length - 1] });
    if (a.winningSide = c || void 0, s) {
      let u = Mo.split("")[0];
      t += u;
    } else e.isDecidingSet || (t += " ");
  }
  return { sets: r, scoreString: t, updated: n };
}
function zF({ analysis: e, set: t = {}, value: r }) {
  let i = e.isDecidingSet && e.matchUpScoringFormat.finalSetFormat || e.matchUpScoringFormat.setFormat, { tiebreakAt: n, setTo: a, NoAD: o } = i, { side1Score: s } = t, c, u;
  return n && n < a ? s === n ? c = r <= a : c = r <= n : s === a ? o ? c = r < a : c = r <= a + 1 : s === a - 1 ? o ? c = r <= a : c = r <= a + 1 : s === a + 1 ? c = r === a || r === a - 1 : c = r <= a, c && (n && n < a ? u = s === a && r === n || s === n && r === a : u = s >= a && r >= a && s !== r), { validSide2Score: c, requiresTiebreak: u };
}
function wM({ lowSide: e, value: t, sets: r, scoreString: i, winningSide: n, matchUpStatus: a }) {
  let o;
  return t === dM ? i ? (o = !0, i = as({ scoreString: i, lowSide: e, outcome: "RET" }), n = e === 2 ? 1 : 2, a = uM) : (o = !0, i = as({ scoreString: i, lowSide: e, outcome: "DEF" }), n = e === 2 ? 1 : 2, a = Vf) : t === fM ? (o = !0, i = as({ scoreString: i, lowSide: e, outcome: "DEF" }), n = e === 2 ? 1 : 2, a = Vf) : t === hM ? (o = !0, r = [], i = "WO", n = e === 2 ? 1 : 2, a = oM) : t === pM && i ? (o = !0, i = as({ scoreString: i, lowSide: e, outcome: "SUS" }), a = cM, n = void 0) : t === mM ? (o = !0, i = as({ scoreString: i, lowSide: e, outcome: "ABN" }), a = sM, n = void 0) : t === gM && i && (o = !0, i = as({ scoreString: i, lowSide: e, outcome: "INT" }), a = lM, n = void 0), { updated: o, sets: r, scoreString: i, matchUpStatus: a, winningSide: n };
}
function YF(e) {
  let { sets: t, info: r, scoreString: i, winningSide: n, matchUpStatus: a } = e, { analysis: o, lowSide: s, value: c } = e, u, l;
  !t?.length && c !== md && (t = [{ setNumber: 1 }]);
  let d = t.length - 1;
  if (Vp.includes(c)) {
    let p = t[t.length - 1] || {}, { side1Score: m, side2Score: f } = p;
    m && !f ? r = "missing side2Score" : o.finalSetIsComplete || n ? r = "final set is already complete" : o.isIncompleteSetScore ? r = "incomplete set scoreString" : o.isIncompleteSetScore || ({ sets: t, scoreString: i, winningSide: n, matchUpStatus: a, updated: u } = wM({ lowSide: s, value: c, sets: t, scoreString: i, matchUpStatus: a, winningSide: n }));
  } else if (c === md) {
    if ({ scoreString: i, sets: t, outcomeRemoved: l } = jf({ analysis: o, scoreString: i, sets: t }), i?.trim() === "" && (i = i.trim()), i || (t = []), l) {
      let p = t[t.length - 1] || {}, { side1Score: m, side2Score: f } = p;
      if (m && f) {
        let h = m > f && 1 || f > m && 2 || void 0;
        h && (p.winningSide = h, t.push({ setNumber: t.length + 1 }));
      }
    }
    a = void 0, n = void 0, u = !0;
  } else if (o.hasOutcome) r = "has outcome";
  else {
    if (n) return { sets: t, scoreString: i, winningSide: n, matchUpStatus: a, updated: !1, info: "matchUp is complete" };
    if (c === jp) {
      let p = t[t.length - 1] || {}, { side1Score: m, side2Score: f } = p, h = m > f && 1 || f > m && 2 || void 0;
      h && !n && !o.isIncompleteSetScore && (t[t.length - 1].winningSide = h, t.push({ setNumber: t.length + 1 }), i += " ", u = !0);
    } else if (c === ho && t[d].side1Score !== void 0 && t[d].side2Score === void 0 && i && o.isNumericEnding) i += "-", t[d].side2Score = 0, a = void 0, n = void 0, u = !0;
    else if (!isNaN(c)) {
      let p;
      if (t[d].side2Score === void 0) {
        let m = pe((t[d].side1Score || 0).toString() + c).toString().slice(0, 2);
        t[d].side1Score = pe(m), p = t[d].side1Score.toString(), u = !0;
      } else {
        let m = pe((t[d].side2Score || 0).toString() + c).toString().slice(0, 2);
        t[d].side2Score = pe(m), p = [t[d].side1Score, t[d].side2Score].join("-"), u = !0;
      }
      if (u) {
        let m = (t.slice(0, d) || []).filter((f) => f).map((f) => {
          let { side1Score: h, side2Score: g } = f;
          return [h, g].join("-");
        }).join(" ");
        m ? i = m + " " + p : i = p;
      }
    }
  }
  return { sets: t, scoreString: i, winningSide: n, matchUpStatus: a, info: r, updated: u };
}
function KF({ analysis: e, auto: t, lowSide: r, scoreString: i = "", sets: n, value: a }) {
  let o, s, { tiebreakSet: { tiebreakTo: c, NoAD: u } } = e.setFormat, [l] = Va.split("");
  if (e.isMatchTiebreakEntry || (i += l), n[e.setNumber - 1]) {
    let { lastOpenBracketIndex: d } = hs({ brackets: Va, scoreString: i }), p = (i.slice((d ?? 0) + 1) + (t ? "" : a)).split(mn);
    if ((p[r - 1]?.length || 0) >= 2) s = "tiebreak digit limit";
    else if (t) {
      r === 1 && (p[0] = (p[0] || "") + a), r === 2 && (p[1] = (p[1] || "") + a);
      let m = [p[0] || 0, p[1] || 0].map((g) => pe(g)), f = r === 1 ? 1 : 0;
      m[f] = m[1 - f] + (u ? 1 : 2), m[f] < c && (m[f] = c);
      let h = n[n.length - 1];
      h.side1TiebreakScore = m[0], h.side2TiebreakScore = m[1], i = i.slice(0, (d ?? 0) + 1), i += m.join(mn), o = !0;
    } else {
      let m = [p[0] || 0, p[1] || 0].map((h) => pe(h)), f = n[n.length - 1];
      f.side1TiebreakScore = m[0], f.side2TiebreakScore = m[1], i += a, o = !0;
    }
  } else {
    let d = DM({ lowValue: pe(a || 0), tiebreakTo: c, NoAD: u }), p = [pe(a), d];
    r === 2 && p.reverse();
    let m = { side1TiebreakScore: p[0], side2TiebreakScore: p[1], setNumber: n?.length + 1 || 1 };
    n.push(m), i += p.join(mn), o = !0;
  }
  return { info: s, scoreString: i, sets: n, updated: o };
}
function QF({ analysis: e, lowSide: t, scoreString: r, value: i }) {
  let { setTo: n, tiebreakAt: a, NoAD: o } = e?.setFormat || {}, s = i === parseInt(a || n);
  if (a && a < n && i > a) return { scoreString: r };
  if (o && i === n || i > n) return { scoreString: r };
  let c = f(), u = [i, c];
  t === 2 && u.reverse();
  let l = Mo.split("")[0], d = u.join(ho) + (s ? l : " ");
  r = (r || "") + d;
  let p = { side1Score: u[0], side2Score: u[1] }, m = VI({ analysis: e, set: p });
  return p.winningSide = m || void 0, { scoreString: r, set: p };
  function f() {
    return s ? i + 1 : i + 1 === n ? i + (o ? 1 : 2) : n;
  }
}
function XF({ matchUpFormat: e, scoreString: t, winningSide: r, value: i, sets: n }) {
  let a = (n?.filter((_) => _?.winningSide)?.length || 0) + (r ? 0 : 1), o = Sr(e), s = a === o?.bestOf, c = s && o?.finalSetFormat || o?.setFormat || {}, u = c?.timed, l = s && n[o?.bestOf - 1], d = l?.winningSide, { isTiebreakEntry: p } = hs({ brackets: Mo, scoreString: t }), { isTiebreakEntry: m } = hs({ brackets: Va, scoreString: t }), f = p || m, h = !!c.tiebreakSet, g = t?.[t.length - 1]?.trim(), I = t && !isNaN(g), U = !f && g === ho, S = p && jm.includes(g), P = m && jm.includes(g), v = m && g === mn, D = t?.split(""), [y] = Va.split(""), w = D && Math.max(...qi(y, D)), b = D && Math.max(...qi(mn, D)), T = D && b > w, R = n[n.length - 1]?.winningSide, M = n?.length && !R, E = aM.find((_) => t?.indexOf(_) >= 0), A = !isNaN(i), N = i === jp, C = fd.includes(i), k = t?.split("").find((_) => jm.includes(_)), O = C && m && !P && (v || !qF({ scoreString: t }));
  return { isTiebreakSetValue: h && A, matchUpScoringFormat: o, setNumber: a, setFormat: c, matchTiebreakHasJoiner: T, isGameScoreEntry: M, isSpace: N, isCloser: C, isTiebreakCloser: C && k && f && I, isDecidingSet: s, isTiebreakSet: h, isTimedSet: u, isNumericEnding: I, isNumericValue: A, hasOpener: k, hasOutcome: E, finalSet: l, finalSetIsComplete: d, lastSetIsComplete: R, isInvalidSetTiebreakValue: N && f && S, isInvalidMatchTiebreakValue: O, isTiebreakEntry: f, isSetTiebreakEntry: p, isMatchTiebreakEntry: m, isIncompleteSetScore: U, isIncompleteSetTiebreak: S, isIncompleteMatchTiebreak: P, isPartialMatchTiebreakValue: v };
}
function TM(e) {
  let { lowSide: t = 1, value: r } = e, { scoreString: i, sets: n, winningSide: a, matchUpStatus: o } = e, { matchUpFormat: s, shiftFirst: c, auto: u = !0 } = e, l, d, p = c && t === 2 || !c && t === 1;
  if (!vM.includes(r)) return { updated: !1, info: "invalid key" };
  c && (t = 3 - t);
  let { matchUpWinningSide: m } = my({ sets: n, winningSide: a, matchUpStatus: o, matchUpFormat: s });
  a = m;
  let f = XF({ value: r, winningSide: a, scoreString: i, sets: n, matchUpFormat: s });
  if (UM.includes(r) && (r = ho), f.hasOpener && f.isTiebreakEntry && !f.isTiebreakSet && p && pe(r) === 0 && (f.isTiebreakCloser = !0), fd.includes(r) && f.hasOpener && (r = ""), fd.includes(r) && (r = jp), f.lastSetIsComplete) {
    let h = i?.length && i[i.length - 1];
    i && h !== " " && (i += " ");
  }
  if (f.isTimedSet) ({ info: d, sets: n, scoreString: i, updated: l, matchUpStatus: o, winningSide: a } = YF({ analysis: f, lowSide: t, scoreString: i, sets: n, matchUpStatus: o, winningSide: a, value: r }));
  else if (Vp.includes(r)) f.finalSetIsComplete || a ? d = "final set is already complete" : !f.isTiebreakEntry && !f.isIncompleteSetScore ? { sets: n, scoreString: i, matchUpStatus: o, winningSide: a, updated: l } = wM({ lowSide: t, sets: n, scoreString: i, matchUpStatus: o, winningSide: a, value: r }) : f.isTiebreakEntry || f.isIncompleteSetScore ? d = "incomplete set scoreString or tiebreak entry" : console.log("handle case", { value: r });
  else if (r === md) l = !0, { scoreString: i, sets: n } = jf({ analysis: f, scoreString: i, sets: n, lowSide: t }), i || (n = []), o = void 0, a = void 0;
  else if (f.hasOutcome) d = "has outcome";
  else if (r === ho && !f.isMatchTiebreakEntry) (!f.isSetTiebreakEntry || f.isSetTiebreakEntry && !f.isNumericEnding) && (l = !0, { scoreString: i, sets: n } = jf({ analysis: f, scoreString: i, sets: n, lowSide: t }), o = void 0);
  else if (r === mn && f.isMatchTiebreakEntry && !f.isSetTiebreakEntry) f.matchTiebreakHasJoiner ? d = "existing joiner" : f.isNumericEnding && (l = !0, i += mn);
  else if ([ho, mn].includes(r)) d = "invalid location for joiner";
  else {
    if (a) return { updated: !1, info: "matchUp is complete" };
    if (f.isIncompleteSetScore) f.isNumericValue && ({ sets: n, scoreString: i, updated: l } = HF({ analysis: f, scoreString: i, sets: n, value: r }));
    else if (f.isInvalidMatchTiebreakValue) d = "invalid matchUp tiebreak character";
    else if (f.isInvalidSetTiebreakValue) d = "invalid set tiebreak character";
    else if (f.isTiebreakCloser) {
      let h = f.isSetTiebreakEntry ? Mo : Va, g = h.split("").reverse()[0], I = h.split("")[0], U = n[n.length - 1], { tiebreakFormat: S } = f.setFormat, { tiebreakTo: P, NoAD: v } = S || {}, D = $p({ set: U });
      if (!f.isTiebreakSet) {
        let w = parseInt(i.split(I).reverse()[0]), b = DM({ lowValue: w, tiebreakTo: P, NoAD: v });
        D === 1 ? (U.side1TiebreakScore = b, U.side2TiebreakScore = w) : (U.side1TiebreakScore = w, U.side2TiebreakScore = b);
      }
      i = (i || "") + g, f.isDecidingSet || (i += " ");
      let y = VI({ analysis: f, set: U });
      U.winningSide = y || void 0, l = !0;
    } else if (f.isTiebreakSetValue) ({ info: d, scoreString: i, sets: n, updated: l } = KF({ analysis: f, auto: u, lowSide: t, scoreString: i, sets: n, value: r }));
    else if (f.isSetTiebreakEntry) {
      let [h] = Mo.split(""), g = Math.max(...qi(h, i.split(""))), I = i.slice(g + 1), U = I && pe(I) === VF, S = pe(I ? I + r : r), { tiebreakFormat: P } = f.setFormat, { tiebreakTo: v, NoAD: D } = P || {};
      !U && I.length < 2 ? D && S > v - 1 ? d = "invalid low value for NoAD tiebreak" : (l = !0, i = (i || "") + r) : d = U ? "tiebreak begins with zero" : "tiebreak digit limit";
    } else if (f.isCloser) d = `invalid key: ${r}`;
    else if (f.isGameScoreEntry) d = "game scoreString entry";
    else if (f.lastSetIsComplete || !n.length) {
      l = !0;
      let { scoreString: h, set: g } = QF({ analysis: f, lowSide: t, scoreString: i, value: pe(r) });
      g && (g.setNumber = n?.length + 1 || 1), n = n?.concat(g).filter(Boolean) || [g], i = h || void 0;
    } else console.log("error: unknown outcome");
  }
  if (l) {
    n = n?.filter(Boolean);
    let { matchUpWinningSide: h } = my({ sets: n, winningSide: a, matchUpStatus: o, matchUpFormat: s });
    return a = h, h && (!o || [Dt, $r].includes(o)) ? (o = xF, n = n.filter((g) => {
      let { side1Score: I, side2Score: U, side1TiebreakScore: S, side2TiebreakScore: P } = g;
      return I || U || S || P;
    })) : i && !a && ![cM, sM, lM].includes(o) && (o = void 0), { updated: l, scoreString: i, sets: n, winningSide: a, matchUpStatus: o, info: d };
  }
  return { updated: l, scoreString: i, sets: n, winningSide: a, matchUpStatus: o, info: d };
}
var qp = "\\d+-\\d+", iu = "\\d+-\\d+\\(\\d+\\)", jI = "\\[\\d+-\\d+\\]", JF = "\\d+-\\d+\\(\\d+-\\d+\\)", ZF = new RegExp(`(${qp}),`, "g"), eL = new RegExp(`(${iu}),`, "g"), tL = [qp, iu, jI, JF], rL = ["0", "1", "2", "00", "01", "10", "11", "002", "012", "102", "112", "000", "001", "010", "100", "011", "101", "110", "111", "002", "012", "102", "112", "0002", "0012", "0102", "1002", "0112", "1012", "1102", "1112", "3", "03", "13", "013", "103"], iL = rL.map((e) => {
  let t = e.split("").map((r) => tL[r]).join(" ");
  return new RegExp(`^${t}$`);
});
function fy(e) {
  return !e || iL.some((t) => t.test(e));
}
function nL(e) {
  let t = "[];()", r = ["[", "("], i = Object.assign({}, ...t.split("").map((o) => ({ [o]: 0 }))), n = "", a = e.split("").map((o) => {
    let s = t.includes(o) && o, c = r.includes(s);
    if (c && s) return i[s] += 1, n = s, o;
    if (!c && s && n && s !== n) {
      i[n] -= 1;
      let u = "[];".includes(n) && "[];" || "()".includes(n) && "()" || "", l = u.split("").find((d) => d !== n);
      if (u.includes(s)) i[n] || (n = "");
      else return i[s] || (n = ""), l;
    }
    return o;
  }).join("");
  return e !== a ? a : e;
}
function Gl(e) {
  return /^\(\d+\)$/.test(e) || /^\(\d+$/.test(e);
}
function aL(e) {
  return /^\(\d+-\d+\)$/.test(e) || /^\[\d+-\d+\]$/.test(e);
}
function xs(e) {
  let t = ((r) => r?.split("-").join("").split("/").join(""))(e);
  if (/^\d+$/.test(t) && t.length === 2) {
    let r = t.split("");
    return Math.abs(r.reduce((i, n) => +i - +n)) === 1;
  }
  return !1;
}
function hd(e, t) {
  let r = [e.slice(t, t + 2), t ? e.slice(0, 1) : e.slice(2)].map((n) => parseInt(n.join("")));
  t && r.reverse();
  let i = r;
  if (Math.abs(i.reduce((n, a) => +n - +a)) >= 2) return i.join("-");
}
function hy(e) {
  return e.length === 2 ? e.split("").join("-") : ([", ", ",", "/", " "].forEach((t) => e = e.split(t).join("-")), e = e.replace(/-{2,}/, "-"), e);
}
function oL(e) {
  return e.startsWith("(") && e.endsWith(")");
}
function sL({ score: e, applied: t }) {
  e = nL(e);
  let r = /\)(\d+)/g;
  if (r.test(e)) for (let D of e.match(r)) {
    let y = D.replace(")", ") ");
    e = e.replace(D, y);
  }
  e = e.replace(/\)\//g, ") / "), e = e.replace(/\/\)/g, ")");
  let i = /\(([\d- ]+)\)/g, n = /\(([\d- ]+)\)/, a = e.match(i);
  for (let D of a || []) {
    let [y] = D.match(n).slice(1), w = y.replace(/ /g, "");
    e = e.replace(D, `(${w})`);
  }
  let o = /\(\(\d-\d\)\)/g;
  if (o.test(e)) {
    let D = e.match(o);
    D.length && D.forEach((y) => {
      let w = y.match(/\((\(\d-\d\))\)/).slice(1)[0];
      e = e.replace(y, w);
    });
  }
  if (o = /\(\((\d)\)\)/g, o.test(e)) {
    let D = e.match(o);
    D.length && D.forEach((y) => {
      let w = y.match(/\((\(\d\))\)/).slice(1)[0];
      e = e.replace(y, w);
    });
  }
  /(^|\s)6-,/.test(e) && (e = e.replace(/(^|\s)6-,/g, "6-0,"));
  let s = new RegExp(/[-,]{2,}/g);
  e = e.replace(s, "-"), ["- ", " -"].forEach((D) => {
    let y = new RegExp(`(\\d+)${D}(\\d+)`, "g"), w = e.match(y);
    w && w.forEach((b) => e = e.replace(b, b.split(D).join("-")));
  }), /^[(-/,]+$/.test(e) && (e = ""), /\)[-/,]+$/.test(e) && (e = e.slice(0, e.length - 1)), /\d \/\d/.test(e) && (e = e.replace(/ \//g, "/")), e.includes(" /") && (e = e.replace(/ \//g, " "));
  let c = /\(\d+, \)/g;
  c.test(e) && e.match(c).forEach((D) => {
    let [y] = D.match(/\((\d+), \)/).slice(1);
    y.length === 2 ? e = e.replace(D, `(${y})`) : y.length === 1 && y === "6" && (e = e.replace(D, "(6-0)"));
  });
  let u = /\((\d+)\/\)/g;
  u.test(e) && e.match(u).forEach((D) => {
    let [y] = D.match(/\((\d+)\/\)/).slice(1);
    y.length === 2 ? e = e.replace(D, `(${y})`) : y.length === 1 && y === "6" ? e = e.replace(D, "(6-0)") : e = e.replace(D, `(${y})`);
  });
  let l = /\d\/\d\/,/g;
  l.test(e) && e.match(l).forEach((D) => {
    let [y] = D.match(/(\d\/\d)\/,/).slice(1);
    e = e.replace(D, `${y},`), t.push("slashComma");
  });
  let d = /\(\/(\d+)\)/g;
  d.test(e) && e.match(d).forEach((D) => {
    let [y] = D.match(/\(\/(\d+)\)/).slice(1);
    y.length === 2 ? e = e.replace(D, `(${y})`) : y.length === 1 && parseInt(y) < 6 ? e = e.replace(D, `(6-${y})`) : e = e.replace(D, `(${y})`);
  });
  let p, m, f, h, g, I = () => {
    g = Br(e.split("")), m = g["("] === (g[")"] || 0) + 1, p = (g["("] || 0) + 1 === g[")"], f = g["["] === g["]"] + 1, h = m && !f;
  };
  I();
  let U = /(\d+-\d+\(\d+)0,/;
  if (U.test(e)) {
    let [D] = e.match(U).slice(1);
    e = e.replace(U, D + ")");
  }
  if (g["("] === g[")"] && g["("] > 1) {
    let D = e.split(")(").join(") (").split(" ");
    D.every(oL) ? e = D.map((y) => {
      let w = y.slice(1, y.length - 1);
      return w.length > 2 ? w : y;
    }).join(" ") : e = D.join(" ");
  }
  I();
  let S = /[A-Za-z]+/.test(e), P = /\d+/.test(e);
  if (!S && !P) return { score: "" };
  if (/^\[.+\]$/.test(e) && "()/,- ".split("").some((D) => g[D]) && (e = e.slice(1, e.length - 1)), /^\(.+\)$/.test(e) && g["("] === 1 && g[")"] === 1 && "[]/,".split("").some((D) => g[D] > 1) && (e = e.slice(1, e.length - 1)), e.startsWith("(") && e.endsWith("))") && (e = e.slice(1, e.length - 1)), g["("] > (g[")"] || 0) && e[e.length - 1] === "(" && (e = e.slice(0, e.length - 1) + ")", I()), g["("] === 1 && !g[")"] && e[0] === "(" && (e = e + ")", I()), g["("] > (g[")"] || 0) && e.slice(0, 2) === "((" && (e = e.slice(1)), p) {
    if (/^9\d/.test(e)) e = "(" + e.slice(1);
    else if (e[0] !== "(") e = "(" + e;
    else {
      let D = [], y = 0;
      for (let w of e.split("").reverse()) w === ")" && (y ? D.push("(") : y += 1), w === "(" && (y -= 1), D.push(w);
      D.reverse(), e = D.join("");
    }
    I();
  }
  if (g[")"] > (g["("] || 0) && e[0] === ")" && (e = "(" + e.slice(1), I()), h && (e.endsWith(9) || /\d+0$/.test(e)) && (e = e.slice(0, e.length - 1) + ")", I()), h && (!e.endsWith(")") || e.startsWith("((")) && (e = e + ")", I()), h) {
    let D = "", y = 0;
    for (let w of e.split("")) w === "(" && (y ? D += ")" : y += 1), w === ")" && (y -= 1), D += w;
    e = D;
  }
  I(), f && !m && (e = e + "]"), e.includes("([") && e.includes("])") && (e = e.split("([").join("[").split("])").join("]"), I()), /\(\d+0$/.test(e) && (e = e.slice(0, e.length - 1) + ")"), I(), g[")"] === 1 && !g["("] && e.endsWith(")") && (e = e.slice(0, e.length - 1)), e.startsWith("(") && e.endsWith(")") && g["("] === 1 && g[")"] === 1 && (e = e.slice(1, e.length - 1), I());
  let v = (D) => {
    let y = D.indexOf("("), w = D.indexOf(")");
    return y >= 0 && w >= 0 && y < w;
  };
  if (/^\([\d ]+.*[\d ]+\)$/.test(e) && g["("] === g[")"]) {
    let D = e.slice(1, e.length - 1);
    v(D) && (e = D, I());
  }
  return { score: e, applied: t };
}
function Wp(e) {
  if (!/^[\d-]+(\(\d\))*$/.test(e)) return e;
  let t = qi("-", e.split(""));
  if (!t.length) return e;
  let r = e.split("-"), i = !(r.length % 2), n = !!(t.length % 2);
  return i && n && t.length > r.length / 2 && t.filter((a, o) => o % 2).forEach((a) => {
    e = e.substring(0, a) + " " + e.substring(a + 1);
  }), e;
}
function cL({ score: e, applied: t }) {
  return e.includes("( ") && (t.push("removeParenSpacingAfterOpen"), e = e.split("( ").map((r) => r.trim()).join("(")), e.includes(" )") && (t.push("removeParenSpacingBeforeClose"), e = e.split(" )").map((r) => r.trim()).join(")")), [ZF, eL].forEach((r) => {
    let i = e.match(r);
    i?.length && (i.forEach((n) => {
      e = e.replace(n, n.slice(0, n.length - 1) + " ");
    }), t.push("setsEndComma"));
  }), e = e.split(" ").filter(Boolean).map(Wp).join(" "), { score: e, applied: t };
}
function uL({ score: e }) {
  if (typeof e != "string") return { score: e };
  let t = (p) => p?.split("-").join("").split("/").join(""), r = (p) => p.split("[").join("(").split("]").join(")");
  e = e.split(", ").join(" ");
  let i = e.split(" ");
  e = i.map((p) => {
    let m = /^-(\d+)$/;
    if (m.test(p)) {
      let [f] = p.match(m).slice(1);
      if (f.length === 2) return f.split("").join("-");
    }
    return p;
  }).join(" "), i = e.split(" ");
  let n = i.filter(Gl), a = 0, o = "";
  for (let p of n) {
    let m = qi(p, i).filter((I) => !a || I > a)[0], f = i.slice(a, m - 1), h = i[m - 1], g = t(h);
    if (/^\d+$/.test(g) && g.length === 2) {
      let I = g.split(""), U = Math.abs(I.reduce((S, P) => +S - +P));
      if (U === 1) {
        let S = [f.join(" "), [h, p].join("")].join(" ");
        o += S, a = m + 1;
      } else if (U === 0) {
        let S = Math.max(...I);
        if ([4, 5, 6, 7, 8, 9].includes(S)) {
          let P = [6, 4].includes(S) ? S + 1 : S - 1, v = [S, P].sort().reverse().join("-"), D = [f.join(" "), [v, p].join("")].join(" ");
          o += D, a = m + 1;
        }
      }
    }
  }
  if (n.length && o.length) {
    let p = i.slice(a).join(" ");
    return o = [o, p].join(" "), { score: o.trim() };
  }
  if (i.length === 2 && ["(", "["].some((p) => i[1].includes(p))) {
    let p = t(i[0]).split("");
    if (Math.abs(p.reduce((m, f) => +m - +f, 0)) === 1) return i[1] = r(i[1]), { score: i.join("") };
  }
  let s = i.map((p) => aL(p) && "bracket" || xs(p) && "set");
  if (s.includes("set") && s.includes("bracket")) {
    let p, m = "";
    return i.forEach((f, h) => {
      s[h] === "bracket" && p === "set" ? (f = r(f), m += f) : m += ` ${f}`, p = s[h];
    }), { score: m.trim() };
  }
  i = e.split(" ");
  let c, u = i.map((p) => {
    let m = new RegExp(/^(\d+)-(\d+)$/);
    if (m.test(p)) {
      let [f, h] = p.match(m).slice(1), g = Math.abs([f, h].reduce((U, S) => +U - +S)), I = Math.max(f, h);
      if (g === 1) return c = "tiebreakSet", c;
      if (g >= 2 && I >= 7 && c === "tiebreakSet") return c = "tiebreak", c;
    }
  }), l = qi("tiebreak", u);
  if (l.length) {
    let p = "";
    i.forEach((m, f) => {
      l.includes(f) ? p += `(${m}) ` : l.includes(f + 1) ? p += `${m}` : p += `${m} `;
    }), e = p.trim();
  }
  let d = /(\d+-\d+)\((\d+)-(\d+)\)$/;
  if (d.test(e)) {
    let [p, m, f] = e.match(d).slice(1), h = Math.max(m, f) >= 10;
    !xs(p) && h && (e = e.replace(d, `${p} [${m}-${f}]`));
  }
  return u = [], e = e.split(" ").map((p) => {
    let m = /^\((.*)\)$/, f = m.test(p), h = new RegExp(jI).test(p) && "super" || new RegExp(iu).test(p) && "tiebreak" || new RegExp(qp).test(p) && "standard" || "unknown";
    return u.push(h), h === "standard" && f ? p.match(m)[1] : p;
  }).join(" "), { score: e };
}
function lL({ score: e, applied: t }) {
  for (let w of [".", ",", " ", "/"]) {
    let b = new RegExp(`^(\\d+)\\${w}(\\d+)$`);
    if (b.test(e)) {
      let T = e.match(b).slice(1).map((M) => parseInt(M)), R = Math.abs(T[0] - T[1]);
      R <= 10 && R >= 2 && (e = e.split(w).join("-"), t.push("variedJoinerPattern"));
    }
  }
  e.includes(";") && (e = e.split(";").join(" "), t.push("semicolon set separation"));
  let r = /(^|\s)(\d)\/(\d)(\d)\/(\d)(\(|$)/;
  if (r.test(e)) {
    let [w, b, T, R, M, E] = e.match(r).slice(1);
    e = e.replace(r, `${w}${b}-${T} ${R}-${M}${E}`), t.push("smashSlashPattern");
  }
  /.*\s6[/-]+$/.test(e) && (e += "0", t.push("incompleteFinalSetPattern"));
  let i = /\(6,\)/g;
  i.test(e) && (e = e.replace(i, "(6, 0)"), t.push("missingZeroPattern1"));
  let n = /^\d{3,}\(/, a = /\(\d+\)\d+/;
  [n, a].forEach(() => {
    e = e.split(" ").map((w) => (n.test(w) && (w = w.replace("(", " (")), a.test(w) && (w = w.replace(")", ") ")), w)).join(" "), t.push("spaceConsiderationPatterns");
  });
  let o = Wp(e);
  o !== e && (e = o, t.push("deDashMash"));
  let s = /^(\d)[-/,]+(\d{2})[-/,]+(\d)$/;
  if (s.test(e)) {
    let [w, b, T] = e.match(s).slice(1), [R, M] = b.split("");
    e = `${w}-${R} ${M}-${T}`, t.push("smashSetPattern");
  }
  let c = /^(\d+)[ -](\d+)$/, u = /^([\d -]+)\/([\d -]+)$/;
  if (u.test(e)) {
    let [w, b] = e.match(u).slice(1), T = w.trim(), R = b.trim();
    if (c.test(T) && c.test(R)) {
      let M = T.match(c).slice(1, 3).join("-"), E = R.match(c).slice(1, 3).join("-");
      e = `${M} ${E}`, t.push("slashSeparationPattern");
    }
  }
  let l = /^([\d -]+),([\d -]+)$/;
  if (l.test(e)) {
    let [w, b] = e.match(l).slice(1), T = w.trim(), R = b.trim();
    if (c.test(T) && c.test(R)) {
      let M = T.match(c).slice(1, 3).join("-"), E = R.match(c).slice(1, 3).join("-");
      e = `${M} ${E}`, t.push("commaSeparationPattern");
    }
  }
  let d = /^\d \d,/;
  if (d.test(e)) {
    let w = e.match(d)[0], b = w.slice(0, w.length - 1).split(" ").join("-");
    e = e.replace(w, b), t.push("singleSetCommaSeparationPattern");
  }
  let p = 0, m = /(\d+)-(\d{2})-(\d+)/;
  for (; m.test(e) && p < 3; ) {
    let [w, b, T] = e.match(m).slice(1), R = b.split(""), M = `${w}-${R[0]} ${R[1]}-${T}`;
    e = e.replace(m, M), t.push("noSetSeparationPattern"), p += 1;
  }
  let f = /(^|\s)7-6\s(\d+)\s/g, h = e.match(f);
  if (h?.length) {
    let w = /(^|\s)7-6\s(\d+)\s/;
    h.forEach((b) => {
      let T = b.match(w).slice(2)[0];
      e = e.replace(b, `7-6(${T}) `), t.push("floatingTiebreakPattern1");
    });
  }
  let g = e.match(/\d \d /);
  g?.forEach((w) => {
    let b = w.slice(0, w.length - 1).split(" ").join("-");
    e = e.replace(w, b), t.push("spaceSeparatedSetPattern1");
  }), g = e.match(/ \d \d$/), g?.forEach((w) => {
    let b = " " + w.slice(1).split(" ").join("-");
    e = e.replace(w, b), t.push("spaceSeparatedSetPattern2");
  });
  let I = /^\d, *\d\/\d, *\d/;
  if (I.test(e)) {
    let w = e.match(I)[0], b = w.split("/").map((T) => `(${T})`).join(" ") + " ";
    e = e.replace(w, b), t.push("slashCommaSetPattern");
  }
  let U = /\(6-\)/g;
  U.test(e) && (e = e.replace(U, "(6-0)"), t.push("missingZeroPattern2"));
  let S = new RegExp("(?<!-)(\\d+)\\/(\\d+)(?!-)", "g");
  if (S.test(e)) {
    let w = e.match(S), b = new RegExp("(?<!-)(\\d+)\\/(\\d+)(?!-)"), T = e;
    w.forEach((R) => {
      let [M, E] = R.match(b).slice(1), A = `${M}-${E}`;
      T = T.replace(R, A);
    }), e = T, t.push("slashSetPattern");
  }
  let P = /(.*)\s(1\d)\s(\d+)$/;
  if (P.test(e)) {
    let [w, b, T] = e.match(P).slice(1);
    w.replace(/\D/g, "").length >= 4 && (e = w + ` ${b}${T}`, t.push("spaceSeparatedSuperPattern"));
  }
  let v = /(^|\s)(\d+-\d+)\s(\d+)(\s|$)/g;
  for (let w of e.match(v) || []) {
    let [b, T, R, M] = w.match(/(^|\s)(\d+-\d+)\s(\d+)(\s|$)/).slice(1), [E, A] = T.split("-").map((N) => parseInt(N));
    Math.abs(E - A) === 1 && (e = e.replace(w, `${b}${T}(${R})${M}`), t.push("spaceSeparatedSetPattern"));
  }
  let D = /\d-\d \(\d{1,2}\)(\s|$|,)/g;
  for (let w of e.match(D) || []) {
    let b = /(\d-\d) \((\d{1,2})\)(\s|$|,)/, [T, R, M] = w.match(b).slice(1), [E, A] = T.split("-").map((N) => parseInt(N));
    Math.abs(E - A) === 1 && (e = e.replace(w, `${T}(${R})${M}`), t.push("floatingTiebreakPattern2"));
  }
  let y = /(^|\s)(\d \d)\(/g;
  for (let w of e.match(y) || []) {
    let b = /(^|\s)(\d \d)\(/, [T, R] = w.match(b).slice(1);
    e = e.replace(w, `${T}${R.split(" ").join("-")}(`), t.push("spacedTiebreakPattern");
  }
  return { score: e, applied: t };
}
function dL({ score: e, matchUpStatus: t }) {
  let r = e?.split(" ");
  e = r.map((s) => {
    if (s.endsWith("]")) {
      let c = s.split("[");
      if (xs(c[0])) return c[0] + `(${c[1].slice(0, c[1].length - 1)})`;
    }
    return s;
  }).join(" ");
  let i = new RegExp(/(\([\d ]+\))/g);
  if (i.test(e)) for (let s of e.match(i)) {
    let c = s.replace(" ", "-").match(/\((.*)\)/)?.[1];
    if (gt(c) && c?.[0] > 2) {
      if ([2, 4].includes(c.length)) c = c.split("").join("-");
      else if (c.length === 3) {
        let u = c.indexOf("1");
        c = hd(c.split(""), u);
      }
    }
    e = e.replace(s, `(${c})`);
  }
  r = e?.split(" ");
  let n = new RegExp(/^(\d[-/]+\d)\((\d+)[-/]+(\d+)\)$/), a = r.length - 1;
  e = r.map((s, c) => {
    let u = [void 0, "", "COMPLETED"].includes(t) || c !== a;
    if (n.test(s) && u) {
      let [l, d, p] = Array.from(s.match(n)).slice(1), m = Math.min(d, p);
      return `${l}(${m})`;
    }
    return s;
  }).join(" "), r = e?.split(" "), n = new RegExp(/^(\d{2})\((\d+)\)$/), e = r.map((s) => {
    if (n.test(s)) {
      let [c, u] = Array.from(s.match(n)).slice(1), l = c.split("");
      return `${l[0]}-${l[1]}(${u})`;
    }
    return s;
  }).join(" "), r = e?.split(" "), n = new RegExp(/^\((\d[-/]+\d)\)(\d+)$/), e = r.map((s) => {
    if (n.test(s)) {
      let [c, u] = Array.from(s.match(n)).slice(1);
      return xs(c) ? `${c}(${u})` : c;
    }
    return s;
  }).join(" "), r = e?.split(" "), n = new RegExp(/^1-0\((\d+)\)$/), e = r.map((s) => {
    if (n.test(s)) {
      let [c] = s.match(n).slice(1);
      return `[${c < 9 ? 10 : parseInt(c) + 2}-${c}]`;
    }
    return s;
  }).join(" ");
  let o = /\((\d)+0 /;
  if (o.test(e)) {
    let s = e.match(o)[1];
    e = e.replace(o, `(${s}) `);
  }
  return { score: e };
}
function pL({ score: e, attributes: t, identifier: r }) {
  if (typeof e != "string") return { score: e, identifier: r };
  let i = new RegExp(/\([\d,/ ]+\)/g), n = e.match(i);
  for (let l of n || []) {
    let d = l.match(/^\((.*)\)$/)?.slice(1)?.[0], p = e.split(l)[0].split(")").reverse()[0].replace(/\D/g, "");
    if (d?.length === 2 && p?.length >= 2) {
      let h = p.slice(p.length - 2).split("").map((g) => parseInt(g));
      if (Math.abs(h[0] - h[1]) === 1) continue;
    }
    let m = hy(d), f = Wp(m);
    e = e.replace(l, `(${f})`).trim();
  }
  let a = new RegExp(/\[[\d,/ ]+\]/g);
  e.match(a)?.forEach((l) => {
    let d = hy(l.match(/^\[(.*)\]$/)[1]);
    e = e.replace(l, `(${d}) `).trim();
  });
  let o = [")", "]"], s = [")(", "), (", ") (", ")[", ") [", "](", "] ("];
  if (e.startsWith("(") && o.some((l) => e.endsWith(l)) && s.some((l) => e.includes(l))) {
    let l = "", d = e.split(/[)\]]/).filter(Boolean).map((g) => (g.startsWith(",") && (g = g.slice(1)), g.trim())), p = d.every((g) => g.includes(",") || Gl(g)), m = d.every((g) => g.includes("/") || Gl(g)), f = d.every((g) => g.includes("-") || Gl(g)), h = p && "," || f && "-" || m && "/";
    if (h) {
      let g;
      d.forEach((I) => {
        if (I.startsWith("(")) if (g === "set" && (l += " "), I.includes(h)) l += I.slice(1).split(h).map((U) => U.trim()).join("-"), g = "set";
        else {
          let U = I.slice(1);
          l += `(${U}) `, g = "tiebreak";
        }
        else if (I.startsWith("[")) {
          let U = I.slice(1).split(h).map((P) => parseInt(P.trim())), S = Math.min(...U);
          g === "set" ? l += `(${S}) ` : l += `[${U.join("-")}] `, g = "tiebreak";
        }
      }), e = l.trim();
    }
  }
  let c = Br(e.split(""));
  c["("] === 1 && c[")"] === 1 && e.startsWith("(") && e.endsWith(")") && (e = e.slice(1, e.length - 1), c["-"] === 1 && xs(e) && gt(t?.removed) && (e = e + `(${t.removed})`, t.removed = void 0));
  let u = /\(\)/g;
  return u.test(e) && (e = e.replace(u, "").trim()), { score: e };
}
function bM({ score: e }) {
  let t = e.split(""), r = [], i, n = () => i = [void 0, void 0, void 0], a = () => {
    let s = `${i[0]}-${i[1]}`;
    return i[2] && (s += ` (${i[2]})`), n(), i.push(i), s;
  };
  n();
  let o = () => i[0] !== void 0 && i[1] !== void 0 && Math.abs(parseInt(i[0]) - parseInt(i[1]));
  for (; t.length; ) {
    let s = t.shift(), c = gt(s) && parseInt(s), u = i[0] !== void 0 && i[1] !== void 0;
    if (gt(c)) {
      if (i[0] === void 0) {
        i[0] = c;
        continue;
      }
      if (i[1] === void 0 && (i[1] = c, o())) {
        r.push(a()), i = [void 0, void 0];
        continue;
      }
      if (u && t.length === 1 && gt(t[0])) {
        let l = t.pop();
        i[0] = i[0].toString() + i[1].toString(), i[1] = l, r.push(a()), i = [void 0, void 0];
      }
      u && o();
    }
  }
  return { sets: r };
}
function Gf(e) {
  let t = e.indexOf("1"), r = e.split(""), i = r.every((n) => !isNaN(n));
  if (i && e.length === 3 && t === 0) {
    let n = hd(r, t);
    if (n) return n;
  }
  if (i && e.length === 7 && t > 3) {
    let n = r.slice(4), a = hd(n, t - 4);
    if (a) return `${r[0]}-${r[1]} ${r[2]}-${r[3]} ${a}`;
  }
}
function MM(e) {
  let { score: t } = e, { applied: r, matchUpStatus: i } = e, n = t?.toString().split(""), a = n?.every((s) => gt(s)), o = (s) => Math.abs(s[0] - s[1]);
  if (typeof t == "number" || a) {
    t = t.toString().toLowerCase(), a && (t = n.join(""));
    let s = a ? n.map((u) => parseInt(u)) : t.split("").map((u) => parseInt(u)), { sets: c } = bM({ score: t });
    if (s.length, t.length === 3 && o(s.slice(0, 2)) === 1) {
      let [u, l, d] = s;
      t = `${u}-${l}(${d})`, r.push("numericTiebreakPattern1");
    } else if (t.length === 3 && s[0] === 1) {
      let [u, l, d] = s;
      t = `[${u}${l}-${d}]`, r.push("numericTiebreakPattern2");
    } else if (t.length === 4 && o(s.slice(0, 2)) === 1 && "987654".split("").includes(s[0].toString())) {
      let [u, l, d, p] = s, m = Math.min(d, p);
      t = `${u}-${l}(${m})`, r.push("numericTiebreakPattern3");
    } else if (t.length === 4 && s[0] === 1 && s[2] === 1) {
      let [u, l, d, p] = s;
      t = `[${u}${l}-${d}${p}]`, r.push("bigSuper");
    } else if (t.length === 4) {
      let [u, l, d, p] = s;
      t = `${u}${l} ${d}${p}`, r.push("split4");
    } else if (t.length === 5 && o(s.slice(0, 2)) === 1) {
      let [u, l, d, p, m] = s;
      t = `${u}-${l}(${d}) ${p}-${m}`, r.push("numericTiebreakPattern4");
    } else if (t.length === 5 && o(s.slice(3)) === 1) {
      let [u, l, d, p, m] = s;
      t = `${u}-${l} ${d}-${p}(${m})`, r.push("numericTiebreakPattern5");
    } else if (s.length === 7) if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) > 1 && s[4] === 1) {
      let [u, l, d, p, m, f, h] = s;
      t = `${u}-${l} ${d}-${p} [${m}${f}-${h}]`, r.push("numericTiebreakPattern6");
    } else if (o(s.slice(0, 2)) === 1 && o(s.slice(3, 5)) > 1 && o(s.slice(5, 7)) > 1) {
      let [u, l, d, p, m, f, h] = s;
      t = `${u}-${l}(${d}) ${p}-${m} ${f}-${h}`, r.push("numericTiebreakPattern7");
    } else if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) === 1 && o(s.slice(5, 7)) > 1) {
      let [u, l, d, p, m, f, h] = s;
      t = `${u}-${l} ${d}-${p}(${m}) ${f}-${h}`, r.push("numericTiebreakPattern8");
    } else if (o(s.slice(0, 2)) > 1 && o(s.slice(2, 4)) > 1 && o(s.slice(4, 6)) === 1) {
      let [u, l, d, p, m, f, h] = s;
      t = `${u}-${l} ${d}-${p} ${m}-${f}(${h})`, r.push("numericTiebreakPattern9");
    } else t = t.slice(0, 2) + " " + t.slice(2, 4) + " " + t.slice(4), r.push("numericMatchTiebreakPattern");
    else if (t.length % 2) {
      let u = Gf(t);
      u && t !== u && r.push("parsedSuperPattern"), t = u ?? t;
    } else {
      let u = qt(t.split(""), 2).map((I) => I.join("")), l = u.map((I) => {
        let [U, S] = I.split("").map((D) => parseInt(D)), P = Math.abs(U - S), v = U > S ? 1 : 2;
        return P > 1 && v || v * -1;
      }), d = l.reduce((I, U) => I > 0 && U > 0, 1), p = Br(l), m = l.map((I) => Math.abs(I)), f = Br(m), h = l[0] < 0, g = !h && l[1] < 0;
      if (l[0] > 0 && l[1] > 0 && l[0] !== l[1]) t = [u.slice(0, 2).join(" "), u.slice(2).join("-")].join(" "), r.push("numeric3rdSetTiebreakPattern");
      else if (d) t = u.join(" "), r.push("chunkSplit");
      else if (s.length === 6) {
        if (p[1] === 2 || p[2] === 2) if (!Object.values(f).includes(3)) t = u.join(" "), r.push("chunkSplit");
        else {
          let [I, U, S, P, v, D] = s, y = l.reduce((w, b, T) => b < 0 ? T : w, void 0);
          if (y === 0) {
            let w = Math.min(S, P);
            t = `${I}-${U}(${w}) ${v}-${D}`, r.push("chunkSplitTiebreak1");
          } else if (y === 1) {
            let w = Math.min(v, D);
            t = `${I}-${U} ${S}-${P}(${w})`, r.push("chunkSplitTiebreak2");
          } else t = `${I}-${U} ${S}-${P}`, r.push("chunkSplitTrimExtraneous");
        }
      } else if (s.length === 8) {
        let [I, U, S, P, v, D, y, w] = s;
        h || g ? s[5] === 1 && (h ? t = `${I}-${U}(${S}) ${P}-${v} [${D}${y}-${w}]` : t = `${I}-${U} ${S}-${P}(${v}) [${D}${y}-${w}]`) : (l[0], l[1]);
      }
    }
  }
  return { score: t, applied: r, matchUpStatus: i };
}
function RM(e) {
  let t = [0, 0], r = [], i = e.split(" "), n = /(\d+)-(\d+)/;
  i.forEach((c) => {
    if (n.test(c)) {
      let u = c.match(n).slice(1).map((d) => parseInt(d)), l = u[0] > u[1] && 1 || u[1] > u[0] && 2;
      l && (t[l - 1] += 1, r.push(l));
    }
  });
  let a = t[0] > t[1] && 1 || t[1] > t[0] && 2, o = t[0] > 0 && t[0] === t[1], s = t.reduce((c, u) => c + u, 0);
  return { setsWon: t, setsTied: o, setWinners: r, totalSets: s, winningSide: a };
}
function mL({ score: e, matchUpStatus: t, attributes: r }) {
  let i = [], n, a = e.split(" "), o = a.length;
  e = a.map((l, d) => {
    if (new RegExp(iu).test(l)) {
      let m = l.slice(3), f = l.slice(0, 3), h = f.split("-");
      if (!xs(f) && !t) {
        let g = Math.max(...h), I = f.indexOf(g), U = [g, g - 1];
        return I && U.reverse(), U.join("-") + m;
      }
    } else if (l.length === 2 && gt(l)) return l.split("").join("-");
    l = Wp(l);
    let p = new RegExp(`^${jI}$`).test(l) && "super" || new RegExp(`^${iu}$`).test(l) && "tiebreak" || new RegExp(`^${qp}$`).test(l) && "standard" || "unknown";
    if (i.push(p), o > 1 && p === "standard" && d < 2) {
      let [m, f] = l.split("-"), h = Math.abs(parseInt(m) - parseInt(f)), g = Math.max(m, f), I = Math.min(m, f), U = [parseInt(m), parseInt(f)].indexOf(I);
      if (g > 9 && h > 2) {
        let S = g.toString().split(""), P = S.find((v) => parseInt(v) > I || d && parseInt(v) <= n) ?? S[0];
        P && (l = U ? [P, I].join("-") : [I, P].join("-"));
      }
      g > (n || 0) && (n = g);
    }
    if (p === "standard") {
      let [m, f] = l.split("-");
      if (!Math.abs(parseInt(m) - parseInt(f)) && t !== "RETIRED") return "";
    }
    return l;
  }).filter(Boolean).join(" ");
  let { setsWon: s, setWinners: c, totalSets: u } = RM(e);
  if (u === 1 && r?.removed === "6" && (e += " 6-0"), e.split(" ").length > 2 && Math.max(...s) >= 2 && c[0] === c[1] && (e = e.split(" ").slice(0, 2).join(" ")), Math.max(...s) > 2) {
    let l = [0, 0];
    e = e.split(" ").map((d, p) => (l[c[p]] += 1, Math.max(...l) > 2 ? void 0 : d)).filter(Boolean).join(" ");
  }
  return { score: e, profile: i };
}
function fL({ score: e }) {
  let { setsTied: t, winningSide: r } = RM(e), i = /\s\((\d+)\)$/;
  if (!r && t && i.test(e)) {
    let s = e.match(i).slice(1)[0], c = s <= 8 ? 10 : s + 2;
    e = e.replace(i, ` [${c}-${s}]`);
  }
  let n = e.split(" "), a = n[n.length - 1];
  if (!a.includes("-") || a.indexOf("(") > 0) return { score: e };
  let o = a.split("(").join("").split(")").join("").split("-");
  if (!o.every((s) => gt(s))) return { score: e };
  if (o[0] === "76") {
    let s = o[1].length === 2 ? Math.min(...o[1].split("").map((c) => parseInt(c))) : o[1];
    e = [...n.slice(0, n.length - 1), `7-6(${s})`].join(" ");
  } else {
    o = o.map((u) => parseInt(u));
    let s = Math.max(...o), c = Math.abs(o[0] - o[1]);
    if (s >= 10) {
      if (c > 2 && o.every((u) => +u >= 10)) {
        let u = o.map((l) => l === s ? l - 10 : 10).sort();
        c = Math.abs(u[0] - u[1]), c > 2 && (o = u);
      }
      e = [...n.slice(0, n.length - 1), `[${o.join("-")}]`].join(" ");
    } else n.length === 3 && s >= 7 && c > 2 && (e = [...n.slice(0, n.length - 1), `[${o.join("-")}]`].join(" "));
  }
  return { score: e };
}
function hL({ score: e }) {
  return e = e?.toString().toLowerCase() || "", { score: e };
}
function gL({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : (e.toLowerCase().includes("o") && (e = e.toLowerCase().split(" ").map((r) => r.split("o").join("0")).join(" "), t.push("replaceOh")), { score: e, applied: t });
}
function IL({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : (e = e.toLowerCase().split(" ").map((r) => {
    if (/^\d+$/.test(r) && r.length > 2) {
      let i = r.indexOf("1");
      if (r.length % 2) {
        if (r.length === 3 && i === 0) {
          let n = hd(r.split(""), i);
          return t.push("getSuper"), n;
        }
      } else {
        let { score: n, applied: a } = MM({ score: r, applied: [] });
        n !== r && (r = n, t.push(...a));
      }
    }
    return r;
  }).join(" "), { score: e, applied: t });
}
function UL({ score: e, applied: t }) {
  return typeof e != "string" ? { score: e } : [3, 4].includes(e.length) && Gf(e) ? { score: Gf(e) } : (e = e.toLowerCase().split(" ").map((r) => {
    if (/^\d+$/.test(r) && r.length === 1) {
      t.push("removeErroneous1");
      return;
    }
    return r;
  }).filter(Boolean).join(" "), { score: e, applied: t });
}
function SL({ score: e, applied: t }) {
  return ["walkover", "wo", "w/o", "w-o"].includes(e?.toString().toLowerCase()) ? (t.push("handleWalkover"), { matchUpStatus: "walkover", score: "", applied: t }) : { score: e };
}
function yL({ score: e, profile: t, applied: r }) {
  e = e?.toString().toLowerCase();
  let i = /^(.*\d+.*)(ret|con)+[A-Za-z ]*$/;
  if (i.test(e)) {
    let [o] = e.match(i).slice(1);
    return r.push("handleRetired"), { score: o.trim(), matchUpStatus: "retired", applied: r };
  }
  let n = t?.matchUpStatuses?.retired, a = ["rtd", ...Array.isArray(n) ? n : [n].filter(Boolean)].find((o) => e?.endsWith(o));
  return a ? (r.push("handleRetired"), { matchUpStatus: "retired", score: e?.replace(a, "").trim(), applied: r }) : { score: e };
}
function vL({ score: e, attributes: t }) {
  (e.endsWith(" am") || e.endsWith(" pm")) && (e = ""), e = e.replace(/[A-Za-z]+/g, "").trim(), [".", ","].some((n) => e.endsWith(n)) && (e = e.slice(0, e.length - 1));
  let r = "()/-".split("").some((n) => e.includes(n));
  / \d$/.test(e) && r && (t = { removed: e.slice(e.length - 2).trim() }, e = e.slice(0, e.length - 2));
  let i = /(.*)[A-Za-z]+$/;
  return i.test(e) && (e = e.match(i).slice(1)[0].trim()), { score: e, attributes: t };
}
function PL({ score: e }) {
  return new RegExp(/-\d+\/\d+-/).test(e) && (e = e.split("/").join(" ")), { score: e };
}
function DL({ score: e }) {
  let t = new RegExp(/^\d+\/\d+/), r = e.split(" ");
  r.some((n) => t.test(n)) && (e = r.map((n) => t.test(n) ? n.replace("/", "-") : n).join(" "));
  let i = /^(\d+), *(\d+)$/;
  if (i.test(e)) {
    let [n, a] = e.match(i).slice(1);
    e = [n, a].join("-");
  }
  return { score: e };
}
function wL({ score: e }) {
  let t = new RegExp(/\(\d+\/\d+\)/g), r = e.match(t);
  for (let i of r || []) {
    let n = i.replace("/", "-");
    e = e.replace(i, n);
  }
  return { score: e };
}
function TL({ score: e }) {
  if (e.includes(",")) {
    let t = e.split(",").map((i) => i.trim()), r = (i) => /\d \d/.test(i);
    t.every(r) && (e = t.map((i) => {
      let n = /\d+ \d+/g;
      for (let a of i.match(n)) {
        let [o, s] = a.match(/(\d+) (\d+)/).slice(1);
        i = i.replace(a, `${o}-${s}`);
      }
      return i;
    }).join(" "));
  }
  if (e.includes(" ")) {
    let t = e.replace(/[ ,]/g, "");
    t.split("").every((r) => gt(r)) && t.length === 4 && (e = t);
  }
  return { score: e };
}
function bL({ score: e }) {
  let t = new RegExp(/^\[\d+\](.*)$/);
  t.test(e) && (e = e.match(t).slice(1)[0].trim());
  let r = /\(,/g;
  return r.test(e) && (e = e.replace(r, "(")), { score: e };
}
var ML = { handleTiebreakSlashSeparation: wL, handleSetSlashSeparation: PL, punctuationAdjustments: sL, handleGameSeparation: DL, joinFloatingTiebreak: uL, handleBracketSpacing: cL, handleSpaceSeparator: TL, separateScoreBlocks: IL, matchKnownPatterns: lL, removeDanglingBits: vL, removeErroneous: UL, handleWalkover: SL, properTiebreak: dL, handleNumeric: MM, handleRetired: yL, containedSets: pL, sensibleSets: mL, stringScore: hL, superSquare: fL, setBuilder: bM, excisions: bL, replaceOh: gL }, Gm = {}, RL = ["handleNumeric", "handleWalkover", "handleRetired", "replaceOh", "stringScore", "punctuationAdjustments", "excisions", "handleSpaceSeparator", "matchKnownPatterns", "removeDanglingBits", "handleBracketSpacing", "matchKnownPatterns", "containedSets", "separateScoreBlocks", "handleGameSeparation", "removeErroneous", "joinFloatingTiebreak", "handleSetSlashSeparation", "handleTiebreakSlashSeparation", "properTiebreak", "sensibleSets", "superSquare"], NL = ["handleNumeric", "separateScoreBlocks", "sensibleSets", "superSquare"];
function NM(e) {
  if (!e.score) return { error: z };
  let { score: t, sheetName: r, identifier: i, fileName: n, stepLog: a, fullLog: o, profile: s } = e, c = [], u, l = [], d, p, m = t, f = (g) => {
    g.forEach((I) => {
      p = ML[I]({ profile: s, identifier: i, matchUpStatus: u, attributes: d, applied: l, score: m });
      let U = p.score !== m;
      U && c.push({ method: I, score: p.score }), a && (o || U || p.matchUpStatus !== u) && console.log(u ? { score: p.score, matchUpStatus: u } : { score: p.score }, I), p.matchUpStatus && (u = p.matchUpStatus), p.attributes && (d = p.attributes), p.applied && (l = p.applied), m = p.score;
    });
  };
  f(RL);
  let h = fy(m);
  return h || (m = t.toString().replace(/\D/g, ""), d?.removed && (d.removed = void 0), f(NL), h = fy(m), h || (m = "")), l.forEach((g) => {
    Gm[g] || (Gm[g] = 0), Gm[g] += 1;
  }), { matchUpStatus: u?.toUpperCase(), modifications: c, attributes: d, isValid: h, score: m };
}
var EM = {};
Me(EM, { analyzeScore: () => GI, analyzeSet: () => nu, checkScoreHasValue: () => Bt, checkSetIsComplete: () => Gp, getSetComplement: () => qI, getTiebreakComplement: () => Hp, isValidMatchUpFormat: () => Vr, parseScoreString: () => gd, validateScore: () => $I, validateTieFormat: () => wr });
function GI({ existingMatchUpStatus: e, matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n }) {
  let a = n?.sets ?? [], o = (a?.filter((v) => v?.winningSide) || []).reduce((v, D) => {
    let { winningSide: y } = D;
    if (!y) return v;
    let w = y - 1;
    return v[w]++, v;
  }, [0, 0]), s = i ? i - 1 : void 0, c = s !== void 0 ? 1 - s : void 0, u = s !== void 0 && o[s], l = c !== void 0 && o[c], d = t ? Sr(t) : void 0, p = Math.max(...o), m = Br(o)[p], f = d?.setFormat?.timed || d?.finalSetFormat?.timed, h = d?.bestOf, g = h && Math.ceil(h / 2) || 1, I = r ?? e, U = I && [Pe, Xt, be].includes(I), S = !d || !a.length || a.every((v, D) => {
    let y = D + 1, w = y === h, b = y === a.length, { side1Score: T, side2Score: R, side1TiebreakScore: M, side2TiebreakScore: E, winningSide: A } = v, N = Math.max(T ?? 0, R ?? 0), C = M ?? E, { finalSetFormat: k, setFormat: O } = d, _ = w && k || O;
    if (C) {
      let { tiebreakTo: B, NoAD: L } = _?.tiebreakFormat || {}, j = Math.max(M ?? 0, E ?? 0);
      if (L && j > B || j < B && A && (b && !U || !b)) return !1;
    }
    return _.setTo ? !(!_.noTiebreak && N > _.setTo + 1) : !0;
  }), P = (!t || p === g) && m === 1 && o.indexOf(p) + 1 || void 0;
  return { valid: !!(S && (i && u > l && i === P || i && U || !i && !P && (![vt, Pe, Xt, be].includes(I) || f && I === vt))) };
}
function $I({ existingMatchUpStatus: e, matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n }) {
  if (typeof n != "object") return { error: z };
  let { sets: a, scoreStringSide1: o, scoreStringSide2: s } = n, c = "scoreString must be a string!";
  if (o !== void 0 && typeof o != "string") return { error: z, info: c };
  if (s !== void 0 && typeof s != "string") return { error: z, info: c };
  if (a !== void 0 && !Array.isArray(a)) return { error: z, info: La("sets") };
  if (a?.length) {
    let u = a.map((d) => d?.setNumber).filter(Boolean);
    if (u.length !== Ue(u).length) return { error: z, info: "setNumbers not unique" };
    for (let d of a) {
      let { side1Score: p, side2Score: m, side1TiebreakScore: f, side2TiebreakScore: h, side1PointScore: g, side2PointScore: I, winningSide: U, setNumber: S } = d;
      if (![[p, m], [f, h], [g, I]].filter((P) => P.some((v) => ![void 0, null].includes(v))).every((P) => P.every((v) => Ie(v)))) return { error: z, info: "non-numeric values" };
      if (![S, U].filter((P) => ![void 0, null].includes(P)).every((P) => Ie(P))) return { error: z, info: "non-numeric values" };
      if (U && ![1, 2].includes(U)) return { error: z, info: "winningSide must be 1 or 2" };
    }
    let { valid: l } = GI({ existingMatchUpStatus: e, matchUpStatus: r, matchUpFormat: t, winningSide: i, score: n });
    if (!l) return { error: Yv, info: "score is invalid for matchUpFormat or winningSide does not match calculated winningSide" };
  }
  return { valid: !0 };
}
var qI = (e) => {
  let { isSide1: t, lowValue: r, setTo: i, tiebreakAt: n, NoAD: a } = e;
  if (r === void 0) return !1;
  let o = pe(r);
  o?.toString().length > 2 && (o = parseInt(o.toString().slice(0, 2))), n && n < i && o > n && (o = n);
  let s;
  return a && !n ? (o > i && (s = i), s = o < i ? i : i - 1) : s = o + 1 < i && i || n && n < i && o === n && i || !n && o + 2 || i + 1, [t ? o : s, t ? s : o];
}, Hp = (e) => {
  let { isSide1: t, lowValue: r, tiebreakTo: i, tiebreakNoAd: n } = e;
  if (r === void 0) return !1;
  let a = typeof r == "string" ? parseInt(r) : r;
  a?.toString().length > 2 && (a = parseInt(a.toString().slice(0, 2))), n && a > i - 1 && (a = i - 1);
  let o = EL({ lowValue: a, NoAD: n, tiebreakTo: i });
  return [t ? a : o, t ? o : a];
};
function EL(e) {
  let { lowValue: t, NoAD: r, tiebreakTo: i } = e, n = r ? 1 : 2;
  return t + 1 >= i ? t + n : i;
}
function gd({ tiebreakTo: e = 7, scoreString: t = "" }) {
  return t?.split(" ").filter(Boolean).map((i, n) => r({ set: i, setNumber: n + 1 }));
  function r({ set: i, setNumber: n }) {
    let a = /\(([^)]+)\)/, o = /\[([^)]+)\]/, s = a.exec(i), c = o.exec(i), u = i?.startsWith("[") && c && c[1].split("-").map((S) => parseInt(S)), l = s && i.replace(s[0], "") || c && i.replace(c[0], "") || i, d = !u && l.split("-").map((S) => parseInt(S)), p = u ? u[0] > u[1] && 1 || u[0] < u[1] && 2 || void 0 : d[0] > d[1] && 1 || d[0] < d[1] && 2 || void 0, m = s ? s[1] : void 0, f = (m && Hp({ lowValue: m, isSide1: p === 2, tiebreakTo: e })) ?? [], [h, g] = d || [], [I, U] = u || f || [];
    return { side1Score: h, side2Score: g, side1TiebreakScore: I, side2TiebreakScore: U, winningSide: p, setNumber: n };
  }
}
function AL({ matchUpScoringFormat: e, isDecidingSet: t, isTiebreakSet: r, isTimedSet: i, setObject: n }) {
  if (!n) return;
  let a = $p({ set: n });
  return Gp({ matchUpScoringFormat: e, set: n, isDecidingSet: t, isTiebreakSet: r, isTimedSet: i }) && a || void 0;
}
function nu(e) {
  let { setObject: t, matchUpScoringFormat: r } = e;
  if (!t) return { error: Ad };
  let { setNumber: i } = t || {}, { bestOf: n, exactly: a } = r || {}, o = n || a, s = !!(i && o && i === o), c = s && r?.finalSetFormat || r?.setFormat, u = !!c?.tiebreakSet, l = !!c?.timed, d = !u && !l, p = !!(i && o && i <= o), m = [t?.side1Score, t?.side2Score], f = [t?.side1PointScore, t?.side2PointScore], h = [t?.side1TiebreakScore, t?.side2TiebreakScore], g = m.filter((O) => O !== void 0).length, I = f.filter((O) => O !== void 0).length, U = h.filter((O) => O !== void 0).length, S = m?.filter((O) => !isNaN(O)).length, P = h?.filter((O) => !isNaN(O)).length, { tiebreakAt: v } = c || {}, D = v && m.filter((O) => O >= v).length === 2, y = D && (m[0] > m[1] && 1 || m[1] > m[0] && 2 || void 0), w = !!(P && !S), b = !!t?.winningSide, { error: T, result: R } = CL({ sideTiebreakScores: h, sideGameScores: m, setFormat: c, setObject: t }), { error: M, result: E } = OL({ sideTiebreakScores: h, setObject: t, setFormat: c }), A = d && !w && R || u && w && E || l, N = p && !(u && !w) && !(d && w) && (!b || A), C = AL({ isTimedSet: l, matchUpScoringFormat: r, isDecidingSet: s, isTiebreakSet: w, setObject: t }), k = { expectTiebreakSet: u, expectTimedSet: l, hasTiebreakCondition: D, isCompletedSet: b, isDecidingSet: s, isTiebreakSet: w, isValidSet: N, isValidSetNumber: p, isValidSetOutcome: A, leadingSide: y, setFormat: c, sideGameScores: m, sideGameScoresCount: g, sidePointScores: f, sidePointScoresCount: I, sideTiebreakScores: h, sideTiebreakScoresCount: U, winningSide: C };
  return t?.winningSide !== void 0 && (w ? (k.isValidTiebreakSetOutcome = E, E || (k.tiebreakSetError = M)) : (k.isValidStandardSetOutcome = R, R || (k.standardSetError = T))), k;
}
function CL({ setObject: e, setFormat: t, sideGameScores: r, sideTiebreakScores: i }) {
  if (!e) return { result: !1, error: Ad };
  let n = !!t?.tiebreakSet, a = !!t?.timed;
  if (!t || n || a) return { result: !1, error: z };
  if (r?.filter((y) => !isNaN(y)).length !== 2) return { result: !1, error: cf };
  let { setTo: o, tiebreakAt: s, tiebreakFormat: c, NoAD: u } = t || {};
  if (!(o && r?.find((y) => y >= o))) return { result: !1, error: cf };
  let l = [1, 2].includes(e?.winningSide);
  if (!e || !l) return { result: !1, error: Cd };
  let d = e?.winningSide - 1, p = 1 - d, m = r[d], f = r[p], h = m - f;
  if (!(m > f)) return { result: !1, error: { message: "winningSide game scoreString is not high" } };
  let g = s && c, I = i?.filter((y) => !isNaN(y)).length === 2, U = i?.[d], S = i?.[p], P = s && r.filter((y) => y >= s).length === 2;
  if (g) {
    let { NoAD: y, tiebreakTo: w } = c;
    if (P) {
      if (h > 1) return { result: !1, error: { message: "invalid winning game scoreString (5)" } };
      if (!I) return { result: !1, error: { message: "invalid tiebreak scores (1)" } };
      if (isNaN(w)) return { result: !1, error: { message: "tiebreakTo error" } };
      if (!(w && i?.find((E) => E >= w))) return { result: !1, error: { message: "invalid tiebreak scores (2)" } };
      let b = s < o ? o : o + 1;
      if (m > b) return { result: !1, error: { message: "invalid winning game scoreString (1)" } };
      if (!U || !S || U < S) return { result: !1, error: { message: "winningSide tiebreak value is not high" } };
      let T = y ? 1 : 2, R = U - S, M = S >= w - 1;
      if (R && M && R < T) return { result: !1, error: { message: "invalid tiebreak scores (3)" } };
    }
    if (m > o && !P) return { result: !1, error: { message: "invalid winning game scoreString (2)" } };
  }
  let v = u ? 1 : 2, D = f >= o - 1;
  return h && D && !P && h < v ? { result: !1, error: { message: "invalid winning game scoreString (3)" } } : h > v && m > o ? { result: !1, error: { message: "invalid winning game scoreString (4)" } } : { result: !0 };
}
function OL({ setObject: e, setFormat: t, sideTiebreakScores: r }) {
  if (!e) return { result: !1, error: Ad };
  let i = !!t?.tiebreakSet, n = !!t?.timed;
  if (!t || !i || n) return { result: !1, error: { message: "not tiebreak set" } };
  let a = [1, 2].includes(e?.winningSide);
  if (!e || !a) return { result: !1, error: Cd };
  let { tiebreakSet: o } = t || {}, { NoAD: s, tiebreakTo: c } = o || {};
  if (r?.filter((g) => !isNaN(g)).length !== 2) return { result: !1, error: { message: "invalid tiebreak scores (1)" } };
  if (isNaN(c)) return { result: !1, error: { message: "tiebreakTo error" } };
  if (!r?.find((g) => g >= c)) return { result: !1, error: { message: "invalid tiebreak scores (2)" } };
  let u = e?.winningSide - 1, l = 1 - u, d = r[u], p = r[l];
  if (!d || !p || d < p) return { result: !1, error: { message: "winningSide tiebreak value is not high" } };
  let m = s ? 1 : 2, f = d - p, h = p >= c - 1;
  return f && h && f < m ? { result: !1, error: { message: "invalid tiebreak scores (3)" } } : { result: !0 };
}
function kL(e) {
  let { existingDrawDefinition: t, hydrateCollections: r, enforceGender: i, tieFormatName: n, matchUpType: a, eventType: o, isMock: s, event: c } = e, { tieFormat: u, matchUpFormat: l } = e;
  if (a === kt && o === kt) {
    let d = t?.structures?.find(({ stage: p }) => p === re)?.tieFormat;
    u = u || d || n && c?.tieFormat?.tieFormatName === n && c.tieFormat || n && kn({ namedFormat: n, hydrateCollections: r, isMock: s, event: c }) || c?.tieFormat || kn({ event: c, isMock: s, hydrateCollections: r }), l = void 0;
  } else l || (u = void 0, c?.matchUpFormat || (l = Si));
  if (u) {
    let d = wr({ gender: c?.gender, enforceGender: i, tieFormat: u });
    if (d.error) return d;
  }
  return { tieFormat: u, matchUpFormat: l };
}
function xL(e) {
  let t = e.drawDefinition, { existingQualifyingPlaceholderStructureId: r, appliedPolicies: i, qualifyingOnly: n, drawEntries: a, structureId: o, tieFormat: s, idPrefix: c, isMock: u, event: l } = e, d = e.qualifyingProfiles, p = d?.length ? xb({ hasExistingDrawDefinition: !0, uuids: e.uuids, qualifyingProfiles: d, appliedPolicies: i, qualifyingOnly: n, tieFormat: s, idPrefix: c, isMock: u }) : void 0;
  if (p?.error) return p;
  t.structures = t.structures?.filter(({ structureId: v }) => v !== r), t.links = t.links?.filter(({ source: v }) => v.structureId !== r);
  let { qualifiersCount: m, qualifyingDrawPositionsCount: f, qualifyingDetails: h } = p ?? {};
  f && (p?.structures && t.structures?.push(...p.structures), p?.links && t.links?.push(...p.links));
  let g = t.structures?.find(({ stage: v, stageSequence: D }) => v === re && D === 1), { qualifiersCount: I } = ic({ stageSequence: 1, drawDefinition: t, structureId: o, stage: re }), U = Math.max(m ?? 0, I ?? 0), S = LT({ qualifiersCount: U, drawDefinition: t, stage: re });
  if (S.error || (S = dd({ drawSize: f, stage: se, drawDefinition: t }), S.error)) return S;
  FL({ drawDefinition: t, drawEntries: a, event: l });
  let P = LL({ mainStructure: g, qualifyingDetails: h, drawDefinition: t });
  return P.error ? P : { drawDefinition: t, structureId: o };
}
function FL({ drawDefinition: e, drawEntries: t, event: r }) {
  for (let i of (t ?? []).filter(({ entryStage: n }) => n === se)) {
    let n = { ...i, entryStage: i.entryStage ?? re, drawDefinition: e, event: r };
    jg(n);
  }
}
function LL({ mainStructure: e, qualifyingDetails: t, drawDefinition: r }) {
  for (let i of t || []) {
    let { finalQualifyingRoundNumber: n, finalQualifyingStructureId: a, roundTarget: o, finishingPositions: s, linkType: c } = i, u = e && tl({ targetStructureId: e.structureId, sourceStructureId: a, sourceRoundNumber: n, finishingPositions: s, targetEntryRound: o, linkType: c })?.link;
    if (u?.error) return u;
    u && (r.links || (r.links = []), r.links.push(u));
  }
  return { error: void 0 };
}
function AM(e) {
  let { participantIds: t } = e, r = e.drawDefinition?.entries?.filter((i) => {
    let n = i.entryStatus;
    return !e.restrictEntryStatus || Ni.includes(n);
  }).map(Re) ?? [];
  if (t) {
    let i = t.filter((n) => !r?.includes(n));
    if (i?.length) return F({ result: { error: Li }, info: { invalidParticipantIds: i } });
  } else t = r;
  return e.roundsCount && e.restrictRoundsCount !== !1 && e.roundsCount > t.length - 1 && (!e.enableDoubleRobin || e.roundsCount > (t.length - 1) * 2) ? { error: z, info: "Not enough participants for roundsCount" } : e.roundsCount && e.restrictRoundsCount !== !1 && e.roundsCount > 31 ? { error: z, info: "roundsCount must be less than 32" } : { participantIds: t };
}
function WI(e) {
  let t = [], { roundsCount: r = 1, drawDefinition: i, matchUpsCount: n, structureId: a, idPrefix: o, isMock: s, event: c } = e, u, l = AM(e);
  if (l.error) return l;
  for (let d of te(1, r + 1)) {
    let p = Bp({ restrictMatchUpsCount: e.restrictMatchUpsCount, ignoreLastRoundNumber: !!u, newRound: !u, drawDefinition: i, matchUpsCount: n, structureId: a, roundNumber: u, idPrefix: o, isMock: s, event: c });
    if (p.error) return F({ result: p, info: { iteration: d } });
    p.matchUps?.length && t.push(...p.matchUps), u = (p?.roundNumber ?? 1) + 1;
  }
  return { matchUps: t };
}
function _L(e) {
  let { tournamentRecord: t, participantIds: r, scaleName: i, eventType: n, adHocRatings: a = {} } = e, o = e.scaleAccessor ?? Gt[i]?.accessor, s = t.participants ?? [];
  for (let c of r ?? []) {
    let u = s?.find((d) => d.participantId === c), l = gy({ scaleName: `${i}.${eg}`, participant: u, eventType: n });
    !l && i && (l = gy({ scaleAccessor: o, participant: u, scaleName: i, eventType: n })), l && !a[c] && (a[c] = l);
  }
  return a;
}
function gy({ scaleType: e = Zn, scaleAccessor: t, participant: r, scaleName: i, eventType: n }) {
  let a = (r && dn({ scaleAttributes: { eventType: n ?? So, scaleType: e, scaleName: i }, participant: r }))?.scaleItem?.scaleValue;
  return t && xe(a) ? a[t] : a;
}
function HI(e) {
  let t = VL(e);
  if (t?.error) return t;
  let r = AM(e);
  if (r.error) return r;
  let i = BL(e);
  if (i.error) return i;
  let n = _L(e), a = e.tournamentRecord?.isMock ?? e.isMock, o = e.eventType ?? e.event?.eventType, s = [], c = [], u;
  for (let l of te(1, (e.roundsCount ?? 1) + 1)) {
    let d = xI({ ...e, participantIds: r.participantIds, structure: i.structure, ignoreLastRoundNumber: !0, iterationMatchUps: s, adHocRatings: n, roundNumber: u, eventType: o, isMock: a });
    if (d.error) return d;
    let { matchUps: p, ...m } = d;
    m.modifiedScaleValues && (n = m.modifiedScaleValues), c.push({ ...m, iteration: l, matchUpsCount: p?.length }), u = (m?.roundNumber ?? 1) + 1, p?.length && s.push(...p);
  }
  return { ...x, matchUps: s, roundResults: c };
}
function BL(e) {
  if (e.structureId) return e.structureId;
  let t = e.drawDefinition, r = t?.structures?.filter((n) => n.stageSequence === 1)?.reduce((n, a) => {
    let o = a.stage && yo[a.stage];
    return Tr({ structure: a }) && o > (yo[n?.stage] || 1) ? a : n;
  }, void 0), i = t?.structures?.find((n) => n.structureId === r?.structureId);
  return i ? Tr({ structure: i }) ? { structure: i } : { error: co } : { error: mt };
}
function VL(e) {
  return e.roundsCount && typeof e.roundsCount != "number" ? { error: z, info: "roundsCount must be a number" } : typeof e.drawDefinition != "object" || e.drawDefinition.drawType && e.drawDefinition.drawType !== Gr ? { error: co } : !Array.isArray(e.drawDefinition?.entries) && e.participantIds && !Array.isArray(e.participantIds) ? { error: z, info: "Missing Entries" } : { error: void 0 };
}
function jL(e) {
  let { tournamentRecord: t, drawDefinition: r, structureId: i, idPrefix: n, isMock: a, event: o } = e, s = o?.entries?.filter(({ entryStage: l, entryStatus: d }) => (!l || l === re) && d && Ni.includes(d)), c = s?.map(Re), u = s ? Math.floor(s.length / 2) : 0;
  if (e.automated) return GL({ ...e, participantIds: c });
  {
    let l = WI({ roundsCount: e.roundsCount, drawDefinition: r, matchUpsCount: u, idPrefix: n, isMock: a, event: o });
    if (l.error) return l;
    l.matchUps?.length && xp({ matchUps: l.matchUps, suppressNotifications: !0, tournamentRecord: t, drawDefinition: r, structureId: i, event: o });
  }
  return { ...x };
}
function GL(e) {
  let { restrictEntryStatus: t, generateMatchUps: r, structureId: i, matchUpIds: n, scaleName: a, scaleAccessor: o } = e.drawMatic ?? {}, s = HI({ ...e, eventType: e.drawMatic?.eventType ?? e.matchUpType, generateMatchUps: r ?? !0, scaleAccessor: o ?? e.scaleAccessor, scaleName: a ?? e.scaleName, participantIds: e.participantIds, roundsCount: e.roundsCount, restrictEntryStatus: t, structureId: i, matchUpIds: n });
  return s.error ? s : (s?.matchUps?.length && xp({ tournamentRecord: e.tournamentRecord, drawDefinition: e.drawDefinition, suppressNotifications: !0, matchUps: s.matchUps, event: e.event, structureId: i }), { ...x });
}
function $L({ requireParticipantCount: e = !0, enforcePolicyLimits: t = !0, drawSizeProgression: r, participantsCount: i, participantCount: n, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structureId: c, seedsCount: u }) {
  i = i ?? n;
  let l = me({ drawDefinition: o, structureId: c });
  if (l.error) return l;
  let d = l.structure;
  if (!d) return { error: mt };
  let { positionAssignments: p } = _t({ structure: d }), m = p?.length || 0;
  if (u > m) return { error: Tv };
  let f = d.structures?.length, h = Ie(s?.groupSeedingThreshold) && s?.groupSeedingThreshold, g = Qg({ roundRobinGroupsCount: f, drawSize: m })?.seedGroups, { seedsCount: I } = ll({ policyDefinitions: a, requireParticipantCount: e, drawSizeProgression: r, participantsCount: i, drawSize: m });
  return I && a?.[hi] && u > I && t && (u = I), d.seedLimit = u, d.seedAssignments = te(1, u + 1).map((U) => {
    let S = g?.find((D) => D.includes(U)), P = S && Math.min(...S), v = h && U >= h ? P : U;
    return { participantId: void 0, seedNumber: U, seedValue: v };
  }), tt({ drawDefinition: o, structureIds: [c] }), { ...x, seedLimit: u };
}
function Zo({ sortDescending: e = !1, tournamentRecord: t, scaleAttributes: r, scaleSortMethod: i, stageSequence: n, entries: a, event: o, stage: s }) {
  if (!t) return { error: J };
  return a = a ?? o?.entries ?? [], { scaledEntries: a.filter((l) => (!s || !l.entryStage || l.entryStage === s) && (!n || !l.entryStageSequence || l.entryStageSequence === n) && Ni.includes(l.entryStatus)).map((l) => {
    let { participantId: d } = l, { scaleItem: p } = ks({ tournamentRecord: t, scaleAttributes: r, participantId: d });
    return { ...l, ...p };
  }).filter((l) => {
    let d = l.scaleValue;
    return !i && (isNaN(d) || !parseFloat(d)) ? !1 : d;
  }).sort(i || c) };
  function c(l, d) {
    return e ? u(d) - u(l) : u(l) - u(d);
  }
  function u(l) {
    return parseFloat(l.scaleValue || (e ? -1 : 1e5));
  }
}
function CM(e) {
  let t = "prepareStage", { drawDefinition: r } = e, { structures: i } = Ti({ stageSequence: e.stageSequence || 1, roundTarget: e.roundTarget, stage: e.stage, drawDefinition: r }), n = e.preparedStructureIds || [], a = i?.find(({ structureId: m }) => !n.includes(m));
  if (!a) return F({ result: { error: mt }, stack: t });
  let o = a?.structureId, { seedsCount: s, stageEntries: c, seedLimit: u } = XL({ ...e, structureId: o });
  (e.seededParticipants || e.event || e.seedingScaleName) && HL({ ...e, seedsCount: s, structure: a, structureId: o });
  let l = e.automated !== !1 && e.drawType !== Gr && !(e.qualifyingOnly && e.stage !== se), d = (i?.length || 0) > 1, p = l ? WL({ ...e, multipleStructures: d, seedLimit: u, structureId: o }) : {};
  return p?.error ? F({ result: p, stack: t }) : { ...p, stageEntries: c, structureId: o, seedsCount: s };
}
function qL({ entries: e, stage: t, stageSequence: r, roundTarget: i }) {
  return e.filter((n) => {
    let a = we({ name: rn, element: n })?.extension?.value;
    return (!n.entryStage || n.entryStage === t) && (!r || !n.entryStageSequence || n.entryStageSequence === r) && (!i || !a || a === i) && Ja.includes(n.entryStatus);
  });
}
function WL(e) {
  let t = typeof e.automated == "object" && e.automated.seedsOnly, r = el({ ...e, seedsOnly: t });
  if (r.error) return r;
  let i = r?.positionAssignments, n = r?.positioningReport;
  return { conflicts: r.conflicts, positionAssignments: i, positioningReport: n };
}
function HL(e) {
  let { seededParticipants: t, seedingScaleName: r, entries: i, event: n } = e, a = i.map(Re);
  t ? zL({ ...e, enteredParticipantIds: a }) : (n || r) && YL({ ...e, enteredParticipantIds: a });
}
function zL(e) {
  let { provisionalPositioning: t, enteredParticipantIds: r, seededParticipants: i, tournamentRecord: n, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structureId: c, structure: u, event: l } = e, d = u ? Ko({ provisionalPositioning: t, appliedPolicies: a, drawDefinition: o, seedingProfile: s, structure: u }) : void 0;
  i.filter(({ participantId: p }) => r.includes(p)).filter((p) => !p.seedNumber || p.seedNumber <= i.length).sort((p, m) => p.seedNumber < m.seedNumber ? -1 : p.seedNumber < m.seedNumber ? 1 : 0).forEach((p) => {
    let { participantId: m, seedNumber: f, seedValue: h } = p;
    ac({ provisionalPositioning: t, tournamentRecord: n, drawDefinition: o, seedingProfile: s, participantId: m, seedBlockInfo: d, structureId: c, seedNumber: f, seedValue: h, event: l });
  });
}
function YL(e) {
  let t = e.seedsCount, { provisionalPositioning: r, enteredParticipantIds: i, seedAssignmentProfile: n, assignSeedsCount: a, tournamentRecord: o, drawDefinition: s, seedByRanking: c, seedingProfile: u, structureId: l, event: d } = e, { categoryName: p, ageCategoryCode: m } = d?.category || {};
  d?.eventType;
  let f = KL({ ...e }) || c && QL({ ...e }), h = f?.length ?? 0;
  h < t && (t = h), f?.filter(({ participantId: g }) => i.includes(g)).slice(0, a || t).forEach((g, I) => {
    let U = I + 1, { participantId: S, scaleValue: P } = g, v = n?.[U] || P || U;
    ac({ provisionalPositioning: r, tournamentRecord: o, drawDefinition: s, seedingProfile: u, participantId: S, structureId: l, seedNumber: U, seedValue: v, event: d });
  });
}
function KL(e) {
  let { tournamentRecord: t, seedingScaleName: r, stageSequence: i, entries: n, stage: a, event: o } = e, { categoryName: s, ageCategoryCode: c } = o?.category || {}, u = o?.eventType, l = { scaleName: r || s || c || o.eventId, scaleType: un, eventType: u };
  return Zo({ scaleAttributes: l, tournamentRecord: t, stageSequence: i, entries: n, stage: a }).scaledEntries;
}
function QL(e) {
  let { tournamentRecord: t, stageSequence: r, event: i, entries: n, stage: a } = e, { categoryName: o, ageCategoryCode: s } = i?.category || {}, c = i?.eventType;
  return Zo({ scaleAttributes: { scaleName: o || s, scaleType: ia, eventType: c }, tournamentRecord: t, stageSequence: r, entries: n, stage: a }).scaledEntries;
}
function XL(e) {
  let { seedsCount: t } = e;
  e.seededParticipants && (t = e.seededParticipants.length), t > e.drawSize && (t = e.drawSize);
  let r = qL(e);
  t > r.length && (t = r.length);
  let { seedLimit: i } = $L({ enforcePolicyLimits: e.enforcePolicyLimits ?? !0, appliedPolicies: e.appliedPolicies, participantsCount: r.length, seedingProfile: e.seedingProfile, drawDefinition: e.drawDefinition, structureId: e.structureId, seedsCount: t });
  return i && i < t && (t = i), { seedsCount: t, stageEntries: r, seedLimit: i };
}
function JL(e) {
  let t = OI({ ...e, modifyOriginal: !1 });
  if (t.error) return t;
  let r = t.drawDefinition, { suppressDuplicateEntries: i = !0, ignoreStageSpace: n, appliedPolicies: a, qualifyingOnly: o, seedingProfile: s, participants: c, drawEntries: u, placeByes: l, drawSize: d, drawType: p, entries: m } = e, f = [], h = [], g = ZL({ ignoreStageSpace: n, drawDefinition: r, drawEntries: u, drawType: p, entries: m });
  if (g.error) return g;
  let I = p === Ha ? 0 : pe(e.seedsCount ?? 0), U = CM({ ...e, qualifyingOnly: !d || o, appliedPolicies: a, drawDefinition: r, seedingProfile: s, participants: c, stage: re, seedsCount: I, placeByes: l, drawSize: d, entries: m });
  if (U.error && !U.conflicts) return U;
  U.positioningReport?.length && f.push({ [re]: U.positioningReport });
  let S = U.structureId;
  return U.conflicts && (h = U.conflicts), p === Gr && e.roundsCount && jL({ ...e, drawDefinition: r, structureId: S }), { drawDefinition: r, positioningReports: f, conflicts: h, structureId: S };
}
function ZL(e) {
  let { ignoreStageSpace: t, drawDefinition: r, drawEntries: i, drawType: n, entries: a } = e;
  for (let o of a) {
    if (i && o.entryStage && o.entryStage !== re) continue;
    let s = { ...o, ignoreStageSpace: t ?? n === Gr, entryStage: o.entryStage ?? re, event: e.event, drawDefinition: r, drawType: n }, c = jg(s);
    if (i && c.error) return c;
  }
  return { error: void 0 };
}
var e_ = () => ({ matchUpType: void 0, drawName: void 0, drawId: void 0, structures: [], entries: [], links: [] }), t_ = e_;
function r_(e) {
  let { drawId: t = je(), processCodes: r, matchUpType: i, drawType: n } = e ?? {}, a = t_();
  return Object.assign(a, { processCodes: r, matchUpType: i, drawType: n, drawId: t });
}
function zI(e) {
  let t = e.structureIds, { tournamentRecord: r, drawDefinition: i, matchUpFormat: n, structureId: a, matchUpId: o, event: s } = e, c = oe(e, [{ [lr]: !0, [Yh]: !0 }]);
  if (c.error) return c;
  if (!Vr({ matchUpFormat: n })) return { error: fu };
  let u = "setMatchUpFormat";
  if (o) {
    let l = ut({ drawDefinition: i, matchUpId: o, event: s });
    if (l.error) return l;
    let d = l.matchUp;
    if (d?.matchUpType === kt) return { info: "Cannot set matchUpFormat when { matchUpType: TEAM }", error: Cr };
    d && (d.matchUpFormat = n, Oe({ tournamentId: r?.tournamentId, eventId: s?.eventId, context: u, drawDefinition: i, matchUp: d }));
  } else if (Array.isArray(t)) {
    if (s?.eventType === kt) return { error: fn };
    for (let l of t) {
      let d = me({ drawDefinition: i, structureId: l });
      if (d.error) return d;
      d.structure && (d.structure.matchUpFormat = n);
    }
  } else if (a) {
    if (s?.eventType === kt) return { error: fn };
    let l = me({ drawDefinition: i, structureId: a });
    if (l.error) return l;
    l.structure && (l.structure.matchUpFormat = n);
  } else i && (i.matchUpFormat = n);
  return t = t ?? (a ? [a] : void 0), tt({ drawDefinition: i, structureIds: t }), { ...x };
}
function i_({ tieFormat: e }) {
  let t = wr({ checkCollectionIds: !1, tieFormat: e });
  if (t.error) return t;
  for (let r of e.collectionDefinitions) r.collectionId || (r.collectionId = je());
  return { tieFormat: e };
}
function n_({ existingQualifyingStructures: e, tournamentRecord: t, drawDefinition: r, matchUpFormat: i, matchUpType: n, tieFormat: a, event: o }) {
  if ((i || a) && !(i && o?.matchUpFormat === i || o?.tieFormat && a && JSON.stringify(o.tieFormat) === JSON.stringify(a))) {
    if (a) {
      let s = i_({ tieFormat: a });
      if (s.error) return s;
      let c = e?.every((u) => u.tieFormat);
      (!e?.length || c) && (r.tieFormat = s.tieFormat ?? a);
    } else if (i) {
      let s = zI({ tournamentRecord: t, drawDefinition: r, matchUpFormat: i, event: o });
      if (s.error) return { info: "matchUpFormat or tieFormat error", error: s.error };
    }
    n && (r.matchUpType = n);
  }
  return { error: void 0 };
}
var OM = {};
Me(OM, { attachPolicies: () => _a, findPolicy: () => Qa, getAppliedPolicies: () => _e, getPolicyDefinitions: () => Wn, mutate: () => kM, query: () => FM, removePolicy: () => xM });
var kM = {};
Me(kM, { attachPolicies: () => _a, removePolicy: () => xM });
function xM(e) {
  let t = oe(e, [{ [o1]: !0, _anyOf: { [ur]: !1, [Vt]: !1, [lr]: !1, [qn]: !1 } }]);
  if (t.error) return t;
  let r, i = e.drawDefinition ?? e.event ?? ((e.tournamentId || !e.tournamentRecords) && e.tournamentRecord);
  if (i) return Iy(e, i);
  if (e.tournamentRecords) {
    let n = Object.keys(e.tournamentRecords);
    if (!n.length) return { error: J };
    for (let a of n) {
      let o = e.tournamentRecords[a], s = Iy(e, o);
      if (s.error) return s;
      r = !0;
    }
  } else return { error: J };
  return r ? { ...x } : { error: hu };
}
function Iy(e, t) {
  let r = _e(e).appliedPolicies ?? {};
  return r[e.policyType] ? (delete r[e.policyType], Object.keys(r).length ? Be({ element: t, extension: { name: Yc, value: r } }) : fr({ element: t, name: Yc }), { ...x }) : { error: hu };
}
var FM = {};
Me(FM, { findPolicy: () => Qa, getAppliedPolicies: () => _e, getPolicyDefinitions: () => Wn });
var LM = { [hi]: { validSeedPositions: { ignore: !0 }, duplicateSeedNumbers: !0, drawSizeProgression: !0, seedingProfile: { drawTypes: { [Sn]: { positioning: Na }, [Di]: { positioning: Na } }, positioning: Q0 }, policyName: "USTA SEEDING", seedsCountThresholds: [{ drawSize: 4, minimumParticipantCount: 3, seedsCount: 2 }, { drawSize: 16, minimumParticipantCount: 12, seedsCount: 4 }, { drawSize: 32, minimumParticipantCount: 24, seedsCount: 8 }, { drawSize: 64, minimumParticipantCount: 48, seedsCount: 16 }, { drawSize: 128, minimumParticipantCount: 96, seedsCount: 32 }, { drawSize: 256, minimumParticipantCount: 192, seedsCount: 64 }] } }, $f = LM;
function a_({ appliedPolicies: e, policyDefinitions: t, drawDefinition: r, stack: i }) {
  if (t && typeof t != "object") return F({ info: "policyDefinitions must be an object", result: { error: z }, stack: i });
  let n = { [zc]: e?.[zc] };
  return t ? o_({ policyDefinitions: t, appliedPolicies: e, policiesToAttach: n, drawDefinition: r }) : n.avoidance && _a({ drawDefinition: r, policyDefinitions: n }), !e?.[hi] && !t?.[hi] && (_a({ policyDefinitions: $f, drawDefinition: r }), e && Object.assign(e, $f)), { error: void 0 };
}
function o_({ policyDefinitions: e, appliedPolicies: t, policiesToAttach: r, drawDefinition: i }) {
  for (let n of Object.keys(e)) JSON.stringify(t?.[n]) !== JSON.stringify(e[n]) && (r[n] = e[n]);
  Object.keys(r).length && (_a({ policyDefinitions: r, drawDefinition: i }), t && Object.assign(t, r));
}
function s_(e) {
  let { tournamentRecord: t, policyDefinitions: r, appliedPolicies: i, matchUpFormat: n, matchUpType: a, tieFormat: o, drawType: s, stack: c, event: u } = e, l = e.drawId ? u?.drawDefinitions?.find((I) => I.drawId === e.drawId) : void 0, d = l?.structures?.find((I) => I.stage === re && I.stageSequence === 1)?.structureId, p = l ? l.structures?.filter((I) => I.stage === se) : [], m = p?.length === 1 && !p[0].matchUps?.length && p[0].structureId;
  l && s !== l.drawType && (l.drawType = s);
  let f = l ?? r_({ processCodes: e.processCodes, drawId: e.drawId, drawType: s }), h = n_({ existingQualifyingStructures: p, tournamentRecord: t, drawDefinition: f, matchUpFormat: n, matchUpType: a, tieFormat: o, event: u });
  if (h.error) return F({ result: h, stack: c });
  let g = a_({ appliedPolicies: i, policyDefinitions: r, drawDefinition: f, stack: c });
  return g.error ? g : { drawDefinition: f, structureId: d, existingDrawDefinition: l, existingQualifyingPlaceholderStructureId: m };
}
function c_(e) {
  let t = "generateOrGetExisting", r = [], i = [], n = s_(e);
  if (n.error) return F({ result: n, stack: t });
  let a = n.existingDrawDefinition, o = n.drawDefinition ?? {}, s = n.structureId, c = e.drawEntries ?? e.eventEntries ?? [], u = n.existingQualifyingPlaceholderStructureId && xL({ ...e, ...n }) || JL({ ...e, ...n, entries: c });
  return u.error ? F({ result: u, stack: t }) : (u.positioningReports?.length && r.push(...u.positioningReports ?? []), u.conflicts?.length && i.push(...u.conflicts ?? []), o = u.drawDefinition, s = u.structureId, { existingDrawDefinition: a, positioningReports: r, drawDefinition: o, structureId: s, conflicts: i, entries: c });
}
function u_(e) {
  let { qualifyingPlaceholder: t, existingDrawDefinition: r, positioningReports: i, qualifyingProfiles: n, appliedPolicies: a, qualifyingOnly: o, drawDefinition: s, seedingProfile: c, participants: u, structureId: l, tieFormat: d, entries: p, stack: m } = e, f = t && !n?.length && !r, h = [];
  if (n) {
    let g = (P, v) => P.stageSequence - v.stageSequence, I = (P, v) => P.roundTarget - v.roundTarget, U = [], S = 1;
    n.sort(I);
    for (let P of n) {
      if (!Array.isArray(P.structureProfiles)) return F({ info: La("structureProfiles"), result: { error: ue }, stack: m });
      S = P.roundTarget || S;
      let v = P.structureProfiles?.sort(g) || [], D = 1;
      for (let y of v) {
        let { qualifyingRoundNumber: w, qualifyingPositions: b, seededParticipants: T, seedingScaleName: R, seedsCount: M = 0, seedByRanking: E, placeByes: A, drawSize: N } = y, C = CM({ ...e, seedingProfile: y.seedingProfile ?? c, stageSequence: D, qualifyingRoundNumber: w, preparedStructureIds: U, qualifyingPositions: b, seededParticipants: T, stage: se, seedingScaleName: R, appliedPolicies: a, drawDefinition: s, qualifyingOnly: o, seedByRanking: E, participants: u, roundTarget: S, seedsCount: M, placeByes: A, drawSize: N, entries: p });
        if (C.error) return C;
        C.structureId && U.push(C.structureId), D += 1, C.conflicts?.length && h.push(...C.conflicts), C.positioningReport?.length && i.push({ [se]: C.positioningReport });
      }
      S += 1;
    }
  } else if (l && f) {
    let g = ii({ structureName: ir(se), stage: se, qualifyingOnly: o, tieFormat: d }), { link: I } = tl({ sourceStructureId: g.structureId, targetStructureId: l, sourceRoundNumber: 0, linkType: gn });
    s.structures || (s.structures = []), s.structures.push(g), s.links || (s.links = []), s.links.push(I);
  }
  return { qualifyingConflicts: h, error: void 0 };
}
var _M = {};
Me(_M, { addGoesTo: () => Fa, allCompetitionMatchUps: () => Bi, allDrawMatchUps: () => hr, allEventMatchUps: () => Rn, allPlayoffPositionsFilled: () => iI, allTournamentMatchUps: () => Jt, analyzeDraws: () => cl, analyzeMatchUp: () => ou, analyzeTournament: () => iU, bulkUpdatePublishedEventIds: () => aU, calculateWinCriteria: () => ts, categoryCanContain: () => vu, checkMatchUpIsComplete: () => ba, checkValidEntries: () => _p, compareTieFormats: () => jn, competitionScheduleMatchUps: () => gl, courtGridRows: () => nm, credits: () => l_, drawMatchUps: () => SU, eventMatchUps: () => sm, filterMatchUps: () => An, filterParticipants: () => Ku, findDrawDefinition: () => MI, findExtension: () => we, findVenue: () => Mn, getAggregateTeamResults: () => rU, getAllDrawMatchUps: () => Et, getAllEventData: () => oU, getAllStructureMatchUps: () => Ve, getAllowedDrawTypes: () => zp, getAllowedMatchUpFormats: () => ZI, getAppliedPolicies: () => _e, getAssignedParticipantIds: () => eo, getAvailableMatchUpsCount: () => Fp, getAvailablePlayoffProfiles: () => il, getCategoryAgeDetails: () => Uo, getCheckedInParticipantIds: () => $o, getCompetitionDateRange: () => Kp, getCompetitionMatchUps: () => au, getCompetitionParticipants: () => YI, getCompetitionPenalties: () => eU, getCompetitionVenues: () => pl, getCourtInfo: () => Sp, getCourts: () => yU, getDrawData: () => Jp, getDrawDefinitionTimeItem: () => wg, getDrawParticipantRepresentativeIds: () => TI, getDrawStructures: () => Ti, getDrawTypeCoercion: () => ul, getEligibleVoluntaryConsolationParticipants: () => wI, getEntriesAndSeedsCount: () => am, getEvent: () => DU, getEventData: () => Zp, getEventMatchUpFormatTiming: () => lU, getEventProperties: () => vU, getEventPublishStatus: () => mi, getEventStructures: () => Mp, getEventTimeItem: () => Cu, getEvents: () => PU, getFlightProfile: () => wt, getHomeParticipantId: () => fU, getLinkedTournamentIds: () => Nu, getMatchUpCompetitiveProfile: () => ju, getMatchUpContextIds: () => hU, getMatchUpDailyLimits: () => um, getMatchUpDailyLimitsUpdate: () => dU, getMatchUpDependencies: () => Ei, getMatchUpFormat: () => gU, getMatchUpFormatTiming: () => Gu, getMatchUpFormatTimingUpdate: () => uU, getMatchUpScheduleDetails: () => yp, getMatchUpType: () => vp, getMatchUpsMap: () => or, getMatchUpsStats: () => IU, getMatchUpsToSchedule: () => em, getMaxEntryPosition: () => cU, getModifiedMatchUpFormatTiming: () => om, getPairedParticipant: () => bi, getParticipantEventDetails: () => KI, getParticipantIdFinishingPositions: () => bI, getParticipantMembership: () => QI, getParticipantResults: () => nl, getParticipantScaleItem: () => ks, getParticipantSchedules: () => XI, getParticipantSignInStatus: () => JI, getParticipantTimeItem: () => Tg, getParticipants: () => ft, getPersonRequests: () => io, getPolicyDefinitions: () => Wn, getPositionAssignments: () => ru, getPositionsPlayedOff: () => sc, getPredictiveAccuracy: () => mU, getProfileRounds: () => im, getPublishState: () => zo, getRandomQualifierList: () => EI, getRoundMatchUps: () => Ir, getRounds: () => UU, getScaleValues: () => Qs, getScaledEntries: () => Zo, getScheduledRoundsDetails: () => ml, getSchedulingProfile: () => Kn, getSchedulingProfileIssues: () => sU, getSeedingThresholds: () => Xg, getSeedsCount: () => ll, getStructureSeedAssignments: () => si, getTeamLineUp: () => xa, getTieFormat: () => Xp, getTimeItem: () => li, getTournamentIds: () => Mu, getTournamentInfo: () => es, getTournamentPenalties: () => Yp, getTournamentPersons: () => tU, getTournamentPoints: () => Qp, getTournamentPublishStatus: () => Yu, getTournamentStructures: () => rI, getTournamentTimeItem: () => fp, getValidGroupSizes: () => Ju, getVenueData: () => Cs, getVenuesAndCourts: () => Yn, isAdHoc: () => Tr, isCompletedStructure: () => wn, isValidForQualifying: () => AI, isValidMatchUpFormat: () => Vr, matchUpActions: () => Lp, participantScaleItem: () => dn, participantScheduledMatchUps: () => pU, positionActions: () => NI, publicFindCourt: () => Fg, publicFindVenue: () => xg, tallyParticipantResults: () => cc, tieFormatGenderValidityCheck: () => qd, tournamentMatchUps: () => cm, validMatchUp: () => hp, validMatchUps: () => pi, validateCollectionDefinition: () => Pu, validateLineUp: () => bp });
function l_() {
  return `
    This project would not have been possible without the generous input and patience
    of tournament organizers and directors who worked with early versions of CourtHive/TMX.

    Thanks to Miro, Pavel, Ivan, Mladen, Zdenko, Antonia, Jakov, Kreso, Barry, Jeff, Bobby... to name just a few. 

    The project would not have even begun without the support of Miro, or the introduction by Sretchko.
    The project would not have succeeded without the enthusiasm of Randy and Bruce.
    Thanks to serendipity and Luca and the ensuing TODS conversations with ITF.
    Thanks to Scott and Jake for sanity checks, suggestions, and camaraderie.
    Thanks to Zoran for inspiring the async support and getting into the weeds with subscriptions.
    Thanks to Dave for backing the conversion of TMX 1.x source into the factory repository.
    Thanks to Vuk and Pavle and Rich and Chris and Deepa for the direct engagement with the APIs.
    Thanks to Joe for repeatedly challenging me and the many pointers to useful tooling.
    Thanks to Shannon for the validation of the approach from his deep domain experience.
    Thanks to Nikola for the ongoing camaraderie and explorations of what we can do with TODS.

    And a special thanks to my family for putting up with the long days and weeks and months of coding
    and conversations at all hours.
  `;
}
var BM = {};
Me(BM, { filterParticipants: () => Ku, getCompetitionParticipants: () => YI, getPairedParticipant: () => bi, getParticipantEventDetails: () => KI, getParticipantMembership: () => QI, getParticipantScaleItem: () => ks, getParticipantSchedules: () => XI, getParticipantSignInStatus: () => JI, getParticipantTimeItem: () => Tg, getParticipants: () => ft, getScaleValues: () => Qs, participantScaleItem: () => dn, validateLineUp: () => bp });
function YI(e) {
  let { tournamentRecords: t } = e || {};
  if (typeof t != "object" || !Object.keys(t).length) return { error: ht };
  let r = [], i = {}, n = {}, a = {}, o = [], s = {}, c = [];
  for (let u of Object.values(t)) {
    let { participantIdsWithConflicts: l, mappedMatchUps: d, participantMap: p, participants: m, matchUps: f, derivedEventInfo: h, derivedDrawInfo: g } = ft({ ...e, tournamentRecord: u });
    Object.assign(s, d), Object.assign(i, p), Object.assign(n, h), Object.assign(a, g), r.push(...m ?? []), o.push(...f ?? []), l?.forEach((I) => {
      c.includes(I) || c.push(I);
    });
  }
  return { participantIdsWithConflicts: c, derivedEventInfo: n, derivedDrawInfo: a, participantMap: i, mappedMatchUps: s, participants: r, ...x, matchUps: o };
}
function KI({ tournamentRecord: e, participantId: t }) {
  if (!e) return { error: J };
  if (!t) return { error: Ft };
  let r = [t].concat((e.participants ?? []).filter((i) => i?.participantType && [We, De].includes(i.participantType) && i.individualParticipantIds?.includes(t)).map((i) => i.participantId));
  return { eventDetails: (e.events ?? []).filter((i) => {
    let n = (i?.entries ?? []).map((a) => a.participantId);
    return gr(n, r);
  }).map((i) => ({ eventName: i.eventName, eventId: i.eventId })) };
}
function QI({ tournamentRecord: e, participantId: t }) {
  if (!e) return { error: J };
  if (!t) return { error: Ft };
  let { participants: r } = ft({ participantFilters: { participantTypes: [We, De, Xr] }, tournamentRecord: e });
  return (r ?? []).filter((i) => i.individualParticipantIds?.includes(t)).reduce((i, n) => {
    let a = n.participantType;
    return a && (i[a] || (i[a] = []), i[a].push(n)), i;
  }, {});
}
function XI({ participantFilters: e = {}, tournamentRecord: t }) {
  if (!t) return { error: J };
  if (typeof e != "object") return { error: $n, context: { participantFilters: e } };
  let r = { eventIds: e.eventIds }, i = Jt({ tournamentRecord: t, contextFilters: r }).matchUps ?? [], n = Object.assign({}, ...i.map((c) => ({ [c.matchUpId]: c }))), a = i.filter(({ schedule: c }) => c && Object.keys(c).length), o = Ei({ tournamentRecord: t, matchUps: i }).sourceMatchUpIds ?? [], s = {};
  for (let c of a) {
    let { sides: u } = c, l, d = u?.map((m) => {
      if (m.participant) return [m.participant].concat(...m.participant.individualParticipants || []);
      o[c.matchUpId] && !l && (l = (o[c.matchUpId] || []).map((f) => n[f]).filter(({ winningSide: f, bye: h }) => !f && !h));
    }).filter(Boolean).flat() ?? [];
    for (let m of d) {
      let { participantId: f } = m;
      s[f] || (s[f] = { potentialMatchUps: [], participant: m, matchUps: [] }), s[f].matchUps.push(c);
    }
    let p = l?.map(({ sides: m }) => m).flat().map(({ participant: m }) => m && [m].concat(...m.individualParticipants || [])).filter(Boolean).flat() || [];
    for (let m of p) {
      let { participantId: f } = m;
      s[f] || (s[f] = { potentialMatchUps: [], participant: m, matchUps: [] }), s[f].potentialMatchUps.push(c);
    }
  }
  return { participantSchedules: Object.values(s).filter(({ participant: c }) => !(e.participantIds && !e.participantIds.includes(c.participantId) || e.participantTypes && !e.participantTypes.includes(c.participantType))), ...x };
}
function JI({ tournamentRecord: e, participantId: t }) {
  if (!e) return { error: J };
  if (!t) return { error: Ft };
  let { participant: r } = ha({ tournamentRecord: e, participantId: t });
  if (!r) return { error: Tt };
  let { timeItem: i } = li({ itemType: Au, element: r });
  return i && i.itemValue === Qc && Qc;
}
var VM = {};
Me(VM, { analyzeDraws: () => cl, analyzeTournament: () => iU, getAggregateTeamResults: () => rU, getAllowedDrawTypes: () => zp, getAllowedMatchUpFormats: () => ZI, getAppliedPolicies: () => _e, getCompetitionDateRange: () => Kp, getCompetitionPenalties: () => eU, getPolicyDefinitions: () => Wn, getTournamentInfo: () => es, getTournamentPenalties: () => Yp, getTournamentPersons: () => tU, getTournamentPoints: () => Qp, getTournamentStructures: () => rI, getTournamentTimeItem: () => fp });
function ZI({ tournamentRecord: e, categoryName: t, categoryType: r }) {
  if (!e) return { error: J };
  let { appliedPolicies: i } = _e({ tournamentRecord: e });
  return (i?.[oi]?.matchUpFormats || []).filter(({ categoryNames: n, categoryTypes: a }) => !t && !a || t && n?.includes(t) || r && a?.includes(r));
}
function zp({ tournamentRecord: e, categoryName: t, categoryType: r }) {
  if (!e) return { error: J };
  let { appliedPolicies: i } = _e({ tournamentRecord: e });
  return (i?.[ed]?.allowedDrawTypes || []).filter(({ categoryNames: n, categoryTypes: a }) => !t && !a || t && n?.includes(t) || r && a?.includes(r));
}
function Yp({ tournamentRecord: e }) {
  if (!e) return { error: J };
  let t = (e?.participants ?? []).reduce((r, i) => {
    let { participantId: n } = i;
    return (i.penalties ?? []).forEach((a) => {
      let { penaltyId: o } = a || {};
      r[o] ? r[o].participants.push(n) : r[o] = { ...a, participantIds: [n] };
    }), r;
  }, {});
  return { penalties: Object.values(t) };
}
function eU({ tournamentRecords: e }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: ht };
  let t = [];
  for (let r of Object.values(e)) {
    let { penalties: i } = Yp({ tournamentRecord: r });
    t.push(...i ?? []);
  }
  return { penalties: t };
}
function jM({ event: e }) {
  return { eventInfo: (({ eventId: t, eventName: r, eventType: i, eventLevel: n, surfaceCategory: a, matchUpFormat: o, category: s, gender: c, startDate: u, endDate: l, ballType: d, discipline: p, onlineResources: m, notes: f }) => ({ eventId: t, eventName: r, eventType: i, eventLevel: n, surfaceCategory: a, matchUpFormat: o, category: s, gender: c, startDate: u, endDate: l, ballType: d, discipline: p, onlineResources: m, notes: f }))(e) };
}
var d_ = { [Xs]: { policyName: "Staff Privacy Policy", participant: { contacts: !1, individualParticipants: !1, individualParticipantIds: !1, onlineResources: !1, participantName: !0, participantOtherName: !0, participantId: !0, participantRole: !0, participantRoleResponsibilities: !0, participantStatus: !0, penalties: !1, representing: !0, participantType: !0, person: { addresses: !1, biographicalInformation: !1, birthDate: !1, contacts: !1, nationalityCode: !0, nativeFamilyName: !1, nativeGivenName: !1, onlineResources: !1, otherNames: !0, parentOrganisationId: !1, passportFamilyName: !1, passportGivenName: !1, personId: !1, personOtherIds: !1, previousNames: !1, sex: !1, standardFamilyName: !0, standardGivenName: !0, status: !1, tennisId: !1, wheelchair: !0 } } } }, p_ = d_;
function es(e) {
  let { tournamentRecord: t } = e ?? {};
  if (!t) return { error: J };
  let r = (({ tournamentId: s, tournamentRank: c, tournamentStatus: u, formalName: l, tournamentName: d, promotionalName: p, onlineResources: m, localTimeZone: f, activeDates: h, startDate: g, endDate: I, hostCountryCode: U, venues: S, notes: P, updatedAt: v }) => ({ tournamentId: s, tournamentRank: c, tournamentStatus: u, formalName: l, tournamentName: d, promotionalName: p, onlineResources: m, localTimeZone: f, activeDates: h, startDate: g, endDate: I, hostCountryCode: U, venues: S, notes: P, updatedAt: v }))(t), i = ft({ participantFilters: { participantRoles: [iT, $g, nT, aT, sT] }, policyDefinitions: p_, tournamentRecord: t })?.participants ?? [];
  i && (r.tournamentContacts = i);
  let n = zo({ tournamentRecord: t })?.publishState, a = n?.tournament?.status?.publishedEventIds || [], o = [];
  for (let s of t.events ?? []) if (!e?.usePublishState || a.includes(s.eventId)) {
    let c = jM({ event: s }).eventInfo;
    c && o.push(c);
  }
  return r.timeItemValues = pb({ element: t }), r.publishState = n?.tournament, r.eventInfo = o, { tournamentInfo: ie(ae(r), !1, !0), ...x };
}
function Kp({ tournamentRecords: e }) {
  if (!xe(e)) return { error: ht };
  let t = Object.keys(e ?? {}).reduce((n, a) => {
    let o = e[a], { tournamentInfo: { startDate: s, endDate: c } } = es({ tournamentRecord: o }), u = s && new Date(ve(s));
    (!n.startDate || u && u < n.startDate) && (n.startDate = u);
    let l = c && new Date(ve(c));
    return (!n.endDate || l && l > n.endDate) && (n.endDate = l), n;
  }, { startDate: void 0, endDate: void 0 }), r = t.startDate && ve(t.startDate.toISOString()), i = t.endDate && ve(t.endDate.toISOString());
  return !r || !i ? { error: qv } : { startDate: r, endDate: i };
}
function tU({ tournamentRecord: e, participantFilters: t }) {
  if (!e) return { error: J };
  let r = e.participants || [];
  t && (r = Ku({ participants: r, participantFilters: t, tournamentRecord: e }));
  let i = {}, n = (a) => {
    if (a.person) {
      let { personId: o } = a.person;
      i[o] ? i[o].participantIds.push(a.participantId) : i[o] = { ...a.person, participantIds: [a.participantId] };
    }
  };
  return r.forEach((a) => {
    a.person && n(a);
  }), { tournamentPersons: Object.values(i) };
}
function rU(e) {
  let t = oe(e, [{ [Vt]: !0 }]);
  if (t.error) return t;
  let r = e.finishingPositionRangeBounsPoints || {}, i = {}, n = (d) => {
    let p = d?.individualParticipants?.map((m) => m.teams?.length === 1 && m.teams[0]);
    return d?.teams?.length === 1 && d?.teams?.[0] || p?.[0].participantId === p?.[1].participantId && p?.[0];
  }, { matchUps: a, participants: o } = ft({ participantFilters: { participantTypes: [Ne] }, withRankingProfile: !0, withStatistics: !0, ...e });
  for (let d of o ?? []) {
    if (d.participantType === Pr) continue;
    d.draws?.[0]?.drawId === "draw-0-3" && console.log(d.participantType, d.draws[0].finishingPositionRange);
    let p = n(d);
    if (p) for (let m of d?.draws ?? []) {
      let f = m?.finishingPositionRange?.join("-");
      if (f && r?.[f]) {
        let h = p?.participantId, g = m?.drawId, I = `${h}|${g}|${f}`;
        i[I] = r[f];
      }
    }
  }
  let s = (d) => ({ teamName: d, standingPoints: 0, pointsPlayed: 0, pointsPct: 0, points: 0, bonus: 0, diff: 0, loss: 0, win: 0 }), c = (d, p, m) => {
    d[p] === void 0 && (d[p] = 0), d[p] += m;
  }, u = {}, l = {};
  for (let d of a ?? []) {
    let { sides: p, matchUpFormat: m } = d, f = m && Sr(m);
    if (p?.length === 2 && f.setFormat?.timed && (!f.finalSetFormat || f.finalSetFormat?.timed)) for (let h of p) {
      let g = n(h.participant), I = g?.participantId, U = h.participant?.participantId, S = g?.participantName, P = h.sideNumber, v = h.participant?.individualParticipantIds || U && [U] || [];
      if (v.forEach((D) => {
        D && !u[D] && (u[D] = s(S));
      }), I && P) {
        l[I] || (l[I] = s(S));
        let D = [...v.map((w) => u[w]), l[I]];
        d.winningSide && (P === d.winningSide ? D.forEach((w) => c(w, "win", 1)) : D.forEach((w) => c(w, "loss", 1)));
        let y = d.score?.sets || [];
        for (let w of y) {
          let b = w?.[`side${3 - P}Score`] || 0, T = w?.[`side${P}Score`] || 0, R = T - b;
          D.forEach((M) => c(M, "pointsPlayed", T + b)), D.forEach((M) => c(M, "points", T)), D.forEach((M) => c(M, "diff", R));
        }
      }
    }
  }
  for (let d of Object.keys(i)) {
    let [p] = d.split("|");
    l[p] && (l[p].bonus += i[d], l[p].pointsPct = parseFloat((l[p].points / l[p].pointsPlayed).toFixed(2)), l[p].standingPoints = l[p].win + l[p].bonus);
  }
  for (let d of Object.keys(u)) u[d].pointsPct = parseFloat((u[d].points / u[d].pointsPlayed).toFixed(2));
  return { ...x, individualResults: u, teamResults: l };
}
function m_(e) {
  let t = e.participants?.filter(({ participantType: a }) => a === We)?.length === 2, r = e.events?.length === 1 && e.events[0], i = r?.drawDefinitions?.length === 1 && r.drawDefinitions[0], n = (i?.structures?.length === 1 && i.structures[0])?.positionAssignments?.length === 2;
  return !!(r.tieFormat && t && n);
}
function iU({ tournamentRecord: e }) {
  if (!e) return { error: J };
  let { drawsAnalysis: t } = cl({ tournamentRecord: e }), r = { isDual: m_(e), drawsAnalysis: t }, i = ft({ tournamentRecord: e });
  return i.missingParticipantIds?.length && (r.missingParticipantIds = i.missingParticipantIds), { ...x, analysis: r };
}
function GM(e, t) {
  return e && t && Array.isArray(t) && t[e - 1] || typeof t == "object" && t[e];
}
function f_(e) {
  let { participation: t = {}, awardProfiles: r, startDate: i, eventType: n, drawSize: a, drawType: o, category: s, endDate: c, level: u } = e, { participationOrder: l, flightNumber: d, rankingStage: p } = t, m = (f) => !i && !c || !f.dateRanges ? !0 : f.dateRanges.some((h) => {
    let g = !i || !h.startDate || new Date(i) > new Date(h.startDate), I = !c || !h.endDate || new Date(c) <= new Date(h.endDate);
    return g && I;
  });
  return { awardProfile: r.find((f) => m(f) && (!f.maxFlightNumber || d <= f.maxFlightNumber) && (!f.drawTypes?.length || f.drawTypes?.includes(o)) && (!f.drawSizes?.length || f.drawSizes.includes(a)) && (!f.stages?.length || f.stages.includes(p)) && (!f.levels?.length || f.levels.includes(u)) && (!f.maxDrawSize || a <= f.maxDrawSize) && (!f.drawSize || f.drawSize === a) && (!f.maxLevel || u <= f.maxLevel) && (!d || !f.flights?.flightNumbers?.length || f.flights.flightNumbers.includes(d)) && (!f.participationOrder || f.participationOrder === l) && (!f.category?.ageCategoryCodes || f.category.ageCategoryCodes.includes(s?.ageCategoryCode)) && (!f.eventTypes?.length || f.eventTypes?.includes(n))) };
}
function Uy({ participantWon: e, flightNumber: t, valueObj: r, drawSize: i, flights: n, level: a }) {
  let o = (f, h) => {
    if (f) {
      if (Array.isArray(h)) {
        let g = h.find((I) => I.flight === f || I.f === f);
        return g.value || g.v;
      }
      if (typeof h == "object") {
        let g = h.flights || h.f;
        if (Array.isArray(g)) return g[f - 1];
      }
    }
  }, s = (f, h) => {
    let g = f?.value || f?.v || (Ie(f) ? f : 0), I = GM(a, f?.level);
    return { value: o(h, I) || Ie(I) && I || g };
  }, c = 0, u, l, d, p, m = e && "won" || e === !1 && "lost" || void 0;
  if (Array.isArray(r)) {
    let f = r.find((I) => I.drawSize === i || I.drawSizes?.includes(i)), h = r.find((I) => I.drawSize && I.threshold && i > I.drawSize), g = r.find((I) => !I.drawSize && !I.drawSizes?.length);
    m !== void 0 && (f = f?.[m], h = h?.[m], g = g?.[m]), l = s(f, t).value, d = s(h, t).value, p = s(g, t).value, c = l || d || p, u = l && f.requireWin || d && h.requireWin || g?.requireWin;
  } else if (typeof r == "object") {
    let f = r?.drawSizes?.[i], h = r;
    m !== void 0 && (f = f?.[m], h = h?.[m]), l = s(f, t).value, p = s(h, t).value, c = l || p, u = l ? f.requireWin : h?.requireWin;
  } else Ie(r) && m === void 0 && (c = r);
  return t && n?.pct?.[t] && (c = Math.round(c * n.pct[t])), { awardPoints: c, requireWin: u };
}
function Qp({ participantFilters: e, policyDefinitions: t, tournamentRecord: r, level: i }) {
  if (!r) return { error: J };
  let { policyDefinitions: n } = Wn({ policyTypes: [kl], tournamentRecord: r }), a = t?.[kl] ?? n?.[kl];
  if (!a) return { error: Ed };
  let o = a.awardProfiles, s = a.requireWinFirstRound, c = a.requireWinForPoints, { participants: u, derivedEventInfo: l, derivedDrawInfo: d, mappedMatchUps: p } = ft({ withRankingProfile: !0, participantFilters: e, tournamentRecord: r }), m = u?.filter((I) => I.draws?.length), f = {}, h = {}, g = {};
  for (let I of m ?? []) {
    let { participantType: U, participantId: S, person: P, draws: v } = I;
    for (let D of v) {
      let { drawId: y, structureParticipation: w, eventId: b } = D, T = l[b], R = d[y], M = R?.drawType, { category: E, eventType: A } = T || {}, N = D.startDate || T.startDate || r.startDate, C = D.endDate || T.endDate || r.endDate;
      if (A === jr && S !== Pr) continue;
      let k;
      if (o) {
        let O = c, _ = 0, B = 0, L = 0, j;
        for (let H of w) {
          let { finishingPositionRange: G, participationOrder: V, participantWon: $, flightNumber: q, rankingStage: Y, winCount: W } = H;
          _ += W || 0;
          let K = R?.drawSize, { awardProfile: Q } = f_({ awardProfiles: o, participation: H, eventType: A, startDate: N, category: E, drawSize: K, drawType: M, endDate: C, level: i });
          if (Q) {
            if (!K) continue;
            let X = Array.isArray(G) && Math.max(...G), ee = Ue(G || []).join("-"), Z = X && Y !== se && G?.includes(K);
            Q.requireWinForPoints !== void 0 && (O = Q.requireWinForPoints), Q.requireWinFirstRound !== void 0 && (s = Q.requireWinFirstRound);
            let { finishingPositionPoints: ce = {}, finishingPositionRanges: fe, finishingRound: He, pointsPerWin: Te, flights: $e } = Q, it = Array.isArray(Q.perWinPoints) ? Q.perWinPoints?.find((lt) => lt.participationOrders?.includes(V)) : Q.perWinPoints, It = ce.participationOrders, Rt = 0, de;
            if ((!It || It.includes(V)) && fe && X) {
              let lt = fe[X];
              lt && ({ awardPoints: Rt, requireWin: de } = Uy({ flightNumber: q, valueObj: lt, drawSize: K, flights: $e, level: i }));
            }
            if (!Rt && He && V === 1 && X) {
              let lt = He[X];
              lt && ({ awardPoints: Rt, requireWin: de } = Uy({ participantWon: $, flightNumber: q, valueObj: lt, drawSize: K, flights: $e, level: i }));
            }
            if (Z && s !== void 0 && (O = s), de !== void 0 && (O = de), Rt > B && (!O || W) && (B = Rt, j = X), !Rt && Te && W && (L += W * Te, j = ee), !Rt && W && it) {
              let lt = GM(i, it?.level);
              lt ? L += W * lt : it.value && (L += W * it.value);
            }
          }
          if (k = B + L, U === Pr) {
            let X = (I.matchUps || []).filter(({ structureId: ee }) => ee === H.structureId);
            for (let { matchUpId: ee } of X) {
              let Z = p[ee], ce = Z.sides.find((fe) => fe.participantId === S).sideNumber;
              if (Z.winningSice === ce) for (let fe of Z.tieMatchUps) fe.winningSide;
            }
          }
        }
        if (L || B) {
          let H = { winCount: _, positionPoints: B, rangeAccessor: j, perWinPoints: L, eventType: A, drawId: y, points: k }, G = P?.personId;
          G ? (f[G] || (f[G] = []), f[G].push(H)) : U === De ? (g[S] || (g[S] = []), g[S].push(H)) : U === Pr && (h[S] || (h[S] = []), h[S].push(H));
        }
      }
    }
  }
  return { participantsWithOutcomes: m, personPoints: f, pairPoints: g, teamPoints: h, ...x };
}
var $M = {};
Me($M, { compareTieFormats: () => jn, getTieFormat: () => Xp, tieFormatGenderValidityCheck: () => qd, validateCollectionDefinition: () => Pu });
function Id(e) {
  if (!e) return {};
  let t = [], r = e.tieFormatName, i = e.collectionDefinitions?.map((n) => {
    let { matchUpType: a, matchUpFormat: o, matchUpCount: s, category: c, gender: u } = n;
    t.includes(o) || t.push(o);
    let l = c?.ageCategoryCode;
    return [s, a === Ma ? "D" : "S", l, o, u].join(";");
  }).join("|");
  return { tieFormatName: e && r || "UNNAMED", matchUpFormats: t, tieFormatDesc: i };
}
function jn({ considerations: e = {}, descendant: t, ancestor: r }) {
  let i = {}, n = {}, { matchUpFormats: a, tieFormatDesc: o } = Id(t), { matchUpFormats: s, tieFormatDesc: c } = Id(r), u = Ue((a ?? []).filter((v) => !(s ?? []).includes(v)).concat((s ?? []).filter((v) => !(a ?? []).includes(v)))), l = !!(e?.collectionName && t.collectionDefinitions.map(({ collectionName: v }) => v).join("|") !== r.collectionDefinitions.map(({ collectionName: v }) => v).join("|")), d = !!(e?.collectionOrder && t.collectionDefinitions.map(({ collectionOrder: v }) => v).join("|") !== r.collectionDefinitions.map(({ collectionOrder: v }) => v).join("|")), p = Object.assign({}, ...(t?.collectionDefinitions || []).map((v) => ({ [v.collectionId]: v }))), m = Object.assign({}, ...(r?.collectionDefinitions || []).map((v) => ({ [v.collectionId]: v })));
  i.collectionIds = FS(Object.keys(p), Object.keys(m)), n.collectionIds = FS(Object.keys(m), Object.keys(p)), i.collectionsValue = Sy(p), n.collectionsValue = Sy(m), i.groupsCount = r?.collectionGroups?.length ?? (0 - (t?.collectionGroups?.length ?? 0) || 0), n.groupsCount = i.groupsCount ? -1 * i.groupsCount : 0;
  let f = i.collectionsValue.totalValue - n.collectionsValue.totalValue, h = i.collectionsValue.totalMatchUps - n.collectionsValue.totalMatchUps, g = n.collectionsValue.assignmentValues.length !== i.collectionsValue.assignmentValues.length, I = n.collectionsValue.assignmentValues.some((v, D) => {
    let y = i.collectionsValue.assignmentValues[D];
    return !y || v.valueKey !== y.valueKey || v.value !== y.value ? !0 : Array.isArray(v.value) ? v.value.every((w, b) => y.value[b] === w) : !1;
  }), U = l || d || c !== o || g || I || f !== 0, S = [...n.collectionsValue.invalidValues, ...i.collectionsValue.invalidValues], P = S.length && S;
  return { matchUpFormatDifferences: u, matchUpCountDifference: h, descendantDifferences: i, ancestorDifferences: n, orderDifference: d, valueDifference: f, nameDifference: l, descendantDesc: o, ancestorDesc: c, ...x, different: U, invalid: P };
}
function Sy(e) {
  let t = [], r = [], i = 0;
  return { totalValue: Object.keys(e).sort(Dp).reduce((n, a) => {
    let o = e[a], { collectionValueProfiles: s, collectionValue: c, matchUpCount: u, matchUpValue: l, scoreValue: d, setValue: p } = o, m = { collectionValueProfiles: s, collectionValue: c, matchUpValue: l, scoreValue: d, setValue: p }, f = Object.keys(m).filter((g) => ![void 0, null].includes(m[g]) && (!Array.isArray(m[g]) || m[g].length > 0));
    f.length !== 1 && t.push({ collectionId: a });
    let h = f[0];
    if (h) {
      let g = h === "collectionValueProfiles" ? Object.values(s) : m[h];
      r.push({ valueKey: h, value: g });
    }
    return i += u, s?.length ? n + s.reduce((g, I) => g + I.value, 0) : u ? Ie(l) ? n + l * u : Ie(d) ? n + d * u : Ie(p) ? n + p * u : n + c : n;
  }, 0), totalMatchUps: i, invalidValues: t, assignmentValues: r };
}
function nU(e) {
  Object.assign(e, { inContext: !0 });
  let { matchUp: t, error: r } = qM(e);
  return { matchUp: ie(t, !0, !0), error: r };
}
function qM({ participantsProfile: e, afterRecoveryTimes: t, tournamentRecord: r, contextContent: i, contextProfile: n, drawDefinition: a, nextMatchUps: o, matchUpId: s, inContext: c, eventId: u, drawId: l, event: d }) {
  if (!r) return { error: J };
  if (typeof s != "string") return { error: pr };
  if (!a || !d) {
    let f = (Jt({ tournamentRecord: r, nextMatchUps: o }).matchUps ?? []).find((h) => h.matchUpId === s);
    if (!f) return { error: cr };
    ({ eventId: u, drawId: l } = f), { event: d, drawDefinition: a } = br({ tournamentRecord: r, eventId: u, drawId: l });
  }
  if (!a) return { error: zr };
  n && !i && (i = Hn({ tournamentRecord: r, contextProfile: n }));
  let p = { surfaceCategory: d?.surfaceCategory ?? r.surfaceCategory, indoorOutDoor: d?.indoorOutdoor ?? r.indoorOutdoor, endDate: d?.endDate ?? r.endDate, tournamentId: r.tournamentId, eventId: u ?? d?.eventId, drawId: l }, { participants: m = [] } = Ka({ participantsProfile: e, tournamentRecord: r, contextProfile: n, inContext: c });
  if (o) {
    let f = (hr({ context: c ? p : void 0, participants: m, afterRecoveryTimes: t, contextContent: i, contextProfile: n, drawDefinition: a, nextMatchUps: o, inContext: c, event: d }).matchUps ?? []).find((g) => g.matchUpId === s);
    if (!f) return { error: cr };
    let h = a?.structures?.find((g) => g.structureId === f.structureId);
    return { drawDefinition: a, structure: h, matchUp: f };
  } else {
    let { matchUp: f, structure: h } = ut({ context: c ? p : void 0, tournamentParticipants: m, afterRecoveryTimes: t, contextContent: i, drawDefinition: a, contextProfile: n, matchUpId: s, inContext: c, event: d });
    return { matchUp: f, structure: h, drawDefinition: a };
  }
}
function Xp({ tournamentRecord: e, drawDefinition: t, structureId: r, matchUpId: i, structure: n, eventId: a, drawId: o, event: s }) {
  if (!e) return { error: J };
  if (!o && !s && !r && !i) return F({ result: { error: ue }, stack: "getTieFormat" });
  a && !s && (s = e.events?.find((m) => m.eventId === a));
  let c = nU({ tournamentRecord: e, drawDefinition: t, matchUpId: i, drawId: o, event: s });
  if (i && c?.error) return c;
  if (!t && c?.drawDefinition && (t = c?.drawDefinition), n = n ?? c?.structure, !n && r && !i) {
    if (!t) return { error: Vi };
    let m = me({ drawDefinition: t, structureId: r });
    if (m.error) return m;
    n = m.structure;
  }
  let u = (n?.tieFormat || n?.tieFormatId) && dr({ structure: n, drawDefinition: t, event: s })?.tieFormat, l = (t?.tieFormat || t?.tieFormatId) && dr({ drawDefinition: t, event: s })?.tieFormat, d = dr({ event: s })?.tieFormat, p = dr({ matchUp: c?.matchUp, drawDefinition: t, structure: n, event: s })?.tieFormat;
  return { ...x, matchUp: c?.matchUp, structureDefaultTieFormat: er(u), eventDefaultTieFormat: er(d), drawDefaultTieFormat: er(l), tieFormat: er(p), structure: n };
}
var WM = {};
Me(WM, { bulkUpdatePublishedEventIds: () => aU, getAllEventData: () => oU, getCourtInfo: () => Sp, getDrawData: () => Jp, getEventData: () => Zp, getEventPublishStatus: () => mi, getPublishState: () => zo, getTournamentPublishStatus: () => Yu, getVenueData: () => Cs });
function aU({ tournamentRecord: e, outcomes: t }) {
  if (!e) return { error: J };
  if (!t?.length) return { error: ue, info: "Missing outcomes" };
  let r = t.reduce((n, a) => {
    let { drawId: o, eventId: s } = a;
    return s && o && (n[s] ? n[s].includes(o) || n[s].push(o) : n[s] = [o]), n;
  }, {}), i = Object.keys(r);
  return { publishedEventIds: (e.events?.filter((n) => i.includes(n.eventId))).filter((n) => {
    let a = mi({ event: n }), { drawDetails: o, drawIds: s } = a ?? {}, { eventId: c } = n;
    return r[c].filter((u) => {
      let l = o ? Object.keys(a.drawDetails).filter((d) => Vg({ drawId: d, drawDetails: o })) : [];
      return s?.includes(u) || l.includes(u);
    }).length;
  }).map((n) => n.eventId), eventIdPublishedDrawIdsMap: r };
}
function HM({ dates: e = [], extension: t }) {
  if (!t) return !1;
  if (typeof t.value == "boolean" && t.value) return !0;
  if (!e.length) return !1;
  let r = xe(t.value) ? t.value?.dates : void 0;
  if (Array.isArray(r)) return r?.length ? !!r.filter((i) => !e.length || e.includes(i)).length : !1;
}
function zM({ convertExtensions: e, ignoreDisabled: t, venue: r, court: i }) {
  let n = { ...ie(i, e, !0), venueId: r.venueId }, { extension: a } = we({ name: ki, element: i });
  if (t && a) {
    let o = xe(a.value) ? a.value?.dates : void 0, s = a?.value === !0 ? [] : n.dateAvailability.map((c) => {
      let u = c.date;
      if (!(!u || o.includes(u))) return c;
    }).filter(Boolean);
    n.dateAvailability = s;
  }
  return { inContextCourt: n };
}
function Yn(e) {
  let { convertExtensions: t, ignoreDisabled: r, venueIds: i = [], dates: n } = e, a = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {}, o = [], s = [], c = [], u = [];
  return Object.keys(a).filter((l) => !e.tournamentId || l === e.tournamentId).forEach((l) => {
    let d = a[l];
    for (let p of d.venues ?? []) if (!(i.length && !i.includes(p.venueId))) {
      if (r) {
        let { extension: m } = we({ name: ki, element: p });
        if (m?.value) continue;
      }
      o.includes(p.venueId) || (u.push(ie(p, t, !0)), o.push(p.venueId));
      for (let m of p.courts ?? []) if (!s.includes(m.courtId)) {
        if (r) {
          let { extension: h } = we({ name: ki, element: m });
          if (HM({ extension: h, dates: n })) continue;
        }
        let { inContextCourt: f } = zM({ convertExtensions: t, ignoreDisabled: r, venue: p, court: m });
        c.push(f), s.push(m.courtId);
      }
    }
  }), { courts: c, venues: u, ...x };
}
function h_({ convertExtensions: e, tournamentRecord: t, ignoreDisabled: r, dates: i }) {
  if (!t) return { error: ht };
  let n = ie(t.venues ?? [], e).filter((o) => {
    if (!r) return o;
    let { extension: s } = we({ name: ki, element: o });
    return !s?.value && o;
  }).filter(Boolean), a = n.reduce((o, s) => {
    let c = (s?.courts || []).filter((u) => {
      if (!r && !i?.length) return u;
      let { extension: l } = we({ name: ki, element: u });
      return HM({ extension: l, dates: i });
    }).filter(Boolean).map((u) => {
      let { inContextCourt: l } = zM({ convertExtensions: e, ignoreDisabled: r, venue: s, court: u });
      return l;
    });
    return c.length ? o.concat(c) : o;
  }, []);
  return { venues: n, courts: a };
}
function pl({ tournamentRecords: e, requireCourts: t, dates: r }) {
  return typeof e != "object" || !Object.keys(e).length ? { error: ht } : Object.keys(e).reduce((i, n) => {
    let a = e[n], { venues: o } = h_({ tournamentRecord: a, dates: r });
    return o?.forEach((s) => {
      let { venueId: c, courts: u } = s;
      (!t || u?.length) && !i.venueIds.includes(c) && (i.venues.push(s), i.venueIds.push(c));
    }), i;
  }, { venues: [], venueIds: [] });
}
function oU({ tournamentRecord: e, policyDefinitions: t }) {
  if (!e) return { error: J };
  let r = e.events || [], i = e?.participants || [], { tournamentInfo: n } = es({ tournamentRecord: e }), { venues: a } = Yn({ tournamentRecord: e }), o = r.map((s) => {
    let { eventId: c } = s, u = jM({ event: s }).eventInfo, l = Ou({ tournamentRecord: e, event: s }).scheduleTiming, d = (s.drawDefinitions || []).map((m) => {
      let f = (({ drawId: S, drawName: P, matchUpFormat: v, updatedAt: D }) => ({ matchUpFormat: v, updatedAt: D, drawName: P, drawId: S }))(m), { abandonedMatchUps: h, completedMatchUps: g, upcomingMatchUps: I, pendingMatchUps: U } = rc({ requireParticipants: !0, tournamentParticipants: i, context: { eventId: c }, policyDefinitions: t, tournamentRecord: e, inContext: !0, scheduleTiming: l, drawDefinition: m, event: s });
      return { drawInfo: f, matchUps: { abandonedMatchUps: h, completedMatchUps: g, upcomingMatchUps: I, pendingMatchUps: U } };
    }), p = mi({ event: s });
    return Object.assign(u, { drawsData: d, publish: p }), u;
  });
  return { allEventData: { tournamentInfo: n, venuesData: a, eventsData: o } };
}
function YM({ publishStatus: e, drawId: t }) {
  return e?.drawDetails ? e.drawDetails?.[t]?.publishingDetail?.published : e?.drawIds ? e.drawIds.includes(t) : !0;
}
var KM = "PUBLIC", g_ = "ADMIN", I_ = { PUBLIC_DISPLAY: KM, ADMIN_DISPLAY: g_ };
function Jp(e) {
  let { tournamentParticipants: t = [], includePositionAssignments: r, policyDefinitions: i, tournamentRecord: n, inContext: a = !0, usePublishState: o, status: s = Jr, pressureRating: c, refreshResults: u, contextProfile: l, drawDefinition: d, noDeepCopy: p, sortConfig: m, context: f, event: h } = e;
  if (!d) return { error: ne };
  let g = (({ matchUpFormat: C, updatedAt: k, drawType: O, drawName: _, drawId: B }) => ({ matchUpFormat: C, updatedAt: k, drawName: _, drawType: O, drawId: B }))(d);
  g.display = we({ element: d, name: td }).extension?.value;
  let I = {}, U, S, { allStructuresLinked: P, sourceStructureIds: v, hasDrawFeedProfile: D, structureGroups: y } = Rp({ drawDefinition: d });
  if (!P) return { error: Cv };
  let w = e?.eventPublishState ?? zo({ event: h }).publishState, b = e?.publishStatus ?? mi({ event: h, status: s }), T = w?.status?.drawDetails?.[d.drawId], R = !!w?.status?.published, M = T?.structureDetails, E = !1, A = !1, N = y.map((C) => {
    let k = {}, O = C.map((_) => {
      let { structure: B } = me({ drawDefinition: d, structureId: _ }), { seedAssignments: L } = si({ drawDefinition: d, structure: B });
      return B?.stage === re && B.stageSequence === 1 && (U = L), B?.stage === se && (I[B.stageSequence ?? 0] = L), B;
    }).sort((_, B) => _o(_, B, m)).map((_) => {
      if (!_) return;
      let B = _?.structureId, L = [];
      _.stage && [re, nr, yt].includes(_.stage) && (L = U), _?.stage === se && (L = I[_.stageSequence ?? 0]);
      let { matchUps: j, roundMatchUps: H, roundProfile: G } = Ve({ seedAssignments: _?.seedAssignments?.length ? void 0 : L, context: { drawId: g.drawId, ...f }, hydrateParticipants: e.hydrateParticipants, participantsProfile: e.participantsProfile, tournamentParticipants: t, policyDefinitions: i, tournamentRecord: n, usePublishState: o, publishStatus: b, contextProfile: l, drawDefinition: d, inContext: a, structure: _, event: h }), { positionAssignments: V } = Je({ structure: _ }), $ = V?.filter(qr(yn)).map((K) => {
        let Q = we({ element: K, name: _n })?.extension?.value, { drawPosition: X, participantId: ee } = K;
        return A = !0, { participantResult: Q, participantId: ee, drawPosition: X };
      });
      if (j.length && (!$?.length && e.allParticipantResults || u && !_.structures)) {
        let { subOrderMap: K } = sb({ positionAssignments: V }), Q = j.some((ee) => ee.matchUpType === Hr) ? j.filter((ee) => ee.matchUpType === Hr) : j, X = cc({ matchUpFormat: _.matchUpFormat, matchUps: Q, policyDefinitions: i, pressureRating: c, subOrderMap: K });
        S = X?.report, $ = V?.filter(qr(yn)).map((ee) => {
          let { drawPosition: Z, participantId: ce } = ee;
          return A = !0, { participantResult: ce && X?.participantResults?.[ce], participantId: ce, drawPosition: Z };
        });
      }
      let q = _ ? (({ stageSequence: K, structureName: Q, structureType: X, matchUpFormat: ee, stage: Z }) => ({ stageSequence: K, structureName: Q, structureType: X, matchUpFormat: ee, stage: Z }))(_) : {}, Y = we({ element: _, name: td }).extension?.value;
      q.display = Y?.[KM] ?? Y, q.sourceStructureIds = v[B], q.hasDrawFeedProfile = D[B], q.positionAssignments = V, q.structureActive = j.reduce((K, Q) => {
        let X = [Mt, xt, Ri, vt, nn, Pe, Xt, be].includes(Q.matchUpStatus);
        return K || X || !!Q.winningSide || !!Q.score?.scoreStringSide1;
      }, !1);
      let W = j.reduce((K, Q) => K && ["BYE", vt, Xt, be, Pe, Or].includes(Q.matchUpStatus), !!j.length);
      return q.structureCompleted = W, k[B] = W, q.structureActive && (E = !0), { ...q, participantResults: $, seedAssignments: L, roundMatchUps: H, roundProfile: G, structureId: B, report: S };
    });
    return O.forEach((_) => {
      r || delete _.positionAssignments, _.sourceStructuresComplete = _.sourceStructureIds?.every((B) => k[B]);
    }), O;
  }).flat().filter((C) => !o || M?.[C?.structureId]?.published || !0);
  return g.drawActive = E, g.participantPlacements = A, g.drawGenerated = N?.reduce((C, k) => C || !!k?.roundMatchUps, !1), g.drawCompleted = N?.reduce((C, k) => C && k.structureCompleted, !0), g.drawPublished = o ? R && YM({ publishStatus: b, drawId: g.drawId }) : void 0, { structures: !o || g.drawPublished ? p && N || ie(N, !1, !0) : void 0, drawInfo: p ? g : ie(g, !1, !0), ...x };
}
function Zp(e) {
  let { includePositionAssignments: t, participantsProfile: r, policyDefinitions: i, usePublishState: n, status: a = Jr, contextProfile: o, sortConfig: s } = e, c = oe(e, [{ tournamentRecord: !0 }, { [Zh]: { event: !1, eventId: !1 } }]);
  if (c.error) return c;
  let u = ie(e.tournamentRecord, !1, !0), l = e.event ? void 0 : br({ tournamentRecord: u, eventId: e.eventId }).event, d = e.event ? ie(e.event, !1, !0) : l && ie(l, !1, !0) || void 0;
  if (!d) return { error: ni };
  let { eventId: p } = d, { tournamentId: m, endDate: f } = u, h = mi({ event: d, status: a }), g = zo({ event: d }).publishState ?? {}, I = !!g?.status?.published, { participants: U } = ft({ withEvents: !1, withDraws: !1, policyDefinitions: i, ...r, tournamentRecord: u }), S = ({ stage: E, drawId: A }) => {
    if (!n) return !0;
    let N = h?.drawDetails?.[A]?.stageDetails;
    return !N || !Object.keys(N).length ? !0 : N[E]?.published;
  }, P = ({ structureId: E, drawId: A }) => {
    if (!n) return !0;
    let N = h?.drawDetails?.[A]?.structureDetails;
    return !N || !Object.keys(N).length ? !0 : N[E]?.published;
  }, v = ({ drawId: E }) => n ? YM({ publishStatus: h, drawId: E }) : !0, D = ({ drawId: E, structure: A }) => {
    if (!n) return A;
    let N = h?.drawDetails?.[E]?.structureDetails?.[A.structureId]?.roundLimit;
    if (Ie(N)) {
      let C = te(1, N + 1), k = {}, O = {};
      for (let _ of C) A.roundMatchUps[_] && (k[_] = A.roundMatchUps[_], O[_] = A.roundProfile[_]);
      A.roundMatchUps = k, A.roundProfile = O;
    }
    return A;
  }, y = d.drawDefinitions || [], w = !n || I ? y.filter(v).map((E) => (({ drawInfo: A, structures: N }) => ({ ...A, structures: N }))(Jp({ allParticipantResults: e.allParticipantResults, hydrateParticipants: e.hydrateParticipants, context: { eventId: p, tournamentId: m, endDate: f }, pressureRating: e.pressureRating, refreshResults: e.refreshResults, includePositionAssignments: t, tournamentParticipants: U, eventPublishState: g, noDeepCopy: !0, policyDefinitions: i, tournamentRecord: u, usePublishState: n, contextProfile: o, drawDefinition: E, publishStatus: h, sortConfig: s, event: d }))).map(({ structures: E, ...A }) => {
    let N = E?.filter(({ stage: C, structureId: k }) => P({ structureId: k, drawId: A.drawId }) && S({ stage: C, drawId: A.drawId })).map((C) => D({ drawId: A.drawId, structure: C }));
    return { ...A, structures: N };
  }).filter((E) => E.structures?.length) : void 0, b = (Array.isArray(u.venues) ? u.venues : []).map((E) => (({ venueData: A }) => ({ ...A }))(Cs({ venueId: E.venueId, tournamentRecord: u }))), T = (({ eventId: E, eventName: A, eventType: N, eventLevel: C, surfaceCategory: k, matchUpFormat: O, category: _, gender: B, startDate: L, endDate: j, ballType: H, discipline: G }) => ({ eventId: E, eventName: A, eventType: N, eventLevel: C, surfaceCategory: k, matchUpFormat: O, category: _, gender: B, startDate: L, endDate: j, ballType: H, discipline: G }))(d);
  T.display = we({ element: d, name: td }).extension?.value;
  let { tournamentInfo: R } = es({ tournamentRecord: u }), M = { tournamentInfo: R, venuesData: b, eventInfo: T, drawsData: w };
  return M.eventInfo.publishState = g, M.eventInfo.published = g?.status?.published, { ...x, eventData: M, participants: U };
}
var QM = {};
Me(QM, { courtGridRows: () => nm, findVenue: () => Mn, getMatchUpsToSchedule: () => em, getPersonRequests: () => io, getProfileRounds: () => im, getScheduledRoundsDetails: () => ml, getSchedulingProfile: () => Kn, getSchedulingProfileIssues: () => sU, publicFindCourt: () => Fg });
function Fs({ matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: t, timeAfterRecovery: r, matchUp: i }) {
  let { individualParticipantIds: n } = pp(i);
  r = r ?? i.schedule?.timeAfterRecovery;
  let a = (u) => {
    e[u] || (e[u] = []), e[u] = Ue(e[u].concat(...n));
  }, o = (u) => {
    r && (!t[u] || r > t[u]) && (t[u] = r);
  }, s = i.winnerTo?.matchUpId || i.winnerMatchUpId;
  s && (r && o(s), a(s));
  let c = i.loserTo?.matchUpId || i.loserMatchUpId;
  c && (r && o(c), a(c)), i.sidesTo?.length && i.sidesTo.forEach(({ matchUpId: u }) => {
    u && (r && o(u), a(u));
  });
}
function em(e) {
  let t = oe(e, [{ [Xh]: !0 }]);
  if (t.error) return t;
  let { matchUpPotentialParticipantIds: r, dateScheduledMatchUpIds: i = [], scheduleCompletedMatchUps: n, matchUpNotBeforeTimes: a, matchUpScheduleTimes: o, orderedMatchUpIds: s, clearDate: c, matchUps: u } = e, l = o ? Object.keys(o) : [], d = (s ?? []).map((m) => u.find((f) => f.matchUpId === m)).filter(Boolean).filter((m) => {
    let f = !c && (i.includes(m.matchUpId) || l.includes(m.matchUpId)), h = ["BYE", Pe, vt, Or, Xt, be, Mt, xt].includes(m?.matchUpStatus);
    return n || !f && !m.winningSide && !h;
  }), p = r && a ? d.reduce((m, f) => {
    let { drawId: h, tournamentId: g } = f;
    return m.matchUpMap[g] || (m.matchUpMap[g] = {}), m.matchUpMap[g][h] ? m.matchUpMap[g][h].push(f) : m.matchUpMap[g][h] = [f], Fs({ matchUpPotentialParticipantIds: r, matchUpNotBeforeTimes: a, matchUp: f }), m;
  }, { matchUpMap: {} }).matchUpMap : {};
  return { matchUpsToSchedule: d, matchUpMap: p };
}
function tm({ defaultRecoveryMinutes: e = 0, defaultAverageMinutes: t, tournamentRecords: r, matchUpFormat: i, categoryName: n, categoryType: a, tournamentId: o, eventType: s, eventId: c }) {
  if (!Vr({ matchUpFormat: i })) return { error: fu };
  let u = Object.keys(r).filter((d) => !o || d === o), l;
  return u.forEach((d) => {
    if (l) return;
    let p = r[d], m = c ? br({ tournamentRecord: p, eventId: c })?.event : void 0;
    return l = Gu({ tournamentRecord: p, matchUpFormat: i, categoryName: n, categoryType: a, eventType: s, event: m }), l?.averageMinutes || l?.recoveryMinutes;
  }), { recoveryMinutes: l?.recoveryMinutes || e, averageMinutes: l?.averageMinutes || t, typeChangeRecoveryMinutes: l?.typeChangeRecoveryMinutes || l?.recoveryMinutes || e };
}
function ml(e) {
  let t = oe(e, [{ [Zh]: { tournamentRecords: !1, tournamentRecord: !1 } }, { rounds: !0, [Mr]: sr }]);
  if (t.error) return t;
  let { scheduleCompletedMatchUps: r, periodLength: i = 30 } = e, n = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {};
  if (typeof n != "object") return { error: ht };
  let a = {}, o = [], s = e.rounds.toSorted((f, h) => (f.sortOrder ?? 0) - (h.sortOrder ?? 0)), c = e.containedStructureIds ?? Object.assign({}, ...Object.values(n).map((f) => ec({ tournamentRecord: f }).containedStructures)), u = e.matchUps ?? Bi({ nextMatchUps: !0, tournamentRecords: n }).matchUps, l = 0, d = {}, p = {}, m = {};
  return { scheduledRoundsDetails: s.flatMap((f) => {
    let h = f.periodLength || i, g = [];
    c?.[f.structureId] ? g.push(...c[f.structureId]) : g.push(f.structureId);
    let I = u ? An({ tournamentIds: [f.tournamentId], roundNumbers: [f.roundNumber], matchUpIds: f.matchUpIds, eventIds: [f.eventId], drawIds: [f.drawId], processContext: !0, structureIds: g, matchUps: u }).sort(Ho) : [], { segmentNumber: U, segmentsCount: S } = f.roundSegment || {};
    if (Ie(U) && Fi(I?.length) && Fi(S) && U > 0 && U <= S && S < I?.length && !f.matchUpIds?.length) {
      let y = I.length / S, w = y * (U - 1);
      I = I.slice(w, w + y);
    }
    let P = n[f.tournamentId], v = br({ drawId: f.drawId, tournamentRecord: P }).event, D = [];
    for (let y of I) {
      let w = y.matchUpFormat;
      w && (a[w] || (a[w] = [], a[w].push(y)), D.push(w));
    }
    for (let y of D) {
      let { eventType: w, category: b } = v ?? {}, { categoryName: T, ageCategoryCode: R } = b ?? {}, { typeChangeRecoveryMinutes: M, recoveryMinutes: E, averageMinutes: A, error: N } = tm({ categoryName: T ?? R, categoryType: b?.categoryType, tournamentId: f.tournamentId, eventId: f.eventId, tournamentRecords: n, matchUpFormat: y, eventType: w });
      if (N) return { error: N, round: f };
      let C = I.filter((O) => (r || !Lt.includes(O.matchUpStatus)) && O.matchUpStatus !== "BYE").map($t);
      C.forEach((O) => {
        m[O] = { typeChangeRecoveryMinutes: M, recoveryMinutes: E, averageMinutes: A }, d[O] = E, p[O] = A;
      }), o.push(...C), l = Math.max(A || 0, l);
      let k = `${A}|${h}`;
      return { roundPeriodLength: h, recoveryMinutes: E, averageMinutes: A, matchUpIds: C, hash: k };
    }
  }), greatestAverageMinutes: l, matchUpFormatCohorts: a, recoveryMinutesMap: d, averageMinutesMap: p, orderedMatchUpIds: o, minutesMap: m, ...x };
}
function XM({ schedulingProfile: e, venueIds: t, eventIds: r, drawIds: i }) {
  let n = [], a = e?.map((s) => {
    let c = ve(s?.scheduleDate);
    if (!c) {
      n.push(`Invalid date: ${s?.scheduledDate}`);
      return;
    }
    let u = (s?.venues || []).map((l) => {
      let { rounds: d, venueId: p } = l;
      if (!t?.includes(p)) {
        n.push(`Missing venueId: ${p}`);
        return;
      }
      let m = d.filter((f) => {
        let h = r.includes(f.eventId) && i.includes(f.drawId);
        return h || n.push(`Invalid eventId: ${f.eventId} or drawId: ${f.drawId}`), h;
      });
      if (m.length) return { venueId: p, rounds: m };
    }).filter(Boolean);
    return u.length && c && { ...s, venues: u };
  }).filter(Boolean), o = n.length;
  return { updatedSchedulingProfile: a, modifications: o, issues: n };
}
function rm({ tournamentRecords: e, schedulingProfile: t }) {
  if (!t) return { valid: !0 };
  if (!Array.isArray(t)) return { valid: !1, error: z };
  let { venueIds: r, tournamentsMap: i } = S_({ tournamentRecords: e }), n, a, o = t.every((s) => {
    let { scheduleDate: c, venues: u } = s;
    return Ar(c) ? u.every((l) => {
      let { venueId: d, rounds: p } = l;
      return typeof d != "string" ? (a = "venueId should be a string", !1) : Array.isArray(p) ? r.includes(d) ? !!p.every((m) => {
        if (!m) return a = "empty round", !1;
        let { roundSegment: f, tournamentId: h, structureId: g, roundNumber: I, eventId: U, drawId: S } = m, P = i?.[h]?.[U]?.[S]?.[g]?.includes(I);
        P || (a = "Invalid rounds");
        let { segmentNumber: v, segmentsCount: D } = f || {}, y = !f || Ie(v) && Fi(D) && v <= D;
        return y || (a = "Invalid segment"), P && y;
      }) : (n = Co, !1) : (a = "rounds should be an array", !1);
    }) : !1;
  });
  return !o && !n && (n = z), { valid: !!o, error: n, info: a };
}
function U_(e) {
  let { tournamentRecord: t = {}, tournamentMap: r = {}, requireCourts: i } = e, n = [], a = [], o = [], s = [], c = (t?.venues || []).map(({ venueId: l, courts: d }) => (!i || d?.length) && l), u = t?.tournamentId;
  if (u) {
    n.push(u), r[u] = {};
    let l = t?.events || [];
    for (let d of l) {
      let p = d.eventId;
      o.push(p), r[u][p] = {};
      let m = (f) => parseInt(f);
      for (let f of d.drawDefinitions || []) {
        let h = f.drawId;
        s.push(h), r[u][p][h] = {};
        let { structures: g } = Ti({ drawDefinition: f });
        for (let I of g || []) {
          let U = I.structureId, { matchUps: S } = Ve({ structure: I }), { roundMatchUps: P } = Ir({ matchUps: S }), v = P && Object.keys(P).map(m);
          if (r[u][p][h][U] = v, a.push(U), I.structures?.length) for (let D of I.structures) a.push(D.structureId), r[u][p][h][D.structureId] = v;
        }
      }
    }
  }
  return { tournamentMap: r, tournamentIds: n, structureIds: a, venueIds: c, eventIds: o, drawIds: s };
}
function S_(e) {
  let t = e?.tournamentRecords && Object.values(e?.tournamentRecords) || [], r = {}, { venueIds: i, eventIds: n, drawIds: a, structureIds: o, tournamentIds: s } = t.reduce((c, u) => {
    let { tournamentIds: l, tournamentMap: d, structureIds: p, venueIds: m, eventIds: f, drawIds: h } = U_({ tournamentRecord: u });
    return m.forEach((g) => {
      c.venueIds.includes(g) || c.venueIds.push(g);
    }), c.tournamentIds.push(...l), c.structureIds.push(...p), c.eventIds.push(...f), c.drawIds.push(...h), Object.assign(r, d), c;
  }, { tournamentIds: [], structureIds: [], venueIds: [], eventIds: [], drawIds: [] });
  return { tournamentsMap: r, tournamentIds: s, structureIds: o, venueIds: i, eventIds: n, drawIds: a };
}
function Kn({ tournamentRecords: e, tournamentRecord: t }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: ht };
  let { extension: r } = we({ element: t, name: Do, tournamentRecords: e, discover: !0 }), i = r?.value || [];
  if (i.length) {
    let { venueIds: n } = pl({ requireCourts: !0, tournamentRecords: e }), { eventIds: a, drawIds: o } = SI({ tournamentRecords: e }), { updatedSchedulingProfile: s, modifications: c, issues: u } = XM({ schedulingProfile: i, venueIds: n, eventIds: a, drawIds: o });
    if (c) {
      i = s;
      let l = uc({ tournamentRecords: e, tournamentRecord: t, schedulingProfile: i });
      return l.error ? l : { schedulingProfile: i, modifications: c, issues: u };
    }
  }
  return { schedulingProfile: i, modifications: 0 };
}
function uc({ tournamentRecords: e, tournamentRecord: t, schedulingProfile: r }) {
  let i = rm({ tournamentRecords: e, schedulingProfile: r });
  return i.error ? i : r ? Be({ tournamentRecords: e, discover: !0, extension: { name: Do, value: r } }) : fr({ element: t, name: Do, tournamentRecords: e, discover: !0 });
}
function fl(e) {
  let { tournamentRecord: t } = e, r = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!e.schedulingProfile) {
    let { modifications: u, issues: l } = Kn({ tournamentRecords: r, tournamentRecord: t });
    return { success: !u, modifications: u, issues: l };
  }
  let { venueIds: i } = pl({ tournamentRecords: r }), { eventIds: n, drawIds: a } = SI({ tournamentRecords: r }), { updatedSchedulingProfile: o, modifications: s, issues: c } = XM({ schedulingProfile: e.schedulingProfile, venueIds: i, eventIds: n, drawIds: a });
  return s ? { ...uc({ schedulingProfile: o, tournamentRecords: r }), modifications: s, issues: c } : { ...x, modifications: s, issues: c };
}
function sU(e) {
  let { scheduleDates: t = [], tournamentRecords: r, periodLength: i = 30 } = e ?? {};
  if (typeof r != "object") return { error: du };
  if (!Array.isArray(t)) return { error: z };
  if (!t.every(Ar)) return { error: Ht };
  let n = [], a = 0, o = {}, { schedulingProfile: s } = Kn({ tournamentRecords: r });
  if (!s) return { issues: n, ...x };
  let { matchUps: c } = Bi({ nextMatchUps: !0, tournamentRecords: r });
  for (let l of s) {
    let { scheduleDate: d, venues: p = [] } = l;
    if (!t?.length || t.includes(d)) {
      for (let m of p || []) if (m) {
        let { rounds: f } = m, h = [], { orderedMatchUpIds: g, scheduledRoundsDetails: I } = ml({ tournamentRecords: r, periodLength: i, matchUps: c, rounds: f }), { matchUpDependencies: U } = Ei({ tournamentRecords: r, matchUps: c }), S = (P) => {
          let v;
          return I?.find((D, y) => {
            let w = D.matchUpIds.includes(P);
            return w && (v = y), w;
          }), v;
        };
        if (g?.forEach((P, v) => {
          let D = g.slice(v + 1), y = Pt(D, U?.[P]?.matchUpIds || []);
          y.length && h.push({ matchUpId: P, shouldBeAfter: y });
        }), h.length) {
          a += h.length;
          let P = h.map(({ matchUpId: v, shouldBeAfter: D }) => {
            let y = S(v), w = Ue(D.map(S));
            return o[d] || (o[d] = {}), o[d][y] || (o[d][y] = []), w.forEach((b) => {
              o[d][y].includes(b) || o[d][y].push(b);
            }), { matchUpId: v, matchUpRoundIndex: y, earlierRoundIndices: w, shouldBeAfter: D };
          });
          n.push(...P);
        }
      }
    }
  }
  let u = { matchUpIdShouldBeAfter: Object.assign({}, ...n.map((l) => {
    let { matchUpId: d, shouldBeAfter: p, earlierRoundIndices: m } = l;
    return { [d]: { earlierRoundIndices: m, shouldBeAfter: p } };
  })) };
  return { issuesCount: a, profileIssues: u, roundIndexShouldBeAfter: o, ...x };
}
function io(e) {
  let { tournamentRecords: t, requestType: r } = e, i = oe(e, [{ [ur]: !0 }]);
  if (i.error) return i;
  let n = {};
  for (let a of Object.values(t)) {
    let { extension: o } = we({ element: a, name: Js }), s = o?.value || [];
    for (let c of s) {
      let { personId: u, requests: l } = c || {};
      n[u] || (n[u] = []);
      for (let d of l) r && d.requestType !== r || n[u].push(d);
    }
  }
  return { personRequests: n, ...x };
}
function qf(e) {
  let { containerStructureId: t, roundSegment: r, isRoundRobin: i, tournamentId: n, roundNumber: a, structureId: o, eventId: s, drawId: c } = e, u = i ? t : o, l = [n, s, c, u, a].join("|");
  return ae({ structureId: u, roundSegment: r, tournamentId: n, roundNumber: a, eventId: s, drawId: c, id: l });
}
function yy({ round: e, matchUps: t, events: r, tournamentRecords: i }) {
  let n = r.find((p) => p.eventId === e.eventId), { eventType: a, category: o, categoryType: s } = n || {}, { categoryName: c, ageCategoryCode: u } = o || {}, l = Br(t.map(({ matchUpFormat: p }) => p)), d = 0;
  return Object.keys(l).forEach((p) => {
    let m = l[p], f = tm({ categoryName: c || u, tournamentId: e.tournamentId, eventId: e.eventId, tournamentRecords: i, matchUpFormat: p, categoryType: s, eventType: a });
    if (f.error) return f;
    let h = f.averageMinutes * m;
    isNaN(d) || (d += h);
  }), { roundMinutes: d };
}
function y_(e) {
  return (e || []).reduce((t, r) => {
    let i = (r.finishingPositionRange?.winner || []).reduce((a, o) => a + o, 0), n = (r.finishingPositionRange?.winner || []).join("-") || "";
    return !t.minFinishingSum || i < t.minFinishingSum ? { minFinishingSum: i, winnerFinishingPositionRange: n } : t;
  }, { minFinishingSum: 0, winnerFinishingPositionRange: "" });
}
function vy(e) {
  let t = e.length, r = e.filter(({ sides: u }) => u?.some(({ bye: l }) => l)).length || 0, i = e.filter(({ winningSide: u, matchUpStatus: l }) => u || Lt.includes(l)).length || 0, n = e.filter(({ schedule: u, matchUpStatus: l }) => u?.scheduledDate && u?.scheduledTime && l !== "BYE").length || 0, a = t - r, o = a === i, s = a - n, c = a - n;
  return { unscheduledCount: s, incompleteCount: c, scheduledCount: n, completedCount: i, matchUpsCount: t, isScheduled: a === n, isComplete: o, byeCount: r };
}
function im({ tournamentRecords: e, schedulingProfile: t, tournamentRecord: r, withRoundId: i }) {
  if (r && !e) {
    if (typeof r != "object") return { error: du };
    e = { [r.tournamentId]: r };
  }
  if (t) {
    let a = rm({ tournamentRecords: e, schedulingProfile: t });
    if (a.error) return a;
  }
  if (!t && e) {
    let a = Kn({ tournamentRecords: e });
    if (a.error) return a;
    t = a.schedulingProfile;
  }
  if (!t) return { error: Kt };
  let n = {};
  return { profileRounds: t.map(({ venues: a, scheduleDate: o }) => a.map(({ rounds: s }) => s.map((c) => {
    let u = qf(c);
    return u.roundSegment?.segmentsCount && (n[u.id] = u.roundSegment.segmentsCount), ae({ id: i ? u.id : void 0, scheduleDate: o, ...u });
  }))).flat(1 / 0), segmentedRounds: n };
}
function nm({ courtPrefix: e = "C|", minRowsCount: t, courtsData: r }) {
  if (!Array.isArray(r)) return { error: z };
  let i = r?.reduce((o, s) => {
    let c = s.matchUps || [], u = Math.max(0, ...c.map((l) => l.schedule.courtOrder || 0));
    return u > o ? u : o;
  }, 1), n = t ? Math.max(t, i) : i, a = te(0, n).map((o) => ({ matchUps: te(0, r.length).map((s) => {
    let c = r[s], { courtId: u, venueId: l } = c;
    return { schedule: { courtOrder: o + 1, venueId: l, courtId: u } };
  }) }));
  return r.forEach((o, s) => {
    for (let c of o.matchUps) {
      let u = c.schedule?.courtOrder;
      u && (a[u - 1].matchUps[s] = c);
    }
  }), { courtPrefix: e, rows: a.map((o, s) => Object.assign({ rowId: `rowId-${s + 1}` }, ...o.matchUps.map((c, u) => ({ [`${e}${u}`]: c })))) };
}
var JM = {};
Me(JM, { getEntriesAndSeedsCount: () => am, getMaxEntryPosition: () => cU });
function am({ policyDefinitions: e, drawDefinition: t, drawSize: r, drawId: i, event: n, stage: a }) {
  if (!n) return { error: st };
  let { entries: o, stageEntries: s } = uT({ drawDefinition: t, drawId: i, stage: a, event: n }), c = s.length, { drawSize: u } = kb({ participantsCount: c }), l = ll({ drawSize: r ?? u, participantsCount: c, policyDefinitions: e });
  if (l.error) return F({ result: l, stack: "getEntriesAndSeedsCount" });
  let { seedsCount: d } = l;
  return { entries: o, seedsCount: d, stageEntries: s };
}
function cU(e) {
  let { entries: t = [], entryStatus: r, stage: i } = e;
  return Math.max(...t.filter((n) => (!i || i === n.entryStage) && (!r || n.entryStatus === r) && !isNaN(n.entryPosition)).map(({ entryPosition: n }) => pe(n || 0)), 0);
}
var ZM = {};
Me(ZM, { allCompetitionMatchUps: () => Bi, allDrawMatchUps: () => hr, allEventMatchUps: () => Rn, allTournamentMatchUps: () => Jt, analyzeMatchUp: () => ou, calculateWinCriteria: () => ts, checkMatchUpIsComplete: () => ba, competitionScheduleMatchUps: () => gl, drawMatchUps: () => SU, eventMatchUps: () => sm, filterMatchUps: () => An, getAllDrawMatchUps: () => Et, getAllStructureMatchUps: () => Ve, getCheckedInParticipantIds: () => $o, getCompetitionMatchUps: () => au, getEventMatchUpFormatTiming: () => lU, getHomeParticipantId: () => fU, getMatchUpCompetitiveProfile: () => ju, getMatchUpContextIds: () => hU, getMatchUpDailyLimits: () => um, getMatchUpDailyLimitsUpdate: () => dU, getMatchUpDependencies: () => Ei, getMatchUpFormat: () => gU, getMatchUpFormatTiming: () => Gu, getMatchUpFormatTimingUpdate: () => uU, getMatchUpScheduleDetails: () => yp, getMatchUpType: () => vp, getMatchUpsStats: () => IU, getModifiedMatchUpFormatTiming: () => om, getParticipantResults: () => nl, getPredictiveAccuracy: () => mU, getRoundMatchUps: () => Ir, getRounds: () => UU, isValidMatchUpFormat: () => Vr, matchUpActions: () => Lp, participantScheduledMatchUps: () => pU, tallyParticipantResults: () => cc, tournamentMatchUps: () => cm, validMatchUp: () => hp, validMatchUps: () => pi });
function eR({ tournamentRecords: e, extensionName: t }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: ht };
  let r = [], i;
  for (let n of Object.values(e)) {
    let { extension: a } = we({ element: n, name: t });
    a && !i && (r.push({ params: { extension: a, discover: !0 }, method: "addExtension" }), i = !0);
    let o = n.events ?? [];
    for (let s of o) {
      let { eventId: c } = s, { extension: u } = we({ name: t, element: s });
      u && r.push({ params: { eventId: c, extension: u }, method: "addEventExtension" });
    }
  }
  return { methods: r };
}
function uU({ tournamentRecords: e }) {
  return eR({ extensionName: Ln, tournamentRecords: e });
}
var $m = "ADULT", qm = "JUNIOR", Tl = "WHEELCHAIR", tR = { [pa]: { allowModificationWhenMatchUpsScheduled: { courts: !1, venues: !1 }, defaultTimes: { averageTimes: [{ categoryNames: [], minutes: { default: 90 } }], recoveryTimes: [{ minutes: { [Ke]: 30, default: 60 } }] }, defaultDailyLimits: { [Xe]: 2, [Ke]: 2, total: 3 }, matchUpAverageTimes: [{ matchUpFormatCodes: [Si], averageTimes: [{ categoryNames: [], minutes: { default: 90 } }, { categoryTypes: [Tl], minutes: { default: 120 } }] }, { matchUpFormatCodes: ["SET3-S:6/TB7-F:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 85 } }] }, { matchUpFormatCodes: ["SET3-S:6/TB7-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 70 } }] }, { matchUpFormatCodes: ["SET3-S:4NOAD-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 55 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 60 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 50 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 55 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB5@3"], averageTimes: [{ categoryNames: [], minutes: { default: 45 } }] }, { matchUpFormatCodes: ["SET1-S:8/TB7", "SET1-S:8/TB7@7"], averageTimes: [{ categoryNames: [], minutes: { default: 40 } }] }, { matchUpFormatCodes: ["SET1-S:5/TB9@4"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:6/TB7"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:6NOAD"], averageTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:4/TB7", "SET1-S:4/TB5@3", "SET3-S:TB10", "SET1-S:T20"], averageTimes: [{ categoryNames: [], minutes: { default: 20 } }] }, { matchUpFormatCodes: ["SET1-S:4NOAD"], averageTimes: [{ categoryNames: [], minutes: { default: 20 } }] }, { matchUpFormatCodes: ["SET1-S:TB10"], averageTimes: [{ categoryNames: [], minutes: { default: 10 } }] }], matchUpRecoveryTimes: [{ matchUpFormatCodes: ["SET3-S:6/TB7", "SET3-S:6/TB7-F:TB10", "SET3-S:6/TB7-F:TB7"], recoveryTimes: [{ categoryTypes: [$m, Tl], minutes: { default: 60, [Ke]: 30 } }, { categoryTypes: [qm], minutes: { default: 60, [Ke]: 60 } }] }, { matchUpFormatCodes: ["SET3-S:4/TB7-F:TB7", "SET3-S:4/TB7-F:TB10", "SET3-S:4NOAD-F:TB7", "SET3-S:4/TB7", "SET3-S:4/TB5@3"], recoveryTimes: [{ categoryTypes: [$m, Tl], minutes: { default: 30 } }, { categoryTypes: [qm], minutes: { default: 60 } }] }, { matchUpFormatCodes: ["SET1-S:8/TB7", "SET1-S:8/TB7@7", "SET1-S:5/TB9@4", "SET1-S:6/TB7", "SET1-S:6NOAD", "SET1-S:4/TB7", "SET1-S:4NOAD", "SET3-S:TB10", "SET1-S:T20"], recoveryTimes: [{ categoryNames: [], minutes: { default: 30 } }] }, { matchUpFormatCodes: ["SET1-S:4/TB5@3"], recoveryTimes: [{ categoryTypes: [$m, qm], minutes: { default: 30 } }, { categoryTypes: [Tl], minutes: { default: 15 } }] }, { matchUpFormatCodes: ["SET1-S:TB10"], recoveryTimes: [{ categoryNames: [], minutes: { default: 15 } }] }], matchUpDailyLimits: [] } }, v_ = tR;
function lU({ tournamentRecord: e, matchUpFormats: t, categoryType: r, event: i }) {
  if (!i) return { error: st };
  let n = [], a;
  if (t?.length) {
    let d = [];
    n = t.map((p) => {
      let m = typeof p == "string" ? { matchUpFormat: p } : p;
      if (!d.includes(m?.matchUpFormat) && Vr({ matchUpFormat: m?.matchUpFormat })) return d.push(m.matchUpFormat), m;
    }).filter(Boolean);
  } else {
    let { policy: d } = Qa({ policyType: oi, tournamentRecord: e, event: i });
    if (d?.matchUpFormats) n = d?.matchUpFormats;
    else {
      let { extension: p } = we({ name: Ln, element: i }), m, f;
      p?.value ? { matchUpAverageTimes: m, matchUpRecoveryTimes: f } = p.value : { matchUpAverageTimes: m, matchUpRecoveryTimes: f } = v_[pa], n = Ue([...(m || []).map((h) => h.matchUpFormatCodes), ...(f || []).map((h) => h.matchUpFormatCodes)].flat()).map((h) => ({ matchUpFormat: h })), a = "default scheduling policy in use";
    }
  }
  let { eventType: o, eventId: s, category: c } = i, u = c?.categoryName ?? c?.ageCategoryCode ?? s;
  if (!s) return { error: st };
  let l = n.map(({ matchUpFormat: d, description: p }) => {
    let m = Gu({ tournamentRecord: e, matchUpFormat: d, categoryName: u, categoryType: r, eventType: o, event: i });
    return { matchUpFormat: d, description: p, ...m };
  });
  return ae({ eventMatchUpFormatTiming: l, info: a });
}
function om(e) {
  let t = oe(e, [{ [Vt]: !0 }, { [tr]: (h) => Vr({ matchUpFormat: h }), [Kr]: fu, [Yh]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, matchUpFormat: i, event: n } = e, { extension: a } = we({ name: Ln, element: n }), o = a?.value, { extension: s } = we({ element: r, name: Ln }), c = s?.value, u = o?.matchUpAverageTimes && Rc({ ...o, matchUpFormat: i }), l = c?.matchUpAverageTimes && Rc({ ...c, matchUpFormat: i }), d = [u, l].find((h) => h), p = o?.matchUpRecoveryTimes && Nc({ ...o, matchUpFormat: i }), m = c?.matchUpRecoveryTimes && Nc({ ...c, matchUpFormat: i }), f = [p, m].find((h) => h);
  return { matchUpFormat: i, recoveryTimes: f, averageTimes: d };
}
function dU({ tournamentRecords: e }) {
  return eR({ extensionName: Ru, tournamentRecords: e });
}
var hl = ({ scheduleAttributes: e = ["scheduledDate", "scheduledTime"], schedule: t = {} }) => !!Object.keys(t).filter((r) => e.includes(r)).filter((r) => t[r]).length;
function pU({ scheduleAttributes: e = ["scheduledDate", "scheduledTime"], matchUps: t = [] }) {
  if (!pi(t)) return { error: Gn };
  if (!Array.isArray(e)) return { error: z };
  let r = t.filter(Boolean).filter(({ schedule: i }) => hl({ schedule: i, scheduleAttributes: e })).reduce((i, n) => {
    let { schedule: a } = n, o = ve(a?.scheduledDate), s = ct(a?.scheduledTime);
    return o && s && (i[o] ? i[o].push(n) : i[o] = [n]), i;
  }, {});
  return Object.keys(r).forEach((i) => {
    r[i].sort((n, a) => $P(ct(n.schedule?.scheduledTime), ct(a.schedule?.scheduledTime)));
  }), { ...x, scheduledMatchUps: r };
}
function P_({ tournamentRecords: e }) {
  let t = {}, r = [];
  for (let i of Object.values(e)) for (let n of i.events ?? []) {
    let a = mi({ event: n }), o = a?.drawDetails;
    xe(o) ? (Object.assign(t, o), r.push(...Object.keys(o).filter((s) => Vg({ drawId: s, drawDetails: o })))) : a?.drawIds?.length && r.push(...a.drawIds);
  }
  return { drawIds: r, detailsMap: t };
}
function Ud({ schedulingProfile: e, matchUps: t = [] }) {
  let r = {}, i = ({ eventId: s, drawId: c, structureId: u, roundNumber: l }) => `${s}|${c}|${u}${l}`;
  e?.length && e.map(({ venues: s }) => s.map(({ rounds: c }) => c)).flat().forEach((s) => {
    s.sort((c, u) => (c.sortOrder || 0) - (u.sortOrder || 0)).forEach(({ eventId: c, drawId: u, structureId: l, roundNumber: d }, p) => {
      let m = i({ eventId: c, drawId: u, structureId: l, roundNumber: d });
      r[m] = p;
    });
  });
  let n = [], a = { noScheduledDate: [] };
  for (let s of t) {
    let c = s.schedule || {}, u = c.scheduledDate && ve(c.scheduledDate) || c.scheduledTime && ve(c.scheduledTime) || "noScheduledDate";
    a[u] || (a[u] = []), a[u].push(s);
  }
  let o = Object.keys(a).sort();
  for (let s of o) {
    let c = a[s], u = { noScheduledTime: [] };
    for (let d of c) {
      let p = d.schedule || {}, m = p.scheduledTime && ct(p.scheduledTime) || "noScheduledTime";
      u[m] || (u[m] = []), u[m].push(d);
    }
    for (let d of Object.keys(u)) {
      let p = u[d].sort((m, f) => (m.roundNumber || 0) - (f.roundNumber || 0));
      u[d] = p;
    }
    let l = Object.keys(u).sort();
    for (let d of l) {
      let p = u[d];
      p.sort((m, f) => {
        let h = r[i(m)] || 0, g = r[i(f)] || 0;
        return h - g;
      }), n.push(...p);
    }
  }
  return n;
}
function sm(e) {
  let { participants: t, contextContent: r, participantMap: i } = e, { tournamentAppliedPolicies: n, scheduleVisibilityFilters: a, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, useParticipantMap: u, tournamentRecord: l, usePublishState: d, contextFilters: p, matchUpFilters: m, contextProfile: f, nextMatchUps: h, tournamentId: g, inContext: I, context: U, event: S } = e;
  if (!S) return { error: st };
  let { eventId: P, eventName: v, endDate: D, eventType: y, category: w, gender: b } = S ?? {}, T = { ...U, ...ae({ surfaceCategory: S.surfaceCategory ?? l?.surfaceCategory, indoorOutDoor: S.indoorOutdoor ?? l?.indoorOutdoor, tournamentId: g ?? l?.tournamentId, endDate: D ?? l?.endDate, eventName: v, eventType: y, category: w, eventId: P, gender: b }) }, R;
  !t && l && ({ participants: t, participantMap: i, groupInfo: R } = Ka({ participantsProfile: o, useParticipantMap: u, tournamentRecord: l, contextProfile: f, inContext: I })), f && !r && (r = Hn({ policyDefinitions: c, tournamentRecord: l, contextProfile: f, event: S }));
  let M = mi({ event: S });
  return { ...(S.drawDefinitions ?? []).reduce((E, A) => {
    let N = rc({ hydrateParticipants: e.hydrateParticipants, context: T, tournamentAppliedPolicies: n, scheduleVisibilityFilters: a, tournamentParticipants: t, participantsProfile: o, afterRecoveryTimes: s, policyDefinitions: c, tournamentRecord: l, usePublishState: d, contextContent: r, contextFilters: p, matchUpFilters: m, participantMap: i, publishStatus: M, contextProfile: f, drawDefinition: A, nextMatchUps: h, inContext: I, event: S });
    return Object.keys(N)?.forEach((C) => {
      Array.isArray(N[C]) && (E[C] || (E[C] = []), E[C] = E[C].concat(N[C]));
    }), E;
  }, {}), ...x, groupInfo: R };
}
function cm(e) {
  if (!e?.tournamentRecord) return { error: J };
  let t = e.contextContent, { scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, tournamentRecord: o, inContext: s = !0, usePublishState: c, contextFilters: u, matchUpFilters: l, contextProfile: d, nextMatchUps: p, context: m } = e, f = e.tournamentId ?? o.tournamentId, h = o?.events ?? [], { participants: g, participantMap: I, groupInfo: U } = Ka({ participantsProfile: i, tournamentRecord: o, contextProfile: d, inContext: s });
  d && !t && (t = Hn({ policyDefinitions: a, tournamentRecord: o, contextProfile: d }));
  let { appliedPolicies: S } = _e({ tournamentRecord: o }), P = u?.eventIds ?? [];
  return { ...h.filter((v) => !P.includes(v.eventId)).map((v) => {
    let D = { eventDrawsCount: wt({ event: v }).flightProfile?.flights?.length || v.drawDefinitions?.length || 0, ...m };
    return sm({ hydrateParticipants: e.hydrateParticipants, context: D, tournamentAppliedPolicies: S, scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, tournamentRecord: o, usePublishState: c, contextFilters: u, contextProfile: d, contextContent: t, matchUpFilters: l, participantMap: I, participants: g, tournamentId: f, nextMatchUps: p, inContext: s, event: v });
  }).reduce((v, D) => ((D && Object.keys(D).filter((y) => !["success", "matchUpsMap"].includes(y)))?.forEach((y) => {
    Array.isArray(D[y]) && (v[y] || (v[y] = []), v[y] = v[y].concat(D[y]), v.matchUpsCount !== void 0 ? v.matchUpsCount += D[y].length : v.matchUpsCount = D[y].length);
  }), v), { matchUpsCount: 0 }), groupInfo: U, participants: g };
}
function au({ scheduleVisibilityFilters: e, hydrateParticipants: t, participantsProfile: r, tournamentRecords: i, useParticipantMap: n, policyDefinitions: a, usePublishState: o, matchUpFilters: s, contextFilters: c, nextMatchUps: u, inContext: l }) {
  if (typeof i != "object" || !Object.keys(i).length) return { error: ht };
  let d = Object.keys(i).map((f) => {
    let h = i[f];
    return cm({ scheduleVisibilityFilters: e, hydrateParticipants: t, participantsProfile: r, policyDefinitions: a, tournamentRecord: h, usePublishState: o, matchUpFilters: s, contextFilters: c, nextMatchUps: u, inContext: l });
  }), p = {}, m = {};
  return { ...d.reduce((f, h) => (Object.keys(h).forEach((g) => {
    if (g === "groupInfo") Object.assign(m, h[g]);
    else if (g === "participants") for (let I of h[g] ?? []) p[I.participantId] = I;
    else Array.isArray(h[g]) && (f[g] || (f[g] = []), f[g] = f[g].concat(h[g]));
  }), f), {}), groupInfo: m, mappedParticipants: p };
}
function gl(e) {
  if (typeof e?.tournamentRecords != "object" || !Object.keys(e?.tournamentRecords).length) return { error: ht };
  let { courts: t, venues: r } = Yn(e), i = Kn(e).schedulingProfile, { sortDateMatchUps: n = !0, courtCompletedMatchUps: a, alwaysReturnCompleted: o, activeTournamentId: s, tournamentRecords: c, withCourtGridRows: u, minCourtGridRows: l, usePublishState: d, status: p = Jr, sortCourtsData: m } = e, f = s ?? Oo() ?? Object.keys(c)[0], h = d ? Yu({ tournamentRecord: c[f], status: p }) : void 0, g = o ? au({ ...e, matchUpFilters: { ...e.matchUpFilters, matchUpStatuses: [vt] }, contextFilters: e.contextFilters }).completedMatchUps : [];
  if (d && !h?.orderOfPlay?.published) return { completedMatchUps: g, dateMatchUps: [], courtsData: [], venues: r };
  let I, U;
  d && ({ drawIds: I, detailsMap: U } = P_({ tournamentRecords: c })), I?.length && (e.contextFilters || (e.contextFilters = {}), e.contextFilters?.drawIds ? e.contextFilters.drawIds = e.contextFilters.drawIds.filter((E) => I.includes(E)) : e.contextFilters.drawIds = I), h?.eventIds?.length && (e.matchUpFilters || (e.matchUpFilters = {}), e.matchUpFilters?.eventIds && e.matchUpFilters.eventIds.length ? e.matchUpFilters.eventIds = e.matchUpFilters.eventIds.filter((E) => h.eventIds.includes(E)) : e.matchUpFilters.eventIds = h.eventIds), h?.scheduledDates?.length && (e.matchUpFilters || (e.matchUpFilters = {}), e.matchUpFilters.scheduledDates && e.matchUpFilters.scheduledDates.length ? e.matchUpFilters.scheduledDates = e.matchUpFilters.scheduledDates.filter((E) => h.scheduledDates.includes(E)) : e.matchUpFilters.scheduledDates = h.scheduledDates), o && (e.matchUpFilters || (e.matchUpFilters = {}), e.matchUpFilters?.excludeMatchUpStatuses?.length ? e.matchUpFilters.excludeMatchUpStatuses.includes(vt) || e.matchUpFilters.excludeMatchUpStatuses.push(vt) : e.matchUpFilters.excludeMatchUpStatuses = [vt]);
  let { completedMatchUps: S, upcomingMatchUps: P, pendingMatchUps: v, groupInfo: D, mappedParticipants: y } = au({ ...e, matchUpFilters: e.matchUpFilters, contextFilters: e.contextFilters }), w = [...P ?? [], ...v ?? []];
  U && (!I?.length || Object.keys(U).length) && (w = w.filter((E) => {
    let { drawId: A, structureId: N, stage: C } = E;
    if (!U?.[A]?.publishingDetail?.published) return !1;
    let k = Object.keys(U[A].stageDetails ?? {});
    if (k.length) {
      let _ = k.filter((L) => !U[A].stageDetails[L].published), B = k.filter((L) => U[A].stageDetails[L].published);
      return _.length && _.includes(C) ? !1 : B.length && B.includes(C) ? !0 : _.length && !_.includes(C) && !B.length;
    }
    let O = Object.keys(U[A].structureDetails ?? {});
    if (O.length) {
      let _ = O.filter((L) => !U[A].structureDetails[L].published), B = O.filter((L) => U[A].structureDetails[L].published);
      return _.length && _.includes(N) ? !1 : B.length && B.includes(N) ? !0 : _.length && !_.includes(N) && !B.length;
    }
    return !0;
  }));
  let b = n ? Ud({ matchUps: w, schedulingProfile: i }) : w, T = t?.map((E) => {
    let A = M(E);
    return { surfaceCategory: E?.surfaceCategory ?? "", matchUps: A, ...E };
  }), R = { completedMatchUps: o ? g : S, mappedParticipants: e.hydrateParticipants ? void 0 : y, dateMatchUps: b, courtsData: T, groupInfo: D, venues: r };
  if (u) {
    let { rows: E, courtPrefix: A } = nm({ minRowsCount: l, courtsData: T });
    R.courtPrefix = A, R.rows = E;
  }
  return { ...R, ...x };
  function M({ courtId: E }) {
    let A = (a ? b.concat(S ?? []) : b).filter((N) => N.schedule?.courtId === E || N.schedule?.allocatedCourts?.map(({ courtId: C }) => C).includes(E));
    return m ? Ud({ matchUps: A, schedulingProfile: i }) : A;
  }
}
function um({ tournamentRecords: e, tournamentId: t }) {
  if (typeof e != "object" || !Object.keys(e).length) return { error: ht };
  let r = Object.keys(e).filter((n) => !t || n === t), i;
  return r.forEach((n) => {
    let a = e[n], { matchUpDailyLimits: o } = D_({ tournamentRecord: a });
    i = o;
  }), { matchUpDailyLimits: i };
}
function D_(e) {
  let t = oe(e, [{ [Vt]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r } = e, { policy: i } = Qa({ policyType: pa, tournamentRecord: r }), { extension: n } = we({ element: r, name: Ru }), a = n?.value?.dailyLimits, o = i?.defaultDailyLimits;
  return { matchUpDailyLimits: a || o };
}
function mU(e) {
  let { matchUps: t } = e, { singlesForDoubles: r, tournamentRecord: i, drawDefinition: n, excludeMargin: a, exclusionRule: o, zoneDoubling: s, matchUpType: c, scaleName: u, eventId: l, zonePct: d, drawId: p, event: m } = e;
  if (!i && !t) return { error: J };
  if (c && ![Xe, Ke].includes(c)) return { error: z, info: { matchUpType: c } };
  if (t && !pi(t)) return { error: z, context: { matchUps: t } };
  let f = Gt[u], h = f?.ascending ?? e.ascending ?? !1, g = f?.accessor ?? e.valueAccessor, I = Array.isArray(f?.range) ? Math.abs(f.range[0] - f.range[1]) : 0, U = Ie(d) && I ? (d ?? 0 / 100) * I : e.zoneMargin ?? I, S = { withScaleValues: !0, withCompetitiveness: !0 }, P = { matchUpTypes: c ? [c] : [Xe, Ke] }, v = i?.participants;
  t?.[0]?.hasContext ? p ? t = t.filter((A) => A.drawId === p) : l && (t = t.filter((A) => A.eventId === l)) : t === void 0 && (t = p && !n && [] || !p && l && !m && [] || p && hr({ inContext: !0, drawDefinition: n, contextFilters: P, contextProfile: S, participants: v })?.matchUps || !p && l && Rn({ inContext: !0, contextFilters: P, contextProfile: S, participants: v, event: m })?.matchUps || Jt({ tournamentRecord: i, contextFilters: P, contextProfile: S })?.matchUps || []), c && (t = t.filter((A) => A.matchUpType === c));
  let D = t.filter(({ winningSide: A, score: N, sides: C, matchUpStatus: k }) => ![Xt, Pe, be, Zs, Or].includes(k ?? "") && Bt({ score: N }) && C?.length === 2 && A), y = T_({ matchUps: D, excludeMargin: a, exclusionRule: o, valueAccessor: g, ascending: h, scaleName: u }), w = !s || bt(Xe)(c) ? U : (U || 0) * 2, b = U ? D.map(({ competitiveProfile: A, matchUpType: N, score: C, sides: k }) => {
    let O = rR({ singlesForDoubles: r, valueAccessor: g, matchUpType: N, scaleName: u, sides: k }), _ = Math.abs(O[0].value - O[1].value);
    return { competitiveness: A?.competitiveness, valuesGap: _, score: C };
  }).filter(({ valuesGap: A }) => A <= w) : [], T = w_({ zoneData: b }), R = T && [].concat(Object.values(T)).flat().length, M = R && Object.assign({}, ...Object.keys(T).map((A) => ({ [A]: Math.round(1e4 * T[A].length / R) / 100 }))), E = D.length - (b?.length || 0);
  return { ...x, relevantMatchUps: D, zoneDistribution: M, zoneData: b, accuracy: y, nonZone: E };
}
function w_({ zoneData: e }) {
  let t = { [bg]: [], [Xc]: [], [Jc]: [] };
  for (let r of e) {
    let { competitiveness: i, score: n, valuesGap: a } = r;
    t[i] && t[i].push({ score: n, valuesGap: a });
  }
  return t;
}
function rR({ singlesForDoubles: e, exclusionRule: t, valueAccessor: r, matchUpType: i, scaleName: n, sides: a }) {
  let o = t?.range.sort(), s = (c) => {
    let u = c?.[t?.valueAccessor];
    return { exclude: t && u >= o[0] && u <= o[1], exclusionValue: u };
  };
  return a.sort((c, u) => c.sideNumber - u.sideNumber).map(({ participant: c }) => {
    let u = [], l = c?.individualParticipants;
    if (l?.length) {
      let d = [], p = 0;
      for (let m of l) {
        let { scaleValue: f, value: h } = Py({ singlesForDoubles: e, valueAccessor: r, participant: m, matchUpType: i, scaleName: n }), { exclude: g, exclusionValue: I } = s(f);
        g && u.push(I), d.push(f), h && !isNaN(p) ? p += h : p = void 0;
      }
      return { participantName: c.participantName, exclusionValues: u, scaleValues: d, value: p };
    } else if (c) {
      let { scaleValue: d, value: p } = Py({ singlesForDoubles: e, valueAccessor: r, matchUpType: i, participant: c, scaleName: n }), { exclude: m, exclusionValue: f } = s(d);
      return m && u.push(f), { participantName: c.participantName, exclusionValues: u, scaleValue: d, value: p };
    } else return {};
  });
}
function Py({ singlesForDoubles: e, valueAccessor: t, matchUpType: r, participant: i, scaleName: n }) {
  let a = e ? Xe : r, o = i?.rankings?.[a]?.find((u) => u.scaleName === n), s = (i?.ratings?.[a]?.find((u) => u.scaleName === n) || o)?.scaleValue, c = t ? s?.[t] : s;
  return { scaleValue: s, value: c };
}
function T_({ excludeMargin: e, exclusionRule: t, valueAccessor: r, ascending: i, scaleName: n, matchUps: a }) {
  let o = { affirmative: [], negative: [], excluded: [] };
  for (let u of a) {
    let { matchUpType: l, sides: d, score: p, winningSide: m } = u;
    if (!m) continue;
    if (t && (!t.valueAccessor || !t.range)) return { info: "exclusionRule requires valueAccessor and range", error: ue };
    let f = m - 1, h = rR({ exclusionRule: t, valueAccessor: r, matchUpType: l, scaleName: n, sides: d });
    if (t) {
      let v = h.map(({ exclusionValues: D }) => D).flat();
      if (v.length) {
        o.excluded.push({ scoreString: p?.scoreStringSide1, exclusionValues: v, winningSide: m, sideValues: h });
        continue;
      }
    }
    if (h.filter((v) => ![void 0, "", null].includes(v.value)).length < 2) {
      o.excluded.push({ scoreString: p?.scoreStringSide1, missingValues: !0, winningSide: m, sideValues: h });
      continue;
    }
    let g = h[f].value - h[1 - f].value, I = parseFloat(e || 0), U = I && Math.abs(g) < I;
    if (U) {
      o.excluded.push({ scoreString: p?.scoreStringSide1, excludeMargin: e, winningSide: m, excludeGap: U, sideValues: h, valuesGap: g });
      continue;
    }
    let S = i ? g : g * -1, P = m === 1 ? p?.scoreStringSide1 : p?.scoreStringSide2;
    S > 0 ? o.affirmative.push({ winningScoreString: P, winningSide: m, sideValues: h, valuesGap: g, score: p }) : o.negative.push({ winningScoreString: P, winningSide: m, sideValues: h, valuesGap: g, score: p });
  }
  let s = o.affirmative.length + o.negative.length, c = s && o.affirmative.length / s * 100;
  return o.percent = c ? Math.round(100 * c) / 100 : 0, o;
}
function ts({ collectionDefinitions: e = [], collectionGroups: t = [] }) {
  let r = 0, { groupValueNumbers: i } = ub({ collectionGroups: t }), n;
  for (let a of e || []) {
    let { collectionValueProfiles: o, collectionGroupNumber: s, collectionValue: c, matchUpCount: u, matchUpValue: l, scoreValue: d, setValue: p } = a, m = s && i.includes(s);
    if (Ie(p || d)) n = !0;
    else {
      if (m) continue;
      if (typeof c == "number" && Ie(c)) r += c;
      else if (Array.isArray(o) && o?.length) for (let f of o) r += f.matchUpValue;
      else typeof l == "number" && Ie(l) && (r += (u ?? 0) * l);
    }
  }
  for (let a of t) r += a.groupValue ?? 0;
  return n || !r ? { aggregateValue: !0, ...x } : { valueGoal: Math.floor(r / 2) + 1, ...x };
}
function fU(e) {
  let { timeStamp: t, schedule: r, matchUp: i } = e, n = oe(e, [{ [Tn]: !0 }]);
  if (n.error) return n;
  let { itemValue: a, timeStamp: o } = Za({ timeItems: i?.timeItems || [], itemType: Cg });
  return !r || o && t && new Date(o).getTime() > new Date(t).getTime() ? { homeParticipantId: a } : r;
}
function hU({ matchUps: e, matchUpId: t }) {
  if (!pi(e)) return { error: z };
  let r = e.find((s) => s.matchUpId === t), { drawId: i, eventId: n, structureId: a, tournamentId: o } = r || {};
  return { matchUpId: t, drawId: i, eventId: n, structureId: a, tournamentId: o };
}
function lc(e, t) {
  if (!xe(e)) return { error: z };
  if (!Array.isArray(t)) return { error: z };
  let r = {};
  for (let { param: i, error: n, attr: a } of t) {
    let o = b_({ params: e, param: i, attr: a, error: n });
    if (o?.error) return o;
    r[i] = o;
  }
  return r;
}
function b_({ params: e, param: t, attr: r, error: i }) {
  if (t === ep && xe(e.drawDefinition) && dt(e.structureId)) {
    let n = (e.drawDefinition.structures ?? []).find(({ structureId: a }) => a === e.structureId);
    return !n.length && i ? { error: i } : { structure: n };
  }
  if (t === Tn) {
    let n = qM({ ...e, ...r });
    return n.error && i ? { ...n, error: i } : n;
  }
  return { error: Kt, info: { param: t } };
}
function gU(e) {
  let { structureId: t, matchUpId: r, event: i } = e, n = e.drawDefinition, a = oe(e, [{ [Vt]: !0 }, { [Zh]: { [Xd]: !1, [tn]: !1, [GD]: !1, [qn]: !1 } }]);
  if (a[yi]) return a;
  let o = lc(e, [{ [Ks]: Tn, [yi]: ue }])?.matchUp;
  if (r && o?.error) return o;
  !n && o?.drawDefinition && (n = o?.drawDefinition);
  let s = o?.structure;
  if (!s && t && !r) {
    if (!n) return { error: Vi };
    let p = me({ drawDefinition: n, structureId: t });
    if (p.error) return p;
    s = p.structure;
  }
  let c = s?.matchUpFormat, u = n?.matchUpFormat, l = i?.matchUpFormat, d = o?.matchUp?.matchUpFormat || c || u || l;
  return { structureDefaultMatchUpFormat: c, eventDefaultMatchUpFormat: l, drawDefaultMatchUpFormat: u, matchUpFormat: d };
}
function IU({ profileBands: e, tournamentRecord: t, matchUps: r }) {
  if (!pi(r)) return { error: Gn };
  let i = !e && Qa({ policyType: En, tournamentRecord: t }).policy, n = e || i?.profileBands || Mg[En].profileBands, a = r.filter(({ winningSide: p }) => p), o = a.map(Ew), s = (p, m) => {
    let f = Nw(m, n);
    return p[f] += 1, p;
  }, c = Aw(o).reduce((p, m) => s(p, m), { [bg]: 0, [Xc]: 0, [Jc]: 0, [ww]: 0 }), u = Object.keys(c).reduce((p, m) => (c[m] || 0) + p, 0), l = Object.keys(c).map((p) => {
    let m = parseFloat((c[p] / u).toFixed(4));
    return { [p]: m * 100 };
  }), d = a.filter(({ matchUpStatus: p }) => p === HS).length;
  return l.push({ [HS]: parseFloat((d / u).toFixed(4)) * 100 }), { competitiveBands: Object.assign({}, ...l), ...x };
}
var { stageOrder: Dy } = r1;
function M_(e, t) {
  return e.eventName.localeCompare(t.eventName) || e.eventId.localeCompare(t.eventId) || (Dy[e?.stage] || 0) - (Dy[t?.stage] || 0) || t.matchUpsCount - e.matchUpsCount || `${e.stageSequence}-${e.roundNumber}-${e.minFinishingSum}`.localeCompare(`${t.stageSequence}-${t.roundNumber}-${t.minFinishingSum}`);
}
function UU({ excludeScheduleDateProfileRounds: e, excludeScheduledRounds: t, excludeCompletedRounds: r, inContextMatchUps: i, tournamentRecords: n, schedulingProfile: a, tournamentRecord: o, withSplitRounds: s, matchUpFilters: c, scheduleDate: u, withRoundId: l, venueId: d, context: p }) {
  if (i && !Array.isArray(i || typeof i[0] != "object")) return { error: z, inContextMatchUps: i };
  if (o && !n) {
    if (typeof o != "object") return { error: du };
    n = { [o.tournamentId]: o };
  }
  let m = typeof n != "object" || !Object.keys(n).length;
  if ((d || u || !i || !a && (e || r || a || s)) && m) return { error: ht };
  let f = Object.assign({}, ...Object.values(n ?? {}).map(({ venues: D = [], tournamentId: y }) => ({ [y]: D?.map(({ venueId: w }) => w) }))), h = Object.values(n ?? {}).map(({ events: D = [], tournamentId: y, startDate: w, endDate: b }) => D.map((T) => ({ ...T, validVenueIds: f[y], startDate: T.startDate ?? w, endDate: T.endDate ?? b }))).flat(), { segmentedRounds: g, profileRounds: I } = n && (e || r || a || s) && im({ tournamentRecords: n, schedulingProfile: a }) || {}, U = e && Object.assign({}, ...I.map((D) => ({ [D.id]: D }))), S = i || n && Bi({ tournamentRecords: n, matchUpFilters: c })?.matchUps || [], P = [], v = S && Object.values(S.reduce((D, y) => {
    let w = qf(y).id, b = g?.[w], T = [...D[w]?.matchUps ?? [], y], { containerStructureId: R, stageSequence: M, structureName: E, tournamentId: A, isRoundRobin: N, matchUpType: C, roundNumber: k, roundOffset: O, structureId: _, eventName: B, roundName: L, drawName: j, eventId: H, drawId: G } = y, V = N ? R : _;
    return { ...D, [w]: { id: l ? w : void 0, structureId: V, stageSequence: M, segmentsCount: b, structureName: E, tournamentId: A, matchUpType: C, roundNumber: k, roundOffset: O, eventName: B, roundName: L, drawName: j, matchUps: T, eventId: H, drawId: G } };
  }, {})).map((D) => {
    let { minFinishingSum: y, winnerFinishingPositionRange: w } = y_(D.matchUps), b = D.segmentsCount;
    if (b) {
      let k = D.matchUps.length / b;
      return qt(D.matchUps.sort((O, _) => O.roundPosition - _.roundPosition), k).map((O, _) => {
        let { unscheduledCount: B, incompleteCount: L, matchUpsCount: j, isScheduled: H, isComplete: G, byeCount: V } = vy(O), $ = yy({ matchUps: D.matchUps, tournamentRecords: n, events: h, round: D });
        return ae({ ...D, ...p, roundSegment: { segmentsCount: b, segmentNumber: _ + 1 }, winnerFinishingPositionRange: w, unscheduledCount: B, incompleteCount: L, minFinishingSum: y, matchUpsCount: j, isScheduled: H, roundTiming: $, isComplete: G, byeCount: V, matchUps: O });
      });
    }
    let { unscheduledCount: T, incompleteCount: R, matchUpsCount: M, isScheduled: E, isComplete: A, byeCount: N } = vy(D.matchUps), C = yy({ matchUps: D.matchUps, tournamentRecords: n, events: h, round: D });
    return ae({ ...D, ...p, winnerFinishingPositionRange: w, unscheduledCount: T, incompleteCount: R, minFinishingSum: y, matchUpsCount: M, isScheduled: E, roundTiming: C, isComplete: A, byeCount: N });
  }).flat().filter((D) => {
    if (e) {
      let _ = ve(e), B = l ? D.id : qf(D).id;
      if (_ && U[B] && ve(U[B].scheduleDate) === _) return !1;
    }
    let { isComplete: y, isScheduled: w } = D, b = !r || !y, T = !t || !w, R = d || u ? h?.find(({ eventId: _ }) => _ === D.eventId) : void 0, M = R?.startDate ?? o?.startDate, E = R?.endDate ?? o?.endDate, A = !u || !M || new Date(u) >= new Date(M), N = !u || !E || new Date(u) <= new Date(E), C = A && N, k = !d || R?.validVenueIds.includes(d), O = b && T && k && C;
    return O || P.push(D), O;
  }).sort(M_) || [];
  return { ...x, rounds: v, excludedRounds: P };
}
function ou(e) {
  let { matchUp: t, sideNumber: r, setNumber: i, isTiebreakValue: n, isPointValue: a } = e || {}, { matchUpFormat: o } = e || {};
  if (!t) return { error: Dr };
  o = o || t?.matchUpFormat;
  let s = Sr(o), c = !!t?.winningSide, u = t.score?.sets, l = u?.length, d = i && i - 1, p = !!u?.find((V, $) => V.setNumber === i && $ === d), m = u?.filter((V) => V?.winningSide) || [], f = m?.length || 0, h = i && u?.slice(i) || [], g = !!(l && i && h?.reduce((V, $) => (!$ || !$.side1Score && !$.side2Score && !$.side1TiebreakScore && !$.side2TiebreakScore && !$.side1PointScore && !$.side2PointScore) && V, !0)), I = i <= l && u.find((V) => V.setNumber === i), U = I && nu({ setObject: I, matchUpScoringFormat: s }), { isCompletedSet: S, sideGameScores: P, sideTiebreakScores: v } = U || {}, D = !!(I && !S && g || i && i === l + 1 && !c), y = [1, 2].includes(r), w = y ? r - 1 : 0, b = I && y && (!n && !a && P[w] !== void 0 && P[w] || n && v[w] !== void 0 && v[w]), T = !!b, R = m?.map((V) => nu({ setObject: V, matchUpScoringFormat: s }).isValidSetOutcome).reduce((V, $) => V && $, !0), M = m.reduce((V, $) => {
    let { winningSide: q } = $, Y = q - 1;
    return V[Y]++, V;
  }, [0, 0]), E = t?.winningSide, A = E && E - 1, N = 1 - A, C = M[A], k = M[N], O = Math.max(...M), _ = Br(M)[O], { bestOf: B, exactly: L } = s ?? {}, j = B && Math.ceil(B / 2) || L || 1, H = O === j && _ === 1 && M.indexOf(O) + 1 || void 0, G = C > k && E === H;
  return { completedSetsHaveValidOutcomes: R, validMatchUpWinningSide: G, calculatedWinningSide: H, matchUpScoringFormat: s, validMatchUpOutcome: H && R && G, isLastSetWithValues: g, completedSetsCount: f, isCompletedMatchUp: c, isValidSideNumber: y, hasExistingValue: T, existingValue: b, isExistingSet: p, isActiveSet: D, ...U };
}
function SU({ participants: e, tournamentAppliedPolicies: t, scheduleVisibilityFilters: r, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, useParticipantMap: o, tournamentRecord: s, usePublishState: c, contextFilters: u, contextContent: l, matchUpFilters: d, participantMap: p, publishStatus: m, contextProfile: f, drawDefinition: h, nextMatchUps: g, tournamentId: I, inContext: U, context: S, event: P }) {
  let { eventId: v, eventName: D, endDate: y, eventType: w, category: b, gender: T } = P ?? {}, R = { ...S, ...ae({ surfaceCategory: P?.surfaceCategory ?? s?.surfaceCategory, indoorOutDoor: P?.indoorOutdoor ?? s?.indoorOutdoor, endDate: y ?? P?.endDate ?? s?.endDate, tournamentId: I ?? s?.tournamentId, eventName: D, eventType: w, category: b, eventId: v, gender: T }) }, M;
  return !e?.length && s && ({ participants: e, participantMap: p, groupInfo: M } = Ka({ participantsProfile: i, useParticipantMap: o, tournamentRecord: s, contextProfile: f, inContext: U })), P && f && !l && (l = Hn({ policyDefinitions: a, tournamentRecord: s, contextProfile: f, drawDefinition: h, event: P })), { ...rc({ context: R, tournamentAppliedPolicies: t, scheduleVisibilityFilters: r, tournamentParticipants: e, participantsProfile: i, afterRecoveryTimes: n, policyDefinitions: a, tournamentRecord: s, usePublishState: c, participantMap: p, contextContent: l, contextFilters: u, matchUpFilters: d, publishStatus: m, contextProfile: f, drawDefinition: h, nextMatchUps: g, inContext: U, event: P }), groupInfo: M };
}
var iR = {};
Me(iR, { getCompetitionVenues: () => pl, getCourts: () => yU, getVenuesAndCourts: () => Yn, publicFindVenue: () => xg });
function yU({ tournamentRecord: e, venueId: t, venueIds: r }) {
  return e ? { courts: (e.venues || []).filter((i) => t ? i.venueId === t : r ? r.includes(i.venueId) : !0).map((i) => {
    let { venueId: n } = i, a = ie(i.courts || []);
    return a.forEach((o) => Object.assign(o, { venueId: n })), a;
  }).flat() } : { error: J };
}
var nR = {};
Me(nR, { categoryCanContain: () => vu, getCategoryAgeDetails: () => Uo, getEvent: () => DU, getEventProperties: () => vU, getEventStructures: () => Mp, getEventTimeItem: () => Cu, getEvents: () => PU, getFlightProfile: () => wt, getScaledEntries: () => Zo });
function vU({ tournamentRecord: e, event: t }) {
  if (!e) return { error: J };
  if (!t) return { error: st };
  let r = t.entries || [], i = e.participants || [], n = t.category?.categoryName || t.category?.ageCategoryCode, { eventType: a } = t, o = r.map((d) => d.participantId), s = i.filter((d) => o.includes(d.participantId)), c, u, l;
  return { entryScaleAttributes: s.map((d) => {
    let { participantId: p, participantName: m, name: f } = d, h = { scaleType: kg, eventType: a, scaleName: n }, g = dn({ participant: d, scaleAttributes: h })?.scaleItem?.scaleValue;
    h = { scaleType: Vw, eventType: a, scaleName: n };
    let I = dn({ participant: d, scaleAttributes: h })?.scaleItem?.scaleValue;
    h = { scaleType: Bw, eventType: a, scaleName: n };
    let U = dn({ participant: d, scaleAttributes: h })?.scaleItem?.scaleValue;
    return c = !!(c || g), u = !!(u || I), l = !!(l || U), { participantId: p, participantName: m || f, seed: g, ranking: I, rating: U };
  }), hasSeededParticipants: c, hasRankedParticipants: u, hasRatedParticipants: l };
}
function PU({ tournamentRecord: e, withScaleValues: t, scaleEventType: r, inContext: i, eventIds: n, drawIds: a, context: o }) {
  if (!e) return { error: J };
  let { tournamentId: s } = e, c = (e.events ?? []).filter(({ eventId: l }) => !n || Array.isArray(n) && n.includes(l)).map((l) => {
    let d = l.drawDefinitions?.map(Kc);
    if (a?.length && !Pt(a, d).length) return;
    let p = ie(l);
    return i && Object.assign(p, { tournamentId: s }), o && Object.assign(p, o), p;
  }).filter(Boolean), u = {};
  if (t) {
    let l = ft({ withScaleValues: !0, tournamentRecord: e }).participantMap, d = (p) => p.reduce((m, f) => m + parseFloat(f), 0);
    for (let p of c) {
      let m = r ?? p.eventType, f = p.eventId;
      u[f] || (u[f] = { ratingsStats: {}, ratings: {}, ranking: {}, draws: {} });
      let h = (p.entries ?? []).filter(({ entryStatus: D }) => Ni.includes(D)).map(Re), g = (D) => {
        if (D?.ratings?.[m]) for (let y of D?.ratings?.[m] ?? []) {
          let w = y.scaleName;
          u[f].ratings[w] || (u[f].ratings[w] = []);
          let b = Gt[w]?.accessor;
          if (b) {
            let T = parseFloat(y.scaleValue?.[b]);
            T && u[f].ratings[w].push(T);
          }
        }
        if (D?.rankings?.[m]) for (let y of D?.rankings?.[m] ?? []) {
          let w = y.scaleName;
          u[f].ranking[w] || (u[f].ranking[w] = []), y.scaleValue && u[f].ranking[w].push(y.scaleValue);
        }
      };
      for (let D of h) {
        let y = l?.[D]?.participant;
        if (y?.participantType !== Ne) for (let w of y?.individualParticipantIds ?? []) {
          let b = l?.[w]?.participant;
          g(b);
        }
        else g(y);
      }
      let I = u[f].ratings;
      for (let D of Object.keys(I)) {
        let y = I[D];
        if (!y.length) continue;
        let w = xS(y)?.toFixed(2);
        u[f].ratingsStats[D] = { avg: parseFloat((d(y) / y.length).toFixed(2)), median: w ? parseFloat(w) : void 0, max: Math.max(...y), min: Math.min(...y) };
      }
      let U = (D, y) => {
        let w = (b) => {
          if (u[f].draws?.[D] && b?.ratings?.[m]) for (let T of b?.ratings?.[m] ?? []) {
            let R = T.scaleName;
            u[f].draws[D]?.ratings[R] || (u[f].draws[D].ratings[R] = []);
            let M = Gt[R]?.accessor;
            if (M) {
              let E = parseFloat(T.scaleValue?.[M]);
              E && u[f].draws[D].ratings[R].push(E);
            }
          }
          if (u[f].draws?.[D] && b?.rankings?.[m]) for (let T of b?.rankings?.[m] ?? []) {
            let R = T.scaleName;
            u[f].draws[D]?.ranking[R] || (u[f].draws[D].ranking[R] = []);
            let M = T.scaleValue;
            M && u[f].draws[D].ranking[R].push(M);
          }
        };
        for (let b of y.filter(Boolean)) {
          let T = l?.[b]?.participant;
          if (T?.participantType !== Ne) for (let R of T?.individualParticipantIds ?? []) {
            let M = l?.[R]?.participant;
            w(M);
          }
          else w(T);
        }
      }, S = [], P = (D) => a?.length && a.includes(D) || S.includes(D);
      for (let D of p.drawDefinitions ?? []) {
        let y = D.drawId;
        if (P(y)) continue;
        let w = eo({ drawDefinition: D }).assignedParticipantIds ?? [];
        u[f].draws[y] || (u[f].draws[y] = { ratingsStats: {}, ratings: {}, ranking: {} }), S.push(y), U(y, w);
      }
      let v = wt({ event: p }).flightProfile;
      for (let D of v?.flights ?? []) {
        let y = D.drawId;
        if (P(y)) continue;
        let w = D.drawEntries.map(Re);
        U(y, w);
      }
      for (let D of S) {
        let y = u[f].draws[D].ratings;
        for (let w of Object.keys(y)) {
          let b = y[w];
          if (!b.length) continue;
          let T = xS(b)?.toFixed(2);
          u[f].draws[D].ratingsStats[w] = { avg: parseFloat((d(b) / b.length).toFixed(2)), median: T ? parseFloat(T) : void 0, max: Math.max(...b), min: Math.min(...b) };
        }
      }
    }
  }
  return ae({ eventScaleValues: u, events: c, ...x });
}
function DU({ tournamentRecord: e, drawDefinition: t, context: r, event: i }) {
  if (!e) return { error: J };
  if (!i) return { error: st };
  let n = ie(i);
  r && Object.assign(n, r);
  let a = t && n.drawDefinitions?.find(({ drawId: o }) => t.drawId === o);
  return ae({ drawDefinition: a, event: n });
}
function R_(e) {
  let t = "validateAndDeriveDrawValues", { appliedPolicies: r, policyDefinitions: i } = A_(e), n = C_({ ...e, policyDefinitions: i, appliedPolicies: r }), a = E_(e), o = O_({ ...e, consideredEntries: a, appliedPolicies: r });
  if (o?.error) return F({ result: o, stack: t });
  let s = k_({ ...e, consideredEntries: a }), c = N_({ ...e, appliedPolicies: r, policyDefinitions: i, drawSize: s });
  if (c.error) return F({ result: c, stack: t });
  let u = c.drawType;
  if (isNaN(s) && u !== Gr) return F({ result: { error: mu }, stack: t });
  let l = i?.[hi] ?? r?.[hi], d = e.seedingProfile ?? l?.seedingProfile?.drawTypes?.[u ?? ""] ?? l?.seedingProfile;
  e.seedingProfile && (i[hi] || (i[hi] = { ...$f[hi] }), i[hi].seedingProfile = d);
  let p = x_({ ...e, drawType: u });
  return p?.error ? F({ result: p, stack: t }) : { drawSize: s, drawType: u, enforceGender: n, seedingProfile: d, appliedPolicies: r, policyDefinitions: i };
}
function N_(e) {
  let { policyDefinitions: t, appliedPolicies: r, enforceMinimumDrawSize: i = !0, drawSize: n } = e, a = e.drawTypeCoercion ?? ul({ drawType: e.drawType, policyDefinitions: t, appliedPolicies: r }), o = Fb({ drawType: e.drawType, enforceMinimumDrawSize: i, drawTypeCoercion: a, drawSize: n });
  return o.error ? o : { drawType: o.drawType };
}
function aR(e) {
  return e?.filter((t) => t.entryStatus && [...Ni, Bu].includes(t.entryStatus));
}
function E_({ considerEventEntries: e = !0, drawEntries: t, eventEntries: r, qualifyingOnly: i }) {
  return (i && [] || aR(t) || (e ? r : [])).filter(({ entryStage: n }) => !n || n === re);
}
function A_(e) {
  let { tournamentRecord: t, event: r } = e, i = _e({ tournamentRecord: t, event: r }).appliedPolicies ?? {}, n = ie(e.policyDefinitions ?? {}, !1, !0);
  return { appliedPolicies: i, policyDefinitions: n };
}
function C_({ enforceGender: e, policyDefinitions: t, appliedPolicies: r }) {
  return e ?? t?.[Yt]?.participants?.enforceGender ?? r?.[Yt]?.participants?.enforceGender;
}
function O_(e) {
  let { consideredEntries: t, appliedPolicies: r, policyDefinitions: i, enforceGender: n, participantMap: a, participants: o, event: s } = e;
  return s && o && _p({ consideredEntries: t, policyDefinitions: i, appliedPolicies: r, participantMap: a, enforceGender: n, participants: o, event: s });
}
function k_(e) {
  return !e.drawSize && e.consideredEntries.length && ![Gr, Du, Ys, Di, Sn].includes(e.drawType ?? "") && Bs(e.consideredEntries.length) || e.drawSize && pe(e.drawSize) || !1;
}
function x_(e) {
  let { tournamentRecord: t, event: r, ignoreAllowedDrawTypes: i, drawType: n } = e, a = !i && t && zp({ tournamentRecord: t, categoryType: r?.category?.categoryType, categoryName: r?.category?.categoryName });
  return a?.length && !a.includes(n) ? { error: ah } : { ...x };
}
function Il(e) {
  let { voluntaryConsolation: t, tournamentRecord: r, event: i } = e, n = "generateDrawDefinition", { participants: a, participantMap: o } = ft({ withIndividualParticipants: !0, convertExtensions: !0, internalUse: !0, tournamentRecord: r }), s = aR(i?.entries) ?? [], c = R_({ ...e, participantMap: o, participants: a, eventEntries: s });
  if (c.error) return F({ result: c, stack: n });
  let { appliedPolicies: u, policyDefinitions: l, drawSize: d, drawType: p, enforceGender: m, seedingProfile: f } = c, h = i?.eventType, g = e.matchUpType ?? h, I = kL({ ...e, enforceGender: m, eventType: h, matchUpType: g });
  if (I.error) return F({ result: I, stack: n });
  let { matchUpFormat: U, tieFormat: S } = I;
  if (e.drawId && typeof e.drawId != "string") return F({ result: { error: z }, stack: n });
  let P = c_({ ...e, policyDefinitions: l, tournamentRecord: r, appliedPolicies: u, matchUpFormat: U, seedingProfile: f, participants: a, eventEntries: s, matchUpType: g, tieFormat: S, drawSize: d, drawType: p, event: i });
  if (P.error) return F({ result: P, stack: n });
  let { existingDrawDefinition: v, positioningReports: D, drawDefinition: y, structureId: w, conflicts: b, entries: T } = P;
  if (!y) return F({ result: { error: z }, stack: n });
  let R = u_({ ...e, existingDrawDefinition: v, positioningReports: D, appliedPolicies: u, drawDefinition: y, seedingProfile: f, participants: a, structureId: w, entries: T, params: e, stack: n });
  if (R.error) return R;
  let { qualifyingConflicts: M } = R;
  return y.drawName = e.drawName ?? (p && ir(p)), d && typeof t == "object" && d >= 4 && zg({ ...t, drawDefinition: y, matchUpType: g }), { existingDrawDefinition: !!v, qualifyingConflicts: M, positioningReports: D, drawDefinition: y, structureId: w, ...x, conflicts: b };
}
function oR({ scaleAttributes: e, scaledEntries: t, stageEntries: r, seedsCount: i, scaleName: n }) {
  if (!e) return { error: ue, info: "missing scaleAttributes" };
  let a = Object.assign({}, ...(t || []).slice(0, i).map(({ participantId: s }, c) => ({ [s]: c + 1 })));
  n = n || e.scaleName;
  let o = (/* @__PURE__ */ new Date()).toISOString();
  return { scaleItemsWithParticipantIds: r.map(({ participantId: s }) => ({ scaleItems: [{ scaleValue: a[s], eventType: e.eventType, scaleType: un, scaleName: n, scaleDate: o }], participantId: s })) };
}
function F_({ tournamentRecord: e, drawDefinition: t, policyDefinitions: r, scaleAttributes: i, scaleName: n, drawSize: a, drawId: o, event: s, stage: c, sortDescending: u, scaleSortMethod: l }) {
  let d = am({ policyDefinitions: r, drawDefinition: t, drawSize: a, drawId: o, event: s, stage: c });
  if (d.error) return d;
  let { entries: p, seedsCount: m, stageEntries: f } = d;
  if (!f || !m) return { error: z };
  let h = Zo({ tournamentRecord: e, scaleAttributes: i, scaleSortMethod: l, sortDescending: u, entries: p, stage: c }).scaledEntries ?? [], { scaleItemsWithParticipantIds: g } = oR({ scaleAttributes: i, scaledEntries: h, stageEntries: f, seedsCount: m, scaleName: n });
  return { scaleItemsWithParticipantIds: g };
}
var sR = {};
Me(sR, { addDrawEntries: () => Gg, addEventEntries: () => Hi, addEventEntryPairs: () => pR, destroyPairEntries: () => dT, destroyPairEntry: () => Hg, getEntriesAndSeedsCount: () => am, getMaxEntryPosition: () => cU, modifyEntriesStatus: () => sd, modifyEventEntries: () => mR, mutate: () => cR, promoteAlternate: () => lR, promoteAlternates: () => TU, query: () => JM, removeDrawEntries: () => dR, removeEventEntries: () => Qu, setEntryPosition: () => wU, setEntryPositions: () => uR });
var cR = {};
Me(cR, { addDrawEntries: () => Gg, addEventEntries: () => Hi, addEventEntryPairs: () => pR, destroyPairEntries: () => dT, destroyPairEntry: () => Hg, modifyEntriesStatus: () => sd, modifyEventEntries: () => mR, promoteAlternate: () => lR, promoteAlternates: () => TU, removeDrawEntries: () => dR, removeEventEntries: () => Qu, setEntryPosition: () => wU, setEntryPositions: () => uR });
function wU({ tournamentRecord: e, drawDefinition: t, participantId: r, entryPosition: i, skipRefresh: n, event: a }) {
  let o = "setEntryPositions";
  if (!e) return { error: J };
  if (!r) return F({ result: { error: Ft }, stack: o });
  if (i !== void 0 && !Number.isSafeInteger(i)) return { error: z, entryPosition: i };
  (a?.entries || []).forEach((c) => {
    c.participantId === r && (c.entryPosition = i);
  }), (t?.entries || []).forEach((c) => {
    c.participantId === r && (c.entryPosition = i);
  });
  let s = (c) => {
    c.entries.forEach((u) => {
      u.entryPosition === i && u.participantId !== r && (u.entryPosition += 0.1);
    });
  };
  return n || (a?.entries && (s(a), a.entries = xi({ entries: a.entries })), t?.entries && (s(t), t.entries = xi({ entries: t.entries }))), { ...x };
}
function uR({ tournamentRecord: e, entryPositions: t, drawDefinition: r, event: i }) {
  if (!e) return { error: J };
  if (!Array.isArray(t)) return { error: z };
  for (let n of t) {
    let { participantId: a, entryPosition: o } = n, s = wU({ skipRefresh: !0, tournamentRecord: e, drawDefinition: r, participantId: a, entryPosition: o, event: i });
    if (s.error) return s;
  }
  return i?.entries && (i.entries = xi({ entries: i.entries })), r?.entries && (r.entries = xi({ entries: r.entries })), { ...x };
}
function lR(e) {
  let { participantId: t } = e;
  return t && typeof t != "string" ? { error: z, participantId: t } : TU({ ...e, participantIds: [t].filter(Boolean) });
}
function TU({ tournamentRecord: e, drawDefinition: t, participantIds: r, stageSequence: i, stage: n = re, eventId: a, event: o }) {
  if (!e) return { error: J };
  if (!Array.isArray(r)) return { error: z, participantIds: r };
  if (!o) return { error: st };
  let s = "promoteAlternates";
  if (o) {
    let c = wy({ element: o, participantIds: r, stageSequence: i, stage: n });
    if (c.error) return c;
  }
  if (t) {
    let c = wy({ element: t, participantIds: r, stageSequence: i, stage: n });
    if (c.error) return a ? F({ context: { drawPromotionError: c.error, drawId: t.drawId }, result: { ...x }, stack: s }) : c;
  }
  return { ...x };
}
function wy({ participantIds: e, stageSequence: t, element: r, stage: i }) {
  let n = (r.entries || []).filter((d) => d.entryStatus === vi), a = (r.entries || []).filter((d) => e.includes(d.participantId)), o = n.reduce((d, p) => {
    let { entryPosition: m } = p;
    return isNaN(m) && d || (!d || m < d.entryPosition) && p || d;
  }, void 0), s = a.length ? a : [o].filter(Boolean);
  if (!s?.length) return { error: nP };
  let c = s.filter(({ entryStatus: d }) => d !== vi);
  if (c.length) return { error: lf, invalidEntryStatus: c };
  let u = s.filter(({ entryStage: d }) => d && d !== i);
  if (u.length) return { error: VC, invalidStage: u };
  let l = t && s.filter((d) => d.stageSequence !== t);
  if (l?.length) return { error: jC, invalidStageSequence: l };
  for (let d of s) {
    d.entryStatus = kr;
    let p = d?.entryPosition;
    isNaN(p) || r.entries.forEach((f) => {
      f.entryStatus === vi && f.entryPosition > p && (f.entryPosition = f.entryPosition - 1);
    });
    let m = Math.max(...r.entries.filter((f) => f.entryStatus === kr && !isNaN(f.entryPosition)).map(({ entryPosition: f }) => pe(f || 0)), 0);
    d.entryPosition = m || 0;
  }
  return { ...x };
}
function dR({ autoEntryPositions: e = !0, participantIds: t, drawDefinition: r, drawId: i, stages: n, event: a }) {
  if (!a) return { error: st };
  if (!i) return { error: Vi };
  if (!t?.length) return { error: la };
  let o = eo({ drawDefinition: r, stages: n }).assignedParticipantIds ?? [];
  if (gr(o, t)) return { error: qs };
  let s = (l) => {
    let d = l.participantId;
    return !t.includes(d);
  }, { flightProfile: c } = wt({ event: a }), u = c?.flights?.find((l) => l.drawId === i);
  return u?.drawEntries && (u.drawEntries = u.drawEntries.filter(s), e && (u.drawEntries = xi({ entries: u.drawEntries }))), r?.entries && (r.entries = r.entries.filter(s), e && (r.entries = xi({ entries: r.entries }))), { ...x };
}
function en(e) {
  let t = "addParticipant", { allowDuplicateParticipantIdPairs: r, returnParticipant: i, disableNotice: n, pairOverride: a, participant: o } = e, s = e.tournamentId ? e.tournamentRecords?.[e.tournamentId] : e.tournamentRecord ?? (e.activeTournamentId && e.tournamentRecords?.[e.activeTournamentId]);
  if (!s) return { error: J };
  if (!o) return F({ result: { error: Ao }, stack: t });
  o.participantId || (o.participantId = je()), s.participants || (s.participants = []);
  let { participantId: c, individualParticipantIds: u } = o;
  if (s.participants.reduce((h, g) => g.participantId === c || h, !1)) return { error: Zv };
  let { participantType: l, participantRole: d } = o;
  if (!l || !Object.keys(bc).includes(l)) return { error: _i, participantType: l };
  if (!d) return { error: Xv };
  let p = s.participants || [], m = p.filter((h) => h.participantType === Ne).map((h) => h.participantId);
  if (l !== Ne && o.person) return { error: z, person: o.person };
  if (u && !Array.isArray(u)) return { error: z, individualParticipantIds: u };
  if (l === De) {
    if (o.person) return { error: z, person: o.person };
    if (o.individualParticipantIds) {
      if (o.individualParticipantIds.length !== 2 && !a) return F({ info: "PAIR must be 2 individualParticipantIds", result: { error: _r }, stack: t });
      {
        let I = p.filter((U) => U.participantType === Ne).map((U) => U.participantId);
        if (!Array.isArray(o.individualParticipantIds)) return F({ result: { error: _r }, stack: t });
        if (!o.individualParticipantIds.reduce((U, S) => I.includes(S) && U, !0)) return F({ result: { error: _r }, stack: t });
      }
    } else return F({ result: { error: la }, stack: t });
    let h = p.filter((I) => I.participantType === De).map((I) => ({ individualParticipantIds: I.individualParticipantIds, participant: I })), g = o.participantType === De && h.find((I) => Pt(I.individualParticipantIds, o.individualParticipantIds).length === 2);
    if (g && !r) return { ...x, existingParticipant: !0, participant: i && ie(g.participant) };
    if (!o.participantName) {
      let I = p.filter((S) => o.individualParticipantIds?.includes(S.participantId)), U = I.map((S) => S.person?.standardFamilyName).filter(Boolean).join("/");
      I.length === 1 && (U += "/Unknown"), o.participantName = U;
    }
  } else if (l === Ne) {
    if (!o.person?.standardFamilyName || !o.person?.standardGivenName) return { error: iP };
    if (!o.participantName) {
      let h = `${o.person.standardFamilyName.toUpperCase()}, ${o.person.standardGivenName}`;
      o.participantName = h;
    }
  } else if (l && [We, Xr].includes(l)) {
    if (u || (o.individualParticipantIds = []), o.individualParticipantIds?.length) for (let h of o.individualParticipantIds) {
      if (typeof h != "string") return F({ result: { participantId: h, error: z }, stack: t });
      if (!m.includes(h)) return F({ result: { participantId: h, error: Tt }, stack: t });
    }
  } else return { error: _i };
  s.participants.push(o), n || Se({ payload: { tournamentId: s.tournamentId, participants: [o] }, topic: aa });
  let f = { participant: i && ie(o), ...x };
  return ae(f);
}
function Mi({ allowDuplicateParticipantIdPairs: e, returnParticipants: t, tournamentRecord: r, participants: i = [] }) {
  if (!r) return { error: J };
  r.participants || (r.participants = []);
  let n = r.participants.map((d) => d.participantId) || [];
  i.forEach((d) => {
    d.participantId || (d.participantId = je());
  });
  let a = i.filter((d) => !n.includes(d.participantId)), o = i.filter((d) => n.includes(d.participantId)), s = a.filter((d) => d.participantType === Ne), c = a.filter((d) => d.participantType !== Ne), u = s.concat(...c), l = [];
  if (u.length) {
    for (let p of u) {
      let m = en({ allowDuplicateParticipantIdPairs: e, returnParticipant: !0, disableNotice: !0, tournamentRecord: r, participant: p });
      if (m.error) return m;
      m.success && !m.existingParticipant && l.push(m.participant);
    }
    l.length && Se({ topic: aa, payload: { tournamentId: r.tournamentId, participants: l } });
    let d = { participants: t && ie(l), addedCount: l.length, ...x };
    return o.length && Object.assign(d, { notAdded: o, info: xd }), ae(d);
  } else return { info: "No new participants to add", addedCount: 0, ...x };
}
function pR(e) {
  let t = oe(e, [{ [Vt]: !0, [qn]: !0 }]);
  if (t.error) return t;
  let { allowDuplicateParticipantIdPairs: r, entryStatus: i = vi, participantIdPairs: n = [], entryStage: a = re, tournamentRecord: o, drawDefinition: s, event: c, uuids: u } = e;
  if (c.eventType !== Ke) return { error: fn };
  let l = [], d = /* @__PURE__ */ new Map();
  for (let P of o.participants ?? []) {
    let { participantType: v, participantId: D, person: y, individualParticipantIds: w } = P;
    v === Ne && y?.sex ? d.set(D, y.sex) : v === De && w && l.push(w);
  }
  let p = n.filter((P) => {
    if (P.length !== 2) return !0;
    if (!c.gender || c.gender === "ANY") return !1;
    if (!d.has(P[0]) || !d.has(P[1])) return !0;
    let v = P.map((y) => d.get(y)), D = c.gender === Ye && (v[0] !== Ye || v[1] !== Ye) || c.gender === at && (v[0] !== at || v[1] !== at);
    return c.gender === vr && (v.sort(Dp), (v[0] !== at || v[1] !== Ye) && (D = !0)), D;
  });
  if (p.length) return { error: _r, invalidParticipantIdPairs: p };
  let m = n.map((P) => ({ participantId: u?.pop() ?? je(), participantRole: rr, individualParticipantIds: P, participantType: De })), f = r ? m : m.filter((P) => !l.find((v) => Pt(v, P.individualParticipantIds).length === 2)), h, g = [];
  if (f) {
    let P = Mi({ allowDuplicateParticipantIdPairs: r, participants: f, returnParticipants: !0, tournamentRecord: o });
    if (P.error) return P;
    g = P.participants || [], h = P.info;
  }
  let I = n.map((P) => {
    let v = g.find((y) => Pt(y.individualParticipantIds, P).length === 2);
    if (v) return v;
    let { participant: D } = bi({ tournamentRecord: o, participantIds: P });
    return D;
  }).map((P) => P.participantId), U = Hi({ participantIds: I, tournamentRecord: o, drawDefinition: s, entryStatus: i, entryStage: a, event: c });
  f.length && Se({ payload: { participants: f }, topic: aa });
  let S = f.map(Re);
  return { ...U, info: h, newParticipantIds: S };
}
function mR({ entryStatus: e = kr, unpairedParticipantIds: t = [], participantIdPairs: r = [], entryStage: i = re, tournamentRecord: n, event: a }) {
  if (!n) return { error: J };
  if (!a) return { error: st };
  let o = n.participants ?? [], s = o.filter((h) => h.participantType === Ne).map((h) => h.participantId), c = t.concat(...r).flat(1 / 0).filter((h) => !s.includes(h));
  if (c.length) return { error: _r, invalidParticipantIds: c };
  let u = r.filter((h) => h.length !== 2);
  if (u.length) return { error: _r, invalidParticipantIdPairs: u };
  let l = o.filter((h) => h.participantType === De).map((h) => h.individualParticipantIds), d = r.filter((h) => !l.find((g) => Pt(g, h).length === 2)).map((h) => ({ participantType: De, participantRole: rr, individualParticipantIds: h })), p = Mi({ participants: d, tournamentRecord: n });
  if (p.error) return p;
  let m = r.map((h) => {
    let { participant: g } = bi({ tournamentRecord: n, participantIds: h });
    return g;
  }).map((h) => ({ participantId: h, entryStatus: e, entryStage: i })), f = t.map((h) => ({ entryStatus: di, participantId: h, entryStage: i }));
  return a.entries = (a.entries ?? []).filter((h) => h.entryStage === i), a.entries = a.entries.concat(...m, ...f), { ...x };
}
var fR = {};
Me(fR, { addDrawDefinition: () => Ul, addEvent: () => dc, addFlight: () => mm, assignSeedPositions: () => MR, attachFlightProfile: () => CU, categoryCanContain: () => vu, deleteDrawDefinitions: () => lm, deleteEvents: () => NR, deleteFlightAndFlightDraw: () => TR, deleteFlightProfileAndFlightDraws: () => yR, generate: () => hR, generateEventsFromTieFormat: () => IR, getCategoryAgeDetails: () => Uo, getEvent: () => DU, getEventProperties: () => vU, getEventStructures: () => Mp, getEventTimeItem: () => Cu, getEvents: () => PU, getFlightProfile: () => wt, getScaledEntries: () => Zo, modifyEvent: () => ER, modifyEventMatchUpFormatTiming: () => vR, modifyPairAssignment: () => bR, mutate: () => UR, query: () => nR, refreshEventDrawOrder: () => AU, removeEventMatchUpFormatTiming: () => dm, removeScaleValues: () => OU, removeSeeding: () => RR, setEventDates: () => NU, setEventDisplay: () => pm, setEventEndDate: () => RU, setEventStartDate: () => MU, updateDrawIdsOrder: () => EU, validateCategory: () => jc });
var hR = {};
Me(hR, { generateEventsFromTieFormat: () => IR });
function L_({ tournamentId: e, event: t }) {
  return t ? (Se({ payload: { tournamentId: e, event: t }, key: t.eventId, topic: lw }), { ...x }) : { error: st };
}
var __ = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7@7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_D3", winCriteria: { valueGoal: 5 } }, B_ = { collectionDefinitions: [{ collectionName: "Doubles", collectionValue: 1, matchUpCount: 3, matchUpFormat: "SET1-S:6/TB7", matchUpType: "DOUBLES" }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_DEFAULT", winCriteria: { valueGoal: 5 } }, V_ = { collectionDefinitions: [{ collectionName: "Doubles", matchUpCount: 3, matchUpFormat: "SET1-S:8/TB7", matchUpType: "DOUBLES", matchUpValue: 1 }, { collectionName: "Singles", matchUpCount: 6, matchUpFormat: "SET3-S:6/TB7", matchUpType: "SINGLES", matchUpValue: 1 }], tieFormatName: "COLLEGE_JUCO", winCriteria: { valueGoal: 5 } }, gR = { COLLEGE_D3: __, COLLEGE_DEFAULT: B_, COLLEGE_JUCO: V_, DOMINANT_DUO: iD, DOMINANT_DUO_MIXED: JP, LAVER_CUP: cD, TEAM_DOUBLES_3_AGGREGATION: zP, TIME_TENNIS_DUAL: ZP, TIME_TENNIS_PRO_CIRCUIT: XP, USTA_BREWER_CUP: eD, USTA_OZAKI_CUP: tD, USTA_COLLEGE: nD, USTA_GOLD_TEAM_CHALLENGE: HP, USTA_INTERSECTIONAL: QP, USTA_LEVEL_1: aD, USTA_SECTION_BATTLE: KP, USTA_SOUTHERN_LEVEL_5: YP, USTA_TOC: uD, USTA_WTT_ITT: oD, USTA_ZONAL: sD };
function dc({ suppressNotifications: e, tournamentRecord: t, internalUse: r, event: i }) {
  if (!t) return { error: J };
  if (t.events || (t.events = []), !i) return { error: st };
  let { startDate: n, endDate: a } = t;
  if (!r && (i.entries?.length || i.drawDefinitions?.length)) {
    let s = ae({ drawDefinitions: !!i.drawDefinitions?.length, entries: !!i.entries?.length });
    return { info: "entries/drawDefinitions cannot exist", error: z, context: s };
  }
  let o = { eventType: So, drawDefinitions: [], entries: [], startDate: n, endDate: a, ...i };
  if (i.eventType === jr) {
    if (i.tieFormat) {
      let s = wr({ tieFormat: i.tieFormat });
      if (s.error) return s;
    } else if (i.tieFormatName) {
      if (!gR[i.tieFormatName]) return { context: { tieFormatName: i.tieFormatName }, error: z };
      let s = kn({ isMock: t?.isMock, namedFormat: i.tieFormatName, event: i });
      o.tieFormat = s;
    }
  }
  if (o.eventId || (o.eventId = je()), t.events.reduce((s, c) => s || c.eventId === o.eventId, void 0)) return { error: Ov };
  {
    let s = o;
    if (t.events.push(s), !e) {
      let { topics: c } = ci();
      if (c.includes(cp)) {
        let d = Rn({ event: i }).matchUps ?? [];
        oa({ tournamentId: t?.tournamentId, eventId: i.eventId, matchUps: d });
      }
      let { drawDefinitions: u, ...l } = i;
      for (let d of u || []) Eu({ drawDefinition: d });
      L_({ tournamentId: t?.tournamentId, event: l });
    }
    return { ...x, event: o };
  }
}
function IR(e) {
  let t = oe(e, [{ [Ms]: { [Jd]: !0, [FD]: !0 } }, { [Vt]: !0 }]);
  if (t.error) return t;
  let r = e.tieFormat || kn({ namedFormat: e.tieFormatName }), i = e.uuids || [WP(r.collectionDefinitions.length)], n = { [Ye]: [], [at]: [] };
  if (e.addEntriesFromTeams) {
    let o = e.tournamentRecord.participants?.filter((s) => s.participantType === Pr)?.flatMap((s) => s.individualParticipantIds ?? []);
    for (let s of e.tournamentRecord.participants ?? []) if (o?.includes(s.participantId)) {
      let c = s.person?.sex;
      c && [Ye, at].includes(c) && n[c].push(s.participantId);
    }
  }
  let a = [];
  for (let o of r.collectionDefinitions ?? []) {
    let s = i?.pop()?.toString() || je(), c = o.matchUpType, u = o.gender, l = { matchUpFormat: o.matchUpFormat, eventName: o.collectionName, category: o.category, gender: u, eventType: c, eventId: s };
    if (e.addEntriesFromTeams) {
      let d = c === xn ? di : e.entryStatus || kr, p = u === vr ? [...n[Ye], ...n[at]] : n[u] ?? [];
      if (p.length) {
        let m = Hi({ participantIds: p, entryStatus: d, event: l });
        if (m.error) return m;
      }
    }
    if (a.push(l), e.addEvents !== !1) {
      let d = dc({ internalUse: !0, tournamentRecord: e.tournamentRecord, event: l });
      if (d.error) return d;
    }
  }
  return { ...x, events: a };
}
var UR = {};
Me(UR, { addDrawDefinition: () => Ul, addEvent: () => dc, addFlight: () => mm, assignSeedPositions: () => MR, attachFlightProfile: () => CU, deleteDrawDefinitions: () => lm, deleteEvents: () => NR, deleteFlightAndFlightDraw: () => TR, deleteFlightProfileAndFlightDraws: () => yR, modifyEvent: () => ER, modifyEventMatchUpFormatTiming: () => vR, modifyPairAssignment: () => bR, refreshEventDrawOrder: () => AU, removeEventMatchUpFormatTiming: () => dm, removeScaleValues: () => OU, removeSeeding: () => RR, setEventDates: () => NU, setEventDisplay: () => pm, setEventEndDate: () => RU, setEventStartDate: () => MU, updateDrawIdsOrder: () => EU, validateCategory: () => jc });
function pc({ removePriorValues: e = !0, status: t = Jr, statusObject: r, event: i }) {
  if (!xe(r)) return { error: z };
  let n = mi({ event: i, status: t }), a = `${ga}.${Ia}`, o = { itemValue: { [t]: { ...n, ...r } }, itemType: a };
  return Jo({ timeItem: o, removePriorValues: e, event: i });
}
function mc(e) {
  let t = oe(e, [{ [Vt]: !0, [qn]: !0 }, { eventDataParams: !1, [Mr]: Nr }]);
  if (t.error) return t;
  let { includePositionAssignments: r, removePriorValues: i, tournamentRecord: n, status: a = Jr, event: o, drawIdsToRemove: s, drawIdsToAdd: c } = e, { appliedPolicies: u } = _e({ tournamentRecord: n, event: o }), l = { ...u, ...e.policyDefinitions }, d = o?.drawDefinitions?.map(({ drawId: v }) => v) ?? [], p = e.drawDetails ? Object.keys(e.drawDetails) : [], m = p.length ? [] : e.drawIds, f = (c ?? []).concat(...s ?? [], ...m ?? [], ...p), h = f.filter((v) => !d.includes(v));
  if (h.length) return F({ result: { error: zr }, context: { invalidDrawIds: h } });
  let g = mi({ event: o, status: a }), I = Object.keys(g?.drawDetails || {}).filter((v) => d.includes(v)).reduce((v, D) => (v[D] = g.drawDetails[D], v), {});
  for (let v of d) if ((!f.length || f.includes(v)) && (s?.includes(v) || m?.length && !m.includes(v) ? I[v] = { ...I[v], publishingDetail: { published: !1 } } : (c?.includes(v) || m?.includes(v) || !m?.length) && (I[v] = { ...I[v], publishingDetail: { published: !0 } })), e.drawDetails?.[v]) {
    let D = e.drawDetails[v], y = D.structureDetails ?? I[v].structureDetails, w = D.stageDetails ?? I[v].stageDetails ?? {}, { structureIdsToRemove: b = [], structureIdsToAdd: T = [], publishingDetail: R = {}, stagesToRemove: M = [], stagesToAdd: E = [] } = D;
    if ((T || E) && (R.published = !0), I[v] = { publishingDetail: R, structureDetails: y, stageDetails: w }, T.length || b.length) {
      let N = (o?.drawDefinitions?.find((k) => k.drawId === v)?.structures ?? []).map(({ structureId: k }) => k), C = (T ?? []).concat(b ?? []).filter((k) => !N.includes(k));
      if (C.length) return F({ result: { error: mt }, context: { invalidStructureIds: C } });
      y = y ?? {};
      for (let k of N) b.includes(k) ? y[k] = { published: !1 } : y[k] = { published: !0 };
      I[v].structureDetails = y;
    }
    let A = (o?.drawDefinitions?.find((N) => N.drawId === v)?.structures ?? []).map(({ stage: N }) => N);
    if (E.length) {
      for (let N of E) w[N] = { published: !0 };
      for (let N of A) w[N] || (w[N] = { published: !1 });
    }
    if (E.length || M.length) {
      for (let N of M) w[N] = { published: !1 };
      for (let N of A) w[N] || (w[N] = { published: !0 });
    }
    (E.length || M.length) && (I[v].stageDetails = w);
  }
  pc({ statusObject: { drawDetails: I }, removePriorValues: i, status: a, event: o });
  let { topics: U } = ci(), S = U.includes(vf), P = S || e.returnEventData ? Zp({ includePositionAssignments: r, ...e.eventDataParams, usePublishState: !0, tournamentRecord: n, policyDefinitions: l, event: o })?.eventData : void 0;
  return S && Se({ payload: { eventData: P, tournamentId: n.tournamentId }, topic: vf }), { ...x, eventData: P };
}
var SR = "deleteDrawDefinitions", Wf = "autoSchedulingAudit", $l = "deleteEvents", j_ = { AUTO_SCHEDULING_AUDIT: Wf, DELETE_EVENTS: $l, DELETE_DRAW_DEFINITIONS: SR };
function lm(e) {
  if (!e.tournamentRecord) return { error: J };
  let t = "deleteDrawDefinitions", r = e.drawIds ?? [], i = e.event, { autoPublish: n = !0, tournamentRecord: a, auditData: o, eventId: s, force: c } = e, { appliedPolicies: u } = _e({ tournamentRecord: a, event: i }), l = { ...u, ...e.policyDefinitions }, d = Array.isArray(r) ? r[0] : void 0;
  if (!i) {
    let w = br({ tournamentRecord: a, eventId: s, drawId: d });
    if (w.error) return w;
    i = w.event;
  }
  let p = [], m = [], f = [];
  if (!i?.drawDefinitions) return F({ info: "event has no drawDefinition", result: { ...x }, stack: t });
  let h = i.drawDefinitions.map(({ drawId: w }) => w);
  if (r.length || (r = h), r = r.filter((w) => h.includes(w)), !r.length) return F({ info: "nothing to do; no matching drawIds in event.", result: { ...x }, stack: t });
  let g = ie(wt({ event: i }).flightProfile, !1, !0), I = ({ participantId: w, drawPosition: b, qualifier: T, bye: R }) => ({ bye: R, qualifier: T, drawPosition: b, participantId: w }), U = c ?? u?.[oi]?.allowDeletionWithScoresPresent?.drawDefinitions, S = mi({ event: i }) ?? {}, P = S.drawIds ?? (S.drawDetails && Object.keys(S.drawDetails)) ?? [], v, D = [], y = i.drawDefinitions.filter((w) => {
    if (r.includes(w.drawId)) {
      let b = hr({ event: i, drawDefinition: w })?.matchUps ?? [];
      if (b.some(({ score: _ }) => Bt({ score: _ })) && !U) return D.push(w.drawId), !0;
      let { drawId: T, drawType: R, drawName: M } = w, E = g?.flights?.find((_) => _.drawId === w.drawId);
      E && (E.drawEntries = E.drawEntries?.filter((_) => Ni.includes(_.entryStatus))), P.includes(T) && (P = P.filter((_) => _ !== T), v = !0);
      let A = Ti({ stageSequence: 1, drawDefinition: w, stage: re })?.structures?.[0], N = (A ? ru({ structureId: A.structureId, tournamentRecord: a, drawDefinition: w }) : void 0)?.positionAssignments?.map(I), C = Ti({ stage: se, drawDefinition: w })?.structures, k = C?.length ? C.map((_) => {
        let B = _.stageSequence;
        return { positionAssignments: ru({ structureId: _.structureId, tournamentRecord: a, drawDefinition: w })?.positionAssignments.map(I), stageSequence: B };
      }) : void 0, O = { action: SR, payload: { drawDefinitions: [w], eventId: s ?? i?.eventId, auditData: o } };
      f.push(O), p.push(ae({ tournamentId: a.tournamentId, eventId: s ?? i?.eventId, qualifyingPositionAssignments: k, positionAssignments: N, auditData: o, drawType: R, drawName: M, drawId: T })), b?.forEach(({ matchUpId: _ }) => m.push(_));
    }
    return !r.includes(w.drawId);
  });
  if (D.length && !c) return F({ context: { drawIdsWithScoresPresent: D }, result: { error: Iu }, stack: t });
  if (i.drawDefinitions = y, g && ma({ event: i, extension: { name: wi, value: g } }), fl({ tournamentRecord: a }), v) {
    let w = {};
    for (let T of P) w[T] = S.drawDetails?.[T] ?? { published: !0 };
    let b = pc({ statusObject: { drawDetails: w }, event: i });
    if (b.error) return { error: b.error };
  }
  if (f.length) if (jd(Cn)) {
    let w = a.tournamentId;
    Se({ topic: Cn, payload: { tournamentId: w, detail: f } });
    let b = (li({ element: i, itemType: Ta })?.timeItem?.itemValue || 0) + 1;
    an({ element: i, timeItem: { itemType: Ta, itemValue: b }, removePriorValues: !0 });
  } else G_({ appliedPolicies: u, event: i, deletedDrawsDetail: p, auditData: o });
  if (m.length && bn({ tournamentId: a?.tournamentId, matchUpIds: m }), r.forEach((w) => B1({ drawId: w })), n && v) {
    let w = mc({ ...e.eventDataParams, drawIdsToRemove: r, policyDefinitions: l, tournamentRecord: a, event: i });
    if (w.error) return { ...x, info: w.error };
  }
  return { ...x };
}
function G_({ appliedPolicies: e, event: t, deletedDrawsDetail: r, auditData: i }) {
  if (e?.audit?.[Ta] === !1) return;
  let { extension: n } = we({ name: Ta, element: t }), a = { ...i, deletedDrawsDetail: r }, o = { value: Array.isArray(n?.value) ? n?.value.concat(a) : [a], name: Ta };
  Be({ element: t, extension: o });
}
function yR({ autoPublish: e = !0, tournamentRecord: t, auditData: r, event: i, force: n }) {
  if (!t) return { error: J };
  if (!i) return { error: st };
  let { flightProfile: a } = wt({ event: i });
  if (a) {
    let o = a.flights?.map(({ drawId: c }) => c).filter(Boolean), s = lm({ eventId: i.eventId, tournamentRecord: t, autoPublish: e, auditData: r, drawIds: o, event: i, force: n });
    return s.error ? s : np({ event: i, name: wi });
  }
  return { ...x };
}
function bU(e) {
  let { matchUpFormat: t, recoveryTimes: r, averageTimes: i, tournamentId: n, eventId: a } = e, o = e?.tournamentRecords ?? (e?.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord }) ?? {};
  if (!Object.keys(o).length) return { error: ht };
  let s = Object.keys(o).filter((u) => !n || n === u);
  if (n && !s.includes(n)) return { error: z };
  let c;
  for (let u of s) {
    let l = o[u], { event: d } = br({ tournamentRecord: l, eventId: a });
    a && d && (c = !0);
    let p = $_({ tournamentRecord: l, event: d, matchUpFormat: t, averageTimes: i, recoveryTimes: r });
    if (p.error) return p;
  }
  return !a || c ? { ...x } : { error: ni };
}
function $_({ tournamentRecord: e, recoveryTimes: t, matchUpFormat: r, averageTimes: i, event: n }) {
  if (!e) return { error: J };
  if (i && !Array.isArray(i)) return { error: z };
  if (t && !Array.isArray(t)) return { error: z };
  let a = Ln;
  if (n) {
    let { extension: o } = we({ element: n, name: a }), s = o?.value || {}, c = Ty({ ...s, matchUpFormat: r, averageTimes: i, recoveryTimes: t });
    Be({ element: n, extension: { name: a, value: c } });
  } else {
    let { extension: o } = we({ element: e, name: a }), s = o?.value || {}, c = Ty({ ...s, matchUpFormat: r, averageTimes: i, recoveryTimes: t });
    Be({ extension: { name: a, value: c }, element: e });
  }
  return { ...x };
}
function Ty(e) {
  let { matchUpRecoveryTimes: t = [], matchUpAverageTimes: r = [], matchUpFormat: i } = e, { averageTimes: n, recoveryTimes: a } = e;
  n = (n || []).filter((c) => c?.categoryNames?.length || c?.categoryTypes?.length);
  let o = n?.length && r.map((c) => c?.matchUpFormatCodes.includes(i) ? { ...c, matchUpFormatCodes: c.matchUpFormatCodes?.filter((u) => u !== i) } : c).filter(({ matchUpFormatCodes: c }) => c?.length).concat({ matchUpFormatCodes: [i], averageTimes: n });
  a = (a || []).filter((c) => c?.categoryNames?.length || c?.categoryTypes?.length);
  let s = a?.length && t.map((c) => c?.matchUpFormatCodes.includes(i) ? { ...c, matchUpFormatCodes: c.matchUpFormatCodes?.filter((u) => u !== i) } : c).filter(({ matchUpFormatCodes: c, averageTimes: u }) => c?.length || u).concat({ matchUpFormatCodes: [i], recoveryTimes: a });
  return { matchUpAverageTimes: o?.length && o || r, matchUpRecoveryTimes: s?.length && s || t };
}
function vR(e) {
  let { tournamentRecord: t, recoveryMinutes: r, averageMinutes: i, matchUpFormat: n, categoryType: a, eventId: o, event: s } = e;
  if (!t) return { error: J };
  if (!Vr({ matchUpFormat: n })) return { error: z };
  if (!s) return { error: st };
  let { averageTimes: c = [], recoveryTimes: u = [] } = om({ tournamentRecord: t, matchUpFormat: n, event: s }), l = s.category, d = l?.categoryName || l?.ageCategoryCode || s?.eventId, p = { categoryNames: [d], minutes: {} }, m = { categoryNames: [d], minutes: {} }, f = (S) => {
    if (S.categoryTypes?.includes(a) && console.log("encountered:", { categoryType: a }), !(S.categoryNames?.includes(d) && (S.categoryNames = S.categoryNames.filter((P) => P !== d), p = { minutes: S.minutes, categoryNames: [d] }, !S.categoryNames.length))) return S;
  }, h = i && !isNaN(pe(i)), g = r && !isNaN(pe(r)), I = c.map(f).filter((S) => S?.categoryNames?.length), U = u.map(f).filter((S) => S?.categoryNames?.length);
  return h && (Object.assign(p.minutes, { [s?.eventType || Xe]: i }), I.push(p)), g && (Object.assign(m.minutes, { [s?.eventType || Xe]: r }), U.push(m)), !h && !g ? { error: z } : bU({ averageTimes: h && I, recoveryTimes: g && U, tournamentRecord: t, matchUpFormat: n, eventId: o });
}
function dm(e) {
  if (e.event) return by({ event: e.event });
  {
    e.tournamentRecord && !e.tournamentRecords && (e.tournamentRecords = { [e.tournamentRecord.tournamentId]: e.tournamentRecord });
    let t = oe(e, [{ [ur]: !0, [jD]: !0 }]);
    if (t.error) return t;
    let { tournamentRecords: r, eventId: i } = e;
    for (let n of Object.values(r ?? {})) {
      let { event: a } = br({ tournamentRecord: n, eventId: i });
      if (a) return by({ event: a });
    }
  }
  return { error: ni };
}
function by({ event: e }) {
  return np({ event: e, name: Ln });
}
var PR = { MON: "MON", TUE: "TUE", WED: "WED", THU: "THU", FRI: "FRI", SAT: "SAT", SUN: "SUN" };
function DR(e) {
  return !Array.isArray(e) || Ue(e).length !== e.length ? !1 : e.every((t) => Object.keys(PR).includes(t));
}
function MU({ tournamentRecord: e, event: t, startDate: r }) {
  if (!e) return { error: J };
  if (!t) return { error: st };
  if (!Yi.test(r)) return { error: Ht };
  let i = wR(e);
  if (i.error) return i;
  let { tournamentStartDate: n, tournamentEndDate: a } = i, o = new Date(ve(r)).getTime();
  if (!n || !a || o < n || o > a) return { error: Ht };
  let s = t.endDate && new Date(ve(t.endDate)).getTime();
  return s && o > s && (t.endDate = r), t.startDate = r, { ...x };
}
function RU(e) {
  let { tournamentRecord: t, event: r, endDate: i } = e;
  if (!t) return { error: J };
  if (!r) return { error: st };
  if (!Yi.test(i)) return { error: Ht };
  let n = wR(t);
  if (n.error) return n;
  let { tournamentStartDate: a, tournamentEndDate: o } = n, s = new Date(ve(i)).getTime();
  if (!a || !o || s < a || s > o) return { error: Ht };
  let c = r.startDate && new Date(ve(r.startDate)).getTime();
  return c && s < c && (r.startDate = i), r.endDate = i, { ...x };
}
function NU(e) {
  let t = oe(e, [{ tournamentRecord: !0, event: !0 }, { [tr]: (c) => Yi.test(c), [Kr]: Ht, startDate: !1, endDate: !1 }, { [tr]: (c) => c.filter(Boolean).every((u) => Yi.test(u)), [Kr]: Ht, activeDates: !1 }, { [tr]: DR, weekdays: !1 }]);
  if (t.error) return t;
  let { tournamentRecord: r, weekdays: i, event: n, startDate: a, endDate: o } = e, s = e.activeDates?.filter(Boolean);
  if (a && o) {
    let c = new Date(ve(a)).getTime(), u = new Date(ve(o)).getTime();
    if (c > u) return { error: z };
  }
  if (s) {
    let c = a || r.startDate, u = o || r.endDate, l = !c || s.every((p) => new Date(p) >= new Date(c)), d = !u || s.every((p) => new Date(p) <= new Date(u));
    if (!l || !d) return { error: Ht };
  }
  if (a) {
    let c = MU({ tournamentRecord: r, event: n, startDate: a });
    if (c.error) return c;
  }
  if (o) {
    let c = RU({ tournamentRecord: r, event: n, endDate: o });
    if (c.error) return c;
  }
  return s && (n.activeDates = s), i && (n.weekdays = i), { ...x };
}
function wR(e) {
  let { startDate: t, endDate: r } = e;
  return !Yi.test(t) || !Yi.test(r) ? F({ result: { error: zv }, context: { startDate: t, endDate: r } }) : { tournamentStartDate: new Date(ve(t)).getTime(), tournamentEndDate: new Date(ve(r)).getTime() };
}
function EU({ event: e, orderedDrawIdsMap: t }) {
  if (typeof e != "object") return { error: st };
  if (!t) return { error: ue, info: "Missing drawIdsOrderMap" };
  if (typeof t != "object") return { error: z, info: "orderedDrawIdsMap must be an object" };
  let r = Object.values(t);
  if (!r.every((n) => !isNaN(n))) return { error: z, info: "drawOrder must be numeric" };
  if (Ue(r).length !== r.length) return { error: z, info: "drawOrder values must be unique" };
  if (e.drawDefinitions?.length) {
    let n = (e.drawDefinitions || []).map(({ drawId: o }) => o), a = Object.keys(t);
    if (a?.length && Pt(n, a).length !== n.length) return { error: z, info: "Missing drawIds" };
    e.drawDefinitions.forEach((o) => {
      o.drawOrder = t[o.drawId];
    });
  }
  let { flightProfile: i } = wt({ event: e });
  return i?.flights?.forEach((n) => {
    n.flightNumber = t[n.drawId];
  }), { ...x };
}
function AU({ tournamentRecord: e, event: t }) {
  if (!e) return { error: J };
  if (!t) return { error: st };
  let { flightProfile: r } = wt({ event: t }), i = r?.flights && Object.assign({}, ...r.flights.sort((n, a) => n.flightNumber - a.flightNumber).map((n, a) => ({ [n.drawId]: a + 1 }))) || t.drawDefinitions?.length && Object.assign({}, ...t.drawDefinitions.sort((n, a) => n.drawOrder - a.drawOrder).map((n, a) => ({ [n.drawId]: a + 1 }))) || void 0;
  return i ? EU({ event: t, orderedDrawIdsMap: i }) : { ...x };
}
function TR({ autoPublish: e = !0, tournamentRecord: t, auditData: r, drawId: i, event: n, force: a }) {
  if (!t) return { error: J };
  if (!i) return { error: Vi };
  if (!n) return { error: st };
  let { flightProfile: o } = wt({ event: n });
  if (o && o.flights?.find((s) => s.drawId === i)) {
    let s = o.flights.filter((u) => u.drawId !== i), c = { name: wi, value: { ...o, flights: s } };
    ma({ event: n, extension: c });
  }
  if (n.drawDefinitions?.find((s) => s.drawId === i)) {
    let s = lm({ drawIds: [i], eventId: n.eventId, tournamentRecord: t, autoPublish: e, auditData: r, event: n, force: a });
    if (s.error) return s;
  }
  return AU({ tournamentRecord: t, event: n });
}
function bR(e) {
  let t = oe(e, [{ [qn]: !0, [Vt]: !0, [Jh]: !1 }, { replacementIndividualParticipantId: !0, [tr]: (g) => dt(g), existingIndividualParticipantId: !0, [yi]: Ft, participantId: !0 }]), { replacementIndividualParticipantId: r, existingIndividualParticipantId: i, tournamentRecord: n, drawDefinition: a, participantId: o, event: s, uuids: c } = e;
  if (t.error) return t;
  if (s?.eventType !== ai) return { error: fn };
  if (!(s?.entries?.filter(({ entryStatus: g }) => [di, Xa].includes(g)).map(({ participantId: g }) => g) || []).includes(r)) return { error: Li };
  let u = (n.participants || []).find((g) => g.participantId === o);
  if (u?.participantType !== De) return { error: Eo, participant: u };
  let l = u.individualParticipantIds, d = [r, ...l.filter((g) => g !== i)], { participant: p } = bi({ participantIds: d, tournamentRecord: n }), m;
  if (p) m = p.participantId;
  else {
    let g = { participantId: c?.pop(), participantRole: rr, individualParticipantIds: d, participantType: De }, I = en({ participant: g, returnParticipant: !0, tournamentRecord: n });
    if (I.error) return I;
    m = I.participant.participantId;
  }
  let { flightProfile: f } = wt({ event: s });
  if (a) {
    let g = f?.flights?.find(({ drawId: I }) => I === a.drawId);
    g && (g.drawEntries = g.drawEntries.map((I) => I.participantId === o ? { ...I, participantId: m } : I)), a.entries = a.entries.map((I) => I.participantId === o ? { ...I, participantId: m } : I);
    for (let I of a.structures || []) if (I.structures) {
      I.positionAssignments = void 0;
      for (let U of I.structures) U.positionAssignments = U.positionAssignments.map((S) => S.participantId === o ? { ...S, participantId: m } : S);
    } else I.positionAssignments && (I.positionAssignments = I.positionAssignments.map((U) => U.participantId === o ? { ...U, participantId: m } : U));
  }
  s.entries = s.entries.map((g) => g.participantId === o && { ...g, participantId: m } || g.participantId === r && { ...g, participantId: i } || g);
  let h = n.events.some(({ entries: g, eventId: I, drawDefinitions: U }) => s.eventId === I ? U.some(({ drawId: S, entries: P }) => S === a?.drawId ? !1 : P?.find((v) => v.participantId === o)) : g?.find((S) => S.participantId === o));
  if (!h) {
    let g = Yo({ addIndividualParticipantsToEvents: !1, participantIds: [o], tournamentRecord: n });
    if (g.error) return g;
  }
  return { ...x, participantOtherEntries: h, newPairParticipantId: m };
}
function Ul(e) {
  let { flight: t, suppressNotifications: r, modifyEventEntries: i, existingDrawCount: n, allowReplacement: a, checkEntryStatus: o, tournamentRecord: s, drawDefinition: c, event: u } = e;
  if (!c) return { error: ne };
  if (!u) return { error: st };
  u.drawDefinitions || (u.drawDefinitions = []);
  let { drawId: l, drawName: d, entries: p } = c, { entries: m } = u, f = 0;
  if (n !== void 0 && n !== u.drawDefinitions.length) return { error: z, info: "drawDefintions count mismatch" };
  let { flightProfile: h } = wt({ event: u }), g = t && h?.flights?.find((M) => M.flightNumber === t.flightNumber), I = h?.links?.find((M) => M?.target?.drawId === l)?.source?.drawId;
  if (I && !u.drawDefinitions.find((M) => M.drawId === I)) return F({ result: { error: ne }, info: { sourceDrawId: I } });
  if (g && g.drawId !== c.drawId) return F({ result: { error: co }, info: { relevantFlight: g } });
  let U = p?.every(({ participantId: M, entryStatus: E }) => {
    let A = g?.drawEntries.find((N) => N.participantId === M);
    return !E || A?.entryStatus === E;
  }), S = !o || m && p?.every(({ participantId: M, entryStatus: E, entryStage: A }) => m.find((N) => N.participantId === M && (!N.entryStage || N.entryStage === A))?.entryStatus === E);
  if (g && !U) return F({ result: { error: co }, context: { drawEntriesPresentInFlight: U, matchingEventEntries: S, relevantFlight: g }, info: "Draw entries are not present in flight or do not match entryStatuses" });
  if (i && p?.filter(Boolean).forEach((M) => {
    if (M?.entryStatus && Ni.includes(M?.entryStatus)) {
      let E = m?.filter(Boolean).find((A) => A.participantId === M.participantId);
      E && M.entryStatus && E?.entryStatus !== M.entryStatus && (E.entryStatus = M.entryStatus, f += 1);
    }
  }), m && !S) return F({ result: { info: "Draw entries do not match event entryStatuses", context: { matchingEventEntries: S, eventEntries: m }, error: co } });
  let P = h?.flights?.map(({ flightNumber: M }) => !isNaN(M) && pe(M))?.filter(Boolean) || [], v = u.drawDefinitions.map(({ drawOrder: M }) => M && pe(M))?.filter(Boolean) || [], D = Math.max(0, ...v, ...P) + 1, y = h?.flights?.find((M) => M.drawId === l), w;
  if (y) {
    y.drawName = c.drawName, w = { name: wi, value: { ...h, flights: h.flights } };
    let M = y.flightNumber;
    M && !v.includes(M) ? D = M : y.flightNumber = D;
  } else {
    let M = h?.flights || [];
    M.push({ manuallyAdded: !0, flightNumber: D, drawEntries: p, drawName: d, drawId: l }), w = { name: wi, value: { ...h || {}, flights: M } };
  }
  ma({ event: u, extension: w }), Object.assign(c, { drawOrder: D });
  let b = u.drawDefinitions.find((M) => M.drawId === l), T = s?.tournamentId, R = u.eventId;
  if (b) {
    if (!a) return { error: Dv };
    let M = hr({ drawDefinition: b })?.matchUps?.map($t) ?? [], E = hr({ drawDefinition: c })?.matchUps;
    if (!r) {
      M?.length && bn({ matchUpIds: M, action: "modifyDrawDefinition", tournamentId: T, eventId: R }), E?.length && oa({ matchUps: E, tournamentId: T, eventId: R }), u.drawDefinitions = u.drawDefinitions.map((N) => N.drawId === l ? c : N);
      let A = c.structures?.map(({ structureId: N }) => N);
      tt({ drawDefinition: c, tournamentId: T, structureIds: A, eventId: R });
    }
  } else if (u.drawDefinitions.push(c), !r) {
    let { matchUps: M } = hr({ drawDefinition: c, event: u });
    M && oa({ tournamentId: s?.tournamentId, matchUps: M }), Eu({ drawDefinition: c, tournamentId: T, eventId: R });
  }
  return { ...x, modifiedEventEntryStatusCount: f };
}
function MR(e) {
  let { provisionalPositioning: t, useExistingSeedLimit: r, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, assignments: s, drawId: c, event: u } = e, l = 0;
  if (!s?.length) return { error: uh };
  if (!i) return { error: J };
  if (!c) return { error: Vi };
  let d = si({ provisionalPositioning: t, drawDefinition: n, structureId: o });
  if (d.error) return d;
  let { seedAssignments: p, seedLimit: m } = d, f = Object.assign({}, ...(p ?? []).filter((I) => I.seedNumber).map((I) => ({ [I.seedNumber]: I })));
  s.forEach((I) => {
    let { seedNumber: U } = I;
    m && U <= m && (!r || f[U]) && (f[U] = I);
  });
  let h = Object.values(f), g = h.map((I) => I?.participantId).filter(Boolean);
  if (g.length !== dv(g).length) return { error: wv };
  for (let I of h) {
    let U = ac({ ...I, provisionalPositioning: t, tournamentRecord: i, drawDefinition: n, seedingProfile: a, structureId: o, event: u });
    if (U?.error) return U;
    U?.success && l++;
  }
  return l ? { ...x, modifications: l } : { error: Hs };
}
function CU({ deleteExisting: e, event: t, flightProfile: r }) {
  let i = "attachFlightProfile";
  if (!r) return F({ result: { error: ue }, stack: i });
  if (!t) return F({ result: { error: st }, stack: i });
  let { flightProfile: n } = wt({ event: t });
  return n && !e ? F({ result: { error: Mh }, stack: i }) : t.drawDefinitions?.length ? F({ result: { error: Sv }, stack: i }) : (ma({ event: t, extension: { name: wi, value: r } }), { flightProfile: ie(r, !1, !0), ...x });
}
function q_({ tournamentRecord: e, scaleAttributes: t, participantIds: r }) {
  if (!e) return { error: J };
  if (!r) return { error: la };
  if (!t) return { error: ue, info: "scaleAttributes required" };
  let { scaleType: i, eventType: n, scaleName: a } = t, o = [_w, i, n, a].join(".");
  return e.participants?.forEach((s) => {
    r.includes(s.participantId) && s.timeItems && (s.timeItems = s.timeItems.filter((c) => c && c?.itemType !== o));
  }), { ...x };
}
function OU({ tournamentRecord: e, scaleAttributes: t, drawDefinition: r, entryStatuses: i, drawId: n, event: a, stage: o }) {
  if (!a) return { error: st };
  if (i && !Array.isArray(i)) return F({ result: { error: z }, info: La("entryStatus"), stack: "removeScaleValues" });
  let s = a.entries;
  if (n) {
    let { flightProfile: u } = wt({ event: a }), l = u?.flights?.find((d) => d.drawId === n);
    l ? s = l.drawEntries : s = r?.entries;
  }
  let c = (s || []).filter((u) => (!o || !u.entryStage || u.entryStage === o) && (!i || i.includes(u.entryStatus))).map(Re);
  return q_({ tournamentRecord: e, scaleAttributes: t, participantIds: c });
}
function pm({ removePriorValues: e, tournamentRecord: t, displaySettings: r, status: i = Jr, event: n }) {
  if (!t) return F({ result: { error: J } });
  if (!n) return F({ result: { error: st } });
  if (!xe(r)) return F({ result: { error: ue } });
  if (xe(r.draws)) for (let o of Object.keys(r.draws)) {
    let s = r.draws[o].scheduleDetails ?? [];
    if (s.length) {
      let c = [];
      for (let u of s) {
        let l = c.find((d) => wC(d.attributes, u.attributes));
        l?.dates && u.dates ? l.dates.push(...u.dates) : c.push(u);
      }
      r.draws[o].scheduleDetails = c;
    }
  }
  let a = pc({ statusObject: { displaySettings: r }, removePriorValues: e, status: i, event: n });
  return a.error ? a : { ...x };
}
function RR({ tournamentRecord: e, drawDefinition: t, entryStatuses: r, scaleName: i, drawId: n, event: a, stage: o }) {
  if (!e) return { error: J };
  if (!a) return { error: st };
  i = i || a.category?.categoryName || a.category?.ageCategoryCode;
  let s = { eventType: a.eventType, scaleType: un, scaleName: i };
  return OU({ tournamentRecord: e, scaleAttributes: s, drawDefinition: t, entryStatuses: r, drawId: n, event: a, stage: o });
}
function NR(e) {
  let t = oe(e, [{ [Vt]: !0 }, { eventIds: !0, [Mr]: sr }]);
  if (t.error) return t;
  let { removePairParticipants: r, tournamentRecord: i, eventIds: n } = e, a = [], o = [], s = [], c = [];
  if (i.events = (i.events || []).filter((u) => {
    if (n.includes(u.eventId)) {
      let p = { action: $l, payload: { events: [u] } };
      a.push(p), o.push({ tournamentId: i.tournamentId, eventName: u.eventName, eventType: u.eventType, category: u.category, eventId: u.eventId, gender: u.gender });
    }
    let l = u.eventType === ai ? (u.entries || []).map(({ entryStatus: p, participantId: m }) => p !== di && m).filter(Boolean) : [], d = n.includes(u.eventId);
    return d ? c.push(...l) : s.push(...l), !d;
  }), r) {
    let u = c.filter((l) => !s.includes(l));
    i.participants = i.participants.filter(({ participantId: l }) => !u.includes(l));
  }
  if (fl({ tournamentRecord: i }), a.length) if (jd(Cn)) {
    let u = i.tournamentId;
    Se({ topic: Cn, payload: { type: $l, tournamentId: u, detail: a } });
  } else sl({ tournamentRecord: i, timeItem: { itemValue: o, itemType: $l } });
  return { ...x };
}
function ER(e) {
  let t = oe(e, [{ tournamentRecord: !0, eventId: !0, event: !0 }, { eventUpdates: !0, _ofType: Nr }]);
  if (t.error) return t;
  let { eventUpdates: r, event: i } = e, n = "modifyEvent", a = z_(e), o = Y_({ enteredParticipants: a }), { enteredParticipantGenders: s, enteredParticipantTypes: c } = o, u = wt({ event: i })?.flightProfile?.flights, l = !i.drawDefinitions?.length && !u?.length, d = K_({ noFlightsNoDraws: l, enteredParticipantGenders: s, eventUpdates: r, stack: n });
  if (d.error) return d;
  let p = Q_({ enteredParticipantTypes: c, eventUpdates: r, stack: n });
  if (p.error) return p;
  let m = W_({ ...e, ...o, enteredParticipants: a, stack: n });
  if (m.error) return m;
  let f = H_({ ...e, stack: n });
  return f.error ? f : (r.eventType && (i.eventType = r.eventType), r.eventName && (i.eventName = r.eventName), r.gender && (i.gender = r.gender), { ...x });
}
function W_(e) {
  let t = e.eventUpdates?.category;
  if (!t) return { ...x };
  let r = jc({ category: t });
  if (r.error) return r;
  if (e.event.eventType === kt) {
    let i = e.event?.drawDefinitions?.map((o) => Gi(o)) ?? [], n = Gi(e.event), a = (Rn(e)?.matchUps ?? []).map((o) => Gi(o)) ?? [];
    if (![n, ...i, ...a].filter(Boolean).every((o) => o.collectionDefinitions.every((s) => !s.category || vu({ category: e.eventUpdates.category, childCategory: s.category })))) return F({ result: { error: xc }, stack: e.stack });
  }
  if (e.enteredParticipants?.length) {
    let i = e.eventUpdates.startDate || e.event.startDate || e.tournamentRecord.startDate, n = e.eventUpdates.endDate || e.event.endDate || e.tournamentRecord.endDate, a = e.enteredParticipants.map((c) => c.participantType === Ne ? c : c.individualParticpants ?? []).flat(), o = Uo({ category: t, consideredDate: i }), s = Uo({ category: t, consideredDate: n });
    if (o?.ageMinDate || o?.ageMaxDate || s?.ageMinDate || s?.ageMaxDate) for (let c of a) {
      let u = c.person?.birthDate;
      if (!u) return F({ result: { error: $v }, stack: e.stack });
      let l = new Date(u).getTime();
      if (o.ageMinDate || o.ageMaxDate) {
        let d = new Date(o.ageMinDate).getTime(), p = new Date(o.ageMaxDate).getTime();
        if (l < d || l > p) return F({ result: { error: uf }, stack: e.stack });
      }
      if (s.ageMin || s.ageMax) {
        let d = new Date(s.ageMinDate).getTime(), p = new Date(s.ageMaxDate).getTime();
        if (l < d || l > p) return F({ result: { error: uf }, stack: e.stack });
      }
    }
  }
  return { ...x };
}
function H_(e) {
  let { tournamentRecord: t, eventUpdates: r, event: i, stack: n } = e;
  if (r.startDate || r.endDate) {
    let a = NU({ startDate: r.startDate, endDate: r.endDate, tournamentRecord: t, event: i });
    if (a.error) return F({ result: a, stack: n });
  }
  return { ...x };
}
function z_(e) {
  let { tournamentRecord: t, event: r } = e, i = r?.entries?.filter(({ entryStatus: n }) => {
    let a = n;
    return [...Ni, vi].includes(a);
  }).map(({ participantId: n }) => n) ?? [];
  return i ? ft({ participantFilters: { participantIds: i }, withIndividualParticipants: !0, tournamentRecord: t }).participants ?? [] : [];
}
function Y_({ enteredParticipants: e }) {
  let t = [], r = e.reduce((n, a) => {
    let o = a.person?.sex ? [a.person.sex] : a.individualParticpants?.map((s) => s.person?.sex) || [];
    return t.push(...o), n.includes(a.participantType) ? n : n.concat(a.participantType);
  }, []), i = Ue(t);
  return { enteredParticipantTypes: r, enteredParticipantGenders: i };
}
function K_({ noFlightsNoDraws: e, enteredParticipantGenders: t, eventUpdates: r, stack: i }) {
  let n = !t.length || !r.gender || r.gender === "ANY" || t.length === 1 && t[0] === r.gender || e && r.gender === vr;
  return r.gender && !n ? F({ context: { gender: r.gender, validGender: n }, result: { error: wc }, stack: i }) : { ...x };
}
function Q_({ enteredParticipantTypes: e, eventUpdates: t, stack: r }) {
  let i = (e.includes(kt) && [kt] || e.includes(Ne) && [Ki] || e.includes(De) && [ai] || [ai, Ki, kt]).includes(t.eventType ?? "");
  return t.eventType && !i ? F({ context: { participantType: t.eventType, validEventType: i }, result: { error: fn }, stack: r }) : { ...x };
}
function mm({ qualifyingPositions: e, drawEntries: t = [], drawName: r, drawId: i, event: n, stage: a }) {
  let o = "addFlight";
  if (!n) return F({ result: { error: st }, stack: o });
  if (!r) return F({ result: { error: ue }, stack: o });
  if (t?.length) {
    let m = (n.entries ?? []).map(Re), f = t.map(Re);
    if (Pt(f, m).length !== f.length) return F({ result: { error: z }, stack: o });
  }
  let s = wt({ event: n })?.flightProfile, c = s?.flights?.map(({ flightNumber: m }) => !isNaN(m) && pe(m))?.filter(Boolean) || [], u = Math.max(0, ...c) + 1, l = { drawId: i || je(), flightNumber: u, drawEntries: t, drawName: r };
  if (a && (l.stage = a), e && (l.qualifyingPositions = e), (s?.flights || []).find(({ drawId: m }) => m === l.drawId)) return F({ result: { error: PP }, stack: o });
  let d = (s?.flights || []).concat(l), p = { name: wi, value: { ...s || {}, flights: d } };
  return ma({ event: n, extension: p });
}
var AR = {};
Me(AR, { drawMatic: () => HI, garman: () => LR, generateAdHocMatchUps: () => Bp, generateAdHocRounds: () => WI, generateAndPopulatePlayoffStructures: () => yI, generateCourts: () => kU, generateDrawDefinition: () => Il, generateDrawMaticRound: () => xI, generateDrawStructuresAndLinks: () => CI, generateDrawTypeAndModifyDrawDefinition: () => OI, generateFlightProfile: () => Z_, generateLineUps: () => FR, generateQualifyingStructure: () => pI, generateSeedingScaleItems: () => oR, generateStatCrew: () => eB, generateVoluntaryConsolation: () => qb, roundRobinGroups: () => lk });
var X_ = "splitLevelBased", CR = "splitWaterfall", OR = "splitShuttle", J_ = { SPLIT_LEVEL_BASED: X_, SPLIT_WATERFALL: CR, SPLIT_SHUTTLE: OR };
function Z_(e) {
  let { drawNameRoot: t = "Flight", attachFlightProfile: r, tournamentRecord: i, scaleAttributes: n, scaleSortMethod: a, deleteExisting: o, sortDescending: s, drawNames: c = [], flightsCount: u, splitMethod: l, uuids: d = [], event: p, stage: m } = e;
  if (!p) return { error: st };
  let f = p.entries ?? [], { flightProfile: h } = wt({ event: p });
  if (h && r && !o) return { error: Mh };
  let g = e.scaledEntries ?? Zo({ tournamentRecord: i, scaleAttributes: n, scaleSortMethod: a, sortDescending: s, event: p, stage: m }).scaledEntries, I = g.map(Re), U = mr(f.filter(({ participantId: T }) => !I.includes(T)).filter((T) => (!m || !T.entryStage || T.entryStage === m) && (!T.entryStatus || Ja.includes(T.entryStatus)))), S = g.concat(...U), P = S.length, v = Math.ceil(P / u), D = qt(S, v);
  l === CR ? D = ef(S, u) : l === OR && (D = ef(S, u, !0));
  function y(T) {
    return (T || []).map(({ participantId: R, scaleValue: M }) => {
      let E = f.find((A) => A.participantId === R);
      return E?.scaleValue && M && (E.scaleValue = M), E;
    }).sort((R, M) => R.scaleValue - M.scaleValue).map((R, M) => (R.scaleValue && (R.seedNumber = M + 1), R));
  }
  let w = te(0, u).map((T) => {
    let R = T + 1;
    return { flightNumber: R, drawId: d?.pop() ?? je(), drawEntries: y(D[T]), drawName: c?.length && c[T] || `${t} ${R}` };
  }), b = { scaleAttributes: n, splitMethod: l, flights: w };
  if (r) {
    let T = CU({ flightProfile: b, deleteExisting: o, event: p });
    return { splitEntries: Yr() && D || void 0, ...T };
  } else return { flightProfile: b, ...x };
}
function kR({ json: e, tagName: t }) {
  let r = Object.keys(e).filter((a) => Array.isArray(e[a])).map((a) => ({ key: a, value: e[a].filter((o) => typeof o == "object" && Object.keys(o).length === 1) })), i = Object.keys(e).filter((a) => typeof e[a] == "object" && !Array.isArray(e[a])).map((a) => ({ key: a, value: e[a] })), n = Object.keys(e).filter((a) => ["string", "number"].includes(typeof e[a])).map((a) => ({ key: a, value: e[a] }));
  return xR({ tagName: t, attributes: n, childArrays: r, childObjects: i });
}
function xR(e) {
  let { tagName: t, attributes: r = [], childArrays: i = [], childObjects: n } = e, a = `\r
`, o = (m) => {
    let f = Object.keys(m)[0], h = m[f];
    return { key: f, value: h };
  }, s = i?.map(({ key: m, value: f }) => xR({ tagName: m, childObjects: f.map(o) })).join(`\r
`), c = n?.map(({ key: m, value: f }) => kR({ tagName: m, json: f ?? [] })).join(`\r
`), u = r?.map(({ key: m, value: f }) => `${m}="${f}"`).join(" "), l = u ? ` ${u}` : "";
  if (t === "childArray") return c;
  let d = c?.length ? `${a}${c}${a}` : "", p = s?.length ? `${a}${s}${a}` : "";
  return `<${t}${l}>${d}${p}</${t}>`;
}
function eB(e) {
  let t = oe(e, [{ [Vt]: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r } = e, { startDate: i, tournamentId: n, tournamentName: a } = r, { participantMap: o, matchUps: s, mappedMatchUps: c } = ft({ withMatchUps: !0, withEvents: !0, tournamentRecord: r }), u = r.participants.filter((S) => S.participantType === We), l = s?.filter((S) => S.matchUpType === We) ?? [], d = l?.reduce((S, P) => {
    let v = P?.tieMatchUps ?? [];
    return v && [...S, ...v];
  }, []) ?? [], p = s?.filter((S) => S.matchUpType === Xe) ?? [], m = s?.filter((S) => S.matchUpType === Ke) ?? [], f = d.length === p.length + m.length, h = l.length === 1 && f, g = { mappedMatchUps: c, participantMap: o, tournamentName: a, tournamentId: n, tournament: f ? "N" : "Y", startDate: i }, I = [], U = [];
  if (h) {
    let S = l[0], { json: P, xml: v } = My({ teamParticipants: u, teamMatchUp: S, ...g, doubles: m, singles: p });
    U.push(P), I.push(v);
  } else for (let S of l) {
    let P = S?.sides?.map(({ participant: w }) => w?.participantId).filter(Boolean);
    if (P?.length !== 2) continue;
    let v = P.map((w) => w && o?.[w]?.participant), { xml: D, json: y } = My({ doubles: S.tieMatchUps?.filter((w) => w.matchUpType === Ke), singles: S.tieMatchUps?.filter((w) => w.matchUpType === Xe), teamParticipants: v, teamMatchUp: S, ...g });
    U.push(y), I.push(D);
  }
  return { json: U, xml: I, ...x };
}
function My({ teamParticipants: e, mappedMatchUps: t, participantMap: r, tournamentName: i, tournamentId: n, teamMatchUp: a, tournament: o, startDate: s, doubles: c, singles: u }) {
  let l = e?.find((P) => P.participantRoleResponsibilities?.includes("Home")), d = e?.filter((P) => P.participantId !== l?.participantId), p = Ui(s, "/", "MDY"), m = l?.participantName || d?.[1]?.participantName, f = l?.participantId || d?.[1]?.participantId, h = d?.[0]?.participantName, g = d?.[0]?.participantId, I = {}, U = e.map((P) => ({ team: { ...iB({ teamParticipant: P, teamMatchUp: a, uniValues: I, participantMap: r, mappedMatchUps: t, homeid: f }) } })), S = ae({ venue: { tournamentname: o ? i : void 0, neutralgame: l ? "N" : "Y", gameid: n, officials: {}, tournament: o, rules: {}, homename: m, visname: h, homeid: f, visid: g, date: p }, childArray: U, singles_matches: u?.map((P) => Ry({ matchUp: P, homeid: f, uniValues: I })), doubles_matches: c?.map((P) => Ry({ matchUp: P, homeid: f, uniValues: I })) });
  return { json: S, xml: kR({ json: S, tagName: "tngame" }) };
}
function tB({ homeid: e, uniValues: t, participant: r }) {
  if (!r) return {};
  let i = r.individualParticipants?.length === 2, n = i ? Ue(r.individualParticipants?.map((h) => h.teams?.[0]?.participantId)) : [], a = i ? Ue(r.individualParticipants?.map((h) => h.teams?.[0]?.teamId)) : [], o = !i && r.teams?.[0]?.participantId || n?.length === 1 && n[0] || void 0, s = !i && r.teams?.[0]?.teamId || a?.length === 1 && a[0] || o, c = i ? void 0 : r.participantName, u = r.individualParticipants?.[0]?.participantName, l = r.individualParticipants?.[1]?.participantName, d = e && (o === e ? "H" : "V") || "", p = i ? void 0 : t[o][r.participantId], m = t[o][r.individualParticipants?.[0]?.participantId], f = t[o][r.individualParticipants?.[1]?.participantId];
  return ae({ vh: d, uni: p, uni_1: m, uni_2: f, team: s, name: c, name_1: u, name_2: l });
}
function rB({ sets: e, sideNumber: t }) {
  return Object.assign({}, ...e?.map((r) => {
    let { setNumber: i, side1Score: n, side2Score: a, side1TiebreakScore: o, side2TiebreakScore: s } = r, c = `set_${i}`, u = `tie_${i}`, l = t === 1 ? n : a, d = t === 1 ? o : s;
    return { [c]: l, [u]: d };
  }) ?? []);
}
function iB({ teamParticipant: e, teamMatchUp: t, participantMap: r, mappedMatchUps: i, homeid: n, uniValues: a }) {
  let { participantId: o, participantName: s } = e, c = n && (o === n ? "H" : "V") || "", u = r?.[o]?.matchUps, l = u && Object.keys(u), d = t?.sides?.find(({ participant: P }) => P.participantId === o)?.sideNumber, p = t?.score?.sets?.[0]?.[`side${d}Score`] ?? 0;
  a[o] = {};
  let m = { SINGLES: { w: 0, l: 0 }, DOUBLES: { w: 0, l: 0 } }, f = [], h = [], g = 0;
  for (let P of l ?? []) {
    let v = i?.[P], D = v.sides.find(({ participant: w }) => w.participantId === o)?.sideNumber, y = v.score?.sets?.[0]?.[`side${D}Score`] ?? 0;
    g += y;
    for (let w of v.tieMatchUps ?? []) {
      let { matchUpType: b, winningSide: T } = w, R = T && (T === D ? "w" : "l") || "";
      R && (m[b][R] += 1);
      let M = R === "w" ? "1" : "0", E = R === "l" ? "1" : "0";
      if (b === Xe) {
        let A = h.length + 1;
        h.push({ singles_pair: { pair: A, won: M, lost: E, tied: "0" } });
      } else if (b === Ke) {
        let A = f.length + 1;
        f.push({ doubles_pair: { pair: A, won: M, lost: E, tied: "0" } });
      }
    }
  }
  let I = [{ singles: { childArray: h, won: m.SINGLES.w, lost: m.SINGLES.l } }, { doubles: { childArray: f, won: m.DOUBLES.w, lost: m.DOUBLES.l } }], U = [], S = 1;
  for (let P of e.individualParticipantIds) {
    let v = r?.[P];
    if (v) {
      let { participant: D, counters: y } = v, w = { won: y?.DOUBLES?.wins || 0, lost: y?.DOUBLES?.losses || 0 }, b = { won: y?.SINGLES?.wins || 0, lost: y?.SINGLES?.losses || 0 }, { participantName: T, participantId: R } = D;
      a[o][R] = S, U.push({ player: { name: T, uni: S, singles: b, doubles: w } });
    }
    S += 1;
  }
  return { vh: c, id: o, name: s, score: p || g, totals: I, childArray: U };
}
function Ry({ matchUp: e, homeid: t, uniValues: r }) {
  let { collectionPosition: i, orderOfFinish: n, matchUpType: a, sides: o } = e ?? {}, s = o?.map((c) => {
    let { sideNumber: u, participant: l } = c, d = rB({ sets: e.score?.sets, sideNumber: u });
    return { [a === Xe ? "singles_score" : "doubles_score"]: { ...tB({ homeid: t, uniValues: r, participant: l }), ...d } };
  });
  return { [a === Xe ? "singles_match" : "doubles_match"]: { match: i, order: n, childArray: s } };
}
var nB = "DESC", Hf = "DESC", aB = { ASC: "ASC", ASCENDING: "ASC", DESC: nB, DESCENDING: Hf };
function FR(e) {
  let { tieFormat: t } = e, { useDefaultEventRanking: r, tournamentRecord: i, drawDefinition: n, scaleAccessor: a, singlesOnly: o, attach: s, event: c } = e;
  if (c?.eventType !== jr) return { error: fn };
  if (!i) return { error: J };
  if (!t && !n) return { error: zr };
  if (t = t ?? dr({ drawDefinition: n, event: c })?.tieFormat, wr({ tieFormat: t }).error) return { error: cn };
  if (typeof a != "object" && !r) return { error: z, context: { scaleAccessor: a } };
  let u = {}, l = (n?.entries ?? c?.entries ?? []).filter((R) => R?.entryStatus === kr).map(Re), { participants: d = [] } = ft({ withIndividualParticipants: !0, withScaleValues: !0, tournamentRecord: i }), p = d.filter(({ participantId: R }) => l.includes(R)), m = (R) => R === ia ? "rankings" : "ratings", f = c?.category?.categoryName ?? c?.category?.ageCategoryCode, { scaleName: h = f, scaleType: g = ia, sortOrder: I, accessor: U } = a || {}, S = m(g), P = (R, M) => {
    let E = R[S]?.[M];
    if (!E && r && (E = R[S]?.[so]), Array.isArray(E)) {
      let A = E.find((N) => N.scaleName === h)?.scaleValue;
      if (gt(A)) return A;
      if (U && typeof A == "object") return A[U];
    }
    return 0;
  }, v = (R, M, E) => {
    let A = I === Hf ? M : R, N = I === Hf ? R : M;
    return P(A, E) - P(N, E);
  }, D = (R, M) => v(R, M, so), y = (R, M) => v(R, M, Ma), w = [], b = t?.collectionDefinitions ?? [];
  for (let R of p) {
    let M = R.individualParticipants?.sort(D) ?? [], E = o ? M : R.individualParticipants?.sort(y) ?? [], A = {};
    for (let C of b) {
      let k = [], { collectionId: O, matchUpCount: _, matchUpType: B, gender: L } = C, j = bt(so)(B);
      te(0, _).forEach((H) => {
        let G = j ? M : E ?? [], V = H + 1, $ = [];
        te(0, j ? 1 : 2).forEach((q) => {
          let Y = G?.find((W) => {
            let K = L && ([Ye, at].includes(L) && L || L === vr && [Ye, at][q]);
            return (!K || K === W.person?.sex) && !k.includes(W.participantId);
          })?.participantId;
          Y && ($.push(Y), k.push(Y), A[Y] || (A[Y] = []), A[Y].push({ collectionPosition: V, collectionId: O }));
        }), j || w.push($);
      });
    }
    let N = Object.keys(A).map((C) => ({ collectionAssignments: A[C], participantId: C }));
    u[R.participantId] = N;
  }
  let T = [];
  for (let R of w) {
    let { participant: M } = bi({ tournamentParticipants: d, participantIds: R });
    if (!M) {
      let E = { individualParticipantIds: R, participantRole: rr, participantType: De };
      T.push(E);
    }
  }
  if (s) {
    for (; T.length; ) en({ participant: T.pop(), tournamentRecord: i });
    Be({ element: n, extension: { name: Fn, value: u } });
  }
  return { ...x, lineUps: u, participantsToAdd: T };
}
function kU(e) {
  if (!e) return { error: ue };
  let t = oe(e, [{ dates: !1, [tr]: (o) => Array.isArray(o) && o.every(Ar) }, { uuids: !1, [tr]: (o) => Array.isArray(o) && o.every(dt) }, { startTime: !1, endTime: !1, [tr]: Lh }, { idPrefix: !1, namePrefix: !1, [tr]: dt }, { count: !0, [tr]: gt }]);
  if (t.error) return t;
  let { startDate: r, endDate: i } = e.tournamentRecord ?? {}, n = e.dates || r && i && ys(r, i) || [], a = te(1, e.count + 1).map((o) => ae({ courtId: e.uuids?.pop() ?? (e.idPrefix && `${e.idPrefix}-${o}`) ?? je(), courtName: e.courtNames?.pop() ?? (e.namePrefix && `${e.namePrefix} ${o}`), dateAvailability: n.map((s) => ({ startTime: e.startTime ?? "08:00", endTime: e.endTime ?? "20:00", date: s })) }));
  return { ...x, courts: a };
}
var LR = {};
Me(LR, { default: () => cB, garman: () => VR });
function Sl({ court: e, date: t }) {
  let r = t && e.dateAvailability.find((n) => hn(n.date, t)), i = e.dateAvailability.find((n) => !n.date);
  return r || i;
}
function fc(e) {
  let t = oe(e, [{ courtDate: !0, _ofType: Nr }]);
  if (t.error) return t;
  let { includeBookingTypes: r = [], courtDate: i } = e, n = [], a = Nt(i.startTime);
  (i.bookings || []).filter((s) => !s.bookingType || !r.includes(s.bookingType)).sort((s, c) => Xl(s.startTime).localeCompare(Xl(c.startTime))).forEach((s) => {
    let c = { startTime: ct(a.toISOString()), endTime: s.startTime };
    Nt(s.startTime) > a && n.push(c), Nt(s.endTime) > a && (a = Nt(s.endTime));
  });
  let o = { startTime: ct(a.toISOString()), endTime: i.endTime };
  return Nt(i.endTime) > a && n.push(o), { timeSlots: n };
}
function oB({ averageMatchUpMinutes: e, includeBookingTypes: t, periodStartTime: r, periodEndTime: i }) {
  let n = (o) => {
    let { timeSlots: s } = fc({ includeBookingTypes: t, courtDate: o });
    return !!s?.filter(a)?.length;
  };
  function a(o) {
    let s = Nt(o.startTime), c = Nt(o.endTime);
    return s > r || c < i ? !1 : yu(r, c) >= e;
  }
  return { enoughTime: n };
}
function _R(e) {
  let t = oe(e, [{ periodStart: !0, date: !0 }, { courts: !0, _ofType: sr }]);
  if (t.error) return t;
  let { averageMatchUpMinutes: r, includeBookingTypes: i, periodStart: n, date: a } = e, o = e.courts, s = Nt(n), c = Bh(s, r), { enoughTime: u } = oB({ averageMatchUpMinutes: r, includeBookingTypes: i, periodStartTime: s, periodEndTime: c });
  return { availableToScheduleCount: (o?.filter((l) => {
    if (!Array.isArray(l.dateAvailability)) return !1;
    let d = Sl({ date: a, court: l });
    return !!(d && u(d));
  }) || []).length, ...x };
}
function fm(e) {
  let { remainingScheduleTimes: t = [], clearScheduleDates: r, periodLength: i = 30, scheduleDate: n, courts: a = [] } = e, { bookings: o = [] } = e;
  if (!Array.isArray(a) || !a.length) return { error: z, courts: a };
  if (!Array.isArray(o)) return { error: zl };
  if (!Ar(n)) return { error: Ht };
  r && (Array.isArray(r) ? r.includes(n) && (o = []) : o = []);
  let { courtBookings: s, unassignedBookings: c } = o.reduce((p, m) => {
    let { courtId: f } = m;
    return f ? p.courtBookings[f] ? p.courtBookings[f].push(m) : p.courtBookings[f] = [m] : p.unassignedBookings.push(m), p;
  }, { courtBookings: {}, unassignedBookings: [] }), u = a.map((p, m) => {
    let { courtId: f, courtName: h } = p, g = s[f] || [], I = Sl({ date: n, court: p }) || {}, { bookings: U = [], startTime: S, endTime: P, date: v } = I, D = [t[m] && { startTime: S, endTime: t[m] }, ...ie(U, !1, !0), ...g].filter(Boolean);
    return { courtId: f, courtName: h, dateAvailability: { bookings: D, startTime: S, endTime: P, date: v } };
  });
  c.sort((p, m) => Le(p.startTime) - Le(m.startTime));
  let l = () => u.map((p) => {
    let m = p.dateAvailability, { timeSlots: f = [] } = fc({ courtDate: m });
    return { courtName: p.courtName, courtId: p.courtId, timeSlots: f };
  }).flat(), d = [];
  for (let p of c) {
    let { startTime: m, endTime: f, averageMinutes: h, recoveryMinutes: g, matchUpId: I } = p, U = Le(m), S = Le(f), P = l().reduce((v, { courtId: D, courtName: y, timeSlots: w }) => {
      let b;
      return w.find(({ startTime: T, endTime: R }) => {
        b = Le(T) - U;
        let M = U >= Le(T);
        return S <= Le(R) && v.startDifference !== 0 && ((b === 0 || b + i >= 0) && (v.startDifference === void 0 || b < v.startDifference) || M);
      }) ? { courtName: y, courtId: D, startDifference: b } : v;
    }, {});
    if (P.courtId) {
      let v = { averageMinutes: h, recoveryMinutes: g, matchUpId: I, startTime: m, endTime: f };
      d.push(v), u.find(({ courtId: D }) => D === P.courtId)?.dateAvailability.bookings.push(v);
    } else console.log({ unassignedBooking: p });
  }
  return { virtualCourts: u.map(({ courtId: p, courtName: m, dateAvailability: f }) => ({ dateAvailability: [f], courtName: m, courtId: p })), assignedBookings: d };
}
function hm({ averageMatchUpMinutes: e, periodLength: t = 30, recoveryMinutes: r }) {
  let i = (e || 90) + (r || 0);
  return t > i ? i : t || 30;
}
function BR(e) {
  let { startTime: t = "8:00", endTime: r = "20:30", count: i = 10, date: n } = e ?? {};
  return te(0, i).map(() => ({ dateAvailability: [{ date: n, startTime: t, endTime: r }] }));
}
function Ls({ scheduleDate: e, startTime: t, endTime: r, courts: i }) {
  let n = t && "startTime" || r && "endTime" || void 0;
  return i.reduce((a, o) => {
    let s = Sl({ date: e, court: o }), c = n && (s?.[n] || o[n]);
    return c && (!a || t && Le(c) < Le(a) || r && Le(c) > Le(a)) ? c : a;
  }, void 0);
}
function sB({ averageMinutes: e, startTime: t, endTime: r, courts: i, date: n }) {
  t = t || Ls({ courts: i, scheduleDate: n, startTime: !0 }), r = r || Ls({ courts: i, scheduleDate: n, endTime: !0 });
  let a;
  if (t && r) {
    let o = Nt(t), s = Nt(r);
    for (let c of i || []) {
      if (!Array.isArray(c.dateAvailability)) continue;
      let u = Sl({ court: c, date: n }), { timeSlots: l } = fc({ courtDate: u });
      l?.forEach((d) => {
        let p = Nt(d.startTime), m = Nt(d.endTime);
        if (p > s || p < o || m < o) return !1;
        if (yu(p, m) >= e) {
          let f = ct(p.toISOString());
          (!a || f < a) && (a = f);
        }
      });
    }
  }
  return { firstTimeSlotStartTime: a };
}
function xU(e) {
  let t = oe(e, [{ courts: !0, _ofType: sr }]);
  if (t.error) return t;
  let { date: r = Fh(), startTime: i = "08:00", endTime: n = "19:00", periodLength: a, courts: o } = e, { calculateStartTimeFromCourts: s = !0, remainingScheduleTimes: c, averageMatchUpMinutes: u, clearScheduleDates: l, courtsCount: d, bookings: p } = e;
  a = a || hm({ averageMatchUpMinutes: u }), r = ve(r), i = ct(i), n = ct(n);
  let m = 0, f = 0, h = 0, g = 0, I = 0;
  !o && d && (o = BR({ startTime: i, endTime: n, count: d, date: r }));
  let { virtualCourts: U } = fm({ remainingScheduleTimes: c, clearScheduleDates: l, scheduleDate: r, periodLength: a, bookings: p, courts: o }), { firstTimeSlotStartTime: S } = sB({ averageMinutes: u, courts: U, startTime: i, endTime: n, date: r });
  s && S && (i = S ?? i);
  let P = Le(i), v = Le(n) - P, D = Math.floor(v / a), y = te(0, D + 1).map((w) => {
    let b = P + w * a, T = M0(b), R = _R({ courts: U ?? [], averageMatchUpMinutes: u, periodStart: T, date: r });
    if (R.error) return { error: R.error };
    let { availableToScheduleCount: M = 0 } = R, E = M > f ? M - f : 0;
    I += w ? M : 0;
    let A = w ? I / w : M, N = a * A / u, C = w ? N * (w - 1) + A : A, k = M ? f && C - m || E : 0;
    m = C, f = M, h += k;
    let O = pe(h) - g;
    return g += O, { periodStart: T, add: O, availableToScheduleCount: M, newCourts: E, totalMatchUps: g };
  });
  return { scheduleTimes: y.reduce((w, b) => {
    let T = te(0, b.add).map(() => ({ scheduleTime: b.periodStart }));
    return w.concat(...T);
  }, []).flat(), timingProfile: y, totalMatchUps: g };
}
var VR = { getCourtsAvailableAtPeriodStart: _R, generateTimeSlots: fc, getScheduleTimes: xU, courtGenerator: BR }, cB = VR, jR = {};
Me(jR, { isValid: () => Vr, isValidMatchUpFormat: () => Vr, parse: () => Sr, stringify: () => Wd });
var GR = {};
Me(GR, { allCompetitionMatchUps: () => Bi, allDrawMatchUps: () => hr, allEventMatchUps: () => Rn, allTournamentMatchUps: () => Jt, analyzeMatchUp: () => ou, applyLineUps: () => dN, assignMatchUpSideParticipant: () => qR, assignTieMatchUpParticipantId: () => Sd, bulkMatchUpStatusUpdate: () => sN, calculateWinCriteria: () => ts, checkInParticipant: () => LU, checkMatchUpIsComplete: () => ba, checkOutParticipant: () => FU, competitionScheduleMatchUps: () => gl, disableTieAutoCalc: () => nN, drawMatchUps: () => SU, enableTieAutoCalc: () => tN, eventMatchUps: () => sm, filterMatchUps: () => An, findMatchUp: () => nU, getAllDrawMatchUps: () => Et, getAllStructureMatchUps: () => Ve, getCheckedInParticipantIds: () => $o, getCompetitionMatchUps: () => au, getEventMatchUpFormatTiming: () => lU, getHomeParticipantId: () => fU, getMatchUpCompetitiveProfile: () => ju, getMatchUpContextIds: () => hU, getMatchUpDailyLimits: () => um, getMatchUpDailyLimitsUpdate: () => dU, getMatchUpDependencies: () => Ei, getMatchUpFormat: () => gU, getMatchUpFormatTiming: () => Gu, getMatchUpFormatTimingUpdate: () => uU, getMatchUpScheduleDetails: () => yp, getMatchUpType: () => vp, getMatchUpsStats: () => IU, getModifiedMatchUpFormatTiming: () => om, getParticipantResults: () => nl, getPredictiveAccuracy: () => mU, getRoundMatchUps: () => Ir, getRounds: () => UU, isValidMatchUpFormat: () => Vr, matchUpActions: () => Lp, mutate: () => $R, participantScheduledMatchUps: () => pU, query: () => ZM, removeDelegatedOutcome: () => rN, removeMatchUpSideParticipant: () => VU, removeTieMatchUpParticipantId: () => HR, replaceTieMatchUpParticipantId: () => BU, resetAdHocMatchUps: () => uN, resetMatchUpLineUps: () => zU, resetScorecard: () => KU, resetTieFormat: () => YU, setDelegatedOutcome: () => cN, setMatchUpFormat: () => aN, setMatchUpStatus: () => yl, setOrderOfFinish: () => lN, substituteParticipant: () => iN, tallyParticipantResults: () => cc, toggleParticipantCheckInState: () => gm, tournamentMatchUps: () => cm, updateTieMatchUpScore: () => zn, validMatchUp: () => hp, validMatchUps: () => pi });
var $R = {};
Me($R, { applyLineUps: () => dN, assignMatchUpSideParticipant: () => qR, assignTieMatchUpParticipantId: () => Sd, bulkMatchUpStatusUpdate: () => sN, checkInParticipant: () => LU, checkOutParticipant: () => FU, disableTieAutoCalc: () => nN, enableTieAutoCalc: () => tN, findMatchUp: () => nU, removeDelegatedOutcome: () => rN, removeMatchUpSideParticipant: () => VU, removeTieMatchUpParticipantId: () => HR, replaceTieMatchUpParticipantId: () => BU, resetAdHocMatchUps: () => uN, resetMatchUpLineUps: () => zU, resetScorecard: () => KU, resetTieFormat: () => YU, setDelegatedOutcome: () => cN, setMatchUpFormat: () => aN, setMatchUpStatus: () => yl, setOrderOfFinish: () => lN, substituteParticipant: () => iN, toggleParticipantCheckInState: () => gm, updateTieMatchUpScore: () => zn });
function qR({ tournamentRecord: e, drawDefinition: t, participantId: r, sideNumber: i, matchUpId: n, event: a }) {
  if (r && typeof r != "string") return { error: Li };
  if (!t) return { error: ne };
  if (!n) return { error: pr };
  let o = i === void 0;
  if (o && (i = 1), ![1, 2].includes(i)) return F({ result: { error: z, context: { sideNumber: i } } });
  let { matchUp: s, structure: c } = ut({ drawDefinition: t, matchUpId: n, event: a });
  if (!s) return { error: cr };
  if (!(!c?.structures && !(t.drawType && t.drawType !== Gr) && !c?.matchUps?.find(({ roundPosition: u }) => !!u))) return { error: ah };
  if (!r && (s?.score?.scoreStringSide1 || Lt.includes(s?.matchUpstatus) || s?.matchUpStatus && [Mt, xt].includes(s.matchUpStatus))) return { error: Od, info: "matchUp has completed status or score" };
  if (s) {
    if (s.sides = [1, 2].map((u) => {
      let l = s.sides?.find((d) => d.sideNumber === u) ?? { sideNumber: u };
      return i === u ? { ...l, participantId: r } : l;
    }), o) for (let u of s.sides) u.sideNumber && (u.sideNumber = 3 - u.sideNumber);
    Oe({ tournamentId: e?.tournamentId, context: "assignSideParticipant", drawDefinition: t, matchUp: s });
  }
  return { ...x, sidesSwapped: o };
}
function Wr({ removePriorValues: e, tournamentRecord: t, duplicateValues: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: o, event: s }) {
  let { matchUp: c } = ut({ drawDefinition: i, event: s, matchUpId: a });
  if (!c) return { error: cr };
  let u = an({ removePriorValues: e, element: c, duplicateValues: r, timeItem: o });
  return n || Oe({ tournamentId: t?.tournamentId, eventId: s?.eventId, context: "addTimeItem", drawDefinition: i, matchUp: c }), u;
}
function FU(e) {
  let t = [{ [Vt]: !0 }, { [lr]: !0 }, { [yn]: !0 }, { [tn]: !0 }], r = oe(e, t);
  if (r.error) return r;
  let i = lc(e, [{ [Ks]: Tn, attr: { [Zd]: !0 } }]);
  if (i.error) return i;
  let { tournamentRecord: n, drawDefinition: a, participantId: o, matchUpId: s } = e, c = i?.matchUp?.matchUp, { matchUpStatus: u, score: l } = c ?? {};
  if (u && cg.includes(u) || u && Lt.includes(u) || Bt({ score: l })) return { error: Mv };
  let d = $o({ matchUp: c });
  if (d?.error) return d;
  let { checkedInParticipantIds: p, allRelevantParticipantIds: m } = d ?? {};
  if (!m?.includes(o)) return { error: Li };
  if (!p?.includes(o)) return { error: rP };
  let f = Cw({ matchUp: c });
  if (f?.error) return f;
  let { sideParticipantIds: h, nestedIndividualParticipantIds: g } = f ?? {}, I = h?.indexOf(o);
  return I !== void 0 && [0, 1].includes(I) && (g?.[I] ?? []).forEach((U) => {
    Wr({ drawDefinition: a, matchUpId: s, timeItem: { itemType: ad, itemValue: U } });
  }), Wr({ tournamentRecord: n, drawDefinition: a, matchUpId: s, timeItem: { itemValue: o, itemType: ad } }), { ...x, checkedOut: !0 };
}
function LU(e) {
  let t = [{ [Vt]: !0 }, { [lr]: !0 }, { [yn]: !0 }, { [tn]: !0 }], r = oe(e, t);
  if (r[yi]) return r;
  let i = lc(e, [{ [Ks]: Tn, attr: { [Zd]: !0 } }]);
  if (i[yi]) return i;
  let { tournamentRecord: n, drawDefinition: a, participantId: o, matchUpId: s } = e, c = $o({ matchUp: i?.matchUp?.matchUp });
  if (c?.error) return c;
  let { checkedInParticipantIds: u, allRelevantParticipantIds: l } = c ?? {};
  if (!l?.includes(o)) return { [yi]: Li };
  let d = { ...x, checkedIn: !0 };
  return u?.includes(o) || Wr({ tournamentRecord: n, drawDefinition: a, matchUpId: s, timeItem: { itemValue: o, itemType: nd } }), d;
}
function gm(e) {
  let t = oe(e, [{ [yn]: !0, [lr]: !0, [tn]: !0 }]);
  if (t.error) return t;
  let r = e.tournamentId ?? e.activeTournamentId, i = e.tournamentRecord ?? (r && e.tournamentRecords?.[r]);
  if (!i) return { error: J };
  let n = lc(e, [{ [Ks]: Tn, attr: { [Zd]: !0 }, [yi]: cr }]).matchUp?.matchUp;
  if (!n) return { error: cr };
  let { checkedInParticipantIds: a = [] } = $o({ matchUp: n }), { participantId: o, matchUpId: s, drawDefinition: c } = e;
  return o && a.includes(o) ? FU({ tournamentRecord: i, drawDefinition: c, participantId: o, matchUpId: s, matchUp: n }) : LU({ tournamentRecord: i, drawDefinition: c, participantId: o, matchUpId: s, matchUp: n });
}
function _U({ tournamentRecord: e, drawDefinition: t, tieMatchUpId: r, event: i }) {
  if (!e) return { error: J };
  if (!t) return { error: Vi };
  if (!i) return { error: ni };
  let n = or({ drawDefinition: t }), { matchUp: a } = ut({ matchUpId: r, drawDefinition: t, matchUpsMap: n });
  if (!a) return { error: cr };
  let { matchUp: o, structure: s } = ut({ tournamentParticipants: e.participants, matchUpId: r, inContext: !0, drawDefinition: t, matchUpsMap: n, event: i });
  if (!o) return { error: cr };
  let { collectionPosition: c, drawPositions: u, collectionId: l, matchUpTieId: d, matchUpType: p } = o;
  if (p && !Md([Xe, Ke], p)) return { error: Cr };
  let { positionAssignments: m } = Je({ structure: s }), f = m?.filter((D) => u?.includes(D.drawPosition)), { matchUp: h } = ut({ matchUpId: d, drawDefinition: t, matchUpsMap: n }), g = h?.sides?.map(Re) ?? [], I = f?.map(Re) ?? [], U = [...g, ...I], { participants: S } = ft({ tournamentRecord: e, participantFilters: { participantTypes: [We], participantIds: U } }), { matchUp: P } = ut({ matchUpId: d, inContext: !0, drawDefinition: t, matchUpsMap: n }), v = dr({ matchUp: h, drawDefinition: t, structure: s, event: i })?.tieFormat;
  return { inContextDualMatchUp: P, inContextTieMatchUp: o, relevantAssignments: f, collectionPosition: c, teamParticipants: S, collectionId: l, matchUpType: p, dualMatchUp: h, tieMatchUp: a, tieFormat: v, structure: s, ...x };
}
function BU(e) {
  let t = _U(e);
  if (t.error) return t;
  let r = "replaceTieMatchUpParticipantid", { existingParticipantId: i, tournamentRecord: n, newParticipantId: a, drawDefinition: o, substitution: s, event: c } = e;
  if (!i || !a) return F({ result: { error: Ft }, stack: r });
  if (i === a) return { ...x };
  let { inContextDualMatchUp: u, inContextTieMatchUp: l, collectionPosition: d, collectionId: p, dualMatchUp: m, tieMatchUp: f, tieFormat: h } = t, g = l?.matchUpType, I = l?.sides?.find((O) => O.participant?.participantId === i || O.participant?.individualParticipantIds?.includes(i));
  if (!I) return { error: Tt };
  let U = ft({ tournamentRecord: n, participantFilters: { participantIds: [i, a] } })?.participants ?? [];
  if (U.length !== 2) return F({ result: { error: Ft }, stack: r });
  if (U[0].participantType !== U[1].participantType) return F({ result: { error: _i }, stack: r });
  let { appliedPolicies: S } = _e({ tournamentRecord: n, drawDefinition: o, event: c }), P = e.policyDefinitions?.[Yt] ?? S?.[Yt] ?? nc[Yt], v = U.find(({ participantId: O }) => O === a);
  if ((e.enforceGender ?? P?.participants?.enforceGender) !== !1 && [Ye, at].includes(l?.gender) && l?.gender !== v?.person?.sex) return { error: Eo, info: "Gender mismatch" };
  let D = P?.processCodes?.substitution;
  ol({ tournamentId: n.tournamentId, eventId: c.eventId, inContextDualMatchUp: u, drawDefinition: o, dualMatchUp: m });
  let y = m?.sides?.find(({ sideNumber: O }) => O === I.sideNumber);
  if (!y) return F({ result: { sideNumber: I.sideNumber, existingParticipantId: i, error: Kt }, stack: r });
  if (l?.sides?.flatMap((O) => O.participant?.individualParticipantIds || O.participant?.participantId || [])?.includes(a)) return F({ result: { error: xd }, stack: r });
  let w = u?.sides?.find(({ sideNumber: O }) => O === I.sideNumber)?.participantId, b = y.lineUp, T = b?.find(({ participantId: O }) => a === O), R = b?.reduce((O, _) => _.substitutionOrder > O ? _.substitutionOrder : O, 0), M = b?.map((O) => {
    let _ = ie(O, !1, !0);
    if (![i, a].includes(_.participantId)) return _;
    if (!s && [i, a].includes(_.participantId) && (_.collectionAssignments = _.collectionAssignments?.filter((B) => !(B.collectionPosition === d && B.collectionId === p))), s && i === _.participantId && (_.collectionAssignments = _.collectionAssignments.map((B) => B.collectionPosition === d && B.collectionId === p && B.substitutionOrder === void 0 ? { ...B, substitutionOrder: R } : B)), _.participantId === a) {
      _.collectionAssignments || (_.collectionAssignments = []);
      let B = { collectionId: p, collectionPosition: d };
      s && (B.previousParticipantId = i, B.substitutionOrder = (R ?? 0) + 1), _.collectionAssignments.push(B);
    }
    return _;
  }) ?? [];
  if (!T) {
    let O = { collectionId: p, collectionPosition: d };
    s && (O.substitutionOrder = (R ?? 0) + 1, O.previousParticipantId = i);
    let _ = { collectionAssignments: [O], participantId: a };
    M.push(_);
  }
  let E = g === Ke, { assignedParticipantIds: A } = od({ lineUp: b, collectionPosition: d, collectionId: p }), { assignedParticipantIds: N } = od({ lineUp: M, collectionPosition: d, collectionId: p });
  if (y.lineUp = M, w && h) {
    let O = Qo({ participantId: w, lineUp: M, drawDefinition: o, tieFormat: h });
    if (O.error) return F({ result: O, stack: r });
  } else console.log("team participantId not found");
  let C, k;
  if (E) {
    let { tournamentRecord: O } = e, _ = bi({ participantIds: N, tournamentRecord: O });
    if (!_.participant) {
      let L = en({ returnParticipant: !0, pairOverride: !0, tournamentRecord: O, participant: { participantRole: rr, individualParticipantIds: N, participantType: De } });
      if (L.error) return F({ result: L, stack: r });
      C = L.participant?.participantId;
    }
    _ = bi({ participantIds: A, tournamentRecord: O });
    let B = _.participant?.participantId;
    B && Yo({ participantIds: [B], tournamentRecord: O }).success && (k = B);
  }
  if (s || I.substitutions?.length === 1) {
    if (s) D && f && (f.processCodes = Ue([...f?.processCodes ?? [], ...D]));
    else for (let O of D || []) {
      let _ = f?.processCodes?.lastIndexOf(O);
      _ !== void 0 && f?.processCodes?.splice(_, 1);
    }
    f && Oe({ tournamentId: n?.tournamentId, matchUp: f, context: r, drawDefinition: o });
  }
  return m && Oe({ tournamentId: n?.tournamentId, matchUp: m, context: r, drawDefinition: o }), { ...x, modifiedLineUp: M, participantRemoved: k, participantAdded: C };
}
function WR({ collectionPosition: e, teamParticipantId: t, dualMatchUpSide: r, drawDefinition: i, participantIds: n, collectionId: a }) {
  if (!a || !e || !Array.isArray(n)) return { modifiedLineUp: r?.lineUp || [], error: z };
  let o = r?.lineUp || xa({ participantId: t, drawDefinition: i })?.lineUp, s = [], c = [];
  return { modifiedLineUp: o?.map((u) => {
    if (!n.includes(u.participantId)) return u;
    let l = u.collectionAssignments?.filter((d) => {
      let p = d.collectionId === a && d.collectionPosition === e;
      return p && (d.previousParticipantId && s.push(d.previousParticipantId), c.push({ participantId: u.participantId, ...d })), !p;
    });
    return { participantId: u.participantId, collectionAssignments: l };
  }).filter(Boolean) || [], assignmentsRemoved: c, previousParticipantIds: s };
}
function uB({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: r }) {
  let i = (r.events || []).filter((a) => a?.eventType === kt && a?.entries?.some((o) => o.participantId === t)), n = (a) => !e.includes(a.participantId);
  for (let a of i) {
    a.entries = (a.entries || []).filter(n);
    let { flightProfile: o } = wt({ event: a });
    o?.flights?.forEach((s) => {
      s.drawEntries = (s.drawEntries || []).filter(n);
    }), a?.drawDefinitions?.forEach((s) => {
      s.entries = (s.entries || []).filter(n);
    });
  }
  return { ...x };
}
function Im({ individualParticipantIds: e, groupingParticipantId: t, removeFromOtherTeams: r, tournamentRecord: i }) {
  let n = "addIndividualParticipantIds";
  if (!i) return F({ result: { error: J }, stack: n });
  if (!t || !e) return F({ result: { error: ue }, stack: n });
  let a = i.participants ?? [], o = a.find((d) => d.participantId === t);
  if (!o) return F({ result: { error: Tt }, stack: n });
  if (o?.participantType && ![We, Xr].includes(o.participantType)) return F({ context: { participantType: o.participantType }, result: { error: _i }, stack: n });
  let s = e.filter((d) => a.find((p) => p.participantId === d)?.participantType !== Ne);
  if (s.length) return F({ result: { error: _r, invalidParticipantIds: s }, stack: n });
  o.individualParticipantIds || (o.individualParticipantIds = []);
  let c = o.individualParticipantIds, u = e.filter((d) => !c.includes(d));
  u.length && (r && wp({ individualParticipantIds: u, tournamentRecord: i }), o.individualParticipantIds = o.individualParticipantIds.concat(...u));
  let { topics: l } = ci();
  if (l.includes(ar)) {
    let d = a.find(({ participantId: p }) => p === t);
    Se({ topic: ar, payload: { participants: [d] } });
  }
  return uB({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: i }), { groupingParticipant: ie(o, !1, !0), added: u.length, ...x };
}
function Um(e) {
  let { updateParticipantName: t = !0, groupingParticipantId: r, removeFromOtherTeams: i, tournamentRecord: n, pairOverride: a, participant: o } = e;
  if (!n) return { error: J };
  if (!o) return { error: Ao };
  if (!o.participantId) return en({ tournamentRecord: n, participant: o });
  let { participant: s } = ha({ participantId: o.participantId, tournamentRecord: n });
  if (!s) return en({ tournamentRecord: n, participant: o });
  let { participantRoleResponsibilties: c, individualParticipantIds: u, participantOtherName: l, participantName: d, participantRole: p, participantType: m, onlineResources: f, contacts: h, person: g } = o;
  if (m && s.participantType !== m) return { error: Kv };
  let I = {};
  if (h && (I.contacts = h), f && (I.onlineResources = f), l && dt(l) && (I.participantOtherName = l), d && dt(d) && (I.participantName = d), Array.isArray(u)) {
    let { participants: U } = ft({ participantFilters: { participantTypes: [Ne] }, tournamentRecord: n }), S = U?.map(Re);
    if (S) {
      let P = u.filter((v) => dt(v) && S.includes(v));
      ([Xr, ot].includes(m || s.participantType) || m === De && (P.length === 2 || a)) && (I.individualParticipantIds = P), s.participantType === bc.PAIR && t && (I.participantName = lB({ individualParticipants: U, newValues: I }));
    }
  }
  return Object.keys(qg).includes(p) && (I.participantRole = p), Object.keys(bc).includes(m) && (I.participantType = m), Array.isArray(c) && (I.participantRoleResponsibilties = c), s.participantType === bc.INDIVIDUAL && g && dB({ updateParticipantName: t, existingParticipant: s, newValues: I, person: g }), Object.assign(s, ae(I)), r && Im({ individualParticipantIds: [s.participantId], groupingParticipantId: r, removeFromOtherTeams: i, tournamentRecord: n }), Se({ topic: ar, payload: { tournamentId: n.tournamentId, participants: [s] } }), { participant: ie(s), ...x };
}
function lB({ individualParticipants: e, newValues: t }) {
  let r = t.individualParticipantIds, i = e.filter(({ participantId: n }) => r.includes(n)).map(({ person: n }) => n?.standardFamilyName).filter(Boolean).sort().join("/");
  return r.length === 1 && (i += "/Unknown"), i;
}
function dB({ updateParticipantName: e, existingParticipant: t, newValues: r, person: i }) {
  let n = {}, { standardFamilyName: a, standardGivenName: o, nationalityCode: s, personId: c, birthdate: u, tennisId: l, sex: d } = i;
  d && Object.keys(kh).includes(d) && (n.sex = d);
  let p;
  if (dt(c) && (n.personId = c), s && dt(s) && (pB(s) || s === "") && (n.nationalityCode = s), a && typeof dt(a) && a.length > 1 && (n.standardFamilyName = a, p = !0), o && typeof dt(o) && o.length > 1 && (n.standardGivenName = o, p = !0), p && e) {
    let m = `${n.standardGivenName} ${n.standardFamilyName}`;
    r.participantName = m;
  }
  u && Ar(u) && (n.birthdate = u), l && dt(l) && (n.tennisId = l), Object.assign(t.person, n);
}
function pB(e) {
  return ea.flatMap(({ iso: t, ioc: r }) => [t, r]).filter(Boolean).includes(e);
}
function Sd(e) {
  let t = _U(e);
  if (t.error) return t;
  let r = "assignTieMatchUpParticipantId", i = e.teamParticipantId, { tournamentRecord: n, drawDefinition: a, participantId: o, event: s } = e;
  if (!o) return F({ result: { error: Ft }, stack: r });
  if (e.sideNumber && ![1, 2].includes(e.sideNumber)) return F({ result: { error: hh }, stack: r });
  let { inContextDualMatchUp: c, inContextTieMatchUp: u, relevantAssignments: l, collectionPosition: d, teamParticipants: p, collectionId: m, matchUpType: f, dualMatchUp: h, tieFormat: g } = t;
  if (u?.sides?.flatMap((B) => B.participant?.individualParticipantIds || B.participant?.participantId || [])?.includes(o)) return F({ result: { ...x }, stack: r });
  i = i ?? (e.sideNumber ? c?.sides?.find((B) => B.sideNumber === e.sideNumber)?.participantId : void 0);
  let I = ft({ participantFilters: { participantIds: [o] }, tournamentRecord: n })?.participants?.[0];
  if (!I) return F({ result: { error: Tt }, stack: r });
  let { appliedPolicies: U } = _e({ tournamentRecord: n, drawDefinition: a, event: s }), S = e.policyDefinitions?.[Yt] ?? U?.[Yt] ?? nc[Yt];
  if ((e.enforceGender ?? S?.participants?.enforceGender) !== !1 && [Ye, at].includes(u?.gender) && u?.gender !== I.person?.sex) return { error: Eo, info: "Gender mismatch" };
  let { individualParticipantIds: P, participantType: v } = I;
  if (bt(Xe)(f) && v !== Ne) return { error: _i };
  let D = v === Ne ? [o] : P, y = i && p?.find(({ participantId: B }) => B === i) || p?.find(({ individualParticipantIds: B }) => gr(D, B));
  if (!y) return { error: Th };
  if (i || (i = y.participantId), !i) return { error: Tt };
  let w = l?.find((B) => B.participantId === y?.participantId)?.drawPosition, b = h?.sides?.find((B) => B.participantId === i)?.sideNumber, T = u?.sides?.find((B) => w && B.drawPosition === w)?.sideNumber, R = b ?? T ?? e.sideNumber;
  if (!g) return { error: $s };
  if (!g.collectionDefinitions?.find((B) => B.collectionId === m)) return { error: Vv };
  ol({ tournamentId: n.tournamentId, eventId: s.eventId, inContextDualMatchUp: c, drawDefinition: a, dualMatchUp: h });
  let M = h?.sides?.find((B) => B.sideNumber === R), E = u?.sides?.find((B) => B.sideNumber === R), A = (M?.lineUp ?? xa({ participantId: i, drawDefinition: a })?.lineUp)?.filter((B) => B.collectionAssignments?.find((L) => L.collectionPosition === d && L.collectionId === m && !L.previousParticipantId))?.map((B) => B?.participantId), N = A?.length > 1 && A || (v === De ? I.individualParticipantIds : [o]), C = WR({ collectionPosition: d, teamParticipantId: i, dualMatchUpSide: M, drawDefinition: a, participantIds: N, collectionId: m });
  if (C.error) return F({ result: C, stack: r });
  let { modifiedLineUp: k } = C, O;
  if (f === Ke) {
    if (v !== De) {
      let B = Wm({ collectionPosition: d, teamParticipantId: i, drawDefinition: a, modifiedLineUp: k, participantId: o, collectionId: m, tieFormat: g });
      if (B?.error) return F({ result: B, stack: r });
      if (B = _({ side: E }), B.error) return B;
      O = B.deletedParticipantId, M && (M.lineUp = k), h && Oe({ tournamentId: n?.tournamentId, matchUp: h, context: r, drawDefinition: a });
    } else if (v === De) for (let B of N) Wm({ collectionPosition: d, teamParticipantId: i, drawDefinition: a, modifiedLineUp: k, participantId: B, collectionId: m, tieFormat: g });
  } else {
    let B = Wm({ collectionPosition: d, teamParticipantId: i, drawDefinition: a, modifiedLineUp: k, participantId: o, collectionId: m, tieFormat: g });
    if (B?.error) return B;
  }
  if (M && (M.lineUp = k), h && Oe({ tournamentId: n?.tournamentId, matchUp: h, context: r, drawDefinition: a }), O) {
    let { error: B } = Yo({ participantIds: [O], tournamentRecord: n });
    B && console.log("cleanup");
  }
  return { ...x, modifiedLineUp: k };
  function _({ side: B }) {
    let L;
    if (B.participant) {
      let j = B.participant.individualParticipantIds || [];
      if (j.filter(Boolean).length === 1) {
        let { participant: H } = bi({ participantIds: j, tournamentRecord: n });
        j.push(o);
        let { participant: G } = bi({ participantIds: j, tournamentRecord: n });
        if (!G && H) {
          H.individualParticipantIds = j;
          let V = Um({ pairOverride: !0, tournamentRecord: n, participant: H });
          if (V.error) return V;
        } else L = H?.participantId;
      }
    } else {
      let j = en({ participant: { individualParticipantIds: [o], participantRole: rr, participantType: De }, pairOverride: !0, tournamentRecord: n });
      if (j.error) return j;
    }
    return { ...x, deletedParticipantId: L };
  }
}
function Wm({ collectionPosition: e, teamParticipantId: t, drawDefinition: r, modifiedLineUp: i, participantId: n, collectionId: a, tieFormat: o }) {
  let s = xa({ participantId: t, drawDefinition: r })?.lineUp, c = (i || s)?.find((l) => l?.participantId === n), u = { collectionId: a, collectionPosition: e };
  if (c) c.collectionAssignments.push(u);
  else {
    let l = { collectionAssignments: [u], participantId: n };
    i.push(l);
  }
  return Qo({ participantId: t, lineUp: i, drawDefinition: r, tieFormat: o });
}
function HR(e) {
  let { tournamentRecord: t, drawDefinition: r, participantId: i, event: n } = e, a = "removeTieMatchUpParticiapantId";
  if (!i) return F({ result: { error: Ft }, stack: a });
  let o = _U(e);
  if (o.error) return o;
  let { appliedPolicies: s } = _e({ tournamentRecord: t, drawDefinition: r, event: n }), c = (e.policyDefinitions?.[Yt] ?? s?.[Yt] ?? nc[Yt])?.processCodes?.substitution, { inContextDualMatchUp: u, inContextTieMatchUp: l, relevantAssignments: d, collectionPosition: p, teamParticipants: m, collectionId: f, matchUpType: h, dualMatchUp: g, tieMatchUp: I, tieFormat: U } = o;
  if (!g) return F({ result: { error: Dr }, stack: a });
  let S = l?.sides?.find((R) => R.participant?.participantId === i || R.participant?.individualParticipantIds?.includes(i));
  if (!S) return F({ result: { error: Tt }, stack: a });
  let P = e.policyDefinitions?.[oi] ?? s?.[oi];
  if (!S.substitutions?.length && (Bt({ score: l?.score }) || l?.winningSide) && P?.requireParticipantsForScoring !== !1) return F({ result: { error: DP }, stack: a });
  let v = u?.sides?.find(({ sideNumber: R }) => R === S.sideNumber)?.participantId;
  if (!v) return F({ result: { error: Tt }, stack: a });
  let D = ft({ participantFilters: { participantIds: [i] }, tournamentRecord: t })?.participants?.[0];
  if (!D) return F({ result: { error: Tt }, stack: a });
  if (h === Xe && D.participantType === De) return F({ result: { error: Eo }, stack: a });
  let y = D.participantType === Ne ? [i] : D.individualParticipantIds;
  ol({ tournamentId: t.tournamentId, eventId: n.eventId, inContextDualMatchUp: u, drawDefinition: r, dualMatchUp: g });
  let w = g.sides?.find(({ sideNumber: R }) => R === S.sideNumber);
  if (!w && (g.sides?.filter(({ lineUp: R }) => !R).length || 0) < 2) {
    let R = m?.map(({ participantId: M }) => ({ drawPosition: d?.find((E) => E.participantId === M)?.drawPosition, teamParticipantId: M }));
    w = g.sides?.find((M) => R?.find(({ drawPosition: E }) => E === M.drawPosition)?.teamParticipantId === v);
  }
  if (!w) return F({ result: { error: Tt, context: { participantId: i } } });
  let { modifiedLineUp: b, previousParticipantIds: T } = WR({ collectionPosition: p, teamParticipantId: v, dualMatchUpSide: w, participantIds: y, drawDefinition: r, collectionId: f });
  if (w.lineUp = b, v && U && Qo({ participantId: v, lineUp: b, drawDefinition: r, tieFormat: U }), h === Ke && D.participantType === Ne) {
    let R = l?.sides?.find((A) => A.sideNumber === w?.sideNumber), { participantId: M } = R ?? {}, E = M && ft({ participantFilters: { participantIds: [M] }, tournamentRecord: t, withDraws: !0 })?.participants?.[0];
    if (E) {
      let A = E?.individualParticipantIds?.filter((N) => N !== i) ?? [];
      if (T && A.push(...T), A.length > 2) return F({ result: { error: _r }, stack: a });
      if (E.draws?.length) {
        if (A.length === 1) {
          let { participant: N } = bi({ participantIds: A, tournamentRecord: t });
          if (!N) {
            let C = en({ participant: { participantRole: rr, individualParticipantIds: A, participantType: De }, pairOverride: !0, tournamentRecord: t });
            if (C.error) return F({ result: C, stack: a });
          }
        }
      } else if (A.length) {
        E.individualParticipantIds = A;
        let N = Um({ participant: E, pairOverride: !0, tournamentRecord: t });
        if (N.error) return F({ result: N, stack: a });
      } else {
        let N = Yo({ participantIds: [M], tournamentRecord: t });
        N.error && console.log("cleanup", { result: N });
      }
    } else return F({ result: { error: Tt }, stack: a });
  }
  if (S.substitutions?.length === 1 && !l?.sides?.find((R) => R.sideNumber !== S.sideNumber)?.substitutions?.length && I?.processCodes?.length) {
    for (let R of c || []) {
      let M = I.processCodes.lastIndexOf(R);
      I.processCodes.splice(M, 1);
    }
    Oe({ tournamentId: t?.tournamentId, matchUp: I, context: a, drawDefinition: r });
  }
  return Oe({ tournamentId: t?.tournamentId, matchUp: g, context: a, drawDefinition: r }), { ...x, modifiedLineUp: b };
}
function VU(e) {
  let t = oe(e, [{ [Vt]: !0, [lr]: !0, [tn]: !0 }]);
  if (t.error) return t;
  let { drawDefinition: r, sideNumber: i, matchUpId: n, event: a } = e;
  if (i && ![1, 2].includes(i)) return { error: z, sideNumber: i };
  let { matchUp: o, structure: s } = ut({ drawDefinition: r, matchUpId: n, event: a });
  return o ? Tr({ structure: s }) ? (o.sides?.forEach((c) => {
    (!i || c.sideNumber === i) && delete c.participantId;
  }), Oe({ tournamentId: e.tournamentRecord?.tournamentId, context: "assignSideParticipant", drawDefinition: r, matchUp: o }), { ...x }) : { error: ah } : { error: cr };
}
function mB({ matchUpStatuses: e = ["BYE", be, Pe], drawPositionMatchUps: t, loserDrawPosition: r, sourceMatchUps: i }) {
  let n = t?.reduce((l, d) => !l || d.roundNumber > l.roundNumber ? d : l, void 0), a = n?.drawPositions?.find((l) => l !== r), o = i.filter((l) => l?.drawPositions?.includes(a)).map((l) => l.matchUpStatus), s = i.filter((l) => l?.drawPositions?.includes(r)).map((l) => l.matchUpStatus), c = gr(o || [], e), u = gr(s || [], e);
  return { sourceMatchUp: n, winnerHadMatchUpStatus: c, winnerMatchUpStatuses: o, loserHadMatchUpStatus: u, loserMatchUpStatuses: s };
}
function fB({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, targetDrawPosition: r, tournamentRecord: i, sourceMatchUpId: n, drawDefinition: a, structureId: o, dualMatchUp: s, roundNumber: c, matchUpsMap: u, event: l }) {
  let { structure: d } = me({ drawDefinition: a, structureId: o });
  if (d?.structureType === yr) return { ...x };
  u = u ?? or({ drawDefinition: a });
  let p = (u?.mappedMatchUps || {})[o].matchUps, { initialRoundNumber: m } = wo({ drawPosition: r, matchUps: p }), f = p?.filter((g) => g.roundNumber >= c && g.roundNumber !== m && g.drawPositions?.includes(r)), { positionAssignments: h } = Je({ drawDefinition: a, structureId: o });
  for (let g of f ?? []) hB({ inContextDrawMatchUps: e, sourceMatchUpStatus: t, positionAssignments: h, targetDrawPosition: r, tournamentRecord: i, sourceMatchUpId: n, drawDefinition: a, dualMatchUp: s, matchUpsMap: u, matchUp: g, event: l });
  return { ...x };
}
function hB({ inContextDrawMatchUps: e, positionAssignments: t, sourceMatchUpStatus: r, targetDrawPosition: i, tournamentRecord: n, sourceMatchUpId: a, drawDefinition: o, dualMatchUp: s, matchUpsMap: c, matchUp: u, event: l }) {
  let d = "removeSubsequentDrawPosition";
  if (s) {
    let m = e.find(({ matchUpId: h }) => u.matchUpId === h).sides?.find((h) => h.drawPosition === i)?.sideNumber, f = u.sides?.find((h) => h.sideNumber === m);
    f && delete f.lineUp;
  }
  u.drawPositions = (u.drawPositions || []).map((m) => m === i ? void 0 : m).filter(Boolean);
  let p = t.filter(({ drawPosition: m }) => u.drawPositions?.includes(m)).filter((m) => m.bye).length;
  return u.matchUpStatus = p && "BYE" || [Pe, be].includes(u.matchUpStatus) && u.matchUpStatus || Dt, [be, Pe].includes(u.matchUpStatus) && (u.winningSide = void 0), u.matchUpStatusCodes && UT({ inContextDrawMatchUps: e, sourceMatchUpStatus: r, sourceMatchUpId: a, matchUpsMap: c, matchUp: u }), Oe({ tournamentId: n?.tournamentId, eventId: l?.eventId, context: `${d}-${i}`, drawDefinition: o, matchUp: u }), { ...x };
}
function hc(e) {
  let { dualWinningSideChange: t, inContextDrawMatchUps: r, tournamentRecord: i, drawDefinition: n, matchUpStatus: a, matchUpsMap: o, dualMatchUp: s, targetData: c, matchUpId: u, structure: l, event: d } = e, p = !!e.matchUp.collectionId, m = Tr({ structure: l }), { drawPositions: f, winningSide: h } = c.matchUp || {};
  if (!m && !f) return { error: pu };
  let { targetLinks: { loserTargetLink: g, winnerTargetLink: I, byeTargetLink: U }, targetMatchUps: { loserMatchUp: S, winnerMatchUp: P, byeMatchUp: v } } = c, D = zi({ ...e, matchUpStatus: a || Dt, removeWinningSide: !0 });
  if (D.error) return D;
  let y;
  if (p) {
    let { matchUpTieId: k, matchUpsMap: O } = e;
    if (y = zn({ appliedPolicies: e.appliedPolicies, matchUpId: k, tournamentRecord: i, drawDefinition: n, matchUpsMap: O, event: d }), !t && !y.removeWinningSide) return { ...x };
  }
  if (m) return { ...x };
  let { matchUps: w } = Ve({ afterRecoveryTimes: !1, inContext: !0, drawDefinition: n, matchUpsMap: o, structure: l }), { positionAssignments: b } = _t({ structure: l }), T = h - 1, R = 1 - T, M = f[T], E = f[R], { winnerParticipantId: A, loserParticipantId: N } = b?.reduce((k, O) => (O.drawPosition === E && (k.loserParticipantId = O.participantId), O.drawPosition === M && (k.winnerParticipantId = O.participantId), k), { winnerParticipantId: void 0, loserParticipantId: void 0 }) || {}, C = w.filter((k) => k.drawPositions?.includes(E));
  if (P && zR({ sourceMatchUpStatus: a, sourceMatchUpId: u, inContextDrawMatchUps: r, winningDrawPosition: M, winnerParticipantId: A, tournamentRecord: i, winnerTargetLink: I, drawDefinition: n, winnerMatchUp: P, dualMatchUp: s, matchUpsMap: o }), S) {
    let { winnerHadMatchUpStatus: k } = mB({ drawPositionMatchUps: C, loserDrawPosition: E, sourceMatchUps: w }), O = g.linkCondition === Qi;
    if (k && O) {
      let B = Math.min(...S.drawPositions);
      zf({ targetLink: g, inContextDrawMatchUps: r, drawDefinition: n, drawPosition: B, matchUpsMap: o, event: d });
    }
    let _ = gB({ sourceMatchUpStatus: a, sourceMatchUpId: u, loserParticipantId: N, tournamentRecord: i, loserTargetLink: g, drawDefinition: n, loserMatchUp: S, dualMatchUp: s, matchUpsMap: o, event: d });
    if (_.error) return _;
  }
  if (v) {
    let k = Math.min(...v.drawPositions);
    zf({ targetLink: U, inContextDrawMatchUps: r, drawDefinition: n, drawPosition: k, matchUpsMap: o, event: d });
  }
  return { ...x, ...y && { tieMatchUpResult: y } };
}
function zR({ inContextDrawMatchUps: e, winningDrawPosition: t, sourceMatchUpStatus: r, winnerParticipantId: i, tournamentRecord: n, winnerTargetLink: a, sourceMatchUpId: o, drawDefinition: s, winnerMatchUp: c, matchUpsMap: u, dualMatchUp: l, event: d }) {
  let { structureId: p, roundNumber: m } = c, f = "removeDirectedWinner";
  if (a) {
    let h = a.target.structureId, { structure: g } = me({ drawDefinition: s, structureId: h });
    if (!g) return { error: mt };
    let { positionAssignments: I } = _t({ structure: g });
    g.seedAssignments = (g.seedAssignments ?? []).filter((y) => y.participantId !== i);
    let U = I?.find((y) => y.participantId === i)?.drawPosition, { matchUps: S } = Ve({ drawDefinition: s, structure: g, event: d }), P = S.map((y) => y.drawPositions).flat(1 / 0).filter(Boolean), v = Br(P);
    if ((U ? v[U] : void 0) === 1) I?.forEach((y) => {
      y.participantId === i && delete y.participantId;
    });
    else {
      let y = S.filter(({ drawPositions: w }) => w.includes(U));
      console.log("not removing from position assignments since instances > 1", { drawPositionMatchUps: y, winnerTargetLink: a });
    }
    let D = u?.drawMatchUps?.find(({ matchUpId: y }) => y === c.matchUpId);
    D && Oe({ tournamentId: n?.tournamentId, eventId: d?.eventId, matchUp: D, context: f, drawDefinition: s });
  }
  return m && fB({ targetDrawPosition: t, inContextDrawMatchUps: e, sourceMatchUpStatus: r, tournamentRecord: n, sourceMatchUpId: o, drawDefinition: s, dualMatchUp: l, matchUpsMap: u, roundNumber: m, structureId: p }), { ...x };
}
function gB({ sourceMatchUpStatus: e, loserParticipantId: t, tournamentRecord: r, loserTargetLink: i, sourceMatchUpId: n, drawDefinition: a, loserMatchUp: o, matchUpsMap: s, dualMatchUp: c, event: u }) {
  let l = "removeDirectedLoser", d = i.target.structureId, { structure: p } = me({ drawDefinition: a, structureId: d });
  if (!p) return { error: mt };
  let { positionAssignments: m } = _t({ structure: p }), f = m?.find((h) => h.participantId === t)?.drawPosition;
  if (m?.forEach((h) => {
    h.participantId === t && delete h.participantId;
  }), p.seedAssignments = (p.seedAssignments ?? []).filter((h) => h.participantId !== t), c) {
    let h = o?.sides.reduce((U, S, P) => S.drawPosition === f ? P : U, void 0), g = s?.drawMatchUps?.find(({ matchUpId: U }) => U === o.matchUpId), I = g?.sides?.[h];
    I && (delete I.lineUp, Oe({ tournamentId: r?.tournamentId, eventId: u?.eventId, matchUp: g, context: l, drawDefinition: a }));
  }
  return { ...x };
}
function zf({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, targetLink: a, event: o }) {
  let s = a.target.structureId, c = "removeDirectedBye", u = zu({ inContextDrawMatchUps: e, tournamentRecord: t, drawDefinition: r, drawPosition: i, matchUpsMap: n, structureId: s, event: o });
  return F({ result: u, stack: c });
}
function IB(e) {
  let { matchUpFormat: t, score: r } = e, i = r?.sets?.length, n = t && Sr(t), { setFormat: a, finalSetFormat: o, bestOf: s } = n ?? {};
  return (s && i === s && o || a)?.timed || !1;
}
function UB({ tournamentRecord: e, drawDefinition: t, structure: r, matchUp: i }) {
  let n = "attemptToSetMatchUpStatusBYE";
  if (i?.winningSide) return F({ result: { error: Gs }, context: { matchUpStatus: "BYE" }, stack: n });
  let { positionAssignments: a } = _t({ structure: r }), o = a?.filter((s) => s.bye).map((s) => s.drawPosition);
  return i.drawPositions?.some((s) => o?.includes(s)) ? (i.matchUpStatus = "BYE", i.matchUpStatusCodes = [], Oe({ tournamentId: e?.tournamentId, context: n, drawDefinition: t, matchUp: i }), { ...x }) : F({ result: { error: Bv }, info: "matchUp does not include BYE", stack: n });
}
function Cc(e) {
  let { tournamentRecord: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: n, targetData: a, structure: o, event: s } = e, c = "doubleExitAdvancement";
  if (o.structureType === yr) return F({ result: { ...x }, stack: c });
  let { matchUp: u, targetMatchUps: l, targetLinks: d } = a, { loserMatchUp: p, winnerMatchUp: m, loserTargetDrawPosition: f } = l, h = [be, Pe].includes(p?.matchUpStatus) && !p.sides?.map((g) => g.participantId ?? g.participant).filter(Boolean).length;
  if (p && p.matchUpStatus !== "BYE") {
    let { loserTargetLink: g } = d;
    if (r?.progression?.doubleExitPropagateBye || p.feedRound && p.sides?.[0]?.participantFed) {
      let I = YR({ loserTargetDrawPosition: f, tournamentRecord: t, loserTargetLink: g, drawDefinition: i, matchUpsMap: n, event: s });
      if (I.error) return F({ result: I, stack: c });
    } else if (!h) {
      let { feedRound: I, drawPositions: U, matchUpId: S } = p, P = I ? 2 : 2 - U.indexOf(f), v = Ny({ ...e, targetMatchUp: p, walkoverWinningSide: P, tournamentRecord: t, sourceMatchUp: u, matchUpId: S });
      if (v.error) return F({ result: v, stack: c });
    }
  }
  if (m) {
    let g = Ny({ ...e, matchUpId: m.matchUpId, targetMatchUp: m, tournamentRecord: t, sourceMatchUp: u });
    if (g.error) return F({ result: g, stack: c });
  }
  return F({ result: { ...x }, stack: c });
}
function Ny(e) {
  let { inContextDrawMatchUps: t, tournamentRecord: r, drawDefinition: i, sourceMatchUp: n, targetMatchUp: a, matchUpsMap: o } = e, s = i.structures.find(({ structureId: V }) => V === a.structureId), c = e.matchUpStatus === xt ? xt : Mt, u = e.matchUpStatus === xt ? Pe : be, l = "conditionallyAdvanceDrawPosition", d = o.drawMatchUps.find((V) => V.matchUpId === a.matchUpId);
  if (!d) return { error: Dr };
  let p = n?.drawPositions || [], m = d.drawPositions?.filter(Boolean), f = n?.structureId === a.structureId;
  if (f && gr(p, m) && (m = m.filter((V) => !p.includes(V))), f && m.length > 1) return F({ result: { error: Us }, stack: l });
  let { pairedPreviousMatchUpIsDoubleExit: h, pairedPreviousMatchUp: g } = gT(e), I = Ur({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), { targetMatchUps: U, targetLinks: S } = I, { loserTargetDrawPosition: P, winnerMatchUp: v, loserMatchUp: D } = U;
  if (D) {
    let { loserTargetLink: V } = S, $ = YR({ loserTargetDrawPosition: P, tournamentRecord: r, loserTargetLink: V, drawDefinition: i, matchUpsMap: o });
    if ($.error) return F({ result: $, stack: l });
  }
  let y = d.drawPositions?.filter(Boolean) || [], w = y.length === 1, b = e.walkoverWinningSide || w && Bl({ drawPosition: y[0], matchUpId: a.matchUpId, inContextDrawMatchUps: t }) || void 0, T = [be, Pe].includes(d.matchUpStatus) && !y.length, R = d.finishingRound === 1, M = T && !R ? c : u, E = t.find((V) => V.matchUpId === g.matchUpId), A = [], N;
  n && (n?.structureId === E?.structureId ? n.roundPosition < g?.roundPosition ? N = 1 : N = 2 : a.feedRound ? n.structureId === a.structureId ? N = 2 : N = 1 : b && (N = 3 - b));
  let C = e.matchUpStatus, k = g?.matchUpStatus;
  N === 1 ? A = [{ matchUpStatus: bl(C), previousMatchUpStatus: C, sideNumber: 1 }, { matchUpStatus: bl(k), previousMatchUpStatus: k, sideNumber: 2 }] : N === 2 && (A = [{ matchUpStatus: bl(k), previousMatchUpStatus: k, sideNumber: 1 }, { matchUpStatus: bl(C), previousMatchUpStatus: C, sideNumber: 2 }]), A.length && (A = A.map((V) => ae(V)));
  let O = zi({ ...e, winningSide: b, matchUp: d, matchUpStatusCodes: A, matchUpStatus: M });
  if (O.error) return F({ result: O, stack: l });
  if (T) return Cc({ ...e, matchUpStatus: M, targetData: I });
  if (!v) return F({ result: { ...x }, stack: l });
  let _ = m.length === 2 ? m[b - 1] : m[0], { positionAssignments: B } = Je({ structure: s }), L = B?.find((V) => V.drawPosition === _), j = o.drawMatchUps.find((V) => V.matchUpId === v.matchUpId), H = j?.drawPositions?.filter(Boolean), G = H.length === 1;
  if (_) {
    if (L?.bye) {
      let V = Ur({ matchUpId: j.matchUpId, inContextDrawMatchUps: t, drawDefinition: i });
      if (G) {
        let $ = H.filter(Boolean)[0], q = Bl({ drawPosition: $, matchUpId: j.matchUpId, inContextDrawMatchUps: t }), Y = zi({ appliedPolicies: e.appliedPolicies, matchUpId: j.matchUpId, matchUp: j, matchUpStatus: u, matchUpStatusCodes: [], removeScore: !0, drawDefinition: i, winningSide: q });
        return Y.error ? F({ result: Y, stack: l }) : _g({ drawPositionToAdvance: $, matchUpId: j.matchUpId, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: o });
      } else if ([be, Pe].includes(v.matchUpStatus)) {
        let $ = Cc({ ...e, matchUpId: j.matchUpId, matchUpStatus: M, targetData: V });
        if ($.error) return F({ result: $, stack: l });
      }
      return F({ result: { ...x }, stack: l });
    }
    return po({ matchUpId: v.matchUpId, drawPosition: _, inContextDrawMatchUps: t, drawDefinition: i });
  } else if (h) {
    if (!j) return { error: Dr };
    if (G) {
      let q = H[0], Y = Bl({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawPosition: q });
      console.log("existing drawPosition is winningSide", { walkoverWinningSide: Y });
    }
    let V = [be, Pe].includes(j.matchUpStatus) ? u : c, $ = zi({ matchUpId: j.matchUpId, appliedPolicies: e.appliedPolicies, matchUp: j, matchUpStatusCodes: [], removeScore: !0, drawDefinition: i, matchUpStatus: V });
    if ($.error) return F({ result: $, stack: l });
    if (V === c) {
      let q = Cc({ ...e, matchUpId: a.matchUpId, matchUpStatus: V, targetData: I });
      if (q.error) return q;
    }
  }
  return F({ result: { ...x }, stack: l });
}
function YR(e) {
  let { loserTargetDrawPosition: t, tournamentRecord: r, loserTargetLink: i, drawDefinition: n, matchUpsMap: a, event: o } = e, s = i?.target?.structureId, { structure: c } = me({ drawDefinition: n, structureId: s });
  return c ? Zr({ drawPosition: t, tournamentRecord: r, drawDefinition: n, structureId: s, matchUpsMap: a, event: o }) : { error: qa };
}
function bl(e) {
  return e === Mt ? be : e === xt ? Pe : e;
}
function SB(e) {
  let { tournamentRecord: t, drawDefinition: r, matchUpStatus: i, structure: n, matchUp: a } = e, o = !!(a.tieMatchUps && !a.rondPosition && e.inContextDrawMatchUps.find((I) => I.matchUpId === a.matchUpId).containerStructureId), s = "attemptToSetMatchUpStatus", c = i === "BYE", u = a.winningSide, l = [Mt, xt].includes(i), d = Wu({ matchUpStatus: i }), p = Mf({ matchUpStatus: i }), m = !d && !p, f = e.matchUpTieId || u && d && !l, h = u && l, g = () => zi({ ...e, removeScore: [nn, be].includes(i), matchUpStatus: i || Dt });
  return m && { error: sf } || f && ql(e) || h && yB(e) || u && hc(e) || p && g() || c && UB({ tournamentRecord: t, drawDefinition: r, structure: n, matchUp: a }) || !d && { error: sf } || l && vB(e) || o && ql(e) || e.propagateExitStatus && ql(e) || F({ result: { error: Gs, info: "matchUpStatus: " + i }, stack: s });
}
function yB(e) {
  let t = hc(e);
  return t.error ? t : Cc(e);
}
function vB(e) {
  let t = ql({ ...e, removeScore: !0 });
  return t.error ? t : Cc(e);
}
function ql(e) {
  let t = "scoreModification";
  if (e.isCollectionMatchUp && e.dualMatchUp?.winningSide && !e.projectedWinningSide) {
    let n = hc(e);
    if (n.error) return F({ result: n, stack: t });
  }
  let r = !!e.matchUp.collectionId, i = zi({ ...e });
  if (r) {
    let { matchUpTieId: n, drawDefinition: a, matchUpsMap: o } = e, s = zn({ tournamentRecord: e.tournamentRecord, appliedPolicies: e.appliedPolicies, matchUpId: n, event: e.event, drawDefinition: a, matchUpsMap: o });
    if (s.error) return F({ result: s, stack: t });
    Object.assign(i, { tieMatchUpResult: s });
  }
  return F({ result: i, stack: t });
}
function PB({ drawDefinition: e, structure: t, matchUp: r }) {
  let { drawPositions: i } = r, { positionAssignments: n } = Je({ drawDefinition: e, structure: t }), a = n?.filter(({ drawPosition: c }) => i?.includes(c))?.map((c) => {
    let { extension: u } = we({ element: c, name: _n });
    return u?.value?.groupOrder;
  }), { containerStructures: o } = ec({ drawDefinition: e }), s = o[t.structureId];
  return { structureIds: tc({ drawDefinition: e, structureId: s })?.links?.source?.filter((c) => gr(a, c.source?.finishingPositions || [])).map((c) => c.source.structureId) };
}
function KR({ drawDefinition: e, structure: t, matchUp: r }) {
  let i = [];
  if (t.finishingPosition === Aa && wn({ drawDefinition: e, structure: t })) {
    let { structureIds: n } = PB({ drawDefinition: e, structure: t, matchUp: r });
    n?.length && i.push(...n);
  }
  return { connectedStructureIds: i };
}
function DB(e) {
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n, winningSide: a } = e, o = e.targetData.targetLinks?.winnerTargetLink;
  if (o.target.feedProfile === gi) {
    let s = i.sides.find(({ sideNumber: u }) => u !== a).participantId, c = r.find((u) => u.structureId === o.target.structureId && u.roundNumber === o.target.roundNumber && u.sides.some(({ participantId: l }) => l === s));
    if (c?.matchUpStatus === Dt) {
      let u = Ur({ matchUpId: c.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!Ba({ inContextDrawMatchUps: r, drawDefinition: n, targetData: u })) {
        let { structure: l } = me({ structureId: c.structureId, drawDefinition: n }), d = Je({ structure: l }).positionAssignments;
        for (let p of d || []) if (p.participantId === s) {
          let m = i.sides.find(({ sideNumber: f }) => f === a).participantId;
          if (p.participantId = m, l?.positionAssignments) l.positionAssignments = d;
          else if (l?.structures) {
            let f = Object.assign({}, ...(d || []).map((h) => ({ [h.drawPosition]: h.participantId })));
            for (let h of l.structures) h.positionAssignments?.forEach((g) => g.participantId = f[g.drawPosition]);
          }
          sa({ tournamentId: e.tournamentRecord?.tournamentId, event: e.event, drawDefinition: n, structure: l }), t = !0;
        }
      }
    }
  }
  return { ...x, qualifierReplaced: t };
}
function wB(e) {
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n, winningSide: a } = e, o = e.targetData.targetLinks?.winnerTargetLink;
  if (o.target.feedProfile === gi) {
    let s = i.sides.find(({ sideNumber: l }) => l === a)?.participantId, c = r.filter((l) => l.structureId === o.target.structureId && l.roundNumber === o.target.roundNumber && l.sides.some(({ participantId: d, qualifier: p }) => p && !d)), u = xr(c);
    if (u?.matchUpStatus === Dt) {
      let l = Ur({ matchUpId: u.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!Ba({ inContextDrawMatchUps: r, drawDefinition: n, targetData: l })) {
        let d = u.sides.find((f) => f.qualifier && !f.participantId)?.drawPosition, { structure: p } = me({ structureId: u.structureId, drawDefinition: n });
        if (!p) return { error: mt };
        let m = Je({ structure: p }).positionAssignments;
        for (let f of m || []) if (f.drawPosition === d && !f.participantId) {
          if (f.participantId = s, p.positionAssignments) p.positionAssignments = m;
          else if (p.structures) {
            let h = Object.assign({}, ...(m || []).map((g) => ({ [g.drawPosition]: g.participantId })));
            for (let g of p.structures) g.positionAssignments?.forEach((I) => I.participantId = h[I.drawPosition]);
          }
          sa({ tournamentId: e.tournamentRecord?.tournamentId, event: e.event, drawDefinition: n, structure: p }), t = !0;
        }
      }
    }
  }
  return { ...x, qualifierPlaced: t };
}
function TB(e) {
  let t = "attemptToSetWinningSide", r, i = {}, { appliedPolicies: n, disableAutoCalc: a, drawDefinition: o, dualMatchUp: s, winningSide: c, structure: u, matchUp: l } = e;
  if (s?._disableAutoCalc && a !== !1) return UI(e);
  if (l.winningSide && l.winningSide !== c) {
    let { connectedStructureIds: f } = KR({ drawDefinition: o, structure: u, matchUp: l });
    f.length && (console.log({ connectedStructureIds: f }), r = !0);
    let h = hc(e);
    if (h.error) return h;
  }
  let d = db(e);
  if (d.context?.progressExitStatus && Object.assign(i, d.context), d.error) return F({ result: d, stack: t });
  let p, m;
  return e.qualifierChanging && n?.[Hc]?.autoReplaceQualifiers && (p = DB(e).qualifierReplaced), e.qualifierAdvancing && n?.[Hc]?.autoPlaceQualifiers && (m = wB(e).qualifierPlaced), F({ result: ae({ ...x, ...d, connectedStructures: r, qualifierReplaced: p, qualifierPlaced: m, context: i }), stack: t });
}
function QR(e) {
  let { inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: n, targetData: a, matchUp: o } = e, { iteration: s = 0 } = e;
  s += 1;
  let c = "removeDoubleExit", { targetMatchUps: { loserMatchUp: u, winnerMatchUp: l, loserTargetDrawPosition: d }, targetLinks: { loserTargetLink: p } } = a;
  l && l.matchUpStatus !== "BYE" && Ey({ ...e, targetMatchUp: l, sourceMatchUp: o, iteration: s });
  let m = u?.matchUpStatus === "BYE" && (u?.feedRound || u?.roundNumber === 1), f = a?.targetLinks?.loserTargetLink?.linkCondition === Qi;
  if (m && f) {
    let h = t.filter(({ roundNumber: U, structureId: S }) => S === o.structureId && U === 1), g = h.map(({ roundPosition: U }) => U), I = qt(g.sort(), 2).find((U) => U.includes(o.roundPosition));
    if ((h.filter(({ roundPosition: U }) => I.includes(U))?.map(({ matchUpStatus: U }) => U)).every((U) => [xt, Mt].includes(U))) return F({ result: { ...x }, stack: c });
  }
  if (u && (u.matchUpStatus !== "BYE" || m)) {
    let h = t.find(({ matchUpId: I }) => I === u.matchUpId), { structure: g } = me({ drawDefinition: i, structureId: h.structureId });
    if (r?.progression?.doubleExitPropagateBye || m) zf({ drawPosition: d, targetLink: p, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: n });
    else {
      let I = Ey({ ...e, targetMatchUp: u, structure: g, iteration: s });
      if (I.error) return F({ result: I, stack: c });
    }
  }
  return F({ result: { ...x }, stack: c });
}
function Ey(e) {
  let { inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, sourceMatchUp: n, targetMatchUp: a, matchUpsMap: o, structure: s, iteration: c } = e, u = "conditionallyRemoveDrawPosition", l = Ur({ matchUpId: a.matchUpId, inContextDrawMatchUps: t, drawDefinition: i }), { targetMatchUps: { winnerMatchUp: d } } = l, p = o?.drawMatchUps.find((P) => P.matchUpId === a.matchUpId), m = [], f, h, g;
  if (a.feedRound) g = d?.drawPositions?.filter(Boolean)?.find((P) => a.drawPositions.includes(P));
  else if (!n) g = Pt(a?.drawPositions || [], d?.drawPositions || [])?.[0];
  else if (h = IT({ structureId: s.structureId, matchUp: n, matchUpsMap: o })?.pairedPreviousMatchUp, f = [Mt, xt].includes(h?.matchUpStatus), m = h?.drawPositions?.filter(Boolean) || [], [...Lt, "BYE"].includes(h?.matchUpStatus) || h?.winningSide) {
    let P = n.drawPositions || [], v = a.drawPositions?.filter(Boolean);
    gr(P, v) && (v = v?.filter((D) => !P.includes(D))), g = P.concat(m).find((D) => v?.includes(D));
  }
  d && g && zR({ winningDrawPosition: g, winnerMatchUp: d, inContextDrawMatchUps: t, drawDefinition: i, matchUpsMap: o });
  let I = QR({ targetData: l, matchUp: a, inContextDrawMatchUps: t, appliedPolicies: r, drawDefinition: i, matchUpsMap: o, structure: s, iteration: c });
  if (I.error) return F({ result: I, stack: u });
  let U = bB({ pairedPreviousDoubleExit: f, noContextTargetMatchUp: p }), S = !f;
  return I = zi({ ...e, matchUpId: a.matchUpId, matchUp: p, removeWinningSide: !0, matchUpStatusCodes: [], matchUpStatus: U, removeScore: S, score: { scoreStringSide1: "", scoreStringSide2: "", sets: void 0 } }), I.error ? F({ result: I, stack: u }) : { ...x };
}
function bB({ pairedPreviousDoubleExit: e, noContextTargetMatchUp: t }) {
  return t.matchUpStatus === "BYE" ? "BYE" : e ? [xt, Pe].includes(t?.matchUpStatus) ? Pe : be : Dt;
}
function MB(e) {
  let t, { inContextDrawMatchUps: r, inContextMatchUp: i, drawDefinition: n } = e, a = e.targetData.targetLinks?.winnerTargetLink;
  if (a.target.feedProfile === gi) {
    let o = i.sides?.find(({ sideNumber: c }) => c === i.winningSide)?.participantId, s = r.find((c) => c.structureId === a.target.structureId && c.roundNumber === a.target.roundNumber && c.sides?.some(({ participantId: u }) => u === o));
    if (s && s.matchUpStatus === Dt) {
      let c = Ur({ matchUpId: s.matchUpId, inContextDrawMatchUps: r, drawDefinition: n });
      if (!Ba({ inContextDrawMatchUps: r, drawDefinition: n, targetData: c })) {
        let { structure: u } = me({ structureId: s.structureId, drawDefinition: n }), l = Je({ structure: u }).positionAssignments;
        for (let d of l || []) if (d.participantId === o) {
          if (d.participantId = void 0, u?.positionAssignments) u.positionAssignments = l;
          else if (u?.structures) {
            let p = Object.assign({}, ...(l || []).map((m) => ({ [m.drawPosition]: m.participantId })));
            for (let m of u?.structures || []) m.positionAssignments?.forEach((f) => f.participantId = p[f.drawPosition]);
          }
          sa({ tournamentId: e.tournamentRecord?.tournamentId, event: e.event, drawDefinition: n, structure: u }), t = !0;
        }
      }
    }
  }
  return { qualifierRemoved: t };
}
function RB(e) {
  let { matchUp: t, matchUpStatus: r, score: i, winningSide: n } = e, a = "noDownStreamDependencies";
  if ([Mt, xt].includes(t?.matchUpStatus) && ![Mt, xt].includes(r)) {
    let g = QR(e);
    if (g.error) return F({ result: g, stack: a });
  }
  let o = r === Mt, s = Bt({ score: i }) && !o && (e.isCollectionMatchUp && !e.projectedWinningSide || !n), c = e?.inContextMatchUp?.collectionId && IB(e.inContextMatchUp), u = e.removeScore || !c && ![$r, Or].includes(r || $r), l = e.isCollectionMatchUp && e.dualMatchUp.winningSide && !e.projectedWinningSide || t.winningSide && !n && !Bt({ score: i }), d = (g) => {
    let I, { structure: U, drawDefinition: S, dualMatchUp: P, disableAutoCalc: v } = e;
    if (P?._disableAutoCalc && v !== !1) return UI({ ...e, removeWinningSide: l });
    let { connectedStructureIds: D } = KR({ drawDefinition: S, structure: U, matchUp: t });
    D.length && (console.log({ connectedStructureIds: D }), I = !0), Object.assign(e, { removeScore: g });
    let y = hc(e);
    if (y.error) return y;
    if (e.removingQualifier && e.appliedPolicies?.[Hc]?.autoRemoveQualifiers) {
      let w = MB(e);
      return { ...x, connectedStructures: I, ...w };
    }
    return { ...x, connectedStructures: I };
  };
  if (l && n && e.isCollectionMatchUp) return Ay(e);
  let p = [nn, Or].includes(r) && e.dualWinningSideChange, m = r && r !== Dt, f = e.propagateExitStatus && [be, Pe].includes(r), h = (n || p || f) && TB(e) || s && d(u) || m && SB(e) || l && d(u) || t && Ay({ ...e, removeScore: !0 }) || { ...x };
  return F({ result: h, stack: a });
}
function Ay(e) {
  let t = "ndd:scoreModification";
  if (e.isCollectionMatchUp && e.dualMatchUp?.winningSide && !e.projectedWinningSide && !e.autoCalcDisabled) {
    let i = hc(e);
    if (i.error) return i;
  }
  let r = zi({ ...e });
  if (e.isCollectionMatchUp) {
    let { matchUpTieId: i, drawDefinition: n, event: a, matchUpsMap: o } = e, { removeWinningSide: s } = zn({ tournamentRecord: e.tournamentRecord, appliedPolicies: e.appliedPolicies, matchUpId: i, drawDefinition: n, matchUpsMap: o, event: a });
    s && console.log("REMOVE WINNING SIDE");
  }
  return F({ result: r, stack: t });
}
function jU(e) {
  let t = oe(e, [{ [Vt]: !0, [lr]: !0, [tn]: !0 }, { homeParticipantId: !0, [yi]: Ft }]);
  if (t.error) return t;
  let r = lc(e, [{ [Ks]: Tn, attr: { [Zd]: !0 } }]);
  if (r.error) return r;
  let i = r?.matchUp?.matchUp?.sides?.map((l) => l?.participantId);
  if (e.homeParticipantId && !i?.includes(e.homeParticipantId)) return { error: Li };
  let { disableNotice: n, homeParticipantId: a, removePriorValues: o, tournamentRecord: s, drawDefinition: c, matchUpId: u } = e;
  return Wr({ duplicateValues: !1, removePriorValues: o, tournamentRecord: s, drawDefinition: c, disableNotice: n, matchUpId: u, timeItem: { itemType: Cg, itemValue: a } });
}
function XR({ timeStamp: e, schedule: t, matchUp: r }) {
  let { itemValue: i, timeStamp: n } = Za({ timeItems: r?.timeItems || [], itemType: Ip });
  return !t || n && e && new Date(n).getTime() > new Date(e).getTime() ? { timeModifiers: i } : t;
}
function Sa(e) {
  let t = "addMatchUpScheduledTime", r = e.matchUp, { removePriorValues: i, tournamentRecord: n, drawDefinition: a, disableNotice: o, scheduledTime: s, matchUpId: c } = e;
  if (!c) return F({ result: { error: pr }, stack: t });
  if (!zs(s)) return F({ result: { error: fi }, stack: t });
  if (!r) {
    let m = ut({ drawDefinition: a, matchUpId: c });
    if (m.error) return F({ result: m, stack: t });
    r = m.matchUp;
  }
  let u = ve(s), l = qo({ matchUp: r }).scheduledDate, d = u && !l;
  if ((XR({ matchUp: r }).timeModifiers || [])?.length) {
    let m = JR({ disableNotice: !0, removePriorValues: i, tournamentRecord: n, timeModifiers: [], drawDefinition: a, matchUpId: c, matchUp: r });
    if (m?.error) return F({ result: m, stack: t });
  }
  let p = xo(s, !0, d);
  return Wr({ duplicateValues: !1, removePriorValues: i, tournamentRecord: n, drawDefinition: a, disableNotice: o, matchUpId: c, timeItem: { itemType: Go, itemValue: p } });
}
function JR({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, timeModifiers: n, matchUpId: a, matchUp: o }) {
  let s = "addMatchUpTimeModifiers";
  if (!a) return F({ result: { error: pr }, stack: s });
  if (n !== void 0 && !Array.isArray(n)) return F({ info: La("timeModifiers"), result: { error: z }, stack: s });
  if (!o) {
    let d = ut({ drawDefinition: r, matchUpId: a });
    if (d.error) return F({ result: d, stack: s });
    o = d.matchUp;
  }
  let c = XR({ matchUp: o }).timeModifiers || [], u = n.filter((d) => !c.includes(d));
  if (n.length && !u.length) return { ...x };
  if (u.some((d) => Df.includes(d))) {
    c = c.filter((p) => !Df.includes(p));
    let d = Sa({ disableNotice: !0, removePriorValues: e, scheduledTime: "", tournamentRecord: t, drawDefinition: r, matchUpId: a });
    if (d.error) return F({ result: d, stack: s });
  }
  let l = n?.length ? [...u, ...c] : void 0;
  return Wr({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: { itemType: Ip, itemValue: l } });
}
function Sm({ scheduledDate: e, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a }) {
  if (!a) return { error: pr };
  let o = e && Yi.test(e);
  if (e && !o) return { error: Ht };
  let s = { itemValue: ve(e), itemType: jo };
  return Wr({ duplicateValues: !1, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: s });
}
function ym({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, courtDayDate: a, matchUpId: o, courtIds: s }) {
  if (!r && !t) return { error: J };
  if (!o) return { error: pr };
  let c = ut({ drawDefinition: i, matchUpId: o });
  if (c.error) return c;
  if (c?.matchUp?.matchUpType !== Hr) return { error: Cr };
  if (!(s === void 0 || Array.isArray(s) && s.length && s.every((l) => typeof l == "string"))) return { error: z, context: { courtIds: s } };
  let u;
  if (s) {
    let l = t || r && { [r.tournamentId]: r }, d = Yn({ tournamentRecords: l });
    if (d.error) return d;
    let p = d.courts?.filter((m) => s.includes(m.courtId));
    if (p?.length !== s.length) return { error: z, context: { courtIds: s } };
    u = p?.map((m) => ({ venueId: m.venueId, courtId: m.courtId }));
  }
  return Wr({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, timeItem: { itemType: Dn, itemDate: a, itemValue: u } });
}
function gc({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, venueId: o }) {
  if (!r) return { error: J };
  if (!a) return { error: pr };
  if (o) {
    let s = Mn({ tournamentRecords: t, tournamentRecord: r, venueId: o });
    if (s.error) return s;
  }
  return Wr({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: { itemType: Vo, itemValue: o } });
}
function rs({ removePriorValues: e, tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, courtDayDate: a, matchUpId: o, courtId: s }) {
  if (!r && !t) return { error: J };
  if (!o) return { error: pr };
  if (s) {
    let c = Wo({ tournamentRecords: t, tournamentRecord: r, courtId: s });
    if (c.error) return c;
    let u = c.venue?.venueId;
    gc({ tournamentRecords: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, venueId: u });
  }
  return Wr({ duplicateValues: !1, removePriorValues: e, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: o, timeItem: { itemType: ca, itemDate: a, itemValue: s } });
}
function $i(e, t) {
  let r = GP.test(e) ? e : ct(e), i = ve(e) || ve(t) || Ui(/* @__PURE__ */ new Date());
  return (/* @__PURE__ */ new Date(`${i}T${r}`)).getTime();
}
function vm(e) {
  let t = "addMatchUpScheduleItems", r = oe(e, [{ drawDefinition: !0, matchUpId: !0 }, { schedule: !0, [Mr]: Nr }], t);
  if (r.error) return r;
  let { matchUpDependencies: i, inContextMatchUps: n } = e, { errorOnAnachronism: a = !1, checkChronology: o = !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: l, disableNotice: d, drawMatchUps: p, matchUpId: m, schedule: f, event: h } = e, g, I;
  if (p) g = p.find((N) => N.matchUpId === m);
  else {
    let N = ut({ drawDefinition: l, event: h, matchUpId: m });
    if (N.error) return N;
    g = N.matchUp;
  }
  let { endTime: U, courtId: S, courtIds: P, courtOrder: v, resumeTime: D, homeParticipantId: y, scheduledDate: w, scheduledTime: b, startTime: T, stopTime: R, timeModifiers: M, venueId: E } = f;
  o && (!i || !n) && ({ matchUpDependencies: i, matchUps: n } = Ei({ drawDefinition: l }));
  let A = i?.[m]?.matchUpIds;
  if (f.scheduledDate && o && A) {
    let N = n?.filter((C) => (C.schedule?.scheduledDate || ve(C.schedule?.scheduledTime)) && A.includes(C.matchUpId)).map(({ schedule: C }) => {
      let k = Kl(C);
      return new Date(k).getTime();
    });
    if (N?.length) {
      let C = Kl(f), k = new Date(C).getTime();
      if (Math.max(...N) >= k) {
        if (a) return F({ result: { error: nf }, stack: t });
        I = nf;
      }
    }
  }
  if (w !== void 0) {
    let N = Sm({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, scheduledDate: w, matchUpId: m });
    if (N?.error) return F({ result: N, stack: t, context: { scheduledDate: w } });
  }
  if (b !== void 0) {
    let N = Sa({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, scheduledTime: b, matchUpId: m, matchUp: g });
    if (N?.error) return F({ result: N, stack: t, context: { scheduledTime: b } });
  }
  if (T !== void 0) {
    let N = $U({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, matchUpId: m, startTime: T, event: h });
    if (N?.error) return F({ result: N, stack: t, context: { startTime: T } });
  }
  if (R !== void 0) {
    let N = WU({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, matchUpId: m, stopTime: R, event: h });
    if (N?.error) return F({ result: N, stack: t, context: { stopTime: R } });
  }
  if (D !== void 0) {
    let N = HU({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, resumeTime: D, matchUpId: m, event: h });
    if (N?.error) return F({ result: N, stack: t, context: { resumeTime: D } });
  }
  if (U !== void 0) {
    let N = qU({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, matchUpId: m, endTime: U, event: h });
    if (N?.error) return F({ result: N, stack: t, context: { endTime: U } });
  }
  if (P !== void 0) {
    let N = ym({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, matchUpId: m, courtIds: P });
    if (N?.error) return F({ result: N, stack: t, context: { courtIds: P } });
  }
  if (S !== void 0 && w !== void 0) {
    let N = rs({ courtDayDate: w, disableNotice: !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: l, matchUpId: m, courtId: S });
    if (N?.error) return F({ result: N, stack: t, context: { courtId: S } });
  }
  if (E !== void 0) {
    let N = gc({ disableNotice: !0, removePriorValues: s, tournamentRecords: c, tournamentRecord: u, drawDefinition: l, matchUpId: m, venueId: E });
    if (N?.error) return F({ result: N, stack: t, context: { venueId: E } });
  }
  if (v !== void 0 && Ie(v)) {
    let N = GU({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, courtOrder: v, matchUpId: m });
    if (N?.error) return F({ result: N, stack: t, context: { courtOrder: v } });
  }
  if (M !== void 0) {
    let N = JR({ disableNotice: !0, removePriorValues: s, tournamentRecord: u, drawDefinition: l, timeModifiers: M, matchUpId: m, matchUp: g });
    if (N?.error) return F({ result: N, stack: t, context: { timeModifiers: M } });
  }
  return dt(y) && jU({ disableNotice: !0, homeParticipantId: y, removePriorValues: s, tournamentRecord: u, drawDefinition: l, matchUpId: m }), d || Oe({ tournamentId: u?.tournamentId, eventId: h?.eventId, context: t, drawDefinition: l, matchUp: g }), I ? { ...x, warnings: [I] } : { ...x };
}
function GU({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, courtOrder: n, matchUpId: a }) {
  if (!a) return { error: pr };
  if (n && !Ie(n)) return { error: z, info: "courtOrder must be numeric" };
  let o = n && pe(n);
  return Wr({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: { itemType: gp, itemValue: o } });
}
function ZR({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, participantId: n, officialType: a, matchUpId: o }) {
  if (!o) return { error: pr };
  if (!n) return { error: Ft };
  if (t) {
    let c = ft({ tournamentRecord: t, participantFilters: { participantTypes: [Ne], participantRoles: [$g] } }).participants ?? [];
    if (!na({ tournamentParticipants: c, participantId: n })) return { error: Tt };
  }
  let s = { itemType: "SCHEDULE.ASSIGNMENT.OFFICIAL", itemValue: n };
  return a && (s.itemSubTypes = [a]), Wr({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: o, timeItem: s });
}
function $U({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, startTime: a, event: o }) {
  if (!n) return { error: pr };
  if (!zs(a)) return { error: fi };
  let { matchUp: s } = ut({ drawDefinition: r, event: o, matchUpId: n }), { scheduledDate: c } = qo({ matchUp: s }), u = (s?.timeItems ?? []).filter((l) => [On, ln, Vn].includes(l?.itemType)).map((l) => $i(l.itemValue, c)).reduce((l, d) => !l || d < l ? d : l, void 0);
  if (!u || $i(a, c) < u) {
    s?.timeItems && (s.timeItems = s.timeItems.filter((d) => d.itemType !== Ci));
    let l = xo(a, !0, !0);
    return Wr({ duplicateValues: !1, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, timeItem: { itemType: Ci, itemValue: l } });
  } else return { error: mP };
}
function qU({ validateTimeSeries: e = !0, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, endTime: o, event: s }) {
  if (!a) return { error: pr };
  if (!zs(o)) return { error: fi };
  let { matchUp: c } = ut({ drawDefinition: i, event: s, matchUpId: a }), { scheduledDate: u } = qo({ matchUp: c }), l = (c?.timeItems ?? []).filter((d) => [Ci, ln, On].includes(d?.itemType)).map((d) => $i(d.itemValue, u)).reduce((d, p) => !d || p > d ? p : d, void 0);
  if (!e || !l || $i(o, u) > l) {
    c?.timeItems && (c.timeItems = c.timeItems.filter((p) => p.itemType !== Vn));
    let d = xo(o, !0, !0);
    return Wr({ duplicateValues: !1, removePriorValues: t, tournamentRecord: r, drawDefinition: i, disableNotice: n, matchUpId: a, timeItem: { itemType: Vn, itemValue: d } });
  } else return { error: dP };
}
function WU({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, stopTime: a, event: o }) {
  if (!n) return { error: pr };
  if (!zs(a)) return { error: fi };
  let { matchUp: s } = ut({ drawDefinition: r, event: o, matchUpId: n }), { scheduledDate: c } = qo({ matchUp: s }), u = s?.timeItems ?? [];
  if (u.reduce((f, h) => h.itemType === Vn || f, void 0)) return { error: vh };
  let l = u.filter((f) => [Ci, ln, On].includes(f?.itemType)).sort((f, h) => $i(f.itemValue, c) - $i(h.itemValue, c)), d = l[l.length - 1], p = d && d.itemType === On, m = l.filter((f) => !p || f.createdAt !== d.createdAt).map((f) => $i(f.itemValue, c)).reduce((f, h) => !f || h > f ? h : f, void 0);
  if ($i(a, c) > m) {
    if (s?.timeItems && p) {
      let h = d.createdAt;
      s.timeItems = s.timeItems.filter((g) => g.createdAt !== h);
    }
    let f = { itemValue: xo(a, !0, !0), itemType: On };
    return Wr({ duplicateValues: !0, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: n, timeItem: f });
  } else return { error: pP };
}
function HU({ removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, resumeTime: n, matchUpId: a, event: o }) {
  if (!a) return { error: pr };
  if (!zs(n)) return { error: fi };
  let { matchUp: s } = ut({ drawDefinition: r, event: o, matchUpId: a }), { scheduledDate: c } = qo({ matchUp: s }), u = s?.timeItems ?? [];
  if (u.reduce((f, h) => h.itemType === Vn || f, void 0)) return { error: vh };
  let l = u.filter((f) => [Ci, ln, On].includes(f?.itemType)).sort((f, h) => $i(f.itemValue, c) - $i(h.itemValue, c)), d = l[l.length - 1], p = d && d.itemType === ln, m = l.filter((f) => !p || f.createdAt !== d.createdAt).map((f) => $i(f.itemValue, c)).reduce((f, h) => !f || h > f ? h : f, void 0);
  if ($i(n, c) > m) {
    if (s?.timeItems && p) {
      let h = d.createdAt;
      s.timeItems = s.timeItems.filter((g) => g.createdAt !== h);
    }
    let f = { itemValue: xo(n, !0, !0), itemType: ln };
    return Wr({ duplicateValues: !0, removePriorValues: e, tournamentRecord: t, drawDefinition: r, disableNotice: i, matchUpId: a, timeItem: f });
  } else return { error: GC };
}
function NB({ drawDefinition: e, matchUpStatus: t, matchUpsMap: r, winningSide: i, dualMatchUp: n, tieFormat: a, structure: o, matchUp: s, event: c, score: u }) {
  let l = ie(n, void 0, !0);
  for (let p of l?.tieMatchUps || []) p.matchUpId === s.matchUpId && (p.winningSide = i, p.score = u, !Bt({ score: u }) && !t ? Object.assign(p, { ...Cp }) : t && (p.matchUpStatus = t));
  a = a ?? dr({ matchUp: s, structure: o, drawDefinition: e, event: c })?.tieFormat;
  let { winningSide: d } = al({ matchUp: l, drawDefinition: e, matchUpsMap: r, structure: o, tieFormat: a, event: c });
  return { projectedWinningSide: d };
}
function EB(e) {
  let { tournamentRecord: t, inContextMatchUp: r, structure: i, drawDefinition: n } = e, a = r.roundNumber, o = r.sides.find((v) => v.sideNumber === r.winningSide), s = r.sides.find((v) => v.sideNumber !== r.winningSide), { drawPosition: c, participantId: u } = o, { drawPosition: l, participantId: d } = s, p = "swapWinnerLoser", { matchUps: m } = Ve(e), f = m.filter(({ drawPositions: v, roundNumber: D }) => v?.includes(c) && D > a);
  Yr({ changeWinner: !0 }) && console.log({ existingWinnerSubsequentMatchUps: f }), f.forEach((v) => {
    v.drawPositions = v.drawPositions?.map((D) => D === c ? l : D) || [], Oe({ tournamentId: t?.tournamentId, eventId: e.event?.eventId, context: p, drawDefinition: n, matchUp: v });
  });
  let { stage: h, stageSequence: g } = i, I = n.structures.filter(({ stage: v, stageSequence: D }) => v === h && D > g).map(({ structureId: v }) => v), { targetLinks: { loserTargetLink: U, winnerTargetLink: S } } = e.targetData, P = [U?.target.structureId, S?.target?.structureId].filter(Boolean);
  return n.structures.filter(({ stage: v, structureId: D }) => v !== h && P.includes(D)).forEach(({ stage: v, stageSequence: D, structureId: y }) => {
    I.includes(y) || I.push(y), n.structures.filter(({ stage: w, stageSequence: b }) => w === v && b > D).forEach(({ structureId: w }) => {
      I.includes(w) || I.push(w);
    });
  }), n.structures.filter(({ structureId: v }) => I.includes(v)).forEach((v) => {
    let { positionAssignments: D } = Je({ structure: v }), y = D?.find(({ participantId: b }) => b === u), w = D?.find(({ participantId: b }) => b === d);
    y && (y.participantId = d), w && (w.participantId = u);
  }), zi({ ...e });
}
function Ic(e) {
  let t = "setMatchUpState";
  e.matchUpStatus && [be, Mt].includes(e.matchUpStatus) && (e.score = void 0);
  let { allowChangePropagation: r, disableScoreValidation: i, propagateExitStatus: n, tournamentRecords: a, tournamentRecord: o, disableAutoCalc: s, enableAutoCalc: c, drawDefinition: u, matchUpStatus: l, winningSide: d, matchUpId: p, event: m, score: f } = e;
  if (!u) return { error: ne };
  if (l && [nn, $r, Or, Dt].includes(l) && d) return { error: z, winningSide: d, matchUpStatus: l };
  if (![void 0, ...nw].includes(l)) return F({ result: { error: Gs }, info: "matchUpStatus does not exist", stack: "setMatchUpStatus" });
  let h = or({ drawDefinition: u }), { matchUps: g } = Et({ nextMatchUps: !0, tournamentRecord: o, inContext: !0, drawDefinition: u, matchUpsMap: h, event: m }), I = h.drawMatchUps.find((j) => j.matchUpId === p), U = g?.find((j) => j.matchUpId === p);
  if (!I || !g) return { error: cr };
  if ((I.winningSide || d) && l === "BYE") return { context: "Cannot have Bye with winningSide", error: Al, matchUpStatus: l };
  let S = U?.structureId, { structure: P } = me({ drawDefinition: u, structureId: S }), v = bt(ot)(I.matchUpType), D = U?.drawPositions?.filter(Boolean), y = U?.matchUpTieId, w = Ur({ matchUpId: y || p, inContextDrawMatchUps: g, drawDefinition: u });
  Object.assign(e, { inContextDrawMatchUps: g, inContextMatchUp: U, matchUpTieId: y, matchUpsMap: h, targetData: w, structure: P, matchUp: I });
  let b = Ba(e), T;
  if (v) {
    if (s) Be({ extension: { name: Po, value: !0 }, element: I });
    else if (c) {
      let j = I.winningSide, { winningSide: H, scoreStringSide1: G, scoreStringSide2: V, set: $ } = al({ drawDefinition: u, matchUpsMap: h, structure: P, matchUp: I, event: m }), q = { scoreStringSide1: G, scoreStringSide2: V, sets: $ ? [$] : [] };
      if (T = H !== j, b && T) return F({ stack: "winningSideWithDownstreamDependencies", result: { error: kd }, context: { winningSide: d, matchUp: I } });
      fr({ name: Po, element: I }), Object.assign(e, { winningSide: H, dualWinningSideChange: T, projectedWinningSide: H, score: q });
    }
    ol({ tournamentId: o?.tournamentId, inContextDualMatchUp: U, eventId: m?.eventId, dualMatchUp: I, drawDefinition: u });
  }
  if (v && l && [Lo].includes(l)) return { info: "Not supported for matchUpType: TEAM", error: z };
  if (f && !v && !i) {
    let j = I.matchUpFormat ?? P?.matchUpFormat ?? u?.matchUpFormat ?? m?.matchUpFormat, H = $I({ existingMatchUpStatus: I.matchUpStatus, matchUpFormat: j, matchUpStatus: l, winningSide: d, score: f });
    if (H.error) return H;
  }
  let R = _e({ policyTypes: [Hc, oi], tournamentRecord: o, drawDefinition: u, event: m })?.appliedPolicies ?? {};
  xe(e.policyDefinitions) && Object.assign(R, e.policyDefinitions);
  let M = CB({ assignedDrawPositions: D, propagateExitStatus: n, inContextMatchUp: U, appliedPolicies: R, drawDefinition: u, matchUpStatus: l, structure: P, matchUp: I });
  if (M?.error) return M;
  let E = U?.stage === se && U.finishingRound === 1, A = E && d, N = E && I.winningSide && !d && (!e.matchUpStatus || e.matchUpStatus && Mf({ matchUpStatus: e.matchUpStatus })) && (!e.outcome || !Bt({ outcome: e.outcome })), C = A && d !== I.winningSide && I.winningSide;
  if (Object.assign(e, { qualifierAdvancing: A, qualifierChanging: C, removingQualifier: N, appliedPolicies: R }), y) {
    let { matchUp: j } = ut({ matchUpId: y, inContext: !0, drawDefinition: u, matchUpsMap: h, event: m });
    if (j) {
      let H = dr({ matchUp: j, drawDefinition: u, structure: P, event: m })?.tieFormat, { projectedWinningSide: G } = NB({ drawDefinition: u, matchUpStatus: l, dualMatchUp: j, matchUpsMap: h, winningSide: d, tieFormat: H, structure: P, matchUp: I, event: m, score: f }), V = j.winningSide;
      T = G !== V;
      let $ = j._disableAutoCalc;
      Object.assign(e, { isCollectionMatchUp: !0, dualWinningSideChange: T, projectedWinningSide: G, autoCalcDisabled: $, matchUpTieId: y, dualMatchUp: j, tieFormat: H });
    }
  }
  let k = Wu({ matchUpStatus: l });
  if (!y) {
    if (b && !d && (l && Mf({ matchUpStatus: l }) || l && [Mt, xt].includes(l))) return { error: Al, activeDownstream: b, winningSide: d };
    if (d && d === I.winningSide && l && !k) return { context: "winningSide must include directing matchUpStatus", error: Al, directingMatchUpStatus: k, matchUpStatus: l };
  }
  let { schedule: O } = e;
  if (O) {
    let j = vm({ disableNotice: !0, tournamentRecords: a, tournamentRecord: o, drawDefinition: u, matchUpId: p, schedule: O });
    if (j.error) return j;
  }
  let _ = !v && !T && d && I.winningSide && I.winningSide !== d;
  if (r && _ && I.roundPosition) return EB(e);
  let B = d && !y || e.projectedWinningSide, L = !b && RB(e) || B && AB(e) || (k || e.autoCalcDisabled) && eN(e) || { error: vP };
  return F({ result: L, stack: t });
}
function AB(e) {
  let { matchUp: t, winningSide: r, matchUpTieId: i, dualWinningSideChange: n } = e;
  return r === t.winningSide || i && !n ? eN(e) : F({ stack: "winningSideWithDownstreamDependencies", result: { error: kd }, context: { winningSide: r, matchUp: t } });
}
function eN(e) {
  let { tournamentRecord: t, matchUp: r, event: i } = e, n = e.isCollectionMatchUp && r.winningSide && !e.winningSide && !Bt({ score: e.score }), a = e.isCollectionMatchUp ? e.matchUpStatus || n && Dt || e.winningSide && vt || $r : e.matchUpStatus || vt, o = e.removeScore || [nn, be].includes(a) && ![$r, Or].includes(a), s = zi({ ...e, matchUpStatus: a, removeWinningSide: n, removeScore: o });
  if (s.error) return s;
  if (e.isCollectionMatchUp) {
    let { matchUpTieId: c, drawDefinition: u, matchUpsMap: l } = e, d = zn({ appliedPolicies: e.appliedPolicies, matchUpId: c, tournamentRecord: t, drawDefinition: u, matchUpsMap: l, event: i });
    if (d.error) return d;
    Object.assign(s, { tieMatchUpResult: d });
  }
  return s;
}
function CB({ assignedDrawPositions: e, propagateExitStatus: t, inContextMatchUp: r, appliedPolicies: i, drawDefinition: n, matchUpStatus: a, structure: o, matchUp: s }) {
  if (i?.[oi]?.requireParticipantsForScoring === !1) return { ...x };
  let c = r?.sides?.map((d) => d.participantId).filter(Boolean).length, u = s?.sides ? [] : Je({ structureId: o?.structureId, drawDefinition: n }).positionAssignments, l = c && c === 2 || s.collectionId && Tr({ structure: o }) && c && c >= 1 || e?.length === 2 && u?.filter((d) => e.includes(d.drawPosition)).every((d) => d.participantId);
  return a && [be, Pe, Mt].includes(a) && c === 1 && t ? { ...x } : a && iw.includes(a) && !l ? F({ info: "matchUpStatus requires assigned participants", context: { matchUpStatus: a, requiredParticipants: l, propagateExitStatus: t, participantsCount: c }, result: { error: Gs } }) : { ...x };
}
function tN({ tournamentRecord: e, drawDefinition: t, matchUpId: r, event: i }) {
  if (!t) return { error: ne };
  let { matchUp: n } = ut({ drawDefinition: t, matchUpId: r, event: i });
  return n?.matchUpType !== Hr ? { error: Cr } : Ic({ enableAutoCalc: !0, tournamentRecord: e, drawDefinition: t, matchUpId: r, event: i });
}
function rN({ drawDefinition: e, event: t, matchUpId: r }) {
  if (!e) return { error: ne };
  if (!r) return { error: pr };
  let { matchUp: i } = ut({ drawDefinition: e, event: t, matchUpId: r });
  return i ? fr({ name: ap, element: i }) : { error: cr };
}
function OB({ substituteParticipantId: e, existingParticipantId: t, tournamentRecord: r, drawDefinition: i, sideNumber: n, matchUpId: a, event: o }) {
  let s = "substituteParticipant";
  if (!i) return { error: ne };
  if (!a) return { error: pr };
  if (!t || !e) return F({ result: { error: Ft }, stack: s });
  let { matchUp: c } = ut({ drawDefinition: i, matchUpId: a, event: o });
  if (!c) return { error: cr };
  if (!c.collectionId) return F({ result: { error: Cr }, stack: s });
  let u = or({ drawDefinition: i }), { matchUps: l } = Et({ tournamentParticipants: r?.participants, inContext: !0, drawDefinition: i, matchUpsMap: u }), d = l?.find((m) => m.matchUpId === a), p = l?.find((m) => m.matchUpId === d?.matchUpTieId)?.sides?.find((m) => m.participant.individualParticipants.some(({ participantId: f }) => f === t));
  return !p || n && p.sideNumber !== n ? { error: Li } : p.participant?.individualParticipants?.map(Re).filter((m) => m !== t)?.includes(e) ? BU({ newParticipantId: e, tieMatchUpId: a, existingParticipantId: t, substitution: !0, tournamentRecord: r, drawDefinition: i, event: o }) : F({ result: { error: Li }, stack: s });
}
function iN(e) {
  return OB(e);
}
function nN({ drawDefinition: e, matchUpId: t, event: r }) {
  if (!e) return { error: ne };
  let { matchUp: i } = ut({ drawDefinition: e, matchUpId: t, event: r });
  return Be({ extension: { name: Po, value: !0 }, element: i });
}
function aN(e) {
  let t = "setMatchUpFormat", r = oe(e, [{ tournamentRecord: !0 }, { [tr]: (v) => Vr({ matchUpFormat: v }), [Kr]: fu, matchUpFormat: !0 }]);
  if (r.error) return F({ result: r, stack: t });
  let { tournamentRecord: i, drawDefinition: n, scheduledDates: a, stageSequences: o, matchUpFormat: s, structureId: c, eventType: u, matchUpId: l, eventId: d, stages: p, drawId: m, event: f, force: h } = e;
  if (a && !Array.isArray(a)) return F({ result: { error: z, scheduledDates: a }, stack: t });
  if (u && !Md([Ki, ai], u)) return F({ result: { error: fn }, stack: t });
  let g = 0, I = e.structureIds || c && [c].filter(Boolean) || [], U = e.eventIds || d && [d].filter(Boolean) || [], S = e.drawIds || m && [m].filter(Boolean) || [];
  if ((c || I?.length) && !n) return F({ result: { error: ne }, stack: t });
  if (m && l && n) {
    let v = zI({ tournamentRecord: i, drawDefinition: n, matchUpFormat: s, structureIds: I, structureId: c, matchUpId: l });
    if (v.error) return v;
    g += 1;
  }
  let P = (v) => {
    let D = [];
    for (let y of v.structures || []) {
      if (Array.isArray(p) && !p.includes(y.stage) || Array.isArray(o) && !o.includes(y.stageSequence) || I?.length && !I.includes(y.structureId)) continue;
      I?.length && y.matchUpFormat !== s && (y.matchUpFormat = s, D.push(y.structureId), g += 1);
      let w = ((h || a) && Ve({ matchUpFilters: { matchUpStatuses: [Dt] }, structure: y }).matchUps) ?? [], b = (a && Ve({ matchUpFilters: { matchUpStatuses: [Dt] }, contextFilters: { scheduledDates: a }, afterRecoveryTimes: !1, inContext: !0, structure: y }).matchUps) ?? [];
      if (w?.length) {
        let T = b ? b.map($t) : w.map($t);
        for (let R of w) T.includes(R.matchUpId) && (R.matchUpFormat = a?.length ? s : void 0, Oe({ tournamentId: i?.tournamentId, eventId: f?.eventId, context: t, drawDefinition: v, matchUp: R }));
      }
    }
    return !D.length && v.matchUpFormat !== s && (v.matchUpFormat = s, g += 1), D;
  };
  for (let v of i?.events || []) if (!(U?.length && !U.includes(v.eventId) || u && u !== v.eventType || u === kt)) if (Array.isArray(o) || Array.isArray(p) || I?.length || S?.length) for (let D of v.drawDefinitions || []) {
    if (Array.isArray(S) && !S.includes(D.drawId)) continue;
    let y = P(D);
    tt({ structureIds: y, drawDefinition: D });
  }
  else v.matchUpFormat !== s && (v.matchUpFormat = s, g += 1);
  return g ? { ...x, modificationsCount: g } : { ...x, info: Hs };
}
function zU({ inheritance: e = !0, tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n }) {
  if (!r) return { error: ne };
  let a = ut({ drawDefinition: r, matchUpId: i })?.matchUp;
  if (!a?.tieMatchUps) return { error: Cr };
  let o = ut({ inContext: !0, drawDefinition: r, matchUpId: i, event: n })?.matchUp, s = 0;
  return (a?.sides || []).forEach((c) => {
    c.lineUp && delete c.lineUp;
  }), (o?.sides || []).forEach((c) => {
    if (s += 1, e === !1) {
      let u = o?.tieFormat, l = c.participantId;
      u && l && Qo({ drawDefinition: r, participantId: l, lineUp: [], tieFormat: u });
    }
    Oe({ tournamentId: t?.tournamentId, context: "resetMatchUpLineUps", eventId: n?.eventId, drawDefinition: r, matchUp: a });
  }), { ...x, modificationsCount: s };
}
function oN(e) {
  let { matchUpFormat: t, matchUpStatus: r, winningSide: i, score: n, setTBlast: a } = e;
  if (!n) return { sets: [] };
  let o = n.sets || [], s = pn({ winnerFirst: !1, matchUpFormat: t, matchUpStatus: r, setTBlast: a, sets: o }), c = pn({ winnerFirst: !1, reversed: !0, matchUpFormat: t, matchUpStatus: r, setTBlast: a, sets: o }), u = pn({ matchUpFormat: t, matchUpStatus: r, winningSide: i, setTBlast: a, sets: o }), l = s === u ? c : s;
  return i && (s = i === 1 ? u : l, c = i === 2 ? u : l), { score: { sets: o, scoreStringSide1: s, scoreStringSide2: c } };
}
function kB({ sourceMatchUpStatusCodes: e, propagateExitStatus: t, sourceMatchUpStatus: r, loserParticipantId: i, tournamentRecord: n, drawDefinition: a, loserMatchUp: o, matchUpsMap: s, event: c }) {
  let u = "progressExitStatus", l = [be, Pe].includes(r) && r || be, d = Et({ inContext: !0, drawDefinition: a, matchUpsMap: s })?.matchUps, p = l, m = d?.find((f) => f.matchUpId === o?.matchUpId);
  if (m?.matchUpId && p) {
    let f, h = m.matchUpStatusCodes?.map((U) => typeof U == "string" ? U : "WO") ?? [], g = m.sides?.find((U) => U.participantId === i);
    if (g?.sideNumber) if (m?.sides?.reduce((U, S) => S?.participantId ? U + 1 : U, 0) === 1 && h.length === 0) f = g.sideNumber === 1 ? 2 : 1, h[0] = e[0];
    else if (![be, Pe].includes(o.matchUpStatus)) f = g.sideNumber === 1 ? 2 : 1, h[0] = e[0];
    else {
      let U = h[0];
      h[g.sideNumber - 1] = e[0];
      let S = g.sideNumber === 1 ? 2 : 1;
      h[S - 1] = U, p = Mt, f = void 0;
    }
    let I = Ic({ matchUpStatus: p, matchUpId: o.matchUpId, matchUpStatusCodes: h, allowChangePropagation: !0, propagateExitStatus: t, tournamentRecord: n, drawDefinition: a, winningSide: f, event: c });
    return F({ result: I, stack: u, context: { progressExitStatus: !0 } });
  }
  return F({ result: { error: Dr }, stack: u });
}
function yl(e) {
  let t = oe(e, [{ [tn]: !0, [lr]: !0 }]);
  if (t.error) return t;
  let r = "setMatchUpStatus", i = ui(e);
  if (!e.drawDefinition) {
    let v = e.tournamentRecord ?? (e.tournamentId && i[e.tournamentId]);
    e.tournamentRecord || (e.tournamentRecord = v);
    let D = br({ eventId: e.eventId, drawId: e.drawId, tournamentRecord: v });
    if (D.error) return F({ stack: r, result: D });
    D.drawDefinition && (e.drawDefinition = D.drawDefinition), e.event = D.event;
  }
  let { disableScoreValidation: n, propagateExitStatus: a, policyDefinitions: o, tournamentRecord: s, disableAutoCalc: c, enableAutoCalc: u, drawDefinition: l, matchUpId: d, schedule: p, event: m, notes: f } = e, h = e.matchUpFormat || e.outcome?.matchUpFormat, { policy: g } = Qa({ policyType: oi, tournamentRecord: s, event: m }), I = e.allowChangePropagation !== void 0 && e.allowChangePropagation || g?.allowChangePropagation !== void 0 && g.allowChangePropagation || void 0, { outcome: U, setTBlast: S } = e;
  if (U?.winningSide && ![1, 2].includes(U.winningSide)) return F({ result: { error: Cd }, stack: r });
  if (h) {
    let v = zI({ tournamentRecord: s, drawDefinition: l, matchUpFormat: h, matchUpId: d, event: m });
    if (v.error) return F({ stack: r, result: v });
  }
  if (U?.score?.sets && !U.score.scoreStringSide1) {
    let { score: v } = oN({ ...U, setTBlast: S });
    U.score = v, U.score.sets = U.score.sets.filter((D) => D.side1Score || D.side2Score || D.side1TiebreakScore || D.side2TiebreakScore);
  }
  let P = Ic({ matchUpStatusCodes: U?.matchUpStatusCodes, matchUpStatus: U?.matchUpStatus, winningSide: U?.winningSide, allowChangePropagation: I, disableScoreValidation: n, score: U?.score, propagateExitStatus: a, tournamentRecords: i, policyDefinitions: o, tournamentRecord: s, disableAutoCalc: c, enableAutoCalc: u, drawDefinition: l, matchUpFormat: h, matchUpId: d, schedule: p, event: m, notes: f });
  if (P.context?.progressExitStatus) {
    let v = !0, D = 0;
    for (; v && D < 10; ) {
      v = !1, D += 1;
      let y = kB({ sourceMatchUpStatusCodes: P.context.sourceMatchUpStatusCodes, sourceMatchUpStatus: P.context.sourceMatchUpStatus, loserParticipantId: P.context.loserParticipantId, propagateExitStatus: e.propagateExitStatus, tournamentRecord: e.tournamentRecord, loserMatchUp: P.context.loserMatchUp, matchUpsMap: P.context.matchUpsMap, drawDefinition: e.drawDefinition, event: e.event });
      y.context?.loserMatchUp && (Object.assign(P.context, y.context), v = !0);
    }
  }
  return F({ result: P, stack: r });
}
function sN(e) {
  if (!e?.outcomes) return { error: ue };
  if (!Array.isArray(e.outcomes)) return { error: ue, info: { outcomes: e.outcomes } };
  let t = e.tournamentRecords || e.tournamentRecord && { [e.tournamentRecord.tournamentId]: e.tournamentRecord } || {}, r = e.outcomes ?? [], i = r.reduce((n, a) => n.includes(a.tournamentId) ? n : n.concat(a.tournamentId), []);
  for (let n of i) {
    let a = t[n];
    if (!a) return { error: J };
    let o = r.filter((s) => s.tournamentId === n);
    if (o.length) {
      let s = xB({ outcomes: o, tournamentRecord: a });
      if (s.error) return s;
    }
  }
  return { ...x };
}
function xB(e) {
  let { tournamentRecords: t, tournamentRecord: r, outcomes: i, policyDefinitions: n } = e, a = {};
  i.forEach((o) => {
    let { eventId: s } = o;
    a[s] || (a[s] = []), a[s].push(o);
  });
  for (let o of Object.keys(a)) {
    let { event: s } = br({ tournamentRecord: r, eventId: o });
    for (let c of a[o]) {
      let { drawId: u } = c, l = s?.drawDefinitions?.find((d) => d.drawId === u);
      if (l && u) {
        let { matchUpFormat: d, matchUpId: p } = c, m = yl({ schedule: c?.schedule, tournamentRecords: t, policyDefinitions: n, tournamentRecord: r, drawDefinition: l, matchUpFormat: d, matchUpId: p, outcome: c, drawId: u, event: s });
        if (m.error) return m;
      }
    }
  }
  return { ...x };
}
function FB({ drawDefinition: e, matchUpId: t, outcome: r, matchUp: i }) {
  if (!i && !e) return { error: ne };
  if (!r) return { error: ue, info: "missing outcome" };
  if (!i && !t) return { error: Dr };
  if (!i) {
    let n = ut({ drawDefinition: e, matchUpId: t });
    if (n.error) return n;
    i = n.matchUp;
  }
  return typeof r != "object" || !r.score?.scoreStringSide1 || !r.score?.scoreStringSide2 ? { error: z } : Be({ element: i, extension: { name: ap, value: r } });
}
function cN(e) {
  return FB(e);
}
function YU(e) {
  let t = "resetTieFormat", { drawDefinition: r, event: i, uuids: n } = e, a = oe(e, [{ [Vt]: !0, [tn]: !0 }], t);
  if (a.error) return a;
  let o = lc(e, [{ [Ks]: Tn }]);
  if (o[yi]) return o;
  let s = e.tournamentRecord?.tournamentId, { matchUp: c, structure: u } = o?.matchUp ?? {};
  if (!c?.tieMatchUps) return F({ result: { error: Cr }, info: "Must be a TEAM matchUp", stack: t });
  if (!c.tieFormat) return { ...x };
  let l = dr({ structure: u, drawDefinition: r, event: i })?.tieFormat;
  if (!l) return F({ result: { error: Kt }, info: "No inherited tieFormat", stack: t });
  let d = [], p = [], m = [], f = [];
  for (let h of l.collectionDefinitions) {
    let { matchUpCount: g, collectionId: I } = h;
    p.push(I);
    let U = (c.tieMatchUps || []).filter((S) => S.collectionId === I);
    if (U.length > g) U.sort((S, P) => (S.matchUpStatus === Dt ? 1 : 0) - (P.matchUpStatus === Dt ? 1 : 0)), m.push(...U.slice(0, g)), d.push(...U.slice(3).map($t));
    else if (m.push(...U), U.length < g) {
      let S = g - U.length, P = rl({ collectionDefinition: h, matchUpsLimit: S, matchUp: c, uuids: n });
      f.push(...P);
    }
  }
  for (let h of c?.tieMatchUps || []) h.collectionId && !p.includes(h.collectionId) && d.push(h.matchUpId);
  return f.length && (m.push(...f), oa({ eventId: i?.eventId, matchUps: f, drawDefinition: r, tournamentId: s })), d.length && bn({ matchUpIds: d, eventId: i?.eventId, drawDefinition: r, tournamentId: s }), c && (c.tieMatchUps = m, c.tieFormatId = void 0, c.tieFormat = void 0, Oe({ structureId: u?.structureId, eventId: i?.eventId, context: t, drawDefinition: r, tournamentId: s, matchUp: c })), { ...x, newMatchUps: f, deletedMatchUpIds: d };
}
function KU(e) {
  let { tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n } = e, a = "resetScorecard";
  if (!r) return F({ result: { error: ne }, stack: a });
  if (!i) return F({ result: { error: pr }, stack: a });
  if (!dt(i)) return F({ result: { error: z, matchUpId: i }, stack: a });
  let o = or({ drawDefinition: r }), { matchUps: s } = Et({ nextMatchUps: !0, inContext: !0, drawDefinition: r, matchUpsMap: o }), c = o.drawMatchUps.find((h) => h.matchUpId === i), u = s?.find((h) => h.matchUpId === i);
  if (!c || !s) return { error: cr };
  if (c.matchUpType !== jr) return { error: Cr };
  let l = Ur({ inContextDrawMatchUps: s, drawDefinition: r, matchUpId: i }), d = u?.structureId, { structure: p } = me({ drawDefinition: r, structureId: d });
  if (Object.assign(e, { inContextDrawMatchUps: s, inContextMatchUp: u, matchUpsMap: o, targetData: l, structure: p, matchUp: c }), Ba(e)) return { error: kd };
  if (c.tieMatchUps?.length) for (let h of c.tieMatchUps) {
    let g = Ic({ matchUpId: h.matchUpId, matchUpTieId: i, winningSide: void 0, removeScore: !0, tournamentRecord: t, drawDefinition: r, event: n });
    if (g.error) return F({ result: g, stack: a });
  }
  let m = _e({ tournamentRecord: t, drawDefinition: r, event: n })?.appliedPolicies, f = zn({ event: e.event, removeScore: !0, tournamentRecord: t, appliedPolicies: m, drawDefinition: r, matchUpsMap: o, matchUpId: i });
  if (f.error) return F({ result: f, stack: a });
  if (e.tiebreakReset && !f.tieFormatRemoved) {
    let h = dr({ drawDefinition: r, structure: p, event: n })?.tieFormat;
    if (c.tieFormat && h) {
      let { matchUpCountDifference: g, descendantDifferences: I, ancestorDifferences: U, valueDifference: S } = jn({ descendant: c.tieFormat, ancestor: h });
      if (I.collectionIds.length === 1 && !U.collectionIds.length && !U.groupsCount && g === 1 && S === 1) {
        let P = YU({ tournamentRecord: t, drawDefinition: r, matchUpId: i, event: n });
        if (P.error) return P;
      }
    }
  }
  return { ...x };
}
function uN(e) {
  let t = oe(e, [{ [lr]: !0, [qn]: !0 }, { [Ms]: { [bu]: !1, roundNumbers: !1 }, [$D]: "At least one must be provided", [Mr]: sr }]);
  if (t.error) return t;
  let r = Ub(e);
  if (r.error) return r;
  let { matchUpIds: i } = r, n = bt(jr)(e.event.eventType), { tournamentRecord: a, drawDefinition: o, event: s } = e;
  for (let c of i) {
    if (n) {
      let l = KU({ tiebreakReset: !0, tournamentRecord: a, drawDefinition: o, matchUpId: c, event: s });
      if (l.error || e.removeAssignments && zU({ inheritance: !1, drawDefinition: o, matchUpId: c }).error) return l;
    }
    let u = Ic({ winningSide: void 0, removeScore: !0, tournamentRecord: a, drawDefinition: o, matchUpId: c, event: s });
    if (u.error) return u;
    if (e.removeAssignments) {
      let l = VU({ ...e, matchUpId: c });
      if (l.error) return l;
    }
  }
  return { ...x };
}
function LB({ tournamentRecord: e, drawDefinition: t, finishingOrder: r }) {
  if (!t) return { error: ne };
  let i = "setOrderOfFinish";
  if (!Array.isArray(r)) return F({ info: La("finishingOrder"), result: { error: z }, stack: i });
  let { completedMatchUps: n, matchUpsMap: a } = rc({ inContext: !0, drawDefinition: t }), o = n?.map($t) ?? [], s = r.map($t), { matchUpTypes: c, roundNumbers: u, structureIds: l, matchUpTieIds: d } = (n ?? []).filter(({ matchUpId: U }) => s.includes(U)).reduce((U, S) => {
    let { matchUpTieId: P, matchUpType: v, roundNumber: D, structureId: y } = S;
    return U.matchUpTypes.includes(v) || U.matchUpTypes.push(v), U.roundNumbers.includes(D) || U.roundNumbers.push(D), U.structureIds.includes(y) || U.structureIds.push(y), U.matchUpTieIds.includes(P) || U.matchUpTieIds.push(P), U;
  }, { matchUpTypes: [], roundNumbers: [], structureIds: [], matchUpTieIds: [] });
  if (c.length > 1 || d.length > 1 || u.length > 1 || l.length > 1) return F({ info: "matchUpType, structureId and roundNumber must be equivalent", result: { error: z }, stack: i });
  let p, m, f = {}, h = [], g = [];
  if (!r.every(({ orderOfFinish: U, matchUpId: S }) => (h.push(S), U && g.push(U), f[S] = U, p = o.includes(S), m = U === void 0 || Ie(U) && Math.floor(U) > 0, p && m))) return F({ result: { error: p ? z : Gs }, info: !p && "matchUps must be completed" || !m && "orderOfFinish must be integer > 0 or undefined" || void 0, stack: i });
  let I = n?.filter((U) => U.structureId === l[0] && U.roundNumber === u[0] && U.matchUpType === c[0] && U.matchUpTieId === d[0] && !h.includes(U.matchUpId));
  for (let U of I ?? []) {
    let { orderOfFinish: S } = U || {};
    if (S) {
      if (!Ie(S)) return F({ context: { orderOfFinish: S, matchUp: U }, result: { error: z }, stack: i });
      g.push(S);
    }
  }
  if (dv(g).length !== g.length || Math.max(...g) > g.length) return F({ info: "Values not unique or greater than expected number of values", result: { error: z }, stack: i });
  if (l.length) {
    let U = Pp({ matchUpFilters: { matchUpIds: s }, structureId: l[0], drawDefinition: t, matchUpsMap: a });
    if (U.error) return F({ result: U, stack: i });
    U.completedMatchUps?.forEach((S) => {
      S.orderOfFinish = f[S.matchUpId], Oe({ tournamentId: e.tournamentId, context: "setOrderOfFinish", drawDefinition: t, matchUp: S });
    });
  }
  return { ...x };
}
function lN(e) {
  return LB(e);
}
function dN(e) {
  let { tournamentRecord: t, drawDefinition: r, matchUpId: i, lineUps: n, event: a } = e, o = "applyLineUps", s = oe(e, [{ [Vt]: !0, [lr]: !0, [tn]: !0 }, { lineUps: !0, [Mr]: sr }], o);
  if (s.error) return s;
  let c = t.participants || [], u = ut({ tournamentParticipants: c, inContext: !0, drawDefinition: r, matchUpId: i });
  if (u.error) return u;
  if (!u.matchUp) return { error: cr };
  let { matchUp: l, structure: d } = u, { drawPositions: p, matchUpType: m } = l;
  if (m !== ot) return { error: Cr };
  if (!p?.length) return { error: pu };
  let f = dr({ matchUp: l, drawDefinition: r, structure: d, event: a })?.tieFormat, h = {};
  for (let I of n) {
    if (!Array.isArray(I)) return { error: z, lineUp: I };
    let U = {}, S = [];
    for (let w of I) {
      if (typeof w != "object") return { error: z, lineUpAssignment: w };
      let { participantId: b, collectionAssignments: T = [] } = w;
      if (!Array.isArray(T)) return { error: z, collectionAssignments: T };
      let R = c.find((E) => E.participantId === b);
      if (!R) return { error: Tt };
      if (R.participantType !== Ne) return { error: _i };
      let M = l.sides?.find((E) => E.participant?.individualParticipantIds?.includes(b))?.sideNumber;
      M && S.push(M);
      for (let E of T) {
        if (typeof E != "object") return { error: z, collectionAssignment: E };
        let { collectionId: A, collectionPosition: N } = E, C = f?.collectionDefinitions?.find((_) => _.collectionId === A);
        if (!C) return { error: z, collectionId: A };
        let k = `${A}-${N}`;
        U[k] || (U[k] = []);
        let O = U[k].length;
        if (bt(Xe)(C.matchUpType) && O || C.matchUpType === Ke && O > 1) return { info: "Excessive collectionPosition assignments", error: z };
        U[k].push(b);
      }
    }
    let P = Object.values(U);
    for (let w of P) if (w.length === 2) {
      let { participant: b } = bi({ tournamentParticipants: c, participantIds: w });
      if (!b) {
        let T = en({ participant: { participantType: De, participantRole: rr, individualParticipantIds: w }, pairOverride: !0, tournamentRecord: t });
        if (T.error) return T;
      }
    }
    let v = Br(S), D = (v[1] || 0) > (v[2] || 0) && 1 || (v[2] || 0) > (v[1] || 0) && 2 || void 0, y = Object.keys(h).map((w) => parseInt(w));
    D && !y.includes(D) && (h[D] = I);
  }
  if (!Object.keys(h).length) return { error: bh };
  if (u = ut({ drawDefinition: r, matchUpId: i }), u.error) return u;
  if (!u.matchUp) return { error: cr };
  let { matchUp: g } = u;
  g.sides || (g.sides = []);
  for (let I of [1, 2]) {
    let U = g.sides.find((P) => P.sideNumber === I), S = h[I];
    if (S) U ? U.lineUp = S : g.sides.push({ lineUp: S, sideNumber: I });
    else continue;
  }
  return Oe({ tournamentId: t?.tournamentId, context: o, drawDefinition: r, matchUp: g }), { ...x };
}
var QU = {};
Me(QU, { anonymizeTournamentRecord: () => ON, generate: () => pN, generateEventWithDraw: () => bm, generateOutcome: () => nS, generateOutcomeFromScoreString: () => XU, generateParticipants: () => Uc, generateTournamentRecord: () => AN, modifyTournamentRecord: () => kN, mutate: () => CN });
var pN = {};
Me(pN, { generateEventWithDraw: () => bm, generateOutcome: () => nS, generateOutcomeFromScoreString: () => XU, generateParticipants: () => Uc, generateTournamentRecord: () => AN });
function XU(e) {
  let { matchUpFormat: t, matchUpStatus: r, winningSide: i, scoreString: n, setTBlast: a } = e;
  if (!n) return { outcome: { ...Cp, winningSide: i, matchUpStatus: r } };
  if (i && ![1, 2, void 0].includes(i)) return { error: z, winningSide: i };
  let o = n && gd({ scoreString: n }), s = {}, c = pn({ sets: o, matchUpFormat: t, setTBlast: a }), u = pn({ sets: o, reversed: !0, matchUpFormat: t, setTBlast: a });
  return i === 2 ? (s.scoreStringSide1 = u, s.scoreStringSide2 = c) : (s.scoreStringSide1 = c, s.scoreStringSide2 = u), s.sets = gd({ scoreString: s.scoreStringSide1 }), ae({ outcome: { matchUpStatus: r, winningSide: i, score: s } });
}
function JU({ matchUpScheduleTimes: e, matchUpDependencies: t, allDateMatchUpIds: r, matchUp: i }) {
  let n = (t?.[i.matchUpId]?.matchUpIds || []).filter((a) => r.includes(a)).filter((a) => !e[a]);
  return { dependenciesScheduled: !n?.length, remainingDependencies: n };
}
function vl({ individualParticipantProfiles: e, participantId: t }) {
  e[t] || (e[t] = { typeChangeTimeAfterRecovery: void 0, timeAfterRecovery: void 0, priorMatchUpType: void 0, potentialRecovery: {}, potentialCounted: {}, potentialBookings: {}, bookings: [], counters: {} });
}
function _B({ individualParticipantProfiles: e, recoveryValue: t, participantId: r, scheduleTime: i, drawId: n }) {
  e[r].potentialRecovery[n] || (e[r].potentialRecovery[n] = []), e[r].potentialRecovery[n].push(t), e[r].potentialBookings[n] || (e[r].potentialBookings[n] = []), e[r].potentialBookings[n].push({ timeAfterRecovery: t, scheduleTime: i });
}
function su({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, typeChangeRecoveryMinutes: r, averageMatchUpMinutes: i = 0, matchUpNotBeforeTimes: n, matchUpDependencies: a, recoveryMinutes: o = 0, scheduleTime: s, matchUp: c }) {
  let u = ct(c?.schedule?.endTime), l = u ? Er(u, pe(o)) : Er(s, pe(i) + pe(o)), d = r && (u ? Er(ct(u), r) : Er(s, pe(i) + pe(r))), p = a?.[c.matchUpId]?.participantIds || [], m = (c.roundPosition && e[c.matchUpId] || []).flat();
  p.forEach((f) => {
    vl({ individualParticipantProfiles: t, participantId: f });
    let h = t[f].priorMatchUpType !== c.matchUpType && d || l;
    m.includes(f) ? _B({ individualParticipantProfiles: t, drawId: c.drawId, recoveryValue: h, participantId: f, scheduleTime: s }) : (t[f].timeAfterRecovery = h, t[f].bookings.push({ scheduleTime: s, timeAfterRecovery: h }));
  }), Fs({ matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: n, timeAfterRecovery: l, matchUp: c });
}
function mN({ matchUpScheduleTimes: e, matchUpDependencies: t, scheduleTime: r, matchUpId: i, details: n }) {
  let a, o = n.minutesMap?.[i]?.recoveryMinutes, s = (n.minutesMap?.[i]?.averageMinutes || 0) + (o || 0), c = Er(r, s), u = t?.[i]?.dependentMatchUpIds || [];
  if (u.length) {
    let l = u.reduce((d, p) => {
      let m = e[p];
      if (!m) return d;
      let f = { scheduleTime: m, matchUpId: p };
      return m && !d.matchUpId || Le(m) < Le(d.scheduleTime) ? f : d;
    }, {});
    l.scheduleTime && Le(c) > Le(l.scheduleTime) && (a = l);
  }
  return { scheduledDependent: a };
}
function BB(e) {
  let { sides: t, matchUpType: r } = e || {};
  return (t || []).map((i) => r === Ke && (i?.participant?.individualParticipants || []) || i?.participant && [i.participant] || []).flat();
}
var Pl = "DO_NOT_SCHEDULE", VB = { DO_NOT_SCHEDULE: Pl };
function ZU({ averageMatchUpMinutes: e = 90, requestConflicts: t = {}, potentials: r = !0, personRequests: i, scheduleTime: n, scheduleDate: a, matchUp: o }) {
  let s = BB(o).map(({ person: m }) => m?.personId);
  if (r) {
    let m = (o?.potentialParticipants || []).flat().map(({ person: f }) => f?.personId);
    s.push(...m);
  }
  let c = s.map((m) => i[m]?.map((f) => ({ ...f, personId: m }))).filter(Boolean).flat().filter((m) => m.requestType === Pl && hn(a, m.date)), u = [], l = o?.matchUpId, d = Nt(ct(n), ve(a)), p = ct(Bh(d, e).toISOString());
  for (let m of c) {
    let { requestId: f, startTime: h, endTime: g } = m;
    (n > h && n < g || p > h && p < g) && (u.push({ matchUpId: l, request: m, scheduleTime: n }), t[f] ? (t[f].scheduleTimes.includes(n) || t[f].scheduleTimes.push(n), t[f].matchUpIds.includes(l) || t[f].matchUpIds.push(l)) : t[f] = { request: m, scheduleTimes: [n], matchUpIds: [l] });
  }
  return { conflicts: u };
}
function Yf({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, matchUp: r, value: i }) {
  let { matchUpType: n } = r, { individualParticipantIds: a } = pp(r), o = (e[r.matchUpId] || []).filter((s) => !gr(s, a)).flat();
  [...a, ...o].forEach((s) => {
    if (vl({ individualParticipantProfiles: t, participantId: s }), !t[s].potentialCounted[r.drawId]) {
      let c = t[s].counters;
      c[n] ? c[n] += i : i > 0 && (c[n] = i), c[Pi] ? c[Pi] += i : i > 0 && (c[Pi] = i), o.includes(s) && (t[s].potentialCounted[r.drawId] = !0);
    }
  });
}
function jB({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, dateScheduledMatchUpIds: r, greatestAverageMinutes: i, dateScheduledMatchUps: n, matchUpNotBeforeTimes: a, matchUpScheduleTimes: o, matchUpDependencies: s, clearScheduleDates: c, scheduleDate: u, minutesMap: l, matchUps: d }) {
  let p = [];
  r || (n = d?.filter((h) => {
    let g = h.schedule || {}, I = h.matchUpStatus === "BYE";
    return I && p.push({ tournamentId: h.tournamentId, matchUpId: h.matchUpId }), !I && hl({ schedule: g }) && (!u || h.schedule.scheduledDate === u);
  }), r = n.map($t));
  let m = Array.isArray(c) ? c.includes(u) : c, f = m ? [] : d.filter(({ matchUpId: h }) => r.includes(h));
  for (let h of f) {
    Yf({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, value: 1, matchUp: h });
    let g = h.schedule?.scheduledTime;
    if (g) {
      o[h.matchUpId] = g;
      let I = l?.[h.matchUpId]?.recoveryMinutes;
      su({ individualParticipantProfiles: t, matchUpPotentialParticipantIds: e, matchUpNotBeforeTimes: a, matchUpDependencies: s, averageMatchUpMinutes: i, recoveryMinutes: I, scheduleTime: g, matchUp: h });
    }
  }
  return { dateScheduledMatchUpIds: r, byeScheduledMatchUpDetails: p, dateScheduledMatchUps: n, clearDate: m };
}
function Pm({ defaultRecoveryMinutes: e = 0, averageMatchUpMinutes: t = 90, dateScheduledMatchUps: r, tournamentRecords: i, venueIds: n = [], periodLength: a, scheduleDate: o, matchUps: s }) {
  if (typeof i != "object") return { error: ht };
  if (!pi(s) && !Array.isArray(r)) return { error: Gn };
  a = a ?? hm({ recoveryMinutes: e, averageMatchUpMinutes: t });
  let c = Object.assign({}, ...Object.values(i).map((d) => (d.events ?? []).map((p) => {
    let { scheduleTiming: m } = Ou({ tournamentRecord: d, event: p });
    return { [p.eventId]: { event: p, scheduleTiming: m } };
  })).flat()), u = { averageTimes: [{ minutes: { default: t } }], recoveryTimes: [{ minutes: { default: e } }] };
  r || (r = s?.filter((d) => {
    let p = d.schedule;
    return hl({ schedule: p }) && (!o || d.schedule.scheduledDate === o);
  }));
  let l = r?.filter((d) => (!n.length || n.includes(d.schedule.venueId)) && d.matchUpStatus !== "BYE");
  return { bookings: l?.map(({ eventId: d, schedule: p, matchUpFormat: m }) => {
    let { event: f, scheduleTiming: h } = c[d], g = f?.eventType, I = { ...h, defaultTiming: u, matchUpFormat: m }, { averageMinutes: U, recoveryMinutes: S } = Up({ timingDetails: I, eventType: g }), { courtId: P, venueId: v } = p, D = ct(p.scheduledTime), y = Er(D, U);
    return { recoveryMinutes: S, averageMinutes: U, periodLength: a, startTime: D, courtId: P, endTime: y, venueId: v };
  }).filter(Boolean), relevantMatchUps: l, dateScheduledMatchUps: r };
}
function GB({ calculateStartTimeFromCourts: e = !0, remainingScheduleTimes: t, defaultRecoveryMinutes: r, averageMatchUpMinutes: i, clearScheduleDates: n, tournamentRecords: a, tournamentRecord: o, periodLength: s, scheduleDate: c, startTime: u, venueIds: l, matchUps: d, endTime: p }) {
  if (o && !a && (a = { [o.tournamentId]: o }), typeof a != "object" || !Object.keys(a).length) return { error: ht };
  s = s ?? hm({ recoveryMinutes: r, averageMatchUpMinutes: i });
  let { courts: m, venues: f } = Yn({ dates: [c], ignoreDisabled: !0, tournamentRecords: a }), h = m?.filter((v) => !l || l.includes(v.venueId)) ?? [];
  u = u ?? Ls({ courts: h, scheduleDate: c, startTime: !0 }), p = p ?? Ls({ courts: h, scheduleDate: c, endTime: !0 });
  let { bookings: g, dateScheduledMatchUps: I } = Pm({ defaultRecoveryMinutes: r, averageMatchUpMinutes: i, tournamentRecords: a, scheduleDate: c, periodLength: s, venueIds: l, matchUps: d }), U = { calculateStartTimeFromCourts: e, remainingScheduleTimes: t, averageMatchUpMinutes: i, clearScheduleDates: n, date: c, periodLength: s, startTime: u, bookings: g, endTime: p, courts: h }, { scheduleTimes: S } = xU(U), P = l?.length === 1 && l[0] || f?.length === 1 && f[0].venueId || void 0;
  return { dateScheduledMatchUpIds: I?.map(qr("matchUpId")), dateScheduledMatchUps: I, scheduleTimes: S, venueId: P };
}
function $B({ scheduledRoundsDetails: e, greatestAverageMinutes: t, garmanSinglePass: r }) {
  let i = [], n = [], a, o, s, c;
  for (let u of e.filter(Boolean)) c || (c = u.hash), (u.hash === c || r) && (n = n.concat(u.matchUpIds)), u.hash, s = t, o = u.recoveryMinutes, a = u.roundPeriodLength;
  return n.length && i.push({ matchUpIds: n, roundPeriodLength: a, recoveryMinutes: o, averageMinutes: s }), { groupedRounds: i };
}
function fN({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, scheduleCompletedMatchUps: r, containedStructureIds: i, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, matchUpDependencies: o, clearScheduleDates: s, tournamentRecords: c, periodLength: u, scheduleDate: l, useGarman: d, matchUps: p, courts: m, venues: f }) {
  let h = {}, g = [], I = [], U = [];
  for (let S of f) {
    let { rounds: P = [], venueId: v } = S, { scheduledRoundsDetails: D, greatestAverageMinutes: y, orderedMatchUpIds: w, minutesMap: b } = ml({ scheduleCompletedMatchUps: r, containedStructureIds: i, tournamentRecords: c, periodLength: u, matchUps: p, rounds: P });
    U.push(...w ?? []);
    let { groupedRounds: T } = $B({ scheduledRoundsDetails: D, greatestAverageMinutes: y, garmanSinglePass: !0 }), R, M = [];
    d && ({ scheduleTimes: M, dateScheduledMatchUpIds: R } = GB({ averageMatchUpMinutes: T[0]?.averageMinutes, scheduleDate: ve(l), venueIds: [S.venueId], clearScheduleDates: s, tournamentRecords: c, periodLength: u, matchUps: p }));
    let E = jB({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, dateScheduledMatchUpIds: R, greatestAverageMinutes: y, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, matchUpDependencies: o, clearScheduleDates: s, scheduleDate: l, minutesMap: b, matchUps: p });
    ({ dateScheduledMatchUpIds: R } = E);
    let A = E, { byeScheduledMatchUpDetails: N, clearDate: C } = E;
    N?.length && I.push(...N);
    let { matchUpsToSchedule: k, matchUpMap: O } = em({ matchUpPotentialParticipantIds: e, scheduleCompletedMatchUps: r, dateScheduledMatchUpIds: R, matchUpNotBeforeTimes: n, matchUpScheduleTimes: a, orderedMatchUpIds: w, clearDate: C, matchUps: p }), _ = m.filter((B) => B.venueId === v);
    h[v] = { previousRemainingScheduleTimes: [], courtsCount: _.length, greatestAverageMinutes: y, scheduledRoundsDetails: D, dateScheduledMatchUps: A, matchUpsToSchedule: k, scheduleTimes: M, groupedRounds: T, venueCourts: _, minutesMap: b, matchUpMap: O }, s || g.push(...R);
  }
  return { allDateScheduledByeMatchUpDetails: I, allDateScheduledMatchUpIds: g, venueScheduledRoundDetails: h, allDateMatchUpIds: U };
}
function qB(e, t) {
  let r = Le(e.scheduleTime), i = Le(e.timeAfterRecovery), n = Le(t.scheduleTime), a = Le(t.timeAfterRecovery), o = r === n || i === a, s = r > n && r < a, c = n > r && n < i, u = i > n && i < a, l = a > r && a < i;
  return ae({ hasOverlap: o || s || u || c || l, startAisContained: s, endAisContained: u, startBisContained: c, endBisContained: l }, !0);
}
function eS({ individualParticipantProfiles: e, matchUpNotBeforeTimes: t, matchUpDependencies: r, scheduleTime: i, matchUp: n, details: a }) {
  let o = (r?.[n.matchUpId]?.participantIds || []).flat(), s = a?.minutesMap?.[n.matchUpId]?.averageMinutes || 0, c = a?.minutesMap?.[n.matchUpId]?.recoveryMinutes || 0, u = o.every((p) => {
    vl({ individualParticipantProfiles: e, participantId: p });
    let m = e[p];
    if (!m.timeAfterRecovery) return !0;
    let f = ct(n?.schedule?.endTime), h = f ? Er(f, pe(c)) : Er(i, pe(s) + pe(c));
    return ![...Object.keys(m.potentialBookings).filter((g) => g !== n.drawId).map((g) => m.potentialBookings[g]).flat(), ...m.bookings].find((g) => qB({ scheduleTime: i, timeAfterRecovery: h }, g).hasOverlap);
  }), l = t[n.matchUpId], d = (l ? yu(Nt(l), Nt(i), !1) : 0) >= 0;
  return { enoughTime: u && d };
}
function hN({ autoSchedulingAudit: e, tournamentRecords: t }) {
  Se({ topic: Cn, payload: e });
  let r = (o) => o ? Object.values(o).reduce((s, c) => s + c.length || 0, 0) : 0, i = (e?.schedulingProfile || []).reduce((o, s) => o + s.venues.reduce((c, u) => c + u.rounds.length, 0), 0), n = { scheduledDatesCount: e.scheduledDates?.length, noTimeMatchUpIdsCount: r(e?.noTimeMatchUpIds), scheduledMatchUpIdsCount: r(e?.scheduledMatchUpIds), overLimitMatchUpIdsCount: r(e?.overLimitMatchUpIds), requestConflictsCount: r(e?.requestConflicts), profileRoundsCount: i }, a = { itemType: Wf, itemValue: n };
  for (let o of Object.values(t)) {
    let s = o.tournamentId;
    jd(Cn) ? Se({ payload: { type: Wf, tournamentId: s, detail: n }, topic: Cn }) : sl({ tournamentRecord: o, timeItem: a });
  }
}
function tS({ matchUpPotentialParticipantIds: e, individualParticipantProfiles: t, matchUpDailyLimits: r = {}, matchUp: i }) {
  let { enteredIndividualParticipantIds: n } = pp(i), { matchUpId: a, matchUpType: o } = i, s = (i.roundPosition && e[a] || []).flat(), c = Ue(n.concat(...s));
  return c.forEach((u) => {
    vl({ individualParticipantProfiles: t, participantId: u });
  }), { participantIdsAtLimit: c.filter((u) => {
    let l = t[u];
    if (l) return [o, Pi].find((d) => {
      let p = l.counters?.[d] || 0, m = r[d] || 0;
      return p && m && p >= m;
    });
  }), relevantParticipantIds: c };
}
function cu({ scheduleCompletedMatchUps: e = !1, scheduleByeMatchUps: t = !1, errorOnAnachronism: r = !1, checkChronology: i = !0, matchUpDependencies: n, removePriorValues: a, tournamentRecords: o, tournamentRecord: s, matchUpDetails: c, matchUpIds: u, schedule: l }) {
  if (!s) return { error: J };
  if (!c && (!u || !Array.isArray(u))) return { error: Ro };
  if (!c && (!l || typeof l != "object")) return { error: hP };
  let d, p = [], m = 0;
  if (i && !n) {
    let g = Ei({ tournamentRecords: o, tournamentRecord: s });
    n = g.matchUpDependencies, d = g.matchUps;
  }
  d || (d = Jt({ tournamentRecord: s })?.matchUps ?? []);
  let f = d.reduce((g, I) => {
    let { matchUpId: U, drawId: S, matchUpStatus: P } = I;
    return (t || P !== "BYE") && (e || !Lt.includes(P)) && (g[S] ? g[S].push(U) : g[S] = [U]), g;
  }, {}), h = c?.map((g) => g.matchUpId);
  for (let g of Object.keys(f)) {
    let { drawDefinition: I } = Ua({ tournamentRecord: s, drawId: g });
    if (!I) continue;
    let U = f[g].filter((P) => u?.includes(P) ?? h?.includes(P)), S = hr({ inContext: !1, drawDefinition: I }).matchUps;
    for (let P of U) {
      let v = c?.find((y) => y.matchUpId === P)?.schedule || l, D = vm({ schedule: v, matchUpDependencies: n, errorOnAnachronism: r, removePriorValues: a, inContextMatchUps: d, tournamentRecords: o, tournamentRecord: s, checkChronology: i, drawDefinition: I, drawMatchUps: S, matchUpId: P });
      if (D?.warnings?.length && p.push(...D.warnings), D?.success && (m += 1), D.error) return D;
    }
  }
  return p.length ? { ...x, scheduled: m, warnings: p } : { ...x, scheduled: m };
}
function Dl(e) {
  let { scheduleCompletedMatchUps: t = !1, scheduleByeMatchUps: r = !1, errorOnAnachronism: i, matchUpContextIds: n, removePriorValues: a, tournamentRecords: o, checkChronology: s, matchUpDetails: c, schedule: u } = e;
  if (e.matchUpIds && !n) return cu(e);
  let l = oe(e, [{ [ur]: !0 }, { [Ms]: { matchUpContextIds: !1, matchUpDetails: !1 }, [Kr]: z, [Mr]: sr }]);
  if (l.error) return l;
  if ((!c || n) && !u) return { error: ue, info: "schedule is required" };
  let d = [], p = 0, { matchUpDependencies: m } = Ei({ tournamentRecords: o });
  for (let f of Object.values(o)) {
    let { tournamentId: h } = f, g = n?.filter((U) => U.tournamentId === h).map($t), I = c?.filter((U) => U?.tournamentId === h);
    if (g?.length || I?.length) {
      let U = cu({ matchUpDetails: I, scheduleCompletedMatchUps: t, scheduleByeMatchUps: r, matchUpDependencies: m, errorOnAnachronism: i, removePriorValues: a, tournamentRecords: o, tournamentRecord: f, checkChronology: s, matchUpIds: g, schedule: u });
      if (U.warnings?.length && d.push(...U.warnings), U.scheduled && (p += U.scheduled), U.error) return U;
    }
  }
  return d.length ? { ...x, scheduled: p, warnings: d } : { ...x, scheduled: p };
}
function WB({ schedulingProfileModifications: e, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: i, dateSchedulingProfiles: n, containedStructureIds: a, matchUpDependencies: o, matchUpDailyLimits: s, clearScheduleDates: c, tournamentRecords: u, schedulingProfile: l, personRequests: d, periodLength: p, matchUps: m, courts: f, dryRun: h }) {
  let g = {}, I = {}, U = {}, S = {}, P = {}, v = {}, D = {}, y = {}, w = {}, b = {};
  for (let M of n) {
    let E = ve(M?.scheduleDate), A = M?.venues || [], N = {}, C = {}, k = ($, q) => {
      $.forEach((Y) => {
        let W = C[Y].counters;
        W[q] ? W[q] += 1 : W[q] = 1, W[Pi] ? W[Pi] += 1 : W[Pi] = 1;
      });
    };
    U[E] = {}, S[E] = {}, g[E] = {}, I[E] = {}, D[E] = [], y[E] = [], w[E] = [], b[E] = [];
    let O = {};
    m.forEach(($) => {
      $.schedule?.scheduledDate && hn(E, ve($.schedule.scheduledDate)) && Fs({ matchUpPotentialParticipantIds: N, matchUpNotBeforeTimes: O, matchUp: $ });
    });
    let { allDateScheduledByeMatchUpDetails: _, venueScheduledRoundDetails: B, allDateMatchUpIds: L } = fN({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: C, scheduleCompletedMatchUps: r, containedStructureIds: a, matchUpNotBeforeTimes: O, matchUpScheduleTimes: v, matchUpDependencies: o, clearScheduleDates: c, tournamentRecords: u, useGarman: !0, periodLength: p, scheduleDate: E, matchUps: m, courts: f, venues: A }), j = 10, H = 0, G, V = 10;
    for (; !G; ) {
      for (let { venueId: $ } of A) {
        let q = 0, Y = B[$];
        for (; Y.courtsCount && Y.scheduleTimes?.length && Y.matchUpsToSchedule?.length && q <= Y.courtsCount; ) {
          let { scheduleTime: W, attempts: K = 0 } = Y.scheduleTimes.shift(), Q = Y.matchUpsToSchedule.find((X) => {
            let { matchUpId: ee, matchUpType: Z } = X, { participantIdsAtLimit: ce, relevantParticipantIds: fe } = tS({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: C, matchUpDailyLimits: s, matchUp: X });
            if (ce.length) return y[E].includes(ee) || y[E].push(ee), !1;
            let { scheduledDependent: He } = mN({ matchUpScheduleTimes: v, matchUpDependencies: o, scheduleTime: W, matchUpId: ee, details: Y });
            if (He) return !1;
            let { dependenciesScheduled: Te, remainingDependencies: $e } = JU({ matchUpScheduleTimes: v, matchUpDependencies: o, allDateMatchUpIds: L, matchUp: X });
            if (!Te) return S[E][ee] || (S[E][ee] = []), S[E][ee].push({ scheduleTime: W, remainingDependencies: $e }), !1;
            let { enoughTime: it } = eS({ individualParticipantProfiles: C, matchUpNotBeforeTimes: O, matchUpDependencies: o, scheduleTime: W, details: Y, matchUp: X });
            if (!it) return U[E][ee] || (U[E][ee] = []), U[E][ee].push({ scheduleTime: W }), !1;
            let It = Y.greatestAverageMinutes, { conflicts: Rt } = ZU({ potentials: t, averageMatchUpMinutes: It, requestConflicts: b, personRequests: d, scheduleTime: W, scheduleDate: E, matchUp: X });
            if (Rt?.length) return P[E] || (P[E] = []), P[E].push(...Rt), !1;
            k(fe, Z);
            let de = Y.minutesMap?.[ee]?.recoveryMinutes;
            return su({ matchUpPotentialParticipantIds: N, individualParticipantProfiles: C, matchUpNotBeforeTimes: O, averageMatchUpMinutes: It, matchUpDependencies: o, recoveryMinutes: de, scheduleTime: W, matchUp: X }), v[ee] = W, !0;
          });
          Y.matchUpsToSchedule = Y.matchUpsToSchedule.filter(({ matchUpId: X }) => X !== Q?.matchUpId), Q ? q += 1 : (I[E][$] || (I[E][$] = []), I[E][$].push({ scheduleTime: W, attempts: K + 1 }));
        }
        Y.matchUpsToSchedule?.length && (I[E][$] = I[E][$]?.filter((W) => {
          let K = W.attempts < j;
          return K && Y.scheduleTimes.push(W), !K;
        })), (!Y.scheduleTimes?.length || !Y.matchUpsToSchedule?.length) && (Y.complete = !0);
      }
      H += 1, G = A.every(({ venueId: $ }) => B[$].complete) || H === V;
    }
    for (let { venueId: $ } of A) {
      let q = B[$].matchUpMap;
      Object.keys(q).forEach((Y) => {
        let W = u[Y];
        W && Object.keys(q[Y]).forEach((K) => {
          let { drawDefinition: Q } = Ua({ tournamentRecord: W, drawId: K });
          Q && q[Y][K].forEach(({ matchUpId: X }) => {
            let ee = v[X];
            if (ee) {
              let Z = ee.split(":").map(ri).join(":"), ce = `${ve(E)}T${Z}`;
              h ? D[E].push(X) : (Sa({ drawDefinition: Q, scheduledTime: ce, matchUpId: X }).success && D[E].push(X), $ && gc({ tournamentRecord: W, drawDefinition: Q, matchUpId: X, venueId: $ }));
            }
          });
        });
      }), w[E] = B[$].matchUpsToSchedule.map($t), g[E][$] = B[$].scheduleTimes.sort((Y, W) => Le(Y.scheduleTime) - Le(W.scheduleTime));
    }
    !h && _?.length && Dl({ matchUpDetails: _, scheduleByeMatchUps: !0, removePriorValues: !0, tournamentRecords: u, schedule: { scheduledDate: "", scheduledTime: "", courtOrder: "", courtId: "", venueId: "" } });
    for (let $ of M.venues) for (let q of $.rounds) {
      let Y = (q.matchUps?.map(({ matchUpId: K }) => K) || []).filter((K) => D[E].includes(K));
      q.canScheduledMatchUpIds = Y;
      let W = Math.round(Y.length / q.matchUpsCount * 1e4) / 100;
      (W === 1 / 0 || isNaN(W)) && (W = 0), q.possibleToSchedulePct = W, q.matchUpsCount === Y.length && (q.possibleToSchedule = !0);
    }
  }
  let T = n.map(({ scheduleDate: M }) => M), R = { timeStamp: Date.now(), overLimitMatchUpIds: y, scheduledMatchUpIds: D, schedulingProfile: l, noTimeMatchUpIds: w, requestConflicts: b, scheduledDates: T };
  return hN({ tournamentRecords: u, autoSchedulingAudit: R }), { ...x, schedulingProfileModifications: e, schedulingProfileIssues: i, scheduleTimesRemaining: g, dateSchedulingProfiles: n, skippedScheduleTimes: I, recoveryTimeDeferredMatchUpIds: U, dependencyDeferredMatchUpIds: S, matchUpScheduleTimes: v, overLimitMatchUpIds: y, scheduledMatchUpIds: D, noTimeMatchUpIds: w, requestConflicts: b, scheduledDates: T };
}
function Cy({ averageMinutes: e, startTime: t, endTime: r, court: i, date: n }) {
  if (!Array.isArray(i.dateAvailability)) return { error: ue, stack: "getEarliestCourtTime" };
  let a = Ls({ scheduleDate: n, courts: [i], startTime: !0 }), o = Ls({ scheduleDate: n, courts: [i], endTime: !0 });
  t = t || a, r = r || o;
  let s = Sl({ court: i, date: n }), { timeSlots: c } = fc({ courtDate: s }), u = Nt(t), l = Nt(r);
  return { earliestCourtTime: c?.reduce((d, p) => {
    let m = Nt(p.startTime), f = Nt(p.endTime);
    if (m > l || f < u) return d;
    let h = u > m ? u : m;
    if (yu(h, f) >= e) {
      let g = ct(h.toISOString());
      (!d || g < d) && (d = g);
    }
    return d;
  }, void 0), courtStartTime: a, courtEndTime: o };
}
function HB({ schedulingProfileModifications: e, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: i, dateSchedulingProfiles: n, containedStructureIds: a, matchUpDependencies: o, matchUpDailyLimits: s, clearScheduleDates: c, tournamentRecords: u, periodLength: l = 30, schedulingProfile: d, personRequests: p, matchUps: m = [], courts: f, dryRun: h }) {
  let g = {}, I = {}, U = {}, S = {}, P = {}, v = {}, D = {}, y = {}, w = {};
  for (let R of n ?? []) {
    let M = ve(R?.scheduleDate), E = R?.venues || [], A = {}, N = {}, C = (Q, X) => {
      Q.forEach((ee) => {
        let Z = N[ee].counters;
        Z[X] ? Z[X] += 1 : Z[X] = 1, Z[Pi] ? Z[Pi] += 1 : Z[Pi] = 1;
      });
    };
    g[M] = {}, I[M] = {}, v[M] = [], D[M] = [], y[M] = [], w[M] = [];
    let k = {};
    m?.forEach((Q) => {
      Q.schedule?.scheduledDate && hn(M, ve(Q.schedule.scheduledDate)) && Fs({ matchUpPotentialParticipantIds: A, matchUpNotBeforeTimes: k, matchUp: Q });
    });
    let { allDateScheduledByeMatchUpDetails: O, allDateScheduledMatchUpIds: _, venueScheduledRoundDetails: B, allDateMatchUpIds: L } = fN({ matchUpPotentialParticipantIds: A, individualParticipantProfiles: N, scheduleCompletedMatchUps: r, containedStructureIds: a, matchUpNotBeforeTimes: k, matchUpScheduleTimes: P, matchUpDependencies: o, clearScheduleDates: c, tournamentRecords: u, periodLength: l, scheduleDate: M, matchUps: m, courts: f, venues: E }), j = m?.filter(({ matchUpId: Q }) => _.includes(Q)), { bookings: H } = Pm({ dateScheduledMatchUps: j, tournamentRecords: u, scheduleDate: M, periodLength: l }), { virtualCourts: G } = fm({ scheduleDate: M, periodLength: l, bookings: H, courts: f }), V = G?.reduce((Q, X) => {
      let { earliestCourtTime: ee, courtEndTime: Z } = Cy({ date: M, averageMinutes: 0, court: X });
      return (!Q.startTime || Nt(ee) < Nt(Q.startTime)) && (Q.startTime = ee), (!Q.endTime || Nt(Z) > Nt(Q.endTime)) && (Q.endTime = Z), Q;
    }, {}), $ = V.startTime, q = ({ courtId: Q, booking: X }) => G?.find((ee) => ee.courtId === Q)?.dateAvailability[0].bookings.push(X), Y = 10, W = 0, K;
    for (; !K; ) {
      for (let { venueId: Q } of E) {
        let X = B[Q], ee = X.matchUpsToSchedule.length, Z = [], ce = [], fe, He = 0;
        for (; !fe; ) {
          for (let Te of X.matchUpsToSchedule) {
            if (ce.length === X.courtsCount || Z.length === X.courtsCount) {
              fe = !0;
              break;
            }
            let { matchUpId: $e, matchUpType: it } = Te, { participantIdsAtLimit: It, relevantParticipantIds: Rt } = tS({ matchUpPotentialParticipantIds: A, individualParticipantProfiles: N, matchUpDailyLimits: s, matchUp: Te });
            if (It.length) {
              D[M].includes($e) || D[M].push($e);
              continue;
            }
            let { dependenciesScheduled: de, remainingDependencies: lt } = JU({ matchUpScheduleTimes: P, matchUpDependencies: o, allDateMatchUpIds: L, matchUp: Te });
            if (!de) {
              I[M][$e] || (I[M][$e] = []), I[M][$e].push({ remainingDependencies: lt });
              continue;
            }
            let le = [], ze = G?.reduce((Ae, nt) => {
              if (ce.includes(nt.courtId)) return Ae;
              let { earliestCourtTime: Ee } = Cy({ averageMinutes: X.greatestAverageMinutes, startTime: $, date: M, court: nt });
              if (Ae.scheduleTime && Le(Ee) >= Le(Ae.scheduleTime)) return Ae;
              let { scheduledDependent: rt } = mN({ matchUpScheduleTimes: P, matchUpDependencies: o, scheduleTime: Ee, matchUpId: $e, details: X });
              if (rt) return Ae;
              let { enoughTime: ge } = eS({ individualParticipantProfiles: N, matchUpNotBeforeTimes: k, matchUpDependencies: o, scheduleTime: Ee, details: X, matchUp: Te });
              if (!ge) return g[M][$e] || (g[M][$e] = []), g[M][$e].includes(Ee) || g[M][$e].push(Ee), Ae;
              let Ze = X.minutesMap?.[$e]?.averageMinutes || X.greatestAverageMinutes, { conflicts: At } = ZU({ potentials: t, averageMatchUpMinutes: Ze, requestConflicts: w, personRequests: p, scheduleTime: Ee, scheduleDate: M, matchUp: Te });
              if (At?.length) return le.push(...At), !1;
              C(Rt, it);
              let ye = X.minutesMap?.[$e]?.recoveryMinutes;
              return su({ matchUpPotentialParticipantIds: A, individualParticipantProfiles: N, matchUpNotBeforeTimes: k, averageMatchUpMinutes: Ze, matchUpDependencies: o, recoveryMinutes: ye, scheduleTime: Ee, matchUp: Te }), (!Ae.scheduleTime || Le(Ee) < Le(Ae.scheduleTime)) && (Ae.averageMatchUpMinutes = Ze, Ae.recoveryMinutes = ye, Ae.scheduleTime = Ee, Ae.courtName = nt.courtName, Ae.courtId = nt.courtId), Ae;
            }, {});
            if (ze.scheduleTime) {
              let { averageMatchUpMinutes: Ae, recoveryMinutes: nt, scheduleTime: Ee, courtId: rt } = ze;
              P[$e] = Ee, S[$e] = rt, Z.push($e), ce.push(rt);
              let ge = Ee, Ze = Er(ge, Ae);
              q({ courtId: rt, booking: { averageMatchUpMinutes: Ae, recoveryMinutes: nt, periodLength: l, matchUpId: $e, startTime: ge, courtId: rt, endTime: Ze, venueId: Q } }), X.matchUpsToSchedule = X.matchUpsToSchedule.filter((At) => At.matchUpId !== $e);
            } else le?.length && (U[M] || (U[M] = []), U[M].push(...le));
          }
          (ce.length === X.courtsCount || Z.length === X.courtsCount || !X.matchUpsToSchedule.length) && (fe = !0), X.matchUpsToSchedule.length && Z < X.courtsCount && (Nt($) < Nt(V.endTime) ? $ = Er($, l) : (fe = !0, X.complete = !0)), He += 1, !fe && He >= ee && (fe = !0);
        }
        X.matchUpsToSchedule?.length || (X.complete = !0);
      }
      W += 1, K = E.every(({ venueId: Q }) => B[Q].complete) || W === Y;
    }
    for (let { venueId: Q } of E) {
      let X = B[Q].matchUpMap;
      Object.keys(X).forEach((ee) => {
        let Z = u[ee];
        Z && Object.keys(X[ee]).forEach((ce) => {
          let { drawDefinition: fe } = Ua({ tournamentRecord: Z, drawId: ce });
          fe && X[ee][ce].forEach(({ matchUpId: He }) => {
            let Te = P[He], $e = S[He];
            if (Te) {
              let it = Te.split(":").map(ri).join(":"), It = `${ve(M)}T${it}`;
              h || (Sa({ drawDefinition: fe, scheduledTime: It, matchUpId: He }), rs({ courtDayDate: M, tournamentRecords: u, tournamentRecord: Z, drawDefinition: fe, matchUpId: He, courtId: $e })), v[M].push(He);
            }
          });
        });
      }), y[M] = B[Q].matchUpsToSchedule.map($t);
    }
    !h && O?.length && Dl({ matchUpDetails: O, scheduleByeMatchUps: !0, removePriorValues: !0, tournamentRecords: u, schedule: { scheduledDate: "", scheduledTime: "", courtOrder: "", courtId: "", venueId: "" } });
    for (let Q of R.venues) for (let X of Q.rounds) {
      let ee = (X.matchUps ?? []).map(({ matchUpId: ce }) => ce)?.filter((ce) => v[M].includes(ce));
      X.canScheduledMatchUpIds = ee;
      let Z = Math.round((ee?.length || 0) / X.matchUpsCount * 1e4) / 100;
      (Z === 1 / 0 || isNaN(Z)) && (Z = void 0), X.possibleToSchedulePct = Z, X.matchUpsCount === ee?.length && (X.possibleToSchedule = !0);
    }
  }
  let b = (n ?? []).map(({ scheduleDate: R }) => R), T = { timeStamp: Date.now(), overLimitMatchUpIds: D, scheduledMatchUpIds: v, schedulingProfile: d, noTimeMatchUpIds: y, requestConflicts: w, scheduledDates: b };
  return hN({ tournamentRecords: u, autoSchedulingAudit: T }), { ...x, schedulingProfileModifications: e, schedulingProfileIssues: i, dateSchedulingProfiles: n, recoveryTimeDeferredMatchUpIds: g, dependencyDeferredMatchUpIds: I, matchUpScheduleTimes: P, overLimitMatchUpIds: D, scheduledMatchUpIds: v, noTimeMatchUpIds: y, requestConflicts: w, scheduledDates: b };
}
function Dm(e) {
  let { scheduleAttributes: t = ["scheduledDate", "scheduledTime", "courtOrder"], ignoreMatchUpStatuses: r = Lt, scheduledDates: i, venueIds: n } = e, a = ui(e), o = xe(a) ? Object.values(a).map(({ tournamentId: c }) => c).filter(Boolean) : [];
  if (!o?.length) return { error: ht };
  let s = 0;
  for (let c of o) {
    let u = a[c], l = zB({ ignoreMatchUpStatuses: r, scheduleAttributes: t, tournamentRecord: u, scheduledDates: i, venueIds: n });
    if (l.error) return l;
    s += l.clearedScheduleCount ?? 0;
  }
  return { ...x, clearedScheduleCount: s };
}
function zB({ scheduleAttributes: e = ["scheduledDate", "scheduledTime", "courtOrder"], ignoreMatchUpStatuses: t = Lt, tournamentRecord: r, scheduledDates: i, venueIds: n = [] }) {
  if (typeof r != "object") return { error: J };
  if (!Array.isArray(t) || !Array.isArray(n)) return { error: z };
  n.length && e.push("venueId");
  let a = Jt({ matchUpFilters: { scheduledDates: i }, tournamentRecord: r }).matchUps ?? [], o = {};
  a.forEach(({ matchUpStatus: u, schedule: l, drawId: d, matchUpId: p }) => {
    (!u || !t.includes(u)) && hl({ schedule: l, scheduleAttributes: e }) && (!n?.length || n.includes(l.venueId)) && (o[d] || (o[d] = []), o[d].push(p));
  });
  let s = r.tournamentId, c = 0;
  for (let u in o) {
    let { event: l, drawDefinition: d } = br({ tournamentRecord: r, drawId: u }), p = hr({ drawDefinition: d, matchUpFilters: { matchUpIds: o[u] } }).matchUps ?? [];
    for (let m of p) {
      let f = !1;
      m.timeItems = (m.timeItems ?? []).filter((h) => {
        let g = h?.itemType && ![Dn, ca, Vo, gp, jo, Go].includes(h?.itemType);
        return g || (f = !0), g;
      }), f && (Oe({ context: "clear schedules", eventId: l?.eventId, drawDefinition: d, tournamentId: s, matchUp: m }), c += 1);
    }
  }
  return { ...x, clearedScheduleCount: c };
}
function wm(e) {
  let { checkPotentialRequestConflicts: t = !0, scheduleCompletedMatchUps: r, clearScheduleDates: i, scheduleDates: n = [], tournamentRecords: a, periodLength: o, useGarman: s, dryRun: c, pro: u } = e, l = oe(e, [{ [ur]: !0 }, { [tr]: (b) => !b || Array.isArray(b) && b.every(Ar), [LD]: !1, [Mr]: sr }]);
  if (l.error) return l;
  let d = Kn({ tournamentRecords: a });
  if (d.error) return d;
  if (!d.schedulingProfile.length) return { ...x };
  let { modifications: p, issues: m = [], schedulingProfile: f = [] } = d, h = Object.assign({}, ...Object.values(a).map((b) => ec({ tournamentRecord: b }).containedStructures)), g = n.map((b) => {
    if (Ar(b)) return ve(b);
  }).filter(Boolean), I = f.map((b) => b.scheduleDate).map((b) => Ar(b) && ve(b)).filter((b) => b && (!n.length || g.includes(b)));
  if (!I.length) return { error: Wv };
  if (i && !c) {
    let b = Array.isArray(i) ? i : [];
    Dm({ tournamentRecords: a, scheduledDates: b });
  }
  let U = Yn({ ignoreDisabled: !1, tournamentRecords: a }).courts, { matchUps: S } = Bi({ matchUpFilters: { matchUpTypes: [Xe, Ke] }, afterRecoveryTimes: !0, nextMatchUps: !0, tournamentRecords: a }), { matchUpDependencies: P } = Ei({ includeParticipantDependencies: !0, tournamentRecords: a, matchUps: S }), { matchUpDailyLimits: v } = um({ tournamentRecords: a }), { personRequests: D } = io({ requestType: Pl, tournamentRecords: a }), y = f.filter((b) => {
    let T = ve(b?.scheduleDate);
    return I.includes(T);
  }).sort((b, T) => new Date(b.scheduleDate).getTime() - new Date(T.scheduleDate).getTime()), w = { schedulingProfileModifications: p, checkPotentialRequestConflicts: t, scheduleCompletedMatchUps: r, schedulingProfileIssues: m, dateSchedulingProfiles: y, containedStructureIds: h, matchUpDependencies: P, matchUpDailyLimits: v, clearScheduleDates: i, tournamentRecords: a, schedulingProfile: f, personRequests: D, periodLength: o, matchUps: S, dryRun: c, courts: U };
  return u ? HB(w) : WB(w);
}
function Tm(e) {
  let { tournamentRecord: t, tournamentRecords: r, activeTournamentId: i, ...n } = e || {};
  return n.tournamentId || (n.tournamentId = je()), n.startDate && !Ra(n.startDate) && !Yl.test(n.startDate) ? { error: Ht } : n.endDate && !Ra(n.endDate) && !Yl.test(n.endDate) ? { error: Ht } : (n.extensions && (n.extensions = n.extensions.filter(Xi)), { ...n });
}
function rS({ addParticipants: e = !0, participantAttribute: t, tournamentRecord: r, personAttribute: i, teamNames: n, accessor: a, uuids: o }) {
  if (!r) return { error: J };
  let s = {}, c = (r.participants ?? []).filter(({ participantType: f, participantRole: h }) => f === Ne && h === rr), u = 0;
  for (let f of c) {
    let h = a && uo({ element: f, accessor: a })?.value || i && f.person?.[i] || t && f[t];
    if (h) {
      if (!Object.keys(s).includes(h)) {
        s[h] = { participantName: n?.[u] ?? h, participantId: o?.pop() ?? je(), individualParticipantIds: [], participantRole: rr, participantType: We };
        let g = { value: i ?? t, name: Uf };
        Be({ element: s[h], extension: g }), u += 1;
      }
      s[h].individualParticipantIds.push(f.participantId);
    }
  }
  let l = Object.keys(s), d = (r.participants ?? []).map((f) => {
    if (f.participantType !== We || f.participantRole !== rr) return;
    let { extension: h } = we({ name: Uf, element: f }), g = h?.value;
    if (l.includes(g)) return f.participantId;
  }).filter(Boolean), p = 0, m = [];
  return Object.keys(s).forEach((f) => {
    let h = s[f], { participantId: g } = h;
    d.includes(g) || (r.participants || (r.participants = []), e && r.participants.push(h), m.push(h), p++);
  }), e && p ? (Se({ payload: { tournamentId: r.tournamentId, participants: m }, topic: aa }), { ...x, participantsAdded: p }) : m.length ? { ...x, newParticipants: m } : { error: _C };
}
var YB = [{ AA: "Annexia" }, { BA: "Bacteria" }, { BO: "Borduria" }, { BM: "Bensalem" }, { BS: "Basenji" }, { BI: "Balnibarbi" }, { BV: "Bartovia" }, { BZ: "Berzerkistan" }, { CA: "Caldonia" }, { CC: "Concordia" }, { CH: "Chula" }, { DA: "Deltora" }, { DW: "Discworld" }, { EA: "Eastasia" }, { EP: "Ecotopia" }, { ER: "Erewhon" }, { FA: "Freedonia" }, { FN: "Florin" }, { FG: "Fogg" }, { FK: "Fourecks" }, { GA: "Genovia" }, { GL: "Gilead" }, { GD: "Gilead" }, { GL: "Gondal" }, { GO: "Gondor" }, { GR: "Gruzinia" }, { GT: "Goritania" }, { GU: "Guilder" }, { HA: "Heldscalla" }, { HO: "Hidalgo" }, { IL: "Illyria" }, { KA: "Kinakuta" }, { KG: "Kangan" }, { KN: "Kreplachistan" }, { KS: "Kallipolis" }, { LH: "Lugash" }, { LI: "Listenbourg" }, { LT: "Lilliput" }, { LU: "Luggnagg" }, { LV: "Lichtenslava" }, { MR: "Moher" }, { NA: "Narnia" }, { NV: "Novaria" }, { OA: "Oceania" }, { OS: "Orsinia" }, { OV: "Octavia" }, { PA: "Palombia" }, { PG: "Penguina" }, { QA: "Qasha" }, { PM: "Panem" }, { SA: "Solymbria" }, { SD: "Syldavia" }, { SG: "San Glucose" }, { SL: "San Lorenzo" }, { SR: "Sontar" }, { SY: "Sylvania" }, { TF: "Tralfamadore" }, { TH: "Themyscira" }, { UA: "Utopia" }, { VA: "Vespugia" }, { WA: "Wakanda" }, { WX: "Wessex" }, { ZA: "Zamunda" }, { ZK: "Zubrowka" }], KB = ["Amber", "Ansul", "Atlantis", "Braavos", "Busytown", "Castle Rock", "Centralia", "Coober Pedy", "Chefchaouen", "Chronopolis", "Damanhur", "Diaspar", "Dictionopolis", "Diomira", "El Dorado", "Elista", "Ephesus", "Gotham", "Hadleyburg", "Hallstatt", "Hierusalem", "Ilium", "Inverness", "Kowloon", "Laputa", "Longyearbyen", "Lys", "Matmata", "Maycomb", "Metropolis", "Miyake-jima", "Monowi", "Nagoro", "Navarre", "New New York", "Nimbin", "Pemberley", "Pseudopolis", "Rivendell", "Roswell", "Shangri-La", "Springfield", "Supilinn", "Thneedville", "Trantor", "Wobegon", "Yonwood", "Xanadu", "Xylar", "Zion"];
function gN({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = mr(KB), i = r.slice(0, e);
  return { cities: te(0, t).map((n) => n < Math.min(e, r.length) ? i[n] : xr(i)) };
}
function IN({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = mr(YB), i = r.slice(0, e).map((n) => Object.keys(n)).flat();
  return { states: te(0, t).map((n) => n < Math.min(e, r.length) ? i[n] : xr(i)) };
}
function UN({ count: e = 1, participantsCount: t = 32 } = {}) {
  let r = te(0, e).map(() => te(0, 5).map(() => ti(0, 9)).join(""));
  return { postalCodes: te(0, t).map((i) => i < e ? r[i] : xr(r)) };
}
function yd({ idPrefix: e, participantType: t, index: r, uuids: i }) {
  let n = dt(t) ? t[0] : "X";
  return e ? `${e}-${n}-${r}` : i?.pop() || je();
}
function SN(e) {
  let { cities: t, states: r, postalCodes: i, nationalityCode: n, participantIndex: a } = e;
  return { postalCode: i?.[a], state: r?.[a], city: t?.[a], countryCode: n };
}
var QB = { lastNames: ["Abbey", "Ahern", "Ampleforth", "Ananiadis", "Andelic", "Assange", "Atreides", "Austen", "Bach", "Banks", "Barrington", "Batty", "Bauers", "Beals", "Beer", "Bennett", "Berry", "Bonaparte", "Brewer", "Brockovich", "Bukowski", "Cassidy", "Catton", "Calvino", "Carlin", "Carson", "Chip", "Constant", "Crane", "Crowne", "Cummings", "Curie", "Dallas", "Diamond", "Deckard", "Drazic", "Dunbar", "Earhart", "Eisenstein", "Eldritch", "Elliot", "Ellul", "Escher", "Eyre", "Faulkner", "Fulcher", "Fukuoka", "Godel", "Goldstein", "Greer", "Hedges", "Herbert", "Holmgren", "Humperdinck", "Huxley", "Illich", "Jeffers", "Jensen", "Jevons", "Johnson", "Johnstone", "Jovovich", "Kingsnorth", "Langer", "Fernwright", "Fuller", "Le Guin", "Lem", "Lovelace", "Mander", "McLuhan", "Midgely", "Mond", "Montoya", "Moore", "Murry", "Nagle", "Nearing", "Ogden", "Ophuls", "Parks", "Paz", "Peet", "Perfect", "Pendejo", "Pevensie", "Postman", "Ripley", "Rodda", "Rumfoord", "Runciter", "Rugen", "Sale", "Schumacher", "Shaftoe", "Shelley", "Shepard", "Smith", "Stratton", "Stewart", "Swift", "Tillich", "Turing", "Tyrell", "Twain", "Yeats", "Veblen", "Yates", "Vonnegut", "Waterhouse", "Watson", "Wolin", "Wirt", "Waschuk", "Wormwood", "Zecic"], firstFemale: ["Ada", "Amelia", "Amelie", "America", "Anne", "Antonia", "Aravis", "Astrid", "Beatrice", "Brienne", "Buttercup", "Caitlin", "Cimorene", "Cordelia", "Desdemona", "Ellen", "Elizabeth", "Emily", "Emmie", "Erin", "Eva", "Evelyn", "Heather", "Helen", "Hermia", "Hypatia", "Imogen", "Jane", "Jasmine", "Juliana", "Juliet", "Katniss", "Leeloo", "Lenina", "Lilith", "Linda", "Lizzie", "Louise", "Lucy", "Marie", "Mary", "Martha", "Matilda", "Milla", "Miranda", "Meg", "Melba", "Nicole", "Ola", "Portia", "Pris", "Rachael", "Rachel", "Rebecca", "River", "Rosa", "Rosalind", "Scout", "Sharn", "Susanne", "Titania", "Uhura", "Ursula", "Valentina", "Viola", "Virginia", "Xena", "Zoe"], firstMale: ["Alan", "Aldous", "August", "Axel", "Barda", "Barry", "Bill", "Bruce", "Charles", "Chris", "Constantine", "Darwin", "David", "Derrick", "Edward", "Emmanuel", "Ernst", "Estlin", "Fezzik", "Filby", "Frank", "Frito", "George", "Glen", "Helmholtz", "Inigo", "Italo", "Ivan", "Jacques", "James", "Jared", "Jerry", "Joe", "Johann", "Julian", "John Michael", "Jonathan", "Korben", "Kirkpatrick", "Kurt", "Lief", "Malachi", "Mark", "Marhsall", "Masanobu", "Maurits", "Michael", "Miro", "Mustapha", "Neil", "Nikola", "Octavio", "Palmer", "Paul", "Pierre", "Robinson", "Rick", "Rincewind", "Roy", "Shannon", "Sheldon", "Stafford", "Stanislaw", "Stanley", "Syme", "Thorstein", "Thomas", "Tyrone", "Vizzini", "Walton", "Walker", "Warren", "Wendell", "Westley", "William", "Winston", "Zoran"] };
function Hm(e) {
  let { count: t = 100, sex: r } = e || {};
  if (!t || r && ![Ye, at].includes(r)) return { personData: [], error: z };
  let i = Math.ceil(t * 1.3), { lastNames: n, firstFemale: a, firstMale: o } = QB, s = ea.map(({ iso: h }) => h).filter(Boolean), c = Math.ceil(i / n.length), u = Math.ceil(i / a.length), l = Math.ceil(i / o.length), d = te(0, c).flatMap(() => {
    let h = ie(n, !1, !0);
    return te(0, n.length).map(() => Lr(h));
  }), p = te(0, u).flatMap(() => {
    let h = ie(a, !1, !0);
    return te(0, a.length).map(() => Lr(h));
  }), m = te(0, l).flatMap(() => {
    let h = ie(o, !1, !0);
    return te(0, o.length).map(() => Lr(h));
  }), f = {};
  for (let h = 0; h < i; h++) {
    let g = d.pop(), I = r || xr([Ye, at]), U = I === Ye ? m.pop() : p.pop(), S = xr(s);
    f[`${U}${g}`] = { nationalityCode: S, sex: I, firstName: U, lastName: g };
  }
  return { personData: Object.values(f).slice(0, t) };
}
function yN(e) {
  let t = e?.count || 1, { personExtensions: r, consideredDate: i, isMock: n = !0, gendersCount: a, personData: o, category: s, sex: c } = e || {};
  if (isNaN(t)) return { error: z };
  let u = a?.[Ye] || c === Ye && t || 0, l = a?.[at] || c === at && t || 0;
  t = Math.max(t, u + l);
  let d = t - (u + l), p = u && Hm({ count: u, sex: Ye }).personData || [], m = l && Hm({ count: l, sex: at }).personData || [], f = [...p, ...m, ...d && Hm({ count: d }).personData || []], h = f.filter((w) => !c || u && l || w.sex === c), g = [];
  if (Array.isArray(o)) {
    let w = o.filter((b) => typeof b.firstName != "string" || typeof b.lastName != "string" || b.sex && ![Ye, at].includes(b.sex) || b.nationalityCode && (typeof b.nationalityCode != "string" || b.nationalityCode.length > 3 || !ea.find(({ iso: T, ioc: R }) => [T, R].includes(b.nationalityCode))) ? !1 : (b.nationalityCode && g.push(b.nationalityCode), !0));
    if (w.length) h = w;
    else return { error: z };
  }
  let I = o ? h : mr(h);
  if (I.length < t) {
    let { maleFirstNames: w, maleLastNames: b, femaleFirstNames: T, femaleLastNames: R, nationalityCodes: M } = f.reduce((E, A) => {
      let { firstName: N, lastName: C, nationalityCode: k } = A;
      return A.sex === Ye ? (E.maleFirstNames.includes(N) || E.maleFirstNames.push(N), E.maleLastNames.includes(C) || E.maleLastNames.push(C)) : (E.femaleFirstNames.includes(N) || E.femaleFirstNames.push(N), E.femaleLastNames.includes(C) || E.femaleLastNames.push(C)), E.nationalityCodes.includes(k) || E.nationalityCodes.push(k), E;
    }, { maleFirstNames: [], maleLastNames: [], femaleFirstNames: [], femaleLastNames: [], nationalityCodes: [] });
    te(0, t - I.length).forEach(() => {
      let E = c || xr([Ye, at]), A = xr(M), N = xr(E === Ye ? w : T), C = xr(E === Ye ? b : R), k = { firstName: N, lastName: C, sex: E, nationalityCode: A };
      I.push(k);
    });
  }
  let { ageMinDate: U, ageMaxDate: S } = Uo({ consideredDate: i, category: s }), P = pe(U?.slice(0, 4) || 0) || pe(S?.slice(0, 4) || 0) - 3, v = pe(S?.slice(0, 4) || 0) || pe(U?.slice(0, 4) || 0) + 3, D = (U || S) && [P, v], y = I.slice(0, t).map((w, b) => {
    let [T, R] = D || [], M = D && Lr(te(T, R)), E = Lr(te(0, 365)), A = M && C0(M, E);
    return Object.assign(ae({ extensions: r || [{ name: "regionCode", value: b + 1 }], birthDate: A, isMock: n }), w);
  });
  return { persons: y.length && y || I[0], nationalityCodes: g };
}
var XB = ["Ace Academy", "Avengers", "Ball Bouncers", "Baseliners", "Captivators", "Civil Disobedients", "Continentals", "Court Royal", "Court Sharks", "Diamond Dogs", "Danger Zone", "Doubles Dominators", "Double Faults", "Tricksters", "Eliminators", "Court Crusaders", "Fuzz Busters", "Game Changers", "Goal Gurus", "Good Volley", "Green Machine", "Hawk Eyes", "Inside Outers", "Killer Instinct", "Line Toers", "Masters of Mayhem", "Matter Catchers", "Cheap Shot", "Mean Machines", "Mindspace Invaders", "Net Centric", "Net Positive", "Smash Mullet", "Over Your Head", "Spin Meisters", "Aggressors", "Racket Machine", "Slice Happy", "Refs Nightmare", "Sandeaters", "Sun Seekers", "Slicer Dicers", "Stacked Deck", "Cross Stringers", "The Emergence", "Total Demolition", "Touch and Go", "Unreturnables", "Upside Downers", "Vertically Challenged", "Visual Spectacle"];
function vd({ nameRoot: e = "TEAM", count: t = 1 } = {}) {
  let r = mr(XB).slice(0, t);
  return r.length < t && te(0, t - r.length).forEach((i) => r.push(`${e} ${i + 1}`)), { names: r };
}
function Uc(e) {
  let { scaledParticipantsCount: t, rankingRange: r } = e, { ratingsParameters: i = Gt, valuesInstanceLimit: n, ratingsValues: a = [], consideredDate: o, categories: s, category: c, nationalityCodesCount: u, nationalityCodeType: l, nationalityCodes: d, participantsCount: p = 32, participantType: m, teamSize: f = 8, personIds: h, idPrefix: g, uuids: I, personExtensions: U, addressProps: S, gendersCount: P, matchUpType: v, personData: D, sex: y, inContext: w, withISO2: b, withIOC: T, scaleAllParticipants: R } = e, M = m === De || v === Ma, E = m === We || v === We;
  r && (!Array.isArray(r) || !r.every((de) => gt(de)) || r.length !== 2) && (r = void 0), t = R ? p : t;
  let A = 1e3, N = t && t > A ? t : A;
  r = r || [1, N], r[1] += 1;
  let C = p * (M && 2 || E && (f ?? 8) || 1), k = yN({ count: C, personExtensions: U, consideredDate: o, gendersCount: P, personData: D, category: c, sex: y });
  if (k.error) return k;
  let { nationalityCodes: O, persons: _ } = k, B = {}, L = {}, j = {}, H = {}, G = (de) => {
    Object.assign(B, de.doublesRankings), Object.assign(L, de.singlesRankings), Object.assign(H, de.doublesRatings), Object.assign(j, de.singlesRatings);
  };
  if (xe(c)) {
    let de = Oy({ scaledParticipantsCount: t, ratingsParameters: i, participantType: m, ratingsValues: a, rankingRange: r, category: c });
    G(de);
  }
  Array.isArray(s) && s.forEach((de) => {
    let lt = Oy({ scaledParticipantsCount: t, ratingsParameters: i, participantType: m, ratingsValues: a, rankingRange: r, category: de });
    G(lt);
  });
  let V = ea.filter((de) => l === "IOC" && de.ioc || de.iso);
  function $(de) {
    let lt = Math.ceil(C / de);
    return n && lt > n ? Math.ceil(C / n) : de;
  }
  let { postalCodesProfile: q, postalCodesCount: Y, statesProfile: W, citiesProfile: K, citiesCount: Q, statesCount: X } = S || {}, ee = (de) => Object.keys(de).map((lt) => te(0, W[lt]).map(() => lt)).flat(), Z = K && ee(K) || S?.cities || gN({ count: Q || C, participantsCount: C }).cities, ce = W && ee(W) || S?.states || IN({ count: X || C, participantsCount: C }).states, fe = q && ee(q) || S?.postalCodes || UN({ count: Y || C, participantsCount: C }).postalCodes, He = { cities: Z, states: ce, postalCodes: fe }, Te = $(u), $e = Te ? mr(V).slice(0, u) : d && V.filter((de) => d.includes(de.iso)) || V, it = mr(te(0, Math.ceil(C / (Te || 1))).map(() => $e).flat(1 / 0)), It = vd({ count: p }).names;
  return { participants: te(0, p).map((de) => {
    let lt = M && 2 || E && (f ?? 8) || 1, le = te(0, lt).map((rt) => {
      let ge = de * lt + rt;
      return Rt(ge);
    }), ze = le.map((rt) => rt.participantId), Ae = le.map((rt) => rt.person.standardFamilyName).join("/"), nt = M ? De : We, Ee = { participantId: yd({ participantType: nt, index: de, idPrefix: g, uuids: I }), participantName: M ? Ae : It[de], participantRole: rr, individualParticipantIds: ze, participantType: nt };
    return w && (Ee.individualParticipants = le), M || E ? [Ee, ...le] : le;
  }).flat(), ...x };
  function Rt(de) {
    let lt = _[de], { nationalityCode: le, participantExtensions: ze, participantTimeItems: Ae, extensions: nt, firstName: Ee, birthDate: rt, lastName: ge, personId: Ze, sex: At } = lt || {}, ye = Ee || "GivenName", Qe = ge || "FamilyName", Ce = `${ye} ${Qe}`, Fe = it[de], ke = O?.length && le || Fe && (l === "IOC" ? Fe.ioc || Fe.iso : Fe.iso || Fe.ioc) || le;
    it?.length && !ke && !le && console.log("%c Invalid Nationality Code", { participantIndex: de, country: Fe });
    let Wt = SN({ ...He, participantIndex: de, nationalityCode: ke }), Ut = ae({ participantId: yd({ participantType: Ne, index: de, idPrefix: g, uuids: I }), extensions: ze, timeItems: Ae, participantRole: rr, participantType: Ne, participantName: Ce, person: { personId: Ze || h?.length && h[de] || je(), birthDate: Ar(rt) ? rt : void 0, addresses: [Wt], standardFamilyName: Qe, standardGivenName: ye, nationalityCode: ke, extensions: nt, sex: At } });
    if (T && ke) {
      let qe = ea.find(({ iso: jt }) => jt === ke);
      qe?.ioc && (Ut.person.iocNationalityCode = qe.ioc), qe?.label && (Ut.person.countryName = qe.label);
    }
    if (b && ke) {
      let qe = ea.find(({ iso: jt }) => jt === ke);
      qe?.iso2 && (Ut.person.iso2NationalityCode = qe.iso2), qe?.label && (Ut.person.countryName = qe.label);
    }
    let St = (qe) => {
      let jt = qe.categoryName || qe.ratingType || qe.ageCategoryCode, ji = L[jt]?.[de], Zt = B[jt]?.[de];
      Ml({ scaleValue: ji, eventType: So, scaleType: ia, participant: Ut, category: qe }), Ml({ scaleValue: Zt, eventType: xn, scaleType: ia, participant: Ut, category: qe });
      let Ai = j[jt]?.[de], on = H[jt]?.[de];
      Ml({ scaleValue: Ai, eventType: So, scaleType: Zn, participant: Ut, category: qe }), Ml({ scaleValue: on, eventType: xn, scaleType: Zn, participant: Ut, category: qe });
    };
    return Array.isArray(s) ? s.forEach((qe) => St(qe)) : c && St(c), Ut;
  }
}
function Ml({ scaleValue: e, participant: t, eventType: r, scaleType: i, category: n }) {
  let a = n.categoryName || n.ratingType || n.ageCategoryCode, o = [Ca, i, r, a].join("."), s = { itemValue: e, itemType: o };
  a && e && (t.timeItems || (t.timeItems = []), t.timeItems.push(s));
}
function Oy(e) {
  let { category: t, scaledParticipantsCount: r, ratingsParameters: i, participantType: n, ratingsValues: a = [] } = e, o = t.rankingRange || e.rankingRange || [1, 1e3], s = {}, c = {}, u = {}, l = {}, { categoryName: d, ageCategoryCode: p, ratingType: m } = t, f = t.categoryName || t.ratingType || t.ageCategoryCode;
  if ((d || p) && !m) {
    let [h, g] = o || [];
    if (c[f] = mr(te(h, g)).slice(0, r || ti(20, 30)), [De, We].includes(n)) {
      let [I, U] = o || [];
      s[f] = mr(te(I, U)).slice(0, r || ti(20, 30));
    }
  }
  if (m && i[m]) {
    let { ratingMax: h, ratingMin: g, ratingAttributes: I } = t, U = { ...i[m], ...I || {} }, { attributes: S = {}, decimalsCount: P, accessors: v, range: D, step: y } = U, w = (E) => {
      let A = {}, N = Object.keys(E || {});
      for (let C of N) {
        let k = E[C];
        if (typeof k == "object" && k.generator) {
          let { range: O } = k, [_, B] = O.slice().sort();
          A[C] = ti(_, B);
        } else A[C] = k;
      }
      return A;
    }, b = D[0] > D[1] ? 2 : 0.7, [T, R] = D.slice().sort(), M = te(0, 2e3).map(() => uv(T, R, b, y, P)).filter((E) => (!h || E <= h) && (!g || E >= g)).slice(0, r || ti(20, 30)).map((E) => v ? Object.assign({}, ...v.map((A) => ({ [A]: E })), w(S)) : E);
    u[f] = [...a, ...M], [De, We].includes(n) && (l[f] = [...a, ...M]);
  }
  return { singlesRankings: c, doublesRankings: s, singlesRatings: u, doublesRatings: l };
}
function iS(e) {
  let { alternatesCount: t = 0, tieFormatName: r, drawSize: i } = e, n = 0, a = 0, o = 0, s = 0, c = {}, u = { [Ye]: 0, [at]: 0, [vr]: 0, [Da]: 0, ANY: 0 };
  (xe(e.tieFormat) ? e.tieFormat : kn({ namedFormat: r }))?.collectionDefinitions?.filter(Boolean).forEach((m) => {
    let { category: f, collectionId: h, matchUpType: g, matchUpCount: I, gender: U } = m;
    if ([Ye, at].includes(U)) {
      let S = I * (g === Ke ? 2 : 1);
      u[U] < S && (u[U] = S);
    } else U === vr && (u[Ye] < I && (u[Ye] = I), u[at] < I && (u[at] = I));
    if (f) {
      let S = JSON.stringify(f);
      c[S] = f;
    }
    if (h || (m.collectionId = je()), bt(Ke)(g)) {
      let S = I;
      s += I, n = Math.max(n, S);
    }
    if (bt(Xe)(g)) {
      let S = I;
      o += I, a = Math.max(a, S);
    }
  });
  let l = Object.keys(c).length ? Math.max(o, s * 2) : Math.max(a, n * 2), d = n * (i + t), p = a * (i + t);
  return { maxDoublesDraw: d, maxSinglesDraw: p, teamSize: l, genders: u };
}
function JB({ participantsProfile: e, eventProfiles: t, drawProfiles: r }) {
  let { participantsCount: i, participantType: n = Ne } = e || {}, a = i || 0, o = { [at]: 0, [vr]: 0, [Da]: 0, [Ye]: 0, ANY: 0 }, s = 0, c = 0, u = 0, l = 0, d = 0, p = ({ alternatesCount: f = 0, uniqueParticipants: h, tieFormatName: g, drawSize: I = 0, eventType: U, tieFormat: S, category: P, gender: v, stage: D }) => {
    let y = U === ai, w = U === kt, b = !!(h || D === se || P || v);
    if (w) {
      l = Math.max(l, I + f), S = typeof S == "object" ? S : kn({ namedFormat: g });
      let { teamSize: T, maxDoublesDraw: R, maxSinglesDraw: M, genders: E } = iS({ alternatesCount: f, tieFormatName: g, tieFormat: S, drawSize: I });
      u = Math.max(u, T), c = Math.max(c, M), b || (s = Math.max(s, R)), Object.keys(E).forEach((A) => o[A] += E[A]);
    } else if (y) if (b) {
      let T = (I + f) * 2;
      d += T, v && (o[v] += T);
    } else I + f && I + f > s && (s = I + f);
    else if (b) {
      let T = I + f;
      v && (o[v] += T), d += T;
    } else I && I > c && (c = I + f);
  };
  if (t?.forEach((f) => {
    let { tieFormatName: h, tieFormat: g, drawProfiles: I, eventType: U, category: S, gender: P } = f;
    if (I) for (let v of I) {
      let { tieFormatName: D, tieFormat: y } = v;
      p({ ...v, tieFormatName: D || h, tieFormat: y || g, eventType: U, category: S, gender: P });
    }
  }), Array.isArray(r)) for (let f of r) p(f);
  let m = Math.max(l * u, s * 2, c);
  return s && (n = De), (i || a) < m && (i = m), i && s && [De, kt].includes(n) && (c && Math.floor(c / 2) > s ? i = Math.floor(c / 2) : (!c || s * 2 >= c) && (i = Math.ceil(i / 2))), i === void 0 && (i = !t?.length && !r?.length ? 32 : 0), i < a && (i = a), { uniqueParticipantsCount: d, participantsCount: i, largestTeamDraw: l, largestTeamSize: u, participantType: n, gendersCount: o };
}
function vN({ participantsProfile: e, tournamentRecord: t, eventProfiles: r, drawProfiles: i, startDate: n, uuids: a }) {
  if (e?.participantsCount === 0) return { addedCount: 0, ...x };
  let { participantsCount: o, participantType: s, largestTeamDraw: c, largestTeamSize: u, gendersCount: l } = JB({ participantsProfile: e, eventProfiles: r, drawProfiles: i }), d = e?.teamKey, p = Uc({ consideredDate: n, ...e, participantsCount: o, participantType: s, gendersCount: l, uuids: a }).participants, m = 0, f = Mi({ tournamentRecord: t, participants: p });
  if (f.error) return f;
  if (m += f.addedCount, d) {
    let U = rS({ tournamentRecord: t, ...d });
    if (U.error) return U;
  }
  let h = p.filter(({ participantType: U }) => U === Ne).map(Re), g = e?.idPrefix ? `${We}-${e.idPrefix}` : void 0, I = te(0, c).map((U) => {
    let S = h.slice(U * u, (U + 1) * u), P = yd({ index: U, participantType: s, idPrefix: g, uuids: a });
    return { participantName: `Team ${U + 1}`, participantRole: rr, individualParticipantIds: S, participantType: We, participantId: P };
  });
  return f = Mi({ participants: I, tournamentRecord: t }), f.error ? f : (m += f.addedCount, { addedCount: m, ...x });
}
function PN({ drawProfiles: e, category: t, gender: r }) {
  let i = {}, n = e?.reduce((o, s) => {
    let { qualifyingPositions: c = 0, participantsCount: u = 0, uniqueParticipants: l, stage: d = re, drawSize: p = 0 } = s || {};
    Object.keys(o).includes(d) || (o[d] = 0);
    let m = (u || p) - c;
    return l || r || t || d === se ? (Object.keys(i).includes(d) || (i[d] = 0), i[d] += m) : o[d] = Math.max(o[d], m), o;
  }, {}), a = Object.keys(i);
  return a.forEach((o) => n[o] += i[o]), { stageParticipantsCount: n, uniqueParticipantsCount: i, uniqueParticipantStages: a };
}
function DN({ allUniqueParticipantIds: e, stageParticipantsCount: t, eventParticipantType: r, targetParticipants: i }) {
  let n = t[re] || 0, a = t[se] || 0;
  return { stageParticipants: { QUALIFYING: i?.filter(({ participantType: o }) => o === r).filter(({ participantId: o }) => !e.includes(o)).slice(0, a), MAIN: i?.filter(({ participantType: o }) => o === r).filter(({ participantId: o }) => !e.includes(o)).slice(a, a + n) } };
}
var ZB = { [be]: 2, [Mt]: 1, [xt]: 1, [Xt]: 1, [Pe]: 4 };
function nS(e) {
  let { defaultWithScorePercent: t = 2, winningSide: r } = e, { matchUpStatusProfile: i = ZB, matchUpFormat: n = Si, pointsPerMinute: a = 1, sideWeight: o = 4 } = e;
  if (!Vr({ matchUpFormat: n })) return { error: lh };
  if (typeof i != "object") return { error: z };
  if (t > 100 && (t = 100), isNaN(t) || isNaN(a) || isNaN(o)) return { error: z };
  let s = Object.keys(i).filter((T) => Object.keys(cw).includes(T) && T !== vt);
  if (Object.keys(s).reduce((T, R) => T + i[R], 0) > 100) return { error: z, matchUpStatusProfile: i };
  let c = s.reduce((T, R) => (T.pointer = T.pointer + i[R], T.valueMap.push([T.pointer, R]), T), { pointer: 0, valueMap: [] }), u = ti(1, 100), l = (c.valueMap.find((T) => u <= T[0]) ?? [100, vt])[1], d = { sets: [], scoreStringSide1: "", side2ScoreString: "" };
  if ([be, Pe].includes(l)) {
    r = r || ti(1, 2);
    let T = { score: d, matchUpStatus: l, winningSide: r };
    if (!(l === Pe && ti(1, 100) > 100 - t)) return { outcome: T };
  } else if ([Mt, xt].includes(l)) return { outcome: { score: d, matchUpStatus: l } };
  let p = Sr(n), { bestOf: m = 1, exactly: f, setFormat: h, finalSetFormat: g } = p ?? {}, I = [], U = ti(0, 1), S = r ? [r - 1] : [...te(0, o).map(() => U), 1 - U], P = [Xt, Pe, $r, fa].includes(l) && (Lr(te(1, f || m)) || 1), v, D = te(1, (f ?? m) + 1);
  for (let T of D) {
    let R = T === (f ?? m), { set: M, incomplete: E, winningSideNumber: A } = e2({ setFormat: R && g || h, incomplete: P === T, pointsPerMinute: a, matchUpStatus: l, weightedRange: S, setNumber: T });
    if (I.push(M), E) {
      v = A;
      break;
    }
    if (ou({ matchUp: { score: { sets: I }, matchUpFormat: n } }).calculatedWinningSide) break;
  }
  let y = ou({ matchUp: { score: { sets: I }, matchUpFormat: n, winningSide: r } }), w = v ? r || v : y.calculatedWinningSide, { score: b } = oN({ winningSide: w, score: { sets: I }, matchUpStatus: l });
  return { outcome: { winningSide: w, matchUpStatus: l, score: b } };
}
function e2({ weightedRange: e = [0, 1], pointsPerMinute: t, matchUpStatus: r, incomplete: i, setFormat: n, setNumber: a }) {
  let o = { setNumber: a }, { setTo: s, tiebreakFormat: c, tiebreakAt: u, tiebreakSet: l, timed: d, minutes: p } = n, m = ti(0, e.length - 1), f = e[m], h;
  if (d) {
    let g = p * t, I = Math.round(g * 0.2), U = g + Lr([1, -1]) * I, S = hC(U, 2), P = [S, U - S];
    f && P.reverse(), h = e[m] + 1;
    let v = P[0] > P[1] && 1 || P[1] > P[0] && 2 || 0;
    if (i) {
      let [w, b] = P;
      return Object.assign(o, { side1Score: w, side2Score: b }), Lt.includes(r) ? { set: o, incomplete: i, winningSideNumber: h } : { set: o, incomplete: i };
    }
    v || (P[ti(0, 1)] += 1), v = P[0] > P[1] ? 1 : 2, v !== h && P.reverse();
    let [D, y] = P;
    return Object.assign(o, { side1Score: D, side2Score: y, winningSide: h }), { set: o };
  } else {
    if (i) return o.side1Score = ti(0, u), o.side2Score = ti(0, u), Lt.includes(r) && (h = e[m] + 1), { set: o, incomplete: i, winningSideNumber: h };
    {
      let g = te(1, s + 1).map((y) => te(0, s + 2 - y).map(() => y)).flat(), I = g[ti(0, g.length - 1)], U = s && qI({ isSide1: !0, tiebreakAt: u, lowValue: I, setTo: s }), S = !U, P = e.length === 1 && e[m] + 1;
      if (!S) {
        P ? (U[0] > U[1] ? 1 : 2) !== P && U.reverse() : f && U.reverse();
        let [y, w] = U;
        Object.assign(o, { side1Score: y, side2Score: w });
      }
      let v = nu({ matchUpScoringFormat: { setFormat: n }, setObject: o }), D;
      if (v.hasTiebreakCondition || S) {
        let { NoAD: y, tiebreakTo: w } = c || l || {}, b = te(1, w + 1).map((M) => te(0, w + 2 - M).map(() => M)).flat(), T = b[ti(0, b.length - 1)], R = Hp({ isSide1: !0, tiebreakNoAd: y, tiebreakTo: w, lowValue: T });
        if (R) if (S) {
          let M = R[0] > R[1] ? 1 : 2;
          P ? M !== P && R.reverse() : f && R.reverse(), [o.side1TiebreakScore, o.side2TiebreakScore] = R, D = R[0] > R[1] && 1 || R[1] > R[0] && 2 || void 0;
        } else v.leadingSide === 2 ? [o.side1TiebreakScore, o.side2TiebreakScore] = R : [o.side2TiebreakScore, o.side1TiebreakScore] = R;
      }
      o.winningSide = v.winningSide || v.leadingSide || P || D;
    }
  }
  return { set: o };
}
function Pd(e) {
  let { matchUpStatusProfile: t, completeAllMatchUps: r, randomWinningSide: i, tournamentRecord: n, completionGoal: a, drawDefinition: o, event: s } = e;
  if (!o) return { error: ne };
  let c = e.matchUpFormat || o.matchUpFormat || s?.matchUpFormat, u = o.structures.slice().sort(_o), l = 0, { matchUps: d, matchUpsMap: p } = Et({ matchUpFilters: { matchUpTypes: [ot], roundNumbers: [1] }, contextFilters: { stages: [re, se] }, inContext: !0, drawDefinition: o });
  if (d?.length) {
    let I = s?.category?.ageCategoryCode || s?.category?.categoryName;
    if (I) {
      let U = FR({ singlesOnly: !0, tournamentRecord: n, drawDefinition: o, scaleAccessor: { scaleName: I, sortOrder: "ASC", scaleType: ia }, event: s });
      if (U.error) return U;
      let { lineUps: S, participantsToAdd: P } = U;
      Mi({ tournamentRecord: n, participants: P }), Be({ element: o, extension: { name: Fn, value: S } });
    } else {
      let U = d[0]?.structureId, { positionAssignments: S } = Je({ drawDefinition: o, structureId: U });
      if (S?.length) {
        let { participants: P } = ft({ participantFilters: { participantTypes: [ot] }, tournamentRecord: n }), v = (D) => {
          let y = D.tieMatchUps.filter(bt(Xe)), w = D.tieMatchUps.filter(bt(Ke));
          y.forEach((b, T) => {
            let R = b.matchUpId;
            b.sides.forEach((M) => {
              let { drawPosition: E } = M, A = P?.find((N) => {
                let { participantId: C } = N;
                return S.find((k) => k.participantId === C)?.drawPosition === E;
              });
              if (A) {
                let N = A.individualParticipantIds?.[T];
                N && Sd({ teamParticipantId: A.participantId, participantId: N, tournamentRecord: n, drawDefinition: o, tieMatchUpId: R, event: s });
              }
            });
          }), w.forEach((b, T) => {
            let R = b.matchUpId;
            b.sides.forEach((M) => {
              let { drawPosition: E } = M, A = P?.find((N) => {
                let { participantId: C } = N;
                return S.find((k) => k.participantId === C)?.drawPosition === E;
              });
              A && A.individualParticipantIds?.slice(T * 2, T * 2 + 2)?.forEach((N) => {
                Sd({ teamParticipantId: A.participantId, participantId: N, tournamentRecord: n, drawDefinition: o, tieMatchUpId: R, event: s });
              });
            });
          });
        };
        d.forEach(v);
      }
    }
  }
  let m = typeof r == "string" && r, f = m && vt, h = u.length === 2 && u[0].finishingPosition === Aa && Pt(u.map(({ stage: I }) => I), [re, yt]).length === 2, g = u.map(({ structureId: I }) => I);
  for (let I of g) {
    if (l >= a) break;
    let U = o.structures.find((v) => v.structureId === I), S = Ve({ contextFilters: { matchUpTypes: [Ke, Xe] }, afterRecoveryTimes: !1, tournamentRecord: n, inContext: !0, drawDefinition: o, matchUpsMap: p, structure: U, event: s }).matchUps;
    S.length;
    let P = S.filter(({ winningSide: v }) => !v).sort(Ho).map($t);
    for (let v of P) {
      if (!isNaN(a) && l >= a) break;
      let { matchUps: D } = Ve({ matchUpFilters: { matchUpTypes: [Ke, Xe] }, afterRecoveryTimes: !1, tournamentRecord: n, inContext: !0, drawDefinition: o, matchUpsMap: p, structure: U, event: s }), y = D.find((b) => b.matchUpId === v), w = [Mt, xt].includes(y.matchUpStatus);
      if (y?.readyToScore && !w) {
        let b = t2({ matchUpStatusProfile: t, tournamentRecord: n, drawDefinition: o, targetMatchUp: y, matchUpFormat: c, matchUpStatus: f, scoreString: m, winningSide: !i && 1, event: s });
        if (b?.error) return b;
        l += 1;
      }
    }
    h && U.finishingPosition === Aa && e.completeRoundRobinPlayoffs && oc({ structureId: U.structureId, applyPositioning: !0, drawDefinition: o });
  }
  return { ...x, completedCount: l };
}
function wN(e) {
  let { matchUpStatusCodes: t, policyDefinitions: r, tournamentRecord: i, drawDefinition: n, targetMatchUp: a, matchUpStatus: o, matchUpFormat: s, scoreString: c, winningSide: u, event: l } = e;
  if (!a || a.matchUpStatus === "BYE") return;
  let { matchUpId: d } = a || {}, { outcome: p } = XU({ matchUpFormat: s, matchUpStatus: o, scoreString: c, winningSide: u });
  return t && (p.matchUpStatusCodes = t), yl({ tournamentRecord: i, policyDefinitions: r, drawDefinition: n, matchUpFormat: s, matchUpId: d, outcome: p, event: l });
}
function t2(e) {
  let { matchUpStatusProfile: t = {}, tournamentRecord: r, policyDefinitions: i, drawDefinition: n, matchUpStatus: a, matchUpFormat: o, targetMatchUp: s, scoreString: c, winningSide: u, event: l } = e;
  if (c || a) return wN(e);
  let { matchUpId: d } = s || {}, { outcome: p } = nS({ matchUpStatusProfile: t, matchUpFormat: o, winningSide: u });
  return yl({ policyDefinitions: i, tournamentRecord: r, drawDefinition: n, matchUpFormat: o, matchUpId: d, outcome: p, event: l });
}
function TN({ matchUpStatusProfile: e, completeAllMatchUps: t, randomWinningSide: r, tournamentRecord: i, drawProfiles: n, isMock: a, event: o }) {
  let s = wt({ event: o }).flightProfile, { eventName: c, eventType: u, category: l } = o, { startDate: d } = i, p = [], m = l?.categoryName || l?.ageCategoryCode || l?.ratingType, f = o.drawDefinitions?.map(({ drawId: h }) => h);
  if (Array.isArray(s?.flights)) for (let [h, g] of s.flights.entries()) {
    let { drawId: I, stage: U, drawName: S, drawEntries: P } = g;
    p.push(g.drawId);
    let v = n[h], { seedsCount: D, generate: y = !0 } = v || {};
    if (y) {
      let w = P.filter(qr(yn)).map(qr(yn)), b = m || c;
      if (i && D && D <= w.length && te(1, D + 1).forEach((A, N) => {
        let C = { scaleValue: A, scaleName: b, scaleType: un, eventType: u, scaleDate: d }, k = w[N];
        dl({ tournamentRecord: i, participantId: k, scaleItem: C });
      }), f?.includes(I)) break;
      let T = Il({ ...v, matchUpType: u, seedingScaleName: b, tournamentRecord: i, drawEntries: P, drawName: S, drawId: I, isMock: a, event: o, stage: U });
      if (T.error) return { error: T.error, drawIds: [] };
      let { drawDefinition: R } = T;
      if (!R) return { error: zr };
      let M = n[h]?.drawExtensions;
      if (Array.isArray(M) && M.filter(Xi).forEach((A) => Be({ element: R, extension: A })), T = Ul({ suppressNotifications: !0, tournamentRecord: i, drawDefinition: R, event: o }), T.error) return { error: T.error, drawIds: [] };
      if (v?.withPlayoffs) {
        let A = R.structures?.[0].structureId, N = kp({ idPrefix: v.idPrefix, ...v.withPlayoffs, tournamentRecord: i, drawDefinition: R, structureId: A, isMock: a, event: o });
        if (N?.error) return N;
      }
      let E = v?.completionGoal;
      if (v?.automated !== !1 && (t || E)) {
        let A = v?.matchUpFormat, N = Pd({ completeAllMatchUps: !E && t, matchUpStatusProfile: e, randomWinningSide: r, tournamentRecord: i, completionGoal: E, drawDefinition: R, matchUpFormat: A, event: o });
        if (N.error) return { error: N.error, drawIds: [] };
        let C = N.completedCount;
        if (v?.drawType === Sn) {
          let k = R.structures?.find((B) => B.stage === re);
          if (!k) return { error: mt };
          let O = oc({ structureId: k.structureId, tournamentRecord: i, drawDefinition: R });
          if (O.error) return { error: O.error, drawIds: [] };
          let _ = E ? E - (C ?? 0) : void 0;
          if (O = Pd({ completeAllMatchUps: !E && t, completionGoal: E ? _ : void 0, matchUpStatusProfile: e, randomWinningSide: r, tournamentRecord: i, drawDefinition: R, matchUpFormat: A, event: o }), O.error) return { error: O.error, drawIds: [] };
        }
      }
    }
  }
  return { ...x, drawIds: p };
}
function bN(e) {
  let { participantsProfile: t = {}, uniqueParticipantsCount: r, ratingsParameters: i, tournamentRecord: n, eventProfile: a, eventIndex: o, event: s, uuids: c } = e, { category: u, gender: l, eventType: d } = s, p = bt(Ki)(d) && Ne || bt(ai)(d) && De || d, m = r[re] || 0, f = r[se] || 0, h = a.drawProfiles?.length ? m + f : a.participantsProfile?.participantsCount ?? 0, g = [Ye, at].includes(l) ? l : void 0, I = t?.idPrefix ? `E-${o}-${t?.idPrefix}` : void 0, { participants: U } = Uc({ uuids: a.uuids || c, ...t, scaledParticipantsCount: a.scaledParticipantsCount, consideredDate: n?.startDate, rankingRange: a.rankingRange, participantType: p, participantsCount: h, ratingsParameters: i, category: u, idPrefix: I, sex: g }), S = Mi({ tournamentRecord: n, participants: U });
  if (S.error) return S;
  let P = U?.filter(({ participantType: D }) => D === p), v = U?.map(Re);
  return { uniqueDrawParticipants: P, uniqueParticipantIds: v };
}
function r2({ autoEntryPositions: e, tournamentRecord: t, drawParticipants: r, drawProfile: i, event: n }) {
  let { drawType: a = Wi, qualifyingPositions: o = 0, stage: s = re, drawSize: c = 0, drawName: u, drawId: l } = i, d = c - o, p = r.slice(0, d).map(Re);
  if (p.length) {
    let h = Hi({ participantIds: p, autoEntryPositions: e, entryStage: s, tournamentRecord: t, event: n });
    if (h.error) return h;
  }
  let m = p.map((h) => ({ entryStatus: kr, entryStage: s, participantId: h })), f = mm({ drawName: u || a, qualifyingPositions: o, drawEntries: m, drawId: l, event: n, stage: s });
  return f.error ? f : { ...x };
}
function MN({ uniqueDrawParticipants: e, autoEntryPositions: t, stageParticipants: r, tournamentRecord: i, drawProfiles: n, category: a, gender: o, event: s }) {
  let c = 0;
  for (let u of n) {
    let { qualifyingPositions: l = 0, uniqueParticipants: d, stage: p = re, drawSize: m = 0 } = u, f = m - l, h = d || o || a || p === se, g = h ? e.slice(c, c + f) : r[p || re] || [];
    h && (c += f);
    let I = r2({ autoEntryPositions: t, drawParticipants: g, tournamentRecord: i, drawProfile: u, event: s });
    if (I.error) return I;
  }
  return { ...x };
}
function RN(e) {
  let { allUniqueParticipantIds: t, matchUpStatusProfile: r, participantsProfile: i, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, ratingsParameters: c, tournamentRecord: u, eventProfile: l, eventIndex: d, publish: p, isMock: m, uuids: f } = e, h = l.gender, g = l.eventName, { eventType: I = Ki, policyDefinitions: U, drawProfiles: S = [], eventExtensions: P, surfaceCategory: v, tieFormatName: D, processCodes: y, discipline: w, eventLevel: b, timeItems: T, ballType: R, category: M } = l, E = l.eventId || je(), A = l.tieFormat || (I === kt ? kn({ namedFormat: D, event: { eventId: E, category: M, gender: h }, hydrateCollections: o, isMock: m }) : void 0), N = u.participants;
  for (let W of S) !h && W.gender && (h = W?.gender);
  let { stageParticipantsCount: C, uniqueParticipantsCount: k, uniqueParticipantStages: O } = PN({ drawProfiles: S, category: M, gender: h }), _ = bt(Ki)(I) && Ne || bt(ai)(I) && De || I, { uniqueDrawParticipants: B = [], uniqueParticipantIds: L = [] } = O ? bN({ event: { eventType: I, category: M, gender: h }, uniqueParticipantsCount: k, participantsProfile: i, ratingsParameters: c, tournamentRecord: u, eventProfile: l, eventIndex: d, uuids: f }) : {}, { eventAttributes: j } = l;
  typeof j != "object" && (j = {});
  let H = M?.categoryName || M?.ageCategoryCode || M?.ratingType;
  g = g || H || "Generated Event";
  let G = { ...j, surfaceCategory: v, processCodes: y, discipline: w, eventLevel: b, eventName: g, eventType: I, tieFormat: A, ballType: R, category: M, eventId: E, gender: h };
  if (P?.length && Array.isArray(P)) {
    let W = P.filter(Xi);
    W?.length && Object.assign(G, { extensions: W });
  }
  if (Array.isArray(T) && T.forEach((W) => Jo({ event: q, timeItem: W })), typeof U == "object") for (let W of Object.keys(U)) _a({ policyDefinitions: { [W]: U[W] }, event: G });
  G.category && (G.category.categoryName = H);
  let V, $ = dc({ suppressNotifications: !1, internalUse: !0, tournamentRecord: u, event: G });
  if ($.error) return $;
  let q = $?.event, { stageParticipants: Y } = DN({ allUniqueParticipantIds: t, stageParticipantsCount: C, eventParticipantType: _, targetParticipants: N });
  if (S?.length) {
    let W = MN({ uniqueDrawParticipants: B, autoEntryPositions: a, stageParticipants: Y, tournamentRecord: u, drawProfiles: S, category: M, gender: h, event: q });
    if (W.error) return W;
    let K = TN({ matchUpStatusProfile: r, completeAllMatchUps: n, randomWinningSide: s, tournamentRecord: u, drawProfiles: S, isMock: m, event: q });
    if (K.error) return K;
    V = K.drawIds;
  } else if (l?.participantsProfile?.participantsCount) {
    let W = B.map(Re);
    if (W.length) {
      let K = Hi({ participantIds: W, autoEntryPositions: a, tournamentRecord: u, entryStage: re, event: q });
      if (K.error) return K;
    }
  }
  return p && mc({ tournamentRecord: u, event: q }), { drawIds: V, eventId: E, uniqueParticipantIds: L };
}
function aS({ tournamentRecords: e, scheduleDate: t, venueId: r, round: i }) {
  if (!Ar(t)) return { error: Ht };
  let n = "addSchedulingProfileRound", { extension: a } = we({ name: Do, tournamentRecords: e, discover: !0 }), o = a?.value || [], s = o.find((p) => hn(t, p.scheduleDate));
  if (!s) {
    let { startDate: p, endDate: m } = Kp({ tournamentRecords: e }), f = new Date(t);
    if (p && f < new Date(p) || m && f > new Date(m)) return { error: Ht };
    s = { scheduleDate: t, venues: [] }, o.push(s);
  }
  let c = s.venues.find((p) => p.venueId === r);
  c || (c = { venueId: r, rounds: [] }, s.venues.push(c));
  let u = ["notBeforeTime"], l = (p) => Object.keys(p).filter((m) => !u.includes(m)).sort().map((m) => xe(p[m]) ? l(p[m]) : p[m]).flat().join("|");
  if (c.rounds.find((p) => l(p) === l(i))) return F({ result: { error: Av }, stack: n });
  c.rounds.push(i);
  let d = uc({ tournamentRecords: e, schedulingProfile: o });
  return d.error ? d : { ...x };
}
function i2({ schedulingProfile: e, tournamentRecord: t }) {
  if (typeof e != "object") return { error: z };
  let r = ec({ tournamentRecord: t }).containedStructures, i = Jt({ tournamentRecord: t }).matchUps ?? [], { tournamentId: n } = t, a = [];
  for (let o of e) {
    let { scheduleDate: s, venues: c = [] } = o;
    for (let u of c) {
      let { rounds: l, venueId: d } = u;
      for (let p of l) {
        let { drawId: m, winnerFinishingPositionRange: f, roundSegment: h } = p, g = i.filter((I) => {
          let U = f?.indexOf("-") > 0 && f.split("-").map((P) => +P), S = I.finishingPositionRange?.winner;
          return I.drawId === m && (!p.roundNumber || I.roundNumber === p.roundNumber) && (!S || !U || Pt(S, U).length === 2 || Ue(S).length === Ue(U).length && Pt(S, U).length === Ue(S).length);
        })[0];
        if (g) {
          let { eventId: I, roundNumber: U, drawName: S, structureName: P, roundName: v } = g, D = g.structureId;
          U && !f && (D = Object.keys(r).find((b) => r[b].includes(D)) ?? D);
          let y = { tournamentId: n, structureId: D, roundNumber: U, roundSegment: h, eventId: I, drawId: m }, w = aS({ tournamentRecords: { [n]: t }, round: y, scheduleDate: s, venueId: d });
          if (w.error) return w;
          a.push({ structureName: P, roundName: v, drawName: S, ...y });
        }
      }
    }
  }
  return { scheduledRounds: a };
}
function bm(e) {
  let t = oe(e, [{ drawProfile: !0, _ofType: Nr }]);
  if (t.error) return t;
  let { allUniqueParticipantIds: r = [], participantsProfile: i = {}, matchUpStatusProfile: n, completeAllMatchUps: a, autoEntryPositions: o, hydrateCollections: s, randomWinningSide: c, ratingsParameters: u, tournamentRecord: l, isMock: d = !0, drawProfile: p, startDate: m, drawIndex: f, uuids: h } = e, g = ie(p, !1, !0), { excessParticipantAlternates: I = !0, matchUpFormat: U = Si, drawType: S = Wi, tournamentAlternates: P = 0, alternatesCount: v = 0, qualifyingPositions: D, qualifyingProfiles: y, generate: w = !0, eventExtensions: b, drawExtensions: T, completionGoal: R, tieFormatName: M, buildTeams: E, seedsCount: A, timeItems: N, drawName: C, category: k, idPrefix: O, publish: _, gender: B, stage: L } = g, j = g.drawSize || (g.ignoreDefaults ? void 0 : 32), H = g.eventId || je(), G = p.eventType || p.matchUpType || Ki, V = G === ai ? De : Ne, $ = xe(p.tieFormat) && p.tieFormat || G === We && kn({ event: { eventId: H, category: k, gender: B }, namedFormat: M, hydrateCollections: s, isMock: d }) || void 0, q = k?.categoryName || k?.ageCategoryCode || k?.ratingType, Y = p.eventName || q || `Generated ${G}`, W = l?.participants || [], K = (y?.map((le) => le.structureProfiles || []).flat().reduce((le, ze) => {
    let Ae = !ze.participantsCount || ze.participantsCount > ze.drawSize ? ze.drawSize : ze.participantsCount || 0;
    return le + Ae;
  }, 0) || 0) * (V === De ? 2 : 1), Q = (!p.participantsCount || p.participantsCount > j ? j : p.participantsCount) || 0, X = { eventName: Y, eventType: G, tieFormat: $, category: k, eventId: H, gender: B };
  Array.isArray(N) && N.forEach((le) => Jo({ event: X, timeItem: le }));
  let { eventAttributes: ee } = p;
  if (typeof ee != "object" && (ee = {}), Object.assign(X, ee), b?.length && Array.isArray(b)) {
    let le = b.filter(Xi);
    le?.length && Object.assign(X, { extensions: le });
  }
  let Z = [];
  if (i?.participantsCount === 0 || p.uniqueParticipants || K || !l || B || k) {
    let le = (Q || 0) + v + K, ze = le, Ae = { [Ye]: 0, [at]: 0 }, nt, Ee;
    G === We && ({ teamSize: nt, genders: Ee } = iS({ alternatesCount: v, tieFormatName: M, tieFormat: $, drawSize: j }), Object.keys(Ee).forEach((Ze) => {
      [Ye, at].includes(Ze) && Ee[Ze] && (Ae[Ze] = j * Ee[Ze]);
    }), ze = nt * ((j || 0) + K));
    let rt = i?.idPrefix ? `D-${f}-${i?.idPrefix}` : void 0, ge = Uc({ ...i, scaledParticipantsCount: p.scaledParticipantsCount || i.scaledParticipantsCount, participantsCount: ze, consideredDate: l?.startDate, sex: B || i?.sex, rankingRange: p.rankingRange, uuids: p.uuids || h, ratingsParameters: u, participantType: V, gendersCount: Ae, idPrefix: rt, category: k }).participants;
    if (X.category && (X.category.categoryName = q), l) {
      let Ze = Mi({ participants: ge, tournamentRecord: l });
      if (Ze.error) return Ze;
    }
    if (ge.forEach(({ participantId: Ze }) => Z.push(Ze)), W = ge, G === We) {
      let Ze = Ee[Ye] ? ge.filter(({ participantType: qe, person: jt }) => qe === Ne && jt?.sex === Ye).map(Re) : [], At = Ee[at] ? ge.filter(({ participantType: qe, person: jt }) => qe === Ne && jt?.sex === at).map(Re) : [], ye = ge.filter(({ participantType: qe }) => qe === Ne).map(Re).filter((qe) => !Ze.includes(qe) && !At.includes(qe)), Qe = [...g.teamNames ?? [], ...vd({ count: le }).names], Ce = nt - (Ee[Ye] + Ee[at]), Fe = 0, ke = 0, Wt = 0, Ut = te(0, le).map((qe) => {
        let jt = At.slice(Fe, Fe + Ee[at]), ji = Ze.slice(ke, ke + Ee[Ye]), Zt = ye.slice(Wt, Wt + Ce);
        Fe += Ee[at], ke += Ee[Ye], Wt += Ce;
        let Ai = E !== !1 ? [...jt, ...ji, ...Zt] : [];
        return { participantName: Qe[qe] || `Team ${qe + 1}`, participantOtherName: `TM${qe + 1}`, participantRole: rr, individualParticipantIds: Ai, participantType: We, participantId: je() };
      }), St = Mi({ participants: Ut, tournamentRecord: l });
      if (!St.success) return St;
      W = Ut;
    }
  }
  let ce = (le) => {
    let { participantType: ze } = le;
    return bt(Ki)(G) && ze === Ne || bt(ai)(G) && ze === De ? !0 : G === We && ze === We;
  }, fe = (le) => !p.gender || le.person?.sex === p.gender ? !0 : le.individualParticipantIds?.some((ze) => {
    let Ae = W.find((nt) => nt.participantId === ze);
    return Ae && fe(Ae);
  }), He = W.filter(ce).filter(fe).filter(({ participantId: le }) => !r.includes(le)), Te = He.slice(0, Q).map((le) => le.participantId);
  if (d && Te?.length) {
    let le = Hi({ autoEntryPositions: o, entryStage: L, tournamentRecord: l, participantIds: Te, event: X });
    if (le.error) return le;
  }
  let $e = K ? He.slice(Q, Q + K).map((le) => le.participantId) : 0;
  if (d && $e?.length) {
    let le = 0, ze = 1, Ae = (Ee, rt) => Ee.stageSequence - rt.stageSequence, nt = (Ee, rt) => Ee.roundTarget - rt.roundTarget;
    for (let Ee of y.sort(nt)) {
      ze = Ee.roundTarget || ze;
      let rt = 1, ge;
      for (let Ze of Ee.structureProfiles.sort(Ae)) {
        let At = (Ze.drawSize || eh(Ze.participantsCount)) - (ge || 0), ye = $e.slice(le, le + At), Qe = Hi({ entryStage: se, entryStageSequence: rt, autoEntryPositions: o, tournamentRecord: l, participantIds: ye, roundTarget: ze, event: X });
        if (Qe.error) return Qe;
        ge = Ze.qualifyingPositions, le += At, rt += 1;
      }
      ze += 1;
    }
  }
  let it = I && l?.participants?.filter(({ participantId: le }) => !Te.includes(le)).filter(ce).filter(fe).slice(0, v || j - Q || P).map((le) => le.participantId);
  if (d && it?.length) {
    let le = Hi({ participantIds: it, autoEntryPositions: !1, entryStatus: vi, tournamentRecord: l, event: X });
    if (le.error) return le.error;
  }
  let It = q || Y;
  l && A && A <= Te.length && te(1, A + 1).forEach((le, ze) => {
    let Ae = { scaleName: It, scaleDate: m, scaleType: kg, scaleValue: le, eventType: G }, nt = Te[ze];
    dl({ tournamentRecord: l, participantId: nt, scaleItem: Ae });
  });
  let Rt = Il({ ...ie(p, !1, !0), tournamentRecord: l, seedingScaleName: It, matchUpFormat: U, eventId: H, isMock: d, event: X });
  if (Rt.error) return Rt;
  if (!Rt.drawDefinition) return { error: zr };
  let { drawDefinition: de } = Rt, lt = de.drawId;
  if (Array.isArray(T) && T.filter(Xi).forEach((le) => Be({ element: de, extension: le })), w) {
    if (Ul({ drawDefinition: de, event: X, suppressNotifications: !0 }), p.withPlayoffs) {
      let ze = de.structures?.[0].structureId, Ae = kp({ ...p.withPlayoffs, tournamentRecord: l, drawDefinition: de, structureId: ze, idPrefix: O, isMock: d, event: X });
      if (Ae?.error) return Ae;
    }
    let le = p.automated === !1;
    if (d && !le) {
      let ze = (Ae) => {
        let nt = Pd({ completeAllMatchUps: Ae.completeAllMatchUps, completionGoal: Ae.completionGoal, matchUpStatusProfile: n, randomWinningSide: c, tournamentRecord: l, drawDefinition: de, matchUpFormat: U, event: X });
        if (nt.error) return nt;
        let Ee = nt.completedCount;
        if (S === Sn) {
          let rt = de.structures?.find((At) => At.stage === re);
          if (!rt) return { error: mt };
          oc({ structureId: rt.structureId, tournamentRecord: l, drawDefinition: de });
          let ge = R ? R - (Ee ?? 0) : void 0, Ze = Pd({ completionGoal: R ? ge : void 0, matchUpStatusProfile: n, completeAllMatchUps: a, randomWinningSide: c, tournamentRecord: l, drawDefinition: de, matchUpFormat: U, event: X });
          if (Ze.error) return Ze;
        }
      };
      if (R && ze({ completionGoal: R }), p.outcomes) {
        let { matchUps: Ae } = hr({ inContext: !0, drawDefinition: de, event: X });
        for (let nt of p.outcomes) {
          let { matchUpStatus: Ee = vt, matchUpStatusCodes: rt, stageSequence: ge = 1, matchUpIndex: Ze = 0, structureOrder: At, matchUpFormat: ye, drawPositions: Qe, roundPosition: Ce, stage: Fe = re, roundNumber: ke, winningSide: Wt, scoreString: Ut } = nt, St = Ae?.reduce((Zt, Ai) => {
            let { structureId: on, matchUpId: Sc } = Ai;
            return Zt[on] ? Zt[on].push(Sc) : Zt[on] = [Sc], Zt;
          }, {}) ?? [], qe = Object.assign({}, ...Object.keys(St).map((Zt, Ai) => ({ [Zt]: Ai + 1 }))), jt = Ae?.filter((Zt) => (!Fe || Zt.stage === Fe) && (!ge || Zt.stageSequence === ge) && (!ke || Zt.roundNumber === ke) && (!Ce || Zt.roundPosition === Ce) && (!At || qe[Zt.structureId] === At) && (!Qe || Pt(Qe, Zt.drawPositions).length === 2))?.[Ze], ji = wN({ matchUpStatusCodes: rt, tournamentRecord: l, drawDefinition: de, targetMatchUp: jt, matchUpFormat: ye, matchUpStatus: Ee, scoreString: Ut, winningSide: Wt });
          if (ji?.error) return ji;
        }
      }
      a && ze({ completeAllMatchUps: a });
    }
    _ && mc({ tournamentRecord: l, event: X });
  } else {
    let le = mm({ drawEntries: de.entries, drawName: C || S, qualifyingPositions: D, drawId: lt, event: X, stage: L });
    if (le.error) return le;
  }
  return { ...x, event: ae(X), uniqueParticipantIds: Z, targetParticipants: W, drawDefinition: de, eventId: H, drawId: lt };
}
var NN = () => ({ altitude: void 0, courtId: void 0, courtName: "", courtDimensions: void 0, latitude: void 0, longitude: void 0, surfaceCategory: void 0, surfaceType: void 0, surfacedDate: void 0, dateAvailability: [], onlineResources: [], pace: void 0, notes: void 0 }), n2 = NN;
function Dd(e) {
  return parseInt(e);
}
function ky({ startTime: e = "", endTime: t = "" } = {}) {
  if (!e || !t || !wa.test(e) || !wa.test(t)) return !1;
  let [r, i] = e.split(":").map(Dd), [n, a] = t.split(":").map(Dd);
  return n < r ? !1 : !(r === n && a < i);
}
function a2(e, t) {
  let [r, i] = e.startTime.split(":").map(Dd), [n, a] = t.startTime.split(":").map(Dd);
  return r < n ? -1 : r > n ? 1 : i < a ? -1 : i > a ? 1 : 0;
}
function EN({ dateAvailability: e }) {
  if (!e) return { error: Hv };
  if (!Array.isArray(e)) return { error: Cl };
  let t = "Dates must be formated => YYYY-MM-DD", r = "Times must be 24 hour => 00:00";
  for (let i of e) {
    if (typeof i != "object") return { error: Cl };
    let { date: n, startTime: a, endTime: o, bookings: s = [] } = i;
    if (!a || !o) return { error: Cl };
    if (n && !Yi.test(n)) return { error: Ht, dateAvailability: { date: n }, info: t };
    if (!wa.test(a)) return { error: fi, dateAvailability: { startTime: a }, info: r };
    if (!wa.test(o)) return { error: fi, dateAvailability: { endTime: o }, info: r };
    if (a === o) return { error: fi, dateAvailability: { startTime: a, endTime: o }, info: "startTime and endTime are equivalent" };
    if (!ky({ startTime: a, endTime: o })) return { error: fi, dateAvailability: { startTime: a, endTime: o }, info: "endTime must be after startTime" };
    if (s) {
      if (!Array.isArray(s)) return { error: zl };
      for (let c of s) {
        if (typeof c != "object") return { error: zl };
        let { startTime: u, endTime: l } = c;
        if (!wa.test(u)) return { error: fi, booking: { startTime: u }, info: r };
        if (!wa.test(l)) return { error: fi, booking: { endTime: l }, info: r };
        if (u === l) return { error: fi, dateAvailability: { startTime: u, endTime: l }, info: "startTime and endTime are equivalent" };
        if (!ky({ startTime: u, endTime: l })) return { error: fi, dateAvailability: { startTime: u, endTime: l }, info: "endTime must be after startTime" };
      }
    }
  }
  return { valid: !0 };
}
function Mm({ tournamentRecord: e, disableNotice: t, venueId: r, courtId: i, court: n }) {
  let { venue: a } = Mn({ tournamentRecord: e, venueId: r });
  if (!a) return { error: Co };
  a.courts || (a.courts = []);
  let o = { ...NN(), venueId: r, courtId: i };
  if (o.courtId || (o.courtId = je()), a.courts.some((s) => s.courtId === o.courtId)) return { error: uP };
  {
    let s = (n?.dateAvailability || []).map((l) => ({ ...l, date: ve(l.date), startTime: ct(l.startTime), endTime: ct(l.endTime), bookings: l.bookings?.map(({ startTime: d, endTime: p, bookingType: m }) => ({ startTime: ct(d), endTime: ct(p), bookingType: m })) })), c = Object.keys(o);
    for (let l of c) if (n?.[l]) if (l === "dateAvailability") {
      let d = EN({ dateAvailability: s });
      if (!d.valid && d.error) return d;
      o.dateAvailability = s;
    } else o[l] = n[l];
    let u = o;
    return a.courts.push(u), t || Se({ payload: { venue: a, tournamentId: e.tournamentId }, topic: Ya, key: a.venueId }), { ...x, court: ie(o), venueId: r };
  }
}
function oS(e) {
  let { tournamentRecord: t, venueId: r } = e;
  if (typeof r != "string" || !r) return { error: da };
  let i = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, n = [], a;
  for (let o of Object.values(i)) {
    let { venue: s } = Mn({ tournamentRecord: o, venueId: r });
    if (s) {
      let c = o2({ ...e, tournamentRecord: o });
      for (let u of c?.courts ?? []) n.push(u?.courtId);
      if (c.error) return c;
      a = !0;
    }
  }
  return a ? { ...x, courtIds: n } : { error: Co };
}
function o2({ courtNameRoot: e = "Court", dateAvailability: t = [], venueAbbreviationRoot: r, tournamentRecord: i, courtNames: n = [], courtTimings: a, courtsCount: o, startTime: s, courtIds: c, endTime: u, idPrefix: l, venueId: d, dates: p }) {
  if (!d) return { error: da };
  let m = Mn({ tournamentRecord: i, venueId: d });
  if (m.error) return m;
  let { venue: f } = m;
  if (!gt(o) || !n) return { error: cP };
  o = o ?? n.length;
  let h = te(0, o).map((g) => {
    let I = a?.[g], U = I ? p.map((S) => ({ date: Ui(S), startTime: s, endTime: u, ...I })) : t;
    return I && s && u && U.push({ startTime: s, endTime: u }), { courtName: n[g] || r && f?.venueAbbreviation && `${f?.venueAbbreviation} ${g + 1}` || `${e} ${g + 1}`, dateAvailability: U };
  }).map((g, I) => {
    let U = c?.pop() || l && `${l}-${I + 1}`;
    return Mm({ disableNotice: !0, tournamentRecord: i, courtId: U, venueId: d, court: g });
  }).map((g) => g.court).filter(Boolean);
  return h.length !== o ? F({ info: "not all courts could be generated", result: { error: z } }) : (f && Se({ payload: { venue: f, tournamentId: i.tournamentId }, topic: Ya, key: f.venueId }), { ...x, courts: ie(h) });
}
function sS({ tournamentRecord: e, ignoreExistingVenues: t, venueProfiles: r, uuids: i }) {
  let { startDate: n, endDate: a } = e, o = [];
  for (let [s, c] of r.entries()) {
    let { venueAbbreviation: u, venueId: l = i?.pop() ?? je(), dateAvailability: d, startTime: p = "07:00", endTime: m = "19:00", courtTimings: f, courtsCount: h, courtNames: g, venueName: I, idPrefix: U, courtIds: S } = c, P = { venueName: I || `Venue ${s + 1}`, venueAbbreviation: u, venueId: l }, v = $u({ tournamentRecord: e, venue: P });
    if (v.error) {
      if (t) continue;
      return v;
    }
    o.push(l);
    let D = ys(n, a), y = !Array.isArray(d) && [{ startTime: p, endTime: m }].concat(D.map((w) => ({ date: Ui(w), startTime: p, endTime: m })));
    if (h || g) {
      let w = oS({ dateAvailability: d || y, tournamentRecord: e, courtTimings: f, courtsCount: h, courtNames: g, startTime: p, idPrefix: U, courtIds: S, endTime: m, venueId: l, dates: D });
      if (w.error) return w;
    }
  }
  return o;
}
function s2(e) {
  let { tournamentRecord: t, leagueProfiles: r, eventIds: i, venueIds: n, drawIds: a, allUniqueParticipantIds: o, uuids: s } = e, c = 0;
  for (let l of r) {
    let d = [], { tieFormatName: p = Zl, teamProfiles: m = [], teamsCount: f = 0, category: h, idPrefix: g, gender: I } = l, U = l.leagueName ?? l.eventName ?? `League ${c + 1}`, S = l.leagueId ?? l.eventId ?? s?.pop() ?? je();
    i.push(S);
    let P = xe(l.tieFormat) && l.tieFormat || kn({ event: { eventId: S, category: h, gender: I }, namedFormat: p, isMock: e.isMock }) || void 0;
    if (!P) return { error: $s };
    let v = Math.max(f, m.length), D = te(0, v), { genders: y, teamSize: w } = iS({ tieFormat: P, drawSize: v }), b = { [at]: 0, [vr]: 0, [Da]: 0, [Ye]: 0, ANY: 0 };
    Object.keys(y).forEach((R) => b[R] += y[R]);
    for (let R of D) {
      let M = m?.[R]?.teamName ?? `Team ${R + 1}`, E = m?.[R]?.teamId || s?.pop() || je(), A = l.startDate ?? e.startDate, N = Uc({ ...l?.participantsProfile, participantsCount: w, consideredDate: A, gendersCount: b, category: h, uuids: s }).participants, C = N.map((j) => j.participantId), k = We, O = E ?? yd({ participantType: k, idPrefix: g, index: R, uuids: s });
      d.push({ participantId: O, entryStatus: kr, entryStage: re });
      let _ = m?.[R]?.venueIds ?? [], B = { participantId: O, participantRole: rr, participantName: M, individualParticipantIds: C, participantType: k, homeVenueIds: _ };
      _.forEach((j) => !n.includes(j) && n.push(j)), o.push(...C), o.push(O);
      let L = Mi({ participants: [B, ...N], tournamentRecord: t });
      if (L.error) return L;
    }
    let T = { eventName: U, entries: d, eventType: We, tieFormat: P, category: h, eventId: S, gender: I };
    if (t.events || (t.events = []), t.events.push(T), d.length) {
      let R = (gt(l.roundsCount) && l.roundsCount) ?? l.roundsCount === e1 ? (v - 1) * 2 : v - 1, M = Il({ automated: l.automated, tournamentRecord: t, drawType: Gr, roundsCount: R, drawSize: v, event: T });
      if (M.error) return M;
      let { drawDefinition: E } = M;
      if (E) {
        let A = E?.drawId;
        Ul({ drawDefinition: E, event: T, suppressNotifications: !0 }), a.push(A);
      }
    }
    c++;
  }
  let u = n.map((l) => ({ venueId: l }));
  sS({ tournamentRecord: t, ignoreExistingVenues: !0, venueProfiles: u, uuids: s });
}
var c2 = ["Generated Tournament", "CourtHive Challenge", "Replication Crisis", "Open Competition", "Factory Follies", "Mock Tournament", "Atomic Culture", "Racket Rally", "Stats Fail"];
function AN(e) {
  let { startDate: t, endDate: r } = e ?? {}, { tournamentName: i = Lr(c2), ratingsParameters: n = Gt, tournamentExtensions: a, policyDefinitions: o, schedulingProfile: s, venueProfiles: c, uuids: u } = e ?? {}, l = e?.isMock === !1 ? void 0 : !0;
  if (t && !Ar(t) || r && !Ar(r)) return { error: Ht };
  if (e.leagueProfiles && !Array.isArray(e.leagueProfiles) || e.eventProfiles && !Array.isArray(e.eventProfiles) || e.drawProfiles && !Array.isArray(e.drawProfiles)) return { error: z };
  if (!t) {
    let U = /* @__PURE__ */ new Date();
    t = Ui(r ?? U), r = Ui(U.setDate(U.getDate() + 7));
  }
  if (!r) {
    let U = new Date(t);
    r = Ui(U.setDate(U.getDate() + 7));
  }
  let d = Tm({ ...e.tournamentAttributes ?? {}, tournamentName: i, startDate: t, endDate: r, isMock: l }), p = c?.length ? sS({ tournamentRecord: d, venueProfiles: c, uuids: u }) : [];
  if (a?.length && Array.isArray(a)) {
    let U = a.filter((S) => Xi({ extension: S }));
    U?.length && Object.assign(d, { extensions: U, isMock: l });
  }
  if (typeof o == "object") for (let U of Object.keys(o)) _a({ policyDefinitions: { [U]: o[U] }, tournamentRecord: d });
  if (!e?.leagueProfiles?.length || e.eventProfiles?.length || e.drawProfiles?.length || e.participantsProfile) {
    let U = vN({ tournamentRecord: d, ...e });
    if (!U.success) return U;
  }
  let m = [], f = [], h = [];
  if (e.leagueProfiles) {
    let U = s2({ allUniqueParticipantIds: m, tournamentRecord: d, ...e, eventIds: f, venueIds: p, drawIds: h });
    if (U?.error) return U;
  }
  if (e.drawProfiles) {
    let U = u2({ allUniqueParticipantIds: m, ratingsParameters: n, tournamentRecord: d, ...e, eventIds: f, drawIds: h });
    if (U?.error) return U;
  }
  if (e.eventProfiles) {
    let U = l2({ allUniqueParticipantIds: m, ratingsParameters: n, tournamentRecord: d, ...e, eventIds: f, drawIds: h });
    if (U?.error) return U;
  }
  let { scheduledRounds: g = void 0, schedulerResult: I = {} } = s ? d2({ ...e, tournamentRecord: d }) : {};
  return Ah(), ae({ ...x, tournamentRecord: d, scheduledRounds: g, schedulerResult: I, eventIds: f, venueIds: p, drawIds: h });
}
function u2(e) {
  let { tournamentRecord: t, drawProfiles: r, allUniqueParticipantIds: i, eventIds: n, drawIds: a } = e, o = 0;
  for (let s of r) {
    let c = bm({ allUniqueParticipantIds: i, tournamentRecord: t, drawProfile: s, drawIndex: o, ...e });
    if (c.error) return c;
    let { drawId: u, eventId: l, event: d, uniqueParticipantIds: p } = c;
    if (s?.addEvent !== !1) {
      if (c = dc({ suppressNotifications: !1, internalUse: !0, tournamentRecord: t, event: d }), c.error) return c;
      u && a.push(u), n.push(l);
    }
    p?.length && i.push(...p), o += 1;
  }
}
function l2(e) {
  let { eventProfiles: t, allUniqueParticipantIds: r, eventIds: i, drawIds: n } = e, a = 0;
  for (let o of t) {
    let s = RN({ ...e, eventIndex: a, eventProfile: o });
    if (s.error) return s;
    let { eventId: c, drawIds: u, uniqueParticipantIds: l } = s;
    u && n.push(...u), i.push(c), l?.length && r.push(...l), a += 1;
  }
}
function d2(e) {
  let { schedulingProfile: t, tournamentRecord: r, autoSchedule: i, periodLength: n, scheduleCompletedMatchUps: a } = e, o = i2({ schedulingProfile: t, tournamentRecord: r });
  if (o.error) return o;
  let s = o.scheduledRounds;
  if (i) {
    let { tournamentId: c } = r, u = { [c]: r };
    return { schedulerResult: wm({ scheduleCompletedMatchUps: a, tournamentRecords: u, periodLength: n }), scheduledRounds: s };
  }
  return { scheduledRounds: s };
}
var CN = {};
Me(CN, { anonymizeTournamentRecord: () => ON, modifyTournamentRecord: () => kN });
function ON({ keepExtensions: e = [], anonymizeParticipantNames: t = !0, tournamentRecord: r, tournamentName: i, personIds: n = [], tournamentId: a }) {
  if (!r) return { error: J };
  let o = Array.isArray(e) ? WS.concat(...e) : WS, s = (O) => Array.isArray(e) ? O?.extensions?.filter((_) => o.includes(_.name)) : O?.extensions, c = {};
  r.extensions = s(r);
  let u = a || je();
  c[r.tournamentId] = u, r.tournamentId = u, r.createdAt = (/* @__PURE__ */ new Date()).toISOString(), r.tournamentName = i || `Anonymized: ${Ui(/* @__PURE__ */ new Date())}`, r.isMock = !0, delete r.parentOrganisation;
  for (let O of r.participants || []) {
    O.extensions = s(O), O.onlineResources = [];
    let _ = je();
    c[O.participantId] = _, O.participantId = _;
  }
  for (let O of r.participants || []) Array.isArray(O.individualParticipantIds) && (O.individualParticipantIds = O.individualParticipantIds.map((_) => c[_]));
  let l = 0;
  for (let O of r.venues || []) {
    O.venueAbbreviation = `V${l}`, O.extensions = s(O), O.venueName = `Venue #${l}`, O.onlineResources = [], O.addresses = [];
    let _ = je();
    c[O.venueId] = _, O.isMock = !0, l += 1;
    let B = 0;
    for (let L of O.courts || []) L.courtName = `V${l}C${B}`, L.extensions = s(L), L.onlineResources = [], L.isMock = !0, B += 1;
  }
  let d = 1;
  for (let O of r.events || []) {
    O.extensions = s(O), O.onlineResources = [], O.isMock = !0;
    let _ = je();
    c[O.eventId] = _, O.eventId = _;
    let B = O.category?.categoryName || O.category?.ageCategoryCode || O.category?.ratingType || O.gender;
    if (O.eventName = `Event ${d} ${B}`, Array.isArray(O.entries)) for (let j of O.entries) j.participantId = c[j.participantId];
    for (let j of O.drawDefinitions || []) {
      j.extensions = s(j);
      let H = je();
      if (c[j.drawId] = H, j.drawId = H, j.isMock = !0, Array.isArray(j.entries)) for (let V of j.entries) V.participantId = c[V.participantId];
      let G = (V) => {
        V.extensions = s(V);
        let $ = je();
        c[V.structureId] = $, V.structureId = $;
        for (let q of V.positionAssignments || []) q.participantId && (q.participantId = c[q.participantId]);
        for (let q of V.seedAssignments || []) q.participantId && (q.participantId = c[q.participantId]);
        for (let q of V.matchUps || []) {
          q.isMock = !0;
          for (let Y of q.sides || []) Y.lineUp && (Y.lineUp = Y.lineUp.map(({ participantId: W, collectionAssignments: K }) => ({ participantId: c[W], collectionAssignments: K })));
        }
      };
      for (let V of j.structures || []) if (G(V), Array.isArray(V.structures)) for (let $ of V.structures) G($);
      for (let V of j.links || []) V.source.structureId = c[V.source.structureId], V.target.structureId = c[V.target.structureId];
    }
    let { extension: L } = we({ name: wi, element: O });
    Array.isArray(L?.value?.flights) && L?.value.flights?.forEach((j) => {
      if (j.drawId = c[j.drawId], Array.isArray(j.drawEntries)) for (let H of j.drawEntries) H.participantId = c[H.participantId];
    }), d += 1;
  }
  let p = r.startDate || Ui(/* @__PURE__ */ new Date()), m = (r.participants || []).filter(({ participantType: O }) => O === Ne), f = m.reduce((O, _) => {
    let B = _.person?.sex;
    return [Ye, at].includes(B) ? O[B] += 1 : O[Da] += 1, O;
  }, { [Ye]: 0, [at]: 0, [Da]: 0 }), h = Object.assign({}, ...Object.keys(f).map((O) => ({ [O]: yN({ category: { ageCategoryCode: "O18" }, count: f[O], personExtensions: [], consideredDate: p, sex: O })?.persons || [] }))), g = { [Ye]: 0, [at]: 0, [Da]: 0 }, I = m.length, U = m.reduce((O, _) => {
    let B = _.person?.addresses?.[0] || {}, { city: L, state: j, postalCode: H } = B;
    return O.cities.includes(L) || O.cities.push(L), O.states.includes(j) || O.states.push(j), O.postalCodes.includes(H) || O.postalCodes.push(H), O;
  }, { cities: [], postalCodes: [], states: [] }), S = U.postalCodes.length, P = U.cities.length, v = U.states.length, { cities: D } = gN({ count: P || I, participantsCount: I }), { states: y } = IN({ count: v || I, participantsCount: I }), { postalCodes: w } = UN({ count: S || I, participantsCount: I }), b = { cities: D, states: y, postalCodes: w };
  m.forEach((O, _) => {
    let B = O?.person, L = B?.sex || Da, j = ve(B?.birthDate)?.split("-")[0], H = g[L], G = h[L][H];
    if (g[L] += 1, j) {
      let [, V, $] = G?.birthDate?.split("-") || [], q = [j, V, $].join("-");
      G.birthDate = q;
    }
    if (B?.addresses) {
      let V = SN({ ...b, participantIndex: _, nationalityCode: G.nationalityCode });
      G.addresses = [V];
    }
    G.personId = n?.[_] || je(), t ? (G.standardFamilyName = G.lastName, G.standardGivenName = G.firstName, O.participantName = `${G.standardGivenName} ${G.standardFamilyName}`) : (G.standardFamilyName = B?.standardFamilyName, G.standardGivenName = B?.standardGivenName), delete G.firstName, delete G.lastName, G.extensions = s(B), O.person = G, c[B?.personId] = G.personId;
  }), (r.participants || []).filter(({ participantType: O }) => O === De).forEach((O) => {
    let { individualParticipantIds: _ } = O;
    O.participantName = p2({ individualParticipantIds: _, individualParticipants: m });
  });
  let T = (r.participants || []).filter(({ participantType: O }) => O === We), R = T.length, M = vd({ count: R }).names;
  T.forEach((O, _) => {
    O.participantName = M[_];
  });
  let E = (r.participants || []).filter(({ participantType: O }) => O === Xr), A = E.length, N = vd({ count: A, nameRoot: "Group" }).names;
  E.forEach((O, _) => {
    O.participantName = N[_];
  });
  let { extension: C } = we({ element: r, name: Do });
  Array.isArray(C?.value) && C?.value.forEach((O) => {
    O.tournamentId = c[O.tournamentId], O.structureId = c[O.structureId], O.eventId = c[O.eventId], O.drawId = c[O.drawId];
  });
  let { extension: k } = we({ element: r, name: Js });
  return Array.isArray(k?.value) && k?.value.forEach((O) => {
    O.personId = c[O.personId];
  }), { ...x };
}
function p2({ individualParticipantIds: e, individualParticipants: t }) {
  let r = t.filter(({ participantId: i }) => e.includes(i)).map(({ person: i }) => i?.standardFamilyName).filter(Boolean).sort().join("/");
  return e.length === 1 && (r += "/Unknown"), r;
}
function kN(e) {
  let { ratingsParameters: t = Gt, participantsProfile: r = {}, matchUpStatusProfile: i, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, schedulingProfile: c, tournamentRecord: u, autoSchedule: l, eventProfiles: d, periodLength: p, venueProfiles: m, drawProfiles: f, isMock: h, uuids: g } = e;
  if (!u) return { error: J };
  let I = [], U = [], S = [];
  d?.forEach((b) => {
    let T = u.events?.find((R, M) => b.eventIndex !== void 0 && M === b.eventIndex || b.eventName && R.eventName === b.eventName || b.eventId && R.eventId === b.eventId);
    T?.gender && (b.gender = T.gender);
  });
  let P = u.participants?.length || void 0;
  P && r?.idPrefix && (r.idPrefix = `${r.idPrefix}-${P}`);
  let v = vN({ startDate: u.startDate, participantsProfile: r, tournamentRecord: u, eventProfiles: d, drawProfiles: f, uuids: g });
  if (!v.success) return v;
  if (d) {
    let b = u.events?.length || 0;
    for (let T of d) {
      let { ratingsParameters: R } = T, M = u.events?.find((E, A) => T.eventIndex !== void 0 && A === T.eventIndex || T.eventName && E.eventName === T.eventName || T.eventId && E.eventId === T.eventId);
      if (M) {
        let { gender: E, category: A, eventType: N } = M, { drawProfiles: C, publish: k } = T, O = bt(Ki)(N) && Ne || bt(ai)(N) && De || N;
        if (C) {
          let { stageParticipantsCount: _, uniqueParticipantsCount: B, uniqueParticipantStages: L } = PN({ drawProfiles: C, category: A, gender: E }), { uniqueDrawParticipants: j = [], uniqueParticipantIds: H = [] } = L ? bN({ event: { eventType: N, category: A, gender: E }, uniqueParticipantsCount: B, participantsProfile: r, ratingsParameters: R, tournamentRecord: u, eventProfile: T, uuids: g }) : {};
          I.push(...H);
          let { stageParticipants: G } = DN({ targetParticipants: u.participants || [], allUniqueParticipantIds: I, stageParticipantsCount: _, eventParticipantType: O }), V = MN({ uniqueDrawParticipants: j, autoEntryPositions: a, stageParticipants: G, tournamentRecord: u, drawProfiles: C, category: A, gender: E, event: M });
          if (V.error || (V = TN({ matchUpStatusProfile: i, completeAllMatchUps: n, randomWinningSide: s, tournamentRecord: u, drawProfiles: C, isMock: h, event: M }), V.error)) return V;
          S.push(...V.drawIds);
        }
        k && mc({ tournamentRecord: u, event: M });
      } else {
        let E = RN({ startDate: u.startDate, allUniqueParticipantIds: I, matchUpStatusProfile: i, participantsProfile: r, completeAllMatchUps: n, autoEntryPositions: a, randomWinningSide: s, ratingsParameters: R, tournamentRecord: u, eventProfile: T, eventIndex: b, uuids: g });
        if (E.error) return E;
        let { eventId: A, drawIds: N, uniqueParticipantIds: C } = E;
        N && S.push(...N), U.push(A), C?.length && I.push(...C), b += 1;
      }
    }
  }
  if (f) {
    let b = (u.events || []).map((T) => T.drawDefinitions?.map(() => 1) || []).flat().reduce((T, R) => T + R, 0);
    for (let T of f) {
      let R = bm({ startDate: u.startDate, allUniqueParticipantIds: I, matchUpStatusProfile: i, participantsProfile: r, completeAllMatchUps: n, autoEntryPositions: a, hydrateCollections: o, randomWinningSide: s, ratingsParameters: t, tournamentRecord: u, drawProfile: T, drawIndex: b, uuids: g });
      if (R.error) return R;
      let { drawId: M, eventId: E, event: A, uniqueParticipantIds: N } = R;
      if (R = dc({ tournamentRecord: u, event: A, internalUse: !0 }), R.error) return R;
      M && S.push(M), U.push(E), N?.length && I.push(...N), b += 1;
    }
  }
  let D = m?.length ? sS({ tournamentRecord: u, venueProfiles: m }) : [], y, w = {};
  if (c?.length) {
    let b = { [u.tournamentId]: u }, T = uc({ tournamentRecords: b, schedulingProfile: c });
    if (T.error) return T;
    if (l) {
      let { tournamentId: R } = u, M = { [R]: u };
      w = wm({ tournamentRecords: M, periodLength: p });
    }
  }
  return { totalParticipantsCount: u.participants.length, scheduledRounds: y, schedulerResult: w, ...x, eventIds: U, venueIds: D, drawIds: S };
}
var xN = {};
Me(xN, { addDynamicRatings: () => kI, addIndividualParticipantIds: () => Im, addParticipant: () => en, addParticipants: () => Mi, addPenalty: () => rE, addPersonRequests: () => jN, addPersons: () => iE, createGroupParticipant: () => zN, createTeamsFromParticipantAttributes: () => rS, deleteParticipants: () => Yo, filterParticipants: () => Ku, findParticipant: () => HN, getCompetitionParticipants: () => YI, getPairedParticipant: () => bi, getParticipantEventDetails: () => KI, getParticipantMembership: () => QI, getParticipantScaleItem: () => ks, getParticipantSchedules: () => XI, getParticipantSignInStatus: () => JI, getParticipantTimeItem: () => Tg, getParticipants: () => ft, getScaleValues: () => Qs, mergeParticipants: () => tE, modifyIndividualParticipantIds: () => GN, modifyParticipant: () => Um, modifyParticipantName: () => YN, modifyParticipantOtherName: () => qN, modifyParticipantsSignInStatus: () => $N, modifyPenalty: () => ZN, modifyPersonRequests: () => BN, mutate: () => FN, participantScaleItem: () => dn, query: () => BM, regenerateParticipantNames: () => WN, removeIndividualParticipantIds: () => Wg, removeParticipantIdsFromAllTeams: () => wp, removePenalty: () => XN, removePersonRequests: () => VN, removeRatings: () => QN, scaledTeamAssignment: () => KN, setParticipantScaleItem: () => dl, setParticipantScaleItems: () => _b, validateLineUp: () => bp });
var FN = {};
Me(FN, { addDynamicRatings: () => kI, addIndividualParticipantIds: () => Im, addParticipant: () => en, addParticipants: () => Mi, addPenalty: () => rE, addPersonRequests: () => jN, addPersons: () => iE, createGroupParticipant: () => zN, createTeamsFromParticipantAttributes: () => rS, deleteParticipants: () => Yo, findParticipant: () => HN, mergeParticipants: () => tE, modifyIndividualParticipantIds: () => GN, modifyParticipant: () => Um, modifyParticipantName: () => YN, modifyParticipantOtherName: () => qN, modifyParticipantsSignInStatus: () => $N, modifyPenalty: () => ZN, modifyPersonRequests: () => BN, regenerateParticipantNames: () => WN, removeIndividualParticipantIds: () => Wg, removeParticipantIdsFromAllTeams: () => wp, removePenalty: () => XN, removePersonRequests: () => VN, removeRatings: () => QN, scaledTeamAssignment: () => KN, setParticipantScaleItem: () => dl, setParticipantScaleItems: () => _b });
function LN(e = 0) {
  (typeof e != "number" || isNaN(e)) && (e = 0);
  let t = /* @__PURE__ */ new Date();
  return t.setHours(t.getHours() + e), t.getTime().toString(36).slice(-6).toUpperCase();
}
function _N({ personRequests: e, personId: t, requests: r }) {
  e[t] || (e[t] = []);
  let i = r.filter(({ requestType: n }) => n).map((n) => {
    let { date: a, startTime: o, endTime: s } = n;
    return n.requestType === Pl && (a = ve(a), o = ct(o), s = ct(s), a && o && s) ? { date: a, startTime: o, endTime: s, requestType: n.requestType } : n;
  }).filter(Boolean);
  for (let n of i) n.requestId = LN(), e[t].push(n);
  return { mergeCount: i.length };
}
function cS(e) {
  let { tournamentRecords: t, personRequests: r } = e, i = oe(e, [{ [ur]: !0 }]);
  if (i.error) return i;
  if (!r) return { ...x };
  let n = Object.values(t);
  for (let a of n) {
    let o = a.participants ?? [], s = [];
    for (let c of Object.keys(r)) if (na({ tournamentParticipants: o, personId: c })) {
      let u = r[c];
      u.length && s.push({ personId: c, requests: u });
    }
    Object.keys(s).length && Be({ element: a, extension: { value: s, name: Js } });
  }
  return { ...x };
}
function BN(e) {
  let { tournamentRecords: t, requests: r, personId: i } = e, n = oe(e, [{ [ur]: !0 }, { requests: !0, [Mr]: sr, [Kr]: z }]);
  if (n.error) return n;
  let a = r.map(({ requestId: u }) => u).filter(Boolean), { personRequests: o } = io({ tournamentRecords: t }), s = (u) => {
    o && (o[u] = o[u].map((l) => {
      if (!a.includes(l.requestId)) return l;
      let d = r.find((p) => p.requestId === l.requestId);
      if (d.requestType) return Object.assign(l, d);
    }).filter(Boolean));
  };
  if (i && o?.[i]) s(i);
  else if (o) for (let u of Object.keys(o)) s(u);
  let c = r.filter((u) => !u.requestId);
  return c.length && _N({ personRequests: o, personId: i, requests: c }), cS({ tournamentRecords: t, personRequests: o });
}
function VN(e) {
  let { tournamentRecords: t, requestType: r, requestId: i, personId: n, date: a } = e, o = oe(e, [{ [ur]: !0 }]);
  if (o.error) return o;
  let { personRequests: s } = io({ tournamentRecords: t }), c = (l) => {
    s && (s[l] = s[l].filter((d) => (!r || d.requestType !== r) && (!i || d.requestId !== i) && (!a || d.date !== a)), s?.[l]?.length || delete s[l]);
  }, u = !r && !i && !n && !a;
  if (!u) {
    if (n && s?.[n]) c(n);
    else if (s) for (let l of Object.keys(s)) c(l);
  }
  return u || !s || !Object.keys(s).length ? fr({ name: Js, tournamentRecords: t, discover: !0 }) : cS({ tournamentRecords: t, personRequests: s });
}
function jN(e) {
  let { tournamentRecords: t, personId: r, requests: i } = e, n = oe(e, [{ [ur]: !0, [s1]: !0 }, { requests: !0, [Mr]: sr, [Kr]: z }]);
  if (n.error) return n;
  let { personRequests: a } = io({ tournamentRecords: t }), { mergeCount: o } = _N({ personRequests: a, personId: r, requests: i });
  return o && a ? cS({ tournamentRecords: t, personRequests: a }) : { error: z };
}
function GN({ individualParticipantIds: e, groupingParticipantId: t, tournamentRecord: r }) {
  let i = "modifyIndividualParticipantIds";
  if (!r) return F({ result: { error: J }, stack: i });
  if (!t || !e) return F({ result: { error: ue }, stack: i });
  let n = r.participants || [], a = n.find((m) => m.participantId === t);
  if (!a) return F({ result: { error: Tt }, stack: i });
  if (![We, Xr].includes(a.participantType)) return F({ result: { error: _i }, context: { participantType: a.participantType }, stack: i });
  let o = e.filter((m) => n.find((f) => f.participantId === m)?.participantType !== Ne);
  if (o.length) return F({ result: { error: _r, invalidParticipantIds: o }, stack: i });
  let s = a.individualParticipantIds || [], c = e.filter((m) => !s.includes(m)), u = s.filter((m) => !e.includes(m)), l = Im({ individualParticipantIds: c, groupingParticipantId: t, tournamentRecord: r });
  if (l.error) return F({ result: l, stack: i });
  let d = Wg({ individualParticipantIds: u, groupingParticipantId: t, tournamentRecord: r });
  if (d.error) return F({ result: d, stack: i });
  let { topics: p } = ci();
  if (p.includes(ar)) {
    let m = n.find(({ participantId: f }) => f === t);
    Se({ topic: ar, payload: { tournamentId: r.tournamentId, participants: [m] } });
  }
  return { ...l, ...d };
}
function $N({ tournamentRecord: e, participantIds: t, signInState: r }) {
  if (!e) return { error: J };
  if (!Array.isArray(t)) return { error: ue };
  if (![Qc, Sw].includes(r)) return { error: z, signInState: r };
  let i = e.participants || [];
  if (!i.length) return { error: gu };
  let n = i.map(Re), a = t.filter((u) => !n.includes(u));
  if (a.length) return { error: z, context: { invalidParticipantIds: a } };
  let o = [], s = (/* @__PURE__ */ new Date()).toISOString();
  for (let u of i) {
    let { participantId: l } = u;
    if (t.includes(l)) {
      let d = vI({ duplicateValues: !1, tournamentRecord: e, participantId: l, timeItem: { itemType: Au, itemValue: r, createdAt: s } });
      if (d.error) return d;
      o.push(u);
    }
  }
  let { topics: c } = ci();
  return o.length && c.includes(ar) && Se({ topic: ar, payload: { tournamentId: e.tournamentId, participants: o } }), { ...x };
}
function qN({ tournamentRecord: e, participantId: t, participantOtherName: r }) {
  if (!e) return { error: J };
  if (!t) return { error: Ft };
  let { participant: i } = ha({ tournamentRecord: e, participantId: t });
  if (!i) return { error: Tt };
  i.participantOtherName = r;
  let { topics: n } = ci();
  return n.includes(ar) && Se({ topic: ar, payload: { tournamentId: e.tournamentId, participants: [i] } }), { ...x };
}
function xy({ personFormat: e, person: t }) {
  let r = (h) => h.replace(/\W/g, ""), i = (h) => /^[a-z]*$/.test(r(h)), n = (h) => /^[A-Z]*$/.test(r(h)), a = (h) => /^[LAST]{4}/.test(r(h)), o = (h) => h.toLowerCase().indexOf("l") < h.toLowerCase().indexOf("f"), s = (h) => h.indexOf(",") >= 0, c = (h) => h.toLowerCase().indexOf("f.") >= 0, u = (h) => h.toLowerCase().indexOf("f") < 0, l = (h) => h.indexOf(" ") > 0;
  if (!t) return;
  let d = l(e) ? " " : "", p = Nf(t?.standardGivenName ?? ""), m = Nf(t?.standardFamilyName ?? "");
  if (!e) return `${p}${d}${m}`;
  c(e) && !s(e) && !o(e) && (p = `${p[0]}.`), i(e) ? (p = p.toLowerCase(), m = m.toLowerCase()) : n(e) ? (p = p.toUpperCase(), m = m.toUpperCase()) : a(e) && (m = m.toUpperCase());
  let f = `${p}${d}${m}`;
  return u(e) ? f = m : o(e) && (s(e) ? f = `${m},${d}${p}` : f = `${m}${d}${p}`), f;
}
function m2({ participantMap: e, participant: t, formats: r }) {
  let { participantType: i, individualParticipantIds: n, person: a } = t, o = i && r[i];
  if (i !== Pr && o) {
    let { personFormat: s, doublesJoiner: c } = o;
    i === Ne && (t.participantName = xy({ person: a, personFormat: s })), i === De && (t.participantName = n?.map((u) => {
      let l = e[u]?.person;
      return xy({ person: l, personFormat: s });
    }).filter(Boolean).join(c ?? "/"));
  }
}
function WN({ tournamentRecord: e, formats: t }) {
  if (!e) return { error: J };
  if (!xe(t)) return { error: ue };
  let r = e.participants ?? [], i = hv(r, "participantId");
  for (let n of r) m2({ participant: n, participantMap: i, formats: t });
  return { ...x };
}
function HN(e) {
  let { tournamentRecord: t, policyDefinitions: r, contextProfile: i, participantId: n, personId: a } = e, o = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (typeof n != "string" && typeof a != "string") return { error: ue, stack: "publicFindParticipant" };
  let s, c;
  for (let u of Object.values(o)) {
    c = u.tournamentId;
    let l = u.participants || [];
    if (s = na({ tournamentParticipants: l, internalUse: !0, policyDefinitions: r, contextProfile: i, participantId: n, personId: a }), s) break;
  }
  return { participant: s, tournamentId: c, ...x };
}
function zN({ individualParticipantIds: e = [], participantRoleResponsibilities: t, participantRole: r = oT, tournamentRecord: i, participantId: n, groupName: a }) {
  if (!i) return { error: J };
  if (!a) return { error: ue, info: "Missing groupName" };
  if (!Array.isArray(e)) return { info: "Invalid individualParticipantIds", error: z };
  let o = (ft({ participantFilters: { participantTypes: [Ne] }, tournamentRecord: i }).participants ?? []).map((l) => l.participantId);
  for (let l of e) if (!o.includes(l)) return { error: _i, participantId: l };
  let s = ae({ participantId: n || je(), participantRoleResponsibilities: t, participantName: a, individualParticipantIds: e, participantType: Xr, participantRole: r }), c = en({ participant: s, tournamentRecord: i });
  if (c.error) return c;
  let { topics: u } = ci();
  return u.includes(aa) && Se({ topic: aa, payload: { tournamentId: i.tournamentId, participants: [s] } }), { ...x, participant: ie(s) };
}
function YN({ tournamentRecord: e, participantName: t, participantId: r }) {
  if (!e) return { error: J };
  if (!r) return { error: Ft };
  if (!t) return { error: ue, info: "Missing participantName" };
  let { participant: i } = ha({ tournamentRecord: e, participantId: r });
  if (!i) return { error: Tt };
  i.participantName = t;
  let { topics: n } = ci();
  return n.includes(ar) && Se({ topic: ar, payload: { tournamentId: e.tournamentId, participants: [i] } }), { ...x };
}
function KN({ clearExistingAssignments: e = !0, individualParticipantIds: t, reverseAssignmentOrder: r, initialTeamIndex: i = 0, scaledParticipants: n = [], teamParticipantIds: a, tournamentRecord: o, scaleAttributes: s, teamNameBase: c, teamsCount: u, eventId: l, event: d }) {
  if (!o) return { error: J };
  if (!Array.isArray(a) && !Ie(u) && !l || !Ie(i) || n && !Array.isArray(n) || s && (typeof s != "object" || !Object.keys(s).length)) return { error: z };
  if (!s && !n.length || !n && !(t && s)) return { error: ue, info: "Missing scaling details" };
  if (l && !a) {
    if (d?.eventType !== jr) return { error: fn };
    a = d?.entries?.filter(({ entryStatus: I }) => I === kr).map(Re);
  }
  if (!a?.length && !u) return { info: "Missing teamParticipantIds or teamsCount", error: ue };
  let p = t ?? n.map(({ participantId: I }) => I);
  r && (a?.reverse(), i += 1), i > (a?.length || 0) - 1 && (i = 0);
  let m = a?.slice(i).concat(...a.slice(0, i)) ?? [], f = [];
  for (let I of o.participants ?? []) {
    let { participantId: U, participantType: S } = I;
    if (m.includes(U)) {
      if (S !== Pr) return { error: _i, participant: I };
      f.push(I);
    }
  }
  if (u && f.length < u) {
    let I = u - (f?.length || 0), U = c ?? "Team", S = te(0, I).map((y) => ({ participantName: `${U} ${y + 1}`, participantType: Pr, participantRole: rr })), { participants: P = [] } = Mi({ participants: S, returnParticipants: !0, tournamentRecord: o }), v = P.map(Re), D = o.participants?.filter(({ participantId: y }) => v.includes(y)) ?? [];
    f.push(...D);
  }
  if (!f.length) return { error: Th };
  if (e) for (let I of f) I.individualParticipantIds = [];
  else {
    let I = f.map((U) => U).flat();
    t?.length ? p = p.filter((U) => !I.includes(U)) : n = n?.filter(({ participantId: U }) => !I.includes(U));
  }
  if (!t?.length && !n?.length) return { error: Ld, info: "Nothing to be done" };
  if (!n.length) {
    for (let I of o.participants ?? []) {
      let { participantId: U, participantType: S } = I;
      if (!p.includes(U)) continue;
      if (S !== Ne) return { error: _i, participant: I };
      let P = dn({ scaleAttributes: s, participant: I })?.scaleItem, v = s?.accessor ? P?.scaleValue?.[s?.accessor] : P?.scaleValue, D = { participantId: U, scaleValue: v };
      n.push(D);
    }
    if (!n.length) return { error: Tt };
  }
  n.sort((I, U) => s?.sortOrder ? (U?.scaleValue || 0) - (I?.scaleValue || 0) : (I?.scaleValue || 1 / 0) - (U?.scaleValue || 1 / 0));
  for (let I of n) if (!I.participantId) return { error: z, scaledParticipant: I };
  let h = 0;
  for (; h < n.length; ) {
    for (let I of f) {
      if (h + 1 > n.length) break;
      let U = n[h];
      I.individualParticipantIds.push(U.participantId), h++;
    }
    f.reverse();
  }
  let g = f.map(Re);
  for (let I of o.events ?? []) {
    if (I.eventType !== jr) continue;
    let U = (I.entries ?? []).filter((S) => g.includes(S.participantId));
    for (let S of U) {
      let P = S.participantId, v = f.find((y) => y.participantId === P)?.individualParticipantIds;
      I.entries = (I.entries ?? []).filter((y) => !v.includes(y.participantId)), (I.drawDefinitions ?? []).forEach((y) => {
        y.entries = (y.entries ?? []).filter((w) => !v.includes(w.participantId));
      });
      let { flightProfile: D } = wt({ event: I });
      (D?.flights || []).forEach((y) => {
        y.drawEntries = (y.drawEntries || []).filter((w) => !v.includes(w.participantId));
      });
    }
  }
  return { ...x, scaledParticipants: n };
}
function QN(e) {
  let t = oe(e, [{ [Vt]: !0, [Qh]: !0 }, { ratingType: !1, [tr]: (o) => Gt[o] }]);
  if (t.error) return t;
  let r = `${e.ratingType}.${eg}`, i = e.asDynamic ? r : e.ratingType, n = [Ca, Zn, e.eventType, i].join("."), a = e.tournamentRecord.participants ?? [];
  for (let o of a) o.timeItems && (o.timeItems = o.timeItems.filter((s) => s.itemType !== n));
  return { ...x };
}
function XN(e) {
  let { tournamentRecords: t } = e;
  if (typeof t != "object" || !Object.keys(t).length) return { error: ht };
  for (let r of Object.values(t)) {
    let i = f2({ ...e, tournamentRecord: r });
    if (i.error && i.error !== Ss) return i;
  }
  return { ...x };
}
function f2({ tournamentRecord: e, penaltyId: t }) {
  if (!e) return { error: J };
  if (!t) return { error: yh };
  let r = e?.participants ?? [], i = [], n = !1, a;
  return r.forEach((o) => {
    let s = !1;
    o.penalties = (o.penalties ?? []).filter((c) => (c.penaltyId === t && (s = !0, n || (a = c, n = !0)), s && i.push(o), c.penaltyId !== t));
  }), a && Se({ topic: ar, payload: { tournamentId: e.tournamentId, participants: i } }), a ? { ...x, penalty: a } : { error: Ss };
}
var h2 = ({ penaltyId: e = je() } = {}) => ({ refereeParticipantId: void 0, penaltyCode: void 0, penaltyType: void 0, extensions: void 0, matchUpId: void 0, createdAt: void 0, issuedAt: void 0, notes: void 0, penaltyId: e }), JN = h2;
function ZN(e) {
  let { tournamentRecords: t } = e;
  if (typeof t != "object" || !Object.keys(t).length) return { error: ht };
  for (let r of Object.values(t)) {
    let i = g2({ ...e, tournamentRecord: r });
    if (i.error && i.error !== Ss || i.success) return i;
  }
  return { error: Ss };
}
function g2({ tournamentRecord: e, modifications: t, penaltyId: r }) {
  if (!e) return { error: J };
  if (!t) return { error: z, modifications: t };
  if (!r) return { error: yh };
  let i = e?.participants ?? [], n = Object.keys(JN()).filter((c) => c !== "penaltyId"), a = Object.keys(t).filter((c) => n.includes(c));
  if (!a.length) return { error: _d };
  let o, s = [];
  return i.forEach((c) => {
    let u = !1;
    c.penalties = (c.penalties ?? []).map((l) => (l.penaltyId === r && (u = !0, a.forEach((d) => Object.assign(l, { [d]: t[d] })), o || (o = l)), l)), u && s.push(c);
  }), o && Se({ topic: ar, payload: { tournamentId: e.tournamentId, participants: s } }), o ? { ...x, penalty: o } : { error: Ss };
}
function eE(e, t, r) {
  return !e && t ? t : e && !t || typeof e != "object" || typeof t != "object" ? e : Ue(Object.keys(e).concat(Object.keys(t))).reduce((i, n) => {
    if (!t[n]) i[n] = e[n];
    else if (!e[n]) i[n] = t[n];
    else if (typeof e[n] != typeof t[n]) i[n] = t[n];
    else if (Array.isArray(e[n])) if (r === !0 || Array.isArray(r) && r.includes(n)) {
      let a = Ue(e[n].map((o) => JSON.stringify(o)).concat(t[n].map((o) => JSON.stringify(o)))).map((o) => JSON.parse(o));
      i[n] = a;
    } else i[n] = t[n];
    else typeof e[n] == "object" ? i[n] = eE(e[n], t[n], r) : i[n] = t[n];
    return i;
  }, {});
}
function tE({ participants: e = [], tournamentRecord: t, arraysToMerge: r }) {
  if (!t) return { error: J };
  t.participants || (t.participants = []);
  let i = e.filter(qr(yn)).map((u) => ({ [u.participantId]: u })), n = Object.assign({}, ...i), a = [];
  t.participants = t.participants.map((u) => {
    if (n[u.participantId]) {
      let l = eE(u, n[u.participantId], r);
      return a.push(l), l;
    }
    return u;
  });
  let o = t.participants.map(qr(yn)) || [], s = e.filter(({ participantId: u }) => !o.includes(u)), { topics: c } = ci();
  return s.length && (t.participants = t.participants.concat(...s), c.includes(aa) && Se({ topic: aa, payload: { participants: s } })), a.length && c.includes(ar) && Se({ topic: ar, payload: { tournamentId: t.tournamentId, participants: a } }), { modifiedParticipantsCount: a.length, newParticipantsCount: s.length, ...x };
}
function rE(e) {
  let { tournamentRecord: t, participantIds: r } = e, i = e.tournamentRecords ?? (t && { [t.tournamentId]: t }) ?? {}, n;
  for (let a of Object.values(i)) {
    let o = (ft({ tournamentRecord: a }).participants ?? [])?.map(Re).filter((s) => r.includes(s));
    o.length && (n = I2({ ...e, penaltyId: e.penaltyId ?? n, tournamentRecord: a, participantIds: o }).penaltyId);
  }
  return n ? { ...x, penaltyId: n } : { error: Tt };
}
function I2({ refereeParticipantId: e, tournamentRecord: t, participantIds: r, penaltyCode: i, penaltyType: n, extensions: a, penaltyId: o, matchUpId: s, issuedAt: c, notes: u }) {
  if (!t) return { error: J };
  if (!r) return { error: Ft };
  if (!n) return { error: sP };
  let l = (t?.participants ?? []).filter((m) => r.includes(m.participantId));
  if (!l.length) return { error: Tt };
  let d = (/* @__PURE__ */ new Date()).toISOString(), p = Object.assign(JN({ penaltyId: o }), { refereeParticipantId: e, penaltyCode: i, penaltyType: n, matchUpId: s, createdAt: d, issuedAt: c, notes: u });
  return Array.isArray(a) && a.forEach((m) => Be({ element: p, extension: m })), l.forEach((m) => {
    m.penalties || (m.penalties = []), m.penalties.push(p);
  }), Se({ topic: ar, payload: { tournamentId: t.tournamentId, participants: l } }), { ...x, penaltyId: p.penaltyId };
}
function iE({ participantRole: e = rr, tournamentRecord: t, persons: r }) {
  if (!t) return { error: J };
  if (!Array.isArray(r)) return { error: z };
  if (!Object.keys(qg).includes(e)) return { error: Qv };
  let i = (t.participants || []).map(({ person: f }) => f?.personId).filter(Boolean), n = [], a = r.filter((f) => f && (!f.personId || !i.includes(f.personId))).map((f) => (f.personId || (f.personId = je()), n.push(f.personId), f)), o = (f, h) => Object.assign({}, ...Object.keys(f).filter((g) => !h.includes(g)).map((g) => ({ [g]: f[g] }))), s = a.map((f) => ae({ extensions: f.participantExtensions, timeItems: f.participantTimeItems, participantType: Ne, participantRole: e, person: o(f, ["participantExtensions", "participantTimeItems", "pairedPersons"]) })), c = 0, u = 0, l = Mi({ participants: s, tournamentRecord: t });
  if (l.error) return l;
  u = l.addedCount || 0;
  let d = [], p = ft({ participantFilters: { participantTypes: [Ne] }, tournamentRecord: t })?.participants ?? [];
  if (e === rr && r.filter(({ pairedPersons: f }) => f).forEach(({ personId: f, pairedPersons: h }) => {
    Array.isArray(h) && h.forEach((g) => {
      let I = [f, g.personId].map((U) => na({ tournamentParticipants: p, personId: U })).filter(Boolean);
      if (I.length === 2) {
        let U = I.map(Re);
        d.push(ae({ extensions: g.participantExtensions, timeItems: g.timeItems, participantRole: rr, individualParticipantIds: U, participantType: De }));
      }
    });
  }), d.length) {
    if (l = Mi({ participants: d, tournamentRecord: t }), l.error) return l;
    c = l.addedCount || 0;
  }
  let m = u + c;
  return { ...x, addedCount: m, newPersonIds: n };
}
var nE = {};
Me(nE, { bulkUpdatePublishedEventIds: () => aU, getAllEventData: () => oU, getCourtInfo: () => Sp, getDrawData: () => Jp, getEventData: () => Zp, getEventPublishStatus: () => mi, getPublishState: () => zo, getTournamentPublishStatus: () => Yu, getVenueData: () => Cs, mutate: () => aE, publishEvent: () => mc, publishEventSeeding: () => oE, publishOrderOfPlay: () => dE, publishParticipants: () => lE, query: () => WM, setEventDisplay: () => pm, unPublishEvent: () => pE, unPublishEventSeeding: () => sE, unPublishOrderOfPlay: () => uE, unPublishParticipants: () => cE });
var aE = {};
Me(aE, { publishEvent: () => mc, publishEventSeeding: () => oE, publishOrderOfPlay: () => dE, publishParticipants: () => lE, setEventDisplay: () => pm, unPublishEvent: () => pE, unPublishEventSeeding: () => sE, unPublishOrderOfPlay: () => uE, unPublishParticipants: () => cE });
function oE({ removePriorValues: e = !0, stageSeedingScaleNames: t, seedingScaleNames: r, tournamentRecord: i, status: n = Jr, drawIds: a = [], event: o }) {
  if (!i) return { error: J };
  if (!o) return { error: st };
  let s = mi({ event: o, status: n }), c = (s?.seeding?.seedingScaleNames || r) && { ...s?.seeding?.seedingScaleNames, ...r }, u = (s?.seeding?.stageSeedingScaleNames || t) && { ...s?.seeding?.stageSeedingScaleNames, ...t }, l = ae({ stageSeedingScaleNames: u, seedingScaleNames: c, published: !0, drawIds: a });
  return pc({ statusObject: { seeding: l }, removePriorValues: e, status: n, event: o }), Se({ topic: fw, payload: { tournamentId: i.tournamentId, eventId: o.eventId, drawIds: a } }), { ...x };
}
function sE({ removePriorValues: e = !0, seedingScaleNames: t, tournamentRecord: r, status: i = Jr, drawIds: n, stages: a, event: o }) {
  if (!r) return { error: J };
  if (!o) return { error: st };
  let s = mi({ event: o });
  if (s) {
    let c = s.seeding;
    if (Array.isArray(a) && c.stageSeedingScaleNames) for (let u of a) c.stageSeedingScaleNames[u] && delete c.stageSeedingScaleNames[u];
    Array.isArray(t) && c?.seedingScaleNames && (c.seedingScaleNames = c.seedingScaleNames.filter((u) => !t.includes(u))), Array.isArray(n) && c?.drawIds && (c.drawIds = c.drawIds.filter((u) => !n.includes(u))), (!Object.values(c.stageSeedingScaleNames ?? {}).length && !c.seedingScaleNames?.length && !c.drawIds?.length || !a && !t && !n?.length) && (delete c.stageSeedingScaleNames, delete c.seedingScaleNames, delete c.drawIds, c.published = !1), pc({ statusObject: { seeding: c }, removePriorValues: e, status: i, event: o });
  }
  return Se({ topic: vg, payload: { tournamentId: r.tournamentId, eventId: o.eventId } }), { ...x };
}
function cE(e) {
  let t = ui(e);
  if (!Object.keys(t).length) return { error: ht };
  for (let r of Object.values(t)) {
    let i = U2({ tournamentRecord: r, ...e });
    if (i.error) return i;
  }
  return { ...x };
}
function U2({ removePriorValues: e = !0, tournamentRecord: t, status: r = Jr }) {
  if (!t) return { error: J };
  let i = `${ga}.${Ia}`, { timeItem: n } = li({ element: t, itemType: i }), a = n?.itemValue || { [r]: {} };
  return a[r] && delete a[r].participants, an({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), Se({ payload: { tournamentId: t.tournamentId }, topic: F1 }), { ...x };
}
function uE(e) {
  let t = ui(e);
  if (!Object.keys(t).length) return { error: ht };
  for (let r of Object.values(t)) {
    let i = S2({ tournamentRecord: r, ...e });
    if (i.error) return i;
  }
  return { ...x };
}
function S2({ removePriorValues: e = !0, tournamentRecord: t, status: r = Jr }) {
  if (!t) return { error: J };
  let i = `${ga}.${Ia}`, { timeItem: n } = li({ element: t, itemType: i }), a = n?.itemValue || { [r]: {} };
  return a[r] && delete a[r].orderOfPlay, an({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), Se({ topic: Pg, payload: { tournamentId: t.tournamentId } }), { ...x };
}
function lE(e) {
  let t = ui(e);
  if (!Object.keys(t).length) return { error: ht };
  for (let r of Object.values(t)) {
    let i = y2({ tournamentRecord: r, ...e });
    if (i.error) return i;
  }
  return { ...x };
}
function y2({ removePriorValues: e, tournamentRecord: t, status: r = Jr }) {
  if (!t) return { error: J };
  let i = `${ga}.${Ia}`, { timeItem: n } = li({ element: t, itemType: i }), a = n?.itemValue || { [r]: {} };
  return a[r].participants = { published: !0 }, an({ timeItem: { itemValue: a, itemType: i }, element: t, removePriorValues: e }), Se({ payload: { tournamentId: t.tournamentId }, topic: gw }), { ...x };
}
function dE(e) {
  let t = ui(e);
  if (!Object.keys(t).length) return { error: ht };
  for (let r of Object.values(t)) {
    let i = v2({ tournamentRecord: r, ...e });
    if (i.error) return i;
  }
  return { ...x };
}
function v2({ scheduledDates: e = [], removePriorValues: t, tournamentRecord: r, status: i = Jr, eventIds: n = [] }) {
  if (!r) return { error: J };
  let a = `${ga}.${Ia}`, { timeItem: o } = li({ element: r, itemType: a }), s = o?.itemValue || { [i]: {} };
  return s[i].orderOfPlay = { published: !0, scheduledDates: e, eventIds: n }, an({ timeItem: { itemValue: s, itemType: a }, element: r, removePriorValues: t }), Se({ topic: hw, payload: { tournamentId: r.tournamentId, scheduledDates: e, eventIds: n } }), { ...x };
}
function pE({ removePriorValues: e = !0, tournamentRecord: t, status: r = Jr, event: i }) {
  if (!t) return { error: J };
  if (!i) return { error: st };
  let n = `${ga}.${Ia}`, { timeItem: a } = Cu({ itemType: n, event: i }), o = a?.itemValue || { [r]: {} };
  return delete o[r].structureIds, delete o[r].drawDetails, delete o[r].drawIds, Jo({ event: i, timeItem: { itemValue: o, itemType: n }, removePriorValues: e }), pc({ statusObject: { structureIds: void 0, drawIds: void 0, seeding: void 0 }, removePriorValues: e, status: r, event: i }), Se({ topic: yg, payload: { tournamentId: t.tournamentId, eventId: i.eventId } }), { eventId: i.eventId, ...x };
}
var mE = {};
Me(mE, { getEntryStatusReports: () => D2, getParticipantStats: () => P2, getStructureReports: () => T2, getVenuesReport: () => M2 });
function P2({ withCompetitiveProfiles: e, opponentParticipantId: t, withIndividualStats: r, teamParticipantId: i, tournamentRecord: n, withScaleValues: a, tallyPolicy: o, matchUps: s }) {
  if (!n) return { error: J };
  if (s && !Array.isArray(s)) return { error: Cr };
  if (s = s ?? Jt({ tournamentRecord: n, participantsProfile: a ? { withScaleValues: a } : void 0 }).matchUps, !s?.length) return { error: Gn };
  let c = [];
  t && c.push(t), i && c.push(i);
  let u = c.length ? { participantIds: c } : { participantTypes: [Pr] }, l = ft({ participantFilters: u, tournamentRecord: n }).participants ?? [];
  if (!l.every(({ participantType: y }) => y === Pr)) return { error: _r };
  c.length || c.push(...l.map(Re));
  let d = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), m = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), h = (y, w = "") => p.get(y) || p.set(y, { participantName: w, participantId: y, competitorIds: [], competitiveness: {}, matchUpStatuses: {}, tiebreaks: [0, 0], matchUps: [0, 0], points: [0, 0], games: [0, 0], sets: [0, 0] }) && p.get(y);
  for (let y of l) {
    let { participantId: w, individualParticipantIds: b } = y;
    f.set(w, b ?? []), h(w, y.participantName);
  }
  if (i && !f.get(i)) return F({ result: { error: Tt }, context: { teamParticipantId: i } });
  if (t && !f.get(t)) return F({ result: { error: Tt }, context: { opponentParticipantId: t } });
  let g = [], I = (y) => {
    let w = [[], []];
    for (let T of y) {
      let R = T.participant;
      if (R?.participantName) {
        d.set(R.participantId, { participantName: R.participantName, ratings: R.ratings });
        let M = p.get(R.participantId);
        M && (M.participantName = R.participantName);
      }
    }
    let b = ({ side: T, individualParticipantIds: R }) => T.participantId && (!R?.length || R.includes(T.participantId)) && [T.participantId] || T.participant?.individualParticipantIds?.length && (!R?.length || Pt(R, T.participant?.individualParticipantIds).length === T.participant?.individualParticipantIds?.length) && T.participant.individualParticipantIds;
    if (f.size) {
      let T = (R, M) => {
        for (let E of y) {
          if (!E.participant) continue;
          let A = b({ individualParticipantIds: M, side: E });
          if (A?.length) {
            let N = E.sideNumber;
            if (!N) continue;
            let C = [R];
            r && C.push(...A), w[N - 1] = C;
            let k = p.get(R);
            for (let O of A.filter(Boolean)) k && !k.competitorIds.includes(O) && k.competitorIds.push(O);
          }
        }
      };
      if (i) (!t || y.every((R) => R.participant && (b({ individualParticipantIds: f.get(i), side: R }) || b({ individualParticipantIds: f.get(t), side: R })))) && T(i, f.get(i));
      else for (let [R, M] of f) T(R, M);
    } else if (r) for (let T of y) {
      if (!T.participant) continue;
      let R = b({ individualParticipantIds: [], side: T }), M = T.sideNumber;
      M && (w[M - 1] = R);
    }
    return w;
  };
  for (let y of s) {
    if (!xe(y)) return { error: Cr };
    let { matchUpStatus: w, matchUpFormat: b, matchUpType: T, winningSide: R, score: M, sides: E } = y;
    if (!E || !M || T === Hr || w === "BYE") continue;
    let A = I(E);
    if (!A.filter(Boolean).length) continue;
    let N = e && R && ju({ matchUp: y })?.competitiveness;
    g.push(y);
    let C = fI({ matchUpStatus: w, matchUpFormat: b, tallyPolicy: o, winningSide: R, score: M }), k = eb({ matchUpStatus: w, matchUpFormat: b, tallyPolicy: o, winningSide: R, score: M }), { pointsTally: O, tiebreaksTally: _ } = tb({ matchUpFormat: b, score: M });
    A.forEach((B, L) => {
      for (let j of B) {
        let H = d.get(j)?.participantName, G = h(j, H);
        if (G) {
          let V = (K, Q) => Q.forEach((X, ee) => G[K][ee] += X), $ = L ? [..._].reverse() : _, q = L ? [...O].reverse() : O, Y = L ? [...k].reverse() : k, W = L ? [...C].reverse() : C;
          if (V("tiebreaks", $), V("points", q), V("games", Y), V("sets", W), R) {
            let K = R - 1 === L ? 0 : 1;
            G.matchUps[K] += 1;
          }
          if (N) {
            let K = N.toLowerCase();
            G.competitiveness[K] || (G.competitiveness[K] = [0, 0]), G.competitiveness[K][L] += 1;
          }
          if (w) {
            let K = w.toLowerCase();
            G.matchUpStatuses[K] || (G.matchUpStatuses[K] = 0), G.matchUpStatuses[K] += 1;
          }
        }
      }
    });
  }
  let U = ["tiebreaks", "matchUps", "points", "games", "sets"], S = ["competitive", "routine", "decisive"], P = /* @__PURE__ */ new Map(), v = (y, w) => (y ?? 0) + (w ?? 0);
  for (let [y, w] of p.entries()) {
    for (let b of U) {
      let T = w[b].reduce(v);
      if (T) {
        let R = w[b][0] / T, M = `${b}Ratio`, E = parseFloat(R.toFixed(2));
        w[M] = E, m.set(y, !0), P.has(M) || P.set(M, []), P.get(M)?.push(E);
      }
    }
    for (let b of S) {
      let T = w.competitiveness?.[b]?.reduce(v);
      if (T) {
        let R = w.competitiveness[b][0] / T, M = `${b}Ratio`, E = parseFloat(R.toFixed(2));
        w[M] = E;
      }
    }
  }
  if (!i) {
    let y = (w, b) => b - w;
    for (let w of p.values()) for (let b of U) {
      let T = `${b}Ratio`;
      if (typeof w[T] == "number") {
        let R = P.get(T)?.sort(y).indexOf(w[T]);
        if (typeof R == "number" && R >= 0) {
          let M = `${b}Rank`;
          w[M] = R + 1;
        }
      }
    }
  }
  let D = { relevantMatchUps: g, ...x };
  return i ? (D.teamStats = p.get(i), t && (D.opponentStats = p.get(t))) : D.participatingTeamsCount = m.size, D.allParticipantStats = [...p.values()], D;
}
function wd({ participant: e, eventType: t }) {
  let r = e?.person?.personId, i = e?.person?.personOtherIds?.[0], n = e?.person?.tennisId, a = e?.ratings?.[t]?.find(({ scaleName: u }) => u === "WTN"), o = a?.scaleValue, { wtnRating: s, confidence: c } = o || {};
  return { timeStamp: a?.scaleDate, personOtherId: i, confidence: c, wtnRating: s, personId: r, tennisId: n };
}
function D2({ tournamentRecord: e }) {
  if (!e) return { error: J };
  let t = e.tournamentId, { participantMap: r } = ft({ withScaleValues: !0, withEvents: !0, withSeeding: !0, tournamentRecord: e, withDraws: !0 }), i = (Jt({ matchUpFilters: { matchUpTypes: [so, Ma] }, tournamentRecord: e }).matchUps ?? []).flatMap(({ sides: m, matchUpType: f }) => m?.flatMap((h) => f === Ma ? h?.participant?.individualParticipantIds : h?.participant?.participantId || h.participantId).filter(Boolean)).filter(Boolean), n = [], a = {}, o = {}, s = {}, c = 0, u = ({ id: m, entry: f, eventId: h, eventType: g }) => {
    let { qualifyingSeeding: I, mainSeeding: U, entryStatus: S, entryStage: P, drawId: v } = f;
    a[m] || (a[m] = []);
    let { participant: D, events: y } = r?.[m] ?? {}, w = wd({ participant: D, eventType: g }), b = y?.[h]?.ranking;
    S === uI && n.push(m), a[m].push({ participantType: D?.participantType, participantId: m, tournamentId: t, eventType: g, eventId: h, drawId: v, entryStatus: S, entryStage: P, ...w, ranking: b, mainSeeding: U, qualifyingSeeding: I });
  };
  for (let m of e.events ?? []) {
    let f = {}, h = (y) => {
      f[y] || (f[y] = { count: 0 }), f[y].count += 1;
    }, { drawDefinitions: g = [], eventType: I, eventId: U } = m, S = g.flatMap((y) => {
      let { drawId: w, entries: b } = y;
      c += 1;
      let T = ({ stage: A, stageSequence: N }) => A === re && N === 1 || A === se, R = (y.structures ?? []).filter(T).flatMap(({ positionAssignments: A }) => A).filter(Boolean).map(({ participantId: A }) => A), M = ({ participantId: A }) => R.includes(A), E = (A) => {
        let { participantId: N, entryStatus: C, entryStage: k } = A;
        h(C);
        let O = r?.[N]?.draws?.[w]?.seedAssignments?.[re];
        return { qualifyingSeeding: r?.[N]?.draws?.[w]?.seedAssignments?.[se], participantId: N, mainSeeding: O, entryStatus: C, entryStage: k, drawId: w };
      };
      return b?.filter(M).map(E);
    }), P = (y) => {
      let w = y.participantId, b = r?.[w].participant.individualParticipantIds?.filter((T) => i.includes(T));
      return w && { [w]: { individualParticipantIds: b } };
    };
    I === xn ? (() => {
      let y = Object.assign({}, ...S.map(P).filter(Boolean)), w = (b) => {
        y[b.participantId].individualParticipantIds.forEach((T) => {
          u({ id: T, eventType: I, eventId: U, entry: b });
        });
      };
      S.forEach(w);
    })() : S.forEach((y) => {
      u({ id: y?.participantId, eventType: I, eventId: U, entry: y });
    });
    let v = Object.values(f).reduce((y, w) => y + w.count, 0);
    Object.keys(f).forEach((y) => {
      f[y].pct = f[y].count / v * 100;
    }), s[U] = { tournamentId: t, eventId: U, entries: S, entryStatuses: f };
    let D = Object.assign({}, ...Ni.flatMap((y) => [{ [y + "_count"]: f[y]?.count }, { [y + "_pct"]: f[y]?.pct }]));
    o[U] = { tournamentId: t, eventId: U, ...D };
  }
  let l = Object.values(r ?? {}).filter(({ participant: { participantType: m, participantRole: f } }) => m === Ne && f === rr), d = l.filter(({ participant: m }) => !i.includes(m.participantId)).map(({ participant: m }) => m.participantId), p = { nonParticipatingEntriesCount: d.length, individualParticipantsCount: l.length, eventsCount: Object.values(s).length, nonParticipatingParticipantIds: d, drawDefinitionsCount: c, tournamentId: t };
  return { entryStatusReports: Object.values(o).flat(), participantEntryReports: Object.values(a).flat(), eventReports: Object.values(s).flat(), withDrawnParticipantIds: n, tournamentEntryReport: p };
}
function w2({ eventType: e, matchUps: t, eventId: r, drawId: i }) {
  let n = {}, a = (f) => {
    let h = f?.matchUpFormat;
    h && (n[h] || (n[h] = 0), n[h] += 1);
  }, o = t.filter((f) => r ? f.eventId === r : f.drawId === i).reduce((f, h) => (a(h), (h.sides ?? []).flatMap((g) => (g?.participant?.individualParticipants || [g?.participant]).filter(Boolean)).forEach((g) => f[g.participantId] = g), f), {}), s = Object.values(o), c = s.map((f) => wd({ participant: f, eventType: e })).filter(({ wtnRating: f }) => f), u = (s.length - c.length) / s.length * 100, l = c.reduce((f, h) => {
    let { wtnRating: g, confidence: I } = h;
    return f.totalWTN += g, f.totalConfidence += I, f;
  }, { totalWTN: 0, totalConfidence: 0 }), d = c?.length ? l.totalWTN / c.length : 0, p = c?.length ? l.totalConfidence / c.length : 0, m = Object.values(n).reduce((f, h) => f + (h || 0), 0);
  return { matchUpFormatCounts: n, matchUpsCount: m, avgConfidence: p, pctNoRating: u, avgWTN: d };
}
function T2(e) {
  let { tournamentRecord: t, extensionProfiles: r, firstFlightOnly: i, firstStageSequenceOnly: n = !0 } = e;
  if (!t) return { error: Is };
  let a = [], o = {}, s = {}, c = [], u = Object.assign({}, ...(r ?? []).map(({ name: h, label: g, accessor: I }) => {
    let U = we({ element: t, name: h })?.extension?.value, S = I ? uo({ element: U, accessor: I })?.value : U;
    return { [g ?? h]: S };
  })), l = t?.tournamentId, d = Jt({ participantsProfile: { withScaleValues: !0 }, tournamentRecord: t }).matchUps ?? [], p = (h) => li({ itemType: lg, itemSubTypes: [un], element: { timeItems: h } })?.timeItem?.itemValue?.scaleBasis, m = ({ positionManipulations: h }) => {
    h?.forEach((g) => {
      let { structureId: I, name: U } = g, S = g.drawPositions ?? [g.drawPosition];
      o[I] ??= [], o[I].push(`${U}: ${S.join("/")}`);
    });
  }, f = t?.events?.flatMap(({ timeItems: h, drawDefinitions: g = [], extensions: I, eventType: U, eventName: S, eventId: P, category: v }) => {
    let D = I?.find((A) => A.name === wi)?.value?.flights?.map((A) => ({ [A.drawId]: A.flightNumber })), y = D && Object.assign({}, ...D), w = I?.find((A) => A.name === Ta), b = h?.find((A) => A.itemType === Ta), T = w?.value?.length ?? b?.itemValue ?? 0, R = Object.values(y ?? {}), M = y && Math.min(...R), E = p(h);
    return s[P] = { seedingBasis: E ? JSON.stringify(E) : void 0, totalPositionManipulations: 0, maxPositionManipulations: 0, generatedDrawsCount: 0, drawDeletionsCount: T, tournamentId: l, eventId: P }, g.filter((A) => !i || !D || y[A.drawId] === M).flatMap((A) => {
      let { matchUpFormat: N, tieFormat: C, timeItems: k, extensions: O, structures: _, drawName: B, drawType: L, drawId: j } = A, { matchUpFormatCounts: H, matchUpsCount: G, avgConfidence: V, pctNoRating: $, avgWTN: q } = w2({ eventType: U, matchUps: d, drawId: j }), Y = p(k) ?? E, W = b2({ extensions: O }), K = W?.length ?? 0;
      return m({ positionManipulations: W }), s[P].totalPositionManipulations += K, s[P].generatedDrawsCount += 1, K > s[P].maxPositionManipulations && (s[P].maxPositionManipulations = K), _?.filter((Q) => (Q.stageSequence === 1 || !n) && [se, re, nr, yt].includes(Q.stage)).map((Q) => {
        let X = [re, yt].includes(Q.stage) ? d.find((St) => St.structureId === Q.structureId && St.finishingRound === 1 && St.winningSide) : void 0;
        Q.stage === re && a.push({ eventName: S, drawName: B, structureId: Q.structureId });
        let ee = X?.sides?.find((St) => St.sideNumber === X.winningSide)?.participant, Z = ee?.participantType === Pr && ee.participantId, ce = ee?.participantType === De ? ee.individualParticipants : [], fe = wd({ participant: ce?.[0] ?? ee, eventType: U }), { personId: He, personOtherId: Te, tennisId: $e, confidence: it, wtnRating: It } = fe || {}, Rt = wd({ participant: ce?.[1], eventType: U }), { personId: de, personOtherId: lt, tennisId: le, confidence: ze, wtnRating: Ae } = Rt || {}, { ageCategoryCode: nt, categoryName: Ee, subType: rt } = v ?? {}, ge = Q.matchUpFormat ?? N, Ze = (H[ge] ?? 0) / G * 100, { tieFormatName: At, tieFormatDesc: ye } = Id(C), { tieFormatName: Qe, tieFormatDesc: Ce } = Id(Q.tieFormat), Fe = ye === Ce, ke = !Fe && Qe, Wt = Q.tieFormat && !Fe && Ce, Ut = W?.filter((St) => St.structureId === Q.structureId)?.length ?? 0;
        return { ...u, tournamentId: l, eventId: P, structureId: Q.structureId, drawId: j, eventType: U, category: rt, categoryName: Ee, ageCategoryCode: nt, flightNumber: y?.[j], drawType: L, stage: Q.stage, seedingBasis: Y ? JSON.stringify(Y) : void 0, winningPersonId: He, winningPersonOtherId: Te, winningPersonTennisId: $e, winningPersonWTNrating: It, winningPersonWTNconfidence: it, winningPerson2Id: de, winningPerson2OtherId: lt, winningPerson2TennisId: le, winningPerson2WTNrating: Ae, winningPerson2WTNconfidence: ze, winningTeamId: Z, positionManipulations: Ut, pctNoRating: $, matchUpFormat: ge, pctInitialMatchUpFormat: Ze, matchUpsCount: G, drawTieFormatName: At, drawTieFormatDesc: ye, tieFormatName: ke, tieFormatDesc: Wt, avgConfidence: V, avgWTN: q };
      });
    });
  });
  return a.forEach(({ eventName: h, drawName: g, structureId: I }) => {
    o[I]?.length && c.push({ eventName: h, drawName: g, actions: o[I] });
  }), { eventStructureReports: Object.values(s), structureReports: f, flightReports: c };
}
function b2({ extensions: e }) {
  return e?.find(({ name: t }) => t === ms)?.value?.slice(1);
}
function M2({ ignoreDisabled: e = !0, tournamentRecords: t, tournamentId: r, venueIds: i = [], dates: n = [] }) {
  if (!Array.isArray(n)) return { error: z, dates: n };
  if (!Array.isArray(i)) return { error: z, venueIds: i };
  if (!(t && Object.keys(t).filter((l) => !r || l === r) || []).length) return { error: ht };
  if (!n.every(Ar)) return { error: Ht };
  let a = Yn({ tournamentRecords: t, ignoreDisabled: e, dates: n });
  if (a.error) return a;
  let o = a?.venues?.filter(({ venueId: l }) => !i?.length || i.includes(l)), s = a.courts?.reduce((l, d) => (d.dateAvailability?.forEach((p) => {
    let m = p.date;
    l.includes(m) || l.push(m);
  }), l), []).filter((l) => !n.length || n.includes(l)), c = { venueIds: o?.map(({ venueId: l }) => l) }, { matchUps: u } = Bi({ afterRecoveryTimes: !0, tournamentRecords: t, matchUpFilters: c });
  return { venuesReport: o?.map((l) => R2(s, l, u)) };
}
function R2(e, t, r) {
  let { venueId: i, courts: n, venueName: a } = t, o = {};
  return e.forEach((s) => {
    let c = 0, u = 0, l = 0;
    for (let m of n) {
      let f = m.dateAvailability.find((g) => g.date === s), h = (f && fc({ courtDate: f }).timeSlots)?.reduce((g, I) => {
        let { startTime: U, endTime: S } = I, P = Le(S) - Le(U);
        return g + P;
      }, 0);
      h && (l += 1), c += h;
    }
    let d = r.filter(({ schedule: m }) => m.venueId === i && hn(s, m.scheduledDate));
    d.forEach(({ schedule: m }) => {
      let f = ct(m.scheduledTime), h = Er(f, m.averageMinutes), g = Le(h) - Le(f);
      u += g;
    });
    let p = c ? (u / c * 100).toFixed(2) : "100";
    o[s] = { scheduledMatchUpsCount: d.length, availableCourts: l, availableMinutes: c, scheduledMinutes: u, percentUtilization: p };
  }), { venueId: i, venueName: a, venueReport: o };
}
var fE = {};
Me(fE, { addMatchUpCourtOrder: () => GU, addMatchUpEndTime: () => qU, addMatchUpOfficial: () => ZR, addMatchUpResumeTime: () => HU, addMatchUpScheduleItems: () => vm, addMatchUpScheduledDate: () => Sm, addMatchUpScheduledTime: () => Sa, addMatchUpStartTime: () => $U, addMatchUpStopTime: () => WU, addSchedulingProfileRound: () => aS, allocateTeamMatchUpCourts: () => ym, assignMatchUpCourt: () => rs, assignMatchUpVenue: () => gc, bulkRescheduleMatchUps: () => PE, bulkScheduleMatchUps: () => Dl, bulkScheduleTournamentMatchUps: () => cu, bulkUpdateCourtAssignments: () => UE, calculateScheduleTimes: () => uS, clearMatchUpSchedule: () => wE, clearScheduledMatchUps: () => Dm, courtGridRows: () => nm, findMatchUpFormatTiming: () => tm, findVenue: () => Mn, generateBookings: () => Pm, generateVirtualCourts: () => fm, getMatchUpsToSchedule: () => em, getPersonRequests: () => io, getProfileRounds: () => im, getScheduledRoundsDetails: () => ml, getSchedulingProfile: () => Kn, getSchedulingProfileIssues: () => sU, matchUpScheduleChange: () => DE, modifyMatchUpFormatTiming: () => bU, mutate: () => hE, proAutoSchedule: () => IE, proConflicts: () => yE, publicFindCourt: () => Fg, query: () => QM, removeEventMatchUpFormatTiming: () => dm, removeMatchUpCourtAssignment: () => gE, reorderUpcomingMatchUps: () => vE, scheduleMatchUps: () => SE, scheduleProfileRounds: () => wm, setMatchUpDailyLimits: () => TE, setMatchUpHomeParticipantId: () => jU, setSchedulingProfile: () => uc, toggleParticipantCheckInState: () => gm, validateSchedulingProfile: () => rm });
var hE = {};
Me(hE, { addMatchUpCourtOrder: () => GU, addMatchUpEndTime: () => qU, addMatchUpOfficial: () => ZR, addMatchUpResumeTime: () => HU, addMatchUpScheduleItems: () => vm, addMatchUpScheduledDate: () => Sm, addMatchUpScheduledTime: () => Sa, addMatchUpStartTime: () => $U, addMatchUpStopTime: () => WU, addSchedulingProfileRound: () => aS, allocateTeamMatchUpCourts: () => ym, assignMatchUpCourt: () => rs, assignMatchUpVenue: () => gc, bulkRescheduleMatchUps: () => PE, bulkScheduleMatchUps: () => Dl, bulkScheduleTournamentMatchUps: () => cu, bulkUpdateCourtAssignments: () => UE, calculateScheduleTimes: () => uS, clearMatchUpSchedule: () => wE, clearScheduledMatchUps: () => Dm, findMatchUpFormatTiming: () => tm, generateBookings: () => Pm, generateVirtualCourts: () => fm, matchUpScheduleChange: () => DE, modifyMatchUpFormatTiming: () => bU, proAutoSchedule: () => IE, proConflicts: () => yE, removeEventMatchUpFormatTiming: () => dm, removeMatchUpCourtAssignment: () => gE, reorderUpcomingMatchUps: () => vE, scheduleMatchUps: () => SE, scheduleProfileRounds: () => wm, setMatchUpDailyLimits: () => TE, setMatchUpHomeParticipantId: () => jU, setSchedulingProfile: () => uc, toggleParticipantCheckInState: () => gm, validateSchedulingProfile: () => rm });
function uS({ calculateStartTimeFromCourts: e = !0, defaultRecoveryMinutes: t = 0, averageMatchUpMinutes: r = 90, remainingScheduleTimes: i, clearScheduleDates: n, tournamentRecords: a, periodLength: o, scheduleDate: s, startTime: c, venueIds: u, endTime: l }) {
  if (typeof a != "object" || !Object.keys(a).length) return { error: ht };
  o = o ?? hm({ recoveryMinutes: t, averageMatchUpMinutes: r });
  let { courts: d, venues: p } = Yn({ dates: [s], ignoreDisabled: !0, tournamentRecords: a }), m = d?.filter((T) => !u || u.includes(T.venueId));
  c || (c = m?.reduce((T, R) => {
    let M = R.dateAvailability?.find((E) => !E.date || hn(s, E.date))?.startTime ?? R.startTime;
    return M && (!T || Le(M) < Le(T)) ? M : T;
  }, void 0)), l || (l = m?.reduce((T, R) => {
    let M = R.dateAvailability?.find((E) => !E.date || hn(s, E.date))?.endTime ?? R.endTime;
    return M && (!T || Le(M) > Le(T)) ? M : T;
  }, void 0));
  let f = Object.values(a), h = Object.assign({}, ...f.map((T) => (T.events ?? []).map((R) => {
    let { scheduleTiming: M } = Ou({ tournamentRecord: T, event: R });
    return { [R.eventId]: { event: R, scheduleTiming: M } };
  })).flat()), g = gl({ sortDateMatchUps: !1, tournamentRecords: a, matchUpFilters: { scheduledDate: s, venueIds: u } }), I = g?.dateMatchUps ?? [], U = g?.completedMatchUps ?? [], S = [];
  S.push(...I), S.push(...U);
  let P = { averageTimes: [{ minutes: { default: r } }], recoveryTimes: [{ minutes: { default: t } }] }, v = S?.map(({ eventId: T, schedule: R, matchUpFormat: M }) => {
    let { event: E, scheduleTiming: A } = h[T], N = E?.eventType, C = { ...A, defaultTiming: P, matchUpFormat: M }, { averageMinutes: k, recoveryMinutes: O } = Up({ eventType: N, timingDetails: C }), { courtId: _, venueId: B } = R, L = ct(R.scheduledTime), j = Er(L, k);
    return { recoveryMinutes: O, averageMinutes: k, periodLength: o, startTime: L, endTime: j, courtId: _, venueId: B };
  }), D = { calculateStartTimeFromCourts: e, remainingScheduleTimes: i, averageMatchUpMinutes: r, date: s, clearScheduleDates: n, periodLength: o, startTime: c, endTime: l, bookings: v, courts: m }, { scheduleTimes: y } = xU(D), w = u?.length === 1 && u[0] || p?.length === 1 && p[0].venueId || void 0, b = S.map($t);
  return { venueId: w, scheduleTimes: y, dateScheduledMatchUpIds: b };
}
function gE(e) {
  let t = oe(e, [{ [ur]: !0 }]);
  if (t.error) return t;
  let { removePriorValues: r, tournamentRecords: i, tournamentId: n, courtDayDate: a, matchUpId: o, courtId: s, drawId: c } = e, u = i[n];
  if (!u) return { error: J };
  let { drawDefinition: l, event: d } = Ua({ tournamentRecord: u, drawId: c });
  if (!l) return { error: ne };
  let p = ut({ drawDefinition: l, event: d, matchUpId: o });
  if (p.error) return p;
  if (p?.matchUp?.matchUpType === Hr) {
    let { itemValue: m } = Za({ timeItems: p.matchUp.timeItems ?? [], itemType: Dn }), f = s && m.filter((h) => h.courtId !== s);
    return Wr({ duplicateValues: !1, removePriorValues: r, tournamentRecord: u, drawDefinition: l, matchUpId: o, timeItem: { itemType: Dn, itemValue: f } });
  } else return rs({ tournamentRecord: u, drawDefinition: l, courtDayDate: a, courtId: "", matchUpId: o });
}
function IE({ scheduleCompletedMatchUps: e, tournamentRecords: t, scheduledDate: r, matchUps: i }) {
  if (!pi(i)) return { error: z };
  if (i.some(({ hasContext: m }) => !m)) return { info: "matchUps must have { inContext: true, nextMatchUps: true }", error: Fd };
  let n = gl({ courtCompletedMatchUps: !0, withCourtGridRows: !0, minCourtGridRows: 10, tournamentRecords: t, matchUpFilters: { localPerspective: !0, scheduledDate: r } });
  if (n.error) return n;
  let { rows: a } = n, o = [], s = (m) => [(m.sides || []).map((f) => [f.participantId, f.participant?.individualParticipantIds]), (m.potentialParticipants || []).flat().map((f) => [f.participantId, f.individualParticipantIds])].flat(1 / 0).filter(Boolean), c = a?.reduce((m, f) => {
    let h = [], g = [];
    Object.values(f).forEach((U) => {
      if (xe(U) && (U.matchUpId && (h.push(U.matchUpId), o.push(U)), U.sides)) {
        let S = s(U);
        g.push(...S);
      }
    });
    let I = Object.values(f).filter((U) => xe(U) && !U.matchUpId);
    return m.concat({ matchUpIds: h, availableCourts: I, rowId: f.rowId, participantIds: g });
  }, []);
  i.filter(({ matchUpStatus: m }) => m && m !== "BYE" && (e || !Lt.includes(m))).sort(Ho);
  let u = Ei({ matchUps: i.concat(o), includeParticipantDependencies: !0, tournamentRecords: t }).matchUpDependencies, l = [], d = [];
  for (; i.length && c.length; ) {
    let m = c.shift(), f = [];
    for (; i.length && m.availableCourts.length; ) {
      let h = i.concat(f).map((w) => w.matchUpId), g = i.shift(), I = g?.matchUpId, U = I && u[I].matchUpIds.concat(u[I].dependentMatchUpIds), S = I && h.some((w) => u[I].matchUpIds.includes(w)), P = I && d.some((w) => u[I].dependentMatchUpIds.includes(w)), v = m.matchUpIds.some((w) => U.includes(w)), D = s(g), y = m.participantIds.some((w) => D.includes(w));
      if (g && !v && !S && !y && !P) {
        let w = m.availableCourts.shift();
        Object.assign(g.schedule, w.schedule), Object.assign(w, g), l.push(g), m.participantIds.push(...D), m.matchUpIds.push(I);
      } else g && f.push(g);
    }
    i.push(...f), d.push(...m.matchUpIds);
  }
  let p = l.map(({ matchUpId: m, tournamentId: f, schedule: h, drawId: g }) => ({ tournamentId: f, matchUpId: m, drawId: g, schedule: { ...h, scheduledDate: r } }));
  return n = Dl({ tournamentRecords: t, matchUpDetails: p }), { ...n, scheduled: l, notScheduled: i };
}
function UE(e) {
  let { courtDayDate: t } = e, r = oe(e, [{ courtAssignments: !0, [Mr]: sr, [Kr]: ue }, { [ur]: !0 }]);
  if (r.error) return r;
  let i = e.courtAssignments.reduce((a, o) => {
    let { tournamentId: s } = o;
    return a[s] || (a[s] = []), a[s].push(o), a;
  }, {}), n;
  return Object.keys(i).every((a) => {
    let o = e[ur][a];
    if (!o) return n = { error: J }, !1;
    let s = i[a].reduce((c, u) => {
      let { drawId: l } = u;
      return c[l] || (c[l] = []), c[l].push(u), c;
    }, {});
    Object.keys(s).every((c) => {
      let { drawDefinition: u } = br({ tournamentRecord: o, drawId: c });
      return u ? (s[c].every((l) => {
        let { matchUpId: d, courtId: p } = l, m = rs({ tournamentRecord: o, drawDefinition: u, courtDayDate: t, matchUpId: d, courtId: p });
        if (m.success) return m?.success;
        n = { error: IP };
      }), !0) : (n = { error: ne }, !1);
    });
  }), n || x;
}
function SE(e) {
  let { tournamentRecords: t, allDateMatchUpIds: r = [], averageMatchUpMinutes: i = 90, recoveryMinutes: n = 0, recoveryMinutesMap: a, matchUpPotentialParticipantIds: o = {}, individualParticipantProfiles: s = {}, matchUpNotBeforeTimes: c = {}, matchUpDailyLimits: u = {}, checkPotentialRequestConflicts: l = !0, remainingScheduleTimes: d, clearScheduleDates: p, periodLength: m = 30, scheduleDate: f, matchUpIds: h, venueIds: g, startTime: I, endTime: U, dryRun: S } = e, P = oe(e, [{ [ur]: !0, [bu]: !0 }, { [tr]: Ar, [Kr]: Ht, [n1]: !0 }, { [tr]: (V) => !V || !isNaN(V), [c1]: !1, [Kr]: z, [u1]: !1, [l1]: !1 }]);
  if (P.error) return P;
  let v = e.competitionMatchUps ?? Bi({ nextMatchUps: !0, tournamentRecords: t }).matchUps ?? [], D = e.matchUpDependencies ?? Ei({ includeParticipantDependencies: !0, matchUps: v, tournamentRecords: t }).matchUpDependencies;
  v.forEach((V) => {
    V.schedule?.scheduledDate && hn(f, ve(V.schedule.scheduledDate)) && Fs({ matchUpPotentialParticipantIds: o, matchUpNotBeforeTimes: c, matchUp: V });
  });
  let y = h.map((V) => v.find(($) => $.matchUpId === V)).filter(Boolean), { venueId: w, scheduleTimes: b, dateScheduledMatchUpIds: T } = uS({ tournamentRecords: t, remainingScheduleTimes: d, startTime: ct(I), endTime: ct(U), scheduleDate: ve(f), averageMatchUpMinutes: i, clearScheduleDates: p, periodLength: m, venueIds: g }), R = {}, M = [], E = {}, A = {}, N = {};
  v.filter(({ matchUpId: V }) => T?.includes(V)).forEach((V) => {
    Yf({ matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUp: V, value: 1 });
    let $ = V.schedule?.scheduledTime;
    if ($) {
      E[V.matchUpId] = $;
      let q = a?.[V.matchUpId];
      su({ recoveryMinutes: q || n, matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUpNotBeforeTimes: c, averageMatchUpMinutes: i, matchUpDependencies: D, scheduleTime: $, matchUp: V });
    }
  });
  let C = y.filter((V) => {
    let $ = T?.includes(V.matchUpId), q = ["BYE", Pe, vt, Or, Xt, be].includes(V?.matchUpStatus);
    return !$ && !V.winningSide && !q;
  }), { matchUpMap: k, overLimitMatchUpIds: O, participantIdsAtLimit: _ } = C.reduce((V, $) => {
    let { drawId: q, tournamentId: Y, matchUpType: W } = $, { participantIdsAtLimit: K, relevantParticipantIds: Q } = tS({ individualParticipantProfiles: s, matchUpPotentialParticipantIds: o, matchUpDailyLimits: u, matchUp: $ });
    return K?.length ? (V.overLimitMatchUpIds.push($.matchUpId), V.participantIdsAtLimit.push(...K), V) : (Q.forEach((X) => {
      vl({ individualParticipantProfiles: s, participantId: X });
      let ee = s[X].counters;
      ee[W] ? ee[W] += 1 : ee[W] = 1, ee[Pi] ? ee[Pi] += 1 : ee[Pi] = 1;
    }), V.matchUpMap[Y] || (V.matchUpMap[Y] = {}), V.matchUpMap[Y][q] ? V.matchUpMap[Y][q].push($) : V.matchUpMap[Y][q] = [$], Fs({ matchUpPotentialParticipantIds: o, matchUpNotBeforeTimes: c, matchUp: $ }), V);
  }, { matchUpMap: {}, overLimitMatchUpIds: [], participantIdsAtLimit: [] });
  C = C.filter(({ matchUpId: V }) => !O.includes(V));
  let B = 0, L = b?.length ?? 0, { personRequests: j } = io({ tournamentRecords: t, requestType: Pl });
  for (; b?.length && C.length && B <= L; ) {
    B++;
    let { scheduleTime: V } = b.shift(), $ = C.find((q) => {
      let { matchUpId: Y } = q, { dependenciesScheduled: W, remainingDependencies: K } = JU({ matchUpScheduleTimes: E, matchUpDependencies: D, allDateMatchUpIds: r, matchUp: q });
      if (!W) return N[Y] || (N[Y] = []), N[Y].push({ scheduleTime: V, remainingDependencies: K }), !1;
      let { enoughTime: Q } = eS({ individualParticipantProfiles: s, matchUpNotBeforeTimes: c, matchUpDependencies: D, scheduleTime: V, matchUp: q });
      if (!Q) return A[Y] || (A[Y] = []), A[Y].push({ scheduleTime: V }), !1;
      let { conflicts: X } = ZU({ potentials: l, averageMatchUpMinutes: i, requestConflicts: R, personRequests: j, scheduleTime: V, scheduleDate: f, matchUp: q });
      if (X?.length) return !1;
      let ee = a?.[q.matchUpId];
      return su({ recoveryMinutes: ee || n, matchUpPotentialParticipantIds: o, individualParticipantProfiles: s, matchUpNotBeforeTimes: c, averageMatchUpMinutes: i, matchUpDependencies: D, scheduleTime: V, matchUp: q }), E[q.matchUpId] = V, !0;
    });
    C = C.filter(({ matchUpId: q }) => q !== $?.matchUpId), $ || M.push(V);
  }
  C.forEach((V) => {
    Yf({ individualParticipantProfiles: s, matchUpPotentialParticipantIds: o, value: -1, matchUp: V });
  });
  let H = [];
  Object.keys(k).forEach((V) => {
    let $ = t[V];
    $ && Object.keys(k[V]).forEach((q) => {
      let { drawDefinition: Y } = Ua({ tournamentRecord: $, drawId: q });
      Y && k[V][q].forEach(({ matchUpId: W }) => {
        let K = E[W];
        if (K) {
          let Q = K.split(":").map(ri).join(":"), X = `${ve(f)}T${Q}`;
          S ? H.push(W) : (Sa({ drawDefinition: Y, matchUpId: W, scheduledTime: X }).success && H.push(W), w && gc({ tournamentRecords: t, tournamentRecord: $, drawDefinition: Y, matchUpId: W, venueId: w }));
        }
      });
    });
  });
  let G = og(C);
  return { ...x, requestConflicts: Object.values(R), remainingScheduleTimes: b?.map(({ scheduleTime: V }) => V), individualParticipantProfiles: s, matchUpNotBeforeTimes: c, participantIdsAtLimit: _, skippedScheduleTimes: M, overLimitMatchUpIds: O, scheduledMatchUpIds: H, noTimeMatchUpIds: G, recoveryTimeDeferred: A, dependencyDeferred: N };
}
function yE({ tournamentRecords: e, matchUps: t }) {
  if (!pi(t)) return { error: Gn };
  if (t.some(({ matchUpId: m, hasContext: f }) => m && !f)) return { info: "matchUps must have { inContext: true, nextMatchUps: true }", error: Fd };
  let r = Math.max(...t.map(({ schedule: m }) => m?.courtOrder || 1).map((m) => pe(m))), i = te(1, r + 1).map((m) => t.filter((f) => pe(f.schedule?.courtOrder) === m)), n = {}, a = {}, o = {};
  i.flat().filter(Boolean).sort(Ho).forEach(({ schedule: m }) => delete m[_l]);
  let s = Ue(t.map(({ drawId: m }) => m)), c = Ei({ includeParticipantDependencies: !0, tournamentRecords: e, drawIds: s }).matchUpDependencies, u = i.map((m, f) => m.reduce((h, g) => {
    if (!g.matchUpId) return h;
    let { matchUpId: I, winnerMatchUpId: U, loserMatchUpId: S, schedule: P, sides: v, potentialParticipants: D } = g, y = P?.courtId;
    n[I] = f, a[y] = [], h.matchUpIds.push(I), o[I] = g;
    let w = c[I].matchUpIds;
    w.length && h.sourceMatchUpIds.push(...w);
    let b = v?.map((R) => [R.participant?.individualParticipantIds, R.participantId]).flat().filter(Boolean) ?? [], T = D?.flat().map(({ individualParticipantIds: R, participantId: M }) => [R, M]).flat().filter(Boolean) || [];
    return h.participantIds.push(...T, ...b), U && h.targetMatchUpIds.push(U), S && h.targetMatchUpIds.push(S), h;
  }, { sourceMatchUpIds: [], targetMatchUpIds: [], participantIds: [], matchUpIds: [] })), l = (m, f) => c[m].sources.reduce((h, g, I) => g.includes(f) && I + 1 || h, 0), d = u.map(() => []), p = (m, f, h, g) => {
    if (!o[m].schedule[_l]) {
      o[m].schedule[_l] = f, o[m].schedule[qw] = g, d[n[m]].push({ matchUpId: m, issueType: h, issueIds: g, issue: f });
      let I = o[m].schedule.courtId;
      a[I] || (a[I] = []), a[I].push({ matchUpId: m, issue: f, issueType: h, issueIds: g });
    }
  };
  return u.forEach((m, f) => {
    let h = f ? u[f - 1] : void 0, g = u.slice(f + 1), I = {}, U = Br(m.participantIds), S = Object.keys(U).filter((D) => U[D] > 1), P = m.matchUpIds.filter((D) => c[D].participantIds.some((y) => S.includes(y)));
    P.forEach((D) => {
      I[D] || (I[D] = {}), I[D][ya] || (I[D][ya] = P.filter((y) => y !== D));
    });
    let v = h && m.participantIds.filter((D) => h.participantIds.includes(D));
    v && v.forEach((D) => {
      let y = m.matchUpIds.concat(h.matchUpIds).filter((w) => c[w].participantIds.includes(D));
      y.forEach((w) => {
        I[w] || (I[w] = {}), I[w][va] || (I[w][va] = y.filter((b) => b !== w));
      });
    }), m.matchUpIds.forEach((D) => {
      let y = c[D].matchUpIds;
      for (let b of g) {
        let T = b.matchUpIds.filter((R) => y.includes(R));
        T?.length && (T.forEach((R) => p(R, Tf, Qn, [D])), p(D, Tf, Qn, T));
      }
      if (I[D]?.[ya] && p(D, ya, wf, I[D][ya]), m.sourceMatchUpIds.includes(D)) {
        let b = m.matchUpIds.filter((T) => c[T].matchUpIds.includes(D));
        p(D, ya, Qn, b), m.matchUpIds.filter((T) => c[T].matchUpIds.includes(D)).forEach((T) => p(T, ya, Qn, [D]));
      }
      let w = h?.matchUpIds?.filter((b) => l(D, b) > 1);
      if (w?.length && (p(D, bf, Qn, w), w.forEach((b) => p(b, bf, Qn, [D]))), I[D]?.[va] && p(D, va, wf, I[D][va]), h?.targetMatchUpIds?.includes(D)) {
        let b = o[D].schedule.courtId, T = y.filter((R) => h.matchUpIds.includes(R));
        T.some((R) => o[R].schedule.courtId === b) || (T.forEach((R) => p(R, va, Qn, [D])), p(D, va, Qn, T));
      }
    });
  }), { courtIssues: a, rowIssues: d };
}
function vE(e) {
  let t = "reorderUpcomingMatchUps", { tournamentRecords: r } = e;
  if (typeof r != "object" || !Object.keys(r).length) return F({ result: { error: ht }, stack: t });
  let { matchUpsContextIds: i, firstToLast: n } = e;
  if (!i) return F({ result: { error: ue }, stack: t });
  let a = i?.length;
  if (!a) return { ...x };
  let o = 0;
  return i.forEach((c, u) => {
    let { tournamentId: l, drawId: d, matchUpId: p } = c, m = u + (n ? -1 : 1);
    m < 0 && (m = a - 1), m === a && (m = 0);
    let f = i[m].schedule.scheduledTime, h = s({ tournamentId: l, scheduledTime: f, matchUpId: p, drawId: d });
    if (h.success) o++;
    else return h;
  }), o === a ? x : F({ result: { error: gP }, stack: t });
  function s({ tournamentId: c, scheduledTime: u, matchUpId: l, drawId: d }) {
    let p = r[c], { drawDefinition: m } = Ua({ tournamentRecord: p, drawId: d });
    return m ? Sa({ drawDefinition: m, scheduledTime: u, matchUpId: l }) : { error: zr };
  }
}
function PE(e) {
  let { scheduleChange: t, matchUpIds: r, dryRun: i } = e;
  if (!r || !Array.isArray(r)) return { error: Ro };
  if (typeof t != "object") return { error: z };
  let n = ui(e), a = [], o = [];
  for (let c of Object.values(n)) {
    let u = N2({ tournamentRecord: c, scheduleChange: t, matchUpIds: r, dryRun: i });
    if (u.error) return u;
    Array.isArray(u.notRescheduled) && o.push(...u.notRescheduled);
    let l = og(u.notRescheduled), d = [];
    u.rescheduled?.forEach((p) => {
      let { matchUpId: m } = p;
      l.includes(m) && d.push(m), a.push(p);
    }), d.length && (o = u?.notRescheduled?.filter(({ matchUpId: p }) => !d.includes(p)) || []);
  }
  let s = !!(a.length && !o.length);
  return { ...x, rescheduled: a, notRescheduled: o, allRescheduled: s };
}
function N2({ tournamentRecord: e, scheduleChange: t, matchUpIds: r, dryRun: i }) {
  if (!e) return { error: J };
  if (!r || !Array.isArray(r)) return { error: Ro };
  if (typeof t != "object") return { error: z };
  let n = [], a = [], { minutesChange: o, daysChange: s } = t;
  if (!o && !s) return { ...x };
  if (o && isNaN(o)) return { error: z };
  if (s && isNaN(s)) return { error: z };
  let { matchUps: c } = Jt({ matchUpFilters: { matchUpIds: r }, tournamentRecord: e }), u = ({ matchUpStatus: P }) => !Lt.includes(P), l = c?.filter((P) => hl({ schedule: P.schedule })).filter((P) => u({ matchUpStatus: P.matchUpStatus }));
  if (!l?.length) return { ...x };
  let { tournamentInfo: d } = es({ tournamentRecord: e }), { startDate: p, endDate: m } = d, f = l?.reduce((P, v) => {
    let { matchUpId: D, drawId: y } = v;
    return P[y] ? P[y].push(D) : P[y] = [D], P;
  }, {}), h = 1440;
  for (let P of Object.keys(f)) {
    let v = Ua({ tournamentRecord: e, drawId: P });
    if (v.error) return v;
    let D = v.drawDefinition, y = f[P].filter((w) => r.includes(w));
    for (let w of y) if (w && D) {
      let b = l.find((N) => N.matchUpId === w)?.schedule, { scheduledTime: T, scheduledDate: R } = b, M, E, A;
      if (!M && s && R) {
        let N = ve(R);
        A = Pc(N, s), M = new Date(A) < new Date(p) || new Date(A) > new Date(m);
      }
      if (o && T) {
        let N = ve(T), C = Le(ct(T)) + o;
        if (M = C < 0 || C > h, !M) {
          let k = Er(T, o), O = N && A || R === N && N;
          E = O ? `${O}T${k}` : k;
        }
      }
      if (M) a.push(w);
      else {
        if (!i) {
          if (E) {
            let N = Sa({ scheduledTime: E, drawDefinition: D, matchUpId: w });
            if (N.error) return N;
          }
          if (A) {
            let N = Sm({ scheduledDate: A, drawDefinition: D, matchUpId: w });
            if (N.error) return N;
          }
        }
        (E || A) && n.push(w);
      }
    }
  }
  let g = Jt({ matchUpFilters: { matchUpIds: r }, tournamentRecord: e }).matchUps ?? [], I = g.filter(({ matchUpId: P }) => n.includes(P)), U = g.filter(({ matchUpId: P }) => a.includes(P)), S = I.length && !U.length;
  return { ...x, rescheduled: I, notRescheduled: U, allRescheduled: S };
}
function DE(e) {
  let t = "matchUpScheduleChange", { tournamentRecords: r } = e;
  if (typeof r != "object" || !Object.keys(r).length) return { error: ht };
  let { sourceMatchUpContextIds: i, targetMatchUpContextIds: n, sourceCourtId: a, targetCourtId: o, courtDayDate: s } = e || {}, { drawId: c, matchUpId: u, tournamentId: l } = i || {}, { drawId: d, matchUpId: p, tournamentId: m } = n || {};
  if (!u && !p) return F({ result: { error: ue }, stack: t });
  let { matchUps: f } = Bi({ matchUpFilters: { matchUpIds: [u, p].filter(Boolean), drawIds: [c, d].filter(Boolean) }, tournamentRecords: e.tournamentRecords }), h = f?.find(({ matchUpId: P }) => P === u), g = f?.find(({ matchUpId: P }) => P === p), I = 0;
  if (o && u && !p) {
    let P = U({ tournamentId: l, matchUpId: u, courtId: o, matchUp: h, drawId: c, tournamentRecords: r, sourceCourtId: a, courtDayDate: s });
    if (P?.success && I++, P.error) return F({ result: P, stack: t });
  } else if (a && o && u && p) {
    let P = U({ tournamentId: l, matchUpId: u, courtId: o, matchUp: h, drawId: c, tournamentRecords: r, sourceCourtId: a, courtDayDate: s });
    if (P.success && I++, P.error) return F({ result: P, stack: t, info: "source" });
    let v = U({ tournamentId: m, sourceCourtId: o, matchUpId: p, matchUp: g, courtId: a, drawId: d, tournamentRecords: r, courtDayDate: s });
    if (v.success && I++, v.error) return F({ result: v, stack: t, info: "target" });
  } else return { error: ue };
  return I ? x : F({ result: { error: Hs }, stack: t });
  function U(P) {
    let { tournamentRecords: v, tournamentId: D, matchUp: y, drawId: w } = P, b = v[D], { drawDefinition: T } = Ua({ tournamentRecord: b, drawId: w });
    return y.matchUpType === ot ? S({ ...P, tournamentRecord: b, drawDefinition: T }) : rs({ ...P, tournamentRecord: b, drawDefinition: T });
  }
  function S({ removePriorValues: P, tournamentRecords: v, tournamentRecord: D, drawDefinition: y, sourceCourtId: w, courtDayDate: b, matchUpId: T, matchUp: R, courtId: M }) {
    let E = [M].concat(R.schedule.allocatedCourts.map(({ courtId: A }) => A).filter((A) => A !== w));
    return ym({ removePriorValues: P, tournamentRecords: v, tournamentRecord: D, drawDefinition: y, courtDayDate: b, matchUpId: T, courtIds: E });
  }
}
function wE({ scheduleAttributes: e = [Dn, ca, Vo, jo, Go, Ci, Vn, ln, On], tournamentRecord: t, drawDefinition: r, matchUpId: i }) {
  let n = "clearMatchUpSchedule", a = r ? hr({ matchUpFilters: { matchUpIds: [i] }, inContext: !1, drawDefinition: r }).matchUps?.[0] : Jt({ matchUpFilters: { matchUpIds: [i] }, tournamentRecord: t, inContext: !1 }).matchUps?.[0];
  if (!a) return { error: cr };
  let o = (a.timeItems ?? []).filter((s) => s?.itemType && !e.includes(s?.itemType));
  return a.timeItems = o, Oe({ tournamentId: t.tournamentId, context: n, drawDefinition: r, matchUp: a }), { ...x };
}
function TE(e) {
  let { tournamentRecord: t, tournamentId: r, dailyLimits: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (typeof n != "object" || !Object.keys(n).length) return { error: ht };
  if (typeof i != "object") return { error: $n };
  let a = Object.keys(n).filter((o) => !r || r === o);
  if (r && !a.includes(r)) return { error: z };
  for (let o of a) {
    let s = n[o], c = Be({ extension: { name: Ru, value: { dailyLimits: i } }, element: s });
    if (c.error) return c;
  }
  return { ...x };
}
var bE = {};
Me(bE, { addCollectionDefinition: () => pS, addCollectionGroup: () => CE, aggregateTieFormats: () => kE, compareTieFormats: () => jn, getTieFormat: () => Xp, modifyCollectionDefinition: () => lS, modifyTieFormat: () => OE, mutate: () => ME, orderCollectionDefinitions: () => EE, query: () => $M, removeCollectionDefinition: () => dS, removeCollectionGroup: () => NE, tieFormatGenderValidityCheck: () => qd, validateCollectionDefinition: () => Pu });
var ME = {};
Me(ME, { addCollectionDefinition: () => pS, addCollectionGroup: () => CE, aggregateTieFormats: () => kE, modifyCollectionDefinition: () => lS, modifyTieFormat: () => OE, orderCollectionDefinitions: () => EE, removeCollectionDefinition: () => dS, removeCollectionGroup: () => NE });
function ja({ drawDefinition: e, structureId: t, matchUpId: r, structure: i, matchUp: n, eventId: a, event: o }) {
  let s = "getTieFormat", c;
  if (t = i?.structureId ?? t, r = n?.matchUpId ?? r, (r || t) && !e) return { error: ne };
  if (a && o) c = Gi(o);
  else if (r) {
    if (e && (!n || !i)) {
      let u = ut({ drawDefinition: e, matchUpId: r });
      if (u.error) return u;
      if (u.matchUp?.matchUpType !== Hr) return F({ result: { error: Cr }, stack: s });
      i || (i = u.structure), n || (n = u.matchUp);
    }
    c = Mc({ item: n, drawDefinition: e, structure: i, event: o }) || Mc({ item: i, drawDefinition: e, structure: i, event: o }) || Gi(e) || Gi(o);
  } else if (e && t) {
    if (!i) {
      let u = me({ drawDefinition: e, structureId: t });
      if (u.error) return u;
      i = u?.structure;
    }
    c = Mc({ item: i, drawDefinition: e, structure: i, event: o }) || Gi(e) || Gi(o);
  } else c = Gi(e) || Gi(o);
  return c ? { ...x, structure: i, tieFormat: c, matchUp: n } : F({ result: { error: $s }, stack: s });
}
function Td({ matchUp: e, updateInProgressMatchUps: t }) {
  return !e.winningSide && ![Lt].includes(e.matchUpStatus) && (t || e.matchUpStatus !== Ri && !Bt(e));
}
function zm({ from: e, to: t }) {
  let r = Object.keys(e), i = Pt(r, Object.keys(t)).length === r.length, n = r.filter((o) => e[o] !== t[o]).map((o) => ({ countChange: t[o] - e[o], collectionId: o })), a = r.every((o) => e[o] === t[o]);
  return { equivalent: i && a, matchUpsCountChanges: n };
}
function E2({ updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: r, structure: i, tieFormat: n, eventId: a, matchUp: o, event: s, uuids: c }) {
  let u = "updateTieFormat", l = t?.tournamentId, d = 0, p = 0, m = 0, f = 0, h = n?.collectionDefinitions.reduce((D, y) => (D[y.collectionId] = (D[y.collectionId] || 0) + y.matchUpCount, D), {}), g = ({ tieFormat: D }) => {
    let y = D?.collectionDefinitions.reduce((w, b) => (w[b.collectionId] = (w[b.collectionId] || 0) + b.matchUpCount, w), {});
    return zm({ from: y, to: h }).equivalent;
  }, I = ja({ drawDefinition: r })?.tieFormat, U = ja({ event: s })?.tieFormat;
  if (s && a) {
    for (let D of s.drawDefinitions ?? []) S({ drawDefinition: D });
    s.tieFormat = er(n), f += 1;
  } else if (o) {
    if (!o.tieMatchUps) return F({ result: { error: Cr }, stack: u });
    let D = Br(o.tieMatchUps?.map(({ collectionId: R }) => R)), y = zm({ to: h, from: D }), { changes: w, changesArePossible: b, cannotChangeReaon: T } = Fy({ matchUp: o, check: y });
    if (y.equivalent) if (Td({ matchUp: o, updateInProgressMatchUps: e })) o.tieFormat = er(n), f += 1;
    else return F({ result: { error: gh }, info: "matchUp is IN_PROGRESS or COMPLETE", stack: u });
    else if (b) v({ tieFormat: n, matchUp: o, changes: w, uuids: c });
    else return F({ context: { collectionMap: h, matchUpMap: D }, result: { error: cn }, info: T || "specified changes not possible", stack: u });
    p += 1, Oe({ eventId: s?.eventId, context: u, drawDefinition: r, tournamentId: l, matchUp: o });
  } else if (i) {
    let D = P({ inheritedTieFormat: I ?? U, structure: i })?.modifiedMatchUpsCount;
    D && (p += D, d += 1, f += 1);
    let y = !i.tieFormat || jn({ ancestor: i.tieFormat, descendant: n }).different;
    y && (i.tieFormat = er(n), d += 1, f += 1), (D || y) && r && tt({ structureIds: [i.structureId], eventId: s?.eventId, drawDefinition: r });
  } else if (r) S({ drawDefinition: r }), r.tieFormat = er(n), f += 1;
  else return { error: ne };
  return { modifiedStructuresCount: d, modifiedMatchUpsCount: p, addedMatchUpsCount: m, modifiedCount: f, ...x, tieFormat: n };
  function S({ drawDefinition: D }) {
    let y = D.structures || [], w = [];
    for (let b of y) {
      if (b.tieFormat) continue;
      let T = P({ inheritedTieFormat: U, structure: b })?.modifiedMatchUpsCount;
      if (T) {
        d += 1, p += T;
        let R = b.structureId;
        w.push(R);
      }
    }
    return tt({ structureIds: w, eventId: s?.eventId, drawDefinition: D }), w.length;
  }
  function P({ inheritedTieFormat: D, structure: y }) {
    let w = 0, b = Ve({ matchUpFilters: { matchUpTypes: [ot] }, structure: y })?.matchUps || [];
    for (let T of b) {
      let R = Td({ matchUp: T, updateInProgressMatchUps: e }), M = !1, E = Br(T.tieMatchUps?.map(({ collectionId: N }) => N)), A = zm({ from: E, to: h });
      if (A.equivalent) T.tieFormat && g(T) && R && (T.tieFormat = er(n), M = !0);
      else {
        let { changes: N, changesArePossible: C } = Fy({ matchUp: T, check: A });
        if (C && !T.tieFormat) v({ changes: N, matchUp: T, tieFormat: n, uuids: c });
        else if (D) (!T.tieFormat || jn({ ancestor: D, descendant: T.tieFormat }).different) && (T.tieFormat = D, M = !0);
        else return F({ result: { error: $s }, stack: u });
      }
      M && (w += 1, Oe({ tournamentId: t?.tournamentId, drawDefinition: r, context: u, eventId: a, matchUp: T }));
    }
    return { modifiedMatchUpsCount: w };
  }
  function v({ uuids: D, matchUp: y, tieFormat: w, changes: b }) {
    y.tieFormat = er(w);
    let T = [], R = [];
    return b.forEach((M) => {
      if (M.countChange > 0) {
        let E = Math.max(0, ...y.tieMatchUps.filter((C) => C.collectionId === M.collectionId).map(qr("collectionPosition"))), A = w.collectionDefinitions.find((C) => C.collectionId === M.collectionId), N = rl({ matchUpsLimit: M.countChange, collectionPositionOffset: E, collectionDefinition: A, matchUp: y, uuids: D });
        R.push(...ie(N, !1, !0)), m += R.length, y.tieMatchUps.push(...N);
      } else {
        let E = M.toBePlayedTieMatchUpIds.slice(0, Math.abs(M.countChange));
        console.log("remove", E.length), T.push(...E), y.tieMatchUps = y.tieMatchUps.filter(({ matchUpId: A }) => !E.includes(A));
      }
    }), R.length && oa({ matchUps: R, drawDefinition: r, tournamentId: l, eventId: a }), T.length && bn({ matchUpIds: T, action: "updateTieFormat", drawDefinition: r, tournamentId: l, eventId: a }), { matchUpIdsRemoved: T, matchUpsAdded: R };
  }
}
function Fy({ check: e, matchUp: t }) {
  let r = "", i = [];
  return { changesArePossible: e.matchUpsCountChanges.every(({ collectionId: n, countChange: a }) => {
    let o = t.tieMatchUps.filter((c) => c.collectionId === n && c.matchUpStatus === Dt).map(qr("matchUpId")), s = o.length + a >= 0 || a > 0;
    return !s && a < 0 && (r = "Insufficient TO_BE_PLAYED matchUps"), i.push({ toBePlayedTieMatchUpIds: o, collectionId: n, countChange: a }), s;
  }), changes: i, cannotChangeReaon: r };
}
function Rm({ appliedPolicies: e, drawDefinition: t, auditData: r }) {
  if (!e?.audit?.[Tc]) return;
  let { extension: i } = we({ name: Tc, element: t }), n = { value: Array.isArray(i?.value) ? i?.value.concat(r) : [r], name: Tc };
  Be({ element: t, extension: n });
}
function lS({ updateInProgressMatchUps: e = !1, tournamentRecord: t, collectionOrder: r, collectionName: i, tieFormatName: n, drawDefinition: a, matchUpFormat: o, matchUpCount: s, collectionId: c, matchUpType: u, structureId: l, matchUpId: d, category: p, eventId: m, gender: f, event: h, collectionValueProfiles: g, collectionValue: I, matchUpValue: U, scoreValue: S, setValue: P }) {
  let v = "modifyCollectionDefinition";
  if (o && !Vr({ matchUpFormat: o })) return F({ result: { error: z }, context: { matchUpFormat: o }, stack: v });
  if (i && typeof i != "string") return F({ result: { error: z }, context: { collectionName: i }, stack: v });
  if (f && !Object.values(kh).includes(f)) return F({ result: { error: z }, context: { gender: f }, stack: v });
  if (p && typeof p != "object") return F({ result: { error: z }, context: { category: p }, stack: v });
  let D = { collectionValueProfiles: g, collectionValue: I, matchUpValue: U, scoreValue: S, setValue: P };
  if (!Object.values(D).filter(Boolean).length && !r && !i && !o && !s && !u) return F({ result: { error: ue }, stack: v });
  if (Object.values(D).filter(Boolean).length > 1) return F({ info: "Only one value assignment allowed per collectionDefinition", result: { error: z }, stack: v });
  let y = ja({ drawDefinition: a, structureId: l, matchUpId: d, eventId: m, event: h });
  if (y.error) return F({ result: y, stack: v });
  let { matchUp: w, structure: b, tieFormat: T } = y, R = er(T), M = T?.collectionDefinitions.find((H) => H.collectionId === c), E = R?.collectionDefinitions.find((H) => H.collectionId === c);
  if (!M) return F({ info: "source collectionDefinition", result: { error: Kt }, context: { collectionId: c }, stack: v });
  let A = I ?? U ?? S ?? P;
  if (g?.length) {
    let H = Iv({ matchUpCount: s ?? M?.matchUpCount ?? 0, collectionValueProfiles: g });
    if (H.errors) return F({ result: { error: z }, info: H.errors, stack: v });
  } else if (A && !Ie(A)) return F({ result: { error: z }, info: "value is not an integer", context: { value: A }, stack: v });
  let N = (H, G) => Pt(Object.keys(H), Object.keys(G)).length === Object.keys(H).length && Pt(Object.values(H), Object.values(G)).length === Object.values(H).length, C = g && (!M.collectionValueProfiles || !N(M.collectionValueProfiles, g)), k = Ie(I) && M.collectionValue !== I || Ie(U) && M.matchUpValue !== U || Ie(S) && M.scoreValue !== S || Ie(P) && M.setValue !== P || C, O = [];
  if (k && (E.collectionValueProfiles = void 0, E.collectionValue = void 0, E.matchUpValue = void 0, E.scoreValue = void 0, E.setValue = void 0, Object.assign(E, D), O.push({ collectionId: c, ...ae(D) })), (Ie(S) || Ie(P)) && E.collectionGroupNumber) {
    let H = E.collectionGroupNumber;
    R.collectionDefinitions = R.collectionDefinitions.map((G) => {
      let { collectionGroupNumber: V, ...$ } = G;
      return V === H ? $ : G;
    }), R.collectionGroups = R.collectionGroups.filter(({ groupNumber: G }) => G !== H), O.push({ collectionId: c, change: "collectionGroupNumber removed" });
  }
  let { aggregateValue: _, valueGoal: B } = ts(R), L = ae({ aggregateValue: _, valueGoal: B });
  if ((L.aggregateValue !== T?.winCriteria.aggregateValue || L.valueGoal !== T?.winCriteria.valueGoal) && (R.winCriteria = L, O.push({ collectionId: c, winCriteria: L })), Ie(r) && M.collectionOrder !== r && (E.collectionOrder = r, O.push({ collectionId: c, collectionOrder: r })), i && M.collectionName !== i && (E.collectionName = i, O.push({ collectionId: c, collectionName: i })), o && M.matchUpFormat !== o && (E.matchUpFormat = o, O.push({ collectionId: c, matchUpFormat: o })), Ie(s) && M.matchUpCount !== s && (E.matchUpCount = s, O.push({ collectionId: c, matchUpCount: s })), u && M.matchUpType !== u) return F({ result: { error: Bd }, context: { matchUpType: u }, stack: v });
  p && M.category !== p && (E.category = p, O.push({ collectionId: c, category: p })), f && M.gender !== f && (E.gender = f, O.push({ collectionId: c, gender: f }));
  let j = ae(R);
  if (y = wr({ tieFormat: j }), y.error) return F({ result: y, stack: v });
  if (!O.length) return F({ result: { ...x, modifications: O } });
  if (T?.tieFormatName !== n ? (j.tieFormatName = n, O.push({ tieFormatName: n })) : O.length && (delete j.tieFormatName, O.push("tieFormatName removed: modifications without new tieFormatName")), y = E2({ tieFormat: j, updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: a, structure: b, eventId: m, matchUp: w, event: h }), !y.error) {
    let { appliedPolicies: H } = _e({ tournamentRecord: t }), G = ae({ collectionDefinition: E, drawId: a?.drawId, action: v, structureId: l, matchUpId: d, eventId: m });
    Rm({ appliedPolicies: H, drawDefinition: a, auditData: G });
  }
  return F({ result: { ...y, modifications: O }, stack: v });
}
function A2({ updateInProgressMatchUps: e, drawDefinition: t, structureId: r, structure: i, matchUpId: n, matchUp: a }) {
  let o = [];
  return n && a ? o = [a] : r && i ? o = Ve({ matchUpFilters: { matchUpTypes: [ot] }, structure: i })?.matchUps ?? [] : t && (o = hr({ matchUpFilters: { matchUpTypes: [ot] }, drawDefinition: t })?.matchUps ?? []), { targetMatchUps: o.filter((s) => !s.winningSide && s.matchUpStatus !== vt && (e || s.matchUpStatus !== Ri && !Bt(s))) };
}
function C2({ updateInProgressMatchUps: e, tournamentRecord: t, drawDefinition: r, targetMatchUps: i, tieFormat: n, event: a }) {
  for (let o of i) {
    let s = !!o.tieFormat;
    s && (o.tieFormat = er(n));
    let c;
    if (e) {
      let u = _e({ tournamentRecord: t, drawDefinition: r, event: a }).appliedPolicies, l = zn({ matchUpId: o.matchUpId, exitWhenNoValues: !0, tournamentRecord: t, appliedPolicies: u, drawDefinition: r, event: a });
      if (l.error) return l;
      c = l.score;
    }
    s && !c && Oe({ tournamentId: t?.tournamentId, context: "updateTargetTeamMatchUps", eventId: a?.eventId, matchUp: o, drawDefinition: r });
  }
  return { ...x };
}
function RE({ updateInProgressMatchUps: e, originalValueGoal: t, tournamentRecord: r, wasAggregateValue: i, tieFormatName: n, drawDefinition: a, structureId: o, structure: s, tieFormat: c, matchUpId: u, matchUp: l, eventId: d, event: p }) {
  let { aggregateValue: m, valueGoal: f } = ts(c);
  c.winCriteria = ae({ aggregateValue: m, valueGoal: f }), (t && t !== f || m && !i) && (n ? c.tieFormatName = n : delete c.tieFormatName);
  let { targetMatchUps: h } = A2({ updateInProgressMatchUps: e, drawDefinition: a, structureId: o, structure: s, matchUpId: u, matchUp: l });
  C2({ updateInProgressMatchUps: e, tournamentRecord: r, targetMatchUps: h, drawDefinition: a, tieFormat: c, event: p });
  let g = ae(c), I = wr({ tieFormat: g });
  if (I.error) return I;
  if (d && p) p.tieFormat = g;
  else if (u && l) l.tieFormat = c;
  else if (s) s.tieFormat = g;
  else if (a) a.tieFormat = g;
  else if (!l || !a) return { error: ne };
  return tt({ drawDefinition: a, eventId: p?.eventId }), { ...x };
}
function NE({ updateInProgressMatchUps: e = !0, collectionGroupNumber: t, tournamentRecord: r, drawDefinition: i, tieFormatName: n, structureId: a, matchUpId: o, matchUp: s, eventId: c, event: u }) {
  if (!t) return { error: ue };
  if (isNaN(t)) return { error: z };
  let l = "removeCollectionGroup", d = s ? void 0 : ja({ drawDefinition: i, structureId: a, matchUpId: o, eventId: c, event: u });
  if (d?.error) return F({ result: d, stack: l });
  let p = d?.structure;
  s = s ?? d?.matchUp;
  let m = d?.tieFormat, f = m?.winCriteria.valueGoal, h = m?.winCriteria.aggregateValue, g = er(m);
  if (d = wr({ tieFormat: g }), d.error) return F({ result: d, stack: l });
  let I = [];
  if (g.collectionDefinitions = g.collectionDefinitions.map((U) => {
    let { collectionGroupNumber: S, ...P } = U;
    return S !== t ? U : (I.push(U.collectionId), P);
  }), g.collectionGroups = g.collectionGroups.filter(({ groupNumber: U }) => U !== t), d = RE({ updateInProgressMatchUps: e, originalValueGoal: f, wasAggregateValue: h, tournamentRecord: r, drawDefinition: i, tieFormatName: n, structureId: a, structure: p, tieFormat: g, matchUpId: o, matchUp: s, eventId: c, event: u }), !d.error) {
    let { appliedPolicies: U } = _e({ tournamentRecord: r }), S = ae({ drawId: i?.drawId, collectionGroupNumber: t, action: l, structureId: a, matchUpId: o, eventId: c });
    Rm({ appliedPolicies: U, drawDefinition: i, auditData: S });
  }
  return F({ result: { ...d, modifiedCollectionIds: I }, stack: l });
}
function _s({ tieFormat: e, orderMap: t }) {
  let r = er(e);
  return r.collectionDefinitions?.forEach((i) => {
    let n = t[i.collectionId];
    n && (i.collectionOrder = n);
  }), r.collectionDefinitions?.sort((i, n) => gs(i.collectionOrder) - gs(n.collectionOrder)), r;
}
function EE({ tournamentRecord: e, drawDefinition: t, structureId: r, matchUpId: i, orderMap: n, eventId: a, matchUp: o, event: s }) {
  if (typeof n != "object" || !Object.values(n).every((l) => Ie(l))) return F({ result: { error: z }, context: { orderMap: n } });
  let c = r ? me({ drawDefinition: t, structureId: r }) : void 0;
  if (c?.error) return c;
  let u = c?.structure;
  if (a && s?.tieFormat) Ly({ tournamentRecord: e, event: s, orderMap: n });
  else if (i) {
    let l = t && ut({ drawDefinition: t, matchUpId: i });
    if (l?.error) return l;
    if (o = l.matchUp, !o) return { error: Dr };
    let d = Xp({ tournamentRecord: e, matchUpId: i, structure: u, drawDefinition: t, event: s })?.tieFormat;
    o.tieFormat = _s({ tieFormat: d, orderMap: n }), Oe({ tournamentId: e?.tournamentId, eventId: s?.eventId, drawDefinition: t, matchUp: o });
  } else if (r) if (u?.tieFormat) u.tieFormat = _s({ tieFormat: u.tieFormat, orderMap: n }), AE({ eventId: s?.eventId, tournamentRecord: e, drawDefinition: t, structure: u, orderMap: n }), tt({ drawDefinition: t, structureIds: [u.structureId] });
  else if (t.tieFormat) Kf({ structureIds: [r], tournamentRecord: e, drawDefinition: t, orderMap: n, event: s });
  else if (s?.tieFormat) Ly({ structureIds: [r], tournamentRecord: e, orderMap: n, event: s });
  else return { error: Kt };
  else if (t?.tieFormat) Kf({ tournamentRecord: e, drawDefinition: t, orderMap: n, event: s });
  else return { error: Kt };
  return { ...x };
}
function Ly({ tournamentRecord: e, structureIds: t, orderMap: r, event: i }) {
  let n = _s({ tieFormat: i.tieFormat, orderMap: r });
  t?.length || (i.tieFormat = n);
  for (let a of i.drawDefinitions ?? []) Kf({ tournamentRecord: e, drawDefinition: a, structureIds: t, orderMap: r, event: i });
}
function Kf({ tournamentRecord: e, drawDefinition: t, structureIds: r, orderMap: i, event: n }) {
  let a = t.tieFormat ?? n?.tieFormat, o = _s({ tieFormat: a, orderMap: i });
  r?.length || (t.tieFormat = o);
  let s = [];
  for (let c of t.structures ?? []) r?.length && !r.includes(c.structureId) || ((c.tieFormat || r?.includes(c.structureId)) && (c.tieFormat = _s({ tieFormat: c.tieFormat ?? t.tieFormat ?? n?.tieFormat, orderMap: i })), AE({ eventId: n?.eventId, tournamentRecord: e, drawDefinition: t, structure: c, orderMap: i }), s.push(c.structureId));
  tt({ drawDefinition: t, structureIds: s });
}
function AE({ tournamentRecord: e, drawDefinition: t, structure: r, orderMap: i, eventId: n }) {
  let a = Ve({ matchUpFilters: { matchUpTypes: [ot] }, structure: r })?.matchUps;
  for (let o of a) o.tieFormat && (o.tieFormat = _s({ tieFormat: o.tieFormat, orderMap: i }), Oe({ tournamentId: e?.tournamentId, drawDefinition: t, eventId: n, matchUp: o }));
}
function dS({ updateInProgressMatchUps: e = !0, tieFormatComparison: t, tournamentRecord: r, drawDefinition: i, tieFormatName: n, collectionId: a, structureId: o, matchUpId: s, eventId: c, matchUp: u, event: l }) {
  let d = "removeCollectionDefinition", p = u ? void 0 : ja({ drawDefinition: i, structureId: o, matchUpId: s, eventId: c, event: l });
  if (p?.error) return F({ result: p, stack: d });
  let m = p?.structure;
  u = u ?? p?.matchUp;
  let f = p?.tieFormat, h = er(f);
  if (p = wr({ tieFormat: h }), p.error) return F({ result: p, stack: d });
  let g = h?.collectionDefinitions?.find((R) => R.collectionId === a);
  if (!g) return F({ result: { error: Kt, collectionId: a } });
  h.collectionDefinitions = h.collectionDefinitions.filter((R) => R.collectionId !== a), g.collectionGroupNumber && (h.collectionDefinitions = h.collectionDefinitions.map((R) => {
    let { collectionGroupNumber: M, ...E } = R;
    return E;
  }), h.collectionGroups = h.collectionGroups.filter(({ groupNumber: R }) => R !== g.collectionGroupNumber));
  let { aggregateValue: I, valueGoal: U } = ts(h);
  h.winCriteria = ae({ aggregateValue: I, valueGoal: U });
  let S = f?.winCriteria.valueGoal, P = f?.winCriteria.aggregateValue;
  (S && S !== U || I && !P) && (n ? h.tieFormatName = n : delete h.tieFormatName);
  let v = [];
  s && u ? v = [u] : o && m ? v = Ve({ matchUpFilters: { matchUpTypes: [ot] }, structure: m })?.matchUps ?? [] : i ? v = hr({ matchUpFilters: { matchUpTypes: [ot] }, drawDefinition: i })?.matchUps ?? [] : l && (v = Rn({ matchUpFilters: { matchUpTypes: [ot] } })?.matchUps ?? []);
  let D = (v || []).filter((R) => {
    let M = R.tieMatchUps?.filter((A) => A.collectionId === a)?.some(Bt), E = t && R.tieFormat ? jn({ descendant: R.tieFormat, ancestor: h })?.different : !1;
    return e && !M || !R.winningSide && R.matchUpStatus !== vt && (e || R.matchUpStatus !== Ri && !Bt(R) && !E);
  });
  if (!D.length) return { error: Hs };
  let { appliedPolicies: y } = _e({ tournamentRecord: r });
  if (s && u && e) {
    let R = u.tieMatchUps?.filter((M) => M.collectionId === a);
    for (let M of R ?? []) {
      let E = Ic({ matchUpId: M.matchUpId, tieMatchUpId: u?.matchUpId, winningSide: void 0, removeScore: !0, tournamentRecord: r, appliedPolicies: y, drawDefinition: i, event: l });
      if (E.error || (E = ut({ drawDefinition: i, matchUpId: s }), E.error)) return E;
      u = E?.matchUp;
    }
  }
  let w = [];
  for (let R of D) {
    for (let M of R?.sides ?? []) M.lineUp = (M.lineUp ?? []).map((E) => ({ participantId: E.participantId, collectionAssignments: (E?.collectionAssignments ?? []).filter((A) => A.collectionId !== a) }));
    if (R.tieMatchUps = (R.tieMatchUps ?? []).filter((M) => {
      let E = M.collectionId === a;
      return E && w.push(M.matchUpId), !E;
    }), R.tieFormat && (R.tieFormat = er(h)), e) {
      let M = zn({ matchUpId: R.matchUpId, exitWhenNoValues: !0, tournamentRecord: r, appliedPolicies: y, drawDefinition: i, event: l });
      if (M.error) return M;
    }
    Oe({ tournamentId: r?.tournamentId, eventId: l?.eventId, drawDefinition: i, context: d, matchUp: R });
  }
  w.length && bn({ tournamentId: r?.tournamentId, matchUpIds: w, eventId: l?.eventId, drawDefinition: i });
  let b = ae(h);
  if (p = wr({ tieFormat: b }), p.error) return F({ result: p, stack: d });
  if (c && l) l.tieFormat = b;
  else if (s && u) u.tieFormat = b;
  else if (m) m.tieFormat = b;
  else if (i) i.tieFormat = b;
  else if (!u || !i) return { error: ne };
  tt({ drawDefinition: i, eventId: l?.eventId });
  let T = ae({ drawId: i?.drawId, action: d, collectionId: a, structureId: o, matchUpId: s, eventId: c });
  return Rm({ appliedPolicies: y, drawDefinition: i, auditData: T }), { tieFormat: b, deletedMatchUpIds: w, targetMatchUps: D, ...x };
}
function CE({ updateInProgressMatchUps: e = !0, tournamentRecord: t, groupDefinition: r, drawDefinition: i, collectionIds: n, tieFormatName: a, structureId: o, matchUpId: s, matchUp: c, eventId: u, event: l }) {
  let d = "addCollectionGroup";
  if (!Array.isArray(n)) return F({ result: { error: ue }, stack: d });
  let p = c ? void 0 : ja({ drawDefinition: i, structureId: o, matchUpId: s, eventId: u, event: l });
  if (p?.error) return F({ result: p, stack: d });
  let m = p?.structure;
  c = c || p?.matchUp;
  let f = p?.tieFormat, h = f?.winCriteria.valueGoal, g = er(f);
  if (p = wr({ tieFormat: g }), p.error) return F({ result: p, stack: d });
  for (let U of g.collectionDefinitions) {
    let { collectionId: S, collectionGroupNumber: P } = U;
    if (P && n.includes(S)) return F({ info: "collectionIds cannot be part of other collectionGroups", result: { error: z }, stack: d });
  }
  let I = (g.collectionGroups || []).reduce((U, S) => S.groupNumber > U ? S.groupNumber : U, 0) + 1;
  return r.groupNumber = I, g.collectionDefinitions = g.collectionDefinitions.map((U) => n.includes(U.collectionId) ? { ...U, collectionGroupNumber: I } : U), g.collectionGroups = [...g.collecitonGroups || [], r], RE({ updateInProgressMatchUps: e, originalValueGoal: h, tournamentRecord: t, drawDefinition: i, tieFormatName: a, structureId: o, structure: m, tieFormat: g, matchUpId: s, matchUp: c, eventId: u, event: l });
}
function pS({ updateInProgressMatchUps: e = !0, collectionDefinition: t, referenceCategory: r, tournamentRecord: i, policyDefinitions: n, enforceCategory: a, referenceGender: o, drawDefinition: s, tieFormatName: c, enforceGender: u, structureId: l, matchUpId: d, matchUp: p, eventId: m, uuids: f, event: h }) {
  let g = "addCollectionDefinition", I = _e({ tournamentRecord: i, drawDefinition: s, event: h }).appliedPolicies ?? {}, U = n?.[Yt] ?? I?.[Yt];
  a = a ?? U?.participants?.enforceCategory;
  let S = (u ?? U?.participants?.enforceGender) !== !1, P = !!((r ?? h?.category) && a !== !1), v = !!((o ?? h?.gender) && S), D = Pu({ referenceCategory: r ?? h?.category, collectionDefinition: t, referenceGender: o, checkCategory: P, checkGender: v, event: h });
  if (D.error) return F({ result: D, stack: g });
  let y = p?.tieFormat ? void 0 : ja({ drawDefinition: s, structureId: l, matchUpId: d, eventId: m, event: h });
  if (y?.error) return F({ result: { error: y.error }, stack: g });
  let w = y?.structure;
  p = p ?? y?.matchUp;
  let b = p?.tieFormat ?? y?.tieFormat, T = er(b);
  if (y = wr({ tieFormat: T }), y?.error) return F({ result: { error: y.error }, stack: g });
  if (!t.collectionId) t.collectionId = je();
  else if (T.collectionDefinitions.map(({ collectionId: B }) => B).includes(t.collectionId)) return F({ context: { collectionId: t.collectionId }, result: { error: yP } });
  T.collectionDefinitions.push(t), T.collectionDefinitions.sort((B, L) => (B.collectionOrder || 0) - (L.collectionOrder || 0)).forEach((B, L) => B.collectionOrder = L + 1);
  let { aggregateValue: R, valueGoal: M } = ts(T);
  T.winCriteria = ae({ aggregateValue: R, valueGoal: M });
  let E = b?.winCriteria.valueGoal, A = b?.winCriteria.aggregateValue;
  (E && E !== M || R && !A) && (c ? T.tieFormatName = c : delete T.tieFormatName);
  let N = [], C = [], k = [], O = ae(T);
  if (y = wr({ tieFormat: O }), y?.error) return F({ result: { error: y.error }, stack: g });
  if (m && h) {
    h.tieFormat = O;
    for (let B of h.drawDefinitions ?? []) if (!B.tieFormat) for (let L of B.structures ?? []) {
      if (L.tieFormat) continue;
      let j = Ym({ updateInProgressMatchUps: e, collectionDefinition: t, structure: L, uuids: f });
      C.push(...j.newMatchUps), k.push(...j.targetMatchUps), N.push(L.structureId);
    }
    Rl({ modifiedMatchUps: k, eventId: h?.eventId, modifiedStructureIds: N, tournamentRecord: i, drawDefinition: s, addedMatchUps: C, stack: g });
  } else if (l && w) {
    w.tieFormat = O;
    let B = Ym({ updateInProgressMatchUps: e, collectionDefinition: t, structure: w, uuids: f });
    C.push(...B.newMatchUps), k = B.targetMatchUps, Rl({ modifiedMatchUps: k, eventId: h?.eventId, modifiedStructureIds: N, tournamentRecord: i, drawDefinition: s, addedMatchUps: C, stack: g });
  } else if (d && p) {
    if (!Td({ matchUp: p, updateInProgressMatchUps: e })) return F({ result: { error: gh }, stack: g });
    p.tieFormat = O;
    let B = rl({ collectionDefinition: t, matchUp: p, uuids: f });
    Array.isArray(p.tieMatchUps) || (p.tieMatchUps = []), p.tieMatchUps.push(...B), C.push(...B), Rl({ modifiedMatchUps: [p], eventId: h?.eventId, modifiedStructureIds: N, tournamentRecord: i, drawDefinition: s, addedMatchUps: C, stack: g });
  } else if (s) {
    s.tieFormat = O;
    for (let B of s.structures ?? []) {
      let L = Ym({ updateInProgressMatchUps: e, collectionDefinition: t, structure: B, uuids: f });
      N.push(B.structureId), C.push(...L.newMatchUps), k.push(...L.targetMatchUps);
    }
    Rl({ modifiedMatchUps: k, eventId: h?.eventId, tournamentRecord: i, drawDefinition: s, addedMatchUps: C, stack: g });
  } else return { error: ne };
  let _ = ae({ drawId: s?.drawId, collectionDefinition: t, action: g, structureId: l, matchUpId: d, eventId: m });
  return Rm({ appliedPolicies: I, drawDefinition: s, auditData: _ }), { tieFormat: O, targetMatchUps: k, addedMatchUps: C, ...x };
}
function Ym({ updateInProgressMatchUps: e, collectionDefinition: t, structure: r, uuids: i }) {
  let n = [], a = (Ve({ matchUpFilters: { matchUpTypes: [ot] }, structure: r })?.matchUps).filter((o) => Td({ matchUp: o, updateInProgressMatchUps: e }) && !o.tieFormat);
  for (let o of a) {
    let s = rl({ collectionDefinition: t, matchUp: o, uuids: i });
    Array.isArray(o.tieMatchUps) || (o.tieMatchUps = []), o.tieMatchUps.push(...s), n.push(...s);
  }
  return { newMatchUps: n, targetMatchUps: a };
}
function Rl({ modifiedStructureIds: e, tournamentRecord: t, modifiedMatchUps: r, drawDefinition: i, addedMatchUps: n, eventId: a, stack: o }) {
  oa({ tournamentId: t?.tournamentId, matchUps: n, drawDefinition: i, eventId: a }), r?.forEach((s) => {
    Oe({ tournamentId: t?.tournamentId, drawDefinition: i, context: o, matchUp: s, eventId: a });
  }), tt({ structureIds: e, drawDefinition: i, eventId: a });
}
function OE({ updateInProgressMatchUps: e = !1, tieFormatComparison: t, modifiedTieFormat: r, tournamentRecord: i, considerations: n, drawDefinition: a, structureId: o, matchUpId: s, eventId: c, uuids: u, event: l }) {
  let d = "modifyTieFormat";
  if (!wr({ tieFormat: r }).valid) return F({ result: { error: cn }, info: "falied validation", stack: d });
  let p = ja({ drawDefinition: a, structureId: o, matchUpId: s, eventId: c, event: l });
  if (p.error) return F({ result: p, stack: d });
  let { matchUp: m, tieFormat: f } = p, h = er(f), g = jn({ descendant: r, ancestor: h, considerations: n });
  if (g.invalid) return F({ context: { invalid: g.invalid }, result: { error: cn }, stack: d });
  if (!g?.different) return F({ result: { ...x }, info: "Nothing to do", stack: d });
  let I = h.collectionDefinitions.map(({ collectionId: b }) => b), U = r.collectionDefinitions.map(({ collectionId: b }) => b), S = I.filter((b) => !U.includes(b)), P = r.collectionDefinitions.filter(({ collectionId: b }) => !I.includes(b)), v = P.map(qr("collectionId")), D = [], y, w = r.tieFormatName;
  for (let b of r.collectionDefinitions) {
    if (v.includes(b.collectionId)) continue;
    let T = lS({ updateInProgressMatchUps: e, ...b, tournamentRecord: i, tieFormatName: w, drawDefinition: a, structureId: o, matchUpId: s, eventId: c, event: l });
    if (T.modifications && D.push(...T.modifications), T.error) return F({ result: T, stack: d });
    T.tieFormat && (y = T.tieFormat);
  }
  for (let b of P) {
    let T = pS({ updateInProgressMatchUps: e, collectionDefinition: b, tournamentRecord: i, drawDefinition: a, tieFormatName: w, structureId: o, matchUpId: s, matchUp: m, eventId: c, uuids: u, event: l });
    if (T.error) return F({ result: T, stack: d });
    T.tieFormat && (y = T.tieFormat);
  }
  for (let b of S) {
    let T = dS({ updateInProgressMatchUps: e, tieFormatComparison: t, tournamentRecord: i, drawDefinition: a, tieFormatName: w, collectionId: b, structureId: o, matchUpId: s, eventId: c, matchUp: m, event: l });
    if (T.error) return F({ result: T, stack: d });
    T.tieFormat && (y = T.tieFormat);
  }
  return f?.tieFormatName !== w ? (y.tieFormatName = w, D.push({ tieFormatName: w })) : (D.length || v.length || S.length) && (delete y.tieFormatName, D.push("tieFormatName removed: modifications without new tieFormatName")), y.collectionDefinitions = y.collectionDefinitions.sort((b, T) => gs(b.collectionOrder) - gs(T.collectionOrder)).map((b, T) => ({ ...b, collectionOrder: T + 1 })), { processedTieFormat: er(y), modifications: D, ...x };
}
function kE({ tournamentRecord: e }) {
  if (!e) return { error: J };
  let t = 0;
  for (let r of e.events ?? []) {
    let i = r.tieFormats ?? [], n = (u) => {
      if (!u.tieFormat) return;
      let l;
      for (let d of i) jn({ descendant: u.tieFormat, ancestor: d }).different || (l = d.tieFormatId);
      if (l) u.tieFormatId = l, delete u.tieFormat;
      else {
        let d = ie(u.tieFormat, void 0, !0);
        d.tieFormatId || (d.tieFormatId = je()), u.tieFormatId = d.tieFormatId, delete u.tieFormat, i.push(d), t += 1;
      }
    };
    r.eventType, n({ tieFormat: r.tieFormat });
    for (let u of r.drawDefinitions ?? []) {
      n({ tieFormat: u.tieFormat });
      for (let l of u.structures ?? []) n({ tieFormat: l.tieFormat });
    }
    let a = (u, l) => {
      let d = s.matchUps?.find((p) => p.matchUpId === u);
      d && (d.tieFormatId = l, delete d.tieFormat, Oe({ tournamentId: e?.tournamentId, eventId: r.eventId, matchUp: d }));
    }, o = (u) => {
      let l = ie(u.tieFormat, void 0, !0);
      l.tieFormatId || (l.tieFormatId = je()), i.push(l), t += 1, a(u.matchUpId, l.tieFormatId);
    }, s = Rn({ matchUpFilters: { matchUpTypes: [Hr] }, event: r }), c = s.matchUps ?? [];
    for (let u of c) {
      let l;
      for (let d of i) u.tieFormat && jn({ descendant: u.tieFormat, ancestor: d }).different || (l = d.tieFormatId);
      l ? a(u.matchUpId, l) : o(u);
    }
    i.length && (r.tieFormats = i);
  }
  return { ...x, addedCount: t };
}
var xE = {};
Me(xE, { addDrawDefinitionExtension: () => ip, addEventExtension: () => ma, addEventTimeItem: () => Jo, addExtension: () => Be, addNotes: () => Ap, addOnlineResource: () => GE, addParticipantExtension: () => WD, addParticipantTimeItem: () => vI, addTimeItem: () => an, addTournamentExtension: () => rg, addTournamentTimeItem: () => sl, analyzeDraws: () => cl, analyzeTournament: () => iU, copyTournamentRecord: () => LE, createTournamentRecord: () => Tm, generate: () => FE, getAggregateTeamResults: () => rU, getAllowedDrawTypes: () => zp, getAllowedMatchUpFormats: () => ZI, getAppliedPolicies: () => _e, getCompetitionDateRange: () => Kp, getCompetitionPenalties: () => eU, getPolicyDefinitions: () => Wn, getTournamentInfo: () => es, getTournamentPenalties: () => Yp, getTournamentPersons: () => tU, getTournamentPoints: () => Qp, getTournamentStructures: () => rI, getTournamentTimeItem: () => fp, mutate: () => _E, query: () => VM, removeDrawDefinitionExtension: () => HD, removeEventExtension: () => np, removeExtension: () => fr, removeNotes: () => II, removeOnlineResource: () => jE, removeParticipantExtension: () => zD, removeTournamentExtension: () => ig, setTournamentCategories: () => WE, setTournamentDates: () => Nm, setTournamentEndDate: () => zE, setTournamentName: () => $E, setTournamentNotes: () => qE, setTournamentStartDate: () => HE, setTournamentStatus: () => VE });
var FE = {};
Me(FE, { copyTournamentRecord: () => LE, createTournamentRecord: () => Tm });
function LE(e) {
  let t = oe(e, [{ tournamentRecord: !0, startDate: !0, endDate: !1, tournamentName: !0 }]);
  if (t.error) return t;
  let { startDate: r, endDate: i } = e.tournamentRecord, n = 1440 * 60 * 1e3, a = (r && i ? new Date(ve(i)).getTime() - new Date(ve(r)).getTime() : 0) / n, o = e.endDate || _h(e.startDate, a), s = (p) => p?.filter(({ itemType: m }) => e.itemTypeList?.includes(m)), c = (p) => p?.filter(({ name: m }) => e.extensionList?.includes(m)), u = (p) => {
    let { timeItems: m, extensions: f, ...h } = p;
    return ie({ ...h, timeItems: s(m), extensions: c(f) }, !1, !0);
  }, l = (p) => {
    let { drawDefinitions: m, timeItems: f, extensions: h, startDate: g, endDate: I, ...U } = p;
    return ie({ extensions: c(h), timeItems: s(f), startDate: e.startDate, endDate: o, ...U }, !1, !0);
  }, d = { participants: e.copyParticipants ? e.tournamentRecord.participants?.map(u) ?? [] : [], parentOrganisation: ie({ ...e.tournamentRecord.parentOrganisation }, !1, !0), venues: ie(e.tournamentRecord.venues ?? [], !1, !0), extensions: c(e.tournamentRecord.extensions), timeItems: s(e.tournamentRecord.timeItems), events: e.tournamentRecord.events?.map(l) ?? [], weekdays: [...e.tournamentRecord.weekdays ?? []], tournamentName: e.tournamentName, startDate: e.startDate, tournamentId: je(), endDate: o };
  return { ...x, tournamentRecord: d };
}
var _E = {};
Me(_E, { addDrawDefinitionExtension: () => ip, addEventExtension: () => ma, addEventTimeItem: () => Jo, addExtension: () => Be, addNotes: () => Ap, addOnlineResource: () => GE, addParticipantExtension: () => WD, addParticipantTimeItem: () => vI, addTimeItem: () => an, addTournamentExtension: () => rg, addTournamentTimeItem: () => sl, removeDrawDefinitionExtension: () => HD, removeEventExtension: () => np, removeExtension: () => fr, removeNotes: () => II, removeOnlineResource: () => jE, removeParticipantExtension: () => zD, removeTournamentExtension: () => ig, setTournamentCategories: () => WE, setTournamentDates: () => Nm, setTournamentEndDate: () => zE, setTournamentName: () => $E, setTournamentNotes: () => qE, setTournamentStartDate: () => HE, setTournamentStatus: () => VE });
var O2 = "ABANDONED", k2 = "ACTIVE", x2 = "CANCELLED", F2 = "COMPLETED", L2 = "IN_PROGRESS", BE = { ABANDONED: O2, ACTIVE: k2, CANCELLED: x2, COMPLETED: F2, IN_PROGRESS: L2 };
function VE({ tournamentRecord: e, status: t }) {
  return e ? t && !Object.keys(BE).includes(t) ? { error: z, info: "Unknown status" } : (e.tournamentStatus = t, { ...x }) : { error: J };
}
function jE(e) {
  let t = oe(e, [{ tournamentRecord: !0, onlineResource: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, onlineResource: i, organisationId: n, participantId: a, personId: o, courtId: s, venueId: c } = e;
  if (n) {
    if (r.parentOrganisation?.parentOrganisationId !== n) return F({ result: { error: Kt } });
    os({ element: r.parentOrganisation, onlineResource: i });
  } else if (a || o) {
    let u = (r.participants ?? []).find((l) => o && l.person?.personId === o || l.participantId === a);
    if (!u) return F(o ? { result: { error: Kt } } : { result: { error: Tt } });
    if (o) {
      if (u.person?.personId !== o) return F({ result: { error: Eo } });
      os({ element: u.person, onlineResource: i });
    } else os({ element: u, onlineResource: i });
  } else if (s) {
    let u = (r.venues ?? []).filter((l) => !c || l.venueId === c).flatMap((l) => (l.courts ?? []).filter((d) => d.courtId === s))?.[0];
    if (!u) return F({ result: { error: Ws } });
    os({ element: u, onlineResource: i });
  } else if (c) {
    let u = (r.venues ?? []).find((l) => l.venueId === c);
    if (!u) return F({ result: { error: Co } });
    os({ element: u, onlineResource: i });
  } else os({ element: r, onlineResource: i }), Se({ payload: { parentOrganisation: r.parentOrganisation, onlineResources: r.onlineResources, tournamentId: r.tournamentId }, topic: za });
  return { ...x };
}
function os({ element: e, onlineResource: t }) {
  let r = (e.onlineResources ?? []).filter((i) => !(i?.[vs] === t[vs] && i?.[Ps] === t[Ps] && i?.[Ds] === t[Ds]));
  e.onlineResources = r;
}
function GE(e) {
  let t = oe(e, [{ tournamentRecord: !0, onlineResource: !0 }]);
  if (t.error) return t;
  let { tournamentRecord: r, onlineResource: i, organisationId: n, participantId: a, personId: o, courtId: s, venueId: c } = e;
  if (n) {
    if (r.parentOrganisation?.parentOrganisationId !== n) return F({ result: { error: Kt } });
    ss({ element: r.parentOrganisation, onlineResource: i });
  } else if (a || o) {
    let u = (r.participants ?? []).find((l) => o && l.person?.personId === o || l.participantId === a);
    if (!u) return F(o ? { result: { error: Kt } } : { result: { error: Tt } });
    if (o) {
      if (u.person?.personId !== o) return F({ result: { error: Eo } });
      ss({ element: u.person, onlineResource: i });
    } else ss({ element: u, onlineResource: i });
  } else if (s) {
    let u = (r.venues ?? []).filter((l) => !c || l.venueId === c).flatMap((l) => (l.courts ?? []).filter((d) => d.courtId === s))?.[0];
    if (!u) return F({ result: { error: Ws } });
    ss({ element: u, onlineResource: i });
  } else if (c) {
    let u = (r.venues ?? []).find((l) => l.venueId === c);
    if (!u) return F({ result: { error: Co } });
    ss({ element: u, onlineResource: i });
  } else ss({ element: r, onlineResource: i }), Se({ payload: { parentOrganisation: r.parentOrganisation, onlineResources: r.onlineResources, tournamentId: r.tournamentId }, topic: za });
  return { ...x };
}
function ss({ element: e, onlineResource: t }) {
  let r = (e.onlineResources ?? []).filter((i) => i?.[vs] !== t[vs] && i?.[Ps] !== t[Ps] && i?.[Ds] !== t[Ds]);
  return r.push(t), e.onlineResources = r, { ...x };
}
function $E({ tournamentRecord: e, promotionalName: t, tournamentName: r, formalName: i }) {
  if (!e) return { error: J };
  let n = e.tournamentId, a = { tournamentId: n };
  return r && r !== e.tournamentName && (e.tournamentName = r, a.tournamentName = r), t && t !== e.promotionalName && (e.promotionalName = t, a.promotionalName = t), i && i !== e.formalName && (e.formalName = i, a.formalName = i), e.promotionalName === e.tournamentName && (delete e.promotionalName, a.promotionalName = ""), e.formalName === e.tournamentName && (delete e.formalName, a.formalName = ""), Object.keys(a).length > 1 && Se({ topic: za, payload: { parentOrganisation: e.parentOrganisation, tournamentId: n, ...a } }), { ...x };
}
function qE({ tournamentRecord: e, notes: t }) {
  if (!e) return { error: J };
  let r = t ? Ap({ element: e, notes: t }) : II({ element: e });
  return r.error ? r : (Se({ topic: za, payload: { parentOrganisation: e.parentOrganisation, tournamentId: e.tournamentId, notes: t ?? "" } }), { ...x });
}
function WE({ tournamentRecord: e, categories: t }) {
  return e ? (t = (t || []).filter((r) => r.categoryName && r.type), e.tournamentCategories = t, Se({ topic: za, payload: { parentOrganisation: e.parentOrganisation, tournamentId: e.tournamentId, categories: t } }), { ...x }) : { error: J };
}
function _2({ tournamentRecord: e }) {
  if (!e) return { error: J };
  let { startDate: t, endDate: r } = e, i = ys(t, r), n = [];
  for (let a of e.venues || []) a?.courts?.length && n.push(...a.courts);
  for (let a of n) {
    let { startTime: o, endTime: s } = (a.dateAvailability ?? []).reduce((l, d) => {
      let p = Le(l.startTime), m = Le(l.endTime);
      return d.startTime && Le(d.startTime) < p && (l.startTime = d.startTime), d.endTime && Le(d.endTime) > m && (l.endTime = d.endTime), l;
    }, { startTime: "08:00", endTime: "18:00" }), c = i.map((l) => a.dateAvailability?.find((d) => d.date === l) ?? { date: l, startTime: o, endTime: s }), u = a.dateAvailability?.find((l) => !l.date);
    u && c.unshift(u), a.dateAvailability = c;
  }
  return { ...x };
}
function Nm(e) {
  let { tournamentRecord: t, startDate: r, endDate: i, weekdays: n } = e, a = e.activeDates?.filter(Boolean), o = oe(e, [{ tournamentRecord: !0 }, { [tr]: (m) => Yi.test(m), [Kr]: Ht, startDate: !1, endDate: !1 }, { [tr]: (m) => m.filter(Boolean).every((f) => Yi.test(f)), [Kr]: Ht, activeDates: !1 }, { [tr]: DR, weekdays: !1 }]);
  if (o.error) return o;
  if (i && r && new Date(i) < new Date(r)) return { error: z };
  if (i && r && new Date(r) > new Date(i)) return { error: z };
  if (a?.length) {
    let m = r || t.startDate, f = i || t.endDate, h = !m || a.every((I) => new Date(I) >= new Date(m)), g = !f || a.every((I) => new Date(I) <= new Date(f));
    if (!h || !g) return { error: Ht };
  }
  let s;
  (r && t.startDate && new Date(r) > new Date(t.startDate) || i && t.endDate && new Date(i) < new Date(t.endDate)) && (s = !0);
  let c = ys(t.startDate, t.endDate);
  r && (t.startDate = r), i && (t.endDate = i);
  let u = ys(t.startDate, t.endDate), l = c.filter((m) => !u.includes(m)), d = u.filter((m) => !c.includes(m));
  for (let m of t.events ?? []) r && m.startDate && new Date(m.startDate) < new Date(r) && (m.startDate = r), i && m.startDate && new Date(m.startDate) > new Date(i) && (m.startDate = r ?? i), i && m.endDate && new Date(m.endDate) > new Date(i) && (m.endDate = i), r && m.endDate && new Date(m.endDate) < new Date(r) && (m.endDate = i ?? r);
  r && t.endDate && new Date(r) > new Date(t.endDate) && (t.endDate = r), i && t.startDate && new Date(i) < new Date(t.startDate) && (t.startDate = i), a && (t.activeDates = a), n && (t.weekdays = n);
  let p = s && B2({ tournamentRecord: t })?.unscheduledMatchUpIds;
  return _2({ tournamentRecord: t }), Se({ payload: ae({ parentOrganisation: t.parentOrganisation, tournamentId: t.tournamentId, activeDates: a, startDate: r, weekdays: n, endDate: i }), topic: za }), { ...x, unscheduledMatchUpIds: p, datesAdded: d, datesRemoved: l };
}
function HE({ tournamentRecord: e, startDate: t }) {
  return t ? Nm({ tournamentRecord: e, startDate: t }) : { error: Ht };
}
function zE({ tournamentRecord: e, endDate: t }) {
  return t ? Nm({ tournamentRecord: e, endDate: t }) : { error: Ht };
}
function B2({ tournamentRecord: e }) {
  let t = Jt({ tournamentRecord: e }).matchUps ?? [], r = e.startDate && new Date(e.startDate), i = e.endDate && new Date(e.endDate), n = [], a = [];
  for (let o of t) {
    let { schedule: s, matchUpId: c } = o;
    if (s && s.scheduledDate) {
      let u = new Date(s.scheduledDate);
      (r && u < r || i && u > i) && (a.push(c), n.includes(s.scheduledDate) || n.push(s.scheduledDate));
    }
  }
  return n.length && !Dm({ scheduledDates: n, tournamentRecord: e }).clearedScheduleCount ? { error: yv } : { unscheduledMatchUpIds: a };
}
var YE = {};
Me(YE, { addCourt: () => Mm, addCourts: () => oS, addVenue: () => $u, deleteCourt: () => iA, deleteVenue: () => gS, deleteVenues: () => JE, disableCourts: () => ZE, disableVenues: () => eA, enableCourts: () => tA, enableVenues: () => rA, generate: () => KE, generateCourts: () => kU, getCompetitionVenues: () => pl, getCourts: () => yU, getVenuesAndCourts: () => Yn, modifyCourt: () => IS, modifyCourtAvailability: () => fS, modifyVenue: () => nA, mutate: () => QE, publicFindVenue: () => xg, query: () => iR });
var KE = {};
Me(KE, { generateCourts: () => kU });
var QE = {};
Me(QE, { addCourt: () => Mm, addCourts: () => oS, addVenue: () => $u, deleteCourt: () => iA, deleteVenue: () => gS, deleteVenues: () => JE, disableCourts: () => ZE, disableVenues: () => eA, enableCourts: () => tA, enableVenues: () => rA, modifyCourt: () => IS, modifyCourtAvailability: () => fS, modifyVenue: () => nA });
function mS(e) {
  if (!e?.tournamentRecord && !Array.isArray(e?.venueMatchUps)) return { error: J };
  if (!e?.courtId) return { error: No };
  let { scheduleVisibilityFilters: t, tournamentRecord: r, matchUpFilters: i, venueMatchUps: n, courtId: a } = e, { schedulingProfile: o } = Kn({ tournamentRecord: r });
  if (Array.isArray(n)) return { matchUps: c({ matchUps: n, courtId: a }) };
  let { matchUps: s } = Jt({ scheduleVisibilityFilters: t, tournamentRecord: r, matchUpFilters: i });
  return { matchUps: c({ matchUps: s, courtId: a }) };
  function c({ matchUps: u, courtId: l }) {
    let d = u.filter((p) => {
      let m = p.schedule?.allocatedCourts?.map(({ courtId: f }) => f);
      return p.schedule?.courtId === l || m?.includes(l);
    });
    return Ud({ matchUps: d, schedulingProfile: o });
  }
}
function V2({ scheduleVisibilityFilters: e, tournamentRecord: t, matchUpFilters: r, venueId: i }) {
  if (!t) return { error: J };
  if (!i) return { error: da };
  let { schedulingProfile: n } = Kn({ tournamentRecord: t }), { matchUps: a } = Jt({ scheduleVisibilityFilters: e, tournamentRecord: t, matchUpFilters: r });
  return { matchUps: o({ matchUps: a, venueId: i }) };
  function o({ matchUps: s, venueId: c }) {
    let u = s.filter((l) => {
      let d = l.schedule?.allocatedCourts?.map(({ venueId: p }) => p);
      return l.schedule?.venueId === c || d?.includes(c);
    });
    return Ud({ matchUps: u, schedulingProfile: n });
  }
}
function fS({ tournamentRecord: e, dateAvailability: t, disableNotice: r, venueMatchUps: i, courtId: n, force: a }) {
  if (!e) return { error: J };
  if (!n) return { error: No };
  let o = EN({ dateAvailability: t });
  if (o.error) return o;
  let { updatedDateAvailability: s, totalMergeCount: c } = j2(t);
  t = s;
  let u = Wo({ tournamentRecord: e, courtId: n });
  if (u.error) return u;
  let { court: l, venue: d } = u, { matchUps: p } = mS({ tournamentRecord: e, venueMatchUps: i, courtId: n });
  if (p?.length) {
    let m = _e({ tournamentRecord: e })?.appliedPolicies, f = a ?? m?.[pa]?.allowDeletionWithScoresPresent?.courts, h = [];
    h.length && (f || console.log("throw error: scheduled court matchUps", h.length));
  }
  return l && (l.dateAvailability = t, !r && d && Se({ payload: { venue: d, tournamentId: e.tournamentId }, topic: Ya, key: d.venueId })), { ...x, totalMergeCount: c };
}
function j2(e) {
  let t = 0, r = e.reduce((n, a) => {
    let { date: o, startTime: s, endTime: c, bookings: u } = a;
    return n[o] || (n[o] = []), n[o].push({ startTime: s, endTime: c, bookings: u }), n;
  }, {}), i = [];
  return Object.keys(r).forEach((n) => {
    r[n].sort(a2);
    let { mergedAvailability: a, mergeCount: o } = G2(r[n]);
    i.push(...a.map((s) => ({ date: n, ...s }))), t += o;
  }), { updatedDateAvailability: i, totalMergeCount: t };
}
function G2(e) {
  let t, r, i, n = e.length, a = 0, o = [];
  for (; e.length && n; ) {
    let c = e.shift(), { startTime: u, endTime: l, bookings: d } = c;
    if (n -= 1, !t) t = u, i = d, r = l;
    else if (yu(Nt(r), Nt(u), !1) > 0) {
      let p = { startTime: t, endTime: r };
      i?.length && (p.bookings = i), o.push(p), t = u, i = d, r = l;
    } else d && (i ? i.push(d) : i = d), r = l, a += 1;
  }
  let s = { startTime: t, endTime: r };
  return i?.length && (s.bookings = i), o.push(s), { mergedAvailability: o, mergeCount: a };
}
function hS({ matchUpsCount: e = 0 }) {
  let t = `Schedule would be deleted from ${e} ${e === 1 ? "matchUp" : "matchUps"}; use { force: true }`;
  return { error: TP, info: t };
}
function XE({ tournamentRecord: e, drawDefinition: t, matchUpId: r, drawId: i }) {
  let n = "removeCourtAssignment";
  if (!r) return { error: pr };
  if (!t && !i) return { error: Vi };
  let a;
  if (!t) {
    if (!e) return { error: J };
    ({ drawDefinition: t } = br({ tournamentRecord: e, drawId: i }));
  }
  if (t) ({ matchUp: a } = ut({ drawDefinition: t, matchUpId: r }));
  else {
    if (!e) return { error: J };
    let o = Jt({ tournamentRecord: e, inContext: !1 }).matchUps ?? [];
    ({ matchUp: a } = cb({ matchUps: o, matchUpId: r }));
  }
  return a ? (a.timeItems && a.timeItems.find((o) => [ca, Dn].includes(o.itemType)) && (a.timeItems = a.timeItems.filter(({ itemType: o }) => ![ca, Dn].includes(o)), Oe({ tournamentId: e?.tournamentId, context: n, drawDefinition: t, matchUp: a })), { ...x }) : { error: cr };
}
function gS(e) {
  if (typeof e?.venueId != "string") return { error: da };
  let { tournamentRecord: t, venueId: r, force: i } = e, n = e.tournamentRecords || t && { [t.tournamentId]: t } || {};
  if (!Object.keys(n).length) return { error: J };
  let a = Bi({ tournamentRecords: n, contextFilters: { venueIds: [r] } }).matchUps ?? [], o = _e({ tournamentRecord: t })?.appliedPolicies, s = i ?? o?.[pa]?.allowDeletionWithScoresPresent?.venues;
  if (!a.length || s) for (let c of Object.values(n)) {
    for (let l of a) {
      let d = XE({ matchUpId: l.matchUpId, drawId: l.drawId, tournamentRecord: c });
      if (d.error) return d;
    }
    let u;
    c.venues = (c.venues ?? []).filter((l) => l?.venueId !== r ? !0 : (u = !0, !1)), u && Se({ payload: { venueId: r, tournamentId: c.tournamentId }, topic: mg, key: r });
  }
  else return hS({ matchUpsCount: a.length });
  return fl({ tournamentRecords: n }), { ...x };
}
function JE({ tournamentRecord: e, venueIds: t, force: r }) {
  if (!e) return { error: J };
  if (!Array.isArray(t)) return { error: z };
  for (let i of e.venues || []) {
    let { venueId: n } = i;
    if (t.includes(n)) {
      let { venueId: a } = i, o = gS({ tournamentRecord: e, venueId: a, force: r });
      if (o.error) return o;
    }
  }
  return { ...x };
}
function ZE(e) {
  let { courtIds: t, dates: r } = e, i = ui(e), n = [{ [ur]: !0, [tp]: !0 }], a = oe(e, n);
  if (a.error) return a;
  for (let o of Object.values(i)) $2({ tournamentRecord: o, courtIds: t, dates: r });
  return { ...x };
}
function $2({ tournamentRecord: e, courtIds: t, dates: r }) {
  let i = Array.isArray(r) && r.length ? { dates: r } : !0, n = (a) => Be({ extension: { value: i, name: ki }, creationTime: !1, element: a });
  for (let a of e.venues || []) for (let o of a.courts || []) if (t?.includes(o.courtId)) {
    let s = n(o);
    if (s.error) return s;
  }
  return { ...x };
}
function eA(e) {
  let { tournamentRecords: t, tournamentId: r, venueIds: i } = e, n = [{ [ur]: !0, [rp]: !0 }], a = oe(e, n);
  if (a.error) return a;
  let o = Object.keys(t).filter((s) => !r || s === r);
  for (let s of o) {
    let c = t[s];
    q2({ tournamentRecord: c, venueIds: i });
  }
  return { ...x };
}
function q2({ tournamentRecord: e, venueIds: t }) {
  for (let r of e.venues || []) if (t?.includes(r.venueId)) {
    let i = Be({ creationTime: !1, element: r, extension: { name: ki, value: !0 } });
    if (i.error) return i;
  }
  return { ...x };
}
function tA(e) {
  let t = ui(e), r = [{ [ur]: !0 }];
  !e.enableAll && r.push({ [tp]: !0 });
  let i = oe(e, r);
  if (i.error) return i;
  let { enableAll: n, courtIds: a, dates: o } = e;
  for (let s of Object.values(t)) W2({ tournamentRecord: s, courtIds: a, enableAll: n, dates: o });
  return { ...x };
}
function W2({ tournamentRecord: e, courtIds: t, enableAll: r, dates: i }) {
  for (let n of e.venues || []) for (let a of n.courts || []) if (r || t?.includes(a.courtId)) if (Array.isArray(i)) {
    let { extension: o } = we({ element: a, name: ki });
    if (o) {
      let s = o.value;
      Array.isArray(s.dates) && (s.dates = s.dates.filter((c) => !i.includes(c))), Be({ extension: { name: ki, value: s }, creationTime: !1, element: a });
    }
  } else fr({ element: a, name: ki });
  return { ...x };
}
function rA(e) {
  let t = ui(e), r = [{ [ur]: !0 }];
  !e.enableAll && r.push({ [rp]: !0 });
  let i = oe(e, r);
  if (i.error) return i;
  let { venueIds: n, enableAll: a } = e;
  for (let o of Object.values(t)) for (let s of o.venues || []) (a || n?.includes(s.venueId)) && fr({ element: s, name: ki });
  return { ...x };
}
function iA(e) {
  let { courtId: t, disableNotice: r, force: i } = e, n = ui(e), a = oe(e, [{ [ur]: !0, [VD]: !0 }]);
  if (a.error) return a;
  let o, s;
  for (let c of Object.values(n)) {
    if (s = H2({ tournamentRecord: c, disableNotice: r, courtId: t, force: i }), s.error && s.error !== Ws) return s;
    s.success && (o = !0);
  }
  return o ? { ...x } : s;
}
function H2({ tournamentRecord: e, disableNotice: t, courtId: r, force: i }) {
  let n = Wo({ tournamentRecord: e, courtId: r });
  if (n.error) return n;
  let a = n.venue, { matchUps: o } = mS({ tournamentRecord: e, courtId: r }), s = _e({ tournamentRecord: e })?.appliedPolicies, c = i ?? s?.[pa]?.allowDeletionWithScoresPresent?.courts;
  if (!o?.length || c) {
    for (let u of o ?? []) {
      let l = XE({ matchUpId: u.matchUpId, drawId: u.drawId, tournamentRecord: e });
      if (l.error) return l;
    }
    a && (a.courts = (a.courts ?? []).filter((u) => u.courtId !== r), t || Se({ payload: { venue: a, tournamentId: e.tournamentId }, topic: Ya, key: a.venueId }));
  } else return hS({ matchUpsCount: o.length });
  return { ...x };
}
function IS(e) {
  let { disableNotice: t, modifications: r, courtId: i, force: n, venueMatchUps: a } = e, o = ui(e);
  if (!Object.keys(o).length) return { error: ht };
  let s, c;
  for (let u of Object.values(o)) {
    let l = z2({ tournamentRecord: u, disableNotice: t, venueMatchUps: a, modifications: r, courtId: i, force: n });
    if (l?.error) return l;
    s = !0;
  }
  return s ? { ...x } : c;
}
function z2({ tournamentRecord: e, disableNotice: t, venueMatchUps: r, modifications: i, courtId: n, force: a }) {
  if (!e) return { error: J };
  if (!n) return { error: No };
  if (!i || typeof i != "object") return { error: $n };
  let o = Wo({ tournamentRecord: e, courtId: n });
  if (o.error) return o;
  let { venue: s, court: c } = o, u = Object.keys(n2()).filter((p) => p !== "courtId");
  if (!Object.keys(i).filter((p) => u.includes(p)).length) return { error: _d };
  let l = u.filter((p) => !["dateAvailability"].includes(p)), d = Object.keys(i).filter((p) => l.includes(p));
  if (c && d.forEach((p) => Object.assign(c, { [p]: i[p] })), i.dateAvailability) {
    let p = fS({ dateAvailability: i.dateAvailability, tournamentRecord: e, venueMatchUps: r, disableNotice: t, courtId: n, force: a });
    if (p.error) return p;
  }
  return t || Se({ payload: { venue: s, tournamentId: e.tournamentId }, topic: Ya, key: s?.venueId }), { ...x, court: ie(c) };
}
var Y2 = () => ({ venueId: void 0, venueName: "", venueAbbreviation: "", onlineResources: [], venueType: void 0, addresses: [], contacts: [], courts: [], roles: [] }), K2 = Y2;
function nA(e) {
  let { modifications: t, venueId: r, force: i } = e, n = ui(e);
  if (!Object.keys(n).length) return { error: ht };
  if (typeof r != "string") return { error: da };
  let a, o;
  for (let s of Object.values(n)) {
    let c = Q2({ tournamentRecord: s, modifications: t, venueId: r, force: i });
    if (c.success && (o = !0), c.error && (a = c.error), c.error && c.error !== Co) return c;
  }
  return fl({ tournamentRecords: n }), o ? { ...x } : { error: a };
}
function Q2({ tournamentRecord: e, modifications: t, venueId: r, force: i }) {
  if (!e) return { error: J };
  if (!t || typeof t != "object") return { error: $n };
  if (!r) return { error: da };
  let n = _e({ tournamentRecord: e })?.appliedPolicies, a = i ?? n?.[pa]?.allowDeletionWithScoresPresent?.venues, { matchUps: o } = V2({ tournamentRecord: e, venueId: r }), s = Mn({ tournamentRecord: e, venueId: r });
  if (s.error) return s;
  let c = s.venue, u = Object.keys(K2()).filter((g) => g !== "venueId");
  if (!Object.keys(t).filter((g) => u.includes(g)).length) return { error: _d };
  let l = u.filter((g) => !["courts", "onlineResources"].includes(g)), d = Object.keys(t).filter((g) => l.includes(g));
  c && d.forEach((g) => Object.assign(c, { [g]: t[g] }));
  let p = c?.courts?.map((g) => g.courtId) ?? [], m = t.courts?.map((g) => g.courtId) || [], f = m.length ? p.filter((g) => !m.includes(g)) : t?.courts && p, h = [];
  if (f?.length) {
    let g = c?.courts?.filter((I) => f.includes(I.courtId))?.map((I) => {
      let U = mS({ courtId: I.courtId, tournamentRecord: e, venueMatchUps: o });
      for (let S of U.matchUps ?? []) h.push({ matchUpId: S.matchUpId, drawId: S.drawId });
      return U.matchUps?.length ?? 0;
    }).reduce((I, U) => I + U);
    if (c && (!g || a)) c.courts = c.courts?.filter((I) => m.includes(I.courtId)), cu({ schedule: { courtId: "", scheduledDate: "" }, matchUpDetails: h, removePriorValues: !0, tournamentRecord: e });
    else return hS({ matchUpsCount: g });
  }
  if (t.courts) for (let g of t.courts) {
    let { courtId: I } = g || {}, U = IS({ modifications: g, disableNotice: !0, tournamentRecord: e, venueMatchUps: o, courtId: I, force: i });
    if (U.error === Ws && (U = Mm({ disableNotice: !0, tournamentRecord: e, venueId: r, court: g })), U.error) return U;
  }
  return fl({ tournamentRecord: e }), c && Se({ payload: { venue: c, tournamentId: e.tournamentId }, topic: Ya, key: c?.venueId }), { ...x, venue: ie(c) };
}
var US = {};
Me(US, { JSON2CSV: () => iV, UUID: () => je, UUIDS: () => WP, allNumeric: () => mv, attributeFilter: () => vo, chunkArray: () => qt, chunkByNth: () => ef, chunkSizeProfile: () => pv, constantToString: () => ir, countValues: () => UC, createMap: () => hv, dateTime: () => qP, definedAttributes: () => ae, dehydrateMatchUps: () => Z2, extractAttributes: () => Yw, flattenJSON: () => SS, generateDateRange: () => ys, generateHashCode: () => bC, generateRange: () => te, generateTimeCode: () => LN, groupValues: () => lv, hasAttributeValues: () => TC, instanceCount: () => Br, intersection: () => Pt, isConvertableInteger: () => Ie, isNumeric: () => gt, isOdd: () => cv, isPowerOf2: () => Fi, makeDeepCopy: () => ie, matchUpScheduleSort: () => J2, matchUpSort: () => Ho, nearestPowerOf2: () => th, nextPowerOf2: () => Bs, noNulls: () => IC, noNumeric: () => fv, numericSort: () => Ot, occurrences: () => yC, overlap: () => gr, randomMember: () => xr, randomPop: () => Lr, shuffleArray: () => mr, structureSort: () => _o, subSort: () => vC, undefinedToNull: () => tf, unique: () => Ue, visualizeScheduledMatchUps: () => X2 });
function X2({ scheduledMatchUps: e, showGlobalLog: t }) {
  KO();
  let r = e?.reduce((n, { structureId: a }) => n.includes(a) ? n : n.concat(a), []), i = Array.isArray(r) && { ...r.map((n) => {
    let { structureName: a, matchUpType: o } = e.find((s) => s.structureId === n);
    return { [n]: `${a} ${o}` };
  }) };
  r?.forEach((n) => {
    Ec({ color: "blue", method: "draw", structure: i[n], keyColors: { structure: "magenta" } }, !0);
    let a = e.filter((s) => s.structureId === n), o = Ir({ matchUps: a })?.roundMatchUps || [];
    Object.keys(o).forEach((s) => {
      Ec({ roundNumber: s, keyColors: { roundNumber: "brightcyan" } }, !0), o[s].forEach(({ matchUpId: c, schedule: u }) => {
        let l = ct(u.scheduledTime);
        Ec({ matchUpId: c, time: l, date: u.scheduledDate, venue: u.venueId, keyColors: { time: "brightcyan", date: "brightcyan", matchUpId: "yellow", venue: "magenta" } }, !0);
      });
    });
  }), t && YO();
}
var { extractTime: _y, timeStringMinutes: By } = qP;
function J2(e, t) {
  let r = e.schedule ?? {}, i = t.schedule ?? {};
  if (r.scheduledDate && !i.scheduledDate) return 1;
  if (i.scheduledDate && !r.scheduledDate) return -1;
  if (r.scheduledDate && i.scheduledDate) {
    if (r.scheduledDate === i.scheduledDate) {
      if (r.scheduledTime && !i.scheduledTime) return 1;
      if (i.scheduledTime && !r.scheduledTime) return -1;
      if (r.scheduledTime && i.scheduledTime) {
        let n = By(_y(r.scheduledTime)), a = By(_y(i.scheduledTime));
        return n - a;
      }
    }
    return new Date(r.scheduledDate).getTime() - new Date(i.scheduledDate).getTime();
  }
  return 0;
}
function Z2({ tournamentRecord: e }) {
  if (!e) return { error: J };
  if (typeof e != "object" || !e.tournamentId) return { error: z };
  let { matchUps: t } = Jt({ tournamentRecord: e, inContext: !1 });
  if (t?.length) {
    let r = eV({ tournamentRecord: e });
    rV(t, r);
  }
  return { ...x };
}
function eV({ tournamentRecord: e }) {
  let t = {};
  for (let r of e.events || []) {
    r.matchUpFormat && (t[r.eventId] = r.matchUpFormat);
    for (let i of r.drawDefinitions || []) {
      i.matchUpFormat && (t[i.drawId] = i.matchUpFormat);
      for (let n of i.structures || []) {
        n.matchUpFormat && (t[n.structureId] = n.matchUpFormat);
        for (let a of n.structures || []) a.matchUpFormat && (t[a.structureId] = a.matchUpFormat);
      }
    }
  }
  return t;
}
var tV = ["collectionId", "collectionPosition", "drawPositions", "extensions", "finishingPositionRange", "finishingRound", "isMock", "matchUpId", "matchUpStatus", "matchUpStatusCodes", "orderOfFinish", "processCodes", "roundNumber", "tieFormat", "tieMatchUps", "roundPosition", "score", "sides", "winnerMatchUpId", "loserMatchUpId", "matchUpDuration", "winningSide"];
function rV(e, t = {}) {
  for (let r of e) {
    let { structureId: i, drawId: n, eventId: a } = r, o = t[i] || t[n] || t[a], s = r.matchUpFormat === o ? void 0 : r.matchUpFormat;
    for (let c of Object.keys(r)) tV.includes(c) || delete r[c];
    r.sides && r.drawPositions && !r.tieMatchUps && delete r.sides, s && (r.matchUpFormat = s);
  }
}
function iV(e, t) {
  if (t && typeof t != "object") return { error: z };
  let { columnTransform: r = {} } = t || {}, { includeTransformAccessors: i, includeHeaderRow: n = !0, returnTransformedJSON: a, removeEmptyColumns: o, onlyHeaderRow: s, columnAccessors: c = [], functionMap: u = {}, columnMap: l = {}, valuesMap: d = {}, context: p = {}, delimiter: m = '"', columnJoiner: f = ",", rowJoiner: h = `\r
`, keyJoiner: g = "." } = t || {};
  if (!Array.isArray(e) || !Array.isArray(c) || typeof p != "object" || typeof l != "object" || typeof r != "object" || typeof u != "object" || typeof d != "object" || typeof f != "string" || typeof h != "string" || typeof g != "string" || typeof m != "string") return { error: z };
  r = Object.assign({}, ...Object.keys(r).reverse().map((A) => ({ [A]: Array.isArray(r[A]) ? r[A] : [typeof r[A] == "string" && r[A]].filter(Boolean) })));
  let I = e.filter(Boolean).map((A) => SS(A, g)), U = Object.values(r).flat();
  i && c.push(...U);
  let S = I.reduce((A, N) => Object.keys(N).every((C) => !A.includes(C) && A.push(C) || !0) && A, []).filter((A) => !c?.length || c.includes(A)), P = Object.assign({}, ...Object.keys(r).reverse().map((A) => r[A].map((N) => ({ [N]: A })).flat()).flat()), v = (A, N) => t?.sortOrder ? t.sortOrder.includes(A) && t.sortOrder.includes(N) && t.sortOrder.indexOf(A) - t.sortOrder.indexOf(N) || !t.sortOrder.includes(N) && -1 : 0, D = S.reduce((A, N) => {
    let C = P[N];
    return C ? A.includes(C) || A.push(C) : A.push(N), A;
  }, []).sort(v);
  Object.keys(l).forEach((A) => !D.includes(A) && D.unshift(A)), Object.keys(r).forEach((A) => !D.includes(A) && D.unshift(A)), typeof p == "object" && Object.keys(p).forEach((A) => !D.includes(A) && D.unshift(A));
  let y = D.map((A) => l[A] || A);
  if (s) return [y];
  let w = (A) => `${m}${A}${m}`, b = [], T = (A) => Object.values(D.reduce((N, C, k) => {
    let O = r[C], _ = (O?.length ? A[O.find((j) => A[j])] : A[C]) || p?.[C] || "", B = d[C]?.[_] || _, L = Fr(u[C]) ? u[C](B) : B;
    return N[C] = w(L), L && (b[k] = (b[k] || 0) + 1), N;
  }, {})), R = I.map(T), M = o && [...b].map((A, N) => !A && N).filter(gt).reverse();
  if (M) {
    let A = (N) => N.filter((C, k) => !M.includes(k));
    R = R.map(A), y = A(y);
  }
  let E = R.map((A) => A.join(f));
  return a ? E.map((A) => {
    let N = A.split(f);
    return Object.assign({}, ...N.map((C, k) => ({ [y[k]]: C })));
  }) : n ? [y.map(w).join(f), ...E].join(h) : E.join(h);
}
function SS(e, t = ".", r = []) {
  return typeof e == "object" && Object.keys(e).reduce((i, n) => typeof e[n] != "object" ? (i[r.concat(n).join(t)] = e[n], i) : Object.assign(i, SS(e[n], t, r.concat(n))), {});
}
var { FACTORY: Vy } = KD;
function nV({ tournamentRecord: e, value: t }) {
  let { extension: r } = we({ element: e, name: Vy }), i = { name: Vy, value: { ...r?.value, ...t } };
  Be({ element: e, extension: i });
}
function aA({ timeStamp: e }) {
  let t = ko(), r = Ah();
  return r && Object.values(t).forEach((i) => {
    nV({ tournamentRecord: i, value: { version: bd(), timeStamp: e } });
  }), r;
}
function oA({ engineType: e, methodName: t, elapsed: r, params: i, result: n }) {
  let a = Yr();
  if (typeof a != "object") return;
  let o = { method: t }, s = n?.error && (a.errors === !0 || Array.isArray(a.errors) && a.errors.includes(t)), c = Array.isArray(a.params) && a.params?.includes(t), u = a.params && !Array.isArray(a.params) || c, l = Array.isArray(a.exclude) && a.exclude.includes(t);
  !l && ![void 0, !1].includes(a.perf) && !isNaN(a.perf) && r >= a.perf && (o.elapsed = r), !l && (s || u) && (o.params = i), !l && (s || a.result && !Array.isArray(a.result) && (!Array.isArray(a.params) || c) || Array.isArray(a.result) && a.result?.includes(t)) && (o.result = n), Object.keys(o).length > 1 && FP(o, e);
}
function yS({ methodName: e, params: t, start: r }) {
  let i = { error: Vd, methodName: e }, n = r ? Date.now() - r : 0;
  return oA({ result: i, methodName: e, elapsed: n, params: t, engineType: "sync" }), i;
}
function aV(e, t) {
  if (t._middleware === !1) return t;
  if (t.tournamentId && !e[t.tournamentId]) return { error: J };
  let r = t.drawId || t.matchUp?.drawId;
  if (r) {
    let { event: a, drawDefinition: o, tournamentId: s } = br({ tournamentRecords: e, drawId: r });
    o && (t.drawDefinition = o), s && (t.tournamentId = s), a && (t.event = a);
  }
  if (t.eventId && !t.event) {
    let { event: a, tournamentId: o } = br({ eventId: t.eventId, tournamentRecords: e });
    if (!a) return { error: ni };
    t.tournamentId = o, t.event = a;
  }
  let i = t.tournamentId ?? Oo();
  if (!i && t) return t;
  let n = e[i];
  return i && !n ? { error: J } : (n && (t.tournamentRecord = n), t);
}
function vS(e, t, r, i, n) {
  delete e.success, delete e.error;
  let a = Date.now(), o = Oo();
  r && (r.activeTournamentId = o);
  let s = r?.tournamentRecord || Oh(o), c = typeof r?.tournamentRecord == "object" && { [r?.tournamentRecord.tournamentId]: r.tournamentRecord } || ko(), u = r ? ie(r, void 0, !0) : void 0, l = r ? aV(c, r) : void 0;
  if (l?.error) return l;
  let d = oV({ params: l, tournamentRecords: c, tournamentRecord: s, methodName: i, method: t }), p = Date.now() - a;
  return oA({ result: d, methodName: i, elapsed: p, params: u, engineType: n }), d;
}
function oV({ tournamentRecords: e, tournamentRecord: t, params: r, methodName: i, method: n }) {
  if (Yr()) return n({ tournamentRecords: e, tournamentRecord: t, ...r });
  try {
    return n({ tournamentRecords: e, tournamentRecord: t, ...r });
  } catch (a) {
    return $d({ engineName: "engine", methodName: i, params: r, err: a });
  }
}
function Em(e) {
  let { mutationStatus: t, tournamentId: r, directives: i, timeStamp: n } = e || {}, { topics: a } = ci();
  for (let o of [...a].sort(sV)) {
    let s = OP({ topic: o });
    s?.length && mf({ topic: o, notices: s });
  }
  t && n && a.includes(yf) && mf({ notices: [{ tournamentId: r, directives: i, timeStamp: n }], topic: yf });
}
var jy = { [vg]: 5, [yg]: 5, [Pg]: 5, [Sg]: 5, [Ug]: 5, [gg]: 5, [pw]: 5, [mw]: 5, [Ig]: 1, [up]: 1, [ar]: 5, [Ya]: 5, [hg]: 4, [pg]: 4, [mg]: 4, [fg]: 4, [cp]: 3, [ug]: 2 };
function sV(e, t) {
  return (jy[t] || 0) - (jy[e] || 0);
}
function cV({ convertExtensions: e, removeExtensions: t }) {
  let r = ko();
  return { tournamentId: Oo(), tournamentRecords: ie(r, e, !1, t) };
}
function uV(e) {
  let { convertExtensions: t = !1, removeExtensions: r = !1 } = e ?? {}, i = e?.tournamentId ?? Oo();
  if (typeof i != "string") return {};
  let n = Oh(i);
  return { tournamentRecord: ie(n, t, !1, r) };
}
function lV() {
  let e = ko(), { extension: t } = we({ name: Oa, tournamentRecords: e, discover: !0 }), r = t?.value?.tournamentIds || [];
  return Object.keys(e).forEach((i) => {
    r.includes(i) || delete e[i];
  }), Gd(e);
}
function Gy(e, t = !0) {
  return typeof e != "object" || Array.isArray(e) ? { error: $n } : e?.tournamentId ? kP(t ? ie(e) : e) : { error: z };
}
function uu(e, t = !0) {
  if (typeof e != "object") return { error: $n };
  if (_c(), Array.isArray(e)) {
    if (e.filter((r) => r?.tournamentId).length !== e.length) return { error: af };
    e = Object.assign({}, ...e.map((r) => ({ [r.tournamentId]: r })));
  } else if (e?.tournamentId) e = { [e.tournamentId]: e }, _c(e.tournamentId);
  else if (!Object.keys(e).every((r) => e[r].tournamentId === r)) return { error: af };
  return Gd(t ? ie(e) : e);
}
function dV(e, t, r, i, n, a) {
  let o = LP(r, i, n, a);
  if (o.error) return o;
  let s = o.methods ?? [];
  return Object.keys(s).filter((c) => Fr(s[c])).forEach((c) => {
    e[c] = (u) => {
      let l = () => t(e, { [c]: s[c], ...u });
      if (Yr()) return l();
      try {
        return l();
      } catch (d) {
        $d({ engineName: "engine", methodName: c, params: u, err: d });
      }
    };
  }), { ...x, ...e };
}
function cs(e, t) {
  return t?.error ? (e.error = t.error, e.success = !1) : (e.error = void 0, e.success = !0), e;
}
function sA(e, t) {
  e.importMethods = (r, i, n, a) => dV(e, t, r, i, n, a), e.getTournament = (r) => uV(r), e.getState = (r) => cV({ convertExtensions: r?.convertExtensions, removeExtensions: r?.removeExtensions }), e.version = () => bd(), e.reset = () => (Gd({}), cs(e)), e.devContext = (r) => (Fc(r), cs(e)), e.getDevContext = (r) => Yr(r), e.newTournamentRecord = (r = {}) => {
    let i = Tm(r), n = i.tournamentId;
    return i.error ? i : (Gy(i), _c(n), { ...x, tournamentId: n });
  }, e.setState = (r, i, n) => {
    Lc(i, n);
    let a = uu(r, i);
    return cs(e, a);
  }, e.setTournamentId = (r) => _c(r), e.getTournamentId = () => Oo(), e.setTournamentRecord = (r, i, n) => {
    Lc(i, n);
    let a = Gy(r, i);
    return cs(e, a);
  }, e.removeTournamentRecord = (r) => {
    let i = xP(r);
    return cs(e, i);
  }, e.removeUnlinkedTournamentRecords = () => {
    let r = lV();
    return cs(e, r);
  };
}
function pV(e, t, r) {
  if (!Array.isArray(t)) return { error: z, message: "directives must be an array" };
  let i = CP(), n = Date.now(), a = r && ie(ko(), !1, !0), o = [];
  for (let u of t) {
    if (typeof u != "object") return { error: z, message: "directive must be an object" };
    if (u.params && typeof u.params != "object") return { error: z, message: "params must be an object" };
    let { method: l, pipe: d } = u, p = u.params ? { ...u.params } : {};
    if (!i[l]) return yS({ methodName: l, start: n, params: p });
    if (d) {
      let f = o[o.length - 1], h = Object.keys(d);
      for (let g of h) f[g] && (p[g] = f[g]);
    }
    let m = vS(e, i[l], p, l, "sync");
    if (m?.error) return a && uu(a), { ...m, rolledBack: !!a };
    o.push({ ...m, methodName: l });
  }
  let s = Date.now(), c = aA({ timeStamp: s });
  return Em({ directives: t, mutationStatus: c, timeStamp: s }), Uu(), { success: o.every((u) => u.success), results: o };
}
function $y(e, t) {
  if (!xe(t)) return { error: z, message: "args must be an object" };
  let r = Object.values(t).filter(Fr).length;
  if (r > 1) return { message: "there must be only one arg with typeof function", error: z };
  let i = r ? Object.keys(t).find((m) => Fr(t[m])) : dt(t.method) && t.method;
  if (!i) return { error: Vd };
  let { [i]: n, ...a } = t, o = t?.params ? { ...t.params } : { ...a }, s = o.rollbackOnError && ie(ko(), !1, !0), c = n || e[i] || Nh()[i];
  if (!c) return yS({ methodName: i, params: o });
  let u = vS(e, c, o, i, "sync") ?? {};
  u?.error && s && uu(s);
  let l = Date.now(), d = aA({ timeStamp: l }), p = u?.success && o?.delayNotify !== !0 && o?.doNotNotify !== !0;
  return p && Em({ directives: [{ method: c, params: o }], mutationStatus: d, timeStamp: l }), (p || !u?.success || o?.doNotNotify) && Uu(), u;
}
var mV = (() => {
  let e = { executionQueue: (t, r) => pV(e, t, r), execute: (t) => $y(e, t) };
  return sA(e, $y), e;
})(), PS = mV;
function qy(e, t) {
  if (!xe(t)) return { error: z, message: "args must be an object" };
  let r = Object.values(t).filter(Fr).length;
  if (r > 1) return { message: "there must be only one arg with typeof function", error: z };
  let i = r ? Object.keys(t).find((c) => Fr(t[c])) : dt(t.method) && t.method;
  if (!i) return { error: Vd };
  let { [i]: n, ...a } = t, o = t?.params ? { ...t.params } : { ...a }, s = n || e[i] || Nh()[i];
  return s ? vS(e, s, o, i, "ask") : yS({ methodName: i, params: o });
}
(() => {
  let e = { execute: (t) => qy(e, t) };
  return sA(e, qy), e;
})();
var go = {}, Jn;
function cA(e, t = !0) {
  if (!e) return { error: ue };
  if (typeof e != "object") return { error: $n };
  if (e.matchUpId) Jn = e.matchUpId, go[Jn] = t ? ie(e) : e;
  else if (Array.isArray(e)) for (let r of e.reverse()) r.matchUpId && (go[r.matchUpId] = t ? ie(r) : r, Jn || (Jn = r.matchUpId));
  else for (let r of Object.values(e)) r.matchUpId && (go[r.matchUpId] = t ? ie(r) : r, Jn || (Jn = r.matchUpId));
  return t ? ie(e) : e;
}
function fV() {
  return go[Jn];
}
function hV() {
  return Object.values(go);
}
function gV() {
  Jn = void 0, go = {};
}
function IV(e) {
  return ie(go[Jn], e?.convertExtensions, !1, e?.removeExtensions);
}
(() => {
  let e = { getState: (r) => IV(r), version: () => bd(), reset: () => (gV(), { ...x }), drawId: void 0, error: void 0, success: !1, devContext: (r) => (Fc(r), e), setState: (r, i, n) => {
    Lc(i, n);
    let a = cA(r);
    return t(a);
  } };
  function t(r) {
    return r?.error ? (e.error = r.error, e.success = !1) : (e.error = void 0, e.success = !0, e.drawId = r.drawId), e;
  }
  return UV(e, [FI]), e;
})();
function UV(e, t) {
  t.forEach((r) => {
    Object.keys(r).forEach((i) => {
      e[i] = (n) => {
        if (Yr()) return Wy(e, { params: n, governor: r, methodName: i });
        try {
          return Wy(e, { params: n, governor: r, methodName: i });
        } catch (a) {
          $d({ engineName: "matchUpEngine", methodName: i, params: n, err: a });
        }
      };
    });
  });
}
function Wy(e, { params: t, governor: r, methodName: i }) {
  e.error = void 0, e.success = !1;
  let n = t?.matchUp || fV(), a = t?.matchUps || hV(), o = t?.rollbackOnError && ie(n, !1, !0);
  t = { ...t, matchUpId: n?.matchUpId, matchUps: a, matchUp: n };
  let s = r[i](t);
  if (s?.error) return o && cA(o), { ...s, rolledBack: !!o };
  let c = s?.success && t?.delayNotify !== !0 && t?.doNotNotify !== !0;
  return c && Em(), (c || !s?.success || t?.doNotNotify) && Uu(), s;
}
var Km = !1;
(() => {
  let e = { version: () => bd(), setDeepCopy: (i, n) => (Lc(i, n), e), devContext: (i) => (Fc(i), Km = !0, e) };
  return r([QU]), e;
  function t(i, n) {
    let a = i({ ...n });
    return a?.error || Em(), Uu(), Km && (Fc(!1), Km = !1), a;
  }
  function r(i) {
    i.forEach((n) => {
      Object.keys(n).forEach((a) => {
        e[a] = (o) => {
          if (Yr()) {
            let s = t(n[a], o);
            return !s?.error && o?.setState && s?.tournamentRecord && uu(s.tournamentRecord), s;
          } else try {
            let s = t(n[a], o);
            return !s?.error && o?.setState && s?.tournamentRecord && uu(s.tournamentRecord), s;
          } catch (s) {
            let c;
            typeof s == "string" ? c = s.toUpperCase() : s instanceof Error && (c = s.message), console.log("ERROR", { params: JSON.stringify(o), method: a, error: c });
          }
        };
      });
    });
  }
})();
PS.importMethods(nv, !0, 1);
var uA = PS, SV = { getTournamentPoints: Qp }, yV = SV, vV = { calculateNewRatings: jb, generateDynamicRatings: Gb }, PV = vV, DV = { ...yV, ...PV };
PS.importMethods(DV);
var wV = { [zc]: { roundsToSeparate: void 0, policyName: "Nationality Code", policyAttributes: [{ key: "person.nationalityCode" }, { key: "individualParticipants.person.nationalityCode" }] } }, TV = { [vn]: { policyName: "positionActionsUnrestricted", enabledStructures: [], otherFlightEntries: !0, disableRoundRestrictions: !0, activePositionOverrides: [mo, Ac] } }, bV = { [vn]: { policyName: "positionActionsNoMovement", enabledStructures: [{ stages: [], stageSequences: [], enabledActions: [mo, tu, bo], disabledActions: [] }] } }, MV = { [vn]: { policyName: "positionActionsDisabled", enabledStructures: !1 } }, RV = { [Xs]: { policyName: "Participant Privacy Policy", participant: { contacts: !1, individualParticipants: { onlineResources: !1, participantName: !0, participantOtherName: !0, participantId: !0, participantRole: !0, participantStatus: !0, penalties: !1, rankings: !0, ratings: !0, representing: !0, participantRoleResponsibilities: !1, participantType: !0, person: { addresses: !1, biographicalInformation: !1, birthDate: !1, contacts: !1, nationalityCode: !0, nativeFamilyName: !1, nativeGivenName: !1, onlineResources: !1, otherNames: !0, parentOrganisationId: !1, passportFamilyName: !1, passportGivenName: !1, personId: !1, personOtherIds: !1, previousNames: !1, sex: !1, standardFamilyName: !0, standardGivenName: !0, status: !1, tennisId: !1, wheelchair: !0 } }, individualParticipantIds: !0, onlineResources: !1, participantName: !0, participantOtherName: !0, participantId: !0, participantRole: !0, participantStatus: !0, penalties: !1, rankings: !0, ratings: !0, representing: !0, participantRoleResponsibilities: !1, participantType: !0, person: { addresses: !1, biographicalInformation: !1, birthDate: !1, contacts: !1, nationalityCode: !0, nativeFamilyName: !1, nativeGivenName: !1, onlineResources: !1, otherNames: !0, parentOrganisationId: !1, passportFamilyName: !1, passportGivenName: !1, personId: !1, personOtherIds: !1, previousNames: !1, sex: !1, standardFamilyName: !0, standardGivenName: !0, status: !1, tennisId: !1, wheelchair: !0 } } } }, NV = { [oi]: { processCodes: { incompleteAssignmentsOnDefault: ["RANKING.IGNORE"] }, defaultMatchUpFormat: Si, allowDeletionWithScoresPresent: { drawDefinitions: !1, structures: !1 }, requireParticipantsForScoring: !1, requireAllPositionsAssigned: void 0, allowChangePropagation: !1, stage: { [re]: { stageSequence: { 1: { requireAllPositionsAssigned: !0 } } } }, matchUpFormats: [], matchUpStatusCodes: { [Or]: [], [nn]: [], [Pe]: [], [$r]: [], [Xt]: [], [be]: [] } } }, Qm = "Personal circumstance", EV = { [oi]: { requireAllPositionsAssigned: !1, stage: { [re]: { stageSequence: { 1: { requireAllPositionsAssigned: !0 } } } }, defaultMatchUpFormat: Si, matchUpFormats: [{ description: "Best of 3 tiebreak sets", matchUpFormat: Si, categoryNames: [], categoryTypes: [] }, { description: "Two tiebreak sets, 7-point match tiebreak at one set all", matchUpFormat: "SET3-S:6/TB7-F:TB7" }, { description: "Two tiebreak sets, 10-point match tiebreak at one set all", matchUpFormat: "SET3-S:6/TB7-F:TB10" }, { description: "One standard tiebreak set to 6, 7-point tiebreak at 6 games all", matchUpFormat: "SET1-S:6/TB7" }, { description: "Best of 3 sets to 4", matchUpFormat: "SET3-S:4/TB7" }, { description: "Two out of three short sets to 4 with 5-point tiebreak at 3 games all", matchUpFormat: "SET3-S:4/TB5@3" }, { description: "One short set to 4, 7-point tiebreak at 4 games all", matchUpFormat: "SET1-S:4/TB7" }, { description: "One short set to 4, 5-point tiebreak at 3 games all", matchUpFormat: "SET1-S:4/TB5@3" }, { description: "Two short sets to 4, 10-point match tiebreak at one set all", matchUpFormat: "SET3-S:4/TB7-F:TB10" }, { description: "Two short sets to 4, 7-point match tiebreak at one set all", matchUpFormat: "SET3-S:4/TB7-F:TB7" }, { description: "One no advantage set to 5, tiebreak to 9 at 4-4", matchUpFormat: "SET1-S:5/TB9@4" }, { description: "One set to 6 with deciding game at 5 games all", matchUpFormat: "SET1-S:6NOAD" }, { description: "One short set to 4, deciding game is played at 3 games all", matchUpFormat: "SET1-S:4NOAD" }, { description: "Two short sets to 4 with deciding game at 3-3, 7-point match tiebreak at one set all", matchUpFormat: "SET3-S:4NOAD-F:TB7" }, { description: "8 game pro-set with 7 point tiebreak at 8 games all", matchUpFormat: "SET1-S:8/TB7" }, { description: "8 game pro-set with 7 point tiebreak at 7 games all", matchUpFormat: "SET1-S:8/TB7@7" }, { description: "Best of 3 10-point tiebreak games", matchUpFormat: "SET3-S:TB10" }, { description: "One 10-point tiebreak game", matchUpFormat: "SET1-S:TB10" }, { description: "Timed 20 minute game - game based", matchUpFormat: "SET1-S:T20" }], matchUpStatusCodes: { [Or]: [{ matchUpStatusCodeDisplay: "Abandoned", label: "Abandoned match", matchUpStatusCode: "OA" }], [nn]: [{ matchUpStatusCodeDisplay: "Unplayed or Cancelled", label: "Cancelled match", matchUpStatusCode: "OC" }], [$r]: [{ matchUpStatusCodeDisplay: "Incomplete", label: "Incomplete match", matchUpStatusCode: "OI" }], [Pe]: [{ description: "Disqualification for cause or ineligibility", label: "Disqualification (ineligibility)", matchUpStatusCodeDisplay: "Def [dq]", matchUpStatusCode: "DQ" }, { description: "Misconduct before or between matches", label: "Misconduct", matchUpStatusCodeDisplay: "Def [cond]", matchUpStatusCode: "DM" }, { description: "Failure to start match because of adult discipline", label: "Fail. (adult discipline)", matchUpStatusCodeDisplay: "Def [ad]", matchUpStatusCode: "D5" }, { description: "Refusal to start match for reason other than adult discipline, injury, illness, or personal circumstance. (After the Referee has conclusively confirmed that a player refuses to play a match, the Referee need not wait until the scheduled time of the match to records the result.)", label: "Refusal to start match", matchUpStatusCodeDisplay: "Def [refsl]", matchUpStatusCode: "D4" }, { label: "Not showing up", matchUpStatusCodeDisplay: "Def [ns]", matchUpStatusCode: "D6" }, { description: "Lateness for match including, but not limited to, intending to play but mistakenly arriving at the wrong time, location, or without proper equipment", label: "Lateness for match", matchUpStatusCodeDisplay: "Score + Def [late]", matchUpStatusCode: "D7" }, { label: "Double default", matchUpStatusCodeDisplay: "Def/Def", matchUpStatusCode: "DD" }, { description: "Refusal to continue playing a match for reason other than injury, illness, personal circumstance, or adult discipline", label: "Refusal to continue match", matchUpStatusCodeDisplay: "Def [refsl]", matchUpStatusCode: "D9" }, { description: "Default for receiving an injection, IV, or supplemental oxygen", label: "Default (PEDs)", matchUpStatusCodeDisplay: "Def [med]", matchUpStatusCode: "DI" }, { description: "Default under Point Penalty System", label: "Default (Point Penalty System)", matchUpStatusCodeDisplay: "Def [pps]", matchUpStatusCode: "DP" }], [be]: [{ matchUpStatusCodeDisplay: "Wo [inj]", matchUpStatusCode: "W1", label: "Injury" }, { matchUpStatusCodeDisplay: "Wo [ill]", matchUpStatusCode: "W2", label: "Illness" }, { matchUpStatusCodeDisplay: "Wo [pc]", label: Qm, matchUpStatusCode: "W3" }, { matchUpStatusCodeDisplay: "Wo/Wo", matchUpStatusCode: "WOWO", label: "Double walkover" }, { matchUpStatusCodeDisplay: "Wo [Tae]", label: "Tournament Administrative Error", matchUpStatusCode: "W4" }, { matchUpStatusCodeDisplay: "Wo/Withdrawn", matchUpStatusCode: "W5", label: "Withdrawn" }], [Xt]: [{ matchUpStatusCodeDisplay: "Ret [inj]", matchUpStatusCode: "RJ", label: "Injury" }, { matchUpStatusCodeDisplay: "Ret [ill]", matchUpStatusCode: "RI", label: "Illness" }, { matchUpStatusCodeDisplay: "Ret [pc]", label: Qm, matchUpStatusCode: "RC" }, { description: "Retirement because of adult discipline", label: "Ret. (adult discipline)", matchUpStatusCodeDisplay: "Ret [ad]", matchUpStatusCode: "RD" }, { description: "A player who retires from a match remains eligible for consolations, place playoffs, doubles and subsequent round robin matches", matchUpStatusCodeDisplay: "Ret [elg]", label: "Ret. (eligible)", matchUpStatusCode: "RU" }], [Pn]: [{ matchUpStatusCodeDisplay: "Wd [inj]", matchUpStatusCode: "WD.INJ", label: "Injury" }, { matchUpStatusCodeDisplay: "Wd [ill]", matchUpStatusCode: "WD.ILL", label: "Illness" }, { matchUpStatusCodeDisplay: "Wd [pc]", label: Qm, matchUpStatusCode: "WD.PC" }, { matchUpStatusCodeDisplay: "Wd/Wd", matchUpStatusCode: "WD.WD", label: "Double withdrawal" }, { label: "Tournament Administrative Error", matchUpStatusCodeDisplay: "Wd [Tae]", matchUpStatusCode: "WD.TAE" }] } } }, AV = { [hi]: { seedingProfile: { positioning: zd }, validSeedPositions: { ignore: !0 }, duplicateSeedNumbers: !0, drawSizeProgression: !0, policyName: "ITF SEEDING", seedsCountThresholds: [{ drawSize: 4, minimumParticipantCount: 3, seedsCount: 2 }, { drawSize: 16, minimumParticipantCount: 12, seedsCount: 4 }, { drawSize: 32, minimumParticipantCount: 24, seedsCount: 8 }, { drawSize: 64, minimumParticipantCount: 48, seedsCount: 16 }, { drawSize: 128, minimumParticipantCount: 97, seedsCount: 32 }, { drawSize: 256, minimumParticipantCount: 192, seedsCount: 64 }] } }, CV = { POLICY_AVOIDANCE_COUNTRY: wV, POLICY_POSITION_ACTIONS_DEFAULT: Db, POLICY_POSITION_ACTIONS_DISABLED: MV, POLICY_POSITION_ACTIONS_NO_MOVEMENT: bV, POLICY_POSITION_ACTIONS_UNRESTRICTED: TV, POLICY_PRIVACY_DEFAULT: RV, POLICY_ROUND_NAMING_DEFAULT: Ag, POLICY_SCHEDULING_DEFAULT: tR, POLICY_SCORING_DEFAULT: NV, POLICY_SCORING_USTA: EV, POLICY_SEEDING_ITF: AV, POLICY_SEEDING_DEFAULT: LM }, OV = { ratingsParameters: Gt, matchUpFormats: $0, countryToFlag: yw, tieFormats: gR, countries: ea, policies: CV, flagIOC: j1 }, kV = {};
Me(kV, { activeMatchUpStatuses: () => cg, auditConstants: () => j_, completedMatchUpStatuses: () => Lt, directingMatchUpStatuses: () => aw, displayConstants: () => I_, drawDefinitionConstants: () => xD, entryStatusConstants: () => Q1, errorConditionConstants: () => $C, eventConstants: () => Y0, extensionConstants: () => KD, flightConstants: () => J_, genderConstants: () => kh, keyValueConstants: () => $F, matchUpActionConstants: () => tF, matchUpStatusConstants: () => cw, matchUpTypes: () => mC, nonDirectingMatchUpStatuses: () => ow, particicipantsRequiredMatchUpStatuses: () => iw, participantConstants: () => V1, participantRoles: () => qg, participantTypes: () => bc, penaltyConstants: () => JV, policyConstants: () => D1, positionActionConstants: () => hx, ratingConstants: () => Nx, recoveryTimeRequiredMatchUpStatuses: () => x1, requestConstants: () => VB, resourceContants: () => F0, resultConstants: () => MC, scaleConstants: () => S1, scheduleConstants: () => PO, sortingConstants: () => aB, surfaceConstants: () => nj, tieFormatConstants: () => q0, timeItemConstants: () => SO, topicConstants: () => L1, tournamentConstants: () => BE, upcomingMatchUpStatuses: () => sw, validMatchUpStatuses: () => nw, venueConstants: () => sj, weekdayConstants: () => PR });
var xV = "Coaching", FV = "Ball Abuse", LV = "Racket Abuse", _V = "Verbal Abuse", BV = "INELIGIBILITY", VV = "Physical Abuse", jV = "Unsportmanlike Conduct", GV = "Dress Code Violation", $V = "Equipment Violation", qV = "Leaving the court", WV = "Failure to complete", HV = "No Show", zV = "Other", YV = "REFUSAL_TO_PLAY", KV = "PROHIBITED_SUBSTANCE", QV = "Puncuality", XV = "Failure to sign in", JV = { COACHING: xV, BALL_ABUSE: FV, RACKET_ABUSE: LV, VERBAL_ABUSE: _V, PHYSICAL_ABUSE: VV, INELIGIBILITY: BV, UNSPORTSMANLIKE_CONDUCT: jV, PROHIBITED_SUBSTANCE: KV, DRESS_CODE_VIOLATION: GV, EQUIMENT_VIOLATION: $V, LEAVING_THE_COURT: qV, REFUSAL_TO_PLAY: YV, FAILURE_TO_COMPLETE: WV, NO_SHOW: HV, OTHER: zV, PUNCTUALITY: QV, FAILUIRE_TO_SIGN_IN: XV }, ZV = "CLAY", ej = "HARD", tj = "GRASS", rj = "CARPET", ij = "ARTIFICIAL", nj = { CLAY: ZV, HARD: ej, GRASS: tj, CARPET: rj, ARTIFICIAL: ij }, aj = "INDOOR", oj = "OUTDOOR", sj = { INDOOR: aj, OUTDOOR: oj };
const cj = Ge({
  WebkitBoxSizing: "border-box",
  marginInlineEnd: ".3em",
  display: "inline-block",
  boxSizing: "border-box",
  position: "relative",
  borderRadius: 2,
  variants: {
    variant: {
      doubles: {
        width: ".75rem"
      },
      singles: {
        width: "1rem"
      }
    }
  }
});
function uj({ matchUp: e, individualParticipant: t, spacer: r }) {
  const i = t?.person?.iso2NationalityCode || "", n = i ? OV.countryToFlag(i)?.slice(0, 4) : "", a = document.createElement("span"), o = e?.matchUpType?.toLowerCase();
  return r || (a.className = cj({ variant: o })), a.innerHTML = r ? "" : n, a;
}
function Xm({
  individualParticipant: e,
  composition: t,
  className: r,
  matchUp: i,
  spacer: n,
  side: a,
  type: o
}) {
  if (o === "scale")
    return dC({
      individualParticipant: e,
      composition: t,
      className: r,
      matchUp: i,
      spacer: n
    });
  const s = t?.configuration || {}, c = document.createElement("div");
  if (o === "flag" && s.flags)
    return uj({ matchUp: i, individualParticipant: e, spacer: n });
  if (o === "seeding") {
    const u = uC({ className: r, composition: t, side: a });
    return typeof u == "string" ? c : u;
  }
  return c;
}
const lj = "Qualifier", dj = "BYE", pj = "TBD";
function Hy(e) {
  const { isWinningSide: t, side: r, sideNumber: i, individualParticipant: n, matchUp: a, composition: o } = e || {}, s = t ? "winner" : void 0, c = e.eventHandlers || {}, u = o?.configuration, l = {
    QUALIFIER: u?.placeHolders?.qualifier || lj,
    BYE: u?.placeHolders?.bye || dj,
    TBD: u?.placeHolders?.tbd || pj
  }, d = n?.participantName, p = (P) => {
    Oi(c?.participantClick) && (P.stopPropagation(), c.participantClick({
      individualParticipant: n,
      pointerEvent: P,
      matchUp: a,
      side: r
    }));
  }, m = document.createElement("div");
  m.classList.add("tmx-i"), m.setAttribute("sideNumber", i), m.setAttribute("id", n?.participantId), m.onclick = p;
  const f = document.createElement("div");
  f.className = $A({ variant: s });
  const g = u?.flags && Xm({ ...e, type: "flag" });
  if (g)
    f.appendChild(g);
  else {
    const P = Xm({
      type: "scale",
      ...e
    });
    P && f.appendChild(P);
  }
  const I = document.createElement("div");
  if (I.className = qA({ variant: s }), d) {
    const P = document.createElement("span");
    if (t && u?.winnerColor)
      P.style.color = typeof u.winnerColor == "string" ? u.winnerColor : "green";
    else if (u?.genderColor) {
      const v = n?.person?.sex, D = v === "MALE" && "#2E86C1" || v === "FEMALE" && "#AA336A" || "";
      P.style.color = typeof u.genderColor == "string" ? u.genderColor : D;
    }
    P.innerHTML = d, I.appendChild(P);
  } else {
    const P = document.createElement("abbr");
    P.className = GA({ variant: u.showAddress ? "showAddress" : "" }), P.innerHTML = r?.bye && l.BYE || r?.qualifier && l.QUALIFIER || l.TBD, I.appendChild(P);
  }
  const U = Xm({
    ...e,
    className: cC(),
    type: "seeding"
  });
  U && I.appendChild(U), f.appendChild(I), m.appendChild(f);
  const S = sC(e);
  return m.appendChild(S), { element: m };
}
const mj = Ge({
  width: "auto",
  display: "inline-block",
  textTransform: "uppercase",
  fontFamily: "Sharp Sans, Arial, sans-serif",
  fontSize: "0.625rem",
  lineHeight: "1rem",
  marginInline: "0.25rem 0.25rem",
  paddingInline: "0.25rem 0.25rem",
  fontWeight: 700,
  borderRadius: "4px",
  color: "#fff",
  textAlign: "center",
  whiteSpace: "nowrap",
  variants: {
    variant: {
      defaulted: {
        backgroundColor: "#df164c"
      },
      retired: {
        backgroundColor: "#df164c"
      },
      walkover: {
        backgroundColor: "black"
      },
      double_walkover: {
        backgroundColor: "black"
      }
    }
  }
});
function Qf({ matchUpStatus: e }) {
  const t = e?.toLowerCase(), i = ["defaulted", "retired", "walkover", "double_walkover"].includes(t) ? t : void 0, n = ["WALKOVER", "DOUBLE_WALKOVER"].includes(e || "") ? "WO" : e?.slice(0, 3) || "", a = document.createElement("div");
  a.className = mj(i ? { variant: i } : {});
  const o = document.createElement("abbr");
  return o.setAttribute("title", e || ""), o.style.textDecoration = "none", o.style.borderBottom = "none", o.innerHTML = n, a.appendChild(o), a;
}
function fj(e) {
  return e instanceof Element || e;
}
const hj = Ge({
  marginInlineEnd: ".5rem",
  backgroundColor: "pink",
  marginInlineStart: 2,
  height: 40,
  width: 40
});
function gj({ teamLogo: e }) {
  console.log({ teamLogo: e });
  const t = document.createElement("div");
  return t.className = hj(), t;
}
const Ij = Ge({
  flexDirection: "column",
  position: "relative",
  display: "flex"
}), Uj = Ge({
  alignItems: "stretch",
  display: "flex"
}), Sj = Ge({
  marginInlineEnd: ".25rem",
  color: "green"
});
function Xf({ dim: e = "20px" } = {}) {
  const t = Sj();
  return `
    <div style="line-height: 0;">
      <svg height="${e}" viewBox="0 0 18 24" width="${e}" xmlns="http://www.w3.org/2000/svg" class="${t}" style="fill: currentcolor;">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
      </svg>
    </div>
  `;
}
function yj({
  initialRoundNumber: e = 1,
  eventHandlers: t,
  sideContainer: r,
  composition: i,
  participant: n,
  placeholder: a,
  sideNumber: o,
  matchUp: s
}) {
  const { winningSide: c, matchUpType: u, isRoundRobin: l, matchUpStatus: d } = s || {}, p = i?.configuration;
  let m;
  const f = o ? s?.sides?.find((R) => R.sideNumber === o) : void 0;
  n || (n = f?.participant, m = p?.allDrawPositions || p?.drawPositions && f?.drawPosition && (s?.roundNumber === e || f?.participantFed || l) ? f?.drawPosition : "");
  const h = u === "DOUBLES", g = h ? n?.individualParticipants?.[0] : n, I = h && n?.individualParticipants?.[1], U = !!(o === c || d === "BYE" && n), S = p?.winnerChevron && U, P = p?.teamLogo, v = ["RETIRED", "DOUBLE_WALKOVER", "WALKOVER", "DEFAULTED", "ABANDONED", "INCOMPLETE", "SUSPENDED"].includes(d) && !U, D = p?.gameScoreOnly, y = document.createElement("div");
  if (r && (y.className = HA({
    drawPosition: m,
    sideNumber: o
  })), y.classList.add("tmx-p"), y.setAttribute("id", n?.participantId || ""), P) {
    const R = gj({ teamLogo: P });
    y.appendChild(R);
  }
  const w = document.createElement("div");
  w.className = WA(
    h ? { variant: "doubles" } : {}
  );
  const b = document.createElement("div");
  b.className = zA({
    winnerChevron: S,
    isDoubles: h
  });
  const T = Hy({
    individualParticipant: g,
    eventHandlers: t,
    isWinningSide: U,
    composition: i,
    sideNumber: o,
    matchUp: s,
    side: f
  }).element;
  if (b.appendChild(T), I) {
    const R = Hy({
      individualParticipant: I,
      eventHandlers: t,
      isWinningSide: U,
      composition: i,
      sideNumber: o,
      matchUp: s,
      side: f
    }).element;
    b.appendChild(R);
  } else h && a && fj(a) && b.appendChild(a);
  if (w.appendChild(b), y.appendChild(w), r) {
    const R = document.createElement("div");
    if (U && !D) {
      const M = Xf();
      typeof M == "string" ? R.innerHTML = M : R.appendChild(M);
    } else if (v) {
      const M = Qf({ matchUpStatus: d });
      R.appendChild(M);
    }
    y.appendChild(R);
  }
  return y;
}
const vj = Ge({
  borderBottom: "solid 1px black",
  marginInlineStart: "16px",
  marginInlineEnd: "16px",
  fontWeight: "bold",
  // width: '370px',
  height: "1.5em"
});
function Pj({
  eventHandlers: e,
  roundMatchUps: t,
  roundProfile: r,
  roundNumber: i,
  context: n
}) {
  const a = document.createElement("div");
  a.className = vj(), a.classList.add("tmx-rh"), a.setAttribute("roundNumber", String(i));
  const o = Oi(e?.roundHeaderClick);
  o && (a.onclick = (l) => e.roundHeaderClick({ roundNumber: i, roundProfile: r, roundMatchUps: t, context: n, pointerEvent: l }));
  const s = o ? "⋮" : "", c = r?.[i]?.roundName, u = c && ` <div style="display: flex; flex-direction: row; justify-content: space-between">
        <div>${c}</div>
        <div style="font-weight: bold">${s}</div>
      </div>
  `;
  return a.innerHTML = u || "", a;
}
const lA = Ge({
  flexDirection: "column",
  display: "flex"
}), Dj = Ge({
  flexDirection: "row",
  display: "flex"
}), dA = Ge({
  justifyContent: "space-around",
  marginInlineStart: "16px",
  marginInlineEnd: "16px",
  flexDirection: "column",
  height: "100%",
  display: "flex",
  // width: '370px',
  variants: {
    variant: {
      adHoc: {
        justifyContent: "flex-start"
      }
    }
  }
}), wj = Ge({
  borderTop: "solid 1px black",
  marginRight: "-1em",
  marginLeft: "-1em",
  paddingTop: ".5em",
  marginTop: ".2em",
  variants: {
    variant: {
      0: {
        marginTop: "1em",
        borderTop: "none",
        paddingTop: "0px"
      }
    },
    roundOrder: {
      first: {
        marginLeft: "0em"
      },
      last: {
        marginRight: "0em"
      }
    }
  }
}), Tj = Ge({
  fontWeight: "bold",
  color: "blue",
  height: "1em"
}), zy = Ge({
  width: "$score$setWidth",
  display: "inline-block",
  fontSize: 9,
  variants: {
    variant: {
      set: {
        textAlign: "center"
      },
      points: {
        marginInlineEnd: 3
      }
    }
  }
}), bj = Ge({
  transform: "translateY(-50%)",
  textTransform: "uppercase",
  backgroundColor: "#fff",
  position: "absolute",
  textAlign: "center",
  top: "calc(50%)",
  color: "#bbb",
  fontSize: 0,
  right: 4
});
function Mj() {
  return Ge({
    backgroundColor: "magenta",
    position: "absolute",
    opacity: "0.2",
    height: "100%",
    width: "100%",
    top: 0
  })();
}
const Rj = Ge({});
function Nj({ configuration: e }) {
  const t = {
    backgroundColor: "$matchUpBackgroundColor",
    WebkitTransition: "all 0.30s linear",
    boxShadow: "$matchUp$boxShadow",
    transition: "all 0.30s linear",
    border: "solid $border",
    marginBottom: "$space$1",
    marginTop: "$space$1",
    position: "relative",
    display: "grid",
    width: "100%",
    // IMPORTANT: must come last
    borderInlineStartWidth: "$borderWidths$borderInlineStart"
  };
  if (e?.matchUpHover) {
    const r = typeof e.matchUpHover == "string" ? e.matchUpHover : "cyan";
    t["&:hover"] = { backgroundColor: r };
  } else
    t["&:hover"] = {
      borderColor: "$borderHover"
    };
  return Ge(t)();
}
function Ej({ variant: e }) {
  return Ge({
    borderBottom: "solid 1px lightgray",
    backgroundColor: "$matchUp",
    position: "relative",
    width: "100%",
    height: "$lineHeights$centerInfo",
    variants: {
      variant: {
        1: {
          borderBottom: "solid 1px black"
        },
        2: {
          borderBottom: "solid 1px lightgray"
        }
      }
    }
  })({ variant: e });
}
const Aj = Ge({
  justifyContent: "center",
  alignContent: "center",
  flexDirection: "column",
  height: "100%",
  display: "flex"
}), Cj = Ge({
  fontFamily: "Lato,Arial,Helvetica,sans-serif",
  WebkitFontSmooting: "antialiased",
  marginInlineStart: "calc(20%)",
  WebkitBoxOrient: "horizontal",
  WebKitBoxDirection: "normal",
  WebkitBoxPack: "center",
  boxSizing: "inherit",
  flexDirection: "row",
  display: "flex"
}), Yy = Ge({
  alignContent: "center",
  boxSizing: "inherit",
  fontFamily: "Lato",
  fontWeight: 900,
  fontSize: 9
});
function Oj({
  eventHandlers: e,
  entryStatus: t,
  sideNumber: r,
  className: i,
  matchUp: n
}) {
  const a = document.createElement("div");
  Oi(e?.centerInfoClick) && (a.onclick = (l) => e.centerInfoClick({ matchUp: n, sideNumber: r, pointerEvent: l })), a.className = Ga(Ej({ variant: r }), i), a.classList.add("tmx-ci"), a.setAttribute("sideNumber", String(r));
  const o = document.createElement("div");
  o.className = Aj();
  const s = document.createElement("div");
  s.className = Cj();
  const c = document.createElement("div");
  c.className = Yy(), c.innerHTML = t ? "Entry status:&nbsp;" : "", s.appendChild(c);
  const u = document.createElement("div");
  return u.className = Yy(), u.innerHTML = t || "", s.appendChild(u), o.appendChild(s), a.appendChild(o), { element: a };
}
const Oc = {
  scheduleInfo: 1.8,
  centerInfo: 1.5,
  gameScore: 2
};
function kj({
  composition: e,
  isDoubles: t,
  roundFactor: r = 1
}) {
  const i = parseInt(window.getComputedStyle(document.body).getPropertyValue("font-size")), n = e?.configuration || {}, a = n?.connectorWidth || 16, o = n.centerInfo ? Oc.centerInfo * i : 0, s = n.scheduleInfo ? Oc.scheduleInfo * i : 0, u = (60 + (n.showAddress ? i : 0)) * (t ? 1.3 : 1) + o, l = u * r, d = (u + s) * r;
  return Ge({
    "&::before": {
      borderBlockStart: "$borderWidths$matchUp solid #999",
      left: -a,
      width: a,
      position: "absolute",
      borderRadius: 2,
      top: -1
    },
    "&::after": {
      width: a,
      position: "absolute",
      borderRadius: 2,
      left: "100%"
    },
    "&::after, &::before": {
      borderWidth: "$borderWidths$matchUp",
      borderColor: "$connector",
      display: "block",
      content: ""
    },
    variants: {
      isFirstRound: {
        true: { "&::before": { height: 0, width: 0, borderWidth: 0 } }
      },
      link: {
        m1: {
          "&::after": {
            borderInlineEnd: "$borderWidths$matchUp solid $connector",
            borderTopStyle: "solid",
            height: l,
            top: -1
          }
        },
        m2: {
          "&::after": {
            bottom: "calc(100%)",
            borderInlineEnd: "$borderWidths$matchUp solid $connector",
            borderBottomStyle: "solid",
            height: d
          }
        },
        m0: {
          "&::after": {
            borderTopStyle: "solid",
            borderColor: "$connector",
            top: -1
          }
        },
        mr: {
          "&::before": { height: 0, width: 0, borderWidth: 0 },
          "&::after": { height: 0, width: 0, borderWidth: 0 }
        },
        noProgression: {
          true: { "&::after": { height: 0, width: 0, borderWidth: 0 } }
        }
      }
    }
  });
}
const pA = (e) => Ge({
  display: "flex",
  alignItems: "center",
  height: e,
  justifyContent: "flex-end",
  backgroundColor: "$matchUp",
  variants: {
    sideNumber: {
      1: {
        borderBottom: "1px solid $internalDividers"
      }
    },
    fontSize: {
      small: {
        fontSize: "smaller",
        paddingRight: "1em",
        color: "blue"
      }
    }
  }
}), xj = Ge({
  lineHeight: "0.75rem",
  fontSize: "0.625rem",
  left: "1.1rem",
  top: ".4rem"
}), mA = Ge({
  lineHeight: "$lineHeights$gameScore",
  justifyContent: "center",
  width: "$score$setWidth",
  position: "relative",
  textAlign: "center",
  cursor: "pointer",
  fontWeight: 500,
  fontSize: "$1",
  display: "flex",
  margin: 0,
  variants: {
    variant: {
      winner: {
        color: "$winner!important",
        fontWeight: 700
      },
      loser: {
        color: "$loser!important"
      }
    }
  }
}), Fj = Ge({
  marginInlineEnd: "$space$gameMarginInlineEnd",
  justifyContent: "flex-end",
  alignItems: "center",
  display: "flex"
}), Lj = Ge({
  lineHeight: "$lineHeights$gameScore",
  justifyContent: "center",
  width: "$score$setWidth",
  position: "relative",
  textAlign: "center",
  cursor: "pointer",
  fontWeight: 500,
  fontSize: "$1",
  display: "flex",
  margin: 0,
  color: "#fff",
  backgroundColor: "#000",
  variants: {
    variant: {
      winner: {
        color: "$winner!important",
        fontWeight: 700
      },
      loser: {
        color: "$loser!important"
      }
    }
  }
});
function _j({ value: e } = {}) {
  const t = document.createElement("input");
  return t.onclick = (r) => r.target.select(), t.className = mA(), t.value = String(e || ""), t;
}
function Bj({
  gameScoreOnly: e,
  scoreStripes: t,
  set: r,
  sideNumber: i
}) {
  const a = i === r?.winningSide || r?.winningSide ? "loser" : void 0, o = i === 2 ? r.side2Score : r.side1Score, s = r.side2TiebreakScore || r.side1TiebreakScore, c = i === 2 ? r.side2TiebreakScore : r.side1TiebreakScore, u = o === void 0 && c, l = u || o, d = t && r.setNumber % 2 ? "lightgray" : "transparent", m = r.editing ? r.editing === i : void 0;
  let f;
  if (m)
    f = _j({ value: l });
  else if (f = document.createElement("p"), f.className = mA({ variant: a }), f.classList.add("tmx-st"), f.setAttribute("setNumber", r.setNumber), f.style.backgroundColor = d, f.innerHTML = isNaN(l) ? "" : l, !e) {
    const h = document.createElement("span");
    h.className = xj(), h.innerHTML = s && !u ? String(c) : "", f.appendChild(h);
  }
  return f;
}
function Dc({
  participantHeight: e,
  eventHandlers: t,
  composition: r,
  sideNumber: i,
  matchUp: n
}) {
  const a = r?.configuration?.winnerChevron, o = r?.configuration?.gameScoreOnly, s = n?.score?.sets || [], c = r?.configuration?.scoreBox, u = e ? i === 2 ? e : e - 1 : void 0, l = (y) => {
    Oi(t?.scoreClick) && (y.stopPropagation(), t.scoreClick({ pointerEvent: y, matchUp: n }));
  }, d = document.createElement("div");
  d.className = pA(u)({
    ...!c && i === 1 && { sideNumber: 1 },
    fontSize: "small"
  }), d.classList.add("sideScore"), d.classList.add("tmx-scr"), d.onclick = l;
  const p = document.createElement("div");
  p.className = Fj();
  const m = n?.matchUpStatus, f = m === "INCOMPLETE", h = m === "ABANDONED", g = m === "SUSPENDED", I = f || h || g, U = h ? "ABD" : f ? "INC" : g ? "SUS" : "";
  if (I) {
    const y = document.createElement("p");
    y.classList.add("tmx-pt"), y.style.margin = "0", y.style.padding = "0", y.style.fontSize = "inherit", y.style.backgroundColor = "transparent", y.style.color = "inherit", y.innerHTML = U, p.appendChild(y);
  }
  for (const y of s || []) {
    const w = Bj({
      gameScoreOnly: o,
      scoreStripes: a,
      sideNumber: i,
      set: y
    });
    p.appendChild(w);
  }
  const S = n?.score || {}, P = s?.[s.length - 1], v = (() => {
    const y = S, w = P;
    return i === 2 ? y.side2PointScore ?? y.side2PointsScore ?? w?.side2PointScore ?? w?.side2PointsScore : y.side1PointScore ?? y.side1PointsScore ?? w?.side1PointScore ?? w?.side1PointsScore;
  })();
  if ((m === "IN_PROGRESS" || m === "INCOMPLETE" || m === "ABANDONED" || m === "SUSPENDED") && v !== void 0 && v !== null && v !== "") {
    const y = document.createElement("p");
    y.className = Lj(), y.classList.add("tmx-pt"), y.innerHTML = String(v), p.appendChild(y);
  }
  return d.appendChild(p), d;
}
const Vj = Ge({
  height: "$lineHeights$scheduleInfo",
  borderBottom: "1px solid darkgray",
  justifyContent: "space-between",
  backgroundColor: "#F8F9F9",
  boxSizing: "border-box",
  paddingRight: "0.2rem",
  paddingLeft: "0.5rem",
  alignItems: "center",
  cursor: "pointer",
  color: "#7F8080",
  display: "flex",
  width: "100%"
});
var Wl = { exports: {} }, jj = Wl.exports, Ky;
function Gj() {
  return Ky || (Ky = 1, (function(e, t) {
    (function(r, i) {
      e.exports = i();
    })(jj, (function() {
      var r = 1e3, i = 6e4, n = 36e5, a = "millisecond", o = "second", s = "minute", c = "hour", u = "day", l = "week", d = "month", p = "quarter", m = "year", f = "date", h = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, I = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, U = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(A) {
        var N = ["th", "st", "nd", "rd"], C = A % 100;
        return "[" + A + (N[(C - 20) % 10] || N[C] || N[0]) + "]";
      } }, S = function(A, N, C) {
        var k = String(A);
        return !k || k.length >= N ? A : "" + Array(N + 1 - k.length).join(C) + A;
      }, P = { s: S, z: function(A) {
        var N = -A.utcOffset(), C = Math.abs(N), k = Math.floor(C / 60), O = C % 60;
        return (N <= 0 ? "+" : "-") + S(k, 2, "0") + ":" + S(O, 2, "0");
      }, m: function A(N, C) {
        if (N.date() < C.date()) return -A(C, N);
        var k = 12 * (C.year() - N.year()) + (C.month() - N.month()), O = N.clone().add(k, d), _ = C - O < 0, B = N.clone().add(k + (_ ? -1 : 1), d);
        return +(-(k + (C - O) / (_ ? O - B : B - O)) || 0);
      }, a: function(A) {
        return A < 0 ? Math.ceil(A) || 0 : Math.floor(A);
      }, p: function(A) {
        return { M: d, y: m, w: l, d: u, D: f, h: c, m: s, s: o, ms: a, Q: p }[A] || String(A || "").toLowerCase().replace(/s$/, "");
      }, u: function(A) {
        return A === void 0;
      } }, v = "en", D = {};
      D[v] = U;
      var y = "$isDayjsObject", w = function(A) {
        return A instanceof M || !(!A || !A[y]);
      }, b = function A(N, C, k) {
        var O;
        if (!N) return v;
        if (typeof N == "string") {
          var _ = N.toLowerCase();
          D[_] && (O = _), C && (D[_] = C, O = _);
          var B = N.split("-");
          if (!O && B.length > 1) return A(B[0]);
        } else {
          var L = N.name;
          D[L] = N, O = L;
        }
        return !k && O && (v = O), O || !k && v;
      }, T = function(A, N) {
        if (w(A)) return A.clone();
        var C = typeof N == "object" ? N : {};
        return C.date = A, C.args = arguments, new M(C);
      }, R = P;
      R.l = b, R.i = w, R.w = function(A, N) {
        return T(A, { locale: N.$L, utc: N.$u, x: N.$x, $offset: N.$offset });
      };
      var M = (function() {
        function A(C) {
          this.$L = b(C.locale, null, !0), this.parse(C), this.$x = this.$x || C.x || {}, this[y] = !0;
        }
        var N = A.prototype;
        return N.parse = function(C) {
          this.$d = (function(k) {
            var O = k.date, _ = k.utc;
            if (O === null) return /* @__PURE__ */ new Date(NaN);
            if (R.u(O)) return /* @__PURE__ */ new Date();
            if (O instanceof Date) return new Date(O);
            if (typeof O == "string" && !/Z$/i.test(O)) {
              var B = O.match(g);
              if (B) {
                var L = B[2] - 1 || 0, j = (B[7] || "0").substring(0, 3);
                return _ ? new Date(Date.UTC(B[1], L, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, j)) : new Date(B[1], L, B[3] || 1, B[4] || 0, B[5] || 0, B[6] || 0, j);
              }
            }
            return new Date(O);
          })(C), this.init();
        }, N.init = function() {
          var C = this.$d;
          this.$y = C.getFullYear(), this.$M = C.getMonth(), this.$D = C.getDate(), this.$W = C.getDay(), this.$H = C.getHours(), this.$m = C.getMinutes(), this.$s = C.getSeconds(), this.$ms = C.getMilliseconds();
        }, N.$utils = function() {
          return R;
        }, N.isValid = function() {
          return this.$d.toString() !== h;
        }, N.isSame = function(C, k) {
          var O = T(C);
          return this.startOf(k) <= O && O <= this.endOf(k);
        }, N.isAfter = function(C, k) {
          return T(C) < this.startOf(k);
        }, N.isBefore = function(C, k) {
          return this.endOf(k) < T(C);
        }, N.$g = function(C, k, O) {
          return R.u(C) ? this[k] : this.set(O, C);
        }, N.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, N.valueOf = function() {
          return this.$d.getTime();
        }, N.startOf = function(C, k) {
          var O = this, _ = !!R.u(k) || k, B = R.p(C), L = function(W, K) {
            var Q = R.w(O.$u ? Date.UTC(O.$y, K, W) : new Date(O.$y, K, W), O);
            return _ ? Q : Q.endOf(u);
          }, j = function(W, K) {
            return R.w(O.toDate()[W].apply(O.toDate("s"), (_ ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(K)), O);
          }, H = this.$W, G = this.$M, V = this.$D, $ = "set" + (this.$u ? "UTC" : "");
          switch (B) {
            case m:
              return _ ? L(1, 0) : L(31, 11);
            case d:
              return _ ? L(1, G) : L(0, G + 1);
            case l:
              var q = this.$locale().weekStart || 0, Y = (H < q ? H + 7 : H) - q;
              return L(_ ? V - Y : V + (6 - Y), G);
            case u:
            case f:
              return j($ + "Hours", 0);
            case c:
              return j($ + "Minutes", 1);
            case s:
              return j($ + "Seconds", 2);
            case o:
              return j($ + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, N.endOf = function(C) {
          return this.startOf(C, !1);
        }, N.$set = function(C, k) {
          var O, _ = R.p(C), B = "set" + (this.$u ? "UTC" : ""), L = (O = {}, O[u] = B + "Date", O[f] = B + "Date", O[d] = B + "Month", O[m] = B + "FullYear", O[c] = B + "Hours", O[s] = B + "Minutes", O[o] = B + "Seconds", O[a] = B + "Milliseconds", O)[_], j = _ === u ? this.$D + (k - this.$W) : k;
          if (_ === d || _ === m) {
            var H = this.clone().set(f, 1);
            H.$d[L](j), H.init(), this.$d = H.set(f, Math.min(this.$D, H.daysInMonth())).$d;
          } else L && this.$d[L](j);
          return this.init(), this;
        }, N.set = function(C, k) {
          return this.clone().$set(C, k);
        }, N.get = function(C) {
          return this[R.p(C)]();
        }, N.add = function(C, k) {
          var O, _ = this;
          C = Number(C);
          var B = R.p(k), L = function(G) {
            var V = T(_);
            return R.w(V.date(V.date() + Math.round(G * C)), _);
          };
          if (B === d) return this.set(d, this.$M + C);
          if (B === m) return this.set(m, this.$y + C);
          if (B === u) return L(1);
          if (B === l) return L(7);
          var j = (O = {}, O[s] = i, O[c] = n, O[o] = r, O)[B] || 1, H = this.$d.getTime() + C * j;
          return R.w(H, this);
        }, N.subtract = function(C, k) {
          return this.add(-1 * C, k);
        }, N.format = function(C) {
          var k = this, O = this.$locale();
          if (!this.isValid()) return O.invalidDate || h;
          var _ = C || "YYYY-MM-DDTHH:mm:ssZ", B = R.z(this), L = this.$H, j = this.$m, H = this.$M, G = O.weekdays, V = O.months, $ = O.meridiem, q = function(K, Q, X, ee) {
            return K && (K[Q] || K(k, _)) || X[Q].slice(0, ee);
          }, Y = function(K) {
            return R.s(L % 12 || 12, K, "0");
          }, W = $ || function(K, Q, X) {
            var ee = K < 12 ? "AM" : "PM";
            return X ? ee.toLowerCase() : ee;
          };
          return _.replace(I, (function(K, Q) {
            return Q || (function(X) {
              switch (X) {
                case "YY":
                  return String(k.$y).slice(-2);
                case "YYYY":
                  return R.s(k.$y, 4, "0");
                case "M":
                  return H + 1;
                case "MM":
                  return R.s(H + 1, 2, "0");
                case "MMM":
                  return q(O.monthsShort, H, V, 3);
                case "MMMM":
                  return q(V, H);
                case "D":
                  return k.$D;
                case "DD":
                  return R.s(k.$D, 2, "0");
                case "d":
                  return String(k.$W);
                case "dd":
                  return q(O.weekdaysMin, k.$W, G, 2);
                case "ddd":
                  return q(O.weekdaysShort, k.$W, G, 3);
                case "dddd":
                  return G[k.$W];
                case "H":
                  return String(L);
                case "HH":
                  return R.s(L, 2, "0");
                case "h":
                  return Y(1);
                case "hh":
                  return Y(2);
                case "a":
                  return W(L, j, !0);
                case "A":
                  return W(L, j, !1);
                case "m":
                  return String(j);
                case "mm":
                  return R.s(j, 2, "0");
                case "s":
                  return String(k.$s);
                case "ss":
                  return R.s(k.$s, 2, "0");
                case "SSS":
                  return R.s(k.$ms, 3, "0");
                case "Z":
                  return B;
              }
              return null;
            })(K) || B.replace(":", "");
          }));
        }, N.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, N.diff = function(C, k, O) {
          var _, B = this, L = R.p(k), j = T(C), H = (j.utcOffset() - this.utcOffset()) * i, G = this - j, V = function() {
            return R.m(B, j);
          };
          switch (L) {
            case m:
              _ = V() / 12;
              break;
            case d:
              _ = V();
              break;
            case p:
              _ = V() / 3;
              break;
            case l:
              _ = (G - H) / 6048e5;
              break;
            case u:
              _ = (G - H) / 864e5;
              break;
            case c:
              _ = G / n;
              break;
            case s:
              _ = G / i;
              break;
            case o:
              _ = G / r;
              break;
            default:
              _ = G;
          }
          return O ? _ : R.a(_);
        }, N.daysInMonth = function() {
          return this.endOf(d).$D;
        }, N.$locale = function() {
          return D[this.$L];
        }, N.locale = function(C, k) {
          if (!C) return this.$L;
          var O = this.clone(), _ = b(C, k, !0);
          return _ && (O.$L = _), O;
        }, N.clone = function() {
          return R.w(this.$d, this);
        }, N.toDate = function() {
          return new Date(this.valueOf());
        }, N.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, N.toISOString = function() {
          return this.$d.toISOString();
        }, N.toString = function() {
          return this.$d.toUTCString();
        }, A;
      })(), E = M.prototype;
      return T.prototype = E, [["$ms", a], ["$s", o], ["$m", s], ["$H", c], ["$W", u], ["$M", d], ["$y", m], ["$D", f]].forEach((function(A) {
        E[A[1]] = function(N) {
          return this.$g(N, A[0], A[1]);
        };
      })), T.extend = function(A, N) {
        return A.$i || (A(N, M, T), A.$i = !0), T;
      }, T.locale = b, T.isDayjs = w, T.unix = function(A) {
        return T(1e3 * A);
      }, T.en = D[v], T.Ls = D, T.p = {}, T;
    }));
  })(Wl)), Wl.exports;
}
var $j = Gj();
const qj = /* @__PURE__ */ iv($j);
function Wj({
  matchUp: e,
  eventHandlers: t
}) {
  const { scheduledTime: r, scheduledDate: i, venueAbbreviation: n, courtName: a } = e?.schedule || {}, {
    dateTime: { extractDate: o, extractTime: s }
  } = US, c = s(r);
  let l = o(i), d = "ddd D MMMM";
  c && (d += ", hh:mm A", l += `T${c}`);
  const p = i ? qj(l).format(d) : "Not scheduled", m = n && a?.toString().startsWith(n) && a || // ensure no duplication of venuAbbreviation
  n && a && `${n} ${a}` || a || n || "", f = document.createElement("div");
  f.className = Vj(), f.classList.add("tmx-sch"), Oi(t?.scheduleClick) && (f.onclick = (S) => t.scheduleClick({ matchUp: e, pointerEvent: S }));
  const h = document.createElement("div");
  h.innerHTML = p, f.append(h);
  const g = (S) => {
    Oi(t?.venueClick) && (S.stopPropagation(), t.venueClick({
      pointerEvent: S,
      matchUp: e
    }));
  }, I = document.createElement("div");
  I.style = "display: flex; flex-direction: row";
  const U = document.createElement("div");
  if (U.style.paddingRight = ".2rem", U.onclick = g, U.innerHTML = m, I.append(U), f.append(I), f.onclick) {
    const S = document.createElement("div");
    S.innerHTML = "⋮", I.append(S);
  }
  return f;
}
function Qy({
  initialRoundNumber: e = 1,
  eventHandlers: t,
  composition: r,
  sideNumber: i,
  className: n,
  matchUp: a
}) {
  const s = (r?.configuration || {})?.scheduleInfo, c = a?.score?.scoreStringSide1, u = r?.configuration?.scoreBox && c, l = a?.readyToScore && t?.scoreClick && !uA.checkScoreHasValue({ matchUp: a }), d = document.createElement("div");
  if (d.className = Ga(Ij(), n), d.classList.add("tmx-sd"), d.setAttribute("sideNumber", String(i)), s && i === 1) {
    const f = Wj({ matchUp: a, eventHandlers: t });
    d.appendChild(f);
  }
  const p = document.createElement("div");
  p.className = Uj();
  const m = yj({
    sideContainer: !0,
    initialRoundNumber: e,
    eventHandlers: t,
    composition: r,
    sideNumber: i,
    matchUp: a
  });
  if (p.appendChild(m), u) {
    const f = document.createElement("div");
    f.style.border = "1px solid lightgray", p.appendChild(f);
  }
  if (c) {
    const f = Dc({
      eventHandlers: t,
      composition: r,
      sideNumber: i,
      matchUp: a
    });
    p.appendChild(f);
  }
  if (l) {
    const f = (g) => {
      Oi(t?.scoreClick) && (g.stopPropagation(), t.scoreClick({ pointerEvent: g, matchUp: a }));
    }, h = document.createElement("div");
    h.className = pA(void 0)({
      ...!u && i === 1 && { sideNumber: 1 },
      fontSize: "small"
    }), h.onclick = f, h.innerHTML = "[Score]", p.appendChild(h);
  }
  return d.appendChild(p), d;
}
function Hj(e) {
  const { composition: t, initialRoundNumber: r = 1, matchUp: i, moiety: n, selectedMatchUpId: a, searchActive: o } = e, { roundFactor: s, roundNumber: c, finishingRound: u, matchUpType: l, preFeedRound: d, stage: p } = i, m = e.isFinalRound || (u ? parseInt(String(u)) === 1 : !1), f = p === "QUALIFYING" && m, h = m, g = c ? parseInt(String(c)) === r : !1, I = l === "DOUBLES", U = (o || i.isRoundRobin || i.collectionId || e.isLucky || e.isAdHoc) && "mr" || h && "noProgression" || (f || d) && "m0" || n && "m1" || "m2", S = kj({ composition: t, isDoubles: I, roundFactor: s })({
    isFirstRound: g,
    link: U
  }), P = t?.configuration || {}, { resultsInfo: v, centerInfo: D } = P || {}, y = e.eventHandlers || {}, w = (L) => {
    Oi(y?.matchUpClick) && y.matchUpClick({ pointerEvent: L, matchUp: i });
  }, b = document.createElement("div");
  b.className = Ga(t?.theme, e?.className, "matchup", Rj()), b.classList.add("tmx-m"), b.setAttribute("id", i?.matchUpId), b.onclick = w;
  const T = document.createElement("div");
  T.className = Nj({ configuration: P });
  const R = ({ sideNumber: L }) => {
    const j = i?.sides?.find((G) => G.sideNumber === L)?.participant?.entryStatus?.replace("_", " ");
    return Oj({
      eventHandlers: y,
      entryStatus: j,
      sideNumber: L,
      className: L === 2 ? S : void 0,
      matchUp: i
    });
  }, M = Qy({
    initialRoundNumber: r,
    eventHandlers: y,
    sideNumber: 1,
    composition: t,
    matchUp: i
  }), E = Qy({
    className: !D && S,
    initialRoundNumber: r,
    eventHandlers: y,
    sideNumber: 2,
    composition: t,
    matchUp: i
  });
  if (T.appendChild(M), D) {
    const L = R({ sideNumber: 1 }), j = R({ sideNumber: 2 });
    T.appendChild(L.element), T.appendChild(j.element);
  }
  T.appendChild(E);
  let A = null;
  if (v && (A = Xy({ score: i.score }), T.appendChild(A)), b.appendChild(T), a === i.matchUpId) {
    const L = document.createElement("div");
    L.className = Mj(), b.appendChild(L);
  }
  const N = (L) => {
    L && (i.score = Object.assign({}, i.score, L));
    const j = M.querySelector(".sideScore"), H = E.querySelector(".sideScore"), G = j?.parentElement || Array.from(M.children).find(
      (Y) => Y.tagName === "DIV" && !Y.classList.contains("tmx-sch")
    ) || M.lastElementChild, V = H?.parentElement || Array.from(E.children).find(
      (Y) => Y.tagName === "DIV" && !Y.classList.contains("tmx-sch")
    ) || E.lastElementChild;
    j && G && G.removeChild(j), H && V && V.removeChild(H);
    const $ = i?.score || {}, q = i?.score?.scoreStringSide1 || i?.score?.scoreStringSide2 || i?.score?.sets?.length || $?.side1PointScore !== void 0 || $?.side1PointsScore !== void 0 || $?.side2PointScore !== void 0 || $?.side2PointsScore !== void 0;
    if (q && G) {
      const Y = Dc({
        eventHandlers: y,
        composition: t,
        sideNumber: 1,
        matchUp: i
      });
      G.appendChild(Y);
    }
    if (q && V) {
      const Y = Dc({
        eventHandlers: y,
        composition: t,
        sideNumber: 2,
        matchUp: i
      });
      V.appendChild(Y);
    }
    if (v && A) {
      const Y = Xy({ score: i.score });
      T.replaceChild(Y, A), A = Y;
    }
  }, C = (L) => {
    L !== void 0 && (i.matchUpStatus = L);
    const j = (H, G) => {
      const V = H.querySelector(".tmx-p");
      if (!V) return;
      const $ = V.lastElementChild;
      if (!$) return;
      const q = $.querySelector("abbr[title]")?.parentElement, Y = $.querySelector("svg")?.parentElement, { winningSide: W } = i, K = i?.sides?.find((Z) => Z.sideNumber === G)?.participant, Q = !!(G === W || L === "BYE" && K), X = ["RETIRED", "DOUBLE_WALKOVER", "WALKOVER", "DEFAULTED", "ABANDONED", "INCOMPLETE", "SUSPENDED"].includes(L || "") && !Q, ee = t?.configuration?.gameScoreOnly;
      if (q && $.removeChild(q), Y && $.removeChild(Y), Q && !ee) {
        const Z = Xf();
        $.innerHTML = Z;
      } else if (X && L) {
        const Z = Qf({ matchUpStatus: L });
        $.appendChild(Z);
      }
    };
    j(M, 1), j(E, 2);
  }, k = (L) => {
    L !== void 0 && (i.winningSide = L);
    const j = (V, $) => {
      const q = V.querySelector(".tmx-p");
      if (!q) return;
      const Y = q.lastElementChild;
      if (!Y) return;
      const W = Y.querySelector("abbr[title]")?.parentElement, K = Y.querySelector("svg")?.parentElement, { winningSide: Q, matchUpStatus: X } = i, ee = i?.sides?.find((Te) => Te.sideNumber === $)?.participant, Z = !!($ === Q || X === "BYE" && ee), ce = ["RETIRED", "DOUBLE_WALKOVER", "WALKOVER", "DEFAULTED", "ABANDONED", "INCOMPLETE", "SUSPENDED"].includes(X || "") && !Z, fe = t?.configuration?.gameScoreOnly;
      if (q.querySelectorAll(".tmx-i").forEach((Te) => {
        Z ? Te.classList.add("winner") : Te.classList.remove("winner");
        const $e = Te.firstElementChild;
        if ($e) {
          const it = Array.from($e.children).find((It) => It.querySelector("span") !== null || It.querySelector("abbr") !== null);
          if (it)
            if (Z) {
              it.classList.add("winner"), it.classList.remove("loser");
              const It = it.querySelector("span") || it.querySelector("abbr");
              It && (It.style.fontWeight = "700");
            } else {
              it.classList.remove("winner"), it.classList.add("loser");
              const It = it.querySelector("span") || it.querySelector("abbr");
              It && (It.style.fontWeight = "500");
            }
        }
      }), W && Y.removeChild(W), K && Y.removeChild(K), Z && !fe) {
        const Te = Xf();
        Y.innerHTML = Te;
      } else if (ce && X) {
        const Te = Qf({ matchUpStatus: X });
        Y.appendChild(Te);
      }
    };
    j(M, 1), j(E, 2);
    const H = i?.score || {};
    if (i?.score?.scoreStringSide1 || i?.score?.scoreStringSide2 || i?.score?.sets?.length || H?.side1PointScore !== void 0 || H?.side1PointsScore !== void 0 || H?.side2PointScore !== void 0 || H?.side2PointsScore !== void 0) {
      const V = M.querySelector(".sideScore"), $ = E.querySelector(".sideScore"), q = V?.parentElement || Array.from(M.children).find(
        (W) => W.tagName === "DIV" && !W.classList.contains("tmx-sch")
      ) || M.lastElementChild, Y = $?.parentElement || Array.from(E.children).find(
        (W) => W.tagName === "DIV" && !W.classList.contains("tmx-sch")
      ) || E.lastElementChild;
      if (V && q && q.removeChild(V), $ && Y && Y.removeChild($), q) {
        const W = Dc({
          eventHandlers: y,
          composition: t,
          sideNumber: 1,
          matchUp: i
        });
        q.appendChild(W);
      }
      if (Y) {
        const W = Dc({
          eventHandlers: y,
          composition: t,
          sideNumber: 2,
          matchUp: i
        });
        Y.appendChild(W);
      }
    }
  }, O = i.matchUpId, _ = (L) => {
    if (!L.data) return;
    const j = L.data.matchId || L.data.matchUpId;
    j === O && (L.data.winningSide !== void 0 && k(L.data.winningSide), L.data.score && N(L.data.score), L.data.matchUpStatus !== void 0 && C(L.data.matchUpStatus));
  }, B = (L) => {
    if (console.log("customEventHandler", L.detail), !L.detail) return;
    const j = L.detail.matchId || L.detail.matchUpId;
    j === O && (L.detail.winningSide !== void 0 && k(L.detail.winningSide), L.detail.score && N(L.detail.score), L.detail.matchUpStatus !== void 0 && C(L.detail.matchUpStatus));
  };
  return window.addEventListener("message", _), window.addEventListener("matchUpScoreUpdate", B), b.__cleanupScoreListener = () => {
    window.removeEventListener("message", _), window.removeEventListener("matchUpScoreUpdate", B);
  }, b;
}
function Xy({ score: e }) {
  const t = e?.sets?.filter(Boolean).sort((a, o) => (a.setNumber || 0) - (o.setNumber || 0)), r = t?.[t.length - 1], i = r?.side1PointsScore || r?.side2PointsScore, n = document.createElement("div");
  if (n.className = bj(), i) {
    const a = document.createElement("div");
    a.className = zy({ variant: "points" }), a.innerHTML = "PTS", n.appendChild(a);
  }
  for (const a of t || []) {
    const o = document.createElement("div");
    o.setAttribute("key", String(a.setNumber)), o.className = zy({ variant: "set" }), o.innerHTML = String(a.setNumber), n.appendChild(o);
  }
  return n;
}
function zj({
  initialRoundNumber: e = 1,
  selectedMatchUpId: t,
  eventHandlers: r,
  isFinalRound: i,
  isRoundRobin: n,
  searchActive: a,
  composition: o,
  roundFactor: s,
  roundNumber: c,
  roundProfile: u,
  minWidth: l,
  matchUps: d,
  context: p,
  isLucky: m
}) {
  const f = d.filter((T) => T.roundNumber === c).sort((T, R) => (T.roundPosition || 0) - (R.roundPosition || 0)), h = f.every(({ roundPosition: T, drawPositions: R }) => !T && !R), g = o?.configuration || {}, I = document.createElement("div");
  if (I.className = lA(), I.classList.add("tmx-rd"), I.setAttribute("roundNumber", String(c)), g.roundHeader) {
    const T = Pj({ roundProfile: u, roundMatchUps: f, roundNumber: c, eventHandlers: r, context: p });
    I.appendChild(T);
  }
  const U = document.createElement("div");
  U.className = dA({ variant: h ? "adHoc" : void 0 }), l && (U.style.minWidth = l);
  let S, P, v;
  if (n) {
    const T = (M) => (M || []).reduce((E, A) => A + E, 0);
    f.sort((M, E) => {
      const A = T(M.drawPositions) - T(E.drawPositions), N = M.drawPositions || [], C = E.drawPositions || [], k = (N.length ? Math.min.apply(null, N) : 0) - (C.length ? Math.min.apply(null, C) : 0);
      return A || k;
    });
    const R = f.reduce((M, E) => (M[E.structureId] = E.structureName, M), {});
    S = Object.values(R), P = Object.keys(R), v = Object.keys(US.instanceCount(f.map(({ structureId: M }) => M))).length;
  } else h && f.sort((T, R) => (T.roundOrder ?? 0) - (R.roundOrder ?? 0));
  const D = v && f.length / v, y = Object.keys(u).map((T) => parseInt(T)), w = y.indexOf(c), b = w === 0 && "first" || w === y.length - 1 && "last";
  return f.forEach((T, R) => {
    const M = D && !(R % D), E = D && Math.floor(R / D), A = D && S[E];
    if (M) {
      const k = document.createElement("div");
      k.className = wj({
        ...E === 0 && { variant: 0 },
        ...b && { roundOrder: b }
      }), U.appendChild(k);
      const O = document.createElement("div");
      if (O.className = Tj(), Oi(r?.groupHeaderClick)) {
        const { drawId: _, containerStructureId: B } = f[0];
        U.onclick = (L) => r.groupHeaderClick({
          structureId: P[E],
          containerStructureId: B,
          pointerEvent: L,
          drawId: _
        });
      }
      c === e && (O.innerHTML = A), U.appendChild(O);
    }
    const N = R % 2 === 0;
    s ? T.roundFactor = s : e > 1 && (T.roundFactor = Math.pow(2, c - e));
    const C = Hj({
      initialRoundNumber: e,
      selectedMatchUpId: t,
      eventHandlers: r,
      isFinalRound: i,
      searchActive: a,
      composition: o,
      isAdHoc: h,
      isLucky: m,
      matchUp: T,
      moiety: N
    });
    U.appendChild(C);
  }), I.appendChild(U), I;
}
function Zj({
  initialRoundNumber: e = 1,
  selectedMatchUpId: t,
  eventHandlers: r,
  searchActive: i,
  composition: n,
  structureId: a,
  finalColumn: o,
  matchUps: s,
  minWidth: c,
  context: u
}) {
  const { roundNumbers: l, roundProfile: d, hasOddMatchUpsCount: p, isNotEliminationStructure: m } = uA.getRoundMatchUps({ matchUps: s });
  a = a || u?.structureId || s?.[0]?.structureId;
  const f = s.some(({ isRoundRobin: U }) => U), h = p || m, g = document.createElement("div");
  g.className = Dj(), g.classList.add("tmx-str"), g.setAttribute("id", a || "");
  const I = l.length ? Math.max.apply(null, l) : 0;
  for (const U of l) {
    if (U < e) continue;
    const P = zj({
      initialRoundNumber: e,
      selectedMatchUpId: t,
      eventHandlers: r,
      isFinalRound: U === I,
      isRoundRobin: f,
      searchActive: i,
      composition: n,
      roundNumber: U,
      roundProfile: d,
      matchUps: s,
      minWidth: c,
      context: u,
      isLucky: h
    });
    g.appendChild(P);
  }
  if (o && typeof o != "boolean") {
    const U = document.createElement("div");
    U.className = lA();
    const S = document.createElement("div");
    S.className = dA(), S.appendChild(o), U.appendChild(S), g.appendChild(U);
  }
  return g;
}
const Jy = Ge({
  backgroundColor: "$colors$backgroundColor",
  color: "$colors$color",
  overflowX: "auto",
  height: 1e3
});
function eG({ content: e, theme: t }) {
  const r = document.createElement("div");
  return r.className = t ? Ga(Jy(), t) : Jy(), t && r.classList.add(t), typeof e == "string" ? r.innerHTML = e : r.appendChild(e), r;
}
const { createTheme: is } = rv({
  theme: {
    lineHeights: {
      scheduleInfo: `${Oc.scheduleInfo}rem`,
      centerInfo: `${Oc.centerInfo}rem`,
      gameScore: `${Oc.gameScore}rem`
    },
    borderWidths: {
      matchUpInline: "1px 1px",
      matchUp: "1px"
    },
    space: {
      1: "10px",
      2: "0.375rem",
      // start/end spacing for individual
      gameMarginInlineEnd: "0.25rem"
    },
    fontSizes: {
      1: "0.875rem"
    },
    colors: {
      internalDividers: "lightgray",
      backgroundColor: "white",
      connector: "lightgray",
      border: "darkgray",
      color: "black"
    },
    participant: {
      textTransform: "capitalize",
      minHeight: "2rem",
      seed: "gray"
    },
    score: {
      setWidth: "1.3rem"
    }
  }
}), Zy = is("australian-theme", {
  colors: {
    borderHover: "#0091d2",
    connector: "#999"
  }
}), Yj = is("wimbledon-theme", {
  borderWidths: {
    borderInlineStart: "10px"
  },
  colors: {
    connector: "transparent",
    borderHover: "darkgrey",
    border: "#00703c",
    matchUp: "#fff"
  },
  participant: {
    textTransform: "uppercase"
  }
}), Kj = is("french-theme", {
  colors: {
    winnerName: "#01503d!important",
    winner: "#01503d!important",
    borderHover: "#0091d2",
    border: "#F8F9F9"
  },
  matchUp: {
    boxShadow: "0 0 30px 0 hsla(0,0%,89%,9)"
  }
}), Qj = is("usopen-theme", {
  colors: {
    matchUpBackgroundColor: "#F8F9F9",
    internalDividers: "darkgray",
    borderHover: "#0091d2",
    connector: "#999"
  }
}), ev = is("basic-theme", {
  colors: {
    internalDividers: "transparent",
    winner: "#50B649!important",
    loser: "#E61A1A!important",
    connector: "#999"
  },
  space: {
    gameMarginInlineEnd: "0.75rem"
  },
  participant: {
    seed: "transparent"
  },
  fontSizes: {
    1: "1.5rem"
  }
}), Xj = is("dark-theme", {
  colors: {
    backgroundColor: "#333333",
    borderHover: "#0091d2",
    color: "white"
  },
  participant: {
    seed: "cyan"
  }
}), Jj = is("itf-theme", {
  colors: {
    borderHover: "#0091d2",
    connector: "#999",
    matchUp: "#fff"
  },
  participant: {
    textTransform: "uppercase",
    seed: "gray"
  }
}), tG = {
  Australian: {
    configuration: { flags: !0 },
    theme: Zy
  },
  Basic: {
    configuration: { gameScoreOnly: !0, teamLogo: !1, roundHeader: !0, placeHolders: { tbd: "-", bye: "Bye" } },
    theme: ev
  },
  DrawPositions: {
    configuration: {
      gameScoreOnly: !0,
      drawPositions: !0,
      teamLogo: !1
    },
    theme: ev
  },
  French: {
    configuration: { bracketedSeeds: !0, flags: !0 },
    theme: Kj
  },
  Wimbledon: {
    configuration: { resultsInfo: !0, flags: !0 },
    theme: Yj
  },
  "US Open": {
    configuration: { scoreBox: !0, flags: !0 },
    theme: Qj
  },
  ITF: {
    configuration: { winnerChevron: !0, centerInfo: !0, flags: !0, roundHeader: !0 },
    theme: Jj
  },
  National: {
    configuration: {
      bracketedSeeds: "square",
      allDrawPositions: !0,
      drawPositions: !0,
      scheduleInfo: !0,
      roundHeader: !0,
      showAddress: !0,
      scaleAttributes: {
        scaleColor: "red",
        scaleType: "RATING",
        scaleName: "WTN",
        accessor: "wtnRating"
      }
    },
    theme: Zy
  },
  Night: {
    configuration: { flags: !0 },
    theme: Xj
  }
};
export {
  kS as cModal,
  tG as compositions,
  eG as renderContainer,
  Hj as renderMatchUp,
  yj as renderParticipant,
  zj as renderRound,
  Pj as renderRoundHeader,
  Zj as renderStructure
};
